var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { defineComponent, ref, onBeforeUnmount, onMounted, nextTick, reactive, watch, computed } from "vue-demi";
const SESSION_KEYS = {
  FILE_URL: "file_url",
  UTM_ITEM: "utm_item",
  Y_TOKEN: "yToken",
  GEN_SIGN: "gen_sign",
  WECHAT_CODE: "wechat_code",
  DING_DING_OAUTH_CODE: "ding_ding_oauth_code",
  SUB_TOKEN: "sub_token",
  EXPERIMENT_STORAGE: "experimentStorageLogin",
  SOURCE_URL: "source_url",
  WE_CHAT_LOGIN_DONE: "we_chat_login_done",
  DING_JUMP_AUTH_CODE: "ding_jump_auth_code",
  INVITE_TOKEN: "invToken",
  SAML_CODE: "errCode",
  RANDOM_NUM: "randomNum",
  PRIVATE_CODE: "privateCode",
  EXTEND_TRACK: "extend_track",
  REDIRECT: "redirect"
};
const WEI_XIN_FAST_LOGIN_CONFIG = {
  response_type: "code",
  state: "LanHuVX"
};
const isWeiXinFastPage = () => {
  const state = getUrlValue("state");
  return state === WEI_XIN_FAST_LOGIN_CONFIG.state;
};
const UTM_TERM = /* @__PURE__ */ new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term"
]);
const PROMOTE = {
  bd_vid: 1,
  clickid: 2,
  cb: 3,
  qhclickid: 4,
  sg_vid: 5
};
const experimentClient = function() {
  const experimentStr = getSessionStorageItem(SESSION_KEYS.EXPERIMENT_STORAGE);
  if (!experimentStr)
    return {};
  return JSON.parse(experimentStr).reduce((rs, str) => {
    const list = str.split(":");
    list.length > 1 && (rs[list[0]] = list[1]);
    return rs;
  }, {});
}();
const projectConfig = {
  imageResource: "https://image-resource.mastergo.com/"
};
var ROUTER_PATH = /* @__PURE__ */ ((ROUTER_PATH2) => {
  ROUTER_PATH2["FILES_HOME"] = "/files/home";
  ROUTER_PATH2["COMMUNITY"] = "/community";
  ROUTER_PATH2["COMMUNITY_PROFILE"] = "/community/profile/id";
  ROUTER_PATH2["OFFICIAL_WEBSITE"] = "/?";
  ROUTER_PATH2["SETTING"] = "/files/account";
  return ROUTER_PATH2;
})(ROUTER_PATH || {});
var ThirdPartType = /* @__PURE__ */ ((ThirdPartType2) => {
  ThirdPartType2[ThirdPartType2["WEIXIN"] = 0] = "WEIXIN";
  ThirdPartType2[ThirdPartType2["DINGDING"] = 1] = "DINGDING";
  ThirdPartType2[ThirdPartType2["LANHU"] = 2] = "LANHU";
  return ThirdPartType2;
})(ThirdPartType || {});
var oneBtnStatus = /* @__PURE__ */ ((oneBtnStatus2) => {
  oneBtnStatus2[oneBtnStatus2["ON_INPUT"] = 1] = "ON_INPUT";
  oneBtnStatus2[oneBtnStatus2["IN_REVIEW"] = 2] = "IN_REVIEW";
  oneBtnStatus2[oneBtnStatus2["CHECK_SUCCESS"] = 3] = "CHECK_SUCCESS";
  return oneBtnStatus2;
})(oneBtnStatus || {});
const samlEmailErrCode = {
  NoSupportSSOError: "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  NoSupportEmail: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1",
  OrganizationFoundError: "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  OrganizationSSONotOpen: "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  OrganizationUserDisabled: "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458"
};
const samlErrCode = {
  OrganizationUserDisabled: "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528",
  OrganizationSSONotOpen: "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  CannotEmptyEmail: "\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458",
  NoSupportSSOError: "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"
};
const accountErrorCode = {
  default: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1",
  saml: "\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458",
  orgEmailErr: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1",
  NoSupportEmail: "\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F",
  emailError: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1",
  UserExists: "\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55",
  noCaptcha: "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801",
  NeedCaptcha: "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801",
  InvalidCaptcha: "\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF"
};
const getUrlKeyReg = (key) => new RegExp(`[&?]${key}=([^&$#]*)`);
const getPathReg = (key = "") => new RegExp(`${key}/(\\d+)`);
function getUrlValue(key, url = "") {
  const result = (url || window.location.href).match(getUrlKeyReg(key));
  return result ? result[1] : "";
}
function getUrlData(list) {
  if (!Array.isArray(list)) {
    return {};
  }
  const result = {};
  list.forEach((item) => {
    const middle = getUrlValue(item);
    if (middle) {
      result[item] = middle;
    }
  });
  return result || {};
}
function setSessionStorageItem(name2, value) {
  try {
    sessionStorage.setItem(name2, value);
  } catch (error) {
  }
}
function removeSessionStorageItem(name2) {
  try {
    sessionStorage.removeItem(name2);
  } catch (error) {
  }
}
function getSessionStorageItem(name2) {
  try {
    return sessionStorage.getItem(name2);
  } catch (error) {
    return null;
  }
}
function setLocalStorageItem(name2, value) {
  try {
    localStorage.setItem(name2, value);
  } catch (error) {
  }
}
const getPathId = (key = "") => {
  const result = window.location.pathname.match(getPathReg(key));
  return result ? result[1] : "";
};
function startRemoveSession(list = []) {
  let targetList = list.length ? list : Object.values(SESSION_KEYS);
  targetList = Array.isArray(targetList) ? targetList : [];
  targetList.forEach((item = "") => {
    removeSessionStorageItem(item);
  });
}
function isChinese(temp) {
  return !/[^\u4e00-\u9fa5]/.test(temp);
}
function isMobile() {
  const computer = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  return !!computer;
}
function transUrl(url) {
  if (!url)
    return url;
  if (/data:image\/\w+;base64/.test(url)) {
    return url;
  }
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return transMobileImgUrl(url);
  }
  return transMobileImgUrl(`${projectConfig.imageResource}${url}`);
}
function transMobileImgUrl(url) {
  var _a2, _b, _c, _d;
  if (!isMobile()) {
    return url;
  }
  const maxW = (_b = (_a2 = window == null ? void 0 : window.document) == null ? void 0 : _a2.body.clientWidth) != null ? _b : 360;
  const maxH = (_d = (_c = window == null ? void 0 : window.document) == null ? void 0 : _c.body.clientHeight) != null ? _d : 640;
  if (~url.indexOf("?")) {
    return url.replace("?", `?x-oss-process=image/resize,h_${maxH},w_${maxW}&`);
  }
  return `${url}?x-oss-process=image/resize,h_${maxH},w_${maxW}`;
}
function parseExperiment(data2) {
  return Object.keys(data2).map((item) => `${item}:${data2[item]}`);
}
let info;
function platformInfo() {
  if (info)
    return info;
  const userAgent = navigator.userAgent;
  const platform2 = navigator.platform;
  let isWindows = false;
  let isiOS = false;
  let isChromeOS = false;
  let isLinux = false;
  const isMacOs = /Mac/.test(platform2);
  if (!isMacOs) {
    isWindows = /Win/.test(platform2);
    if (!isWindows) {
      isiOS = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
      if (!isiOS) {
        isChromeOS = /CrOS/.test(userAgent);
        if (!isChromeOS) {
          isLinux = /Linux/.test(platform2);
        }
      }
    }
  }
  const safariResult = /version\/([\d.]+).*safari/i.exec(userAgent);
  info = {
    isMac: isMacOs,
    isWindows,
    isiOS,
    isChromeOS,
    isLinux,
    isChrome: userAgent.indexOf("Chrome") > -1,
    isFirefox: userAgent.indexOf("Firefox") > -1,
    isEdge: userAgent.indexOf("Edge") > -1,
    isWeiXin: userAgent.indexOf("MicroMessenger") > -1,
    isSafari: !!safariResult,
    safariVersion: safariResult && safariResult[1],
    isDingDing: /DingTalk/.test(navigator.userAgent)
  };
  return info;
}
function isInIframe() {
  return window.self !== window.top;
}
function canUseThiryLogin() {
  return !/\/files\//.test(window.location.href) || /\/files\/home/.test(window.location.href);
}
function getUrlQueries() {
  const start2 = window.location.href.indexOf("?");
  if (start2 === -1)
    return {};
  const end = window.location.href.indexOf("#");
  let search2;
  if (end === -1) {
    search2 = window.location.href.substring(start2 + 1);
  } else {
    search2 = window.location.href.substring(start2 + 1, end);
  }
  return search2.split("&").reduce((rs, str) => {
    if (str) {
      const list = str.split("=");
      rs[list[0]] = list[1];
    }
    return rs;
  }, {});
}
function getUrlHash() {
  let hash = window.location.hash;
  const i = hash.indexOf("?");
  if (i !== -1) {
    hash = hash.substring(0, i);
  }
  return hash;
}
function toSearch(queries) {
  const search2 = Object.keys(queries).map((key) => `${key}=${queries[key]}`).join("&");
  return search2 ? "?" + search2 : "";
}
function deleteUrlQuery(key) {
  if (!key)
    return;
  const queries = getUrlQueries();
  if (key in queries) {
    delete queries[key];
    const search2 = toSearch(queries);
    const hash = getUrlHash();
    const url = window.location.origin + window.location.pathname + search2 + hash;
    window.history.replaceState({}, "", url);
  }
}
function getThemeColor() {
  return window.document && window.document.documentElement.className.split(/\s+/).includes("dark") ? "dark" : "light";
}
function containEmoji(str) {
  return /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u.test(str);
}
function isMirror() {
  return !!(window == null ? void 0 : window.flutter_inappwebview);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
var keys = Object.keys;
var isArray$1 = Array.isArray;
if (typeof Promise !== "undefined" && !_global.Promise) {
  _global.Promise = Promise;
}
function extend$1(obj, extension) {
  if (typeof extension !== "object")
    return obj;
  keys(extension).forEach(function(key) {
    obj[key] = extension[key];
  });
  return obj;
}
var getProto = Object.getPrototypeOf;
var _hasOwn = {}.hasOwnProperty;
function hasOwn(obj, prop) {
  return _hasOwn.call(obj, prop);
}
function props(proto, extension) {
  if (typeof extension === "function")
    extension = extension(getProto(proto));
  (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(extension).forEach(function(key) {
    setProp(proto, key, extension[key]);
  });
}
var defineProperty = Object.defineProperty;
function setProp(obj, prop, functionOrGetSet, options) {
  defineProperty(obj, prop, extend$1(functionOrGetSet && hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? { get: functionOrGetSet.get, set: functionOrGetSet.set, configurable: true } : { value: functionOrGetSet, configurable: true, writable: true }, options));
}
function derive(Child) {
  return {
    from: function(Parent) {
      Child.prototype = Object.create(Parent.prototype);
      setProp(Child.prototype, "constructor", Child);
      return {
        extend: props.bind(null, Child.prototype)
      };
    }
  };
}
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function getPropertyDescriptor(obj, prop) {
  var pd = getOwnPropertyDescriptor(obj, prop);
  var proto;
  return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
}
var _slice = [].slice;
function slice(args, start2, end) {
  return _slice.call(args, start2, end);
}
function override(origFunc, overridedFactory) {
  return overridedFactory(origFunc);
}
function assert(b) {
  if (!b)
    throw new Error("Assertion Failed");
}
function asap$1(fn) {
  if (_global.setImmediate)
    setImmediate(fn);
  else
    setTimeout(fn, 0);
}
function arrayToObject(array, extractor) {
  return array.reduce(function(result, item, i) {
    var nameAndValue = extractor(item, i);
    if (nameAndValue)
      result[nameAndValue[0]] = nameAndValue[1];
    return result;
  }, {});
}
function tryCatch(fn, onerror, args) {
  try {
    fn.apply(null, args);
  } catch (ex) {
    onerror && onerror(ex);
  }
}
function getByKeyPath(obj, keyPath) {
  if (hasOwn(obj, keyPath))
    return obj[keyPath];
  if (!keyPath)
    return obj;
  if (typeof keyPath !== "string") {
    var rv = [];
    for (var i = 0, l = keyPath.length; i < l; ++i) {
      var val = getByKeyPath(obj, keyPath[i]);
      rv.push(val);
    }
    return rv;
  }
  var period = keyPath.indexOf(".");
  if (period !== -1) {
    var innerObj = obj[keyPath.substr(0, period)];
    return innerObj === void 0 ? void 0 : getByKeyPath(innerObj, keyPath.substr(period + 1));
  }
  return void 0;
}
function setByKeyPath(obj, keyPath, value) {
  if (!obj || keyPath === void 0)
    return;
  if ("isFrozen" in Object && Object.isFrozen(obj))
    return;
  if (typeof keyPath !== "string" && "length" in keyPath) {
    assert(typeof value !== "string" && "length" in value);
    for (var i = 0, l = keyPath.length; i < l; ++i) {
      setByKeyPath(obj, keyPath[i], value[i]);
    }
  } else {
    var period = keyPath.indexOf(".");
    if (period !== -1) {
      var currentKeyPath = keyPath.substr(0, period);
      var remainingKeyPath = keyPath.substr(period + 1);
      if (remainingKeyPath === "")
        if (value === void 0) {
          if (isArray$1(obj) && !isNaN(parseInt(currentKeyPath)))
            obj.splice(currentKeyPath, 1);
          else
            delete obj[currentKeyPath];
        } else
          obj[currentKeyPath] = value;
      else {
        var innerObj = obj[currentKeyPath];
        if (!innerObj || !hasOwn(obj, currentKeyPath))
          innerObj = obj[currentKeyPath] = {};
        setByKeyPath(innerObj, remainingKeyPath, value);
      }
    } else {
      if (value === void 0) {
        if (isArray$1(obj) && !isNaN(parseInt(keyPath)))
          obj.splice(keyPath, 1);
        else
          delete obj[keyPath];
      } else
        obj[keyPath] = value;
    }
  }
}
function delByKeyPath(obj, keyPath) {
  if (typeof keyPath === "string")
    setByKeyPath(obj, keyPath, void 0);
  else if ("length" in keyPath)
    [].map.call(keyPath, function(kp) {
      setByKeyPath(obj, kp, void 0);
    });
}
function shallowClone(obj) {
  var rv = {};
  for (var m2 in obj) {
    if (hasOwn(obj, m2))
      rv[m2] = obj[m2];
  }
  return rv;
}
var concat = [].concat;
function flatten(a) {
  return concat.apply([], a);
}
var intrinsicTypeNames = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(flatten([8, 16, 32, 64].map(function(num) {
  return ["Int", "Uint", "Float"].map(function(t) {
    return t + num + "Array";
  });
}))).filter(function(t) {
  return _global[t];
});
var intrinsicTypes = intrinsicTypeNames.map(function(t) {
  return _global[t];
});
arrayToObject(intrinsicTypeNames, function(x) {
  return [x, true];
});
var circularRefs = null;
function deepClone(any) {
  circularRefs = typeof WeakMap !== "undefined" && /* @__PURE__ */ new WeakMap();
  var rv = innerDeepClone(any);
  circularRefs = null;
  return rv;
}
function innerDeepClone(any) {
  if (!any || typeof any !== "object")
    return any;
  var rv = circularRefs && circularRefs.get(any);
  if (rv)
    return rv;
  if (isArray$1(any)) {
    rv = [];
    circularRefs && circularRefs.set(any, rv);
    for (var i = 0, l = any.length; i < l; ++i) {
      rv.push(innerDeepClone(any[i]));
    }
  } else if (intrinsicTypes.indexOf(any.constructor) >= 0) {
    rv = any;
  } else {
    var proto = getProto(any);
    rv = proto === Object.prototype ? {} : Object.create(proto);
    circularRefs && circularRefs.set(any, rv);
    for (var prop in any) {
      if (hasOwn(any, prop)) {
        rv[prop] = innerDeepClone(any[prop]);
      }
    }
  }
  return rv;
}
var toString$1 = {}.toString;
function toStringTag(o2) {
  return toString$1.call(o2).slice(8, -1);
}
var iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var getIteratorOf = typeof iteratorSymbol === "symbol" ? function(x) {
  var i;
  return x != null && (i = x[iteratorSymbol]) && i.apply(x);
} : function() {
  return null;
};
var NO_CHAR_ARRAY = {};
function getArrayOf(arrayLike) {
  var i, a, x, it;
  if (arguments.length === 1) {
    if (isArray$1(arrayLike))
      return arrayLike.slice();
    if (this === NO_CHAR_ARRAY && typeof arrayLike === "string")
      return [arrayLike];
    if (it = getIteratorOf(arrayLike)) {
      a = [];
      while (x = it.next(), !x.done)
        a.push(x.value);
      return a;
    }
    if (arrayLike == null)
      return [arrayLike];
    i = arrayLike.length;
    if (typeof i === "number") {
      a = new Array(i);
      while (i--)
        a[i] = arrayLike[i];
      return a;
    }
    return [arrayLike];
  }
  i = arguments.length;
  a = new Array(i);
  while (i--)
    a[i] = arguments[i];
  return a;
}
var isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
  return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
  return false;
};
var debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function setDebug(value, filter) {
  debug = value;
  libraryFilter = filter;
}
var libraryFilter = function() {
  return true;
};
var NEEDS_THROW_FOR_STACK = !new Error("").stack;
function getErrorWithStack() {
  if (NEEDS_THROW_FOR_STACK)
    try {
      getErrorWithStack.arguments;
      throw new Error();
    } catch (e) {
      return e;
    }
  return new Error();
}
function prettyStack(exception, numIgnoredFrames) {
  var stack = exception.stack;
  if (!stack)
    return "";
  numIgnoredFrames = numIgnoredFrames || 0;
  if (stack.indexOf(exception.name) === 0)
    numIgnoredFrames += (exception.name + exception.message).split("\n").length;
  return stack.split("\n").slice(numIgnoredFrames).filter(libraryFilter).map(function(frame) {
    return "\n" + frame;
  }).join("");
}
var dexieErrorNames = [
  "Modify",
  "Bulk",
  "OpenFailed",
  "VersionChange",
  "Schema",
  "Upgrade",
  "InvalidTable",
  "MissingAPI",
  "NoSuchDatabase",
  "InvalidArgument",
  "SubTransaction",
  "Unsupported",
  "Internal",
  "DatabaseClosed",
  "PrematureCommit",
  "ForeignAwait"
];
var idbDomErrorNames = [
  "Unknown",
  "Constraint",
  "Data",
  "TransactionInactive",
  "ReadOnly",
  "Version",
  "NotFound",
  "InvalidState",
  "InvalidAccess",
  "Abort",
  "Timeout",
  "QuotaExceeded",
  "Syntax",
  "DataClone"
];
var errorList = dexieErrorNames.concat(idbDomErrorNames);
var defaultTexts = {
  VersionChanged: "Database version changed by other database connection",
  DatabaseClosed: "Database has been closed",
  Abort: "Transaction aborted",
  TransactionInactive: "Transaction has already completed or failed",
  MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function DexieError(name2, msg) {
  this._e = getErrorWithStack();
  this.name = name2;
  this.message = msg;
}
derive(DexieError).from(Error).extend({
  stack: {
    get: function() {
      return this._stack || (this._stack = this.name + ": " + this.message + prettyStack(this._e, 2));
    }
  },
  toString: function() {
    return this.name + ": " + this.message;
  }
});
function getMultiErrorMessage(msg, failures) {
  return msg + ". Errors: " + Object.keys(failures).map(function(key) {
    return failures[key].toString();
  }).filter(function(v, i, s) {
    return s.indexOf(v) === i;
  }).join("\n");
}
function ModifyError(msg, failures, successCount, failedKeys) {
  this._e = getErrorWithStack();
  this.failures = failures;
  this.failedKeys = failedKeys;
  this.successCount = successCount;
  this.message = getMultiErrorMessage(msg, failures);
}
derive(ModifyError).from(DexieError);
function BulkError(msg, failures) {
  this._e = getErrorWithStack();
  this.name = "BulkError";
  this.failures = Object.keys(failures).map(function(pos) {
    return failures[pos];
  });
  this.failuresByPos = failures;
  this.message = getMultiErrorMessage(msg, failures);
}
derive(BulkError).from(DexieError);
var errnames = errorList.reduce(function(obj, name2) {
  return obj[name2] = name2 + "Error", obj;
}, {});
var BaseException = DexieError;
var exceptions = errorList.reduce(function(obj, name2) {
  var fullName = name2 + "Error";
  function DexieError2(msgOrInner, inner) {
    this._e = getErrorWithStack();
    this.name = fullName;
    if (!msgOrInner) {
      this.message = defaultTexts[name2] || fullName;
      this.inner = null;
    } else if (typeof msgOrInner === "string") {
      this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
      this.inner = inner || null;
    } else if (typeof msgOrInner === "object") {
      this.message = msgOrInner.name + " " + msgOrInner.message;
      this.inner = msgOrInner;
    }
  }
  derive(DexieError2).from(BaseException);
  obj[name2] = DexieError2;
  return obj;
}, {});
exceptions.Syntax = SyntaxError;
exceptions.Type = TypeError;
exceptions.Range = RangeError;
var exceptionMap = idbDomErrorNames.reduce(function(obj, name2) {
  obj[name2 + "Error"] = exceptions[name2];
  return obj;
}, {});
function mapError(domError, message) {
  if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name])
    return domError;
  var rv = new exceptionMap[domError.name](message || domError.message, domError);
  if ("stack" in domError) {
    setProp(rv, "stack", { get: function() {
      return this.inner.stack;
    } });
  }
  return rv;
}
var fullNameExceptions = errorList.reduce(function(obj, name2) {
  if (["Syntax", "Type", "Range"].indexOf(name2) === -1)
    obj[name2 + "Error"] = exceptions[name2];
  return obj;
}, {});
fullNameExceptions.ModifyError = ModifyError;
fullNameExceptions.DexieError = DexieError;
fullNameExceptions.BulkError = BulkError;
function nop() {
}
function mirror(val) {
  return val;
}
function pureFunctionChain(f1, f2) {
  if (f1 == null || f1 === mirror)
    return f2;
  return function(val) {
    return f2(f1(val));
  };
}
function callBoth(on1, on2) {
  return function() {
    on1.apply(this, arguments);
    on2.apply(this, arguments);
  };
}
function hookCreatingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    var res = f1.apply(this, arguments);
    if (res !== void 0)
      arguments[0] = res;
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = null;
    this.onerror = null;
    var res2 = f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    return res2 !== void 0 ? res2 : res;
  };
}
function hookDeletingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    f1.apply(this, arguments);
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = this.onerror = null;
    f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
  };
}
function hookUpdatingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function(modifications) {
    var res = f1.apply(this, arguments);
    extend$1(modifications, res);
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = null;
    this.onerror = null;
    var res2 = f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    return res === void 0 ? res2 === void 0 ? void 0 : res2 : extend$1(res, res2);
  };
}
function reverseStoppableEventChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    if (f2.apply(this, arguments) === false)
      return false;
    return f1.apply(this, arguments);
  };
}
function promisableChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    var res = f1.apply(this, arguments);
    if (res && typeof res.then === "function") {
      var thiz = this, i = arguments.length, args = new Array(i);
      while (i--)
        args[i] = arguments[i];
      return res.then(function() {
        return f2.apply(thiz, args);
      });
    }
    return f2.apply(this, arguments);
  };
}
var INTERNAL = {};
var LONG_STACKS_CLIP_LIMIT = 100, MAX_LONG_STACKS = 20, ZONE_ECHO_LIMIT = 100, _a$1 = typeof Promise === "undefined" ? [] : function() {
  var globalP = Promise.resolve();
  if (typeof crypto === "undefined" || !crypto.subtle)
    return [globalP, getProto(globalP), globalP];
  var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
  return [
    nativeP,
    getProto(nativeP),
    globalP
  ];
}(), resolvedNativePromise = _a$1[0], nativePromiseProto = _a$1[1], resolvedGlobalPromise = _a$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
var patchGlobalPromise = !!resolvedGlobalPromise;
var stack_being_generated = false;
var schedulePhysicalTick = resolvedGlobalPromise ? function() {
  resolvedGlobalPromise.then(physicalTick);
} : _global.setImmediate ? setImmediate.bind(null, physicalTick) : _global.MutationObserver ? function() {
  var hiddenDiv = document.createElement("div");
  new MutationObserver(function() {
    physicalTick();
    hiddenDiv = null;
  }).observe(hiddenDiv, { attributes: true });
  hiddenDiv.setAttribute("i", "1");
} : function() {
  setTimeout(physicalTick, 0);
};
var asap = function(callback, args) {
  microtickQueue.push([callback, args]);
  if (needsNewPhysicalTick) {
    schedulePhysicalTick();
    needsNewPhysicalTick = false;
  }
};
var isOutsideMicroTick = true, needsNewPhysicalTick = true, unhandledErrors = [], rejectingErrors = [], currentFulfiller = null, rejectionMapper = mirror;
var globalPSD = {
  id: "global",
  global: true,
  ref: 0,
  unhandleds: [],
  onunhandled: globalError,
  pgp: false,
  env: {},
  finalize: function() {
    this.unhandleds.forEach(function(uh) {
      try {
        globalError(uh[0], uh[1]);
      } catch (e) {
      }
    });
  }
};
var PSD = globalPSD;
var microtickQueue = [];
var numScheduledCalls = 0;
var tickFinalizers = [];
function DexiePromise(fn) {
  if (typeof this !== "object")
    throw new TypeError("Promises must be constructed via new");
  this._listeners = [];
  this.onuncatched = nop;
  this._lib = false;
  var psd = this._PSD = PSD;
  if (debug) {
    this._stackHolder = getErrorWithStack();
    this._prev = null;
    this._numPrev = 0;
  }
  if (typeof fn !== "function") {
    if (fn !== INTERNAL)
      throw new TypeError("Not a function");
    this._state = arguments[1];
    this._value = arguments[2];
    if (this._state === false)
      handleRejection(this, this._value);
    return;
  }
  this._state = null;
  this._value = null;
  ++psd.ref;
  executePromiseTask(this, fn);
}
var thenProp = {
  get: function() {
    var psd = PSD, microTaskId = totalEchoes;
    function then(onFulfilled, onRejected) {
      var _this = this;
      var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
      var cleanup = possibleAwait && !decrementExpectedAwaits();
      var rv = new DexiePromise(function(resolve, reject) {
        propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
      });
      debug && linkToPreviousPromise(rv, this);
      return rv;
    }
    then.prototype = INTERNAL;
    return then;
  },
  set: function(value) {
    setProp(this, "then", value && value.prototype === INTERNAL ? thenProp : {
      get: function() {
        return value;
      },
      set: thenProp.set
    });
  }
};
props(DexiePromise.prototype, {
  then: thenProp,
  _then: function(onFulfilled, onRejected) {
    propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
  },
  catch: function(onRejected) {
    if (arguments.length === 1)
      return this.then(null, onRejected);
    var type2 = arguments[0], handler = arguments[1];
    return typeof type2 === "function" ? this.then(null, function(err) {
      return err instanceof type2 ? handler(err) : PromiseReject(err);
    }) : this.then(null, function(err) {
      return err && err.name === type2 ? handler(err) : PromiseReject(err);
    });
  },
  finally: function(onFinally) {
    return this.then(function(value) {
      onFinally();
      return value;
    }, function(err) {
      onFinally();
      return PromiseReject(err);
    });
  },
  stack: {
    get: function() {
      if (this._stack)
        return this._stack;
      try {
        stack_being_generated = true;
        var stacks = getStack(this, [], MAX_LONG_STACKS);
        var stack = stacks.join("\nFrom previous: ");
        if (this._state !== null)
          this._stack = stack;
        return stack;
      } finally {
        stack_being_generated = false;
      }
    }
  },
  timeout: function(ms, msg) {
    var _this = this;
    return ms < Infinity ? new DexiePromise(function(resolve, reject) {
      var handle = setTimeout(function() {
        return reject(new exceptions.Timeout(msg));
      }, ms);
      _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
    }) : this;
  }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag)
  setProp(DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
globalPSD.env = snapShot();
function Listener(onFulfilled, onRejected, resolve, reject, zone) {
  this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
  this.onRejected = typeof onRejected === "function" ? onRejected : null;
  this.resolve = resolve;
  this.reject = reject;
  this.psd = zone;
}
props(DexiePromise, {
  all: function() {
    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function(resolve, reject) {
      if (values.length === 0)
        resolve([]);
      var remaining = values.length;
      values.forEach(function(a, i) {
        return DexiePromise.resolve(a).then(function(x) {
          values[i] = x;
          if (!--remaining)
            resolve(values);
        }, reject);
      });
    });
  },
  resolve: function(value) {
    if (value instanceof DexiePromise)
      return value;
    if (value && typeof value.then === "function")
      return new DexiePromise(function(resolve, reject) {
        value.then(resolve, reject);
      });
    var rv = new DexiePromise(INTERNAL, true, value);
    linkToPreviousPromise(rv, currentFulfiller);
    return rv;
  },
  reject: PromiseReject,
  race: function() {
    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function(resolve, reject) {
      values.map(function(value) {
        return DexiePromise.resolve(value).then(resolve, reject);
      });
    });
  },
  PSD: {
    get: function() {
      return PSD;
    },
    set: function(value) {
      return PSD = value;
    }
  },
  totalEchoes: { get: function() {
    return totalEchoes;
  } },
  newPSD: newScope,
  usePSD,
  scheduler: {
    get: function() {
      return asap;
    },
    set: function(value) {
      asap = value;
    }
  },
  rejectionMapper: {
    get: function() {
      return rejectionMapper;
    },
    set: function(value) {
      rejectionMapper = value;
    }
  },
  follow: function(fn, zoneProps) {
    return new DexiePromise(function(resolve, reject) {
      return newScope(function(resolve2, reject2) {
        var psd = PSD;
        psd.unhandleds = [];
        psd.onunhandled = reject2;
        psd.finalize = callBoth(function() {
          var _this = this;
          run_at_end_of_this_or_next_physical_tick(function() {
            _this.unhandleds.length === 0 ? resolve2() : reject2(_this.unhandleds[0]);
          });
        }, psd.finalize);
        fn();
      }, zoneProps, resolve, reject);
    });
  }
});
if (NativePromise) {
  if (NativePromise.allSettled)
    setProp(DexiePromise, "allSettled", function() {
      var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
      return new DexiePromise(function(resolve) {
        if (possiblePromises.length === 0)
          resolve([]);
        var remaining = possiblePromises.length;
        var results = new Array(remaining);
        possiblePromises.forEach(function(p, i) {
          return DexiePromise.resolve(p).then(function(value) {
            return results[i] = { status: "fulfilled", value };
          }, function(reason) {
            return results[i] = { status: "rejected", reason };
          }).then(function() {
            return --remaining || resolve(results);
          });
        });
      });
    });
  if (NativePromise.any && typeof AggregateError !== "undefined")
    setProp(DexiePromise, "any", function() {
      var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
      return new DexiePromise(function(resolve, reject) {
        if (possiblePromises.length === 0)
          reject(new AggregateError([]));
        var remaining = possiblePromises.length;
        var failures = new Array(remaining);
        possiblePromises.forEach(function(p, i) {
          return DexiePromise.resolve(p).then(function(value) {
            return resolve(value);
          }, function(failure) {
            failures[i] = failure;
            if (!--remaining)
              reject(new AggregateError(failures));
          });
        });
      });
    });
}
function executePromiseTask(promise, fn) {
  try {
    fn(function(value) {
      if (promise._state !== null)
        return;
      if (value === promise)
        throw new TypeError("A promise cannot be resolved with itself.");
      var shouldExecuteTick = promise._lib && beginMicroTickScope();
      if (value && typeof value.then === "function") {
        executePromiseTask(promise, function(resolve, reject) {
          value instanceof DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
        });
      } else {
        promise._state = true;
        promise._value = value;
        propagateAllListeners(promise);
      }
      if (shouldExecuteTick)
        endMicroTickScope();
    }, handleRejection.bind(null, promise));
  } catch (ex) {
    handleRejection(promise, ex);
  }
}
function handleRejection(promise, reason) {
  rejectingErrors.push(reason);
  if (promise._state !== null)
    return;
  var shouldExecuteTick = promise._lib && beginMicroTickScope();
  reason = rejectionMapper(reason);
  promise._state = false;
  promise._value = reason;
  debug && reason !== null && typeof reason === "object" && !reason._promise && tryCatch(function() {
    var origProp = getPropertyDescriptor(reason, "stack");
    reason._promise = promise;
    setProp(reason, "stack", {
      get: function() {
        return stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
      }
    });
  });
  addPossiblyUnhandledError(promise);
  propagateAllListeners(promise);
  if (shouldExecuteTick)
    endMicroTickScope();
}
function propagateAllListeners(promise) {
  var listeners = promise._listeners;
  promise._listeners = [];
  for (var i = 0, len = listeners.length; i < len; ++i) {
    propagateToListener(promise, listeners[i]);
  }
  var psd = promise._PSD;
  --psd.ref || psd.finalize();
  if (numScheduledCalls === 0) {
    ++numScheduledCalls;
    asap(function() {
      if (--numScheduledCalls === 0)
        finalizePhysicalTick();
    }, []);
  }
}
function propagateToListener(promise, listener) {
  if (promise._state === null) {
    promise._listeners.push(listener);
    return;
  }
  var cb = promise._state ? listener.onFulfilled : listener.onRejected;
  if (cb === null) {
    return (promise._state ? listener.resolve : listener.reject)(promise._value);
  }
  ++listener.psd.ref;
  ++numScheduledCalls;
  asap(callListener, [cb, promise, listener]);
}
function callListener(cb, promise, listener) {
  try {
    currentFulfiller = promise;
    var ret, value = promise._value;
    if (promise._state) {
      ret = cb(value);
    } else {
      if (rejectingErrors.length)
        rejectingErrors = [];
      ret = cb(value);
      if (rejectingErrors.indexOf(value) === -1)
        markErrorAsHandled(promise);
    }
    listener.resolve(ret);
  } catch (e) {
    listener.reject(e);
  } finally {
    currentFulfiller = null;
    if (--numScheduledCalls === 0)
      finalizePhysicalTick();
    --listener.psd.ref || listener.psd.finalize();
  }
}
function getStack(promise, stacks, limit) {
  if (stacks.length === limit)
    return stacks;
  var stack = "";
  if (promise._state === false) {
    var failure = promise._value, errorName, message;
    if (failure != null) {
      errorName = failure.name || "Error";
      message = failure.message || failure;
      stack = prettyStack(failure, 0);
    } else {
      errorName = failure;
      message = "";
    }
    stacks.push(errorName + (message ? ": " + message : "") + stack);
  }
  if (debug) {
    stack = prettyStack(promise._stackHolder, 2);
    if (stack && stacks.indexOf(stack) === -1)
      stacks.push(stack);
    if (promise._prev)
      getStack(promise._prev, stacks, limit);
  }
  return stacks;
}
function linkToPreviousPromise(promise, prev) {
  var numPrev = prev ? prev._numPrev + 1 : 0;
  if (numPrev < LONG_STACKS_CLIP_LIMIT) {
    promise._prev = prev;
    promise._numPrev = numPrev;
  }
}
function physicalTick() {
  beginMicroTickScope() && endMicroTickScope();
}
function beginMicroTickScope() {
  var wasRootExec = isOutsideMicroTick;
  isOutsideMicroTick = false;
  needsNewPhysicalTick = false;
  return wasRootExec;
}
function endMicroTickScope() {
  var callbacks, i, l;
  do {
    while (microtickQueue.length > 0) {
      callbacks = microtickQueue;
      microtickQueue = [];
      l = callbacks.length;
      for (i = 0; i < l; ++i) {
        var item = callbacks[i];
        item[0].apply(null, item[1]);
      }
    }
  } while (microtickQueue.length > 0);
  isOutsideMicroTick = true;
  needsNewPhysicalTick = true;
}
function finalizePhysicalTick() {
  var unhandledErrs = unhandledErrors;
  unhandledErrors = [];
  unhandledErrs.forEach(function(p) {
    p._PSD.onunhandled.call(null, p._value, p);
  });
  var finalizers = tickFinalizers.slice(0);
  var i = finalizers.length;
  while (i)
    finalizers[--i]();
}
function run_at_end_of_this_or_next_physical_tick(fn) {
  function finalizer() {
    fn();
    tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
  }
  tickFinalizers.push(finalizer);
  ++numScheduledCalls;
  asap(function() {
    if (--numScheduledCalls === 0)
      finalizePhysicalTick();
  }, []);
}
function addPossiblyUnhandledError(promise) {
  if (!unhandledErrors.some(function(p) {
    return p._value === promise._value;
  }))
    unhandledErrors.push(promise);
}
function markErrorAsHandled(promise) {
  var i = unhandledErrors.length;
  while (i)
    if (unhandledErrors[--i]._value === promise._value) {
      unhandledErrors.splice(i, 1);
      return;
    }
}
function PromiseReject(reason) {
  return new DexiePromise(INTERNAL, false, reason);
}
function wrap(fn, errorCatcher) {
  var psd = PSD;
  return function() {
    var wasRootExec = beginMicroTickScope(), outerScope = PSD;
    try {
      switchToZone(psd, true);
      return fn.apply(this, arguments);
    } catch (e) {
      errorCatcher && errorCatcher(e);
    } finally {
      switchToZone(outerScope, false);
      if (wasRootExec)
        endMicroTickScope();
    }
  };
}
var task = { awaits: 0, echoes: 0, id: 0 };
var taskCounter = 0;
var zoneStack = [];
var zoneEchoes = 0;
var totalEchoes = 0;
var zone_id_counter = 0;
function newScope(fn, props2, a1, a2) {
  var parent = PSD, psd = Object.create(parent);
  psd.parent = parent;
  psd.ref = 0;
  psd.global = false;
  psd.id = ++zone_id_counter;
  var globalEnv = globalPSD.env;
  psd.env = patchGlobalPromise ? {
    Promise: DexiePromise,
    PromiseProp: { value: DexiePromise, configurable: true, writable: true },
    all: DexiePromise.all,
    race: DexiePromise.race,
    allSettled: DexiePromise.allSettled,
    any: DexiePromise.any,
    resolve: DexiePromise.resolve,
    reject: DexiePromise.reject,
    nthen: getPatchedPromiseThen(globalEnv.nthen, psd),
    gthen: getPatchedPromiseThen(globalEnv.gthen, psd)
  } : {};
  if (props2)
    extend$1(psd, props2);
  ++parent.ref;
  psd.finalize = function() {
    --this.parent.ref || this.parent.finalize();
  };
  var rv = usePSD(psd, fn, a1, a2);
  if (psd.ref === 0)
    psd.finalize();
  return rv;
}
function incrementExpectedAwaits() {
  if (!task.id)
    task.id = ++taskCounter;
  ++task.awaits;
  task.echoes += ZONE_ECHO_LIMIT;
  return task.id;
}
function decrementExpectedAwaits() {
  if (!task.awaits)
    return false;
  if (--task.awaits === 0)
    task.id = 0;
  task.echoes = task.awaits * ZONE_ECHO_LIMIT;
  return true;
}
if (("" + nativePromiseThen).indexOf("[native code]") === -1) {
  incrementExpectedAwaits = decrementExpectedAwaits = nop;
}
function onPossibleParallellAsync(possiblePromise) {
  if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
    incrementExpectedAwaits();
    return possiblePromise.then(function(x) {
      decrementExpectedAwaits();
      return x;
    }, function(e) {
      decrementExpectedAwaits();
      return rejection(e);
    });
  }
  return possiblePromise;
}
function zoneEnterEcho(targetZone) {
  ++totalEchoes;
  if (!task.echoes || --task.echoes === 0) {
    task.echoes = task.id = 0;
  }
  zoneStack.push(PSD);
  switchToZone(targetZone, true);
}
function zoneLeaveEcho() {
  var zone = zoneStack[zoneStack.length - 1];
  zoneStack.pop();
  switchToZone(zone, false);
}
function switchToZone(targetZone, bEnteringZone) {
  var currentZone = PSD;
  if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) {
    enqueueNativeMicroTask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
  }
  if (targetZone === PSD)
    return;
  PSD = targetZone;
  if (currentZone === globalPSD)
    globalPSD.env = snapShot();
  if (patchGlobalPromise) {
    var GlobalPromise_1 = globalPSD.env.Promise;
    var targetEnv = targetZone.env;
    nativePromiseProto.then = targetEnv.nthen;
    GlobalPromise_1.prototype.then = targetEnv.gthen;
    if (currentZone.global || targetZone.global) {
      Object.defineProperty(_global, "Promise", targetEnv.PromiseProp);
      GlobalPromise_1.all = targetEnv.all;
      GlobalPromise_1.race = targetEnv.race;
      GlobalPromise_1.resolve = targetEnv.resolve;
      GlobalPromise_1.reject = targetEnv.reject;
      if (targetEnv.allSettled)
        GlobalPromise_1.allSettled = targetEnv.allSettled;
      if (targetEnv.any)
        GlobalPromise_1.any = targetEnv.any;
    }
  }
}
function snapShot() {
  var GlobalPromise = _global.Promise;
  return patchGlobalPromise ? {
    Promise: GlobalPromise,
    PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
    all: GlobalPromise.all,
    race: GlobalPromise.race,
    allSettled: GlobalPromise.allSettled,
    any: GlobalPromise.any,
    resolve: GlobalPromise.resolve,
    reject: GlobalPromise.reject,
    nthen: nativePromiseProto.then,
    gthen: GlobalPromise.prototype.then
  } : {};
}
function usePSD(psd, fn, a1, a2, a3) {
  var outerScope = PSD;
  try {
    switchToZone(psd, true);
    return fn(a1, a2, a3);
  } finally {
    switchToZone(outerScope, false);
  }
}
function enqueueNativeMicroTask(job) {
  nativePromiseThen.call(resolvedNativePromise, job);
}
function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
  return typeof fn !== "function" ? fn : function() {
    var outerZone = PSD;
    if (possibleAwait)
      incrementExpectedAwaits();
    switchToZone(zone, true);
    try {
      return fn.apply(this, arguments);
    } finally {
      switchToZone(outerZone, false);
      if (cleanup)
        enqueueNativeMicroTask(decrementExpectedAwaits);
    }
  };
}
function getPatchedPromiseThen(origThen, zone) {
  return function(onResolved, onRejected) {
    return origThen.call(this, nativeAwaitCompatibleWrap(onResolved, zone), nativeAwaitCompatibleWrap(onRejected, zone));
  };
}
var UNHANDLEDREJECTION = "unhandledrejection";
function globalError(err, promise) {
  var rv;
  try {
    rv = promise.onuncatched(err);
  } catch (e) {
  }
  if (rv !== false)
    try {
      var event, eventData = { promise, reason: err };
      if (_global.document && document.createEvent) {
        event = document.createEvent("Event");
        event.initEvent(UNHANDLEDREJECTION, true, true);
        extend$1(event, eventData);
      } else if (_global.CustomEvent) {
        event = new CustomEvent(UNHANDLEDREJECTION, { detail: eventData });
        extend$1(event, eventData);
      }
      if (event && _global.dispatchEvent) {
        dispatchEvent(event);
        if (!_global.PromiseRejectionEvent && _global.onunhandledrejection)
          try {
            _global.onunhandledrejection(event);
          } catch (_) {
          }
      }
      if (debug && event && !event.defaultPrevented) {
        console.warn("Unhandled rejection: " + (err.stack || err));
      }
    } catch (e) {
    }
}
var rejection = DexiePromise.reject;
function tempTransaction(db, mode, storeNames, fn) {
  if (!db.idbdb || !db._state.openComplete && (!PSD.letThrough && !db._vip)) {
    if (db._state.openComplete) {
      return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
    }
    if (!db._state.isBeingOpened) {
      if (!db._options.autoOpen)
        return rejection(new exceptions.DatabaseClosed());
      db.open().catch(nop);
    }
    return db._state.dbReadyPromise.then(function() {
      return tempTransaction(db, mode, storeNames, fn);
    });
  } else {
    var trans = db._createTransaction(mode, storeNames, db._dbSchema);
    try {
      trans.create();
      db._state.PR1398_maxLoop = 3;
    } catch (ex) {
      if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
        console.warn("Dexie: Need to reopen db");
        db._close();
        return db.open().then(function() {
          return tempTransaction(db, mode, storeNames, fn);
        });
      }
      return rejection(ex);
    }
    return trans._promise(mode, function(resolve, reject) {
      return newScope(function() {
        PSD.trans = trans;
        return fn(resolve, reject, trans);
      });
    }).then(function(result) {
      return trans._completion.then(function() {
        return result;
      });
    });
  }
}
var DEXIE_VERSION = "3.2.2";
var maxString = String.fromCharCode(65535);
var minKey = -Infinity;
var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var STRING_EXPECTED = "String expected.";
var connections = [];
var isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var hasIEDeleteObjectStoreBug = isIEOrEdge;
var hangsOnDeleteLargeKeyRange = isIEOrEdge;
var dexieStackFrameFilter = function(frame) {
  return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var DBNAMES_DB = "__dbnames";
var READONLY = "readonly";
var READWRITE = "readwrite";
function combine(filter1, filter2) {
  return filter1 ? filter2 ? function() {
    return filter1.apply(this, arguments) && filter2.apply(this, arguments);
  } : filter1 : filter2;
}
var AnyRange = {
  type: 3,
  lower: -Infinity,
  lowerOpen: false,
  upper: [[]],
  upperOpen: false
};
function workaroundForUndefinedPrimKey(keyPath) {
  return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
    if (obj[keyPath] === void 0 && keyPath in obj) {
      obj = deepClone(obj);
      delete obj[keyPath];
    }
    return obj;
  } : function(obj) {
    return obj;
  };
}
var Table = function() {
  function Table2() {
  }
  Table2.prototype._trans = function(mode, fn, writeLocked) {
    var trans = this._tx || PSD.trans;
    var tableName = this.name;
    function checkTableInTransaction(resolve, reject, trans2) {
      if (!trans2.schema[tableName])
        throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
      return fn(trans2.idbtrans, trans2);
    }
    var wasRootExec = beginMicroTickScope();
    try {
      return trans && trans.db === this.db ? trans === PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : newScope(function() {
        return trans._promise(mode, checkTableInTransaction, writeLocked);
      }, { trans, transless: PSD.transless || PSD }) : tempTransaction(this.db, mode, [this.name], checkTableInTransaction);
    } finally {
      if (wasRootExec)
        endMicroTickScope();
    }
  };
  Table2.prototype.get = function(keyOrCrit, cb) {
    var _this = this;
    if (keyOrCrit && keyOrCrit.constructor === Object)
      return this.where(keyOrCrit).first(cb);
    return this._trans("readonly", function(trans) {
      return _this.core.get({ trans, key: keyOrCrit }).then(function(res) {
        return _this.hook.reading.fire(res);
      });
    }).then(cb);
  };
  Table2.prototype.where = function(indexOrCrit) {
    if (typeof indexOrCrit === "string")
      return new this.db.WhereClause(this, indexOrCrit);
    if (isArray$1(indexOrCrit))
      return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
    var keyPaths = keys(indexOrCrit);
    if (keyPaths.length === 1)
      return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
    var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
      return ix.compound && keyPaths.every(function(keyPath) {
        return ix.keyPath.indexOf(keyPath) >= 0;
      }) && ix.keyPath.every(function(keyPath) {
        return keyPaths.indexOf(keyPath) >= 0;
      });
    })[0];
    if (compoundIndex && this.db._maxKey !== maxString)
      return this.where(compoundIndex.name).equals(compoundIndex.keyPath.map(function(kp) {
        return indexOrCrit[kp];
      }));
    if (!compoundIndex && debug)
      console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
    var idxByName = this.schema.idxByName;
    var idb = this.db._deps.indexedDB;
    function equals(a, b) {
      try {
        return idb.cmp(a, b) === 0;
      } catch (e) {
        return false;
      }
    }
    var _a2 = keyPaths.reduce(function(_a3, keyPath) {
      var prevIndex = _a3[0], prevFilterFn = _a3[1];
      var index2 = idxByName[keyPath];
      var value = indexOrCrit[keyPath];
      return [
        prevIndex || index2,
        prevIndex || !index2 ? combine(prevFilterFn, index2 && index2.multi ? function(x) {
          var prop = getByKeyPath(x, keyPath);
          return isArray$1(prop) && prop.some(function(item) {
            return equals(value, item);
          });
        } : function(x) {
          return equals(value, getByKeyPath(x, keyPath));
        }) : prevFilterFn
      ];
    }, [null, null]), idx = _a2[0], filterFunction = _a2[1];
    return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
  };
  Table2.prototype.filter = function(filterFunction) {
    return this.toCollection().and(filterFunction);
  };
  Table2.prototype.count = function(thenShortcut) {
    return this.toCollection().count(thenShortcut);
  };
  Table2.prototype.offset = function(offset) {
    return this.toCollection().offset(offset);
  };
  Table2.prototype.limit = function(numRows) {
    return this.toCollection().limit(numRows);
  };
  Table2.prototype.each = function(callback) {
    return this.toCollection().each(callback);
  };
  Table2.prototype.toArray = function(thenShortcut) {
    return this.toCollection().toArray(thenShortcut);
  };
  Table2.prototype.toCollection = function() {
    return new this.db.Collection(new this.db.WhereClause(this));
  };
  Table2.prototype.orderBy = function(index2) {
    return new this.db.Collection(new this.db.WhereClause(this, isArray$1(index2) ? "[" + index2.join("+") + "]" : index2));
  };
  Table2.prototype.reverse = function() {
    return this.toCollection().reverse();
  };
  Table2.prototype.mapToClass = function(constructor) {
    this.schema.mappedClass = constructor;
    var readHook = function(obj) {
      if (!obj)
        return obj;
      var res = Object.create(constructor.prototype);
      for (var m2 in obj)
        if (hasOwn(obj, m2))
          try {
            res[m2] = obj[m2];
          } catch (_) {
          }
      return res;
    };
    if (this.schema.readHook) {
      this.hook.reading.unsubscribe(this.schema.readHook);
    }
    this.schema.readHook = readHook;
    this.hook("reading", readHook);
    return constructor;
  };
  Table2.prototype.defineClass = function() {
    function Class(content) {
      extend$1(this, content);
    }
    return this.mapToClass(Class);
  };
  Table2.prototype.add = function(obj, key) {
    var _this = this;
    var _a2 = this.schema.primKey, auto = _a2.auto, keyPath = _a2.keyPath;
    var objToAdd = obj;
    if (keyPath && auto) {
      objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
    }
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "add", keys: key != null ? [key] : null, values: [objToAdd] });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
    }).then(function(lastResult) {
      if (keyPath) {
        try {
          setByKeyPath(obj, keyPath, lastResult);
        } catch (_) {
        }
      }
      return lastResult;
    });
  };
  Table2.prototype.update = function(keyOrObject, modifications) {
    if (typeof keyOrObject === "object" && !isArray$1(keyOrObject)) {
      var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
      if (key === void 0)
        return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
      try {
        if (typeof modifications !== "function") {
          keys(modifications).forEach(function(keyPath) {
            setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
          });
        } else {
          modifications(keyOrObject, { value: keyOrObject, primKey: key });
        }
      } catch (_a2) {
      }
      return this.where(":id").equals(key).modify(modifications);
    } else {
      return this.where(":id").equals(keyOrObject).modify(modifications);
    }
  };
  Table2.prototype.put = function(obj, key) {
    var _this = this;
    var _a2 = this.schema.primKey, auto = _a2.auto, keyPath = _a2.keyPath;
    var objToAdd = obj;
    if (keyPath && auto) {
      objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
    }
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "put", values: [objToAdd], keys: key != null ? [key] : null });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
    }).then(function(lastResult) {
      if (keyPath) {
        try {
          setByKeyPath(obj, keyPath, lastResult);
        } catch (_) {
        }
      }
      return lastResult;
    });
  };
  Table2.prototype.delete = function(key) {
    var _this = this;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "delete", keys: [key] });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
    });
  };
  Table2.prototype.clear = function() {
    var _this = this;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "deleteRange", range: AnyRange });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
    });
  };
  Table2.prototype.bulkGet = function(keys2) {
    var _this = this;
    return this._trans("readonly", function(trans) {
      return _this.core.getMany({
        keys: keys2,
        trans
      }).then(function(result) {
        return result.map(function(res) {
          return _this.hook.reading.fire(res);
        });
      });
    });
  };
  Table2.prototype.bulkAdd = function(objects, keysOrOptions, options) {
    var _this = this;
    var keys2 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
    options = options || (keys2 ? void 0 : keysOrOptions);
    var wantResults = options ? options.allKeys : void 0;
    return this._trans("readwrite", function(trans) {
      var _a2 = _this.schema.primKey, auto = _a2.auto, keyPath = _a2.keyPath;
      if (keyPath && keys2)
        throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
      if (keys2 && keys2.length !== objects.length)
        throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
      var numObjects = objects.length;
      var objectsToAdd = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
      return _this.core.mutate({ trans, type: "add", keys: keys2, values: objectsToAdd, wantResults }).then(function(_a3) {
        var numFailures = _a3.numFailures, results = _a3.results, lastResult = _a3.lastResult, failures = _a3.failures;
        var result = wantResults ? results : lastResult;
        if (numFailures === 0)
          return result;
        throw new BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
      });
    });
  };
  Table2.prototype.bulkPut = function(objects, keysOrOptions, options) {
    var _this = this;
    var keys2 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
    options = options || (keys2 ? void 0 : keysOrOptions);
    var wantResults = options ? options.allKeys : void 0;
    return this._trans("readwrite", function(trans) {
      var _a2 = _this.schema.primKey, auto = _a2.auto, keyPath = _a2.keyPath;
      if (keyPath && keys2)
        throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
      if (keys2 && keys2.length !== objects.length)
        throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
      var numObjects = objects.length;
      var objectsToPut = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
      return _this.core.mutate({ trans, type: "put", keys: keys2, values: objectsToPut, wantResults }).then(function(_a3) {
        var numFailures = _a3.numFailures, results = _a3.results, lastResult = _a3.lastResult, failures = _a3.failures;
        var result = wantResults ? results : lastResult;
        if (numFailures === 0)
          return result;
        throw new BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
      });
    });
  };
  Table2.prototype.bulkDelete = function(keys2) {
    var _this = this;
    var numKeys = keys2.length;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "delete", keys: keys2 });
    }).then(function(_a2) {
      var numFailures = _a2.numFailures, lastResult = _a2.lastResult, failures = _a2.failures;
      if (numFailures === 0)
        return lastResult;
      throw new BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
    });
  };
  return Table2;
}();
function Events(ctx) {
  var evs = {};
  var rv = function(eventName, subscriber) {
    if (subscriber) {
      var i2 = arguments.length, args = new Array(i2 - 1);
      while (--i2)
        args[i2 - 1] = arguments[i2];
      evs[eventName].subscribe.apply(null, args);
      return ctx;
    } else if (typeof eventName === "string") {
      return evs[eventName];
    }
  };
  rv.addEventType = add;
  for (var i = 1, l = arguments.length; i < l; ++i) {
    add(arguments[i]);
  }
  return rv;
  function add(eventName, chainFunction, defaultFunction) {
    if (typeof eventName === "object")
      return addConfiguredEvents(eventName);
    if (!chainFunction)
      chainFunction = reverseStoppableEventChain;
    if (!defaultFunction)
      defaultFunction = nop;
    var context = {
      subscribers: [],
      fire: defaultFunction,
      subscribe: function(cb) {
        if (context.subscribers.indexOf(cb) === -1) {
          context.subscribers.push(cb);
          context.fire = chainFunction(context.fire, cb);
        }
      },
      unsubscribe: function(cb) {
        context.subscribers = context.subscribers.filter(function(fn) {
          return fn !== cb;
        });
        context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
      }
    };
    evs[eventName] = rv[eventName] = context;
    return context;
  }
  function addConfiguredEvents(cfg) {
    keys(cfg).forEach(function(eventName) {
      var args = cfg[eventName];
      if (isArray$1(args)) {
        add(eventName, cfg[eventName][0], cfg[eventName][1]);
      } else if (args === "asap") {
        var context = add(eventName, mirror, function fire() {
          var i2 = arguments.length, args2 = new Array(i2);
          while (i2--)
            args2[i2] = arguments[i2];
          context.subscribers.forEach(function(fn) {
            asap$1(function fireEvent() {
              fn.apply(null, args2);
            });
          });
        });
      } else
        throw new exceptions.InvalidArgument("Invalid event config");
    });
  }
}
function makeClassConstructor(prototype, constructor) {
  derive(constructor).from({ prototype });
  return constructor;
}
function createTableConstructor(db) {
  return makeClassConstructor(Table.prototype, function Table2(name2, tableSchema, trans) {
    this.db = db;
    this._tx = trans;
    this.name = name2;
    this.schema = tableSchema;
    this.hook = db._allTables[name2] ? db._allTables[name2].hook : Events(null, {
      "creating": [hookCreatingChain, nop],
      "reading": [pureFunctionChain, mirror],
      "updating": [hookUpdatingChain, nop],
      "deleting": [hookDeletingChain, nop]
    });
  });
}
function isPlainKeyRange(ctx, ignoreLimitFilter) {
  return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function addFilter(ctx, fn) {
  ctx.filter = combine(ctx.filter, fn);
}
function addReplayFilter(ctx, factory, isLimitFilter) {
  var curr = ctx.replayFilter;
  ctx.replayFilter = curr ? function() {
    return combine(curr(), factory());
  } : factory;
  ctx.justLimit = isLimitFilter && !curr;
}
function addMatchFilter(ctx, fn) {
  ctx.isMatch = combine(ctx.isMatch, fn);
}
function getIndexOrStore(ctx, coreSchema) {
  if (ctx.isPrimKey)
    return coreSchema.primaryKey;
  var index2 = coreSchema.getIndexByKeyPath(ctx.index);
  if (!index2)
    throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
  return index2;
}
function openCursor(ctx, coreTable, trans) {
  var index2 = getIndexOrStore(ctx, coreTable.schema);
  return coreTable.openCursor({
    trans,
    values: !ctx.keysOnly,
    reverse: ctx.dir === "prev",
    unique: !!ctx.unique,
    query: {
      index: index2,
      range: ctx.range
    }
  });
}
function iter(ctx, fn, coreTrans, coreTable) {
  var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
  if (!ctx.or) {
    return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
  } else {
    var set_1 = {};
    var union2 = function(item, cursor, advance) {
      if (!filter || filter(cursor, advance, function(result) {
        return cursor.stop(result);
      }, function(err) {
        return cursor.fail(err);
      })) {
        var primaryKey = cursor.primaryKey;
        var key = "" + primaryKey;
        if (key === "[object ArrayBuffer]")
          key = "" + new Uint8Array(primaryKey);
        if (!hasOwn(set_1, key)) {
          set_1[key] = true;
          fn(item, cursor, advance);
        }
      }
    };
    return Promise.all([
      ctx.or._iterate(union2, coreTrans),
      iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union2, !ctx.keysOnly && ctx.valueMapper)
    ]);
  }
}
function iterate(cursorPromise, filter, fn, valueMapper) {
  var mappedFn = valueMapper ? function(x, c, a) {
    return fn(valueMapper(x), c, a);
  } : fn;
  var wrappedFn = wrap(mappedFn);
  return cursorPromise.then(function(cursor) {
    if (cursor) {
      return cursor.start(function() {
        var c = function() {
          return cursor.continue();
        };
        if (!filter || filter(cursor, function(advancer) {
          return c = advancer;
        }, function(val) {
          cursor.stop(val);
          c = nop;
        }, function(e) {
          cursor.fail(e);
          c = nop;
        }))
          wrappedFn(cursor.value, cursor, function(advancer) {
            return c = advancer;
          });
        c();
      });
    }
  });
}
function cmp(a, b) {
  try {
    var ta = type(a);
    var tb = type(b);
    if (ta !== tb) {
      if (ta === "Array")
        return 1;
      if (tb === "Array")
        return -1;
      if (ta === "binary")
        return 1;
      if (tb === "binary")
        return -1;
      if (ta === "string")
        return 1;
      if (tb === "string")
        return -1;
      if (ta === "Date")
        return 1;
      if (tb !== "Date")
        return NaN;
      return -1;
    }
    switch (ta) {
      case "number":
      case "Date":
      case "string":
        return a > b ? 1 : a < b ? -1 : 0;
      case "binary": {
        return compareUint8Arrays(getUint8Array(a), getUint8Array(b));
      }
      case "Array":
        return compareArrays(a, b);
    }
  } catch (_a2) {
  }
  return NaN;
}
function compareArrays(a, b) {
  var al = a.length;
  var bl = b.length;
  var l = al < bl ? al : bl;
  for (var i = 0; i < l; ++i) {
    var res = cmp(a[i], b[i]);
    if (res !== 0)
      return res;
  }
  return al === bl ? 0 : al < bl ? -1 : 1;
}
function compareUint8Arrays(a, b) {
  var al = a.length;
  var bl = b.length;
  var l = al < bl ? al : bl;
  for (var i = 0; i < l; ++i) {
    if (a[i] !== b[i])
      return a[i] < b[i] ? -1 : 1;
  }
  return al === bl ? 0 : al < bl ? -1 : 1;
}
function type(x) {
  var t = typeof x;
  if (t !== "object")
    return t;
  if (ArrayBuffer.isView(x))
    return "binary";
  var tsTag = toStringTag(x);
  return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function getUint8Array(a) {
  if (a instanceof Uint8Array)
    return a;
  if (ArrayBuffer.isView(a))
    return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
  return new Uint8Array(a);
}
var Collection = function() {
  function Collection2() {
  }
  Collection2.prototype._read = function(fn, cb) {
    var ctx = this._ctx;
    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
  };
  Collection2.prototype._write = function(fn) {
    var ctx = this._ctx;
    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
  };
  Collection2.prototype._addAlgorithm = function(fn) {
    var ctx = this._ctx;
    ctx.algorithm = combine(ctx.algorithm, fn);
  };
  Collection2.prototype._iterate = function(fn, coreTrans) {
    return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
  };
  Collection2.prototype.clone = function(props2) {
    var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
    if (props2)
      extend$1(ctx, props2);
    rv._ctx = ctx;
    return rv;
  };
  Collection2.prototype.raw = function() {
    this._ctx.valueMapper = null;
    return this;
  };
  Collection2.prototype.each = function(fn) {
    var ctx = this._ctx;
    return this._read(function(trans) {
      return iter(ctx, fn, trans, ctx.table.core);
    });
  };
  Collection2.prototype.count = function(cb) {
    var _this = this;
    return this._read(function(trans) {
      var ctx = _this._ctx;
      var coreTable = ctx.table.core;
      if (isPlainKeyRange(ctx, true)) {
        return coreTable.count({
          trans,
          query: {
            index: getIndexOrStore(ctx, coreTable.schema),
            range: ctx.range
          }
        }).then(function(count2) {
          return Math.min(count2, ctx.limit);
        });
      } else {
        var count = 0;
        return iter(ctx, function() {
          ++count;
          return false;
        }, trans, coreTable).then(function() {
          return count;
        });
      }
    }).then(cb);
  };
  Collection2.prototype.sortBy = function(keyPath, cb) {
    var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
    function getval(obj, i) {
      if (i)
        return getval(obj[parts[i]], i - 1);
      return obj[lastPart];
    }
    var order = this._ctx.dir === "next" ? 1 : -1;
    function sorter(a, b) {
      var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
      return aVal < bVal ? -order : aVal > bVal ? order : 0;
    }
    return this.toArray(function(a) {
      return a.sort(sorter);
    }).then(cb);
  };
  Collection2.prototype.toArray = function(cb) {
    var _this = this;
    return this._read(function(trans) {
      var ctx = _this._ctx;
      if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
        var valueMapper_1 = ctx.valueMapper;
        var index2 = getIndexOrStore(ctx, ctx.table.core.schema);
        return ctx.table.core.query({
          trans,
          limit: ctx.limit,
          values: true,
          query: {
            index: index2,
            range: ctx.range
          }
        }).then(function(_a2) {
          var result = _a2.result;
          return valueMapper_1 ? result.map(valueMapper_1) : result;
        });
      } else {
        var a_1 = [];
        return iter(ctx, function(item) {
          return a_1.push(item);
        }, trans, ctx.table.core).then(function() {
          return a_1;
        });
      }
    }, cb);
  };
  Collection2.prototype.offset = function(offset) {
    var ctx = this._ctx;
    if (offset <= 0)
      return this;
    ctx.offset += offset;
    if (isPlainKeyRange(ctx)) {
      addReplayFilter(ctx, function() {
        var offsetLeft = offset;
        return function(cursor, advance) {
          if (offsetLeft === 0)
            return true;
          if (offsetLeft === 1) {
            --offsetLeft;
            return false;
          }
          advance(function() {
            cursor.advance(offsetLeft);
            offsetLeft = 0;
          });
          return false;
        };
      });
    } else {
      addReplayFilter(ctx, function() {
        var offsetLeft = offset;
        return function() {
          return --offsetLeft < 0;
        };
      });
    }
    return this;
  };
  Collection2.prototype.limit = function(numRows) {
    this._ctx.limit = Math.min(this._ctx.limit, numRows);
    addReplayFilter(this._ctx, function() {
      var rowsLeft = numRows;
      return function(cursor, advance, resolve) {
        if (--rowsLeft <= 0)
          advance(resolve);
        return rowsLeft >= 0;
      };
    }, true);
    return this;
  };
  Collection2.prototype.until = function(filterFunction, bIncludeStopEntry) {
    addFilter(this._ctx, function(cursor, advance, resolve) {
      if (filterFunction(cursor.value)) {
        advance(resolve);
        return bIncludeStopEntry;
      } else {
        return true;
      }
    });
    return this;
  };
  Collection2.prototype.first = function(cb) {
    return this.limit(1).toArray(function(a) {
      return a[0];
    }).then(cb);
  };
  Collection2.prototype.last = function(cb) {
    return this.reverse().first(cb);
  };
  Collection2.prototype.filter = function(filterFunction) {
    addFilter(this._ctx, function(cursor) {
      return filterFunction(cursor.value);
    });
    addMatchFilter(this._ctx, filterFunction);
    return this;
  };
  Collection2.prototype.and = function(filter) {
    return this.filter(filter);
  };
  Collection2.prototype.or = function(indexName) {
    return new this.db.WhereClause(this._ctx.table, indexName, this);
  };
  Collection2.prototype.reverse = function() {
    this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
    if (this._ondirectionchange)
      this._ondirectionchange(this._ctx.dir);
    return this;
  };
  Collection2.prototype.desc = function() {
    return this.reverse();
  };
  Collection2.prototype.eachKey = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    return this.each(function(val, cursor) {
      cb(cursor.key, cursor);
    });
  };
  Collection2.prototype.eachUniqueKey = function(cb) {
    this._ctx.unique = "unique";
    return this.eachKey(cb);
  };
  Collection2.prototype.eachPrimaryKey = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    return this.each(function(val, cursor) {
      cb(cursor.primaryKey, cursor);
    });
  };
  Collection2.prototype.keys = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    var a = [];
    return this.each(function(item, cursor) {
      a.push(cursor.key);
    }).then(function() {
      return a;
    }).then(cb);
  };
  Collection2.prototype.primaryKeys = function(cb) {
    var ctx = this._ctx;
    if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
      return this._read(function(trans) {
        var index2 = getIndexOrStore(ctx, ctx.table.core.schema);
        return ctx.table.core.query({
          trans,
          values: false,
          limit: ctx.limit,
          query: {
            index: index2,
            range: ctx.range
          }
        });
      }).then(function(_a2) {
        var result = _a2.result;
        return result;
      }).then(cb);
    }
    ctx.keysOnly = !ctx.isMatch;
    var a = [];
    return this.each(function(item, cursor) {
      a.push(cursor.primaryKey);
    }).then(function() {
      return a;
    }).then(cb);
  };
  Collection2.prototype.uniqueKeys = function(cb) {
    this._ctx.unique = "unique";
    return this.keys(cb);
  };
  Collection2.prototype.firstKey = function(cb) {
    return this.limit(1).keys(function(a) {
      return a[0];
    }).then(cb);
  };
  Collection2.prototype.lastKey = function(cb) {
    return this.reverse().firstKey(cb);
  };
  Collection2.prototype.distinct = function() {
    var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
    if (!idx || !idx.multi)
      return this;
    var set = {};
    addFilter(this._ctx, function(cursor) {
      var strKey = cursor.primaryKey.toString();
      var found = hasOwn(set, strKey);
      set[strKey] = true;
      return !found;
    });
    return this;
  };
  Collection2.prototype.modify = function(changes) {
    var _this = this;
    var ctx = this._ctx;
    return this._write(function(trans) {
      var modifyer;
      if (typeof changes === "function") {
        modifyer = changes;
      } else {
        var keyPaths = keys(changes);
        var numKeys = keyPaths.length;
        modifyer = function(item) {
          var anythingModified = false;
          for (var i = 0; i < numKeys; ++i) {
            var keyPath = keyPaths[i], val = changes[keyPath];
            if (getByKeyPath(item, keyPath) !== val) {
              setByKeyPath(item, keyPath, val);
              anythingModified = true;
            }
          }
          return anythingModified;
        };
      }
      var coreTable = ctx.table.core;
      var _a2 = coreTable.schema.primaryKey, outbound = _a2.outbound, extractKey = _a2.extractKey;
      var limit = _this.db._options.modifyChunkSize || 200;
      var totalFailures = [];
      var successCount = 0;
      var failedKeys = [];
      var applyMutateResult = function(expectedCount, res) {
        var failures = res.failures, numFailures = res.numFailures;
        successCount += expectedCount - numFailures;
        for (var _i = 0, _a3 = keys(failures); _i < _a3.length; _i++) {
          var pos = _a3[_i];
          totalFailures.push(failures[pos]);
        }
      };
      return _this.clone().primaryKeys().then(function(keys2) {
        var nextChunk = function(offset) {
          var count = Math.min(limit, keys2.length - offset);
          return coreTable.getMany({
            trans,
            keys: keys2.slice(offset, offset + count),
            cache: "immutable"
          }).then(function(values) {
            var addValues = [];
            var putValues = [];
            var putKeys = outbound ? [] : null;
            var deleteKeys = [];
            for (var i = 0; i < count; ++i) {
              var origValue = values[i];
              var ctx_1 = {
                value: deepClone(origValue),
                primKey: keys2[offset + i]
              };
              if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                if (ctx_1.value == null) {
                  deleteKeys.push(keys2[offset + i]);
                } else if (!outbound && cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                  deleteKeys.push(keys2[offset + i]);
                  addValues.push(ctx_1.value);
                } else {
                  putValues.push(ctx_1.value);
                  if (outbound)
                    putKeys.push(keys2[offset + i]);
                }
              }
            }
            var criteria = isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === deleteCallback) && {
              index: ctx.index,
              range: ctx.range
            };
            return Promise.resolve(addValues.length > 0 && coreTable.mutate({ trans, type: "add", values: addValues }).then(function(res) {
              for (var pos in res.failures) {
                deleteKeys.splice(parseInt(pos), 1);
              }
              applyMutateResult(addValues.length, res);
            })).then(function() {
              return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                trans,
                type: "put",
                keys: putKeys,
                values: putValues,
                criteria,
                changeSpec: typeof changes !== "function" && changes
              }).then(function(res) {
                return applyMutateResult(putValues.length, res);
              });
            }).then(function() {
              return (deleteKeys.length > 0 || criteria && changes === deleteCallback) && coreTable.mutate({
                trans,
                type: "delete",
                keys: deleteKeys,
                criteria
              }).then(function(res) {
                return applyMutateResult(deleteKeys.length, res);
              });
            }).then(function() {
              return keys2.length > offset + count && nextChunk(offset + limit);
            });
          });
        };
        return nextChunk(0).then(function() {
          if (totalFailures.length > 0)
            throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
          return keys2.length;
        });
      });
    });
  };
  Collection2.prototype.delete = function() {
    var ctx = this._ctx, range = ctx.range;
    if (isPlainKeyRange(ctx) && (ctx.isPrimKey && !hangsOnDeleteLargeKeyRange || range.type === 3)) {
      return this._write(function(trans) {
        var primaryKey = ctx.table.core.schema.primaryKey;
        var coreRange = range;
        return ctx.table.core.count({ trans, query: { index: primaryKey, range: coreRange } }).then(function(count) {
          return ctx.table.core.mutate({ trans, type: "deleteRange", range: coreRange }).then(function(_a2) {
            var failures = _a2.failures;
            _a2.lastResult;
            _a2.results;
            var numFailures = _a2.numFailures;
            if (numFailures)
              throw new ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                return failures[pos];
              }), count - numFailures);
            return count - numFailures;
          });
        });
      });
    }
    return this.modify(deleteCallback);
  };
  return Collection2;
}();
var deleteCallback = function(value, ctx) {
  return ctx.value = null;
};
function createCollectionConstructor(db) {
  return makeClassConstructor(Collection.prototype, function Collection2(whereClause, keyRangeGenerator) {
    this.db = db;
    var keyRange = AnyRange, error = null;
    if (keyRangeGenerator)
      try {
        keyRange = keyRangeGenerator();
      } catch (ex) {
        error = ex;
      }
    var whereCtx = whereClause._ctx;
    var table = whereCtx.table;
    var readingHook = table.hook.reading.fire;
    this._ctx = {
      table,
      index: whereCtx.index,
      isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
      range: keyRange,
      keysOnly: false,
      dir: "next",
      unique: "",
      algorithm: null,
      filter: null,
      replayFilter: null,
      justLimit: true,
      isMatch: null,
      offset: 0,
      limit: Infinity,
      error,
      or: whereCtx.or,
      valueMapper: readingHook !== mirror ? readingHook : null
    };
  });
}
function simpleCompare(a, b) {
  return a < b ? -1 : a === b ? 0 : 1;
}
function simpleCompareReverse(a, b) {
  return a > b ? -1 : a === b ? 0 : 1;
}
function fail(collectionOrWhereClause, err, T) {
  var collection = collectionOrWhereClause instanceof WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
  collection._ctx.error = T ? new T(err) : new TypeError(err);
  return collection;
}
function emptyCollection(whereClause) {
  return new whereClause.Collection(whereClause, function() {
    return rangeEqual("");
  }).limit(0);
}
function upperFactory(dir) {
  return dir === "next" ? function(s) {
    return s.toUpperCase();
  } : function(s) {
    return s.toLowerCase();
  };
}
function lowerFactory(dir) {
  return dir === "next" ? function(s) {
    return s.toLowerCase();
  } : function(s) {
    return s.toUpperCase();
  };
}
function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp2, dir) {
  var length = Math.min(key.length, lowerNeedle.length);
  var llp = -1;
  for (var i = 0; i < length; ++i) {
    var lwrKeyChar = lowerKey[i];
    if (lwrKeyChar !== lowerNeedle[i]) {
      if (cmp2(key[i], upperNeedle[i]) < 0)
        return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
      if (cmp2(key[i], lowerNeedle[i]) < 0)
        return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
      if (llp >= 0)
        return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
      return null;
    }
    if (cmp2(key[i], lwrKeyChar) < 0)
      llp = i;
  }
  if (length < lowerNeedle.length && dir === "next")
    return key + upperNeedle.substr(key.length);
  if (length < key.length && dir === "prev")
    return key.substr(0, upperNeedle.length);
  return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
  var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
  if (!needles.every(function(s) {
    return typeof s === "string";
  })) {
    return fail(whereClause, STRING_EXPECTED);
  }
  function initDirection(dir) {
    upper = upperFactory(dir);
    lower = lowerFactory(dir);
    compare = dir === "next" ? simpleCompare : simpleCompareReverse;
    var needleBounds = needles.map(function(needle) {
      return { lower: lower(needle), upper: upper(needle) };
    }).sort(function(a, b) {
      return compare(a.lower, b.lower);
    });
    upperNeedles = needleBounds.map(function(nb) {
      return nb.upper;
    });
    lowerNeedles = needleBounds.map(function(nb) {
      return nb.lower;
    });
    direction = dir;
    nextKeySuffix = dir === "next" ? "" : suffix;
  }
  initDirection("next");
  var c = new whereClause.Collection(whereClause, function() {
    return createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
  });
  c._ondirectionchange = function(direction2) {
    initDirection(direction2);
  };
  var firstPossibleNeedle = 0;
  c._addAlgorithm(function(cursor, advance, resolve) {
    var key = cursor.key;
    if (typeof key !== "string")
      return false;
    var lowerKey = lower(key);
    if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) {
      return true;
    } else {
      var lowestPossibleCasing = null;
      for (var i = firstPossibleNeedle; i < needlesLen; ++i) {
        var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
        if (casing === null && lowestPossibleCasing === null)
          firstPossibleNeedle = i + 1;
        else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) {
          lowestPossibleCasing = casing;
        }
      }
      if (lowestPossibleCasing !== null) {
        advance(function() {
          cursor.continue(lowestPossibleCasing + nextKeySuffix);
        });
      } else {
        advance(resolve);
      }
      return false;
    }
  });
  return c;
}
function createRange(lower, upper, lowerOpen, upperOpen) {
  return {
    type: 2,
    lower,
    upper,
    lowerOpen,
    upperOpen
  };
}
function rangeEqual(value) {
  return {
    type: 1,
    lower: value,
    upper: value
  };
}
var WhereClause = function() {
  function WhereClause2() {
  }
  Object.defineProperty(WhereClause2.prototype, "Collection", {
    get: function() {
      return this._ctx.table.db.Collection;
    },
    enumerable: false,
    configurable: true
  });
  WhereClause2.prototype.between = function(lower, upper, includeLower, includeUpper) {
    includeLower = includeLower !== false;
    includeUpper = includeUpper === true;
    try {
      if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper))
        return emptyCollection(this);
      return new this.Collection(this, function() {
        return createRange(lower, upper, !includeLower, !includeUpper);
      });
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
  };
  WhereClause2.prototype.equals = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return rangeEqual(value);
    });
  };
  WhereClause2.prototype.above = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(value, void 0, true);
    });
  };
  WhereClause2.prototype.aboveOrEqual = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(value, void 0, false);
    });
  };
  WhereClause2.prototype.below = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(void 0, value, false, true);
    });
  };
  WhereClause2.prototype.belowOrEqual = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(void 0, value);
    });
  };
  WhereClause2.prototype.startsWith = function(str) {
    if (typeof str !== "string")
      return fail(this, STRING_EXPECTED);
    return this.between(str, str + maxString, true, true);
  };
  WhereClause2.prototype.startsWithIgnoreCase = function(str) {
    if (str === "")
      return this.startsWith(str);
    return addIgnoreCaseAlgorithm(this, function(x, a) {
      return x.indexOf(a[0]) === 0;
    }, [str], maxString);
  };
  WhereClause2.prototype.equalsIgnoreCase = function(str) {
    return addIgnoreCaseAlgorithm(this, function(x, a) {
      return x === a[0];
    }, [str], "");
  };
  WhereClause2.prototype.anyOfIgnoreCase = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return emptyCollection(this);
    return addIgnoreCaseAlgorithm(this, function(x, a) {
      return a.indexOf(x) !== -1;
    }, set, "");
  };
  WhereClause2.prototype.startsWithAnyOfIgnoreCase = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return emptyCollection(this);
    return addIgnoreCaseAlgorithm(this, function(x, a) {
      return a.some(function(n) {
        return x.indexOf(n) === 0;
      });
    }, set, maxString);
  };
  WhereClause2.prototype.anyOf = function() {
    var _this = this;
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    var compare = this._cmp;
    try {
      set.sort(compare);
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    if (set.length === 0)
      return emptyCollection(this);
    var c = new this.Collection(this, function() {
      return createRange(set[0], set[set.length - 1]);
    });
    c._ondirectionchange = function(direction) {
      compare = direction === "next" ? _this._ascending : _this._descending;
      set.sort(compare);
    };
    var i = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
      var key = cursor.key;
      while (compare(key, set[i]) > 0) {
        ++i;
        if (i === set.length) {
          advance(resolve);
          return false;
        }
      }
      if (compare(key, set[i]) === 0) {
        return true;
      } else {
        advance(function() {
          cursor.continue(set[i]);
        });
        return false;
      }
    });
    return c;
  };
  WhereClause2.prototype.notEqual = function(value) {
    return this.inAnyRange([[minKey, value], [value, this.db._maxKey]], { includeLowers: false, includeUppers: false });
  };
  WhereClause2.prototype.noneOf = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return new this.Collection(this);
    try {
      set.sort(this._ascending);
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var ranges = set.reduce(function(res, val) {
      return res ? res.concat([[res[res.length - 1][1], val]]) : [[minKey, val]];
    }, null);
    ranges.push([set[set.length - 1], this.db._maxKey]);
    return this.inAnyRange(ranges, { includeLowers: false, includeUppers: false });
  };
  WhereClause2.prototype.inAnyRange = function(ranges, options) {
    var _this = this;
    var cmp2 = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
    if (ranges.length === 0)
      return emptyCollection(this);
    if (!ranges.every(function(range) {
      return range[0] !== void 0 && range[1] !== void 0 && ascending(range[0], range[1]) <= 0;
    })) {
      return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
    }
    var includeLowers = !options || options.includeLowers !== false;
    var includeUppers = options && options.includeUppers === true;
    function addRange2(ranges2, newRange) {
      var i = 0, l = ranges2.length;
      for (; i < l; ++i) {
        var range = ranges2[i];
        if (cmp2(newRange[0], range[1]) < 0 && cmp2(newRange[1], range[0]) > 0) {
          range[0] = min(range[0], newRange[0]);
          range[1] = max(range[1], newRange[1]);
          break;
        }
      }
      if (i === l)
        ranges2.push(newRange);
      return ranges2;
    }
    var sortDirection = ascending;
    function rangeSorter(a, b) {
      return sortDirection(a[0], b[0]);
    }
    var set;
    try {
      set = ranges.reduce(addRange2, []);
      set.sort(rangeSorter);
    } catch (ex) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var rangePos = 0;
    var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
      return ascending(key, set[rangePos][1]) > 0;
    } : function(key) {
      return ascending(key, set[rangePos][1]) >= 0;
    };
    var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
      return descending(key, set[rangePos][0]) > 0;
    } : function(key) {
      return descending(key, set[rangePos][0]) >= 0;
    };
    function keyWithinCurrentRange(key) {
      return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
    }
    var checkKey = keyIsBeyondCurrentEntry;
    var c = new this.Collection(this, function() {
      return createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
    });
    c._ondirectionchange = function(direction) {
      if (direction === "next") {
        checkKey = keyIsBeyondCurrentEntry;
        sortDirection = ascending;
      } else {
        checkKey = keyIsBeforeCurrentEntry;
        sortDirection = descending;
      }
      set.sort(rangeSorter);
    };
    c._addAlgorithm(function(cursor, advance, resolve) {
      var key = cursor.key;
      while (checkKey(key)) {
        ++rangePos;
        if (rangePos === set.length) {
          advance(resolve);
          return false;
        }
      }
      if (keyWithinCurrentRange(key)) {
        return true;
      } else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) {
        return false;
      } else {
        advance(function() {
          if (sortDirection === ascending)
            cursor.continue(set[rangePos][0]);
          else
            cursor.continue(set[rangePos][1]);
        });
        return false;
      }
    });
    return c;
  };
  WhereClause2.prototype.startsWithAnyOf = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (!set.every(function(s) {
      return typeof s === "string";
    })) {
      return fail(this, "startsWithAnyOf() only works with strings");
    }
    if (set.length === 0)
      return emptyCollection(this);
    return this.inAnyRange(set.map(function(str) {
      return [str, str + maxString];
    }));
  };
  return WhereClause2;
}();
function createWhereClauseConstructor(db) {
  return makeClassConstructor(WhereClause.prototype, function WhereClause2(table, index2, orCollection) {
    this.db = db;
    this._ctx = {
      table,
      index: index2 === ":id" ? null : index2,
      or: orCollection
    };
    var indexedDB2 = db._deps.indexedDB;
    if (!indexedDB2)
      throw new exceptions.MissingAPI();
    this._cmp = this._ascending = indexedDB2.cmp.bind(indexedDB2);
    this._descending = function(a, b) {
      return indexedDB2.cmp(b, a);
    };
    this._max = function(a, b) {
      return indexedDB2.cmp(a, b) > 0 ? a : b;
    };
    this._min = function(a, b) {
      return indexedDB2.cmp(a, b) < 0 ? a : b;
    };
    this._IDBKeyRange = db._deps.IDBKeyRange;
  });
}
function eventRejectHandler(reject) {
  return wrap(function(event) {
    preventDefault(event);
    reject(event.target.error);
    return false;
  });
}
function preventDefault(event) {
  if (event.stopPropagation)
    event.stopPropagation();
  if (event.preventDefault)
    event.preventDefault();
}
var DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);
var Transaction = function() {
  function Transaction2() {
  }
  Transaction2.prototype._lock = function() {
    assert(!PSD.global);
    ++this._reculock;
    if (this._reculock === 1 && !PSD.global)
      PSD.lockOwnerFor = this;
    return this;
  };
  Transaction2.prototype._unlock = function() {
    assert(!PSD.global);
    if (--this._reculock === 0) {
      if (!PSD.global)
        PSD.lockOwnerFor = null;
      while (this._blockedFuncs.length > 0 && !this._locked()) {
        var fnAndPSD = this._blockedFuncs.shift();
        try {
          usePSD(fnAndPSD[1], fnAndPSD[0]);
        } catch (e) {
        }
      }
    }
    return this;
  };
  Transaction2.prototype._locked = function() {
    return this._reculock && PSD.lockOwnerFor !== this;
  };
  Transaction2.prototype.create = function(idbtrans) {
    var _this = this;
    if (!this.mode)
      return this;
    var idbdb = this.db.idbdb;
    var dbOpenError = this.db._state.dbOpenError;
    assert(!this.idbtrans);
    if (!idbtrans && !idbdb) {
      switch (dbOpenError && dbOpenError.name) {
        case "DatabaseClosedError":
          throw new exceptions.DatabaseClosed(dbOpenError);
        case "MissingAPIError":
          throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
        default:
          throw new exceptions.OpenFailed(dbOpenError);
      }
    }
    if (!this.active)
      throw new exceptions.TransactionInactive();
    assert(this._completion._state === null);
    idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }) : idbdb.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }));
    idbtrans.onerror = wrap(function(ev) {
      preventDefault(ev);
      _this._reject(idbtrans.error);
    });
    idbtrans.onabort = wrap(function(ev) {
      preventDefault(ev);
      _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
      _this.active = false;
      _this.on("abort").fire(ev);
    });
    idbtrans.oncomplete = wrap(function() {
      _this.active = false;
      _this._resolve();
      if ("mutatedParts" in idbtrans) {
        globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
      }
    });
    return this;
  };
  Transaction2.prototype._promise = function(mode, fn, bWriteLock) {
    var _this = this;
    if (mode === "readwrite" && this.mode !== "readwrite")
      return rejection(new exceptions.ReadOnly("Transaction is readonly"));
    if (!this.active)
      return rejection(new exceptions.TransactionInactive());
    if (this._locked()) {
      return new DexiePromise(function(resolve, reject) {
        _this._blockedFuncs.push([function() {
          _this._promise(mode, fn, bWriteLock).then(resolve, reject);
        }, PSD]);
      });
    } else if (bWriteLock) {
      return newScope(function() {
        var p2 = new DexiePromise(function(resolve, reject) {
          _this._lock();
          var rv = fn(resolve, reject, _this);
          if (rv && rv.then)
            rv.then(resolve, reject);
        });
        p2.finally(function() {
          return _this._unlock();
        });
        p2._lib = true;
        return p2;
      });
    } else {
      var p = new DexiePromise(function(resolve, reject) {
        var rv = fn(resolve, reject, _this);
        if (rv && rv.then)
          rv.then(resolve, reject);
      });
      p._lib = true;
      return p;
    }
  };
  Transaction2.prototype._root = function() {
    return this.parent ? this.parent._root() : this;
  };
  Transaction2.prototype.waitFor = function(promiseLike) {
    var root = this._root();
    var promise = DexiePromise.resolve(promiseLike);
    if (root._waitingFor) {
      root._waitingFor = root._waitingFor.then(function() {
        return promise;
      });
    } else {
      root._waitingFor = promise;
      root._waitingQueue = [];
      var store2 = root.idbtrans.objectStore(root.storeNames[0]);
      (function spin() {
        ++root._spinCount;
        while (root._waitingQueue.length)
          root._waitingQueue.shift()();
        if (root._waitingFor)
          store2.get(-Infinity).onsuccess = spin;
      })();
    }
    var currentWaitPromise = root._waitingFor;
    return new DexiePromise(function(resolve, reject) {
      promise.then(function(res) {
        return root._waitingQueue.push(wrap(resolve.bind(null, res)));
      }, function(err) {
        return root._waitingQueue.push(wrap(reject.bind(null, err)));
      }).finally(function() {
        if (root._waitingFor === currentWaitPromise) {
          root._waitingFor = null;
        }
      });
    });
  };
  Transaction2.prototype.abort = function() {
    if (this.active) {
      this.active = false;
      if (this.idbtrans)
        this.idbtrans.abort();
      this._reject(new exceptions.Abort());
    }
  };
  Transaction2.prototype.table = function(tableName) {
    var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
    if (hasOwn(memoizedTables, tableName))
      return memoizedTables[tableName];
    var tableSchema = this.schema[tableName];
    if (!tableSchema) {
      throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
    }
    var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
    transactionBoundTable.core = this.db.core.table(tableName);
    memoizedTables[tableName] = transactionBoundTable;
    return transactionBoundTable;
  };
  return Transaction2;
}();
function createTransactionConstructor(db) {
  return makeClassConstructor(Transaction.prototype, function Transaction2(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
    var _this = this;
    this.db = db;
    this.mode = mode;
    this.storeNames = storeNames;
    this.schema = dbschema;
    this.chromeTransactionDurability = chromeTransactionDurability;
    this.idbtrans = null;
    this.on = Events(this, "complete", "error", "abort");
    this.parent = parent || null;
    this.active = true;
    this._reculock = 0;
    this._blockedFuncs = [];
    this._resolve = null;
    this._reject = null;
    this._waitingFor = null;
    this._waitingQueue = null;
    this._spinCount = 0;
    this._completion = new DexiePromise(function(resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
    this._completion.then(function() {
      _this.active = false;
      _this.on.complete.fire();
    }, function(e) {
      var wasActive = _this.active;
      _this.active = false;
      _this.on.error.fire(e);
      _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
      return rejection(e);
    });
  });
}
function createIndexSpec(name2, keyPath, unique, multi, auto, compound, isPrimKey) {
  return {
    name: name2,
    keyPath,
    unique,
    multi,
    auto,
    compound,
    src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + nameFromKeyPath(keyPath)
  };
}
function nameFromKeyPath(keyPath) {
  return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function createTableSchema(name2, primKey, indexes) {
  return {
    name: name2,
    primKey,
    indexes,
    mappedClass: null,
    idxByName: arrayToObject(indexes, function(index2) {
      return [index2.name, index2];
    })
  };
}
function safariMultiStoreFix(storeNames) {
  return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var getMaxKey = function(IdbKeyRange) {
  try {
    IdbKeyRange.only([[]]);
    getMaxKey = function() {
      return [[]];
    };
    return [[]];
  } catch (e) {
    getMaxKey = function() {
      return maxString;
    };
    return maxString;
  }
};
function getKeyExtractor(keyPath) {
  if (keyPath == null) {
    return function() {
      return void 0;
    };
  } else if (typeof keyPath === "string") {
    return getSinglePathKeyExtractor(keyPath);
  } else {
    return function(obj) {
      return getByKeyPath(obj, keyPath);
    };
  }
}
function getSinglePathKeyExtractor(keyPath) {
  var split = keyPath.split(".");
  if (split.length === 1) {
    return function(obj) {
      return obj[keyPath];
    };
  } else {
    return function(obj) {
      return getByKeyPath(obj, keyPath);
    };
  }
}
function arrayify(arrayLike) {
  return [].slice.call(arrayLike);
}
var _id_counter = 0;
function getKeyPathAlias(keyPath) {
  return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function createDBCore(db, IdbKeyRange, tmpTrans) {
  function extractSchema(db2, trans) {
    var tables2 = arrayify(db2.objectStoreNames);
    return {
      schema: {
        name: db2.name,
        tables: tables2.map(function(table) {
          return trans.objectStore(table);
        }).map(function(store2) {
          var keyPath = store2.keyPath, autoIncrement = store2.autoIncrement;
          var compound = isArray$1(keyPath);
          var outbound = keyPath == null;
          var indexByKeyPath = {};
          var result = {
            name: store2.name,
            primaryKey: {
              name: null,
              isPrimaryKey: true,
              outbound,
              compound,
              keyPath,
              autoIncrement,
              unique: true,
              extractKey: getKeyExtractor(keyPath)
            },
            indexes: arrayify(store2.indexNames).map(function(indexName) {
              return store2.index(indexName);
            }).map(function(index2) {
              var name2 = index2.name, unique = index2.unique, multiEntry = index2.multiEntry, keyPath2 = index2.keyPath;
              var compound2 = isArray$1(keyPath2);
              var result2 = {
                name: name2,
                compound: compound2,
                keyPath: keyPath2,
                unique,
                multiEntry,
                extractKey: getKeyExtractor(keyPath2)
              };
              indexByKeyPath[getKeyPathAlias(keyPath2)] = result2;
              return result2;
            }),
            getIndexByKeyPath: function(keyPath2) {
              return indexByKeyPath[getKeyPathAlias(keyPath2)];
            }
          };
          indexByKeyPath[":id"] = result.primaryKey;
          if (keyPath != null) {
            indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
          }
          return result;
        })
      },
      hasGetAll: tables2.length > 0 && "getAll" in trans.objectStore(tables2[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
    };
  }
  function makeIDBKeyRange(range) {
    if (range.type === 3)
      return null;
    if (range.type === 4)
      throw new Error("Cannot convert never type to IDBKeyRange");
    var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
    var idbRange = lower === void 0 ? upper === void 0 ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === void 0 ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
    return idbRange;
  }
  function createDbCoreTable(tableSchema) {
    var tableName = tableSchema.name;
    function mutate(_a3) {
      var trans = _a3.trans, type2 = _a3.type, keys2 = _a3.keys, values = _a3.values, range = _a3.range;
      return new Promise(function(resolve, reject) {
        resolve = wrap(resolve);
        var store2 = trans.objectStore(tableName);
        var outbound = store2.keyPath == null;
        var isAddOrPut = type2 === "put" || type2 === "add";
        if (!isAddOrPut && type2 !== "delete" && type2 !== "deleteRange")
          throw new Error("Invalid operation type: " + type2);
        var length = (keys2 || values || { length: 1 }).length;
        if (keys2 && values && keys2.length !== values.length) {
          throw new Error("Given keys array must have same length as given values array.");
        }
        if (length === 0)
          return resolve({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });
        var req;
        var reqs = [];
        var failures = [];
        var numFailures = 0;
        var errorHandler = function(event) {
          ++numFailures;
          preventDefault(event);
        };
        if (type2 === "deleteRange") {
          if (range.type === 4)
            return resolve({ numFailures, failures, results: [], lastResult: void 0 });
          if (range.type === 3)
            reqs.push(req = store2.clear());
          else
            reqs.push(req = store2.delete(makeIDBKeyRange(range)));
        } else {
          var _a4 = isAddOrPut ? outbound ? [values, keys2] : [values, null] : [keys2, null], args1 = _a4[0], args2 = _a4[1];
          if (isAddOrPut) {
            for (var i = 0; i < length; ++i) {
              reqs.push(req = args2 && args2[i] !== void 0 ? store2[type2](args1[i], args2[i]) : store2[type2](args1[i]));
              req.onerror = errorHandler;
            }
          } else {
            for (var i = 0; i < length; ++i) {
              reqs.push(req = store2[type2](args1[i]));
              req.onerror = errorHandler;
            }
          }
        }
        var done = function(event) {
          var lastResult = event.target.result;
          reqs.forEach(function(req2, i2) {
            return req2.error != null && (failures[i2] = req2.error);
          });
          resolve({
            numFailures,
            failures,
            results: type2 === "delete" ? keys2 : reqs.map(function(req2) {
              return req2.result;
            }),
            lastResult
          });
        };
        req.onerror = function(event) {
          errorHandler(event);
          done(event);
        };
        req.onsuccess = done;
      });
    }
    function openCursor2(_a3) {
      var trans = _a3.trans, values = _a3.values, query2 = _a3.query, reverse = _a3.reverse, unique = _a3.unique;
      return new Promise(function(resolve, reject) {
        resolve = wrap(resolve);
        var index2 = query2.index, range = query2.range;
        var store2 = trans.objectStore(tableName);
        var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
        var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
        var req = values || !("openKeyCursor" in source2) ? source2.openCursor(makeIDBKeyRange(range), direction) : source2.openKeyCursor(makeIDBKeyRange(range), direction);
        req.onerror = eventRejectHandler(reject);
        req.onsuccess = wrap(function(ev) {
          var cursor = req.result;
          if (!cursor) {
            resolve(null);
            return;
          }
          cursor.___id = ++_id_counter;
          cursor.done = false;
          var _cursorContinue = cursor.continue.bind(cursor);
          var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
          if (_cursorContinuePrimaryKey)
            _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
          var _cursorAdvance = cursor.advance.bind(cursor);
          var doThrowCursorIsNotStarted = function() {
            throw new Error("Cursor not started");
          };
          var doThrowCursorIsStopped = function() {
            throw new Error("Cursor not stopped");
          };
          cursor.trans = trans;
          cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
          cursor.fail = wrap(reject);
          cursor.next = function() {
            var _this = this;
            var gotOne = 1;
            return this.start(function() {
              return gotOne-- ? _this.continue() : _this.stop();
            }).then(function() {
              return _this;
            });
          };
          cursor.start = function(callback) {
            var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
              resolveIteration = wrap(resolveIteration);
              req.onerror = eventRejectHandler(rejectIteration);
              cursor.fail = rejectIteration;
              cursor.stop = function(value) {
                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                resolveIteration(value);
              };
            });
            var guardedCallback = function() {
              if (req.result) {
                try {
                  callback();
                } catch (err) {
                  cursor.fail(err);
                }
              } else {
                cursor.done = true;
                cursor.start = function() {
                  throw new Error("Cursor behind last entry");
                };
                cursor.stop();
              }
            };
            req.onsuccess = wrap(function(ev2) {
              req.onsuccess = guardedCallback;
              guardedCallback();
            });
            cursor.continue = _cursorContinue;
            cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
            cursor.advance = _cursorAdvance;
            guardedCallback();
            return iterationPromise;
          };
          resolve(cursor);
        }, reject);
      });
    }
    function query(hasGetAll2) {
      return function(request3) {
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var trans = request3.trans, values = request3.values, limit = request3.limit, query2 = request3.query;
          var nonInfinitLimit = limit === Infinity ? void 0 : limit;
          var index2 = query2.index, range = query2.range;
          var store2 = trans.objectStore(tableName);
          var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
          var idbKeyRange = makeIDBKeyRange(range);
          if (limit === 0)
            return resolve({ result: [] });
          if (hasGetAll2) {
            var req = values ? source2.getAll(idbKeyRange, nonInfinitLimit) : source2.getAllKeys(idbKeyRange, nonInfinitLimit);
            req.onsuccess = function(event) {
              return resolve({ result: event.target.result });
            };
            req.onerror = eventRejectHandler(reject);
          } else {
            var count_1 = 0;
            var req_1 = values || !("openKeyCursor" in source2) ? source2.openCursor(idbKeyRange) : source2.openKeyCursor(idbKeyRange);
            var result_1 = [];
            req_1.onsuccess = function(event) {
              var cursor = req_1.result;
              if (!cursor)
                return resolve({ result: result_1 });
              result_1.push(values ? cursor.value : cursor.primaryKey);
              if (++count_1 === limit)
                return resolve({ result: result_1 });
              cursor.continue();
            };
            req_1.onerror = eventRejectHandler(reject);
          }
        });
      };
    }
    return {
      name: tableName,
      schema: tableSchema,
      mutate,
      getMany: function(_a3) {
        var trans = _a3.trans, keys2 = _a3.keys;
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var store2 = trans.objectStore(tableName);
          var length = keys2.length;
          var result = new Array(length);
          var keyCount = 0;
          var callbackCount = 0;
          var req;
          var successHandler = function(event) {
            var req2 = event.target;
            if ((result[req2._pos] = req2.result) != null)
              ;
            if (++callbackCount === keyCount)
              resolve(result);
          };
          var errorHandler = eventRejectHandler(reject);
          for (var i = 0; i < length; ++i) {
            var key = keys2[i];
            if (key != null) {
              req = store2.get(keys2[i]);
              req._pos = i;
              req.onsuccess = successHandler;
              req.onerror = errorHandler;
              ++keyCount;
            }
          }
          if (keyCount === 0)
            resolve(result);
        });
      },
      get: function(_a3) {
        var trans = _a3.trans, key = _a3.key;
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var store2 = trans.objectStore(tableName);
          var req = store2.get(key);
          req.onsuccess = function(event) {
            return resolve(event.target.result);
          };
          req.onerror = eventRejectHandler(reject);
        });
      },
      query: query(hasGetAll),
      openCursor: openCursor2,
      count: function(_a3) {
        var query2 = _a3.query, trans = _a3.trans;
        var index2 = query2.index, range = query2.range;
        return new Promise(function(resolve, reject) {
          var store2 = trans.objectStore(tableName);
          var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
          var idbKeyRange = makeIDBKeyRange(range);
          var req = idbKeyRange ? source2.count(idbKeyRange) : source2.count();
          req.onsuccess = wrap(function(ev) {
            return resolve(ev.target.result);
          });
          req.onerror = eventRejectHandler(reject);
        });
      }
    };
  }
  var _a2 = extractSchema(db, tmpTrans), schema = _a2.schema, hasGetAll = _a2.hasGetAll;
  var tables = schema.tables.map(function(tableSchema) {
    return createDbCoreTable(tableSchema);
  });
  var tableMap = {};
  tables.forEach(function(table) {
    return tableMap[table.name] = table;
  });
  return {
    stack: "dbcore",
    transaction: db.transaction.bind(db),
    table: function(name2) {
      var result = tableMap[name2];
      if (!result)
        throw new Error("Table '" + name2 + "' not found");
      return tableMap[name2];
    },
    MIN_KEY: -Infinity,
    MAX_KEY: getMaxKey(IdbKeyRange),
    schema
  };
}
function createMiddlewareStack(stackImpl, middlewares) {
  return middlewares.reduce(function(down, _a2) {
    var create2 = _a2.create;
    return __assign$1(__assign$1({}, down), create2(down));
  }, stackImpl);
}
function createMiddlewareStacks(middlewares, idbdb, _a2, tmpTrans) {
  var IDBKeyRange = _a2.IDBKeyRange;
  _a2.indexedDB;
  var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
  return {
    dbcore
  };
}
function generateMiddlewareStacks(_a2, tmpTrans) {
  var db = _a2._novip;
  var idbdb = tmpTrans.db;
  var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
  db.core = stacks.dbcore;
  db.tables.forEach(function(table) {
    var tableName = table.name;
    if (db.core.schema.tables.some(function(tbl) {
      return tbl.name === tableName;
    })) {
      table.core = db.core.table(tableName);
      if (db[tableName] instanceof db.Table) {
        db[tableName].core = table.core;
      }
    }
  });
}
function setApiOnPlace(_a2, objs, tableNames, dbschema) {
  var db = _a2._novip;
  tableNames.forEach(function(tableName) {
    var schema = dbschema[tableName];
    objs.forEach(function(obj) {
      var propDesc = getPropertyDescriptor(obj, tableName);
      if (!propDesc || "value" in propDesc && propDesc.value === void 0) {
        if (obj === db.Transaction.prototype || obj instanceof db.Transaction) {
          setProp(obj, tableName, {
            get: function() {
              return this.table(tableName);
            },
            set: function(value) {
              defineProperty(this, tableName, { value, writable: true, configurable: true, enumerable: true });
            }
          });
        } else {
          obj[tableName] = new db.Table(tableName, schema);
        }
      }
    });
  });
}
function removeTablesApi(_a2, objs) {
  var db = _a2._novip;
  objs.forEach(function(obj) {
    for (var key in obj) {
      if (obj[key] instanceof db.Table)
        delete obj[key];
    }
  });
}
function lowerVersionFirst(a, b) {
  return a._cfg.version - b._cfg.version;
}
function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
  var globalSchema = db._dbSchema;
  var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
  trans.create(idbUpgradeTrans);
  trans._completion.catch(reject);
  var rejectTransaction = trans._reject.bind(trans);
  var transless = PSD.transless || PSD;
  newScope(function() {
    PSD.trans = trans;
    PSD.transless = transless;
    if (oldVersion === 0) {
      keys(globalSchema).forEach(function(tableName) {
        createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
      });
      generateMiddlewareStacks(db, idbUpgradeTrans);
      DexiePromise.follow(function() {
        return db.on.populate.fire(trans);
      }).catch(rejectTransaction);
    } else
      updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
  });
}
function updateTablesAndIndexes(_a2, oldVersion, trans, idbUpgradeTrans) {
  var db = _a2._novip;
  var queue = [];
  var versions = db._versions;
  var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
  var anyContentUpgraderHasRun = false;
  var versToRun = versions.filter(function(v) {
    return v._cfg.version >= oldVersion;
  });
  versToRun.forEach(function(version2) {
    queue.push(function() {
      var oldSchema = globalSchema;
      var newSchema = version2._cfg.dbschema;
      adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
      adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
      globalSchema = db._dbSchema = newSchema;
      var diff = getSchemaDiff(oldSchema, newSchema);
      diff.add.forEach(function(tuple) {
        createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
      });
      diff.change.forEach(function(change) {
        if (change.recreate) {
          throw new exceptions.Upgrade("Not yet support for changing primary key");
        } else {
          var store_1 = idbUpgradeTrans.objectStore(change.name);
          change.add.forEach(function(idx) {
            return addIndex(store_1, idx);
          });
          change.change.forEach(function(idx) {
            store_1.deleteIndex(idx.name);
            addIndex(store_1, idx);
          });
          change.del.forEach(function(idxName) {
            return store_1.deleteIndex(idxName);
          });
        }
      });
      var contentUpgrade = version2._cfg.contentUpgrade;
      if (contentUpgrade && version2._cfg.version > oldVersion) {
        generateMiddlewareStacks(db, idbUpgradeTrans);
        trans._memoizedTables = {};
        anyContentUpgraderHasRun = true;
        var upgradeSchema_1 = shallowClone(newSchema);
        diff.del.forEach(function(table) {
          upgradeSchema_1[table] = oldSchema[table];
        });
        removeTablesApi(db, [db.Transaction.prototype]);
        setApiOnPlace(db, [db.Transaction.prototype], keys(upgradeSchema_1), upgradeSchema_1);
        trans.schema = upgradeSchema_1;
        var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
        if (contentUpgradeIsAsync_1) {
          incrementExpectedAwaits();
        }
        var returnValue_1;
        var promiseFollowed = DexiePromise.follow(function() {
          returnValue_1 = contentUpgrade(trans);
          if (returnValue_1) {
            if (contentUpgradeIsAsync_1) {
              var decrementor = decrementExpectedAwaits.bind(null, null);
              returnValue_1.then(decrementor, decrementor);
            }
          }
        });
        return returnValue_1 && typeof returnValue_1.then === "function" ? DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
          return returnValue_1;
        });
      }
    });
    queue.push(function(idbtrans) {
      if (!anyContentUpgraderHasRun || !hasIEDeleteObjectStoreBug) {
        var newSchema = version2._cfg.dbschema;
        deleteRemovedTables(newSchema, idbtrans);
      }
      removeTablesApi(db, [db.Transaction.prototype]);
      setApiOnPlace(db, [db.Transaction.prototype], db._storeNames, db._dbSchema);
      trans.schema = db._dbSchema;
    });
  });
  function runQueue() {
    return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : DexiePromise.resolve();
  }
  return runQueue().then(function() {
    createMissingTables(globalSchema, idbUpgradeTrans);
  });
}
function getSchemaDiff(oldSchema, newSchema) {
  var diff = {
    del: [],
    add: [],
    change: []
  };
  var table;
  for (table in oldSchema) {
    if (!newSchema[table])
      diff.del.push(table);
  }
  for (table in newSchema) {
    var oldDef = oldSchema[table], newDef = newSchema[table];
    if (!oldDef) {
      diff.add.push([table, newDef]);
    } else {
      var change = {
        name: table,
        def: newDef,
        recreate: false,
        del: [],
        add: [],
        change: []
      };
      if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !isIEOrEdge) {
        change.recreate = true;
        diff.change.push(change);
      } else {
        var oldIndexes = oldDef.idxByName;
        var newIndexes = newDef.idxByName;
        var idxName = void 0;
        for (idxName in oldIndexes) {
          if (!newIndexes[idxName])
            change.del.push(idxName);
        }
        for (idxName in newIndexes) {
          var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
          if (!oldIdx)
            change.add.push(newIdx);
          else if (oldIdx.src !== newIdx.src)
            change.change.push(newIdx);
        }
        if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) {
          diff.change.push(change);
        }
      }
    }
  }
  return diff;
}
function createTable(idbtrans, tableName, primKey, indexes) {
  var store2 = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? { keyPath: primKey.keyPath, autoIncrement: primKey.auto } : { autoIncrement: primKey.auto });
  indexes.forEach(function(idx) {
    return addIndex(store2, idx);
  });
  return store2;
}
function createMissingTables(newSchema, idbtrans) {
  keys(newSchema).forEach(function(tableName) {
    if (!idbtrans.db.objectStoreNames.contains(tableName)) {
      createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    }
  });
}
function deleteRemovedTables(newSchema, idbtrans) {
  [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
    return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
  });
}
function addIndex(store2, idx) {
  store2.createIndex(idx.name, idx.keyPath, { unique: idx.unique, multiEntry: idx.multi });
}
function buildGlobalSchema(db, idbdb, tmpTrans) {
  var globalSchema = {};
  var dbStoreNames = slice(idbdb.objectStoreNames, 0);
  dbStoreNames.forEach(function(storeName) {
    var store2 = tmpTrans.objectStore(storeName);
    var keyPath = store2.keyPath;
    var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", false, false, !!store2.autoIncrement, keyPath && typeof keyPath !== "string", true);
    var indexes = [];
    for (var j = 0; j < store2.indexNames.length; ++j) {
      var idbindex = store2.index(store2.indexNames[j]);
      keyPath = idbindex.keyPath;
      var index2 = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
      indexes.push(index2);
    }
    globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
  });
  return globalSchema;
}
function readGlobalSchema(_a2, idbdb, tmpTrans) {
  var db = _a2._novip;
  db.verno = idbdb.version / 10;
  var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
  db._storeNames = slice(idbdb.objectStoreNames, 0);
  setApiOnPlace(db, [db._allTables], keys(globalSchema), globalSchema);
}
function verifyInstalledSchema(db, tmpTrans) {
  var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
  var diff = getSchemaDiff(installedSchema, db._dbSchema);
  return !(diff.add.length || diff.change.some(function(ch) {
    return ch.add.length || ch.change.length;
  }));
}
function adjustToExistingIndexNames(_a2, schema, idbtrans) {
  var db = _a2._novip;
  var storeNames = idbtrans.db.objectStoreNames;
  for (var i = 0; i < storeNames.length; ++i) {
    var storeName = storeNames[i];
    var store2 = idbtrans.objectStore(storeName);
    db._hasGetAll = "getAll" in store2;
    for (var j = 0; j < store2.indexNames.length; ++j) {
      var indexName = store2.indexNames[j];
      var keyPath = store2.index(indexName).keyPath;
      var dexieName = typeof keyPath === "string" ? keyPath : "[" + slice(keyPath).join("+") + "]";
      if (schema[storeName]) {
        var indexSpec = schema[storeName].idxByName[dexieName];
        if (indexSpec) {
          indexSpec.name = indexName;
          delete schema[storeName].idxByName[dexieName];
          schema[storeName].idxByName[indexName] = indexSpec;
        }
      }
    }
  }
  if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) {
    db._hasGetAll = false;
  }
}
function parseIndexSyntax(primKeyAndIndexes) {
  return primKeyAndIndexes.split(",").map(function(index2, indexNum) {
    index2 = index2.trim();
    var name2 = index2.replace(/([&*]|\+\+)/g, "");
    var keyPath = /^\[/.test(name2) ? name2.match(/^\[(.*)\]$/)[1].split("+") : name2;
    return createIndexSpec(name2, keyPath || null, /\&/.test(index2), /\*/.test(index2), /\+\+/.test(index2), isArray$1(keyPath), indexNum === 0);
  });
}
var Version = function() {
  function Version2() {
  }
  Version2.prototype._parseStoresSpec = function(stores, outSchema) {
    keys(stores).forEach(function(tableName) {
      if (stores[tableName] !== null) {
        var indexes = parseIndexSyntax(stores[tableName]);
        var primKey = indexes.shift();
        if (primKey.multi)
          throw new exceptions.Schema("Primary key cannot be multi-valued");
        indexes.forEach(function(idx) {
          if (idx.auto)
            throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
          if (!idx.keyPath)
            throw new exceptions.Schema("Index must have a name and cannot be an empty string");
        });
        outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
      }
    });
  };
  Version2.prototype.stores = function(stores) {
    var db = this.db;
    this._cfg.storesSource = this._cfg.storesSource ? extend$1(this._cfg.storesSource, stores) : stores;
    var versions = db._versions;
    var storesSpec = {};
    var dbschema = {};
    versions.forEach(function(version2) {
      extend$1(storesSpec, version2._cfg.storesSource);
      dbschema = version2._cfg.dbschema = {};
      version2._parseStoresSpec(storesSpec, dbschema);
    });
    db._dbSchema = dbschema;
    removeTablesApi(db, [db._allTables, db, db.Transaction.prototype]);
    setApiOnPlace(db, [db._allTables, db, db.Transaction.prototype, this._cfg.tables], keys(dbschema), dbschema);
    db._storeNames = keys(dbschema);
    return this;
  };
  Version2.prototype.upgrade = function(upgradeFunction) {
    this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
    return this;
  };
  return Version2;
}();
function createVersionConstructor(db) {
  return makeClassConstructor(Version.prototype, function Version2(versionNumber) {
    this.db = db;
    this._cfg = {
      version: versionNumber,
      storesSource: null,
      dbschema: {},
      tables: {},
      contentUpgrade: null
    };
  });
}
function getDbNamesTable(indexedDB2, IDBKeyRange) {
  var dbNamesDB = indexedDB2["_dbNamesDB"];
  if (!dbNamesDB) {
    dbNamesDB = indexedDB2["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
      addons: [],
      indexedDB: indexedDB2,
      IDBKeyRange
    });
    dbNamesDB.version(1).stores({ dbnames: "name" });
  }
  return dbNamesDB.table("dbnames");
}
function hasDatabasesNative(indexedDB2) {
  return indexedDB2 && typeof indexedDB2.databases === "function";
}
function getDatabaseNames(_a2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  return hasDatabasesNative(indexedDB2) ? Promise.resolve(indexedDB2.databases()).then(function(infos) {
    return infos.map(function(info2) {
      return info2.name;
    }).filter(function(name2) {
      return name2 !== DBNAMES_DB;
    });
  }) : getDbNamesTable(indexedDB2, IDBKeyRange).toCollection().primaryKeys();
}
function _onDatabaseCreated(_a2, name2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  !hasDatabasesNative(indexedDB2) && name2 !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange).put({ name: name2 }).catch(nop);
}
function _onDatabaseDeleted(_a2, name2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  !hasDatabasesNative(indexedDB2) && name2 !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange).delete(name2).catch(nop);
}
function vip(fn) {
  return newScope(function() {
    PSD.letThrough = true;
    return fn();
  });
}
function idbReady() {
  var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
  if (!isSafari || !indexedDB.databases)
    return Promise.resolve();
  var intervalId;
  return new Promise(function(resolve) {
    var tryIdb = function() {
      return indexedDB.databases().finally(resolve);
    };
    intervalId = setInterval(tryIdb, 100);
    tryIdb();
  }).finally(function() {
    return clearInterval(intervalId);
  });
}
function dexieOpen(db) {
  var state = db._state;
  var indexedDB2 = db._deps.indexedDB;
  if (state.isBeingOpened || db.idbdb)
    return state.dbReadyPromise.then(function() {
      return state.dbOpenError ? rejection(state.dbOpenError) : db;
    });
  debug && (state.openCanceller._stackHolder = getErrorWithStack());
  state.isBeingOpened = true;
  state.dbOpenError = null;
  state.openComplete = false;
  var openCanceller = state.openCanceller;
  function throwIfCancelled() {
    if (state.openCanceller !== openCanceller)
      throw new exceptions.DatabaseClosed("db.open() was cancelled");
  }
  var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
  return DexiePromise.race([openCanceller, (typeof navigator === "undefined" ? DexiePromise.resolve() : idbReady()).then(function() {
    return new DexiePromise(function(resolve, reject) {
      throwIfCancelled();
      if (!indexedDB2)
        throw new exceptions.MissingAPI();
      var dbName = db.name;
      var req = state.autoSchema ? indexedDB2.open(dbName) : indexedDB2.open(dbName, Math.round(db.verno * 10));
      if (!req)
        throw new exceptions.MissingAPI();
      req.onerror = eventRejectHandler(reject);
      req.onblocked = wrap(db._fireOnBlocked);
      req.onupgradeneeded = wrap(function(e) {
        upgradeTransaction = req.transaction;
        if (state.autoSchema && !db._options.allowEmptyDB) {
          req.onerror = preventDefault;
          upgradeTransaction.abort();
          req.result.close();
          var delreq = indexedDB2.deleteDatabase(dbName);
          delreq.onsuccess = delreq.onerror = wrap(function() {
            reject(new exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
          });
        } else {
          upgradeTransaction.onerror = eventRejectHandler(reject);
          var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
          wasCreated = oldVer < 1;
          db._novip.idbdb = req.result;
          runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
        }
      }, reject);
      req.onsuccess = wrap(function() {
        upgradeTransaction = null;
        var idbdb = db._novip.idbdb = req.result;
        var objectStoreNames = slice(idbdb.objectStoreNames);
        if (objectStoreNames.length > 0)
          try {
            var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), "readonly");
            if (state.autoSchema)
              readGlobalSchema(db, idbdb, tmpTrans);
            else {
              adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
              if (!verifyInstalledSchema(db, tmpTrans)) {
                console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
              }
            }
            generateMiddlewareStacks(db, tmpTrans);
          } catch (e) {
          }
        connections.push(db);
        idbdb.onversionchange = wrap(function(ev) {
          state.vcFired = true;
          db.on("versionchange").fire(ev);
        });
        idbdb.onclose = wrap(function(ev) {
          db.on("close").fire(ev);
        });
        if (wasCreated)
          _onDatabaseCreated(db._deps, dbName);
        resolve();
      }, reject);
    });
  })]).then(function() {
    throwIfCancelled();
    state.onReadyBeingFired = [];
    return DexiePromise.resolve(vip(function() {
      return db.on.ready.fire(db.vip);
    })).then(function fireRemainders() {
      if (state.onReadyBeingFired.length > 0) {
        var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
        state.onReadyBeingFired = [];
        return DexiePromise.resolve(vip(function() {
          return remainders_1(db.vip);
        })).then(fireRemainders);
      }
    });
  }).finally(function() {
    state.onReadyBeingFired = null;
    state.isBeingOpened = false;
  }).then(function() {
    return db;
  }).catch(function(err) {
    state.dbOpenError = err;
    try {
      upgradeTransaction && upgradeTransaction.abort();
    } catch (_a2) {
    }
    if (openCanceller === state.openCanceller) {
      db._close();
    }
    return rejection(err);
  }).finally(function() {
    state.openComplete = true;
    resolveDbReady();
  });
}
function awaitIterator(iterator) {
  var callNext = function(result) {
    return iterator.next(result);
  }, doThrow = function(error) {
    return iterator.throw(error);
  }, onSuccess = step(callNext), onError = step(doThrow);
  function step(getNext) {
    return function(val) {
      var next = getNext(val), value = next.value;
      return next.done ? value : !value || typeof value.then !== "function" ? isArray$1(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
    };
  }
  return step(callNext)();
}
function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
  var i = arguments.length;
  if (i < 2)
    throw new exceptions.InvalidArgument("Too few arguments");
  var args = new Array(i - 1);
  while (--i)
    args[i - 1] = arguments[i];
  scopeFunc = args.pop();
  var tables = flatten(args);
  return [mode, tables, scopeFunc];
}
function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
  return DexiePromise.resolve().then(function() {
    var transless = PSD.transless || PSD;
    var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
    var zoneProps = {
      trans,
      transless
    };
    if (parentTransaction) {
      trans.idbtrans = parentTransaction.idbtrans;
    } else {
      try {
        trans.create();
        db._state.PR1398_maxLoop = 3;
      } catch (ex) {
        if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
          console.warn("Dexie: Need to reopen db");
          db._close();
          return db.open().then(function() {
            return enterTransactionScope(db, mode, storeNames, null, scopeFunc);
          });
        }
        return rejection(ex);
      }
    }
    var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
    if (scopeFuncIsAsync) {
      incrementExpectedAwaits();
    }
    var returnValue;
    var promiseFollowed = DexiePromise.follow(function() {
      returnValue = scopeFunc.call(trans, trans);
      if (returnValue) {
        if (scopeFuncIsAsync) {
          var decrementor = decrementExpectedAwaits.bind(null, null);
          returnValue.then(decrementor, decrementor);
        } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") {
          returnValue = awaitIterator(returnValue);
        }
      }
    }, zoneProps);
    return (returnValue && typeof returnValue.then === "function" ? DexiePromise.resolve(returnValue).then(function(x) {
      return trans.active ? x : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
    }) : promiseFollowed.then(function() {
      return returnValue;
    })).then(function(x) {
      if (parentTransaction)
        trans._resolve();
      return trans._completion.then(function() {
        return x;
      });
    }).catch(function(e) {
      trans._reject(e);
      return rejection(e);
    });
  });
}
function pad(a, value, count) {
  var result = isArray$1(a) ? a.slice() : [a];
  for (var i = 0; i < count; ++i)
    result.push(value);
  return result;
}
function createVirtualIndexMiddleware(down) {
  return __assign$1(__assign$1({}, down), { table: function(tableName) {
    var table = down.table(tableName);
    var schema = table.schema;
    var indexLookup = {};
    var allVirtualIndexes = [];
    function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
      var keyPathAlias = getKeyPathAlias(keyPath);
      var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
      var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
      var isVirtual = keyTail > 0;
      var virtualIndex = __assign$1(__assign$1({}, lowLevelIndex), { isVirtual, keyTail, keyLength, extractKey: getKeyExtractor(keyPath), unique: !isVirtual && lowLevelIndex.unique });
      indexList.push(virtualIndex);
      if (!virtualIndex.isPrimaryKey) {
        allVirtualIndexes.push(virtualIndex);
      }
      if (keyLength > 1) {
        var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
        addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
      }
      indexList.sort(function(a, b) {
        return a.keyTail - b.keyTail;
      });
      return virtualIndex;
    }
    var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
    indexLookup[":id"] = [primaryKey];
    for (var _i = 0, _a2 = schema.indexes; _i < _a2.length; _i++) {
      var index2 = _a2[_i];
      addVirtualIndexes(index2.keyPath, 0, index2);
    }
    function findBestIndex(keyPath) {
      var result2 = indexLookup[getKeyPathAlias(keyPath)];
      return result2 && result2[0];
    }
    function translateRange(range, keyTail) {
      return {
        type: range.type === 1 ? 2 : range.type,
        lower: pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
        lowerOpen: true,
        upper: pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
        upperOpen: true
      };
    }
    function translateRequest(req) {
      var index3 = req.query.index;
      return index3.isVirtual ? __assign$1(__assign$1({}, req), { query: {
        index: index3,
        range: translateRange(req.query.range, index3.keyTail)
      } }) : req;
    }
    var result = __assign$1(__assign$1({}, table), { schema: __assign$1(__assign$1({}, schema), { primaryKey, indexes: allVirtualIndexes, getIndexByKeyPath: findBestIndex }), count: function(req) {
      return table.count(translateRequest(req));
    }, query: function(req) {
      return table.query(translateRequest(req));
    }, openCursor: function(req) {
      var _a3 = req.query.index, keyTail = _a3.keyTail, isVirtual = _a3.isVirtual, keyLength = _a3.keyLength;
      if (!isVirtual)
        return table.openCursor(req);
      function createVirtualCursor(cursor) {
        function _continue(key) {
          key != null ? cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
        }
        var virtualCursor = Object.create(cursor, {
          continue: { value: _continue },
          continuePrimaryKey: {
            value: function(key, primaryKey2) {
              cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey2);
            }
          },
          primaryKey: {
            get: function() {
              return cursor.primaryKey;
            }
          },
          key: {
            get: function() {
              var key = cursor.key;
              return keyLength === 1 ? key[0] : key.slice(0, keyLength);
            }
          },
          value: {
            get: function() {
              return cursor.value;
            }
          }
        });
        return virtualCursor;
      }
      return table.openCursor(translateRequest(req)).then(function(cursor) {
        return cursor && createVirtualCursor(cursor);
      });
    } });
    return result;
  } });
}
var virtualIndexMiddleware = {
  stack: "dbcore",
  name: "VirtualIndexMiddleware",
  level: 1,
  create: createVirtualIndexMiddleware
};
function getObjectDiff(a, b, rv, prfx) {
  rv = rv || {};
  prfx = prfx || "";
  keys(a).forEach(function(prop) {
    if (!hasOwn(b, prop)) {
      rv[prfx + prop] = void 0;
    } else {
      var ap = a[prop], bp = b[prop];
      if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
        var apTypeName = toStringTag(ap);
        var bpTypeName = toStringTag(bp);
        if (apTypeName !== bpTypeName) {
          rv[prfx + prop] = b[prop];
        } else if (apTypeName === "Object") {
          getObjectDiff(ap, bp, rv, prfx + prop + ".");
        } else if (ap !== bp) {
          rv[prfx + prop] = b[prop];
        }
      } else if (ap !== bp)
        rv[prfx + prop] = b[prop];
    }
  });
  keys(b).forEach(function(prop) {
    if (!hasOwn(a, prop)) {
      rv[prfx + prop] = b[prop];
    }
  });
  return rv;
}
function getEffectiveKeys(primaryKey, req) {
  if (req.type === "delete")
    return req.keys;
  return req.keys || req.values.map(primaryKey.extractKey);
}
var hooksMiddleware = {
  stack: "dbcore",
  name: "HooksMiddleware",
  level: 2,
  create: function(downCore) {
    return __assign$1(__assign$1({}, downCore), { table: function(tableName) {
      var downTable = downCore.table(tableName);
      var primaryKey = downTable.schema.primaryKey;
      var tableMiddleware = __assign$1(__assign$1({}, downTable), { mutate: function(req) {
        var dxTrans = PSD.trans;
        var _a2 = dxTrans.table(tableName).hook, deleting = _a2.deleting, creating = _a2.creating, updating = _a2.updating;
        switch (req.type) {
          case "add":
            if (creating.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "put":
            if (creating.fire === nop && updating.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "delete":
            if (deleting.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "deleteRange":
            if (deleting.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return deleteRange(req);
            }, true);
        }
        return downTable.mutate(req);
        function addPutOrDelete(req2) {
          var dxTrans2 = PSD.trans;
          var keys2 = req2.keys || getEffectiveKeys(primaryKey, req2);
          if (!keys2)
            throw new Error("Keys missing");
          req2 = req2.type === "add" || req2.type === "put" ? __assign$1(__assign$1({}, req2), { keys: keys2 }) : __assign$1({}, req2);
          if (req2.type !== "delete")
            req2.values = __spreadArray([], req2.values, true);
          if (req2.keys)
            req2.keys = __spreadArray([], req2.keys, true);
          return getExistingValues(downTable, req2, keys2).then(function(existingValues) {
            var contexts = keys2.map(function(key, i) {
              var existingValue = existingValues[i];
              var ctx = { onerror: null, onsuccess: null };
              if (req2.type === "delete") {
                deleting.fire.call(ctx, key, existingValue, dxTrans2);
              } else if (req2.type === "add" || existingValue === void 0) {
                var generatedPrimaryKey = creating.fire.call(ctx, key, req2.values[i], dxTrans2);
                if (key == null && generatedPrimaryKey != null) {
                  key = generatedPrimaryKey;
                  req2.keys[i] = key;
                  if (!primaryKey.outbound) {
                    setByKeyPath(req2.values[i], primaryKey.keyPath, key);
                  }
                }
              } else {
                var objectDiff = getObjectDiff(existingValue, req2.values[i]);
                var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans2);
                if (additionalChanges_1) {
                  var requestedValue_1 = req2.values[i];
                  Object.keys(additionalChanges_1).forEach(function(keyPath) {
                    if (hasOwn(requestedValue_1, keyPath)) {
                      requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                    } else {
                      setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                    }
                  });
                }
              }
              return ctx;
            });
            return downTable.mutate(req2).then(function(_a3) {
              var failures = _a3.failures, results = _a3.results, numFailures = _a3.numFailures, lastResult = _a3.lastResult;
              for (var i = 0; i < keys2.length; ++i) {
                var primKey = results ? results[i] : keys2[i];
                var ctx = contexts[i];
                if (primKey == null) {
                  ctx.onerror && ctx.onerror(failures[i]);
                } else {
                  ctx.onsuccess && ctx.onsuccess(req2.type === "put" && existingValues[i] ? req2.values[i] : primKey);
                }
              }
              return { failures, results, numFailures, lastResult };
            }).catch(function(error) {
              contexts.forEach(function(ctx) {
                return ctx.onerror && ctx.onerror(error);
              });
              return Promise.reject(error);
            });
          });
        }
        function deleteRange(req2) {
          return deleteNextChunk(req2.trans, req2.range, 1e4);
        }
        function deleteNextChunk(trans, range, limit) {
          return downTable.query({ trans, values: false, query: { index: primaryKey, range }, limit }).then(function(_a3) {
            var result = _a3.result;
            return addPutOrDelete({ type: "delete", keys: result, trans }).then(function(res) {
              if (res.numFailures > 0)
                return Promise.reject(res.failures[0]);
              if (result.length < limit) {
                return { failures: [], numFailures: 0, lastResult: void 0 };
              } else {
                return deleteNextChunk(trans, __assign$1(__assign$1({}, range), { lower: result[result.length - 1], lowerOpen: true }), limit);
              }
            });
          });
        }
      } });
      return tableMiddleware;
    } });
  }
};
function getExistingValues(table, req, effectiveKeys) {
  return req.type === "add" ? Promise.resolve([]) : table.getMany({ trans: req.trans, keys: effectiveKeys, cache: "immutable" });
}
function getFromTransactionCache(keys2, cache, clone) {
  try {
    if (!cache)
      return null;
    if (cache.keys.length < keys2.length)
      return null;
    var result = [];
    for (var i = 0, j = 0; i < cache.keys.length && j < keys2.length; ++i) {
      if (cmp(cache.keys[i], keys2[j]) !== 0)
        continue;
      result.push(clone ? deepClone(cache.values[i]) : cache.values[i]);
      ++j;
    }
    return result.length === keys2.length ? result : null;
  } catch (_a2) {
    return null;
  }
}
var cacheExistingValuesMiddleware = {
  stack: "dbcore",
  level: -1,
  create: function(core2) {
    return {
      table: function(tableName) {
        var table = core2.table(tableName);
        return __assign$1(__assign$1({}, table), { getMany: function(req) {
          if (!req.cache) {
            return table.getMany(req);
          }
          var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
          if (cachedResult) {
            return DexiePromise.resolve(cachedResult);
          }
          return table.getMany(req).then(function(res) {
            req.trans["_cache"] = {
              keys: req.keys,
              values: req.cache === "clone" ? deepClone(res) : res
            };
            return res;
          });
        }, mutate: function(req) {
          if (req.type !== "add")
            req.trans["_cache"] = null;
          return table.mutate(req);
        } });
      }
    };
  }
};
var _a$2;
function isEmptyRange(node) {
  return !("from" in node);
}
var RangeSet = function(fromOrTree, to) {
  if (this) {
    extend$1(this, arguments.length ? { d: 1, from: fromOrTree, to: arguments.length > 1 ? to : fromOrTree } : { d: 0 });
  } else {
    var rv = new RangeSet();
    if (fromOrTree && "d" in fromOrTree) {
      extend$1(rv, fromOrTree);
    }
    return rv;
  }
};
props(RangeSet.prototype, (_a$2 = {
  add: function(rangeSet) {
    mergeRanges(this, rangeSet);
    return this;
  },
  addKey: function(key) {
    addRange(this, key, key);
    return this;
  },
  addKeys: function(keys2) {
    var _this = this;
    keys2.forEach(function(key) {
      return addRange(_this, key, key);
    });
    return this;
  }
}, _a$2[iteratorSymbol] = function() {
  return getRangeSetIterator(this);
}, _a$2));
function addRange(target, from, to) {
  var diff = cmp(from, to);
  if (isNaN(diff))
    return;
  if (diff > 0)
    throw RangeError();
  if (isEmptyRange(target))
    return extend$1(target, { from, to, d: 1 });
  var left = target.l;
  var right = target.r;
  if (cmp(to, target.from) < 0) {
    left ? addRange(left, from, to) : target.l = { from, to, d: 1, l: null, r: null };
    return rebalance(target);
  }
  if (cmp(from, target.to) > 0) {
    right ? addRange(right, from, to) : target.r = { from, to, d: 1, l: null, r: null };
    return rebalance(target);
  }
  if (cmp(from, target.from) < 0) {
    target.from = from;
    target.l = null;
    target.d = right ? right.d + 1 : 1;
  }
  if (cmp(to, target.to) > 0) {
    target.to = to;
    target.r = null;
    target.d = target.l ? target.l.d + 1 : 1;
  }
  var rightWasCutOff = !target.r;
  if (left && !target.l) {
    mergeRanges(target, left);
  }
  if (right && rightWasCutOff) {
    mergeRanges(target, right);
  }
}
function mergeRanges(target, newSet) {
  function _addRangeSet(target2, _a2) {
    var from = _a2.from, to = _a2.to, l = _a2.l, r = _a2.r;
    addRange(target2, from, to);
    if (l)
      _addRangeSet(target2, l);
    if (r)
      _addRangeSet(target2, r);
  }
  if (!isEmptyRange(newSet))
    _addRangeSet(target, newSet);
}
function rangesOverlap(rangeSet1, rangeSet2) {
  var i1 = getRangeSetIterator(rangeSet2);
  var nextResult1 = i1.next();
  if (nextResult1.done)
    return false;
  var a = nextResult1.value;
  var i2 = getRangeSetIterator(rangeSet1);
  var nextResult2 = i2.next(a.from);
  var b = nextResult2.value;
  while (!nextResult1.done && !nextResult2.done) {
    if (cmp(b.from, a.to) <= 0 && cmp(b.to, a.from) >= 0)
      return true;
    cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
  }
  return false;
}
function getRangeSetIterator(node) {
  var state = isEmptyRange(node) ? null : { s: 0, n: node };
  return {
    next: function(key) {
      var keyProvided = arguments.length > 0;
      while (state) {
        switch (state.s) {
          case 0:
            state.s = 1;
            if (keyProvided) {
              while (state.n.l && cmp(key, state.n.from) < 0)
                state = { up: state, n: state.n.l, s: 1 };
            } else {
              while (state.n.l)
                state = { up: state, n: state.n.l, s: 1 };
            }
          case 1:
            state.s = 2;
            if (!keyProvided || cmp(key, state.n.to) <= 0)
              return { value: state.n, done: false };
          case 2:
            if (state.n.r) {
              state.s = 3;
              state = { up: state, n: state.n.r, s: 0 };
              continue;
            }
          case 3:
            state = state.up;
        }
      }
      return { done: true };
    }
  };
}
function rebalance(target) {
  var _a2, _b;
  var diff = (((_a2 = target.r) === null || _a2 === void 0 ? void 0 : _a2.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
  var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
  if (r) {
    var l = r === "r" ? "l" : "r";
    var rootClone = __assign$1({}, target);
    var oldRootRight = target[r];
    target.from = oldRootRight.from;
    target.to = oldRootRight.to;
    target[r] = oldRootRight[r];
    rootClone[r] = oldRootRight[l];
    target[l] = rootClone;
    rootClone.d = computeDepth(rootClone);
  }
  target.d = computeDepth(target);
}
function computeDepth(_a2) {
  var r = _a2.r, l = _a2.l;
  return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var observabilityMiddleware = {
  stack: "dbcore",
  level: 0,
  create: function(core2) {
    var dbName = core2.schema.name;
    var FULL_RANGE = new RangeSet(core2.MIN_KEY, core2.MAX_KEY);
    return __assign$1(__assign$1({}, core2), { table: function(tableName) {
      var table = core2.table(tableName);
      var schema = table.schema;
      var primaryKey = schema.primaryKey;
      var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
      var tableClone = __assign$1(__assign$1({}, table), { mutate: function(req) {
        var trans = req.trans;
        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
        var getRangeSet = function(indexName) {
          var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
          return mutatedParts[part] || (mutatedParts[part] = new RangeSet());
        };
        var pkRangeSet = getRangeSet("");
        var delsRangeSet = getRangeSet(":dels");
        var type2 = req.type;
        var _a2 = req.type === "deleteRange" ? [req.range] : req.type === "delete" ? [req.keys] : req.values.length < 50 ? [[], req.values] : [], keys2 = _a2[0], newObjs = _a2[1];
        var oldCache = req.trans["_cache"];
        return table.mutate(req).then(function(res) {
          if (isArray$1(keys2)) {
            if (type2 !== "delete")
              keys2 = res.results;
            pkRangeSet.addKeys(keys2);
            var oldObjs = getFromTransactionCache(keys2, oldCache);
            if (!oldObjs && type2 !== "add") {
              delsRangeSet.addKeys(keys2);
            }
            if (oldObjs || newObjs) {
              trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
            }
          } else if (keys2) {
            var range = { from: keys2.lower, to: keys2.upper };
            delsRangeSet.add(range);
            pkRangeSet.add(range);
          } else {
            pkRangeSet.add(FULL_RANGE);
            delsRangeSet.add(FULL_RANGE);
            schema.indexes.forEach(function(idx) {
              return getRangeSet(idx.name).add(FULL_RANGE);
            });
          }
          return res;
        });
      } });
      var getRange = function(_a2) {
        var _b, _c;
        var _d = _a2.query, index2 = _d.index, range = _d.range;
        return [
          index2,
          new RangeSet((_b = range.lower) !== null && _b !== void 0 ? _b : core2.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core2.MAX_KEY)
        ];
      };
      var readSubscribers = {
        get: function(req) {
          return [primaryKey, new RangeSet(req.key)];
        },
        getMany: function(req) {
          return [primaryKey, new RangeSet().addKeys(req.keys)];
        },
        count: getRange,
        query: getRange,
        openCursor: getRange
      };
      keys(readSubscribers).forEach(function(method) {
        tableClone[method] = function(req) {
          var subscr = PSD.subscr;
          if (subscr) {
            var getRangeSet = function(indexName) {
              var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
              return subscr[part] || (subscr[part] = new RangeSet());
            };
            var pkRangeSet_1 = getRangeSet("");
            var delsRangeSet_1 = getRangeSet(":dels");
            var _a2 = readSubscribers[method](req), queriedIndex = _a2[0], queriedRanges = _a2[1];
            getRangeSet(queriedIndex.name || "").add(queriedRanges);
            if (!queriedIndex.isPrimaryKey) {
              if (method === "count") {
                delsRangeSet_1.add(FULL_RANGE);
              } else {
                var keysPromise_1 = method === "query" && outbound && req.values && table.query(__assign$1(__assign$1({}, req), { values: false }));
                return table[method].apply(this, arguments).then(function(res) {
                  if (method === "query") {
                    if (outbound && req.values) {
                      return keysPromise_1.then(function(_a3) {
                        var resultingKeys = _a3.result;
                        pkRangeSet_1.addKeys(resultingKeys);
                        return res;
                      });
                    }
                    var pKeys = req.values ? res.result.map(extractKey) : res.result;
                    if (req.values) {
                      pkRangeSet_1.addKeys(pKeys);
                    } else {
                      delsRangeSet_1.addKeys(pKeys);
                    }
                  } else if (method === "openCursor") {
                    var cursor_1 = res;
                    var wantValues_1 = req.values;
                    return cursor_1 && Object.create(cursor_1, {
                      key: {
                        get: function() {
                          delsRangeSet_1.addKey(cursor_1.primaryKey);
                          return cursor_1.key;
                        }
                      },
                      primaryKey: {
                        get: function() {
                          var pkey = cursor_1.primaryKey;
                          delsRangeSet_1.addKey(pkey);
                          return pkey;
                        }
                      },
                      value: {
                        get: function() {
                          wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                          return cursor_1.value;
                        }
                      }
                    });
                  }
                  return res;
                });
              }
            }
          }
          return table[method].apply(this, arguments);
        };
      });
      return tableClone;
    } });
  }
};
function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
  function addAffectedIndex(ix) {
    var rangeSet = getRangeSet(ix.name || "");
    function extractKey(obj) {
      return obj != null ? ix.extractKey(obj) : null;
    }
    var addKeyOrKeys = function(key) {
      return ix.multiEntry && isArray$1(key) ? key.forEach(function(key2) {
        return rangeSet.addKey(key2);
      }) : rangeSet.addKey(key);
    };
    (oldObjs || newObjs).forEach(function(_, i) {
      var oldKey = oldObjs && extractKey(oldObjs[i]);
      var newKey = newObjs && extractKey(newObjs[i]);
      if (cmp(oldKey, newKey) !== 0) {
        if (oldKey != null)
          addKeyOrKeys(oldKey);
        if (newKey != null)
          addKeyOrKeys(newKey);
      }
    });
  }
  schema.indexes.forEach(addAffectedIndex);
}
var Dexie$1 = function() {
  function Dexie2(name2, options) {
    var _this = this;
    this._middlewares = {};
    this.verno = 0;
    var deps = Dexie2.dependencies;
    this._options = options = __assign$1({
      addons: Dexie2.addons,
      autoOpen: true,
      indexedDB: deps.indexedDB,
      IDBKeyRange: deps.IDBKeyRange
    }, options);
    this._deps = {
      indexedDB: options.indexedDB,
      IDBKeyRange: options.IDBKeyRange
    };
    var addons = options.addons;
    this._dbSchema = {};
    this._versions = [];
    this._storeNames = [];
    this._allTables = {};
    this.idbdb = null;
    this._novip = this;
    var state = {
      dbOpenError: null,
      isBeingOpened: false,
      onReadyBeingFired: null,
      openComplete: false,
      dbReadyResolve: nop,
      dbReadyPromise: null,
      cancelOpen: nop,
      openCanceller: null,
      autoSchema: true,
      PR1398_maxLoop: 3
    };
    state.dbReadyPromise = new DexiePromise(function(resolve) {
      state.dbReadyResolve = resolve;
    });
    state.openCanceller = new DexiePromise(function(_, reject) {
      state.cancelOpen = reject;
    });
    this._state = state;
    this.name = name2;
    this.on = Events(this, "populate", "blocked", "versionchange", "close", { ready: [promisableChain, nop] });
    this.on.ready.subscribe = override(this.on.ready.subscribe, function(subscribe3) {
      return function(subscriber, bSticky) {
        Dexie2.vip(function() {
          var state2 = _this._state;
          if (state2.openComplete) {
            if (!state2.dbOpenError)
              DexiePromise.resolve().then(subscriber);
            if (bSticky)
              subscribe3(subscriber);
          } else if (state2.onReadyBeingFired) {
            state2.onReadyBeingFired.push(subscriber);
            if (bSticky)
              subscribe3(subscriber);
          } else {
            subscribe3(subscriber);
            var db_1 = _this;
            if (!bSticky)
              subscribe3(function unsubscribe3() {
                db_1.on.ready.unsubscribe(subscriber);
                db_1.on.ready.unsubscribe(unsubscribe3);
              });
          }
        });
      };
    });
    this.Collection = createCollectionConstructor(this);
    this.Table = createTableConstructor(this);
    this.Transaction = createTransactionConstructor(this);
    this.Version = createVersionConstructor(this);
    this.WhereClause = createWhereClauseConstructor(this);
    this.on("versionchange", function(ev) {
      if (ev.newVersion > 0)
        console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
      else
        console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
      _this.close();
    });
    this.on("blocked", function(ev) {
      if (!ev.newVersion || ev.newVersion < ev.oldVersion)
        console.warn("Dexie.delete('" + _this.name + "') was blocked");
      else
        console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
    });
    this._maxKey = getMaxKey(options.IDBKeyRange);
    this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
      return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
    };
    this._fireOnBlocked = function(ev) {
      _this.on("blocked").fire(ev);
      connections.filter(function(c) {
        return c.name === _this.name && c !== _this && !c._state.vcFired;
      }).map(function(c) {
        return c.on("versionchange").fire(ev);
      });
    };
    this.use(virtualIndexMiddleware);
    this.use(hooksMiddleware);
    this.use(observabilityMiddleware);
    this.use(cacheExistingValuesMiddleware);
    this.vip = Object.create(this, { _vip: { value: true } });
    addons.forEach(function(addon) {
      return addon(_this);
    });
  }
  Dexie2.prototype.version = function(versionNumber) {
    if (isNaN(versionNumber) || versionNumber < 0.1)
      throw new exceptions.Type("Given version is not a positive number");
    versionNumber = Math.round(versionNumber * 10) / 10;
    if (this.idbdb || this._state.isBeingOpened)
      throw new exceptions.Schema("Cannot add version when database is open");
    this.verno = Math.max(this.verno, versionNumber);
    var versions = this._versions;
    var versionInstance = versions.filter(function(v) {
      return v._cfg.version === versionNumber;
    })[0];
    if (versionInstance)
      return versionInstance;
    versionInstance = new this.Version(versionNumber);
    versions.push(versionInstance);
    versions.sort(lowerVersionFirst);
    versionInstance.stores({});
    this._state.autoSchema = false;
    return versionInstance;
  };
  Dexie2.prototype._whenReady = function(fn) {
    var _this = this;
    return this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip) ? fn() : new DexiePromise(function(resolve, reject) {
      if (_this._state.openComplete) {
        return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
      }
      if (!_this._state.isBeingOpened) {
        if (!_this._options.autoOpen) {
          reject(new exceptions.DatabaseClosed());
          return;
        }
        _this.open().catch(nop);
      }
      _this._state.dbReadyPromise.then(resolve, reject);
    }).then(fn);
  };
  Dexie2.prototype.use = function(_a2) {
    var stack = _a2.stack, create2 = _a2.create, level = _a2.level, name2 = _a2.name;
    if (name2)
      this.unuse({ stack, name: name2 });
    var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
    middlewares.push({ stack, create: create2, level: level == null ? 10 : level, name: name2 });
    middlewares.sort(function(a, b) {
      return a.level - b.level;
    });
    return this;
  };
  Dexie2.prototype.unuse = function(_a2) {
    var stack = _a2.stack, name2 = _a2.name, create2 = _a2.create;
    if (stack && this._middlewares[stack]) {
      this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
        return create2 ? mw.create !== create2 : name2 ? mw.name !== name2 : false;
      });
    }
    return this;
  };
  Dexie2.prototype.open = function() {
    return dexieOpen(this);
  };
  Dexie2.prototype._close = function() {
    var state = this._state;
    var idx = connections.indexOf(this);
    if (idx >= 0)
      connections.splice(idx, 1);
    if (this.idbdb) {
      try {
        this.idbdb.close();
      } catch (e) {
      }
      this._novip.idbdb = null;
    }
    state.dbReadyPromise = new DexiePromise(function(resolve) {
      state.dbReadyResolve = resolve;
    });
    state.openCanceller = new DexiePromise(function(_, reject) {
      state.cancelOpen = reject;
    });
  };
  Dexie2.prototype.close = function() {
    this._close();
    var state = this._state;
    this._options.autoOpen = false;
    state.dbOpenError = new exceptions.DatabaseClosed();
    if (state.isBeingOpened)
      state.cancelOpen(state.dbOpenError);
  };
  Dexie2.prototype.delete = function() {
    var _this = this;
    var hasArguments = arguments.length > 0;
    var state = this._state;
    return new DexiePromise(function(resolve, reject) {
      var doDelete = function() {
        _this.close();
        var req = _this._deps.indexedDB.deleteDatabase(_this.name);
        req.onsuccess = wrap(function() {
          _onDatabaseDeleted(_this._deps, _this.name);
          resolve();
        });
        req.onerror = eventRejectHandler(reject);
        req.onblocked = _this._fireOnBlocked;
      };
      if (hasArguments)
        throw new exceptions.InvalidArgument("Arguments not allowed in db.delete()");
      if (state.isBeingOpened) {
        state.dbReadyPromise.then(doDelete);
      } else {
        doDelete();
      }
    });
  };
  Dexie2.prototype.backendDB = function() {
    return this.idbdb;
  };
  Dexie2.prototype.isOpen = function() {
    return this.idbdb !== null;
  };
  Dexie2.prototype.hasBeenClosed = function() {
    var dbOpenError = this._state.dbOpenError;
    return dbOpenError && dbOpenError.name === "DatabaseClosed";
  };
  Dexie2.prototype.hasFailed = function() {
    return this._state.dbOpenError !== null;
  };
  Dexie2.prototype.dynamicallyOpened = function() {
    return this._state.autoSchema;
  };
  Object.defineProperty(Dexie2.prototype, "tables", {
    get: function() {
      var _this = this;
      return keys(this._allTables).map(function(name2) {
        return _this._allTables[name2];
      });
    },
    enumerable: false,
    configurable: true
  });
  Dexie2.prototype.transaction = function() {
    var args = extractTransactionArgs.apply(this, arguments);
    return this._transaction.apply(this, args);
  };
  Dexie2.prototype._transaction = function(mode, tables, scopeFunc) {
    var _this = this;
    var parentTransaction = PSD.trans;
    if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1)
      parentTransaction = null;
    var onlyIfCompatible = mode.indexOf("?") !== -1;
    mode = mode.replace("!", "").replace("?", "");
    var idbMode, storeNames;
    try {
      storeNames = tables.map(function(table) {
        var storeName = table instanceof _this.Table ? table.name : table;
        if (typeof storeName !== "string")
          throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
        return storeName;
      });
      if (mode == "r" || mode === READONLY)
        idbMode = READONLY;
      else if (mode == "rw" || mode == READWRITE)
        idbMode = READWRITE;
      else
        throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
      if (parentTransaction) {
        if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
          if (onlyIfCompatible) {
            parentTransaction = null;
          } else
            throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
        }
        if (parentTransaction) {
          storeNames.forEach(function(storeName) {
            if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
              if (onlyIfCompatible) {
                parentTransaction = null;
              } else
                throw new exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
            }
          });
        }
        if (onlyIfCompatible && parentTransaction && !parentTransaction.active) {
          parentTransaction = null;
        }
      }
    } catch (e) {
      return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
        reject(e);
      }) : rejection(e);
    }
    var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
    return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : PSD.trans ? usePSD(PSD.transless, function() {
      return _this._whenReady(enterTransaction);
    }) : this._whenReady(enterTransaction);
  };
  Dexie2.prototype.table = function(tableName) {
    if (!hasOwn(this._allTables, tableName)) {
      throw new exceptions.InvalidTable("Table " + tableName + " does not exist");
    }
    return this._allTables[tableName];
  };
  return Dexie2;
}();
var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var Observable = function() {
  function Observable2(subscribe3) {
    this._subscribe = subscribe3;
  }
  Observable2.prototype.subscribe = function(x, error, complete) {
    return this._subscribe(!x || typeof x === "function" ? { next: x, error, complete } : x);
  };
  Observable2.prototype[symbolObservable] = function() {
    return this;
  };
  return Observable2;
}();
function extendObservabilitySet(target, newSet) {
  keys(newSet).forEach(function(part) {
    var rangeSet = target[part] || (target[part] = new RangeSet());
    mergeRanges(rangeSet, newSet[part]);
  });
  return target;
}
function liveQuery(querier) {
  return new Observable(function(observer) {
    var scopeFuncIsAsync = isAsyncFunction(querier);
    function execute(subscr) {
      if (scopeFuncIsAsync) {
        incrementExpectedAwaits();
      }
      var exec = function() {
        return newScope(querier, { subscr, trans: null });
      };
      var rv = PSD.trans ? usePSD(PSD.transless, exec) : exec();
      if (scopeFuncIsAsync) {
        rv.then(decrementExpectedAwaits, decrementExpectedAwaits);
      }
      return rv;
    }
    var closed = false;
    var accumMuts = {};
    var currentObs = {};
    var subscription = {
      get closed() {
        return closed;
      },
      unsubscribe: function() {
        closed = true;
        globalEvents.storagemutated.unsubscribe(mutationListener);
      }
    };
    observer.start && observer.start(subscription);
    var querying = false, startedListening = false;
    function shouldNotify() {
      return keys(currentObs).some(function(key) {
        return accumMuts[key] && rangesOverlap(accumMuts[key], currentObs[key]);
      });
    }
    var mutationListener = function(parts) {
      extendObservabilitySet(accumMuts, parts);
      if (shouldNotify()) {
        doQuery();
      }
    };
    var doQuery = function() {
      if (querying || closed)
        return;
      accumMuts = {};
      var subscr = {};
      var ret = execute(subscr);
      if (!startedListening) {
        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
        startedListening = true;
      }
      querying = true;
      Promise.resolve(ret).then(function(result) {
        querying = false;
        if (closed)
          return;
        if (shouldNotify()) {
          doQuery();
        } else {
          accumMuts = {};
          currentObs = subscr;
          observer.next && observer.next(result);
        }
      }, function(err) {
        querying = false;
        observer.error && observer.error(err);
        subscription.unsubscribe();
      });
    };
    doQuery();
    return subscription;
  });
}
var domDeps;
try {
  domDeps = {
    indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
    IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
  };
} catch (e) {
  domDeps = { indexedDB: null, IDBKeyRange: null };
}
var Dexie = Dexie$1;
props(Dexie, __assign$1(__assign$1({}, fullNameExceptions), {
  delete: function(databaseName) {
    var db = new Dexie(databaseName, { addons: [] });
    return db.delete();
  },
  exists: function(name2) {
    return new Dexie(name2, { addons: [] }).open().then(function(db) {
      db.close();
      return true;
    }).catch("NoSuchDatabaseError", function() {
      return false;
    });
  },
  getDatabaseNames: function(cb) {
    try {
      return getDatabaseNames(Dexie.dependencies).then(cb);
    } catch (_a2) {
      return rejection(new exceptions.MissingAPI());
    }
  },
  defineClass: function() {
    function Class(content) {
      extend$1(this, content);
    }
    return Class;
  },
  ignoreTransaction: function(scopeFunc) {
    return PSD.trans ? usePSD(PSD.transless, scopeFunc) : scopeFunc();
  },
  vip,
  async: function(generatorFn) {
    return function() {
      try {
        var rv = awaitIterator(generatorFn.apply(this, arguments));
        if (!rv || typeof rv.then !== "function")
          return DexiePromise.resolve(rv);
        return rv;
      } catch (e) {
        return rejection(e);
      }
    };
  },
  spawn: function(generatorFn, args, thiz) {
    try {
      var rv = awaitIterator(generatorFn.apply(thiz, args || []));
      if (!rv || typeof rv.then !== "function")
        return DexiePromise.resolve(rv);
      return rv;
    } catch (e) {
      return rejection(e);
    }
  },
  currentTransaction: {
    get: function() {
      return PSD.trans || null;
    }
  },
  waitFor: function(promiseOrFunction, optionalTimeout) {
    var promise = DexiePromise.resolve(typeof promiseOrFunction === "function" ? Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 6e4);
    return PSD.trans ? PSD.trans.waitFor(promise) : promise;
  },
  Promise: DexiePromise,
  debug: {
    get: function() {
      return debug;
    },
    set: function(value) {
      setDebug(value, value === "dexie" ? function() {
        return true;
      } : dexieStackFrameFilter);
    }
  },
  derive,
  extend: extend$1,
  props,
  override,
  Events,
  on: globalEvents,
  liveQuery,
  extendObservabilitySet,
  getByKeyPath,
  setByKeyPath,
  delByKeyPath,
  shallowClone,
  deepClone,
  getObjectDiff,
  cmp,
  asap: asap$1,
  minKey,
  addons: [],
  connections,
  errnames,
  dependencies: domDeps,
  semVer: DEXIE_VERSION,
  version: DEXIE_VERSION.split(".").map(function(n) {
    return parseInt(n);
  }).reduce(function(p, c, i) {
    return p + c / Math.pow(10, i * 2);
  })
}));
Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
    if (!propagatingLocally) {
      var event_1;
      if (isIEOrEdge) {
        event_1 = document.createEvent("CustomEvent");
        event_1.initCustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
      } else {
        event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
          detail: updatedParts
        });
      }
      propagatingLocally = true;
      dispatchEvent(event_1);
      propagatingLocally = false;
    }
  });
  addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function(_a2) {
    var detail = _a2.detail;
    if (!propagatingLocally) {
      propagateLocally(detail);
    }
  });
}
function propagateLocally(updateParts) {
  var wasMe = propagatingLocally;
  try {
    propagatingLocally = true;
    globalEvents.storagemutated.fire(updateParts);
  } finally {
    propagatingLocally = wasMe;
  }
}
var propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
  var bc_1 = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
    if (!propagatingLocally) {
      bc_1.postMessage(changedParts);
    }
  });
  bc_1.onmessage = function(ev) {
    if (ev.data)
      propagateLocally(ev.data);
  };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
    try {
      if (!propagatingLocally) {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
            trig: Math.random(),
            changedParts
          }));
        }
        if (typeof self["clients"] === "object") {
          __spreadArray([], self["clients"].matchAll({ includeUncontrolled: true }), true).forEach(function(client) {
            return client.postMessage({
              type: STORAGE_MUTATED_DOM_EVENT_NAME,
              changedParts
            });
          });
        }
      }
    } catch (_a2) {
    }
  });
  if (typeof addEventListener !== "undefined") {
    addEventListener("storage", function(ev) {
      if (ev.key === STORAGE_MUTATED_DOM_EVENT_NAME) {
        var data2 = JSON.parse(ev.newValue);
        if (data2)
          propagateLocally(data2.changedParts);
      }
    });
  }
  var swContainer = self.document && navigator.serviceWorker;
  if (swContainer) {
    swContainer.addEventListener("message", propagateMessageLocally);
  }
}
function propagateMessageLocally(_a2) {
  var data2 = _a2.data;
  if (data2 && data2.type === STORAGE_MUTATED_DOM_EVENT_NAME) {
    propagateLocally(data2.changedParts);
  }
}
DexiePromise.rejectionMapper = mapError;
setDebug(debug, dexieStackFrameFilter);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var sensorsdata = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    function e(e2) {
      if (!e2)
        return false;
      var t2 = Object.prototype.toString.call(e2);
      return t2 == "[object Function]" || t2 == "[object AsyncFunction]";
    }
    function t() {
      return Date.now && e(Date.now) ? Date.now() : new Date().getTime();
    }
    function r(e2) {
      return e2 != null && Object.prototype.toString.call(e2) == "[object Object]";
    }
    function n() {
      if (typeof Uint32Array == "function") {
        var e2 = "";
        if (typeof crypto != "undefined" ? e2 = crypto : typeof msCrypto != "undefined" && (e2 = msCrypto), r(e2) && e2.getRandomValues) {
          var t2 = new Uint32Array(1), n2 = e2.getRandomValues(t2)[0], i2 = Math.pow(2, 32);
          return n2 / i2;
        }
      }
      return Wi(1e19) / 1e19;
    }
    function i(e2) {
      var t2 = null;
      try {
        t2 = JSON.parse(e2);
      } catch (r2) {
      }
      return t2;
    }
    function a(e2, t2) {
      this.lockGetPrefix = e2 || "lock-get-prefix", this.lockSetPrefix = t2 || "lock-set-prefix";
    }
    function s(e2) {
      return typeof e2 == "function" || !(!e2 || typeof e2 != "object") && s(e2.listener);
    }
    function l() {
      this._events = {};
    }
    function u(e2) {
      var t2 = e2;
      try {
        t2 = decodeURIComponent(e2);
      } catch (r2) {
        t2 = e2;
      }
      return t2;
    }
    function c(e2) {
      e2 = e2 || "";
      for (var t2 = {}, r2 = e2.substring(1), n2 = r2.split("&"), i2 = 0; i2 < n2.length; i2++) {
        var a2 = n2[i2].indexOf("=");
        if (a2 !== -1) {
          var o2 = n2[i2].substring(0, a2), s2 = n2[i2].substring(a2 + 1);
          o2 = u(o2), s2 = u(s2), t2[o2] = s2;
        }
      }
      return t2;
    }
    function p(e2) {
      return Object.prototype.toString.call(e2) == "[object String]";
    }
    function d(e2) {
      return e2.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
    function f(e2) {
      var t2 = function(e3) {
        this._fields = { Username: 4, Password: 5, Port: 7, Protocol: 2, Host: 6, Path: 8, URL: 0, QueryString: 9, Fragment: 10 }, this._values = {}, this._regex = /^((\w+):\/\/)?((\w+):?(\w+)?@)?([^\/\?:]+):?(\d+)?(\/?[^\?#]+)?\??([^#]+)?#?(\w*)/, typeof e3 != "undefined" && this._parse(e3);
      };
      return t2.prototype.setUrl = function(e3) {
        this._parse(e3);
      }, t2.prototype._initValues = function() {
        for (var e3 in this._fields)
          this._values[e3] = "";
      }, t2.prototype.addQueryString = function(e3) {
        if (typeof e3 != "object")
          return false;
        var t3 = this._values.QueryString || "";
        for (var r2 in e3)
          t3 = new RegExp(r2 + "[^&]+").test(t3) ? t3.replace(new RegExp(r2 + "[^&]+"), r2 + "=" + e3[r2]) : t3.slice(-1) === "&" ? t3 + r2 + "=" + e3[r2] : t3 === "" ? r2 + "=" + e3[r2] : t3 + "&" + r2 + "=" + e3[r2];
        this._values.QueryString = t3;
      }, t2.prototype.getUrl = function() {
        var e3 = "";
        return e3 += this._values.Origin, e3 += this._values.Port ? ":" + this._values.Port : "", e3 += this._values.Path, e3 += this._values.QueryString ? "?" + this._values.QueryString : "", e3 += this._values.Fragment ? "#" + this._values.Fragment : "";
      }, t2.prototype._parse = function(e3) {
        this._initValues();
        var t3 = this._regex.exec(e3);
        t3 || Fi.log("URLParser::_parse -> Invalid URL");
        var r2 = e3.split("#"), n2 = r2[0], i2 = r2.slice(1).join("#");
        t3 = this._regex.exec(n2);
        for (var a2 in this._fields)
          typeof t3[this._fields[a2]] != "undefined" && (this._values[a2] = t3[this._fields[a2]]);
        this._values.Hostname = this._values.Host.replace(/:\d+$/, ""), this._values.Origin = this._values.Protocol + "://" + this._values.Hostname, this._values.Fragment = i2;
      }, new t2(e2);
    }
    function g(e2) {
      var t2 = {}, r2 = function() {
        var e3;
        try {
          return e3 = new URL("https://www.sensorsdata.cn/"), e3.href === "https://www.sensorsdata.cn/";
        } catch (t3) {
          return false;
        }
      };
      if (typeof window.URL == "function" && r2())
        t2 = new URL(e2), t2.searchParams || (t2.searchParams = function() {
          var e3 = c(t2.search);
          return { get: function(t3) {
            return e3[t3];
          } };
        }());
      else {
        p(e2) || (e2 = String(e2)), e2 = d(e2);
        var n2 = /^https?:\/\/.+/;
        if (n2.test(e2) === false)
          return void Fi.log("Invalid URL");
        var i2 = f(e2);
        t2.hash = i2._values.Fragment, t2.host = i2._values.Host ? i2._values.Host + (i2._values.Port ? ":" + i2._values.Port : "") : "", t2.href = i2._values.URL, t2.password = i2._values.Password, t2.pathname = i2._values.Path, t2.port = i2._values.Port, t2.search = i2._values.QueryString ? "?" + i2._values.QueryString : "", t2.username = i2._values.Username, t2.hostname = i2._values.Hostname, t2.protocol = i2._values.Protocol ? i2._values.Protocol + ":" : "", t2.origin = i2._values.Origin ? i2._values.Origin + (i2._values.Port ? ":" + i2._values.Port : "") : "", t2.searchParams = function() {
          var e3 = c("?" + i2._values.QueryString);
          return { get: function(t3) {
            return e3[t3];
          } };
        }();
      }
      return t2;
    }
    function _(e2) {
      return !(!e2 || e2.nodeType !== 1);
    }
    function h(e2) {
      return e2 === void 0;
    }
    function v(t2) {
      return Array.isArray && e(v) ? Array.isArray(t2) : Object.prototype.toString.call(t2) === "[object Array]";
    }
    function y(e2) {
      return new Zi(e2);
    }
    function b(e2, t2, r2, n2) {
      function i2(e3) {
        return e3 && (e3.preventDefault = i2.preventDefault, e3.stopPropagation = i2.stopPropagation, e3._getPath = i2._getPath), e3;
      }
      function a2(e3, t3, r3, n3) {
        var a3 = function(a4) {
          if (a4 = a4 || i2(window.event)) {
            a4.target = a4.srcElement;
            var o3, s2, l2 = true;
            return typeof r3 == "function" && (o3 = r3(a4)), s2 = t3.call(e3, a4), n3 !== "beforeunload" ? (o3 !== false && s2 !== false || (l2 = false), l2) : void 0;
          }
        };
        return a3;
      }
      i2._getPath = function() {
        var e3 = this;
        return this.path || this.composedPath && this.composedPath() || y(e3.target).getParents();
      }, i2.preventDefault = function() {
        this.returnValue = false;
      }, i2.stopPropagation = function() {
        this.cancelBubble = true;
      };
      var o2 = function(e3, t3, r3) {
        if (n2 === void 0 && t3 === "click" && (n2 = true), e3 && e3.addEventListener)
          e3.addEventListener(t3, function(e4) {
            e4._getPath = i2._getPath, r3.call(this, e4);
          }, n2);
        else {
          var o3 = "on" + t3, s2 = e3[o3];
          e3[o3] = a2(e3, r3, s2, t3);
        }
      };
      o2.apply(null, arguments);
    }
    function w(e2) {
      var t2 = "pushState" in window.history ? "popstate" : "hashchange";
      b(window, t2, e2);
    }
    function S(e2) {
      if (e2)
        return typeof window.XMLHttpRequest != "undefined" && "withCredentials" in new XMLHttpRequest() ? new XMLHttpRequest() : typeof XDomainRequest != "undefined" ? new XDomainRequest() : null;
      if (typeof window.XMLHttpRequest != "undefined")
        return new XMLHttpRequest();
      if (window.ActiveXObject)
        try {
          return new ActiveXObject("Msxml2.XMLHTTP");
        } catch (t2) {
          try {
            return new ActiveXObject("Microsoft.XMLHTTP");
          } catch (t3) {
            Fi.log(t3);
          }
        }
    }
    function k(e2, t2, r2) {
      if (e2 == null)
        return false;
      if (Qi && e2.forEach === Qi)
        e2.forEach(t2, r2);
      else if (v(e2))
        for (var n2 = 0, i2 = e2.length; n2 < i2; n2++)
          n2 in e2 && t2.call(r2, e2[n2], n2, e2);
      else
        for (var a2 in e2)
          Yi.call(e2, a2) && t2.call(r2, e2[a2], a2, e2);
    }
    function P(e2) {
      return k(Array.prototype.slice.call(arguments, 1), function(t2) {
        for (var r2 in t2)
          ea.call(t2, r2) && t2[r2] !== void 0 && (e2[r2] = t2[r2]);
      }), e2;
    }
    function C(e2) {
      function t2(e3) {
        if (!e3)
          return "";
        try {
          return JSON.parse(e3);
        } catch (t3) {
          return {};
        }
      }
      function n2() {
        try {
          i2 && typeof i2 == "object" && i2.abort && i2.abort();
        } catch (t3) {
          Fi.log(t3);
        }
        a2 && (clearTimeout(a2), a2 = null, e2.error && e2.error(), i2.onreadystatechange = null, i2.onload = null, i2.onerror = null);
      }
      e2.timeout = e2.timeout || 2e4, e2.credentials = typeof e2.credentials == "undefined" || e2.credentials;
      var i2 = S(e2.cors);
      if (!i2)
        return false;
      e2.type || (e2.type = e2.data ? "POST" : "GET"), e2 = P({ success: function() {
      }, error: function() {
      } }, e2);
      var a2, o2 = e2.success, s2 = e2.error;
      e2.success = function(e3) {
        o2(e3), a2 && (clearTimeout(a2), a2 = null);
      }, e2.error = function(e3) {
        s2(e3), a2 && (clearTimeout(a2), a2 = null);
      }, a2 = setTimeout(function() {
        n2();
      }, e2.timeout), typeof XDomainRequest != "undefined" && i2 instanceof XDomainRequest && (i2.onload = function() {
        e2.success && e2.success(t2(i2.responseText)), i2.onreadystatechange = null, i2.onload = null, i2.onerror = null;
      }, i2.onerror = function() {
        e2.error && e2.error(t2(i2.responseText), i2.status), i2.onreadystatechange = null, i2.onerror = null, i2.onload = null;
      }), i2.onreadystatechange = function() {
        try {
          i2.readyState == 4 && (i2.status >= 200 && i2.status < 300 || i2.status == 304 ? e2.success(t2(i2.responseText)) : e2.error(t2(i2.responseText), i2.status), i2.onreadystatechange = null, i2.onload = null);
        } catch (r2) {
          i2.onreadystatechange = null, i2.onload = null;
        }
      }, i2.open(e2.type, e2.url, true);
      try {
        e2.credentials && (i2.withCredentials = true), r(e2.header) && k(e2.header, function(e3, t3) {
          i2.setRequestHeader && i2.setRequestHeader(t3, e3);
        }), e2.data && (e2.cors || i2.setRequestHeader && i2.setRequestHeader("X-Requested-With", "XMLHttpRequest"), e2.contentType === "application/json" ? i2.setRequestHeader && i2.setRequestHeader("Content-type", "application/json; charset=UTF-8") : i2.setRequestHeader && i2.setRequestHeader("Content-type", "application/x-www-form-urlencoded"));
      } catch (l2) {
        Fi.log(l2);
      }
      i2.send(e2.data || null);
    }
    function O(e2, t2) {
      var r2 = [];
      return e2 == null ? r2 : Array.prototype.map && e2.map === Array.prototype.map ? e2.map(t2) : (k(e2, function(e3, n2, i2) {
        r2.push(t2(e3, n2, i2));
      }), r2);
    }
    function N(e2) {
      var t2 = [];
      try {
        t2 = O(atob(e2).split(""), function(e3) {
          return "%" + ("00" + e3.charCodeAt(0).toString(16)).slice(-2);
        });
      } catch (r2) {
        t2 = [];
      }
      try {
        return decodeURIComponent(t2.join(""));
      } catch (r2) {
        return t2.join("");
      }
    }
    function j(e2) {
      var t2 = "";
      try {
        t2 = btoa(encodeURIComponent(e2).replace(/%([0-9A-F]{2})/g, function(e3, t3) {
          return String.fromCharCode("0x" + t3);
        }));
      } catch (r2) {
        t2 = e2;
      }
      return t2;
    }
    function T(e2, t2) {
      t2 = t2 || window;
      var r2 = false, n2 = true, i2 = t2.document, a2 = i2.documentElement, o2 = i2.addEventListener, s2 = o2 ? "addEventListener" : "attachEvent", l2 = o2 ? "removeEventListener" : "detachEvent", u2 = o2 ? "" : "on", c2 = function(n3) {
        n3.type == "readystatechange" && i2.readyState != "complete" || ((n3.type == "load" ? t2 : i2)[l2](u2 + n3.type, c2, false), !r2 && (r2 = true) && e2.call(t2, n3.type || n3));
      }, p2 = function() {
        try {
          a2.doScroll("left");
        } catch (e3) {
          return void setTimeout(p2, 50);
        }
        c2("poll");
      };
      if (i2.readyState == "complete")
        e2.call(t2, "lazy");
      else {
        if (!o2 && a2.doScroll) {
          try {
            n2 = !t2.frameElement;
          } catch (d2) {
            Fi.log(d2);
          }
          n2 && p2();
        }
        i2[s2](u2 + "DOMContentLoaded", c2, false), i2[s2](u2 + "readystatechange", c2, false), t2[s2](u2 + "load", c2, false);
      }
    }
    function I(e2) {
      return k(Array.prototype.slice.call(arguments, 1), function(t2) {
        for (var r2 in t2)
          t2[r2] !== void 0 && e2[r2] === void 0 && (e2[r2] = t2[r2]);
      }), e2;
    }
    function $(e2) {
      var t2 = e2;
      try {
        t2 = decodeURI(e2);
      } catch (r2) {
        t2 = e2;
      }
      return t2;
    }
    function A(e2) {
      var t2 = "t6KJCZa5pDdQ9khoEM3Tj70fbP2eLSyc4BrsYugARqFIw1mzlGNVXOHiWvxUn8", r2 = t2.length - 1, n2 = {}, i2 = 0;
      for (i2 = 0; i2 < t2.length; i2++)
        n2[t2.charAt(i2)] = t2.charAt(r2 - i2);
      var a2 = "";
      for (i2 = 0; i2 < e2.length; i2++)
        a2 += e2.charAt(i2) in n2 ? n2[e2.charAt(i2)] : e2.charAt(i2);
      return a2;
    }
    function D(e2) {
      return Object.prototype.toString.call(e2) == "[object Date]";
    }
    function x(e2) {
      function t2(e3) {
        return e3 < 10 ? "0" + e3 : e3;
      }
      return e2.getFullYear() + "-" + t2(e2.getMonth() + 1) + "-" + t2(e2.getDate()) + " " + t2(e2.getHours()) + ":" + t2(e2.getMinutes()) + ":" + t2(e2.getSeconds()) + "." + t2(e2.getMilliseconds());
    }
    function E(e2) {
      return k(e2, function(t2, n2) {
        D(t2) ? e2[n2] = x(t2) : r(t2) && (e2[n2] = E(t2));
      }), e2;
    }
    function L(e2) {
      return k(Array.prototype.slice.call(arguments, 1), function(t2) {
        for (var n2 in t2)
          t2[n2] !== void 0 && (r(t2[n2]) && r(e2[n2]) ? P(e2[n2], t2[n2]) : e2[n2] = t2[n2]);
      }), e2;
    }
    function U(e2, t2, r2) {
      var n2 = Object.prototype.hasOwnProperty;
      if (e2.filter)
        return e2.filter(t2);
      for (var i2 = [], a2 = 0; a2 < e2.length; a2++)
        if (n2.call(e2, a2)) {
          var o2 = e2[a2];
          t2.call(r2, o2, a2, e2) && i2.push(o2);
        }
      return i2;
    }
    function R(e2) {
      try {
        return JSON.stringify(e2, null, "  ");
      } catch (t2) {
        return JSON.stringify(e2);
      }
    }
    function H(e2) {
      return typeof e2 == "string" && e2.match(/^[a-zA-Z0-9\u4e00-\u9fa5\-\.]+$/) ? e2 : "";
    }
    function B(e2, t2) {
      e2 = e2 || location.hostname, t2 = t2 || "domain_test";
      var r2 = H(e2), n2 = r2.split(".");
      if (v(n2) && n2.length >= 2 && !/^(\d+\.)+\d+$/.test(r2)) {
        for (var i2 = "." + n2.splice(n2.length - 1, 1); n2.length > 0; )
          if (i2 = "." + n2.splice(n2.length - 1, 1) + i2, document.cookie = t2 + "=true; path=/; domain=" + i2, document.cookie.indexOf(t2 + "=true") !== -1) {
            var a2 = new Date();
            return a2.setTime(a2.getTime() - 1e3), document.cookie = t2 + "=true; expires=" + a2.toGMTString() + "; path=/; SameSite=Lax; domain=" + i2, i2;
          }
      }
      return "";
    }
    function J(e2) {
      function t2(e3, t3) {
        e3 = d(e3);
        var r3;
        if (e3 === "body")
          return document.getElementsByTagName("body")[0];
        if (e3.indexOf("#") === 0)
          e3 = e3.slice(1), r3 = document.getElementById(e3);
        else if (e3.indexOf(":nth-of-type") > -1) {
          var n3 = e3.split(":nth-of-type");
          if (!n3[0] || !n3[1])
            return null;
          var i3 = n3[0], a2 = n3[1].match(/\(([0-9]+)\)/);
          if (!a2 || !a2[1])
            return null;
          var o2 = Number(a2[1]);
          if (!(_(t3) && t3.children && t3.children.length > 0))
            return null;
          for (var s2 = t3.children, l2 = 0; l2 < s2.length; l2++)
            if (_(s2[l2])) {
              var u2 = s2[l2].tagName.toLowerCase();
              if (u2 === i3 && (o2--, o2 === 0)) {
                r3 = s2[l2];
                break;
              }
            }
          if (o2 > 0)
            return null;
        }
        return r3 ? r3 : null;
      }
      function r2(e3) {
        var i3, a2 = n2.shift();
        if (!a2)
          return e3;
        try {
          i3 = t2(a2, e3);
        } catch (o2) {
          Fi.log(o2);
        }
        return i3 && _(i3) ? r2(i3) : null;
      }
      if (!p(e2))
        return null;
      var n2 = e2.split(">"), i2 = null;
      return i2 = r2(), i2 && _(i2) ? i2 : null;
    }
    function M2(e2, t2) {
      var r2 = "", n2 = "";
      return e2.textContent ? r2 = d(e2.textContent) : e2.innerText && (r2 = d(e2.innerText)), r2 && (r2 = r2.replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255)), n2 = r2 || "", t2 !== "input" && t2 !== "INPUT" || (n2 = e2.value || ""), n2;
    }
    function q(e2, t2) {
      t2 && typeof t2 == "string" || (t2 = "hostname\u89E3\u6790\u5F02\u5E38");
      var r2 = null;
      try {
        r2 = g(e2).hostname;
      } catch (n2) {
        Fi.log("getHostname\u4F20\u5165\u7684url\u53C2\u6570\u4E0D\u5408\u6CD5\uFF01");
      }
      return r2 || t2;
    }
    function K() {
      try {
        var e2 = navigator.appVersion.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);
        return e2 && e2[1] ? Number.parseInt(e2[1], 10) : "";
      } catch (t2) {
        return "";
      }
    }
    function V(e2) {
      var t2 = {}, r2 = e2.split("?"), n2 = r2[1] || "";
      return n2 && (t2 = c("?" + n2)), t2;
    }
    function F(e2, t2) {
      var r2 = g(e2), n2 = r2.searchParams.get(t2) || "";
      if (!n2) {
        var i2 = r2.hash;
        if (i2) {
          var a2 = V(i2);
          n2 = a2[t2] || "";
        }
      }
      return n2;
    }
    function z() {
      return typeof window.matchMedia != "undefined" || typeof window.msMatchMedia != "undefined";
    }
    function W() {
      var e2 = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type, t2 = "\u672A\u53D6\u5230\u503C";
      if (e2)
        t2 = e2.indexOf("landscape") > -1 ? "landscape" : "portrait";
      else if (z()) {
        var r2 = window.matchMedia || window.msMatchMedia;
        r2("(orientation: landscape)").matches ? t2 = "landscape" : r2("(orientation: portrait)").matches && (t2 = "portrait");
      }
      return t2;
    }
    function X() {
      var e2, t2 = {}, r2 = navigator.userAgent.toLowerCase();
      return (e2 = r2.match(/ qq\/([\d.]+)/)) ? t2.qqBuildinBrowser = Number(e2[1].split(".")[0]) : (e2 = r2.match(/mqqbrowser\/([\d.]+)/)) ? t2.qqBrowser = Number(e2[1].split(".")[0]) : (e2 = r2.match(/opera.([\d.]+)/)) ? t2.opera = Number(e2[1].split(".")[0]) : (e2 = r2.match(/msie ([\d.]+)/)) ? t2.ie = Number(e2[1].split(".")[0]) : (e2 = r2.match(/edge.([\d.]+)/)) ? t2.edge = Number(e2[1].split(".")[0]) : (e2 = r2.match(/firefox\/([\d.]+)/)) ? t2.firefox = Number(e2[1].split(".")[0]) : (e2 = r2.match(/chrome\/([\d.]+)/)) ? t2.chrome = Number(e2[1].split(".")[0]) : (e2 = r2.match(/version\/([\d.]+).*safari/)) ? t2.safari = Number(e2[1].match(/^\d*.\d*/)) : (e2 = r2.match(/trident\/([\d.]+)/)) && (t2.ie = 11), t2;
    }
    function Z(e2) {
      return p(e2) ? (e2 = d(e2), $(e2)) : $(location.href);
    }
    function G(e2) {
      return p(e2) ? (e2 = d(e2), $(e2)) : $(location.pathname);
    }
    function Q(e2, t2) {
      return e2.hasAttribute ? e2.hasAttribute(t2) : e2.attributes ? !(!e2.attributes[t2] || !e2.attributes[t2].specified) : void 0;
    }
    function Y(e2, t2) {
      if (typeof t2 == "string")
        return Q(e2, t2);
      if (v(t2)) {
        for (var r2 = false, n2 = 0; n2 < t2.length; n2++) {
          var i2 = Q(e2, t2[n2]);
          if (i2) {
            r2 = true;
            break;
          }
        }
        return r2;
      }
    }
    function ee(e2) {
      if (typeof e2 != "string")
        return 0;
      var t2 = 0, r2 = null;
      if (e2.length == 0)
        return t2;
      for (var n2 = 0; n2 < e2.length; n2++)
        r2 = e2.charCodeAt(n2), t2 = (t2 << 5) - t2 + r2, t2 &= t2;
      return t2;
    }
    function te(e2) {
      var t2 = 9007199254740992, r2 = -9007199254740992, n2 = 31, i2 = 0;
      if (e2.length > 0)
        for (var a2 = e2.split(""), o2 = 0; o2 < a2.length; o2++) {
          var s2 = a2[o2].charCodeAt(), l2 = n2 * i2 + s2;
          if (l2 > t2)
            for (i2 = r2 + i2; l2 = n2 * i2 + s2, l2 < r2; )
              i2 = i2 / 2 + s2;
          if (l2 < r2)
            for (i2 = t2 + i2; l2 = n2 * i2 + s2, l2 > t2; )
              i2 = i2 / 2 + s2;
          i2 = n2 * i2 + s2;
        }
      return i2;
    }
    function re(e2, t2) {
      var r2 = e2.indexOf;
      if (r2)
        return r2.call(e2, t2);
      for (var n2 = 0; n2 < e2.length; n2++)
        if (t2 === e2[n2])
          return n2;
      return -1;
    }
    function ne(e2, t2) {
      return e2.prototype = new t2(), e2.prototype.constructor = e2, e2.superclass = t2.prototype, e2;
    }
    function ie(e2) {
      return !(!e2 || !ra.call(e2, "callee"));
    }
    function ae(e2) {
      return Object.prototype.toString.call(e2) == "[object Boolean]";
    }
    function oe(e2) {
      if (r(e2)) {
        for (var t2 in e2)
          if (Object.prototype.hasOwnProperty.call(e2, t2))
            return false;
        return true;
      }
      return false;
    }
    function se(e2) {
      if (typeof e2 != "string")
        return false;
      var t2 = /^https?:\/\/.+/;
      return t2.test(e2) !== false || (Fi.log("Invalid URL"), false);
    }
    function le() {
      return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }
    function ue(e2) {
      try {
        JSON.parse(e2);
      } catch (t2) {
        return false;
      }
      return true;
    }
    function ce(e2) {
      return Object.prototype.toString.call(e2) == "[object Number]" && /[\d\.]+/.test(String(e2));
    }
    function pe() {
      var e2 = false;
      if (typeof navigator != "object" || typeof navigator.sendBeacon != "function")
        return e2;
      var t2 = X(), r2 = navigator.userAgent.toLowerCase();
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        var n2 = /os [\d._]*/gi, i2 = r2.match(n2), a2 = (i2 + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."), o2 = a2.split(".");
        typeof t2.safari == "undefined" && (t2.safari = o2[0]), o2[0] && (t2.qqBuildinBrowser || t2.qqBrowser) ? e2 = false : o2[0] && o2[0] < 13 ? (t2.chrome > 41 || t2.firefox > 30 || t2.opera > 25 || t2.safari > 12) && (e2 = true) : (t2.chrome > 41 || t2.firefox > 30 || t2.opera > 25 || t2.safari > 11.3) && (e2 = true);
      } else
        (t2.chrome > 38 || t2.edge > 13 || t2.firefox > 30 || t2.opera > 25 || t2.safari > 11) && (e2 = true);
      return e2;
    }
    function de() {
      return typeof window.XMLHttpRequest != "undefined" && ("withCredentials" in new XMLHttpRequest() || typeof XDomainRequest != "undefined");
    }
    function fe(t2) {
      if (!r(t2) || !p(t2.callbackName))
        return Fi.log("JSONP \u8BF7\u6C42\u7F3A\u5C11 callbackName"), false;
      t2.success = e(t2.success) ? t2.success : function() {
      }, t2.error = e(t2.error) ? t2.error : function() {
      }, t2.data = t2.data || "";
      var n2 = document.createElement("script"), i2 = document.getElementsByTagName("head")[0], a2 = null, o2 = false;
      if (i2.appendChild(n2), ce(t2.timeout) && (a2 = setTimeout(function() {
        return !o2 && (t2.error("timeout"), window[t2.callbackName] = function() {
          Fi.log("call jsonp error");
        }, a2 = null, i2.removeChild(n2), void (o2 = true));
      }, t2.timeout)), window[t2.callbackName] = function() {
        clearTimeout(a2), a2 = null, t2.success.apply(null, arguments), window[t2.callbackName] = function() {
          Fi.log("call jsonp error");
        }, i2.removeChild(n2);
      }, t2.url.indexOf("?") > -1 ? t2.url += "&callbackName=" + t2.callbackName : t2.url += "?callbackName=" + t2.callbackName, r(t2.data)) {
        var s2 = [];
        k(t2.data, function(e2, t3) {
          s2.push(t3 + "=" + e2);
        }), t2.data = s2.join("&"), t2.url += "&" + t2.data;
      }
      n2.onerror = function(e2) {
        return !o2 && (window[t2.callbackName] = function() {
          Fi.log("call jsonp error");
        }, clearTimeout(a2), a2 = null, i2.removeChild(n2), t2.error(e2), void (o2 = true));
      }, n2.src = t2.url;
    }
    function ge(t2) {
      var r2 = { visibleHandler: e(t2.visible) ? t2.visible : function() {
      }, hiddenHandler: e(t2.hidden) ? t2.hidden : function() {
      }, visibilityChange: null, hidden: null, isSupport: function() {
        return typeof document[this.hidden] != "undefined";
      }, init: function() {
        typeof document.hidden != "undefined" ? (this.hidden = "hidden", this.visibilityChange = "visibilitychange") : typeof document.mozHidden != "undefined" ? (this.hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : typeof document.msHidden != "undefined" ? (this.hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (this.hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange"), this.listen();
      }, listen: function() {
        if (this.isSupport()) {
          var e2 = this;
          b(document, this.visibilityChange, function() {
            document[e2.hidden] ? e2.hiddenHandler() : e2.visibleHandler();
          }, 1);
        } else
          b(window, "focus", this.visibleHandler), b(window, "blur", this.hiddenHandler);
      } };
      r2.init();
    }
    function _e(e2) {
      e2 = P({ success: function() {
      }, error: function() {
      }, appendCall: function(e3) {
        document.getElementsByTagName("head")[0].appendChild(e3);
      } }, e2);
      var t2 = null;
      e2.type === "css" && (t2 = document.createElement("link"), t2.rel = "stylesheet", t2.href = e2.url), e2.type === "js" && (t2 = document.createElement("script"), t2.async = "async", t2.setAttribute("charset", "UTF-8"), t2.src = e2.url, t2.type = "text/javascript"), t2.onload = t2.onreadystatechange = function() {
        this.readyState && this.readyState !== "loaded" && this.readyState !== "complete" || (e2.success(), t2.onload = t2.onreadystatechange = null);
      }, t2.onerror = function() {
        e2.error(), t2.onerror = null;
      }, e2.appendCall(t2);
    }
    function he(e2) {
      if (typeof e2 != "string")
        return "";
      for (var t2 = /^\s*javascript/i; t2.test(e2); )
        e2 = e2.replace(t2, "");
      return e2;
    }
    function me(e2, t2) {
      e2 = String(e2), t2 = typeof t2 == "number" ? t2 : 13;
      for (var r2 = 126, n2 = e2.split(""), i2 = 0, a2 = n2.length; i2 < a2; i2++) {
        var o2 = n2[i2].charCodeAt(0);
        o2 < r2 && (n2[i2] = String.fromCharCode((n2[i2].charCodeAt(0) + t2) % r2));
      }
      return n2.join("");
    }
    function ve(e2) {
      var t2 = 13, r2 = 126;
      return e2 = String(e2), me(e2, r2 - t2);
    }
    function ye(e2) {
      (r(e2) || v(e2)) && k(e2, function(t2, n2) {
        r(t2) || v(t2) ? ye(e2[n2]) : D(t2) && (e2[n2] = x(t2));
      });
    }
    function be(e2) {
      var t2 = document.createElement("style");
      t2.type = "text/css";
      try {
        t2.appendChild(document.createTextNode(e2));
      } catch (r2) {
        t2.styleSheet.cssText = e2;
      }
      var n2 = document.getElementsByTagName("head")[0], i2 = document.getElementsByTagName("script")[0];
      n2 ? n2.children.length ? n2.insertBefore(t2, n2.children[0]) : n2.appendChild(t2) : i2.parentNode.insertBefore(t2, i2);
    }
    function we(e2) {
      if (typeof e2 != "string")
        return Fi.log("\u8F6C\u6362unicode\u9519\u8BEF", e2), e2;
      for (var t2 = "", r2 = 0; r2 < e2.length; r2++)
        t2 += "\\" + e2.charCodeAt(r2).toString(16);
      return t2;
    }
    function Se(e2, r2, n2) {
      var i2, a2, o2, s2 = null, l2 = 0;
      n2 || (n2 = {});
      var u2 = function() {
        l2 = n2.leading === false ? 0 : t(), s2 = null, o2 = e2.apply(i2, a2), s2 || (i2 = a2 = null);
      };
      return function() {
        var c2 = t();
        l2 || n2.leading !== false || (l2 = c2);
        var p2 = r2 - (c2 - l2);
        return i2 = this, a2 = arguments, p2 <= 0 || p2 > r2 ? (s2 && (clearTimeout(s2), s2 = null), l2 = c2, o2 = e2.apply(i2, a2), s2 || (i2 = a2 = null)) : s2 || n2.trailing === false || (s2 = setTimeout(u2, p2)), o2;
      };
    }
    function ke(e2) {
      var t2 = [];
      return e2 == null ? t2 : (k(e2, function(e3) {
        t2[t2.length] = e3;
      }), t2);
    }
    function Pe(e2) {
      return e2 ? e2.toArray ? e2.toArray() : v(e2) || ie(e2) ? Array.prototype.slice.call(e2) : ke(e2) : [];
    }
    function Ce(e2) {
      for (var t2, r2 = [], n2 = {}, i2 = 0; i2 < e2.length; i2++)
        t2 = e2[i2], t2 in n2 || (n2[t2] = true, r2.push(t2));
      return r2;
    }
    function Oe() {
      ua2.msg.apply(ua2, arguments).log();
    }
    function Ne() {
      ua2.msg.apply(ua2, arguments).level("warn").log();
    }
    function je() {
      ua2.msg.apply(ua2, arguments).level("error").log();
    }
    function Te(e2) {
      var t2 = ca.current_domain;
      switch (typeof t2) {
        case "function":
          var r2 = t2();
          return r2 === "" || d(r2) === "" ? "url\u89E3\u6790\u5931\u8D25" : r2.indexOf(".") !== -1 ? r2 : "url\u89E3\u6790\u5931\u8D25";
        case "string":
          return t2 === "" || d(t2) === "" ? "url\u89E3\u6790\u5931\u8D25" : t2.indexOf(".") !== -1 ? t2 : "url\u89E3\u6790\u5931\u8D25";
        default:
          var n2 = B(null, ga);
          return e2 === "" ? "url\u89E3\u6790\u5931\u8D25" : n2 === "" ? "url\u89E3\u6790\u5931\u8D25" : n2;
      }
    }
    function Ie() {
      var e2 = document.referrer, t2 = "baidu.com";
      if (!e2)
        return false;
      try {
        var r2 = g(e2).hostname;
        return r2 && r2.substring(r2.length - t2.length) === t2;
      } catch (n2) {
        return false;
      }
    }
    function $e() {
      var e2 = V(document.referrer);
      if (oe(e2) || !e2.eqid) {
        var t2 = V(location.href);
        return e2.ck || t2.utm_source ? "baidu_sem_keyword_id" : "baidu_other_keyword_id";
      }
      return "baidu_seo_keyword_id";
    }
    function Ae() {
      var e2 = V(document.referrer);
      return oe(e2) || !e2.eqid ? Xi().replace(/-/g, "") : e2.eqid;
    }
    function De(e2, t2) {
      return e2 = e2 || document.referrer, p(e2) ? (e2 = d(e2), e2 = $(e2), e2.indexOf("https://www.baidu.com/") !== 0 || t2 || (e2 = e2.split("?")[0]), e2 = e2.slice(0, ca.max_referrer_string_length), p(e2) ? e2 : "") : "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e2);
    }
    function xe(e2) {
      return e2 = e2 || document.referrer, e2 === "" || B(q(e2), ga) !== B(null, ga);
    }
    function Ee(e2, t2) {
      e2 = e2 || document.referrer;
      var n2 = ca.source_type.keyword;
      if (document && p(e2)) {
        if (e2.indexOf("http") === 0) {
          var i2 = Le(e2), a2 = V(e2);
          if (oe(a2))
            return ca.preset_properties.search_keyword_baidu && Ie() ? void 0 : "\u672A\u53D6\u5230\u503C";
          var o2 = null;
          for (var s2 in n2)
            if (i2 === s2 && r(a2)) {
              if (o2 = n2[s2], v(o2))
                for (s2 = 0; s2 < o2.length; s2++) {
                  var l2 = a2[o2[s2]];
                  if (l2)
                    return t2 ? { active: l2 } : l2;
                }
              else if (a2[o2])
                return t2 ? { active: a2[o2] } : a2[o2];
            }
          return ca.preset_properties.search_keyword_baidu && Ie() ? void 0 : "\u672A\u53D6\u5230\u503C";
        }
        return e2 === "" ? "\u672A\u53D6\u5230\u503C_\u76F4\u63A5\u6253\u5F00" : "\u672A\u53D6\u5230\u503C_\u975Ehttp\u7684url";
      }
      return "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e2);
    }
    function Le(e2) {
      var t2 = q(e2);
      if (!t2 || t2 === "hostname\u89E3\u6790\u5F02\u5E38")
        return "";
      var r2 = { baidu: [/^.*\.baidu\.com$/], bing: [/^.*\.bing\.com$/], google: [/^www\.google\.com$/, /^www\.google\.com\.[a-z]{2}$/, /^www\.google\.[a-z]{2}$/], sm: [/^m\.sm\.cn$/], so: [/^.+\.so\.com$/], sogou: [/^.*\.sogou\.com$/], yahoo: [/^.*\.yahoo\.com$/] };
      for (var n2 in r2)
        for (var i2 = r2[n2], a2 = 0, o2 = i2.length; a2 < o2; a2++)
          if (i2[a2].test(t2))
            return n2;
      return "\u672A\u77E5\u641C\u7D22\u5F15\u64CE";
    }
    function Ue(e2, t2) {
      var r2 = "";
      if (t2 = t2 || location.href, ca.cross_subdomain === false) {
        try {
          r2 = g(t2).hostname;
        } catch (n2) {
          je(n2);
        }
        r2 = typeof r2 == "string" && r2 !== "" ? "sajssdk_2015_" + ca.sdk_id + e2 + "_" + r2.replace(/\./g, "_") : "sajssdk_2015_root_" + ca.sdk_id + e2;
      } else
        r2 = "sajssdk_2015_cross_" + ca.sdk_id + e2;
      return r2;
    }
    function Re() {
      var e2 = "new_user";
      return ha.isSupport() ? ha.get("sensorsdata_is_new_user") !== null || ha.get(Ue(e2)) !== null : ba.get(ba.getNewUserFlagMemoryKey(e2)) !== null;
    }
    function He(e2, t2, n2) {
      var i2 = !(!r(ca.heatmap) || !ca.heatmap.useCapture);
      return r(ca.heatmap) && h(ca.heatmap.useCapture) && t2 === "click" && (i2 = true), b(e2, t2, n2, i2);
    }
    function Be() {
      function e2(e3, t3) {
        for (var r3 = 0; r3 < e3.length; r3++)
          if (t3.split("?")[0].indexOf(e3[r3]) !== -1)
            return true;
      }
      var t2 = "(" + ca.source_type.utm.join("|") + ")\\=[^&]+", r2 = ca.source_type.search, n2 = ca.source_type.social, i2 = document.referrer || "", a2 = ya.pageProp.url;
      if (a2) {
        var o2 = a2.match(new RegExp(t2));
        return o2 && o2[0] ? "\u4ED8\u8D39\u5E7F\u544A\u6D41\u91CF" : e2(r2, i2) ? "\u81EA\u7136\u641C\u7D22\u6D41\u91CF" : e2(n2, i2) ? "\u793E\u4EA4\u7F51\u7AD9\u6D41\u91CF" : i2 === "" ? "\u76F4\u63A5\u6D41\u91CF" : "\u5F15\u8350\u6D41\u91CF";
      }
      return "\u83B7\u53D6url\u5F02\u5E38";
    }
    function Je(e2) {
      var t2 = F(e2, "gdt_vid"), r2 = F(e2, "hash_key"), n2 = F(e2, "callbacks"), i2 = { click_id: "", hash_key: "", callbacks: "" };
      return p(t2) && t2.length && (i2.click_id = t2.length == 16 || t2.length == 18 ? t2 : "\u53C2\u6570\u89E3\u6790\u4E0D\u5408\u6CD5", p(r2) && r2.length && (i2.hash_key = r2), p(n2) && n2.length && (i2.callbacks = n2)), i2;
    }
    function Me(t2) {
      var n2 = t2.properties, i2 = JSON.parse(JSON.stringify(t2));
      r(n2) && k(n2, function(t3, r2) {
        if (e(t3))
          try {
            n2[r2] = t3(i2), e(n2[r2]) && (Ne("\u60A8\u7684\u5C5E\u6027- " + r2 + " \u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete n2[r2]);
          } catch (a2) {
            delete n2[r2], Ne("\u60A8\u7684\u5C5E\u6027- " + r2 + " \u629B\u51FA\u4E86\u5F02\u5E38\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664");
          }
      });
    }
    function qe(e2) {
      if (r(e2) && e2.$option) {
        var t2 = e2.$option;
        return delete e2.$option, t2;
      }
      return {};
    }
    function Ke(e2) {
      var t2 = {};
      return k(e2, function(e3, r2) {
        e3 != null && (t2[r2] = e3);
      }), t2;
    }
    function Ve(e2) {
      var t2 = !e2.type || e2.type.slice(0, 7) !== "profile", n2 = "\u53D6\u503C\u5F02\u5E38";
      r(e2.properties) && t2 && ("$referrer" in e2.properties && (e2.properties.$referrer_host = e2.properties.$referrer === "" ? "" : q(e2.properties.$referrer, n2)), ca.preset_properties.latest_referrer && ca.preset_properties.latest_referrer_host && (e2.properties.$latest_referrer_host = e2.properties.$latest_referrer === "" ? "" : q(e2.properties.$latest_referrer, n2)));
    }
    function Fe(e2) {
      var t2 = !e2.type || e2.type.slice(0, 7) !== "profile", r2 = ca.preset_properties && t2;
      r2 && ca.preset_properties.url && h(e2.properties.$url) && (e2.properties.$url = Z()), r2 && ca.preset_properties.title && h(e2.properties.$title) && (e2.properties.$title = document.title);
    }
    function ze(e2) {
      if (!_(e2.target))
        return false;
      var t2 = e2.target, r2 = t2.tagName.toLowerCase(), n2 = {};
      return n2.$element_type = r2, n2.$element_name = t2.getAttribute("name"), n2.$element_id = t2.getAttribute("id"), n2.$element_class_name = p(t2.className) ? t2.className : null, n2.$element_target_url = t2.getAttribute("href"), n2.$element_content = Xe(t2, r2), n2 = Ke(n2), n2.$url = Z(), n2.$url_path = G(), n2.$title = document.title, n2;
    }
    function We(t2) {
      var r2 = ca.heatmap && e(ca.heatmap.collect_input) && ca.heatmap.collect_input(t2);
      return t2.type === "button" || t2.type === "submit" || r2 ? t2.value || "" : "";
    }
    function Xe(e2, t2) {
      return p(t2) && t2.toLowerCase() === "input" ? We(e2) : M2(e2, t2);
    }
    function Ze(e2) {
      return va.protocol.ajax(e2.url), C(e2);
    }
    function Ge(e2) {
      if (typeof e2 == "string" && (e2 = d(e2), e2 && (e2.slice(0, 3) === "://" ? e2 = location.protocol.slice(0, -1) + e2 : e2.slice(0, 2) === "//" ? e2 = location.protocol + e2 : e2.slice(0, 4) !== "http" && (e2 = ""))), v(e2) && e2.length)
        for (var t2 = 0; t2 < e2.length; t2++)
          /sa\.gif[^\/]*$/.test(e2[t2]) || (e2[t2] = e2[t2].replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
      else
        /sa\.gif[^\/]*$/.test(e2) || typeof e2 != "string" || (e2 = e2.replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
      return e2;
    }
    function Qe(e2) {
      p(e2) || (e2 = JSON.stringify(e2));
      var t2 = j(e2), r2 = "crc=" + ee(t2);
      return "data=" + encodeURIComponent(t2) + "&ext=" + encodeURIComponent(r2);
    }
    function Ye() {
      this.sendTimeStamp = 0, this.timer = null, this.serverUrl = "", this.hasTabStorage = false;
    }
    function et(e2, t2) {
      for (var r2 in e2)
        if (Object.prototype.hasOwnProperty.call(e2, r2) && !Da.check(r2, e2[r2], t2))
          return false;
      return true;
    }
    function tt(t2, n2) {
      return r(t2) ? (k(t2, function(i2, a2) {
        if (v(i2)) {
          var o2 = [];
          k(i2, function(e2) {
            if (p(e2))
              o2.push(e2);
            else if (h(e2))
              o2.push("null");
            else
              try {
                o2.push(JSON.stringify(e2));
              } catch (t3) {
                Ne("\u60A8\u7684\u6570\u636E-", a2, i2, "\u6570\u7EC4\u91CC\u503C\u6709\u9519\u8BEF,\u5DF2\u5C06\u5176\u5220\u9664");
              }
          }), t2[a2] = o2;
        }
        var s2 = re(n2 || [], a2) > -1;
        if (r(i2) && a2 !== "$option" && !s2)
          try {
            t2[a2] = JSON.stringify(i2);
          } catch (l2) {
            delete t2[a2], Ne("\u60A8\u7684\u6570\u636E-", a2, i2, "\u6570\u636E\u503C\u6709\u9519\u8BEF\uFF0C\u5DF2\u5C06\u5176\u5220\u9664");
          }
        else
          p(i2) || ce(i2) || D(i2) || ae(i2) || v(i2) || e(i2) || a2 === "$option" || s2 || (Ne("\u60A8\u7684\u6570\u636E-", a2, i2, "-\u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete t2[a2]);
      }), t2) : t2;
    }
    function rt(e2, t2) {
      return ce(t2) && e2.length > t2 ? (Ne("\u5B57\u7B26\u4E32\u957F\u5EA6\u8D85\u8FC7\u9650\u5236\uFF0C\u5DF2\u7ECF\u505A\u622A\u53D6--" + e2), e2.slice(0, t2)) : e2;
    }
    function nt(e2, t2) {
      var n2 = ["distinct_id", "user_id", "id", "date", "datetime", "event", "events", "first_id", "original_id", "device_id", "properties", "second_id", "time", "users"];
      r(e2) && k(n2, function(r2, n3) {
        r2 in e2 && (re(t2 || [], r2) > -1 || (n3 < 3 ? (delete e2[r2], Ne("\u60A8\u7684\u5C5E\u6027- " + r2 + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664")) : Ne("\u60A8\u7684\u5C5E\u6027- " + r2 + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u8BF7\u907F\u514D\u5176\u4F5C\u4E3A\u5C5E\u6027\u540D")));
      });
    }
    function it(e2) {
      var t2 = ["$element_selector", "$element_path"], n2 = ["sensorsdata_app_visual_properties"];
      r(e2) && k(e2, function(i2, a2) {
        if (r(i2))
          it(e2[a2]);
        else if (p(i2)) {
          if (re(n2, a2) > -1)
            return;
          e2[a2] = rt(i2, re(t2, a2) > -1 ? 1024 : ca.max_string_length);
        }
      });
    }
    function at(e2) {
      typeof e2.properties.$project != "undefined" && (e2.project = e2.properties.$project, delete e2.properties.$project), typeof e2.properties.$token != "undefined" && (e2.token = e2.properties.$token, delete e2.properties.$token);
    }
    function ot(e2) {
      if ("item_type" in e2) {
        var t2 = e2.item_type, r2 = function(t3) {
          return t3 || delete e2.item_type, true;
        };
        et({ item_type: t2 }, r2);
      }
      if ("item_id" in e2) {
        var n2 = e2.item_id, i2 = function(t3, r3, n3) {
          return t3 || n3 !== "string" || delete e2.item_id, true;
        };
        et({ item_id: n2 }, i2);
      }
    }
    function st(e2, t2) {
      k(e2, function(r2, n2) {
        var i2 = function(t3, r3, i3) {
          return t3 || i3 === "keyLength" || delete e2[n2], true;
        };
        re(t2 || [], n2) === -1 && et({ propertyKey: n2 }, i2);
      });
    }
    function lt(e2) {
      var t2 = e2.properties;
      ye(e2), r(t2) ? (tt(t2), nt(t2), at(e2), st(t2), it(t2)) : "properties" in e2 && (e2.properties = {}), ot(e2);
    }
    function ut2(e2, t2) {
      var r2 = t2.sensors;
      return e2._track_id = Number(String(n()).slice(2, 5) + String(n()).slice(2, 4) + String(new Date().getTime()).slice(-4)), e2._flush_time = new Date().getTime(), r2.events.tempAdd("send", e2), e2;
    }
    function ct(e2, t2) {
      var n2 = t2.sensors, i2 = {};
      r(e2) && r(e2.identities) && !oe(e2.identities) ? P(i2, e2.identities) : P(i2, Ia._state.identities);
      var a2 = { identities: i2, distinct_id: Ia.getDistinctId(), lib: { $lib: "js", $lib_method: "code", $lib_version: String(n2.lib_version) }, properties: {} };
      return r(e2) && r(e2.properties) && !oe(e2.properties) && (e2.properties.$lib_detail && (a2.lib.$lib_detail = e2.properties.$lib_detail, delete e2.properties.$lib_detail), e2.properties.$lib_method && (a2.lib.$lib_method = e2.properties.$lib_method, delete e2.properties.$lib_method)), L(a2, Ia.getUnionId(), e2), r(e2.properties) && !oe(e2.properties) && P(a2.properties, e2.properties), e2.type && e2.type.slice(0, 7) === "profile" || (a2.properties = P({}, ya.properties(), Ia.getProps(), Ia.getSessionProps(), ya.currentProps, a2.properties), n2.para.preset_properties.latest_referrer && !p(a2.properties.$latest_referrer) && (a2.properties.$latest_referrer = "\u53D6\u503C\u5F02\u5E38"), n2.para.preset_properties.latest_search_keyword && !p(a2.properties.$latest_search_keyword) && (n2.para.preset_properties.search_keyword_baidu && p(a2.properties.$search_keyword_id) && ce(a2.properties.$search_keyword_id_hash) && p(a2.properties.$search_keyword_id_type) || (a2.properties.$latest_search_keyword = "\u53D6\u503C\u5F02\u5E38")), n2.para.preset_properties.latest_traffic_source_type && !p(a2.properties.$latest_traffic_source_type) && (a2.properties.$latest_traffic_source_type = "\u53D6\u503C\u5F02\u5E38"), n2.para.preset_properties.latest_landing_page && !p(a2.properties.$latest_landing_page) && (a2.properties.$latest_landing_page = "\u53D6\u503C\u5F02\u5E38"), n2.para.preset_properties.latest_wx_ad_click_id === "not_collect" ? (delete a2.properties._latest_wx_ad_click_id, delete a2.properties._latest_wx_ad_hash_key, delete a2.properties._latest_wx_ad_callbacks) : n2.para.preset_properties.latest_wx_ad_click_id && !p(a2.properties._latest_wx_ad_click_id) && (a2.properties._latest_wx_ad_click_id = "\u53D6\u503C\u5F02\u5E38", a2.properties._latest_wx_ad_hash_key = "\u53D6\u503C\u5F02\u5E38", a2.properties._latest_wx_ad_callbacks = "\u53D6\u503C\u5F02\u5E38"), p(a2.properties._latest_wx_ad_click_id) && (a2.properties.$url = Z())), a2.properties.$time && D(a2.properties.$time) ? (a2.time = 1 * a2.properties.$time, delete a2.properties.$time) : a2.time = 1 * new Date(), function(e3) {
        if (n2.bridge && n2.bridge.bridge_info.verify_success === "success") {
          var t3 = La.customProp.geth5Props(JSON.parse(JSON.stringify(e3)));
          r(t3) && !oe(t3) && (e3.properties = P(e3.properties, t3));
        }
        var i3 = Ha.customProp.getVtrackProps(JSON.parse(JSON.stringify(e3)));
        r(i3) && !oe(i3) && (e3.properties = P(e3.properties, i3));
      }(a2), Me(a2), wa.checkIsAddSign(a2), wa.checkIsFirstTime(a2), Ve(a2), Fe(a2), a2;
    }
    function pt(e2) {
      return Ja.stage.process("basicProps", e2);
    }
    function dt(e2) {
      return Ja.stage.process("formatData", e2);
    }
    function ft(e2, t2, r2, n2) {
      function i2(e3) {
        function i3() {
          o2 || (o2 = true, location.href = a2.href);
        }
        e3.stopPropagation(), e3.preventDefault();
        var o2 = false;
        setTimeout(i3, 1e3), n2(t2, r2, i3);
      }
      e2 = e2 || {};
      var a2 = null;
      return e2.ele && (a2 = e2.ele), e2.event && (a2 = e2.target ? e2.target : e2.event.target), r2 = r2 || {}, !(!a2 || typeof a2 != "object") && (!a2.href || /^javascript/.test(a2.href) || a2.target || a2.download || a2.onclick ? (n2(t2, r2), false) : (e2.event && i2(e2.event), void (e2.ele && He(e2.ele, "click", function(e3) {
        i2(e3);
      }))));
    }
    function gt() {
      var e2 = location.protocol;
      return e2 === "http:" || e2 === "https:" ? e2 : "http:";
    }
    function _t(e2) {
      return qa.stage.process("webClickEvent", e2);
    }
    function ht(e2) {
      return qa.stage.process("webStayEvent", e2);
    }
    function mt() {
      var e2 = ya.campaignParams(), t2 = {};
      return k(e2, function(e3, r2, n2) {
        (" " + Ki.source_channel_standard + " ").indexOf(" " + r2 + " ") !== -1 ? t2["$" + r2] = n2[r2] : t2[r2] = n2[r2];
      }), t2;
    }
    function vt(e2, t2, r2) {
      if (Ki.is_first_visitor && r2) {
        var n2 = {};
        Ki.para.preset_properties.search_keyword_baidu && xe(document.referrer) && Ie() && (n2.$search_keyword_id = ma.id(), n2.$search_keyword_id_type = ma.type(), n2.$search_keyword_id_hash = te(n2.$search_keyword_id));
        var i2 = De(null, t2);
        e2(P({ $first_visit_time: new Date(), $first_referrer: i2, $first_referrer_host: i2 ? q(i2, "\u53D6\u503C\u5F02\u5E38") : "", $first_browser_language: p(navigator.language) ? navigator.language.toLowerCase() : "\u53D6\u503C\u5F02\u5E38", $first_browser_charset: p(document.charset) ? document.charset.toUpperCase() : "\u53D6\u503C\u5F02\u5E38", $first_traffic_source_type: Be(), $first_search_keyword: Ee() }, mt(), n2)), Ki.is_first_visitor = false;
      }
    }
    function yt(t2) {
      var r2 = location.href, n2 = window.history.pushState, i2 = window.history.replaceState;
      e(window.history.pushState) && (window.history.pushState = function() {
        n2.apply(window.history, arguments), t2(r2), r2 = location.href;
      }), e(window.history.replaceState) && (window.history.replaceState = function() {
        i2.apply(window.history, arguments), t2(r2), r2 = location.href;
      });
      var a2;
      a2 = window.document.documentMode ? "hashchange" : n2 ? "popstate" : "hashchange", b(window, a2, function() {
        t2(r2), r2 = location.href;
      });
    }
    function bt(e2, t2) {
      var r2 = [];
      typeof e2 == "string" && e2 in Xa.EVENT_LIST && (r2 = Xa.EVENT_LIST[e2], Xa[r2[0]].on(r2[1], t2));
    }
    function wt(e2, t2) {
      var n2 = e2.id, i2 = e2.callback, a2 = e2.name, o2 = Ia.getFirstId(), s2 = Ia.getOriginDistinctId();
      if (!et({ distinct_id: n2 }))
        return je("login id is invalid"), false;
      if (n2 === Ia.getOriginDistinctId() && !o2)
        return je("login id is equal to distinct_id"), false;
      if (r(Ia._state.identities) && Ia._state.identities.hasOwnProperty(a2) && n2 === Ia._state.first_id)
        return false;
      var l2 = Ia._state.history_login_id.name !== a2 || n2 !== Ia._state.history_login_id.value;
      if (l2) {
        Ia._state.identities[a2] = n2, Ia.set("history_login_id", { name: a2, value: n2 }), o2 || Ia.set("first_id", s2), t2(n2, "$SignUp", {}, i2);
        var u2 = { $identity_cookie_id: Ia._state.identities.$identity_cookie_id };
        return u2[a2] = n2, St(u2), true;
      }
      return false;
    }
    function St(e2) {
      var t2 = {};
      for (var r2 in e2)
        t2[r2] = e2[r2];
      Ia._state.identities = t2, Ia.save();
    }
    function kt(e2, t2) {
      if (!et({ unbindKey: e2, bindValue: t2 }))
        return false;
      if (r(Ia._state.identities) && Ia._state.identities.hasOwnProperty(e2) && Ia._state.identities[e2] === t2) {
        var n2 = Ia.getUnionId().login_id;
        n2 && e2 + "+" + t2 === n2 && (Ia._state.distinct_id = Ia._state.first_id, Ia._state.first_id = "", Ia.set("history_login_id", { name: "", value: "" })), e2 !== "$identity_cookie_id" && (delete Ia._state.identities[e2], Ia.save());
      }
      var i2 = {};
      return i2[e2] = t2, i2;
    }
    function Pt() {
      Ki._t = Ki._t || 1 * new Date(), Ki.is_first_visitor = false, Ki.source_channel_standard = da;
    }
    function Ct(e2) {
      P(ca, e2 || Ki.para || {}), Ki.para = ca;
      var t2 = {};
      if (r(Ki.para.is_track_latest))
        for (var n2 in Ki.para.is_track_latest)
          t2["latest_" + n2] = Ki.para.is_track_latest[n2];
      Ki.para.preset_properties = P({}, pa.preset_properties, t2, Ki.para.preset_properties || {});
      var i2;
      for (i2 in pa)
        Ki.para[i2] === void 0 && (Ki.para[i2] = pa[i2]);
      typeof Ki.para.web_url != "string" || Ki.para.web_url.slice(0, 3) !== "://" && Ki.para.web_url.slice(0, 2) !== "//" || (Ki.para.web_url.slice(0, 3) === "://" ? Ki.para.web_url = location.protocol.slice(0, -1) + Ki.para.web_url : Ki.para.web_url = location.protocol + Ki.para.web_url), va.protocol.serverUrl(), Ki.bridge && Ki.bridge.initPara();
      var a2 = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"], o2 = ["www.baidu.", "m.baidu.", "m.sm.cn", "so.com", "sogou.com", "youdao.com", "google.", "yahoo.com/", "bing.com/", "ask.com/"], s2 = ["weibo.com", "renren.com", "kaixin001.com", "douban.com", "qzone.qq.com", "zhihu.com", "tieba.baidu.com", "weixin.qq.com"], l2 = { baidu: ["wd", "word", "kw", "keyword"], google: "q", bing: "q", yahoo: "p", sogou: ["query", "keyword"], so: "q", sm: "q" };
      typeof Ki.para.source_type == "object" && (Ki.para.source_type.utm = v(Ki.para.source_type.utm) ? Ki.para.source_type.utm.concat(a2) : a2, Ki.para.source_type.search = v(Ki.para.source_type.search) ? Ki.para.source_type.search.concat(o2) : o2, Ki.para.source_type.social = v(Ki.para.source_type.social) ? Ki.para.source_type.social.concat(s2) : s2, Ki.para.source_type.keyword = r(Ki.para.source_type.keyword) ? P(l2, Ki.para.source_type.keyword) : l2);
      var u2 = { div: false }, c2 = ["mark", "/mark", "strong", "b", "em", "i", "u", "abbr", "ins", "del", "s", "sup"];
      if (Ki.para.heatmap && !r(Ki.para.heatmap) && (Ki.para.heatmap = {}), r(Ki.para.heatmap)) {
        Ki.para.heatmap.clickmap = Ki.para.heatmap.clickmap || "default", Ki.para.heatmap.scroll_notice_map = Ki.para.heatmap.scroll_notice_map || "default", Ki.para.heatmap.scroll_delay_time = Ki.para.heatmap.scroll_delay_time || 4e3, Ki.para.heatmap.scroll_event_duration = Ki.para.heatmap.scroll_event_duration || 18e3, Ki.para.heatmap.renderRefreshTime = Ki.para.heatmap.renderRefreshTime || 1e3, Ki.para.heatmap.loadTimeout = Ki.para.heatmap.loadTimeout || 1e3, Ki.para.heatmap.get_vtrack_config !== true && (Ki.para.heatmap.get_vtrack_config = false);
        var p2 = v(Ki.para.heatmap.track_attr) ? U(Ki.para.heatmap.track_attr, function(e3) {
          return e3 && typeof e3 == "string";
        }) : [];
        if (p2.push("data-sensors-click"), Ki.para.heatmap.track_attr = p2, r(Ki.para.heatmap.collect_tags))
          if (Ki.para.heatmap.collect_tags.div === true)
            Ki.para.heatmap.collect_tags.div = { ignore_tags: c2, max_level: 1 };
          else if (r(Ki.para.heatmap.collect_tags.div)) {
            if (Ki.para.heatmap.collect_tags.div.ignore_tags ? v(Ki.para.heatmap.collect_tags.div.ignore_tags) || (Ne("ignore_tags \u53C2\u6570\u5FC5\u987B\u662F\u6570\u7EC4\u683C\u5F0F"), Ki.para.heatmap.collect_tags.div.ignore_tags = c2) : Ki.para.heatmap.collect_tags.div.ignore_tags = c2, Ki.para.heatmap.collect_tags.div.max_level) {
              var d2 = [1, 2, 3];
              re(d2, Ki.para.heatmap.collect_tags.div.max_level) === -1 && (Ki.para.heatmap.collect_tags.div.max_level = 1);
            }
          } else
            Ki.para.heatmap.collect_tags.div = false;
        else
          Ki.para.heatmap.collect_tags = u2;
      }
      Ki.para.server_url = Ge(Ki.para.server_url), Ki.para.noCache === true ? Ki.para.noCache = "?" + new Date().getTime() : Ki.para.noCache = "", Ki.para.callback_timeout > Ki.para.datasend_timeout && (Ki.para.datasend_timeout = Ki.para.callback_timeout), Ki.para.heatmap && Ki.para.heatmap.collect_tags && r(Ki.para.heatmap.collect_tags) && k(Ki.para.heatmap.collect_tags, function(e3, t3) {
        t3 !== "div" && e3 && Ki.heatmap.otherTags.push(t3);
      }), Ki.para.heatmap && Ki.para.heatmap.clickmap === "default" && Ki.heatmap.initUnlimitedTags();
    }
    function Ot() {
      var e2 = Array.prototype.slice.call(arguments), t2 = e2[0], r2 = e2.slice(1);
      return typeof t2 == "string" && Fa[t2] ? Fa[t2].apply(Fa, r2) : void (typeof t2 == "function" ? t2.apply(Ki, r2) : Ne("quick\u65B9\u6CD5\u4E2D\u6CA1\u6709\u8FD9\u4E2A\u529F\u80FD" + e2[0]));
    }
    function Nt(t2, n2) {
      function i2() {
        return !a2.plugin_is_init && a2.init(Ki, n2), a2.plugin_is_init = true, Ki.modules = Ki.modules || {}, Ki.modules[a2.plugin_name || "unnamed_" + Ga++] = a2, a2;
      }
      if (!p(t2) && !r(t2))
        return void je("use's first arguments must be string or object.");
      var a2;
      if (r(t2)) {
        var o2 = Ki.modules && Ki.modules[t2.plugin_name];
        o2 && o2 !== t2 && Ne(t2.name + " is conflict with builtin plugin, and sdk uses builtin plugin."), a2 = o2 || t2;
      }
      return p(t2) && (r(Ki.modules) && r(Ki.modules[t2]) ? a2 = Ki.modules[t2] : r(window.SensorsDataWebJSSDKPlugin) && r(window.SensorsDataWebJSSDKPlugin[t2]) ? a2 = window.SensorsDataWebJSSDKPlugin[t2] : window.sensorsDataAnalytic201505 && window.sensorsDataAnalytic201505.modules[t2] && (a2 = window.sensorsDataAnalytic201505.modules[t2])), a2 && e(a2.init) ? a2.plugin_is_init ? a2 : (a2.plugin_name || Ne("warning: invalid plugin, plugin_name required."), a2.plugin_version ? a2.plugin_version !== Ki.lib_version && Ne("warning: plugin version not match SDK version. plugin may not work correctly. ") : Ne("warning: invalid plugin, plugin version required."), i2()) : (Ne((t2.plugin_name || t2) + " is not found or it's not a standard plugin. Please check sensorsdata official documents."), a2);
    }
    function jt(e2, t2, r2) {
      et({ event: e2, properties: t2 }) && Ma.send({ type: "track", event: e2, properties: t2 }, r2);
    }
    function Tt(e2, t2) {
      return !!et({ bindKey: e2, bindValue: t2 }) && (Ia._state.identities[e2] = t2, Ia.save(), void Ma.send({ type: "track_id_bind", event: "$BindID", properties: {} }));
    }
    function It(e2, t2) {
      var r2 = kt(e2, t2);
      r2 && Ma.send({ identities: r2, type: "track_id_unbind", event: "$UnbindID", properties: {} });
    }
    function $t(e2, t2, r2) {
      typeof e2 == "object" && e2.tagName ? ft({ ele: e2 }, t2, r2, Ki.track) : typeof e2 == "object" && e2.target && e2.event && ft(e2, t2, r2, Ki.track);
    }
    function At(e2, t2, r2) {
      return r2 = r2 || {}, !(!e2 || typeof e2 != "object") && (!(!e2.href || /^javascript/.test(e2.href) || e2.target) && void He(e2, "click", function(n2) {
        function i2() {
          a2 || (a2 = true, location.href = e2.href);
        }
        n2.preventDefault();
        var a2 = false;
        setTimeout(i2, 1e3), Ki.track(t2, r2, i2);
      }));
    }
    function Dt(e2, t2, r2) {
      et({ item_type: e2, item_id: t2, properties: r2 }) && Ma.sendItem({ type: "item_set", item_type: e2, item_id: t2, properties: r2 || {} });
    }
    function xt(e2, t2) {
      et({ item_type: e2, item_id: t2 }) && Ma.sendItem({ type: "item_delete", item_type: e2, item_id: t2 });
    }
    function Et(e2, t2) {
      et({ propertiesMust: e2 }) && Ma.send({ type: "profile_set", properties: e2 }, t2);
    }
    function Lt(e2, t2) {
      et({ propertiesMust: e2 }) && Ma.send({ type: "profile_set_once", properties: e2 }, t2);
    }
    function Ut(e2, t2) {
      et({ propertiesMust: e2 }) && (k(e2, function(t3, r2) {
        p(t3) ? e2[r2] = [t3] : v(t3) ? e2[r2] = t3 : (delete e2[r2], Ne("appendProfile\u5C5E\u6027\u7684\u503C\u5FC5\u987B\u662F\u5B57\u7B26\u4E32\u6216\u8005\u6570\u7EC4"));
      }), oe(e2) || Ma.send({ type: "profile_append", properties: e2 }, t2));
    }
    function Rt(e2, t2) {
      function r2(e3) {
        for (var t3 in e3)
          if (Object.prototype.hasOwnProperty.call(e3, t3) && !/-*\d+/.test(String(e3[t3])))
            return false;
        return true;
      }
      var n2 = e2;
      p(e2) && (e2 = {}, e2[n2] = 1), et({ propertiesMust: e2 }) && (r2(e2) ? Ma.send({ type: "profile_increment", properties: e2 }, t2) : je("profile_increment\u7684\u503C\u53EA\u80FD\u662F\u6570\u5B57"));
    }
    function Ht(e2) {
      Ma.send({ type: "profile_delete" }, e2), Ia.set("distinct_id", Xi()), Ia.set("first_id", "");
    }
    function Bt(e2, t2) {
      var r2 = e2, n2 = {};
      p(e2) && (e2 = [], e2.push(r2)), v(e2) ? (k(e2, function(e3) {
        p(e3) ? n2[e3] = true : Ne("profile_unset\u7ED9\u7684\u6570\u7EC4\u91CC\u9762\u7684\u503C\u5FC5\u987B\u65F6string,\u5DF2\u7ECF\u8FC7\u6EE4\u6389", e3);
      }), Ma.send({ type: "profile_unset", properties: n2 }, t2)) : je("profile_unset\u7684\u53C2\u6570\u5FC5\u987B\u662F\u6570\u7EC4");
    }
    function Jt(e2, t2) {
      typeof e2 == "number" && (e2 = String(e2));
      var r2 = Ia.getFirstId();
      if (typeof e2 == "undefined") {
        var n2 = Xi();
        r2 ? Ia.set("first_id", n2) : Ia.set("distinct_id", n2);
      } else
        et({ distinct_id: e2 }) && (t2 === true ? r2 ? Ia.set("first_id", e2) : Ia.set("distinct_id", e2) : r2 ? Ia.change("first_id", e2) : Ia.change("distinct_id", e2));
    }
    function Mt(e2, t2, r2, n2) {
      var i2 = Ia.getFirstId() || Ia.getDistinctId();
      Ia.set("distinct_id", e2), Ma.send({ original_id: i2, distinct_id: Ia.getDistinctId(), type: "track_signup", event: t2, properties: r2 }, n2);
    }
    function qt(e2, t2, r2, n2) {
      typeof e2 == "number" && (e2 = String(e2)), et({ distinct_id: e2, event: t2, properties: r2 }) && Mt(e2, t2, r2, n2);
    }
    function Kt(e2) {
      et({ properties: e2 }) ? P(ya.currentProps, e2) : je("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Vt(e2) {
      Ia.clearAllProps(e2);
    }
    function Ft(e2) {
      var t2;
      if (v(e2) && e2.length > 0)
        for (t2 = 0; t2 < e2.length; t2++)
          p(e2[t2]) && e2[t2] in ya.currentProps && delete ya.currentProps[e2[t2]];
      else if (e2 === true)
        for (t2 in ya.currentProps)
          delete ya.currentProps[t2];
    }
    function zt(e2) {
      et({ properties: e2 }) ? Ia.setProps(e2) : je("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Wt(e2) {
      et({ properties: e2 }) ? Ia.setPropsOnce(e2) : je("registerOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Xt(e2) {
      Ki.log("registerSession \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u6709\u95EE\u9898\u8054\u7CFB\u6280\u672F\u987E\u95EE"), et({ properties: e2 }) ? Ia.setSessionProps(e2) : je("registerSession\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Zt(e2) {
      Ki.log("registerSessionOnce \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u6709\u95EE\u9898\u8054\u7CFB\u6280\u672F\u987E\u95EE"), et({ properties: e2 }) ? Ia.setSessionPropsOnce(e2) : je("registerSessionOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Gt(t2, r2) {
      typeof t2 == "number" && (t2 = String(t2));
      var n2 = wt({ id: t2, callback: r2, name: _a2.LOGIN }, Mt);
      !n2 && e(r2) && r2();
    }
    function Qt(e2, t2) {
      return typeof t2 == "number" && (t2 = String(t2)), typeof e2 == "number" && (e2 = String(e2)), !!et({ loginIdKey: e2 }) && (_a2.LOGIN === e2 ? (Gt(t2), false) : void wt({ id: t2, callback: null, name: e2 }, Mt));
    }
    function Yt(e2) {
      var t2 = Ia.getFirstId();
      if (t2)
        if (Ia.set("first_id", ""), e2 === true) {
          var r2 = Xi();
          Ia.set("distinct_id", r2);
        } else
          Ia.set("distinct_id", t2);
      St({ $identity_cookie_id: Ia._state.identities.$identity_cookie_id }), Ia.set("history_login_id", { name: "", value: "" });
    }
    function er() {
      function e2() {
        var e3 = ya.campaignParams(), t3 = {};
        return k(e3, function(e4, r3, n2) {
          (" " + Ki.source_channel_standard + " ").indexOf(" " + r3 + " ") !== -1 ? t3["$" + r3] = n2[r3] : t3[r3] = n2[r3];
        }), t3;
      }
      var t2 = { $is_first_day: Re(), $is_first_time: wa.is_page_first_visited, $referrer: ya.pageProp.referrer || "", $referrer_host: ya.pageProp.referrer ? q(ya.pageProp.referrer) : "", $url: Z(), $url_path: G(), $title: document.title || "", _distinct_id: Ia.getDistinctId(), identities: JSON.parse(JSON.stringify(Ia._state.identities)) }, r2 = P({}, ya.properties(), Ia.getProps(), e2(), t2);
      return Ki.para.preset_properties.latest_referrer && Ki.para.preset_properties.latest_referrer_host && (r2.$latest_referrer_host = r2.$latest_referrer === "" ? "" : q(r2.$latest_referrer)), r2;
    }
    function tr() {
      var e2 = "", t2 = " { cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); }";
      Ki.heatmap && v(Ki.heatmap.otherTags) && k(Ki.heatmap.otherTags, function(r2) {
        e2 += r2 + t2;
      }), le() && K() && K() < 13 && (Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div && be("div, [data-sensors-click]" + t2), Ki.para.heatmap && Ki.para.heatmap.track_attr && be("[" + Ki.para.heatmap.track_attr.join("], [") + "]" + t2), e2 !== "" && be(e2));
    }
    function rr(e2) {
      var t2 = this;
      this.type = e2, this.resultCbs = {}, this.timeoutCbs = {}, this.timerId = null, this.appCallJsCallback = null, window.sensorsdata_app_call_js || (window.sensorsdata_app_call_js = function(e3, t3) {
        if (e3 in window.sensorsdata_app_call_js.modules)
          return window.sensorsdata_app_call_js.modules[e3](t3);
      }), window.sensorsdata_app_call_js.modules = window.sensorsdata_app_call_js.modules || {}, window.sensorsdata_app_call_js.modules[this.type] = function(e3) {
        try {
          var r2 = N(e3) || e3;
          try {
            r2 = JSON.parse(r2);
          } catch (n2) {
          }
          var i2 = r2 && r2.message_id;
          if (i2 && t2.resultCbs[i2]) {
            if (e3 = r2, t2.timeoutCbs[i2] && t2.timeoutCbs[i2].isTimeout)
              return void (t2.resultCbs[i2].callbacks.length = 0);
            if (t2.resultCbs[i2]) {
              t2.resultCbs[i2].result = e3, clearTimeout(t2.timerId), t2.timeoutCbs[i2].callbacks.length = 0;
              for (var a2 in t2.resultCbs[i2].callbacks)
                t2.resultCbs[i2].callbacks[a2].call(null, e3), t2.resultCbs[i2].callbacks.splice(a2, 1);
            }
            return;
          }
          return t2.appCallJsCallback && t2.appCallJsCallback.call(null, e3);
        } catch (o2) {
          je("app \u56DE\u8C03 js \u5F02\u5E38", e3);
        }
      };
    }
    function nr(t2) {
      try {
        if (Ki.bridge.activeBridge && e(Ki.bridge.activeBridge.handleCommand))
          return Ki.bridge.activeBridge.handleCommand(t2);
      } catch (r2) {
        je("Error: handle command exception:" + r2);
      }
      return je("\u6570\u636E\u53D1\u5F80App\u5931\u8D25\uFF0CApp\u6CA1\u6709\u66B4\u9732bridge,type:" + t2.callType), false;
    }
    function ir(e2) {
      function t2(e3) {
        var t3 = { hostname: "", project: "" };
        try {
          e3 = g(e3), t3.hostname = e3.hostname, t3.project = e3.searchParams.get("project") || "default";
        } catch (r3) {
          je("validateAppUrl:" + r3);
        }
        return t3;
      }
      var r2 = t2(e2), n2 = t2(Ki.para.server_url);
      if (r2.hostname === n2.hostname && r2.project === n2.project)
        return true;
      if (v(Ki.para.app_js_bridge.white_list))
        for (var i2 = 0; i2 < Ki.para.app_js_bridge.white_list.length; i2++) {
          var a2 = t2(Ki.para.app_js_bridge.white_list[i2]);
          if (a2.hostname === r2.hostname && a2.project === r2.project)
            return true;
        }
      return false;
    }
    function ar(e2) {
      this.bridge = new rr(e2.type);
    }
    function or() {
      var e2 = ya.pageProp.url_domain, t2 = {};
      e2 === "" && (e2 = "url\u89E3\u6790\u5931\u8D25");
      var n2 = Ee(document.referrer, true);
      if (ca.preset_properties.search_keyword_baidu ? xe(document.referrer) && (!Ie() || r(n2) && n2.active ? Ia._state && Ia._state.props && (Ia._state.props.$search_keyword_id && delete Ia._state.props.$search_keyword_id, Ia._state.props.$search_keyword_id_type && delete Ia._state.props.$search_keyword_id_type, Ia._state.props.$search_keyword_id_hash && delete Ia._state.props.$search_keyword_id_hash) : (t2.$search_keyword_id = ma.id(), t2.$search_keyword_id_type = ma.type(), t2.$search_keyword_id_hash = te(t2.$search_keyword_id))) : Ia._state && Ia._state.props && (Ia._state.props.$search_keyword_id && delete Ia._state.props.$search_keyword_id, Ia._state.props.$search_keyword_id_type && delete Ia._state.props.$search_keyword_id_type, Ia._state.props.$search_keyword_id_hash && delete Ia._state.props.$search_keyword_id_hash), Ia.save(), k(ca.preset_properties, function(n3, i3) {
        if (i3.indexOf("latest_") === -1)
          return false;
        if (i3 = i3.slice(7), n3) {
          if (i3 === "wx_ad_click_id" && n3 === "not_collect")
            return false;
          if (i3 !== "utm" && e2 === "url\u89E3\u6790\u5931\u8D25")
            i3 === "wx_ad_click_id" ? (t2._latest_wx_ad_click_id = "url\u7684domain\u89E3\u6790\u5931\u8D25", t2._latest_wx_ad_hash_key = "url\u7684domain\u89E3\u6790\u5931\u8D25", t2._latest_wx_ad_callbacks = "url\u7684domain\u89E3\u6790\u5931\u8D25") : t2["$latest_" + i3] = "url\u7684domain\u89E3\u6790\u5931\u8D25";
          else if (xe(document.referrer))
            switch (i3) {
              case "traffic_source_type":
                t2.$latest_traffic_source_type = Be();
                break;
              case "referrer":
                t2.$latest_referrer = ya.pageProp.referrer;
                break;
              case "search_keyword":
                Ee() ? t2.$latest_search_keyword = Ee() : r(Ia._state) && r(Ia._state.props) && Ia._state.props.$latest_search_keyword && delete Ia._state.props.$latest_search_keyword;
                break;
              case "landing_page":
                t2.$latest_landing_page = Z();
                break;
              case "wx_ad_click_id":
                var a3 = Je(location.href);
                t2._latest_wx_ad_click_id = a3.click_id, t2._latest_wx_ad_hash_key = a3.hash_key, t2._latest_wx_ad_callbacks = a3.callbacks;
            }
        } else if (i3 === "utm" && Ia._state && Ia._state.props)
          for (var o3 in Ia._state.props)
            (o3.indexOf("$latest_utm") === 0 || o3.indexOf("_latest_") === 0 && o3.indexOf("_latest_wx_ad_") < 0) && delete Ia._state.props[o3];
        else if (Ia._state && Ia._state.props && "$latest_" + i3 in Ia._state.props)
          delete Ia._state.props["$latest_" + i3];
        else if (i3 == "wx_ad_click_id" && Ia._state && Ia._state.props && n3 === false) {
          var s2 = ["_latest_wx_ad_click_id", "_latest_wx_ad_hash_key", "_latest_wx_ad_callbacks"];
          k(s2, function(e3) {
            e3 in Ia._state.props && delete Ia._state.props[e3];
          });
        }
      }), ca.preset_properties.latest_utm) {
        var i2 = ya.campaignParamsStandard("$latest_", "_latest_"), a2 = i2.$utms, o2 = i2.otherUtms;
        oe(a2) || P(t2, a2), oe(o2) || P(t2, o2);
      }
      zt(t2);
    }
    function sr(e2) {
      var t2 = null;
      try {
        var r2 = JSON.parse(window.name);
        t2 = r2[e2] ? u(r2[e2]) : null;
      } catch (n2) {
        t2 = null;
      }
      return t2 === null && (t2 = F(location.href, e2) || null), t2;
    }
    function lr(e2) {
      function t2() {
        var e3 = [];
        n2.touch_app_bridge || e3.push(va.defineMode("1")), r(Ki.para.app_js_bridge) || (e3.push(va.defineMode("2")), n2.verify_success = false), r(Ki.para.heatmap) && Ki.para.heatmap.clickmap == "default" || e3.push(va.defineMode("3")), n2.verify_success === "fail" && e3.push(va.defineMode("4")), new Ki.SDKJSBridge("app_alert").notifyApp({ data: e3 });
      }
      var n2 = Ki.bridge.bridge_info;
      if (Ki.bridge.hasVisualModeBridge())
        if (r(Ki.para.heatmap) && Ki.para.heatmap.clickmap == "default")
          if (r(Ki.para.app_js_bridge) && n2.verify_success === "success")
            if (e2)
              window.sa_jssdk_app_define_mode(Ki, e2);
            else {
              var i2 = location.protocol, a2 = ["http:", "https:"];
              i2 = re(a2, i2) > -1 ? i2 : "https:", _e({ success: function() {
                setTimeout(function() {
                  typeof sa_jssdk_app_define_mode != "undefined" && window.sa_jssdk_app_define_mode(Ki, e2);
                }, 0);
              }, error: function() {
              }, type: "js", url: i2 + "//static.sensorsdata.cn/sdk/" + Ki.lib_version + "/vapph5define.min.js" });
            }
          else
            t2();
        else
          t2();
    }
    function ur(t2) {
      Ki.para.is_track_single_page && za.on("switch", function(n2) {
        var i2 = function(r2) {
          if (r2 = r2 || {}, n2 !== location.href) {
            ya.pageProp.referrer = Z(n2);
            var i3 = P({ $url: Z(), $referrer: Z(n2) }, r2);
            e(t2) ? t2(i3) : Ki.quick && Ki.quick("autoTrack", i3);
          }
        };
        if (typeof Ki.para.is_track_single_page == "boolean")
          i2();
        else if (typeof Ki.para.is_track_single_page == "function") {
          var a2 = Ki.para.is_track_single_page();
          r(a2) ? i2(a2) : a2 === true && i2();
        }
      });
    }
    function cr() {
      Ki._q && v(Ki._q) && Ki._q.length > 0 && k(Ki._q, function(e2) {
        Ki[e2[0]].apply(Ki, Array.prototype.slice.call(e2[1]));
      }), r(Ki.para.heatmap) && (Va.initHeatmap(), Va.initScrollmap());
    }
    function pr() {
      Ki.readyState.setState(3), new Ki.SDKJSBridge("visualized").onAppNotify(function() {
        lr(typeof sa_jssdk_app_define_mode != "undefined" ? true : false);
      }), lr(false), Ki.bridge.app_js_bridge_v1(), ya.initPage(), ur(), Ia.init(), or(), fr(), Ki.readyState.setState(4), cr();
    }
    function dr() {
      to.isSeachHasKeyword() ? to.hasKeywordHandle() : window.parent !== self && ro.isSearchHasKeyword() ? ro.verifyVtrackMode() : to.isWindowNameHasKeyword() ? to.windowNameHasKeywordHandle() : to.isStorageHasKeyword() ? to.storageHasKeywordHandle() : window.parent !== self && ro.isStorageHasKeyword() ? ro.verifyVtrackMode() : (pr(), ro.notifyUser());
    }
    function fr() {
      Ha.init(), Ki.bridge.bridge_info.verify_success === "success" && La.init();
    }
    function gr() {
      k(no, function(t2) {
        var r2 = Ki[t2];
        Ki[t2] = function() {
          if (Ki.readyState.state < 3)
            return v(Ki._q) || (Ki._q = []), Ki._q.push([t2, arguments]), false;
          if (!e(Ki.getDisabled) || !Ki.getDisabled())
            return Ki.readyState.getState() ? r2.apply(Ki, arguments) : void je("\u8BF7\u5148\u521D\u59CB\u5316\u795E\u7B56JS SDK");
        };
      });
    }
    function _r(e2, t2) {
      this.cancel = function() {
        e2 = true;
      }, this.getCanceled = function() {
        return e2 || false;
      }, this.stop = function() {
        t2 = true;
      }, this.getStopped = function() {
        return t2 || false;
      };
    }
    function hr(e2, t2, r2) {
      var n2 = null;
      try {
        n2 = JSON.parse(JSON.stringify(e2 || null));
      } catch (i2) {
      }
      this.getOriginalData = function() {
        return n2;
      }, this.getPosition = function() {
        return t2;
      }, this.cancellationToken = new _r(), this.sensors = r2;
    }
    function mr(e2) {
      if (!r(e2))
        throw "error: Stage constructor requires arguments.";
      this.processDef = e2, this.registeredInterceptors = {};
    }
    function vr(e2) {
      e2 && e2.buildDataStage && oo.registerStageImplementation(e2.buildDataStage), e2 && e2.businessStage && co.registerStageImplementation(e2.businessStage), e2 && e2.sendDataStage && lo.registerStageImplementation(e2.sendDataStage), e2 && e2.viewStage && fo.registerStageImplementation(e2.viewStage);
    }
    function yr(e2, t2) {
      go2[e2] && go2[e2](t2);
    }
    function br() {
      return _o.stage && _o.stage.process("getUtmData");
    }
    function wr(e2) {
      return ho.stage.process("send", e2);
    }
    function Sr(e2) {
      e2.kit = mo, e2.saEvent = Ma, this.buildDataStage = Ja, this.sendDataStage = ho, this.businessStage = _o;
    }
    function kr(e2) {
      e2.heatmap = Va, this.viewStage = qa;
    }
    function Pr(e2) {
      e2 && (Ki.events = Ta, Ki.bridge = eo, Ki.SDKJSBridge = rr, Ki.JSBridge = ar, Ki.store = Ia, Ki.unlimitedDiv = Ua, Ki.customProp = Ra, Ki.vtrackcollect = Ha, Ki.vapph5collect = La, Ki.detectMode = dr, Ki.registerFeature = vr, Ki.registerInterceptor = yr, Ki.commonWays = Fa, vr(new Sr(Ki)), vr(new kr(Ki)), yr("viewStage", vo));
      var t2 = e2 ? Qa : io;
      for (var r2 in t2)
        Ki[r2] = t2[r2];
      Ki.logger = ua2, Ki.log = Oe, Ki._ = Ya, Ki.on = bt, Ki.ee = Xa, Ki.use = Nt, Ki.lib_version = fa;
    }
    function Cr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Or(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Or(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Nr(e2, t2, r2) {
      return Cr(e2, t2, r2), e2.plugin_version = Ho, e2;
    }
    function jr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Tr(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Tr(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Ir(e2, t2, r2) {
      return jr(e2, t2, r2), e2.plugin_version = Mo, e2;
    }
    function $r(e2) {
      return zo && zo.call(Vo, JSON.stringify(e2));
    }
    function Ar(e2) {
      return Fo.call(Vo) && Wo && Wo.call(Vo, JSON.stringify(e2));
    }
    function Dr(e2, t2) {
      return t2 && typeof t2[e2.callType] == "function" && t2[e2.callType]();
    }
    function xr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Er(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Er(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Lr(e2, t2, r2) {
      return xr(e2, t2, r2), e2.plugin_version = Zo, e2;
    }
    function Ur() {
      if (wo = window.SensorsData_APP_New_H5_Bridge, So = wo && wo.sensorsdata_track, ko = So && wo.sensorsdata_get_server_url && wo.sensorsdata_get_server_url(), Po && !Po.bridge.activeBridge && ko) {
        if (Po.bridge.activeBridge = Go, Po.para.app_js_bridge && !Po.para.app_js_bridge.is_mui && (Po.bridge.is_verify_success = ko && Po.bridge.validateAppUrl(ko)), Po.bridge.bridge_info = { touch_app_bridge: true, platform: "android", verify_success: Po.bridge.is_verify_success ? "success" : "fail", support_two_way_call: !!wo.sensorsdata_js_call_app }, !Po.para.app_js_bridge)
          return void Oo("app_js_bridge is not configured, data will not be sent by android bridge.");
        Po.registerInterceptor("sendDataStage", { send: { priority: 60, entry: Rr } }), Oo("Android bridge inits succeed.");
      }
    }
    function Rr(e2, t2) {
      if (Po.para.app_js_bridge.is_mui || e2.data.type === "item_set" || e2.data.type === "item_delete")
        return e2;
      var r2 = e2.callback;
      return Po.bridge.is_verify_success ? (So && So.call(wo, JSON.stringify(Co.extend({ server_url: Po.para.server_url }, e2.data))), Co.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2) : Po.para.app_js_bridge.is_send ? (Po.debug.apph5({ data: e2.data, step: "4.2", output: "all" }), e2) : (Co.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2);
    }
    function Hr(e2) {
      var t2 = e2.callType;
      return t2 in Xo.commands ? Xo.commands[t2](e2, wo) : void (wo && Co.isFunction(wo.sensorsdata_js_call_app) && wo.sensorsdata_js_call_app(JSON.stringify(e2)));
    }
    function Br(e2) {
      return ts && ts.call(Yo, JSON.stringify(e2));
    }
    function Jr(e2) {
      return es.call(Yo) && rs && rs.call(Yo, JSON.stringify(e2));
    }
    function Mr(e2, t2) {
      return t2 && typeof t2[e2.callType] == "function" && t2[e2.callType]();
    }
    function qr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Kr(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Kr(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Vr(e2, t2, r2) {
      return qr(e2, t2, r2), e2.plugin_version = is, e2;
    }
    function Fr() {
      if (No = window.SensorsData_APP_JS_Bridge, jo = No && No.sensorsdata_track, To = No && No.sensorsdata_verify, Io = No && No.sensorsdata_visual_verify, $o && !$o.bridge.activeBridge && (To || jo || Io)) {
        $o.bridge.activeBridge = as;
        var e2 = To || jo;
        if (Io && (e2 = !!Io.call(No, JSON.stringify({ server_url: $o.para.server_url }))), $o.bridge.bridge_info = { touch_app_bridge: true, platform: "android", verify_success: e2 ? "success" : "fail" }, !$o.para.app_js_bridge)
          return void Do("app_js_bridge is not configured, data will not be sent by android obsolete bridge.");
        $o.registerInterceptor("sendDataStage", { send: { priority: 80, entry: zr } }), Do("Android obsolete bridge inits succeed.");
      }
    }
    function zr(e2, t2) {
      if ($o.para.app_js_bridge.is_mui || e2.data.type === "item_set" || e2.data.type === "item_delete")
        return e2;
      var r2 = e2.callback;
      if (To) {
        var n2 = To && To.call(No, JSON.stringify(Ao.extend({ server_url: $o.para.server_url }, e2.data)));
        return n2 ? (Ao.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2) : $o.para.app_js_bridge.is_send ? ($o.debug.apph5({ data: e2.data, step: "3.1", output: "all" }), e2) : (Ao.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2);
      }
      return jo && jo.call(No, JSON.stringify(Ao.extend({ server_url: $o.para.server_url }, e2.data))), Ao.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2;
    }
    function Wr(e2) {
      var t2 = e2.callType;
      return t2 in ns.commands ? ns.commands[t2](e2, No) : No && Ao.isFunction(No.sensorsdata_js_call_app) ? No.sensorsdata_js_call_app(JSON.stringify(e2)) : void 0;
    }
    function Xr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Zr(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Zr(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Gr(e2, t2, r2) {
      return Xr(e2, t2, r2), e2.plugin_version = ss, e2;
    }
    function Qr(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Yr(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Yr(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function en(e2, t2, r2) {
      return Qr(e2, t2, r2), e2.plugin_version = cs, e2;
    }
    function tn() {
      return typeof Ro != "undefined" && document[Ro];
    }
    function rn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return nn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function nn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function an(e2, t2, r2) {
      return rn(e2, t2, r2), e2.plugin_version = $s, e2;
    }
    function on2() {
      if (ds = window.SensorsData_iOS_JS_Bridge && window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url, fs = function() {
        return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker;
      }, gs && !gs.bridge.activeBridge && fs() && fs().postMessage) {
        if (gs.bridge.activeBridge = As, gs.para.app_js_bridge && !gs.para.app_js_bridge.is_mui && (gs.bridge.is_verify_success = ds && gs.bridge.validateAppUrl(ds)), gs.bridge.bridge_info = { touch_app_bridge: true, platform: "ios", verify_success: gs.bridge.is_verify_success ? "success" : "fail", support_two_way_call: true }, !gs.para.app_js_bridge)
          return void hs("app_js_bridge is not configured, data will not be sent by iOS bridge.");
        gs.registerInterceptor("sendDataStage", { send: { priority: 70, entry: sn } }), hs("IOS bridge inits succeed.");
      }
    }
    function sn(e2, t2) {
      if (gs.para.app_js_bridge.is_mui || e2.data.type === "item_set" || e2.data.type === "item_delete")
        return e2;
      var r2 = e2.callback;
      return gs.bridge.is_verify_success ? (fs() && fs().postMessage(JSON.stringify({ callType: "app_h5_track", data: _s.extend({ server_url: gs.para.server_url }, e2.data) })), _s.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2) : gs.para.app_js_bridge.is_send ? (gs.debug.apph5({ data: e2.data, step: "4.1", output: "all" }), e2) : (_s.isFunction(r2) && r2(), t2.cancellationToken.cancel(), e2);
    }
    function ln(e2) {
      var t2 = e2.callType;
      return t2 !== "page_info" && t2 !== "visualized_track" || gs.bridge.hasVisualModeBridge() ? t2 === "sensorsdata_get_app_visual_config" ? _s.isObject(window.SensorsData_APP_New_H5_Bridge) && window.SensorsData_APP_New_H5_Bridge[t2] : fs() && fs().postMessage(JSON.stringify(e2)) : null;
    }
    function un(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return cn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function cn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function pn(e2, t2, r2) {
      return un(e2, t2, r2), e2.plugin_version = xs, e2;
    }
    function dn() {
      if (ms && !ms.bridge.activeBridge && fn()) {
        if (ms.bridge.activeBridge = Es, ms.bridge.bridge_info = { touch_app_bridge: true, platform: "ios", verify_success: gn() ? "success" : "fail" }, !ms.para.app_js_bridge)
          return void ys("app_js_bridge is not configured, data will not be sent by iOS obsolete bridge.");
        ms.registerInterceptor("sendDataStage", { send: { priority: 90, entry: _n } }), ys("IOS obsolete bridge inits succeed.");
      }
    }
    function fn() {
      return (/sensors-verify/.test(navigator.userAgent) || /sa-sdk-ios/.test(navigator.userAgent)) && !window.MSStream;
    }
    function gn() {
      if (/sensors-verify/.test(navigator.userAgent)) {
        var e2 = navigator.userAgent.match(/sensors-verify\/([^\s]+)/);
        if (e2 && e2[0] && typeof e2[1] == "string" && e2[1].split("?").length === 2) {
          e2 = e2[1].split("?");
          var t2 = null, r2 = null;
          try {
            t2 = vs.URL(ms.para.server_url).hostname, r2 = vs.URL(ms.para.server_url).searchParams.get("project") || "default";
          } catch (n2) {
            ms.log(n2);
          }
          return !(!t2 || t2 !== e2[0] || !r2 || r2 !== e2[1]);
        }
        return false;
      }
      return !!/sa-sdk-ios/.test(navigator.userAgent);
    }
    function _n(e2, t2) {
      function r2(e3) {
        var t3 = JSON.stringify(vs.extend({ server_url: ms.para.server_url }, e3));
        return t3 = t3.replace(/\r\n/g, ""), t3 = encodeURIComponent(t3), "sensorsanalytics://trackEvent?event=" + t3;
      }
      if (ms.para.app_js_bridge.is_mui || e2.data.type === "item_set" || e2.data.type === "item_delete")
        return e2;
      var n2 = e2.callback;
      if (ms.bridge.bridge_info.verify_success) {
        var i2 = document.createElement("iframe"), a2 = r2(e2.data);
        return i2.setAttribute("src", a2), document.documentElement.appendChild(i2), i2.parentNode.removeChild(i2), i2 = null, vs.isFunction(n2) && n2(), t2.cancellationToken.cancel(), true;
      }
      return ms.para.app_js_bridge.is_send ? (ms.debug.apph5({ data: e2.data, step: "3.2", output: "all" }), e2) : (vs.isFunction(n2) && n2(), t2.cancellationToken.cancel(), e2);
    }
    function hn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return mn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function mn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function vn(e2, t2, r2) {
      return hn(e2, t2, r2), e2.plugin_version = Us, e2;
    }
    function yn() {
      this.sd = null, this.start_time = +new Date(), this.page_show_status = true, this.page_hidden_status = false, this._ = {}, this.timer = null, this.current_page_url = document.referrer, this.url = location.href, this.title = document.title || "", this.option = {}, this.heartbeat_interval_time = 5e3, this.heartbeat_interval_timer = null, this.page_id = null, this.storage_name = "sawebjssdkpageleave", this.max_duration = Hs;
    }
    function bn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return wn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function wn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Sn(e2, t2, r2) {
      return bn(e2, t2, r2), e2.plugin_version = Ms, e2;
    }
    function kn(e2, t2) {
      if (e2.type !== "track")
        return e2;
      var r2 = t2.sd, n2 = r2._, i2 = r2.saEvent.check, a2 = n2.extend2Lev({ properties: {} }, e2), o2 = t2.customRegister, s2 = a2.properties, l2 = a2.event, u2 = {};
      return n2.each(o2, function(e3) {
        if (n2.isObject(e3))
          n2.indexOf(e3.events, l2) > -1 && i2({ properties: e3.properties }) && (u2 = n2.extend(u2, e3.properties));
        else if (n2.isFunction(e3)) {
          var t3 = e3({ event: l2, properties: s2, data: a2 });
          n2.isObject(t3) && !n2.isEmptyObject(t3) && i2({ properties: t3 }) && (u2 = n2.extend(u2, t3));
        }
      }), e2.properties = n2.extend(s2, u2), e2;
    }
    function Pn() {
      this.sd = null, this.log = window.console && window.console.log || function() {
      }, this.customRegister = [];
    }
    function Cn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return On(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function On(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Nn(e2, t2, r2) {
      return Cn(e2, t2, r2), e2.plugin_version = Fs, e2;
    }
    function jn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Tn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Tn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function In(e2, t2, r2) {
      return jn(e2, t2, r2), e2.plugin_version = Gs, e2;
    }
    function $n(e2) {
      try {
        if (e2.event !== "$pageview" && (!e2.type || e2.type.slice(0, 7) !== "profile")) {
          var t2 = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0, r2 = document.documentElement.scrollHeight || 0, n2 = { $page_height: Math.max(t2, r2) || 0 };
          e2.properties = zs._.extend(e2.properties || {}, n2);
        }
      } catch (i2) {
        Qs("\u9875\u9762\u9AD8\u5EA6\u83B7\u53D6\u5F02\u5E38\u3002");
      }
      return Ws.call(zs.kit, e2);
    }
    function An(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Dn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Dn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function xn(e2, t2, r2) {
      return An(e2, t2, r2), e2.plugin_version = tl, e2;
    }
    function En(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Ln(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Ln(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Un(e2, t2, r2) {
      return En(e2, t2, r2), e2.plugin_version = vl, e2;
    }
    function Rn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Hn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Hn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Bn(e2, t2, r2) {
      return Rn(e2, t2, r2), e2.plugin_version = wl, e2;
    }
    function Jn() {
      Sl = true;
    }
    function Mn() {
      Sl = false;
    }
    function qn() {
      return Sl;
    }
    function Kn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Vn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Vn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Fn(e2, t2, r2) {
      return Kn(e2, t2, r2), e2.plugin_version = Ol, e2;
    }
    function zn(e2) {
      var t2 = e2, r2 = "";
      r2 = il.para.debug_mode_url.indexOf("?") !== -1 ? il.para.debug_mode_url + "&" + il.kit.encodeTrackData(e2) : il.para.debug_mode_url + "?" + il.kit.encodeTrackData(e2), al.ajax({ url: r2, type: "GET", cors: true, header: { "Dry-Run": String(il.para.debug_mode_upload) }, success: function(e3) {
        al.isEmptyObject(e3) === true ? alert("debug\u6570\u636E\u53D1\u9001\u6210\u529F" + t2) : alert("debug\u5931\u8D25 \u9519\u8BEF\u539F\u56E0" + JSON.stringify(e3));
      } });
    }
    function Wn(e2, t2) {
      if (il.para.debug_mode === true) {
        var r2 = e2.data;
        e2.callback;
        zn(JSON.stringify(r2)), t2.cancellationToken.stop();
      }
      return e2;
    }
    function Xn() {
      il.para.debug_mode === true && (il.para.debug_mode_upload = il.para.debug_mode_upload || false, al.isString(il.para.debug_mode_url) || (al.isString(il.para.server_url) ? il.para.debug_mode_url = il.para.server_url.replace("sa.gif", "debug") : al.isArray(il.para.server_url) && al.isString(il.para.server_url[0]) ? il.para.debug_mode_url = il.para.server_url[0].replace("sa.gif", "debug") : il.para.debug_mode = false));
    }
    function Zn() {
      il.on("sdkInitPara", function() {
        Xn();
      }), il.on("sdkAfterInitPara", function() {
        il.registerInterceptor("sendDataStage", { send: { priority: 30, entry: Wn } });
      });
    }
    function Gn(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Qn(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Qn(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Yn(e2, t2, r2) {
      return Gn(e2, t2, r2), e2.plugin_version = Tl, e2;
    }
    function ei(e2, t2) {
      if (sl.isObject(ol.para.jsapp) && !ol.para.jsapp.isOnline && typeof ol.para.jsapp.setData == "function") {
        var r2 = e2;
        delete r2.callback, r2 = JSON.stringify(r2), ol.para.jsapp.setData(r2), t2.cancellationToken.stop();
      }
      return e2;
    }
    function ti() {
      ol.on("sdkAfterInitAPI", function() {
        sl.isObject(ol.commonWays) && (ol.commonWays.setOnlineState = ri), ol.registerInterceptor("sendDataStage", { send: { priority: 40, entry: ei } });
      });
    }
    function ri(e2) {
      if (e2 === true && sl.isObject(ol.para.jsapp) && typeof ol.para.jsapp.getData == "function") {
        ol.para.jsapp.isOnline = true;
        var t2 = ol.para.jsapp.getData();
        sl.isArray(t2) && t2.length > 0 && sl.each(t2, function(e3) {
          sl.isJSONString(e3) && ol.kit.sendData(JSON.parse(e3));
        });
      } else
        ol.para.jsapp.isOnline = false;
    }
    function ni(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return ii(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function ii(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function ai(e2, t2, r2) {
      return ni(e2, t2, r2), e2.plugin_version = Al, e2;
    }
    function oi(e2, t2) {
      return !ll.para.app_js_bridge && ll.para.batch_send && ul.localStorage.isSupport() && localStorage.length < ll.para.batch_send.storage_length && (Dl.add(e2.data), t2.cancellationToken.stop()), e2;
    }
    function si() {
      var e2 = { datasend_timeout: 6e3, send_interval: 6e3, storage_length: 200 };
      ul.localStorage.isSupport() && ul.isSupportCors() && typeof localStorage == "object" ? ll.para.batch_send === true ? ll.para.batch_send = ul.extend({}, e2) : typeof ll.para.batch_send == "object" && (ll.para.batch_send = ul.extend({}, e2, ll.para.batch_send)) : ll.para.batch_send = false;
    }
    function li() {
      ll.on("sdkInitPara", function() {
        si();
      }), ll.on("sdkAfterInitPara", function() {
        !ll.para.app_js_bridge && ll.para.batch_send && ul.localStorage.isSupport() && (Dl || (Dl = new ul.BatchSend()), Dl.batchInterval(), ll.registerInterceptor("sendDataStage", { send: { priority: 100, entry: oi } }));
      });
    }
    function ui(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return ci(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function ci(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function pi(e2, t2, r2) {
      return ui(e2, t2, r2), e2.plugin_version = Ll, e2;
    }
    function di(e2) {
      var t2 = new pl.BeaconSend(e2);
      t2.start();
    }
    function fi(e2, t2) {
      if (cl.para.send_type === "beacon") {
        var r2 = e2.server_url;
        e2.data = cl.kit.encodeTrackData(e2.data), pl.isArray(r2) && r2.length ? pl.each(r2, function(t3) {
          e2.callback = null, e2.server_url = t3, di(e2);
        }) : typeof cl.para.server_url == "string" && cl.para.server_url !== "" ? di(e2) : cl.log("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01"), t2.cancellationToken.stop();
      }
      return e2;
    }
    function gi() {
      cl.para.send_type !== "beacon" || pl.isSupportBeaconSend() || (cl.para.send_type = "image");
    }
    function _i() {
      cl.on("sdkInitPara", function() {
        gi();
      }), cl.on("sdkAfterInitPara", function() {
        cl.registerInterceptor("sendDataStage", { send: { priority: 110, entry: fi } });
      });
    }
    function hi(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return mi(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function mi(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function vi(e2, t2, r2) {
      return hi(e2, t2, r2), e2.plugin_version = Hl, e2;
    }
    function yi(e2) {
      var t2 = new fl.AjaxSend(e2);
      t2.start();
    }
    function bi(e2, t2) {
      if (dl.para.send_type === "ajax") {
        var r2 = e2.server_url;
        e2.data = dl.kit.encodeTrackData(e2.data), fl.isArray(r2) && r2.length ? fl.each(r2, function(t3) {
          e2.callback = null, e2.server_url = t3, yi(e2);
        }) : typeof dl.para.server_url == "string" && dl.para.server_url !== "" ? yi(e2) : dl.log("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01"), t2.cancellationToken.stop();
      }
      return e2;
    }
    function wi() {
      dl.para.send_type !== "ajax" || fl.isSupportCors() || (dl.para.send_type = "image");
    }
    function Si() {
      dl.on("sdkInitPara", function() {
        wi();
      }), dl.on("sdkAfterInitPara", function() {
        dl.registerInterceptor("sendDataStage", { send: { priority: 120, entry: bi } });
      });
    }
    function ki(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Pi(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Pi(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Ci(e2, t2, r2) {
      return ki(e2, t2, r2), e2.plugin_version = Ml, e2;
    }
    function Oi(e2, t2) {
      var r2 = gl.kit.encodeTrackData(t2);
      return e2.indexOf("?") !== -1 ? e2 + "&" + r2 : e2 + "?" + r2;
    }
    function Ni(e2) {
      var t2 = new _l.ImageSend(e2);
      t2.start();
    }
    function ji(e2, t2) {
      var r2 = e2.server_url;
      e2.data = r2 && Oi(r2, e2.data), _l.isArray(r2) && r2.length ? _l.each(r2, function(t3) {
        e2.callback = null, e2.server_url = t3, Ni(e2);
      }) : typeof gl.para.server_url == "string" && gl.para.server_url !== "" ? Ni(e2) : gl.logger && gl.logger.msg("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01").level("warn").log(), t2.cancellationToken.stop();
    }
    function Ti() {
      gl.para.send_type !== "image" && gl.para.send_type !== "ajax" && gl.para.send_type !== "beacon" && (gl.para.send_type = "image");
    }
    function Ii() {
      gl.on("sdkInitPara", function() {
        Ti();
      }), gl.on("sdkAfterInitPara", function() {
        gl.registerInterceptor("sendDataStage", { send: { priority: 130, entry: ji } });
      });
    }
    function $i(e2, t2, r2) {
      if (t2 && (e2.plugin_name = t2), r2 && e2.init) {
        var n2 = e2.init;
        e2.init = function(i2, a2) {
          function o2() {
            n2.call(e2, i2, a2);
          }
          return Ai(i2, e2, t2), i2.readyState && i2.readyState.state >= 3 || !i2.on ? o2() : void i2.on(r2, o2);
        };
      }
      return e2;
    }
    function Ai(e2, t2, r2) {
      function n2(t3, n3) {
        e2.logger ? e2.logger.msg.apply(e2.logger, n3).module(r2 + "" || "").level(t3).log() : e2.log && e2.log.apply(e2, n3);
      }
      t2.log = function() {
        n2("log", arguments);
      }, t2.warn = function() {
        n2("warn", arguments);
      }, t2.error = function() {
        n2("error", arguments);
      };
    }
    function Di(e2, t2, r2) {
      return $i(e2, t2, r2), e2.plugin_version = fa, e2;
    }
    function xi(e2) {
      return zl === null ? void Ei(e2) : void zl.push(e2);
    }
    function Ei(e2) {
      try {
        if (e2.level === "log" && Li())
          return void Hi(e2);
        if (e2.level === "warn" && Ui())
          return void Hi(e2);
        if (e2.level === "error" && Ri())
          return void Hi(e2);
      } catch (t2) {
      }
    }
    function Li() {
      return !!qi() || (Vl.para.show_log === true || Fl.isObject(Vl.para.show_log) && Vl.para.show_log.level === "log");
    }
    function Ui() {
      return !!qi() || (Li() || Fl.isObject(Vl.para.show_log) && Vl.para.show_log.level === "warn");
    }
    function Ri() {
      return !!qi() || (!Fl.isObject(Vl.para.show_log) || Vl.para.show_log.level !== "none");
    }
    function Hi(e2) {
      var t2 = e2.content, r2 = Fl.isObject(t2[0]) ? Fl.formatJsonString(t2[0]) : t2[0], n2 = Bi(e2);
      t2[0] = n2 + (n2.length > 0 ? ": " : "") + r2;
      try {
        console && (Fl.isFunction(console[e2.level]) ? console[e2.level].apply(console, t2) : Fl.isObject(console[e2.level]) && console[e2.level](t2[0]));
      } catch (i2) {
      }
    }
    function Bi(e2) {
      var t2 = "", r2 = "", n2 = Vl.para.show_log;
      return Fl.isObject(n2) && n2.show_brand === false || (t2 += e2.brand), Fl.isObject(n2) && n2.show_level === false || (t2 += (t2.length > 0 ? "-" : "") + e2.level), t2.length > 0 && (t2 = "[" + t2 + "]"), Fl.isObject(n2) && n2.show_module === false || (r2 = e2.module), t2 + r2;
    }
    function Ji() {
      Fl.sessionStorage.isSupport() && sessionStorage.setItem(Zl, "true");
    }
    function Mi() {
      Fl.sessionStorage.isSupport() && sessionStorage.removeItem(Zl);
    }
    function qi() {
      return Fl.sessionStorage.isSupport() && sessionStorage.getItem(Zl) === "true";
    }
    var Ki = {};
    (function() {
      function e2(n3, i3) {
        function a3(e3, t3) {
          try {
            e3();
          } catch (r3) {
            t3 && t3();
          }
        }
        function o3(e3) {
          if (o3[e3] != null)
            return o3[e3];
          var t3;
          if (e3 == "bug-string-char-index")
            t3 = "a"[0] != "a";
          else if (e3 == "json")
            t3 = o3("json-stringify") && o3("date-serialization") && o3("json-parse");
          else if (e3 == "date-serialization") {
            if (t3 = o3("json-stringify") && b2) {
              var r3 = i3.stringify;
              a3(function() {
                t3 = r3(new p2(-864e13)) == '"-271821-04-20T00:00:00.000Z"' && r3(new p2(864e13)) == '"+275760-09-13T00:00:00.000Z"' && r3(new p2(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' && r3(new p2(-1)) == '"1969-12-31T23:59:59.999Z"';
              });
            }
          } else {
            var n4, s3 = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
            if (e3 == "json-stringify") {
              var r3 = i3.stringify, c3 = typeof r3 == "function";
              c3 && ((n4 = function() {
                return 1;
              }).toJSON = n4, a3(function() {
                c3 = r3(0) === "0" && r3(new l2()) === "0" && r3(new u2()) == '""' && r3(v2) === h2 && r3(h2) === h2 && r3() === h2 && r3(n4) === "1" && r3([n4]) == "[1]" && r3([h2]) == "[null]" && r3(null) == "null" && r3([h2, v2, null]) == "[null,null,null]" && r3({ a: [n4, true, false, null, "\0\b\n\f\r	"] }) == s3 && r3(null, n4) === "1" && r3([1, 2], null, 1) == "[\n 1,\n 2\n]";
              }, function() {
                c3 = false;
              })), t3 = c3;
            }
            if (e3 == "json-parse") {
              var d3, f3 = i3.parse;
              typeof f3 == "function" && a3(function() {
                f3("0") !== 0 || f3(false) || (n4 = f3(s3), d3 = n4.a.length == 5 && n4.a[0] === 1, d3 && (a3(function() {
                  d3 = !f3('"	"');
                }), d3 && a3(function() {
                  d3 = f3("01") !== 1;
                }), d3 && a3(function() {
                  d3 = f3("1.") !== 1;
                })));
              }, function() {
                d3 = false;
              }), t3 = d3;
            }
          }
          return o3[e3] = !!t3;
        }
        function s2(e3) {
          return A2(this);
        }
        n3 || (n3 = r2.Object()), i3 || (i3 = r2.Object());
        var l2 = n3.Number || r2.Number, u2 = n3.String || r2.String, c2 = n3.Object || r2.Object, p2 = n3.Date || r2.Date, d2 = n3.SyntaxError || r2.SyntaxError, f2 = n3.TypeError || r2.TypeError, g2 = n3.Math || r2.Math, _2 = n3.JSON || r2.JSON;
        if (typeof _2 == "object" && _2)
          return i3.stringify = _2.stringify, i3.parse = _2.parse, i3.runInContext = e2, i3;
        var h2, m2 = c2.prototype, v2 = m2.toString, y2 = m2.hasOwnProperty, b2 = new p2(-3509827334573292);
        if (a3(function() {
          b2 = b2.getUTCFullYear() == -109252 && b2.getUTCMonth() === 0 && b2.getUTCDate() === 1 && b2.getUTCHours() == 10 && b2.getUTCMinutes() == 37 && b2.getUTCSeconds() == 6 && b2.getUTCMilliseconds() == 708;
        }), o3["bug-string-char-index"] = o3["date-serialization"] = o3.json = o3["json-stringify"] = o3["json-parse"] = null, !o3("json")) {
          var w2 = "[object Function]", S2 = "[object Date]", k2 = "[object Number]", P2 = "[object String]", C2 = "[object Array]", O2 = "[object Boolean]", N2 = o3("bug-string-char-index"), j2 = function(e3, r3) {
            var n4, i4, a4, o4 = 0;
            (n4 = function() {
              this.valueOf = 0;
            }).prototype.valueOf = 0, i4 = new n4();
            for (a4 in i4)
              y2.call(i4, a4) && o4++;
            return n4 = i4 = null, o4 ? j2 = function(e4, t3) {
              var r4, n5, i5 = v2.call(e4) == w2;
              for (r4 in e4)
                i5 && r4 == "prototype" || !y2.call(e4, r4) || (n5 = r4 === "constructor") || t3(r4);
              (n5 || y2.call(e4, r4 = "constructor")) && t3(r4);
            } : (i4 = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"], j2 = function(e4, r4) {
              var n5, a5, o5 = v2.call(e4) == w2, s3 = !o5 && typeof e4.constructor != "function" && t2[typeof e4.hasOwnProperty] && e4.hasOwnProperty || y2;
              for (n5 in e4)
                o5 && n5 == "prototype" || !s3.call(e4, n5) || r4(n5);
              for (a5 = i4.length; n5 = i4[--a5]; )
                s3.call(e4, n5) && r4(n5);
            }), j2(e3, r3);
          };
          if (!o3("json-stringify") && !o3("date-serialization")) {
            var T2 = { 92: "\\\\", 34: '\\"', 8: "\\b", 12: "\\f", 10: "\\n", 13: "\\r", 9: "\\t" }, I2 = "000000", $2 = function(e3, t3) {
              return (I2 + (t3 || 0)).slice(-e3);
            }, A2 = function(e3) {
              var t3, r3, n4, i4, a4, o4, s3, l3, u3;
              if (b2)
                t3 = function(e4) {
                  r3 = e4.getUTCFullYear(), n4 = e4.getUTCMonth(), i4 = e4.getUTCDate(), o4 = e4.getUTCHours(), s3 = e4.getUTCMinutes(), l3 = e4.getUTCSeconds(), u3 = e4.getUTCMilliseconds();
                };
              else {
                var c3 = g2.floor, p3 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], d3 = function(e4, t4) {
                  return p3[t4] + 365 * (e4 - 1970) + c3((e4 - 1969 + (t4 = +(t4 > 1))) / 4) - c3((e4 - 1901 + t4) / 100) + c3((e4 - 1601 + t4) / 400);
                };
                t3 = function(e4) {
                  for (i4 = c3(e4 / 864e5), r3 = c3(i4 / 365.2425) + 1970 - 1; d3(r3 + 1, 0) <= i4; r3++)
                    ;
                  for (n4 = c3((i4 - d3(r3, 0)) / 30.42); d3(r3, n4 + 1) <= i4; n4++)
                    ;
                  i4 = 1 + i4 - d3(r3, n4), a4 = (e4 % 864e5 + 864e5) % 864e5, o4 = c3(a4 / 36e5) % 24, s3 = c3(a4 / 6e4) % 60, l3 = c3(a4 / 1e3) % 60, u3 = a4 % 1e3;
                };
              }
              return (A2 = function(e4) {
                return e4 > -1 / 0 && e4 < 1 / 0 ? (t3(e4), e4 = (r3 <= 0 || r3 >= 1e4 ? (r3 < 0 ? "-" : "+") + $2(6, r3 < 0 ? -r3 : r3) : $2(4, r3)) + "-" + $2(2, n4 + 1) + "-" + $2(2, i4) + "T" + $2(2, o4) + ":" + $2(2, s3) + ":" + $2(2, l3) + "." + $2(3, u3) + "Z", r3 = n4 = i4 = o4 = s3 = l3 = u3 = null) : e4 = null, e4;
              })(e3);
            };
            if (o3("json-stringify") && !o3("date-serialization")) {
              var D2 = i3.stringify;
              i3.stringify = function(e3, t3, r3) {
                var n4 = p2.prototype.toJSON;
                p2.prototype.toJSON = s2;
                var i4 = D2(e3, t3, r3);
                return p2.prototype.toJSON = n4, i4;
              };
            } else {
              var x2 = "\\u00", E2 = function(e3) {
                var t3 = e3.charCodeAt(0), r3 = T2[t3];
                return r3 ? r3 : x2 + $2(2, t3.toString(16));
              }, L2 = /[\x00-\x1f\x22\x5c]/g, U2 = function(e3) {
                return L2.lastIndex = 0, '"' + (L2.test(e3) ? e3.replace(L2, E2) : e3) + '"';
              }, R2 = function(e3, t3, r3, n4, i4, o4, s3) {
                var l3, u3, c3, d3, g3, _3, m3, y3, b3;
                if (a3(function() {
                  l3 = t3[e3];
                }), typeof l3 == "object" && l3 && (l3.getUTCFullYear && v2.call(l3) == S2 && l3.toJSON === p2.prototype.toJSON ? l3 = A2(l3) : typeof l3.toJSON == "function" && (l3 = l3.toJSON(e3))), r3 && (l3 = r3.call(t3, e3, l3)), l3 == h2)
                  return l3 === h2 ? l3 : "null";
                switch (u3 = typeof l3, u3 == "object" && (c3 = v2.call(l3)), c3 || u3) {
                  case "boolean":
                  case O2:
                    return "" + l3;
                  case "number":
                  case k2:
                    return l3 > -1 / 0 && l3 < 1 / 0 ? "" + l3 : "null";
                  case "string":
                  case P2:
                    return U2("" + l3);
                }
                if (typeof l3 == "object") {
                  for (m3 = s3.length; m3--; )
                    if (s3[m3] === l3)
                      throw f2();
                  if (s3.push(l3), d3 = [], y3 = o4, o4 += i4, c3 == C2) {
                    for (_3 = 0, m3 = l3.length; _3 < m3; _3++)
                      g3 = R2(_3, l3, r3, n4, i4, o4, s3), d3.push(g3 === h2 ? "null" : g3);
                    b3 = d3.length ? i4 ? "[\n" + o4 + d3.join(",\n" + o4) + "\n" + y3 + "]" : "[" + d3.join(",") + "]" : "[]";
                  } else
                    j2(n4 || l3, function(e4) {
                      var t4 = R2(e4, l3, r3, n4, i4, o4, s3);
                      t4 !== h2 && d3.push(U2(e4) + ":" + (i4 ? " " : "") + t4);
                    }), b3 = d3.length ? i4 ? "{\n" + o4 + d3.join(",\n" + o4) + "\n" + y3 + "}" : "{" + d3.join(",") + "}" : "{}";
                  return s3.pop(), b3;
                }
              };
              i3.stringify = function(e3, r3, n4) {
                var i4, a4, o4, s3;
                if (t2[typeof r3] && r3) {
                  if (s3 = v2.call(r3), s3 == w2)
                    a4 = r3;
                  else if (s3 == C2) {
                    o4 = {};
                    for (var l3, u3 = 0, c3 = r3.length; u3 < c3; )
                      l3 = r3[u3++], s3 = v2.call(l3), s3 != "[object String]" && s3 != "[object Number]" || (o4[l3] = 1);
                  }
                }
                if (n4)
                  if (s3 = v2.call(n4), s3 == k2) {
                    if ((n4 -= n4 % 1) > 0)
                      for (n4 > 10 && (n4 = 10), i4 = ""; i4.length < n4; )
                        i4 += " ";
                  } else
                    s3 == P2 && (i4 = n4.length <= 10 ? n4 : n4.slice(0, 10));
                return R2("", (l3 = {}, l3[""] = e3, l3), a4, o4, i4, "", []);
              };
            }
          }
          if (!o3("json-parse")) {
            var H2, B2, J2 = u2.fromCharCode, M3 = { 92: "\\", 34: '"', 47: "/", 98: "\b", 116: "	", 110: "\n", 102: "\f", 114: "\r" }, q2 = function() {
              throw H2 = B2 = null, d2();
            }, K2 = function() {
              for (var e3, t3, r3, n4, i4, a4 = B2, o4 = a4.length; H2 < o4; )
                switch (i4 = a4.charCodeAt(H2)) {
                  case 9:
                  case 10:
                  case 13:
                  case 32:
                    H2++;
                    break;
                  case 123:
                  case 125:
                  case 91:
                  case 93:
                  case 58:
                  case 44:
                    return e3 = N2 ? a4.charAt(H2) : a4[H2], H2++, e3;
                  case 34:
                    for (e3 = "@", H2++; H2 < o4; )
                      if (i4 = a4.charCodeAt(H2), i4 < 32)
                        q2();
                      else if (i4 == 92)
                        switch (i4 = a4.charCodeAt(++H2)) {
                          case 92:
                          case 34:
                          case 47:
                          case 98:
                          case 116:
                          case 110:
                          case 102:
                          case 114:
                            e3 += M3[i4], H2++;
                            break;
                          case 117:
                            for (t3 = ++H2, r3 = H2 + 4; H2 < r3; H2++)
                              i4 = a4.charCodeAt(H2), i4 >= 48 && i4 <= 57 || i4 >= 97 && i4 <= 102 || i4 >= 65 && i4 <= 70 || q2();
                            e3 += J2("0x" + a4.slice(t3, H2));
                            break;
                          default:
                            q2();
                        }
                      else {
                        if (i4 == 34)
                          break;
                        for (i4 = a4.charCodeAt(H2), t3 = H2; i4 >= 32 && i4 != 92 && i4 != 34; )
                          i4 = a4.charCodeAt(++H2);
                        e3 += a4.slice(t3, H2);
                      }
                    if (a4.charCodeAt(H2) == 34)
                      return H2++, e3;
                    q2();
                  default:
                    if (t3 = H2, i4 == 45 && (n4 = true, i4 = a4.charCodeAt(++H2)), i4 >= 48 && i4 <= 57) {
                      for (i4 == 48 && (i4 = a4.charCodeAt(H2 + 1), i4 >= 48 && i4 <= 57) && q2(), n4 = false; H2 < o4 && (i4 = a4.charCodeAt(H2), i4 >= 48 && i4 <= 57); H2++)
                        ;
                      if (a4.charCodeAt(H2) == 46) {
                        for (r3 = ++H2; r3 < o4 && (i4 = a4.charCodeAt(r3), !(i4 < 48 || i4 > 57)); r3++)
                          ;
                        r3 == H2 && q2(), H2 = r3;
                      }
                      if (i4 = a4.charCodeAt(H2), i4 == 101 || i4 == 69) {
                        for (i4 = a4.charCodeAt(++H2), i4 != 43 && i4 != 45 || H2++, r3 = H2; r3 < o4 && (i4 = a4.charCodeAt(r3), !(i4 < 48 || i4 > 57)); r3++)
                          ;
                        r3 == H2 && q2(), H2 = r3;
                      }
                      return +a4.slice(t3, H2);
                    }
                    n4 && q2();
                    var s3 = a4.slice(H2, H2 + 4);
                    if (s3 == "true")
                      return H2 += 4, true;
                    if (s3 == "fals" && a4.charCodeAt(H2 + 4) == 101)
                      return H2 += 5, false;
                    if (s3 == "null")
                      return H2 += 4, null;
                    q2();
                }
              return "$";
            }, V2 = function(e3) {
              var t3, r3;
              if (e3 == "$" && q2(), typeof e3 == "string") {
                if ((N2 ? e3.charAt(0) : e3[0]) == "@")
                  return e3.slice(1);
                if (e3 == "[") {
                  for (t3 = []; e3 = K2(), e3 != "]"; )
                    r3 ? e3 == "," ? (e3 = K2(), e3 == "]" && q2()) : q2() : r3 = true, e3 == "," && q2(), t3.push(V2(e3));
                  return t3;
                }
                if (e3 == "{") {
                  for (t3 = {}; e3 = K2(), e3 != "}"; )
                    r3 ? e3 == "," ? (e3 = K2(), e3 == "}" && q2()) : q2() : r3 = true, e3 != "," && typeof e3 == "string" && (N2 ? e3.charAt(0) : e3[0]) == "@" && K2() == ":" || q2(), t3[e3.slice(1)] = V2(K2());
                  return t3;
                }
                q2();
              }
              return e3;
            }, F2 = function(e3, t3, r3) {
              var n4 = z2(e3, t3, r3);
              n4 === h2 ? delete e3[t3] : e3[t3] = n4;
            }, z2 = function(e3, t3, r3) {
              var n4, i4 = e3[t3];
              if (typeof i4 == "object" && i4)
                if (v2.call(i4) == C2)
                  for (n4 = i4.length; n4--; )
                    F2(v2, j2, i4, n4, r3);
                else
                  j2(i4, function(e4) {
                    F2(i4, e4, r3);
                  });
              return r3.call(e3, t3, i4);
            };
            i3.parse = function(e3, t3) {
              var r3, n4;
              return H2 = 0, B2 = "" + e3, r3 = V2(K2()), K2() != "$" && q2(), H2 = B2 = null, t3 && v2.call(t3) == w2 ? z2((n4 = {}, n4[""] = r3, n4), "", t3) : r3;
            };
          }
        }
        return i3.runInContext = e2, i3;
      }
      var t2 = { "function": true, object: true }, r2 = t2[typeof window] && window || this, n2 = r2.JSON, i2 = r2.JSON3, a2 = false, o2 = e2(r2, r2.JSON3 = { noConflict: function() {
        return a2 || (a2 = true, r2.JSON = n2, r2.JSON3 = i2, n2 = i2 = null), o2;
      } });
      r2.JSON = { parse: o2.parse, stringify: o2.stringify };
    }).call(window), function(e2, t2) {
      t2(e2);
    }(window, function(e2) {
      if (e2.atob)
        try {
          e2.atob(" ");
        } catch (t2) {
          e2.atob = function(e3) {
            var t3 = function(t4) {
              return e3(String(t4).replace(/[\t\n\f\r ]+/g, ""));
            };
            return t3.original = e3, t3;
          }(e2.atob);
        }
      else {
        var r2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n2 = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
        e2.btoa = function(e3) {
          e3 = String(e3);
          for (var t2, n3, i2, a2, o2 = "", s2 = 0, l2 = e3.length % 3; s2 < e3.length; ) {
            if ((n3 = e3.charCodeAt(s2++)) > 255 || (i2 = e3.charCodeAt(s2++)) > 255 || (a2 = e3.charCodeAt(s2++)) > 255)
              return "";
            t2 = n3 << 16 | i2 << 8 | a2, o2 += r2.charAt(t2 >> 18 & 63) + r2.charAt(t2 >> 12 & 63) + r2.charAt(t2 >> 6 & 63) + r2.charAt(63 & t2);
          }
          return l2 ? o2.slice(0, l2 - 3) + "===".substring(l2) : o2;
        }, e2.atob = function(e3) {
          if (e3 = String(e3).replace(/[\t\n\f\r ]+/g, ""), !n2.test(e3))
            return "";
          e3 += "==".slice(2 - (3 & e3.length));
          for (var t2, i2, a2, o2 = "", s2 = 0; s2 < e3.length; )
            t2 = r2.indexOf(e3.charAt(s2++)) << 18 | r2.indexOf(e3.charAt(s2++)) << 12 | (i2 = r2.indexOf(e3.charAt(s2++))) << 6 | (a2 = r2.indexOf(e3.charAt(s2++))), o2 += i2 === 64 ? String.fromCharCode(t2 >> 16 & 255) : a2 === 64 ? String.fromCharCode(t2 >> 16 & 255, t2 >> 8 & 255) : String.fromCharCode(t2 >> 16 & 255, t2 >> 8 & 255, 255 & t2);
          return o2;
        };
      }
    });
    var Vi, Fi = { setup: function(e2) {
      Vi = e2;
    }, log: function() {
      (Vi || console && console.log || function() {
      }).apply(null, arguments);
    } }, zi = { get: function(e2) {
      return window.localStorage.getItem(e2);
    }, parse: function(e2) {
      var t2;
      try {
        t2 = JSON.parse(zi.get(e2)) || null;
      } catch (r2) {
        Fi.log("parse localStorage failed");
      }
      return t2;
    }, set: function(e2, t2) {
      try {
        window.localStorage.setItem(e2, t2);
      } catch (r2) {
        Fi.log("localStorage is not support");
      }
    }, remove: function(e2) {
      window.localStorage.removeItem(e2);
    }, isSupport: function() {
      var e2 = true;
      try {
        var t2 = "__local_store_support__", r2 = "testIsSupportStorage";
        zi.set(t2, r2), zi.get(t2) !== r2 && (e2 = false), zi.remove(t2);
      } catch (n2) {
        e2 = false;
      }
      return e2;
    } }, Wi = function() {
      function e2() {
        return r2 = (9301 * r2 + 49297) % 233280, r2 / 233280;
      }
      var t2 = new Date(), r2 = t2.getTime();
      return function(t3) {
        return Math.ceil(e2() * t3);
      };
    }();
    a.prototype.get = function(e2, r2, a2, o2) {
      if (!e2)
        throw new Error("key is must");
      r2 = r2 || 1e4, a2 = a2 || 1e3, o2 = o2 || function() {
      };
      var s2 = this.lockGetPrefix + e2, l2 = zi.get(s2), u2 = String(n());
      return l2 && (l2 = i(l2) || { randomNum: 0, expireTime: 0 }, l2.expireTime > t()) ? o2(null) : (zi.set(s2, JSON.stringify({ randomNum: u2, expireTime: t() + r2 })), void setTimeout(function() {
        l2 = i(zi.get(s2)) || { randomNum: 0, expireTime: 0 }, l2 && l2.randomNum === u2 ? (o2(zi.get(e2)), zi.remove(e2), zi.remove(s2)) : o2(null);
      }, a2));
    }, a.prototype.set = function(e2, r2, a2, o2, s2) {
      if (!e2 || !r2)
        throw new Error("key and val is must");
      a2 = a2 || 1e4, o2 = o2 || 1e3, s2 = s2 || function() {
      };
      var l2 = this.lockSetPrefix + e2, u2 = zi.get(l2), c2 = String(n());
      return u2 && (u2 = i(u2) || { randomNum: 0, expireTime: 0 }, u2.expireTime > t()) ? s2({ status: "fail", reason: "This key is locked" }) : (zi.set(l2, JSON.stringify({ randomNum: c2, expireTime: t() + a2 })), void setTimeout(function() {
        u2 = i(zi.get(l2)) || { randomNum: 0, expireTime: 0 }, u2.randomNum === c2 ? zi.set(e2, r2) && s2({ status: "success" }) : s2({ status: "fail", reason: "This key is locked" });
      }, o2));
    }, l.prototype.on = function(e2, t2) {
      if (!e2 || !t2)
        return false;
      if (!s(t2))
        throw new Error("listener must be a function");
      this._events[e2] = this._events[e2] || [];
      var r2 = typeof t2 == "object";
      return this._events[e2].push(r2 ? t2 : { listener: t2, once: false }), this;
    }, l.prototype.prepend = function(e2, t2) {
      if (!e2 || !t2)
        return false;
      if (!s(t2))
        throw new Error("listener must be a function");
      this._events[e2] = this._events[e2] || [];
      var r2 = typeof t2 == "object";
      return this._events[e2].unshift(r2 ? t2 : { listener: t2, once: false }), this;
    }, l.prototype.prependOnce = function(e2, t2) {
      return this.prepend(e2, { listener: t2, once: true });
    }, l.prototype.once = function(e2, t2) {
      return this.on(e2, { listener: t2, once: true });
    }, l.prototype.off = function(e2, t2) {
      var r2 = this._events[e2];
      if (!r2)
        return false;
      if (typeof t2 == "number")
        r2.splice(t2, 1);
      else if (typeof t2 == "function")
        for (var n2 = 0, i2 = r2.length; n2 < i2; n2++)
          r2[n2] && r2[n2].listener === t2 && r2.splice(n2, 1);
      return this;
    }, l.prototype.emit = function(e2, t2) {
      var r2 = this._events[e2];
      if (!r2)
        return false;
      for (var n2 = 0; n2 < r2.length; n2++) {
        var i2 = r2[n2];
        i2 && (i2.listener.call(this, t2 || {}), i2.once && this.off(e2, n2));
      }
      return this;
    }, l.prototype.removeAllListeners = function(e2) {
      e2 && this._events[e2] ? this._events[e2] = [] : this._events = {};
    }, l.prototype.listeners = function(e2) {
      return e2 && typeof e2 == "string" ? this._events[e2] : this._events;
    };
    var Xi = function() {
      var e2 = function() {
        for (var e3 = 1 * new Date(), t3 = 0; e3 == 1 * new Date(); )
          t3++;
        return e3.toString(16) + t3.toString(16);
      }, t2 = function() {
        return n().toString(16).replace(".", "");
      }, r2 = function() {
        function e3(e4, t4) {
          var r4, n3 = 0;
          for (r4 = 0; r4 < t4.length; r4++)
            n3 |= i2[r4] << 8 * r4;
          return e4 ^ n3;
        }
        var t3, r3, n2 = navigator.userAgent, i2 = [], a2 = 0;
        for (t3 = 0; t3 < n2.length; t3++)
          r3 = n2.charCodeAt(t3), i2.unshift(255 & r3), i2.length >= 4 && (a2 = e3(a2, i2), i2 = []);
        return i2.length > 0 && (a2 = e3(a2, i2)), a2.toString(16);
      };
      return function() {
        var i2 = String(screen.height * screen.width);
        i2 = i2 && /\d{5,}/.test(i2) ? i2.toString(16) : String(31242 * n()).replace(".", "").slice(0, 8);
        var a2 = e2() + "-" + t2() + "-" + r2() + "-" + i2 + "-" + e2();
        return a2 ? a2 : (String(n()) + String(n()) + String(n())).slice(2, 15);
      };
    }(), Zi = function(e2) {
      this.ele = e2;
    }, Gi = function(e2, t2) {
      for (var r2 = []; e2; e2 = e2.nextSibling)
        e2.nodeType === 1 && e2 !== t2 && r2.push(e2);
      return r2;
    };
    Zi.prototype = { addClass: function(e2) {
      var t2 = " " + this.ele.className + " ";
      return t2.indexOf(" " + e2 + " ") === -1 && (this.ele.className = this.ele.className + (this.ele.className === "" ? "" : " ") + e2), this;
    }, removeClass: function(e2) {
      var t2 = " " + this.ele.className + " ";
      return t2.indexOf(" " + e2 + " ") !== -1 && (this.ele.className = t2.replace(" " + e2 + " ", " ").slice(1, -1)), this;
    }, hasClass: function(e2) {
      var t2 = " " + this.ele.className + " ";
      return t2.indexOf(" " + e2 + " ") !== -1;
    }, attr: function(e2, t2) {
      return typeof e2 == "string" && h(t2) ? this.ele.getAttribute(e2) : (typeof e2 == "string" && (t2 = String(t2), this.ele.setAttribute(e2, t2)), this);
    }, offset: function() {
      var e2 = this.ele.getBoundingClientRect();
      if (e2.width || e2.height) {
        var t2 = this.ele.ownerDocument, r2 = t2.documentElement;
        return { top: e2.top + window.pageYOffset - r2.clientTop, left: e2.left + window.pageXOffset - r2.clientLeft };
      }
      return { top: 0, left: 0 };
    }, getSize: function() {
      if (!window.getComputedStyle)
        return { width: this.ele.offsetWidth, height: this.ele.offsetHeight };
      try {
        var e2 = this.ele.getBoundingClientRect();
        return { width: e2.width, height: e2.height };
      } catch (t2) {
        return { width: 0, height: 0 };
      }
    }, getStyle: function(e2) {
      return this.ele.currentStyle ? this.ele.currentStyle[e2] : this.ele.ownerDocument.defaultView.getComputedStyle(this.ele, null).getPropertyValue(e2);
    }, wrap: function(e2) {
      var t2 = document.createElement(e2);
      return this.ele.parentNode.insertBefore(t2, this.ele), t2.appendChild(this.ele), y(t2);
    }, getCssStyle: function(e2) {
      var t2 = this.ele.style.getPropertyValue(e2);
      if (t2)
        return t2;
      var r2 = null;
      if (typeof window.getMatchedCSSRules == "function" && (r2 = window.getMatchedCSSRules(this.ele)), !r2 || !v(r2))
        return null;
      for (var n2 = r2.length - 1; n2 >= 0; n2--) {
        var i2 = r2[n2];
        if (t2 = i2.style.getPropertyValue(e2))
          return t2;
      }
    }, sibling: function(e2, t2) {
      for (; (e2 = e2[t2]) && e2.nodeType !== 1; )
        ;
      return e2;
    }, next: function() {
      return this.sibling(this.ele, "nextSibling");
    }, prev: function() {
      return this.sibling(this.ele, "previousSibling");
    }, siblings: function() {
      return Gi((this.ele.parentNode || {}).firstChild, this.ele);
    }, children: function() {
      return Gi(this.ele.firstChild);
    }, parent: function() {
      var e2 = this.ele.parentNode;
      return e2 = e2 && e2.nodeType !== 11 ? e2 : null, y(e2);
    }, previousElementSibling: function() {
      var e2 = this.ele;
      if ("previousElementSibling" in document.documentElement)
        return y(e2.previousElementSibling);
      for (; e2 = e2.previousSibling; )
        if (e2.nodeType === 1)
          return y(e2);
      return y(null);
    }, getSameTypeSiblings: function() {
      for (var e2 = this.ele, t2 = e2.parentNode, r2 = e2.tagName.toLowerCase(), n2 = [], i2 = 0; i2 < t2.children.length; i2++) {
        var a2 = t2.children[i2];
        a2.nodeType === 1 && a2.tagName.toLowerCase() === r2 && n2.push(t2.children[i2]);
      }
      return n2;
    }, getParents: function() {
      try {
        var e2 = this.ele;
        if (!_(e2))
          return [];
        var t2 = [e2];
        if (e2 === null || e2.parentElement === null)
          return [];
        for (; e2.parentElement !== null; )
          e2 = e2.parentElement, t2.push(e2);
        return t2;
      } catch (r2) {
        return [];
      }
    } };
    var Qi = Array.prototype.forEach, Yi = Object.prototype.hasOwnProperty, ea = Object.prototype.hasOwnProperty, ta = { get: function(e2) {
      for (var t2 = e2 + "=", r2 = document.cookie.split(";"), n2 = 0; n2 < r2.length; n2++) {
        for (var i2 = r2[n2]; i2.charAt(0) == " "; )
          i2 = i2.substring(1, i2.length);
        if (i2.indexOf(t2) == 0)
          return u(i2.substring(t2.length, i2.length));
      }
      return null;
    }, set: function(e2, t2, r2, n2, i2, a2, o2) {
      function s2(e3) {
        return !!e3 && e3.replace(/\r\n/g, "");
      }
      var l2 = o2, u2 = "", c2 = "", d2 = "";
      if (r2 = r2 == null ? 73e3 : r2, r2 !== 0) {
        var f2 = new Date();
        String(r2).slice(-1) === "s" ? f2.setTime(f2.getTime() + 1e3 * Number(String(r2).slice(0, -1))) : f2.setTime(f2.getTime() + 24 * r2 * 60 * 60 * 1e3), u2 = "; expires=" + f2.toGMTString();
      }
      p(i2) && i2 !== "" && (d2 = "; SameSite=" + i2), a2 && (c2 = "; secure");
      var g2 = "", _2 = "", h2 = "";
      e2 && (g2 = s2(e2)), t2 && (_2 = s2(t2)), l2 && (h2 = s2(l2)), g2 && _2 && (document.cookie = g2 + "=" + encodeURIComponent(_2) + u2 + "; path=/" + h2 + d2 + c2);
    }, remove: function(e2, t2) {
      this.set(e2, "1", -1, t2);
    }, isSupport: function(e2, t2) {
      function r2() {
        n2.set(e2, t2);
        var r3 = n2.get(e2);
        return r3 === t2 && (n2.remove(e2), true);
      }
      e2 = e2 || "cookie_support_test", t2 = t2 || "1";
      var n2 = this;
      return navigator.cookieEnabled && r2();
    } }, ra = Object.prototype.hasOwnProperty, na = { isSupport: function() {
      var e2 = true, t2 = "__session_storage_support__", r2 = "testIsSupportStorage";
      try {
        sessionStorage && sessionStorage.setItem ? (sessionStorage.setItem(t2, r2), sessionStorage.removeItem(t2, r2), e2 = true) : e2 = false;
      } catch (n2) {
        e2 = false;
      }
      return e2;
    } }, ia = { "+": "-", "/": "_", "=": "." }, aa = { "-": "+", _: "/", ".": "=" }, oa = { encode: function(e2) {
      return e2.replace(/[+\/=]/g, function(e3) {
        return ia[e3];
      });
    }, decode: function(e2) {
      return e2.replace(/[-_.]/g, function(e3) {
        return aa[e3];
      });
    }, trim: function(e2) {
      return e2.replace(/[.=]{1,2}$/, "");
    }, isBase64: function(e2) {
      return /^[A-Za-z0-9+\/]*[=]{0,2}$/.test(e2);
    }, isUrlSafeBase64: function(e2) {
      return /^[A-Za-z0-9_-]*[.]{0,2}$/.test(e2);
    } }, sa = { __proto__: null, ConcurrentStorage: a, EventEmitter: l, URL: g, UUID: Xi, addEvent: b, addHashEvent: w, ajax: C, base64Decode: N, base64Encode: j, bindReady: T, cookie: ta, coverExtend: I, decodeURI: $, decodeURIComponent: u, dfmapping: A, each: k, encodeDates: E, extend: P, extend2Lev: L, filter: U, formatDate: x, formatJsonString: R, getCookieTopLevelDomain: B, getDomBySelector: J, getElementContent: M2, getHostname: q, getIOSVersion: K, getQueryParam: F, getQueryParamsFromUrl: V, getRandom: n, getRandomBasic: Wi, getScreenOrientation: W, getUA: X, getURL: Z, getURLPath: G, getURLSearchParams: c, hasAttribute: Q, hasAttributes: Y, hashCode: ee, hashCode53: te, indexOf: re, inherit: ne, isArguments: ie, isArray: v, isBoolean: ae, isDate: D, isElement: _, isEmptyObject: oe, isFunction: e, isHttpUrl: se, isIOS: le, isJSONString: ue, isNumber: ce, isObject: r, isString: p, isSupportBeaconSend: pe, isSupportCors: de, isUndefined: h, jsonp: fe, listenPageState: ge, loadScript: _e, localStorage: zi, logger: Fi, map: O, mediaQueriesSupported: z, now: t, removeScriptProtocol: he, rot13defs: ve, rot13obfs: me, ry: y, safeJSONParse: i, searchObjDate: ye, sessionStorage: na, setCssStyle: be, strToUnicode: we, throttle: Se, toArray: Pe, trim: d, unique: Ce, urlParse: f, urlSafeBase64: oa, values: ke, xhr: S }, la = [], ua2 = { appendWriter: function(e2) {
      la.push(e2);
    }, msg: function() {
      var e2 = { module: "", level: "log", brand: "web-sdk", content: null };
      e2.content = Array.prototype.slice.call(arguments);
      var t2 = { module: function(t3) {
        return p(t3) && (e2.module = t3), this;
      }, level: function(t3) {
        return p(t3) && (e2.level = t3), this;
      }, brand: function(t3) {
        return p(t3) && (e2.brand = t3), this;
      }, log: function() {
        if (e2.content && e2.content.length) {
          for (var t3 = 0; t3 < la.length; t3++)
            if (typeof la[t3] == "function")
              try {
                la[t3].call(null, e2);
              } catch (r2) {
              }
        }
        return this;
      } };
      return t2;
    } }, ca = {}, pa = { preset_properties: { search_keyword_baidu: false, latest_utm: true, latest_traffic_source_type: true, latest_search_keyword: true, latest_referrer: true, latest_referrer_host: false, latest_landing_page: false, latest_wx_ad_click_id: void 0, url: true, title: true }, encrypt_cookie: false, enc_cookie: false, img_use_crossorigin: false, name: "sa", max_referrer_string_length: 200, max_string_length: 500, max_id_length: 255, max_key_length: 100, cross_subdomain: true, show_log: false, is_debug: false, source_channel: [], sdk_id: "", vtrack_ignore: {}, auto_init: true, is_track_single_page: false, is_single_page: false, batch_send: false, source_type: {}, callback_timeout: 200, datasend_timeout: 8e3, is_track_device_id: false, ignore_oom: true, app_js_bridge: false }, da = "utm_source utm_medium utm_campaign utm_content utm_term", fa = "1.25.4", ga = "sensorsdata_domain_test", _a2 = { EMAIL: "$identity_email", MOBILE: "$identity_mobile", LOGIN: "$identity_login_id" }, ha = { get: function(e2) {
      return ta.get(e2);
    }, set: function(e2, t2, r2, n2) {
      var i2 = "";
      if (n2 = h(n2) ? ca.cross_subdomain : n2) {
        var a2 = Te(location.href);
        a2 === "url\u89E3\u6790\u5931\u8D25" && (a2 = ""), i2 = a2 ? "; domain=" + a2 : "";
      }
      return ta.set(e2, t2, r2, n2, ca.set_cookie_samesite, ca.is_secure_cookie, i2);
    }, remove: function(e2, t2) {
      return t2 = h(t2) ? ca.cross_subdomain : t2, ta.remove(e2, t2);
    }, isSupport: function(e2, t2) {
      return e2 = e2 || "sajssdk_2015_cookie_access_test", t2 = t2 || "1", ta.isSupport(e2, t2);
    } }, ma = { data: {}, id: function() {
      return this.data.id ? this.data.id : (this.data.id = Ae(), this.data.id);
    }, type: function() {
      return this.data.type ? this.data.type : (this.data.type = $e(), this.data.type);
    } }, va = { distinct_id: function() {
    }, jssdkDebug: function() {
    }, _sendDebug: function(e2) {
    }, apph5: function(e2) {
      var t2 = "app_h5\u6253\u901A\u5931\u8D25-", n2 = { 1: t2 + "use_app_track\u4E3Afalse", 2: t2 + "Android\u6216\u8005iOS\uFF0C\u6CA1\u6709\u66B4\u9732\u76F8\u5E94\u65B9\u6CD5", 3.1: t2 + "Android\u6821\u9A8Cserver_url\u5931\u8D25", 3.2: t2 + "iOS\u6821\u9A8Cserver_url\u5931\u8D25", 4.1: t2 + "H5 \u6821\u9A8C iOS server_url \u5931\u8D25", 4.2: t2 + "H5 \u6821\u9A8C Android server_url \u5931\u8D25" }, i2 = e2.output, a2 = e2.step, o2 = e2.data || "";
      i2 !== "all" && i2 !== "console" || Oe(n2[a2]), (i2 === "all" || i2 === "code") && r(ca.is_debug) && ca.is_debug.apph5 && (o2.type && o2.type.slice(0, 7) === "profile" || (o2.properties._jssdk_debug_info = "apph5-" + String(a2)));
    }, defineMode: function(e2) {
      var t2 = { 1: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 App SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "\u914D\u7F6E\u6587\u6863", link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html" }, 2: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 Web JS SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "\u914D\u7F6E\u6587\u6863", link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html" }, 3: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "Web JS SDK \u6CA1\u6709\u5F00\u542F\u5168\u57CB\u70B9\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "\u914D\u7F6E\u6587\u6863", link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all-1573964.html" }, 4: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "Web JS SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0E App SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "\u914D\u7F6E\u6587\u6863", link_url: "https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html" } };
      return !(!e2 || !t2[e2]) && t2[e2];
    }, protocol: { protocolIsSame: function(e2, t2) {
      try {
        if (g(e2).protocol !== g(t2).protocol)
          return false;
      } catch (r2) {
        return Ne("\u4E0D\u652F\u6301 _.URL \u65B9\u6CD5"), false;
      }
      return true;
    }, serverUrl: function() {
      p(ca.server_url) && ca.server_url !== "" && !this.protocolIsSame(ca.server_url, location.href) && Ne("SDK \u68C0\u6D4B\u5230\u60A8\u7684\u6570\u636E\u53D1\u9001\u5730\u5740\u548C\u5F53\u524D\u9875\u9762\u5730\u5740\u7684\u534F\u8BAE\u4E0D\u4E00\u81F4\uFF0C\u5EFA\u8BAE\u60A8\u4FEE\u6539\u6210\u4E00\u81F4\u7684\u534F\u8BAE\u3002\n\u56E0\u4E3A\uFF1A1\u3001https \u4E0B\u9762\u53D1\u9001 http \u7684\u56FE\u7247\u8BF7\u6C42\u4F1A\u5931\u8D25\u30022\u3001http \u9875\u9762\u4F7F\u7528 https + ajax \u65B9\u5F0F\u53D1\u6570\u636E\uFF0C\u5728 ie9 \u53CA\u4EE5\u4E0B\u4F1A\u4E22\u5931\u6570\u636E\u3002");
    }, ajax: function(e2) {
      return e2 !== ca.server_url && void (p(e2) && e2 !== "" && !this.protocolIsSame(e2, location.href) && Ne("SDK \u68C0\u6D4B\u5230\u60A8\u7684\u6570\u636E\u53D1\u9001\u5730\u5740\u548C\u5F53\u524D\u9875\u9762\u5730\u5740\u7684\u534F\u8BAE\u4E0D\u4E00\u81F4\uFF0C\u5EFA\u8BAE\u60A8\u4FEE\u6539\u6210\u4E00\u81F4\u7684\u534F\u8BAE\u3002\u56E0\u4E3A http \u9875\u9762\u4F7F\u7528 https + ajax \u65B9\u5F0F\u53D1\u6570\u636E\uFF0C\u5728 ie9 \u53CA\u4EE5\u4E0B\u4F1A\u4E22\u5931\u6570\u636E\u3002"));
    } } }, ya = { initPage: function() {
      var e2 = De(), t2 = Z(), r2 = Te(t2);
      r2 || va.jssdkDebug("url_domain\u5F02\u5E38_" + t2 + "_" + r2), this.pageProp = { referrer: e2, referrer_host: e2 ? q(e2) : "", url: t2, url_host: q(t2, "url_host\u53D6\u503C\u5F02\u5E38"), url_domain: r2 };
    }, pageProp: {}, campaignParams: function() {
      return Ki.kit.getUtmData();
    }, campaignParamsStandard: function(e2, t2) {
      e2 = e2 || "", t2 = t2 || "";
      var r2 = ya.campaignParams(), n2 = {}, i2 = {};
      return k(r2, function(r3, a2, o2) {
        (" " + da + " ").indexOf(" " + a2 + " ") !== -1 ? n2[e2 + a2] = o2[a2] : i2[t2 + a2] = o2[a2];
      }), { $utms: n2, otherUtms: i2 };
    }, properties: function() {
      var e2 = window.innerHeight || document.documentElement.clientHeight || document.body && document.body.clientHeight || 0, t2 = window.innerWidth || document.documentElement.clientWidth || document.body && document.body.clientWidth || 0, r2 = { $timezone_offset: new Date().getTimezoneOffset(), $screen_height: Number(screen.height) || 0, $screen_width: Number(screen.width) || 0, $viewport_height: e2, $viewport_width: t2, $lib: "js", $lib_version: fa };
      return r2;
    }, currentProps: {}, register: function(e2) {
      P(ya.currentProps, e2);
    } };
    ha.getNewUser = Re;
    var ba = { data: {}, get: function(e2) {
      var t2 = this.data[e2];
      return t2 === void 0 ? null : t2._expirationTimestamp_ !== void 0 ? new Date().getTime() > t2._expirationTimestamp_ ? null : t2.value : t2;
    }, set: function(e2, t2, r2) {
      if (r2) {
        var n2, i2 = new Date();
        n2 = String(r2).slice(-1) === "s" ? i2.getTime() + 1e3 * Number(String(r2).slice(0, -1)) : i2.getTime() + 24 * r2 * 60 * 60 * 1e3, t2 = { value: t2, _expirationTimestamp_: n2 };
      }
      this.data[e2] = t2;
    }, getNewUserFlagMemoryKey: function(e2) {
      return "sajssdk_2015_" + ca.sdk_id + e2;
    } }, wa = { checkIsAddSign: function(e2) {
      e2.type === "track" && (Re() ? e2.properties.$is_first_day = true : e2.properties.$is_first_day = false);
    }, is_first_visit_time: false, is_page_first_visited: false, checkIsFirstTime: function(e2) {
      e2.type === "track" && e2.event === "$pageview" && (this.is_first_visit_time ? (e2.properties.$is_first_time = true, this.is_first_visit_time = false) : e2.properties.$is_first_time = false);
    }, setDeviceId: function(e2, t2) {
      var r2 = null, n2 = ha.get("sensorsdata2015jssdkcross" + Ki.para.sdk_id);
      n2 = Ki.kit.userDecryptIfNeeded(n2);
      var i2 = {};
      n2 != null && ue(n2) && (i2 = JSON.parse(n2), i2.$device_id && (r2 = i2.$device_id)), r2 = r2 || e2, Ki.para.cross_subdomain === true ? t2.set("$device_id", r2) : (i2.$device_id = r2, i2 = JSON.stringify(i2), Ki.para.encrypt_cookie && (i2 = Ki.kit.userEncrypt(i2)), ha.set("sensorsdata2015jssdkcross" + Ki.para.sdk_id, i2, null, true)), Ki.para.is_track_device_id && (ya.currentProps.$device_id = r2);
    }, storeInitCheck: function() {
      if (Ki.is_first_visitor) {
        var e2 = new Date(), t2 = { h: 23 - e2.getHours(), m: 59 - e2.getMinutes(), s: 59 - e2.getSeconds() };
        ha.isSupport() ? ha.set(Ue("new_user"), "1", 3600 * t2.h + 60 * t2.m + t2.s + "s") : ba.set(ba.getNewUserFlagMemoryKey("new_user"), "1", 3600 * t2.h + 60 * t2.m + t2.s + "s"), this.is_first_visit_time = true, this.is_page_first_visited = true;
      } else
        Re() || (this.checkIsAddSign = function(e3) {
          e3.type === "track" && (e3.properties.$is_first_day = false);
        }), this.checkIsFirstTime = function(e3) {
          e3.type === "track" && e3.event === "$pageview" && (e3.properties.$is_first_time = false);
        };
    } }, Sa = function() {
      this._events = [], this.pendingEvents = [];
    };
    Sa.prototype = { emit: function(e2) {
      var t2 = [].slice.call(arguments, 1);
      k(this._events, function(r2) {
        r2.type === e2 && r2.callback.apply(r2.context, t2);
      }), this.pendingEvents.push({ type: e2, data: t2 }), this.pendingEvents.length > 20 ? this.pendingEvents.shift() : null;
    }, on: function(t2, r2, n2, i2) {
      e(r2) && (this._events.push({ type: t2, callback: r2, context: n2 || this }), i2 = i2 !== false, this.pendingEvents.length > 0 && i2 && k(this.pendingEvents, function(e2) {
        e2.type === t2 && r2.apply(n2, e2.data);
      }));
    }, tempAdd: function(e2, t2) {
      if (t2 && e2)
        return this.emit(e2, t2);
    }, isReady: function() {
    } };
    var ka = function(e2) {
      this.callback = e2.callback, this.server_url = e2.server_url, this.data = e2.data;
    };
    ka.prototype.start = function() {
      var e2 = this;
      Ze({ url: this.server_url, type: "POST", data: this.data, credentials: false, timeout: ca.datasend_timeout, cors: true, success: function() {
        e2.end();
      }, error: function() {
        e2.end();
      } });
    }, ka.prototype.end = function() {
      if (this.callback) {
        if (Oe("warning: sdk callback is deprecated."), !e(this.callback))
          return void Oe("error: sdk callback must be function.");
        this.callback();
      }
    };
    var Pa = "sawebjssdk-", Ca = "tab-sawebjssdk-";
    Ye.prototype = { batchInterval: function() {
      this.serverUrl === "" && this.getServerUrl(), this.hasTabStorage || (this.generateTabStorage(), this.hasTabStorage = true);
      var e2 = this;
      e2.timer = setTimeout(function() {
        e2.updateExpireTime(), e2.recycle(), e2.send(), clearTimeout(e2.timer), e2.batchInterval();
      }, ca.batch_send.send_interval);
    }, getServerUrl: function() {
      return p(ca.server_url) && ca.server_url !== "" || v(ca.server_url) && ca.server_url.length ? void (this.serverUrl = v(ca.server_url) ? ca.server_url[0] : ca.server_url) : je("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01");
    }, send: function() {
      if (!(this.sendTimeStamp && t() - this.sendTimeStamp < ca.batch_send.datasend_timeout)) {
        var e2 = zi.get(this.tabKey);
        if (e2) {
          this.sendTimeStamp = t(), e2 = i(e2) || this.generateTabStorageVal();
          var r2 = Ce(e2.data);
          if (r2.length) {
            for (var n2 = [], a2 = 0; a2 < r2.length; a2++)
              n2.push(Ki.store.readObjectVal(r2[a2]));
            this.request(n2, e2.data);
          }
        }
      }
    }, updateExpireTime: function() {
      var e2 = zi.get(this.tabKey);
      e2 && (e2 = i(e2) || this.generateTabStorageVal(), e2.expireTime = t() + 2 * ca.batch_send.send_interval, e2.serverUrl = this.serverUrl, zi.set(this.tabKey, JSON.stringify(e2)));
    }, request: function(e2, t2) {
      var r2 = this;
      Ze({ url: this.serverUrl, type: "POST", data: "data_list=" + encodeURIComponent(j(JSON.stringify(e2))), credentials: false, timeout: ca.batch_send.datasend_timeout, cors: true, success: function() {
        r2.remove(t2), r2.sendTimeStamp = 0;
      }, error: function() {
        r2.sendTimeStamp = 0;
      } });
    }, remove: function(e2) {
      var t2 = zi.get(this.tabKey);
      if (t2) {
        for (var r2 = (i(t2) || this.generateTabStorageVal()).data, n2 = 0; n2 < e2.length; n2++) {
          var a2 = re(r2, e2[n2]);
          a2 > -1 && r2.splice(a2, 1), zi.remove(e2[n2]);
        }
        r2 = Ce(r2), zi.set(this.tabKey, JSON.stringify(this.generateTabStorageVal(r2)));
      }
    }, add: function(e2) {
      var r2 = Pa + String(n()), a2 = zi.get(this.tabKey);
      a2 === null ? (this.tabKey = Ca + String(n()), a2 = this.generateTabStorageVal()) : a2 = i(a2) || this.generateTabStorageVal(), a2.data.push(r2), a2.expireTime = t() + 2 * ca.batch_send.send_interval, zi.set(this.tabKey, JSON.stringify(a2)), Ki.store.saveObjectVal(r2, e2), e2.type !== "track_signup" && e2.event !== "$pageview" || this.sendImmediately();
    }, generateTabStorage: function() {
      this.tabKey = Ca + String(n()), zi.set(this.tabKey, JSON.stringify(this.generateTabStorageVal()));
    }, generateTabStorageVal: function(e2) {
      return e2 = e2 || [], { data: e2, expireTime: t() + 2 * ca.batch_send.send_interval, serverUrl: this.serverUrl };
    }, sendImmediately: function() {
      this.send();
    }, recycle: function() {
      for (var e2 = {}, r2 = 1e4, n2 = "sajssdk-lock-get-", o2 = 0; o2 < localStorage.length; o2++) {
        var s2 = localStorage.key(o2), l2 = this;
        if (s2.indexOf(Ca) === 0) {
          for (var u2 = i(zi.get(s2)) || this.generateTabStorageVal(), c2 = 0; c2 < u2.data.length; c2++)
            e2[u2.data[c2]] = true;
          if (s2 !== l2.tabKey && t() > u2.expireTime && this.serverUrl === u2.serverUrl) {
            var p2 = new a(n2);
            p2.get(s2, r2, 1e3, function(e3) {
              if (e3) {
                zi.get(l2.tabKey) === null && l2.generateTabStorage();
                var t2 = i(e3) || l2.generateTabStorageVal(), r3 = i(zi.get(l2.tabKey)) || l2.generateTabStorageVal();
                r3.data = Ce(r3.data.concat(t2.data)), zi.set(l2.tabKey, JSON.stringify(r3));
              }
            });
          }
        } else if (s2.indexOf(n2) === 0) {
          var d2 = i(zi.get(s2)) || { expireTime: 0 };
          t() - d2.expireTime > r2 && zi.remove(s2);
        }
      }
      for (var f2 = 0; f2 < localStorage.length; f2++) {
        var g2 = localStorage.key(f2);
        g2.indexOf(Pa) !== 0 || e2[g2] || zi.remove(g2);
      }
    } };
    var Oa = function(e2) {
      this.callback = e2.callback, this.server_url = e2.server_url, this.data = e2.data;
    };
    Oa.prototype.start = function() {
      var e2 = this;
      typeof navigator == "object" && typeof navigator.sendBeacon == "function" && navigator.sendBeacon(this.server_url, this.data), setTimeout(function() {
        e2.end();
      }, 40);
    }, Oa.prototype.end = function() {
      if (this.callback) {
        if (Oe("warning: sdk callback is deprecated."), !e(this.callback))
          return void Oe("error: sdk callback must be function.");
        this.callback();
      }
    };
    var Na = function(e2) {
      this.callback = e2.callback, this.img = document.createElement("img"), this.img.width = 1, this.img.height = 1, ca.img_use_crossorigin && (this.img.crossOrigin = "anonymous"), this.server_url = e2.data;
    };
    Na.prototype.start = function() {
      var e2 = this;
      ca.ignore_oom && (this.img.onload = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e2.end();
      }, this.img.onerror = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e2.end();
      }, this.img.onabort = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e2.end();
      }), this.img.src = this.server_url;
    }, Na.prototype.lastClear = function() {
      var e2 = X();
      e2.ie !== void 0 ? this.img.src = "about:blank" : this.img.src = "";
    }, Na.prototype.end = function() {
      if (this.callback) {
        if (Oe("warning: sdk callback is deprecated."), !e(this.callback))
          return void Oe("error: sdk callback must be function.");
        this.callback();
      }
      var t2 = this;
      setTimeout(function() {
        t2.lastClear && t2.lastClear();
      }, ca.datasend_timeout - ca.callback_timeout);
    };
    var ja = { __proto__: null, addEvent: He, EventEmitterSa: Sa, cookie: ha, info: ya, getReferrer: De, getCurrentDomain: Te, isBaiduTraffic: Ie, getReferrerEqid: Ae, getReferrerEqidType: $e, getBaiduKeyword: ma, isReferralTraffic: xe, getKeywordFromReferrer: Ee, getReferSearchEngine: Le, getSourceFromReferrer: Be, getWxAdIdFromUrl: Je, parseSuperProperties: Me, searchConfigData: qe, strip_empty_properties: Ke, getEleInfo: ze, getElementContent: Xe, ajax: Ze, optimizeServerUrl: Ge, encodeTrackData: Qe, AjaxSend: ka, BatchSend: Ye, BeaconSend: Oa, ImageSend: Na }, Ta = new Sa(), Ia = { requests: [], _sessionState: {}, _state: { distinct_id: "", first_id: "", props: {}, identities: {} }, getProps: function() {
      return this._state.props || {};
    }, getSessionProps: function() {
      return this._sessionState;
    }, getOriginDistinctId: function() {
      return this._state._distinct_id || this._state.distinct_id;
    }, getOriginUnionId: function(e2) {
      var t2 = {};
      e2 = e2 || this._state;
      var r2 = e2._first_id || e2.first_id, n2 = e2._distinct_id || e2.distinct_id;
      return r2 && n2 ? (t2.login_id = n2, t2.anonymous_id = r2) : t2.anonymous_id = n2, t2;
    }, getDistinctId: function() {
      var e2 = this.getUnionId();
      return e2.login_id || e2.anonymous_id;
    }, getUnionId: function(e2) {
      var t2 = this.getOriginUnionId(e2);
      return t2.login_id && this._state.history_login_id && this._state.history_login_id.name && this._state.history_login_id.name !== _a2.LOGIN && (t2.login_id = this._state.history_login_id.name + "+" + t2.login_id), t2;
    }, getFirstId: function() {
      return this._state._first_id || this._state.first_id;
    }, initSessionState: function() {
      var e2 = ha.get("sensorsdata2015session");
      e2 = Ki.kit.userDecryptIfNeeded(e2);
      var t2 = null;
      e2 !== null && typeof (t2 = i(e2)) == "object" && (this._sessionState = t2 || {});
    }, setOnce: function(e2, t2) {
      e2 in this._state || this.set(e2, t2);
    }, set: function(e2, t2) {
      this._state = this._state || {};
      var r2 = this._state.distinct_id;
      this._state[e2] = t2, e2 === "first_id" ? delete this._state._first_id : e2 === "distinct_id" && delete this._state._distinct_id, this.save(), e2 === "distinct_id" && r2 && Ta.tempAdd("changeDistinctId", t2);
    }, change: function(e2, t2) {
      this._state["_" + e2] = t2;
    }, setSessionProps: function(e2) {
      Ki.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE");
      var t2 = this._sessionState;
      P(t2, e2), this.sessionSave(t2);
    }, setSessionPropsOnce: function(e2) {
      Ki.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE");
      var t2 = this._sessionState;
      I(t2, e2), this.sessionSave(t2);
    }, setProps: function(e2, t2) {
      var r2 = {};
      r2 = t2 ? e2 : P(this._state.props || {}, e2);
      for (var n2 in r2)
        typeof r2[n2] == "string" && (r2[n2] = r2[n2].slice(0, Ki.para.max_referrer_string_length));
      this.set("props", r2);
    }, setPropsOnce: function(e2) {
      var t2 = this._state.props || {};
      I(t2, e2), this.set("props", t2);
    }, clearAllProps: function(e2) {
      this._sessionState = {};
      var t2;
      if (v(e2) && e2.length > 0)
        for (t2 = 0; t2 < e2.length; t2++)
          p(e2[t2]) && e2[t2].indexOf("latest_") === -1 && r(this._state.props) && e2[t2] in this._state.props && delete this._state.props[e2[t2]];
      else if (r(this._state.props))
        for (t2 in this._state.props)
          t2.indexOf("latest_") !== 1 && delete this._state.props[t2];
      this.sessionSave({}), this.save();
    }, sessionSave: function(e2) {
      Ki.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE"), this._sessionState = e2;
      var t2 = JSON.stringify(this._sessionState);
      Ki.para.encrypt_cookie && (t2 = Ki.kit.userEncrypt(t2)), ha.set("sensorsdata2015session", t2, 0);
    }, save: function() {
      var e2 = JSON.parse(JSON.stringify(this._state));
      delete e2._first_id, delete e2._distinct_id, e2.identities && (e2.identities = j(JSON.stringify(e2.identities)));
      var t2 = JSON.stringify(e2);
      Ki.para.encrypt_cookie && (t2 = Ki.kit.userEncrypt(t2)), ha.set(this.getCookieName(), t2, 73e3, Ki.para.cross_subdomain);
    }, getCookieName: function() {
      var e2 = "";
      if (Ki.para.cross_subdomain === false) {
        try {
          e2 = g(location.href).hostname;
        } catch (t2) {
          Ne(t2);
        }
        e2 = typeof e2 == "string" && e2 !== "" ? "sa_jssdk_2015_" + Ki.para.sdk_id + e2.replace(/\./g, "_") : "sa_jssdk_2015_root" + Ki.para.sdk_id;
      } else
        e2 = "sensorsdata2015jssdkcross" + Ki.para.sdk_id;
      return e2;
    }, init: function() {
      function e2(e3) {
        var t3;
        e3.identities && (e3.identities.indexOf("\n/") === 0 ? e3.identities = i(ve(e3.identities)) : e3.identities = i(N(e3.identities)));
        var n3 = Ia.getOriginUnionId(e3);
        e3.identities && r(e3.identities) && !oe(e3.identities) || (e3.identities = {}, e3.identities.$identity_cookie_id = Xi()), e3.history_login_id = e3.history_login_id || {};
        var a3 = e3.history_login_id, o3 = a3.name;
        if (n3.login_id)
          if (o3 && e3.identities.hasOwnProperty(o3)) {
            if (e3.identities[o3] !== n3.login_id) {
              e3.identities[o3] = n3.login_id;
              for (t3 in e3.identities)
                e3.identities.hasOwnProperty(t3) && t3 !== "$identity_cookie_id" && t3 !== o3 && delete e3.identities[t3];
              e3.history_login_id.value = n3.login_id;
            }
          } else {
            var s2 = o3 || _a2.LOGIN;
            e3.identities[s2] = n3.login_id;
            for (t3 in e3.identities)
              e3.identities.hasOwnProperty(t3) && t3 !== "$identity_cookie_id" && t3 !== s2 && delete e3.identities[t3];
            e3.history_login_id = { name: s2, value: n3.login_id };
          }
        else {
          if (e3.identities.hasOwnProperty("$identity_login_id") || e3.identities.hasOwnProperty(o3))
            for (t3 in e3.identities)
              e3.identities.hasOwnProperty(t3) && t3 !== "$identity_cookie_id" && t3 !== "$identity_anonymous_id" && delete e3.identities[t3];
          e3.history_login_id = { name: "", value: "" };
        }
        return e3;
      }
      function t2(e3) {
        Ia.set("distinct_id", e3), Ia.set("identities", { $identity_cookie_id: e3 }), Ia.set("history_login_id", { name: "", value: "" });
      }
      this.initSessionState();
      var n2, a2, o2 = Xi();
      ha.isSupport() && (n2 = ha.get(this.getCookieName()), n2 = Ki.kit.userDecryptIfNeeded(n2), a2 = i(n2)), ha.isSupport() && n2 !== null && ue(n2) && r(a2) && (!r(a2) || a2.distinct_id) ? (Ia._state = P(e2(a2)), Ia.save()) : (Ki.is_first_visitor = true, t2(o2)), wa.setDeviceId(o2, this), wa.storeInitCheck();
    }, saveObjectVal: function(e2, t2) {
      p(t2) || (t2 = JSON.stringify(t2)), Ki.para.encrypt_cookie == 1 && (t2 = Ki.kit.userEncrypt(t2)), zi.set(e2, t2);
    }, readObjectVal: function(e2) {
      var t2 = zi.get(e2);
      return t2 ? (t2 = Ki.kit.userDecryptIfNeeded(t2), i(t2)) : null;
    } }, $a = { string: function(e2) {
      Ne(e2 + " must be string");
    }, emptyString: function(e2) {
      Ne(e2 + "'s is empty");
    }, regexTest: function(e2) {
      Ne(e2 + " is invalid");
    }, idLength: function(e2) {
      Ne(e2 + " length is longer than " + ca.max_id_length);
    }, keyLength: function(e2) {
      Ne(e2 + " length is longer than " + ca.max_key_length);
    }, stringLength: function(e2) {
      Ne(e2 + " length is longer than " + ca.max_string_length);
    }, voidZero: function(e2) {
      Ne(e2 + "'s is undefined");
    }, reservedLoginId: function(e2) {
      Ne(e2 + " is invalid");
    }, reservedBind: function(e2) {
      Ne(e2 + " is invalid");
    }, reservedUnbind: function(e2) {
      Ne(e2 + " is invalid");
    } }, Aa = { regName: /^((?!^distinct_id$|^original_id$|^time$|^properties$|^id$|^first_id$|^second_id$|^users$|^events$|^event$|^user_id$|^date$|^datetime$|^user_tag.*|^user_group.*)[a-zA-Z_$][a-zA-Z\d_$]*)$/i, loginIDReservedNames: ["$identity_anonymous_id", "$identity_cookie_id"], bindReservedNames: ["$identity_login_id", "$identity_anonymous_id", "$identity_cookie_id"], unbindReservedNames: ["$identity_anonymous_id", _a2.LOGIN], string: function(e2) {
      return !!p(e2);
    }, emptyString: function(e2) {
      return !(!p(e2) || d(e2).length === 0);
    }, regexTest: function(e2) {
      return !(!p(e2) || !this.regName.test(e2));
    }, idLength: function(e2) {
      return !(!p(e2) || e2.length > ca.max_id_length);
    }, keyLength: function(e2) {
      return !(!p(e2) || e2.length > ca.max_key_length);
    }, stringLength: function(e2) {
      return !(!p(e2) || e2.length > ca.max_string_length);
    }, voidZero: function(e2) {
      return e2 !== void 0;
    }, reservedLoginId: function(e2) {
      return !(re(this.loginIDReservedNames, e2) > -1);
    }, reservedUnbind: function(e2) {
      return !(re(this.unbindReservedNames, e2) > -1);
    }, reservedBind: function(e2) {
      var t2 = Ia._state.history_login_id;
      return (!t2 || !t2.name || t2.name !== e2) && !(re(this.bindReservedNames, e2) > -1);
    } }, Da = { distinct_id: { rules: ["string", "emptyString", "idLength"], onComplete: function(t2, r2, n2) {
      return !t2 && (n2 === "emptyString" && (r2 = "Id"), e($a[n2]) && $a[n2](r2), n2 === "idLength") || t2;
    } }, event: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(t2, r2, n2) {
      return t2 || (n2 === "emptyString" && (r2 = "eventName"), e($a[n2]) && $a[n2](r2)), true;
    } }, propertyKey: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(t2, r2, n2) {
      return t2 || (n2 === "emptyString" && (r2 = "Property key"), e($a[n2]) && $a[n2](r2)), true;
    } }, propertyValue: { rules: ["voidZero"], onComplete: function(t2, r2, n2) {
      return t2 || (r2 = "Property Value", e($a[n2]) && $a[n2](r2)), true;
    } }, properties: function(t2) {
      return r(t2) ? k(t2, function(t3, r2) {
        et({ propertyKey: r2 });
        var n2 = function(t4, n3, i2) {
          return t4 || (n3 = r2 + "'s Value", e($a[i2]) && $a[i2](n3)), true;
        };
        et({ propertyValue: t3 }, n2);
      }) : Aa.voidZero(t2) && Ne("properties\u53EF\u4EE5\u6CA1\u6709\uFF0C\u4F46\u6709\u7684\u8BDD\u5FC5\u987B\u662F\u5BF9\u8C61"), true;
    }, propertiesMust: function(e2) {
      return e2 !== void 0 && r(e2) && !oe(e2) ? this.properties.call(this, e2) : Ne("properties\u5FC5\u987B\u662F\u5BF9\u8C61"), true;
    }, item_type: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(t2, r2, n2) {
      return t2 || (n2 === "emptyString" && (r2 = "item_type"), e($a[n2]) && $a[n2](r2)), true;
    } }, item_id: { rules: ["string", "emptyString", "stringLength"], onComplete: function(t2, r2, n2) {
      return t2 || (n2 === "emptyString" && (r2 = "item_id"), e($a[n2]) && $a[n2](r2)), true;
    } }, loginIdKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedLoginId"], onComplete: function(t2, r2, n2) {
      return !t2 && (n2 === "emptyString" && (r2 = "login_id_key"), e($a[n2]) && $a[n2](r2), n2 === "keyLength") || t2;
    } }, bindKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedBind"], onComplete: function(t2, r2, n2) {
      return !t2 && (n2 === "emptyString" && (r2 = "Key"), e($a[n2]) && $a[n2](r2), n2 === "keyLength") || t2;
    } }, unbindKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedUnbind"], onComplete: function(t2, r2, n2) {
      return !t2 && (n2 === "emptyString" && (r2 = "Key"), e($a[n2]) && $a[n2](r2), n2 === "keyLength") || t2;
    } }, bindValue: { rules: ["string", "emptyString", "idLength"], onComplete: function(t2, r2, n2) {
      return !t2 && (n2 === "emptyString" && (r2 = "Value"), e($a[n2]) && $a[n2](r2), n2 === "idLength") || t2;
    } }, check: function(t2, r2, n2) {
      var i2 = this[t2];
      if (e(i2))
        return i2.call(this, r2);
      if (!i2)
        return false;
      for (var a2 = 0; a2 < i2.rules.length; a2++) {
        var o2 = i2.rules[a2], s2 = Aa[o2](r2), l2 = e(n2) ? n2(s2, r2, o2) : i2.onComplete(s2, r2, o2);
        if (!s2)
          return l2;
      }
      return true;
    } }, xa = {};
    xa.initUrl = function() {
      var e2, t2 = { server_url: { project: "", host: "" }, page_url: { host: "", pathname: "" } };
      if (!se(Ki.para.server_url))
        return je("----vcollect---server_url\u5FC5\u987B\u4E3A\u6709\u6548 URL \u5B57\u7B26\u4E32"), false;
      try {
        e2 = g(Ki.para.server_url), t2.server_url.project = e2.searchParams.get("project") || "default", t2.server_url.host = e2.host;
      } catch (r2) {
        return je("----vcollect---server_url\u89E3\u6790\u5F02\u5E38", r2), false;
      }
      var n2;
      try {
        n2 = g(location.href), t2.page_url.host = n2.hostname, t2.page_url.pathname = n2.pathname;
      } catch (r2) {
        return je("----vcollect---\u9875\u9762\u5730\u5740\u89E3\u6790\u5F02\u5E38", r2), false;
      }
      return t2;
    }, xa.isDiv = function(e2) {
      if (e2.element_path) {
        var t2 = e2.element_path.split(">"), r2 = d(t2.pop());
        if (r2.slice(0, 3) !== "div")
          return false;
      }
      return true;
    }, xa.configIsMatchNew = function(e2, t2) {
      if (p(e2.$element_selector) && p(t2.element_selector)) {
        if (t2.element_field === "element_selector" && t2["function"] === "equal")
          return e2.$element_selector === t2.element_selector;
        if (t2.element_field === "element_selector" && t2["function"] === "contain")
          return e2.$element_selector.indexOf(t2.element_selector) > -1;
      }
      if (p(e2.$element_path) && p(t2.element_path)) {
        if (t2.element_field === "element_path" && t2["function"] === "equal")
          return e2.$element_path === t2.element_path;
        if (t2.element_field === "element_path" && t2["function"] === "contain")
          return e2.$element_path.indexOf(t2.element_path) > -1;
      }
      return false;
    }, xa.configIsMatch = function(e2, t2) {
      return (!t2.limit_element_content || t2.element_content === e2.$element_content) && ((!t2.limit_element_position || t2.element_position === String(e2.$element_position)) && (t2.element_field && t2["function"] ? xa.configIsMatchNew(e2, t2) : xa.configIsMatchOldVersion(e2, t2)));
    }, xa.configIsMatchOldVersion = function(e2, t2) {
      if (!t2.element_path)
        return false;
      if (e2.$element_position !== void 0) {
        if (t2.element_path !== e2.$element_path)
          return false;
      } else if (xa.isDiv({ element_path: t2.element_path })) {
        if (e2.$element_path.indexOf(t2.element_path) < 0)
          return false;
      } else if (t2.element_path !== e2.$element_path)
        return false;
      return true;
    }, xa.filterConfig = function(e2, t2, n2) {
      var i2 = [];
      if (!n2) {
        var a2 = xa.initUrl();
        if (!a2)
          return [];
        n2 = a2.page_url;
      }
      return e2.event === "$WebClick" && k(t2, function(t3) {
        r(t3) && (t3.event_type === "webclick" || t3.event_type === "appclick") && r(t3.event) && t3.event.url_host === n2.host && t3.event.url_path === n2.pathname && xa.configIsMatch(e2.properties, t3.event) && i2.push(t3);
      }), i2;
    }, xa.getPropElInLi = function(e2, t2) {
      if (!(e2 && _(e2) && p(t2)))
        return null;
      if (e2.tagName.toLowerCase() !== "li")
        return null;
      var r2, n2 = Ki.heatmap.getDomSelector(e2);
      if (n2) {
        r2 = n2 + t2;
        var i2 = J(r2);
        return i2 ? i2 : null;
      }
      return Ne("----custom---\u83B7\u53D6\u540C\u7EA7\u5C5E\u6027\u5143\u7D20\u5931\u8D25\uFF0Cselector\u4FE1\u606F\u5F02\u5E38", n2, t2), null;
    }, xa.getProp = function(e2, t2) {
      if (!r(e2))
        return false;
      if (!(p(e2.name) && e2.name.length > 0))
        return Ne("----vcustom----\u5C5E\u6027\u540D\u4E0D\u5408\u6CD5,\u5C5E\u6027\u629B\u5F03", e2.name), false;
      var n2, i2, a2 = {};
      if (e2.method === "content") {
        var o2;
        if (p(e2.element_selector) && e2.element_selector.length > 0)
          o2 = J(e2.element_selector);
        else {
          if (!t2 || !p(e2.list_selector))
            return Ne("----vcustom----\u5C5E\u6027\u914D\u7F6E\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name), false;
          var s2 = J(t2.properties.$element_selector);
          if (!s2)
            return Ne("----vcustom----\u70B9\u51FB\u5143\u7D20\u83B7\u53D6\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name), false;
          var l2 = Ki.heatmap.getClosestLi(s2);
          o2 = xa.getPropElInLi(l2, e2.list_selector);
        }
        if (!o2 || !_(o2))
          return Ne("----vcustom----\u5C5E\u6027\u5143\u7D20\u83B7\u53D6\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name), false;
        if (o2.tagName.toLowerCase() === "input")
          n2 = o2.value || "";
        else if (o2.tagName.toLowerCase() === "select") {
          var u2 = o2.selectedIndex;
          ce(u2) && _(o2[u2]) && (n2 = Xe(o2[u2], "select"));
        } else
          n2 = Xe(o2, o2.tagName.toLowerCase());
        if (e2.regular) {
          try {
            i2 = new RegExp(e2.regular).exec(n2);
          } catch (c2) {
            return Ne("----vcustom----\u6B63\u5219\u5904\u7406\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name), false;
          }
          if (i2 === null)
            return Ne("----vcustom----\u5C5E\u6027\u89C4\u5219\u5904\u7406\uFF0C\u672A\u5339\u914D\u5230\u7ED3\u679C,\u5C5E\u6027\u629B\u5F03", e2.name), false;
          if (!v(i2) || !p(i2[0]))
            return Ne("----vcustom----\u6B63\u5219\u5904\u7406\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name, i2), false;
          n2 = i2[0];
        }
        if (e2.type === "STRING")
          a2[e2.name] = n2;
        else if (e2.type === "NUMBER") {
          if (n2.length < 1)
            return Ne("----vcustom----\u672A\u83B7\u53D6\u5230\u6570\u5B57\u5185\u5BB9\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name, n2), false;
          if (isNaN(Number(n2)))
            return Ne("----vcustom----\u6570\u5B57\u7C7B\u578B\u5C5E\u6027\u8F6C\u6362\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e2.name, n2), false;
          a2[e2.name] = Number(n2);
        }
        return a2;
      }
      return je("----vcustom----\u5C5E\u6027\u4E0D\u652F\u6301\u6B64\u83B7\u53D6\u65B9\u5F0F", e2.name, e2.method), false;
    }, xa.getAssignConfigs = function(e2, t2) {
      var n2 = xa.initUrl();
      if (!n2 || !n2.page_url)
        return [];
      if (!r(t2))
        return [];
      var i2 = [];
      return t2.events = t2.events || t2.eventList, v(t2.events) && t2.events.length > 0 ? (k(t2.events, function(t3) {
        r(t3) && r(t3.event) && t3.event.url_host === n2.page_url.host && t3.event.url_path === n2.page_url.pathname && e2(t3) && i2.push(t3);
      }), i2) : [];
    };
    var Ea = { events: [], getAssignConfigs: xa.getAssignConfigs, filterConfig: xa.filterConfig, getProp: xa.getProp, initUrl: xa.initUrl, updateEvents: function(e2) {
      v(e2) && (this.events = e2);
    }, init: function() {
      this.initAppGetPropsBridge();
    }, geth5Props: function(e2) {
      var t2 = {}, n2 = [], i2 = this;
      if (!this.events.length)
        return {};
      if (e2.event === "$WebClick") {
        var a2 = this.filterConfig(e2, this.events);
        if (!a2.length)
          return {};
        k(a2, function(a3) {
          r(a3) && (v(a3.properties) && a3.properties.length > 0 && k(a3.properties, function(n3) {
            if (r(n3))
              if (n3.h5 === false)
                v(t2.sensorsdata_app_visual_properties) || (t2.sensorsdata_app_visual_properties = []), t2.sensorsdata_app_visual_properties.push(n3);
              else {
                var a4 = i2.getProp(n3, e2);
                r(a4) && (t2 = P(t2, a4));
              }
          }), p(a3.event_name) && n2.push(a3.event_name));
        }), Ki.bridge.hasVisualModeBridge() && (t2.sensorsdata_web_visual_eventName = n2);
      }
      return t2.sensorsdata_app_visual_properties && (t2.sensorsdata_app_visual_properties = j(JSON.stringify(t2.sensorsdata_app_visual_properties))), t2;
    }, initAppGetPropsBridge: function() {
      var e2 = this, t2 = new Ki.SDKJSBridge("getJSVisualProperties");
      return t2.onAppNotify(function(n2) {
        var i2 = {};
        try {
          n2 = JSON.parse(N(n2));
        } catch (a2) {
          je("getJSVisualProperties data parse error!");
        }
        if (r(n2)) {
          var o2 = n2.sensorsdata_js_visual_properties, s2 = e2.initUrl();
          s2 && (s2 = s2.page_url, v(o2) && o2.length > 0 && k(o2, function(t3) {
            if (r(t3) && t3.url_host === s2.host && t3.url_path === s2.pathname && t3.h5) {
              var n3 = e2.getProp(t3);
              r(n3) && (i2 = P(i2, n3));
            }
          }));
        }
        var l2 = Ki.bridge.bridge_info.platform;
        return l2 === "android" && t2.notifyApp({ data: i2 }, n2.message_id), i2;
      }), t2;
    } }, La = { events: [], customProp: Ea, getAssignConfigs: xa.getAssignConfigs, initUrl: xa.initUrl, init: function() {
      if (this.initUrl()) {
        var e2 = this.getConfigFromApp();
        e2 && this.updateConfigs(e2), this.customProp.init(), this.initAppUpdateConfigBridge();
      }
    }, initAppUpdateConfigBridge: function() {
      var e2 = this;
      return new Ki.SDKJSBridge("updateH5VisualConfig").onAppNotify(function(t2) {
        if (t2) {
          try {
            t2 = JSON.parse(N(t2));
          } catch (r2) {
            return void je("updateH5VisualConfig result parse error\uFF01");
          }
          e2.updateConfigs(t2);
        }
      });
    }, getConfigFromApp: function() {
      var e2 = new Ki.SDKJSBridge("sensorsdata_get_app_visual_config").notifyApp();
      if (e2)
        try {
          e2 = JSON.parse(N(e2));
        } catch (t2) {
          e2 = null, je("getAppVisualConfig result parse error\uFF01");
        }
      return e2;
    }, updateConfigs: function(e2) {
      this.events = this.filterConfigs(e2), this.customProp.updateEvents(this.events);
    }, filterConfigs: function(e2) {
      return this.getAssignConfigs(function(e3) {
        return !(!r(e3) || e3.h5 === false);
      }, e2);
    } }, Ua = { events: [], init: function(e2) {
      this.filterWebClickEvents(e2);
    }, filterWebClickEvents: function(e2) {
      this.events = Ha.getAssignConfigs(function(e3) {
        return !(!r(e3) || e3.event.unlimited_div !== true || e3.event_type !== "webclick");
      }, e2);
    }, isTargetEle: function(e2) {
      var t2 = Ki.heatmap.getEleDetail(e2);
      if (!r(t2) || !p(t2.$element_path))
        return false;
      for (var n2 = 0; n2 < this.events.length; n2++)
        if (r(this.events[n2]) && r(this.events[n2].event) && Ha.configIsMatch(t2, this.events[n2].event))
          return true;
      return false;
    } }, Ra = { events: [], configSwitch: false, collectAble: function() {
      return this.configSwitch && r(Ki.para.heatmap) && Ki.para.heatmap.get_vtrack_config;
    }, updateEvents: function(e2) {
      this.events = Ha.getAssignConfigs(function(e3) {
        return !!(r(e3) && v(e3.properties) && e3.properties.length > 0);
      }, e2), this.events.length ? this.configSwitch = true : this.configSwitch = false;
    }, getVtrackProps: function(e2) {
      var t2 = {};
      return this.collectAble() ? (e2.event === "$WebClick" && (t2 = this.clickCustomPropMaker(e2, this.events)), t2) : {};
    }, clickCustomPropMaker: function(e2, t2, n2) {
      var i2 = this;
      n2 = n2 || this.filterConfig(e2, t2, Ha.url_info.page_url);
      var a2 = {};
      return n2.length ? (k(n2, function(t3) {
        v(t3.properties) && t3.properties.length > 0 && k(t3.properties, function(t4) {
          var n3 = i2.getProp(t4, e2);
          r(n3) && P(a2, n3);
        });
      }), a2) : {};
    }, getProp: xa.getProp, getPropElInLi: xa.getPropElInLi, filterConfig: xa.filterConfig }, Ha = { unlimitedDiv: Ua, config: {}, storageEnable: true, storage_name: "webjssdkvtrackcollect", para: { session_time: 18e5, timeout: 5e3, update_interval: 18e5 }, url_info: {}, timer: null, update_time: null, customProp: Ra, initUrl: function() {
      var e2 = xa.initUrl();
      if (e2) {
        var t2;
        try {
          t2 = new f(Ki.para.server_url), t2._values.Path = "/config/visualized/Web.conf", e2.api_url = t2.getUrl();
        } catch (r2) {
          return je("----vtrackcollect---API\u5730\u5740\u89E3\u6790\u5F02\u5E38", r2), false;
        }
        this.url_info = e2;
      }
      return e2;
    }, init: function() {
      if (!r(Ki.para.heatmap) || !Ki.para.heatmap.get_vtrack_config)
        return false;
      if (zi.isSupport() || (this.storageEnable = false), !this.initUrl())
        return je("----vtrackcustom----\u521D\u59CB\u5316\u5931\u8D25\uFF0Curl\u4FE1\u606F\u89E3\u6790\u5931\u8D25"), false;
      if (this.storageEnable) {
        var e2 = Ia.readObjectVal(this.storage_name);
        if (r(e2) && r(e2.data))
          if (this.serverUrlIsSame(e2.serverUrl)) {
            this.config = e2.data, this.update_time = e2.updateTime, this.updateConfig(e2.data);
            var t2 = new Date().getTime(), n2 = t2 - this.update_time;
            if (ce(n2) && n2 > 0 && n2 < this.para.session_time) {
              var i2 = this.para.update_interval - n2;
              this.setNextFetch(i2);
            } else
              this.getConfigFromServer();
          } else
            this.getConfigFromServer();
        else
          this.getConfigFromServer();
      } else
        this.getConfigFromServer();
      this.pageStateListenner();
    }, serverUrlIsSame: function(e2) {
      return !!r(e2) && (e2.host === this.url_info.server_url.host && e2.project === this.url_info.server_url.project);
    }, getConfigFromServer: function() {
      var e2 = this, t2 = function(t3, n3) {
        e2.update_time = new Date().getTime();
        var i2 = {};
        t3 === 200 ? n3 && r(n3) && n3.os === "Web" && (i2 = n3, e2.updateConfig(i2)) : t3 === 205 ? e2.updateConfig(i2) : t3 === 304 ? i2 = e2.config : (je("----vtrackcustom----\u6570\u636E\u5F02\u5E38", t3), e2.updateConfig(i2)), e2.updateStorage(i2), e2.setNextFetch();
      }, n2 = function(t3) {
        e2.update_time = new Date().getTime(), je("----vtrackcustom----\u914D\u7F6E\u62C9\u53D6\u5931\u8D25", t3), e2.setNextFetch();
      };
      this.sendRequest(t2, n2);
    }, setNextFetch: function(e2) {
      var t2 = this;
      this.timer && (clearTimeout(this.timer), this.timer = null), e2 = e2 || this.para.update_interval, this.timer = setTimeout(function() {
        t2.getConfigFromServer();
      }, e2);
    }, pageStateListenner: function() {
      var e2 = this;
      ge({ visible: function() {
        var t2 = new Date().getTime(), r2 = t2 - e2.update_time;
        if (ce(r2) && r2 > 0 && r2 < e2.para.update_interval) {
          var n2 = e2.para.update_interval - r2;
          e2.setNextFetch(n2);
        } else
          e2.getConfigFromServer();
      }, hidden: function() {
        e2.timer && (clearTimeout(e2.timer), e2.timer = null);
      } });
    }, updateConfig: function(e2) {
      return !!r(e2) && (this.config = e2, this.customProp.updateEvents(e2), void this.unlimitedDiv.init(e2));
    }, updateStorage: function(e2) {
      if (!this.storageEnable)
        return false;
      if (!r(e2))
        return false;
      var t2;
      if (this.url_info.server_url)
        t2 = this.url_info.server_url;
      else {
        var n2 = Ha.initUrl();
        if (!n2)
          return false;
        t2 = n2.server_url;
      }
      var i2 = { updateTime: new Date().getTime(), data: e2, serverUrl: t2 };
      Ia.saveObjectVal(this.storage_name, i2);
    }, sendRequest: function(e2, t2) {
      var r2 = this, n2 = { app_id: this.url_info.page_url.host };
      this.config.version && (n2.v = this.config.version), fe({ url: r2.url_info.api_url, callbackName: "saJSSDKVtrackCollectConfig", data: n2, timeout: r2.para.timeout, success: function(t3, r3) {
        e2(t3, r3);
      }, error: function(e3) {
        t2(e3);
      } });
    }, getAssignConfigs: xa.getAssignConfigs, configIsMatch: xa.configIsMatch }, Ba = { basicProps: { priority: 0, entry: ct }, formatData: { priority: 0, entry: lt }, finalAdjustData: { priority: 0, entry: ut2 } }, Ja = { stage: null, init: function(e2) {
      this.stage = e2;
    }, interceptor: Ba }, Ma = {};
    Ma.check = et, Ma.sendItem = function(e2) {
      var t2 = { lib: { $lib: "js", $lib_method: "code", $lib_version: String(Ki.lib_version) }, time: 1 * new Date() };
      P(t2, e2), dt(t2), Ki.kit.sendData(t2);
    }, Ma.send = function(e2, t2) {
      var r2 = Ki.kit.buildData(e2);
      Ki.kit.sendData(r2, t2);
    };
    var qa = { stage: null, init: function(e2) {
      this.stage = e2;
    } }, Ka = { label: false, li: false, a: true, button: true }, Va = { otherTags: [], initUnlimitedTags: function() {
      k(Va.otherTags, function(e2) {
        e2 in Ka && (Ka[e2] = true);
      });
    }, isUnlimitedTag: function(e2) {
      if (!e2 || e2.nodeType !== 1)
        return false;
      var t2 = e2.nodeName.toLowerCase();
      return Ka[t2] || Y(e2, Ki.para.heatmap.track_attr);
    }, getTargetElement: function(e2, t2) {
      var r2 = this, n2 = e2;
      if (typeof n2 != "object")
        return null;
      if (typeof n2.tagName != "string")
        return null;
      var i2 = n2.tagName.toLowerCase();
      if (i2.toLowerCase() === "body" || i2.toLowerCase() === "html")
        return null;
      if (!n2 || !n2.parentNode || !n2.parentNode.children)
        return null;
      var a2 = n2.parentNode, o2 = r2.otherTags;
      if (i2 === "a" || i2 === "button" || i2 === "input" || i2 === "textarea")
        return n2;
      if (re(o2, i2) > -1)
        return n2;
      if (i2 === "area" && a2.tagName.toLowerCase() === "map" && y(a2).prev().tagName && y(a2).prev().tagName.toLowerCase() === "img")
        return y(a2).prev();
      if (i2 === "div" && Ki.para.heatmap.collect_tags.div && r2.isDivLevelValid(n2)) {
        var s2 = Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div && Ki.para.heatmap.collect_tags.div.max_level || 1;
        if (s2 > 1 || r2.isCollectableDiv(n2))
          return n2;
      }
      if (r2.isStyleTag(i2) && Ki.para.heatmap.collect_tags.div) {
        var l2 = r2.getCollectableParent(n2);
        if (l2 && r2.isDivLevelValid(l2))
          return l2;
      }
      var u2 = r2.hasElement({ event: t2 && t2.originalEvent || t2, element: e2 }, function(e3) {
        return r2.isUnlimitedTag(e3);
      });
      return u2 || null;
    }, getDivLevels: function(e2, t2) {
      var r2 = Va.getElementPath(e2, true, t2), n2 = r2.split(" > "), i2 = 0;
      return k(n2, function(e3) {
        e3 === "div" && i2++;
      }), i2;
    }, isDivLevelValid: function(e2) {
      for (var t2 = Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div && Ki.para.heatmap.collect_tags.div.max_level || 1, r2 = e2.getElementsByTagName("div"), n2 = r2.length - 1; n2 >= 0; n2--)
        if (Va.getDivLevels(r2[n2], e2) > t2)
          return false;
      return true;
    }, getElementPath: function(e2, t2, r2) {
      for (var n2 = []; e2.parentNode && _(e2); ) {
        if (e2.id && !t2 && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e2.id)) {
          n2.unshift(e2.tagName.toLowerCase() + "#" + e2.id);
          break;
        }
        if (r2 && e2 === r2) {
          n2.unshift(e2.tagName.toLowerCase());
          break;
        }
        if (e2 === document.body) {
          n2.unshift("body");
          break;
        }
        n2.unshift(e2.tagName.toLowerCase()), e2 = e2.parentNode;
      }
      return n2.join(" > ");
    }, getClosestLi: function(t2) {
      var r2 = function(t3, r3) {
        for (; t3 && t3 !== document && t3.nodeType === 1; t3 = t3.parentNode)
          if (t3.tagName && e(t3.tagName.toLowerCase) && t3.tagName.toLowerCase() === r3)
            return t3;
        return null;
      };
      return r2(t2, "li");
    }, getElementPosition: function(e2, t2, r2) {
      function n2(e3) {
        var t3 = e3.parentNode;
        if (!t3)
          return "";
        var r3 = y(e3).getSameTypeSiblings(), n3 = r3.length;
        if (n3 === 1)
          return 0;
        for (var i3 = 0, a3 = e3; y(a3).previousElementSibling().ele; a3 = y(a3).previousElementSibling().ele, i3++)
          ;
        return i3;
      }
      var i2 = Ki.heatmap.getClosestLi(e2);
      if (!i2 || !_(e2))
        return null;
      var a2 = e2.tagName.toLowerCase(), o2 = i2.getElementsByTagName(a2), s2 = o2.length, l2 = [];
      if (s2 > 1) {
        for (var u2 = 0; u2 < s2; u2++) {
          var c2 = Ki.heatmap.getElementPath(o2[u2], r2);
          c2 === t2 && l2.push(o2[u2]);
        }
        if (l2.length > 1)
          return re(l2, e2);
      }
      return n2(i2);
    }, setNotice: function(e2) {
      Ki.is_heatmap_render_mode = true, Ki.para.heatmap || (Ki.errorMsg = "\u60A8SDK\u6CA1\u6709\u914D\u7F6E\u5F00\u542F\u70B9\u51FB\u56FE\uFF0C\u53EF\u80FD\u6CA1\u6709\u6570\u636E\uFF01"), e2 && e2.slice(0, 5) === "http:" && location.protocol === "https:" && (Ki.errorMsg = "\u60A8\u7684\u5F53\u524D\u9875\u9762\u662Fhttps\u7684\u5730\u5740\uFF0C\u795E\u7B56\u5206\u6790\u73AF\u5883\u4E5F\u5FC5\u987B\u662Fhttps\uFF01"), Ki.para.heatmap_url || (Ki.para.heatmap_url = gt() + "//static.sensorsdata.cn/sdk/" + Ki.lib_version + "/heatmap.min.js");
    }, getDomIndex: function(e2) {
      if (!e2.parentNode)
        return -1;
      for (var t2 = 0, r2 = e2.tagName, n2 = e2.parentNode.children, i2 = 0; i2 < n2.length; i2++)
        if (n2[i2].tagName === r2) {
          if (e2 === n2[i2])
            return t2;
          t2++;
        }
      return -1;
    }, selector: function(e2, t2) {
      var r2 = e2.parentNode && e2.parentNode.nodeType == 9 ? -1 : this.getDomIndex(e2);
      return e2.getAttribute && e2.getAttribute("id") && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e2.getAttribute("id")) && (!Ki.para.heatmap || Ki.para.heatmap && Ki.para.heatmap.element_selector !== "not_use_id") && !t2 ? "#" + e2.getAttribute("id") : e2.tagName.toLowerCase() + (~r2 ? ":nth-of-type(" + (r2 + 1) + ")" : "");
    }, getDomSelector: function(e2, t2, r2) {
      if (!e2 || !e2.parentNode || !e2.parentNode.children)
        return false;
      t2 = t2 && t2.join ? t2 : [];
      var n2 = e2.nodeName.toLowerCase();
      return e2 && n2 !== "body" && e2.nodeType == 1 ? (t2.unshift(this.selector(e2, r2)), e2.getAttribute && e2.getAttribute("id") && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e2.getAttribute("id")) && Ki.para.heatmap && Ki.para.heatmap.element_selector !== "not_use_id" && !r2 ? t2.join(" > ") : this.getDomSelector(e2.parentNode, t2, r2)) : (t2.unshift("body"), t2.join(" > "));
    }, na: function() {
      var e2 = document.documentElement.scrollLeft || window.pageXOffset;
      return parseInt(isNaN(e2) ? 0 : e2, 10);
    }, i: function() {
      var e2 = 0;
      try {
        e2 = o.documentElement && o.documentElement.scrollTop || m.pageYOffset, e2 = isNaN(e2) ? 0 : e2;
      } catch (t2) {
        e2 = 0;
      }
      return parseInt(e2, 10);
    }, getBrowserWidth: function() {
      var e2 = window.innerWidth || document.body.clientWidth;
      return isNaN(e2) ? 0 : parseInt(e2, 10);
    }, getBrowserHeight: function() {
      var e2 = window.innerHeight || document.body.clientHeight;
      return isNaN(e2) ? 0 : parseInt(e2, 10);
    }, getScrollWidth: function() {
      var e2 = parseInt(document.body.scrollWidth, 10);
      return isNaN(e2) ? 0 : e2;
    }, getEleDetail: function(e2) {
      var t2 = this.getDomSelector(e2), r2 = ze({ target: e2 });
      r2.$element_selector = t2 ? t2 : "", r2.$element_path = Ki.heatmap.getElementPath(e2, Ki.para.heatmap && Ki.para.heatmap.element_selector === "not_use_id");
      var n2 = Ki.heatmap.getElementPosition(e2, r2.$element_path, Ki.para.heatmap && Ki.para.heatmap.element_selector === "not_use_id");
      return ce(n2) && (r2.$element_position = n2), r2;
    }, getPointerEventProp: function(e2, t2) {
      function r2() {
        var e3 = document.body.scrollLeft || document.documentElement.scrollLeft || 0, t3 = document.body.scrollTop || document.documentElement.scrollTop || 0;
        return { scrollLeft: e3, scrollTop: t3 };
      }
      function n2(e3) {
        if (document.documentElement.getBoundingClientRect) {
          var t3 = e3.getBoundingClientRect();
          return { targetEleX: t3.left + r2().scrollLeft || 0, targetEleY: t3.top + r2().scrollTop || 0 };
        }
      }
      function i2(e3) {
        return Number(Number(e3).toFixed(3));
      }
      function a2(e3) {
        var a3 = e3.pageX || e3.clientX + r2().scrollLeft || e3.offsetX + n2(t2).targetEleX || 0, o2 = e3.pageY || e3.clientY + r2().scrollTop || e3.offsetY + n2(t2).targetEleY || 0;
        return { $page_x: i2(a3), $page_y: i2(o2) };
      }
      return e2 ? a2(e2) : {};
    }, start: function(t2, n2, i2, a2, o2) {
      if (r(Ki.para.heatmap) && e(Ki.para.heatmap.collect_element) && !Ki.para.heatmap.collect_element(n2))
        return false;
      var s2 = Va.getBasicEleInfo(t2, n2, i2, a2, o2);
      _t(s2);
    }, getBasicEleInfo: function(t2, n2, i2, a2, o2) {
      var s2 = r(a2) ? a2 : {}, l2 = e(o2) ? o2 : e(a2) ? a2 : void 0, u2 = this.getEleDetail(n2);
      if (Ki.para.heatmap && Ki.para.heatmap.custom_property) {
        var c2 = Ki.para.heatmap.custom_property(n2);
        r(c2) && (u2 = P(u2, c2));
      }
      return u2 = P(u2, this.getPointerEventProp(t2, n2), s2), { event: t2, target: n2, props: u2, tagName: i2, callback: l2 };
    }, hasElement: function(e2, t2) {
      var r2;
      if (e2.event) {
        var n2 = e2.event;
        r2 = n2.path || n2._getPath && n2._getPath();
      } else
        e2.element && (r2 = y(e2.element).getParents());
      if (r2 && v(r2) && r2.length > 0) {
        for (var i2 = 0; i2 < r2.length; i2++)
          if (typeof r2[i2] == "object" && r2[i2].nodeType === 1 && t2(r2[i2]))
            return r2[i2];
      }
    }, isStyleTag: function(e2, t2) {
      var n2 = ["a", "div", "input", "button", "textarea"], i2 = ["mark", "/mark", "strong", "b", "em", "i", "u", "abbr", "ins", "del", "s", "sup"];
      return !(re(n2, e2) > -1) && (!t2 || Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div ? !!(r(Ki.para.heatmap) && r(Ki.para.heatmap.collect_tags) && r(Ki.para.heatmap.collect_tags.div) && v(Ki.para.heatmap.collect_tags.div.ignore_tags) && re(Ki.para.heatmap.collect_tags.div.ignore_tags, e2) > -1) : re(i2, e2) > -1);
    }, isCollectableDiv: function(e2, t2) {
      try {
        if (e2.children.length === 0)
          return true;
        for (var r2 = 0; r2 < e2.children.length; r2++)
          if (e2.children[r2].nodeType === 1) {
            var n2 = e2.children[r2].tagName.toLowerCase(), i2 = Ki.para && Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div && Ki.para.heatmap.collect_tags.div.max_level;
            if (!(n2 === "div" && i2 > 1 || this.isStyleTag(n2, t2)))
              return false;
            if (!this.isCollectableDiv(e2.children[r2], t2))
              return false;
          }
        return true;
      } catch (a2) {
        je("isCollectableDiv:" + a2);
      }
      return false;
    }, getCollectableParent: function(e2, t2) {
      try {
        var r2 = e2.parentNode, n2 = r2 ? r2.tagName.toLowerCase() : "";
        if (n2 === "body")
          return false;
        var i2 = Ki.para && Ki.para.heatmap && Ki.para.heatmap.collect_tags && Ki.para.heatmap.collect_tags.div && Ki.para.heatmap.collect_tags.div.max_level;
        if (n2 && n2 === "div" && (i2 > 1 || this.isCollectableDiv(r2, t2)))
          return r2;
        if (r2 && this.isStyleTag(n2, t2))
          return this.getCollectableParent(r2, t2);
      } catch (a2) {
        je("getCollectableParent:" + a2);
      }
      return false;
    }, listenUrlChange: function(e2) {
      e2(), Ki.ee.spa.on("switch", function() {
        e2();
      });
    }, initScrollmap: function() {
      if (!r(Ki.para.heatmap) || Ki.para.heatmap.scroll_notice_map !== "default")
        return false;
      var t2 = true;
      Ki.para.scrollmap && e(Ki.para.scrollmap.collect_url) && this.listenUrlChange(function() {
        t2 = !!Ki.para.scrollmap.collect_url();
      });
      var n2 = function(e2) {
        var t3 = {};
        return t3.timeout = e2.timeout || 1e3, t3.func = e2.func, t3.hasInit = false, t3.inter = null, t3.main = function(e3, t4) {
          this.func(e3, t4), this.inter = null;
        }, t3.go = function(e3) {
          var r2 = {};
          this.inter || (r2.$viewport_position = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0, r2.$viewport_position = Math.round(r2.$viewport_position) || 0, e3 ? t3.main(r2, true) : this.inter = setTimeout(function() {
            t3.main(r2);
          }, this.timeout));
        }, t3;
      }, i2 = n2({ timeout: 1e3, func: function(e2, t3) {
        var r2 = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0, n3 = new Date(), i3 = n3 - this.current_time;
        (i3 > Ki.para.heatmap.scroll_delay_time && r2 - e2.$viewport_position !== 0 || t3) && (e2.$url = Z(), e2.$title = document.title, e2.$url_path = G(), e2.event_duration = Math.min(Ki.para.heatmap.scroll_event_duration, parseInt(i3) / 1e3), e2.event_duration = e2.event_duration < 0 ? 0 : e2.event_duration, ht(e2)), this.current_time = n3;
      } });
      i2.current_time = new Date(), He(window, "scroll", function() {
        return !!t2 && void i2.go();
      }), He(window, "unload", function() {
        return !!t2 && void i2.go("notime");
      });
    }, initHeatmap: function() {
      var t2 = this, n2 = true;
      return !(!r(Ki.para.heatmap) || Ki.para.heatmap.clickmap !== "default") && (e(Ki.para.heatmap.collect_url) && this.listenUrlChange(function() {
        n2 = !!Ki.para.heatmap.collect_url();
      }), Ki.para.heatmap.collect_elements === "all" ? Ki.para.heatmap.collect_elements = "all" : Ki.para.heatmap.collect_elements = "interact", void (Ki.para.heatmap.collect_elements === "all" ? He(document, "click", function(e2) {
        if (!n2)
          return false;
        var r2 = e2 || window.event;
        if (!r2)
          return false;
        var i2 = r2.target || r2.srcElement;
        if (typeof i2 != "object")
          return false;
        if (typeof i2.tagName != "string")
          return false;
        var a2 = i2.tagName.toLowerCase();
        if (a2 === "body" || a2 === "html")
          return false;
        if (!i2 || !i2.parentNode || !i2.parentNode.children)
          return false;
        var o2 = i2.parentNode.tagName.toLowerCase();
        o2 === "a" || o2 === "button" ? t2.start(r2, i2.parentNode, o2) : t2.start(r2, i2, a2);
      }) : He(document, "click", function(e2) {
        if (!n2)
          return false;
        var i2 = e2 || window.event;
        if (!i2)
          return false;
        var a2 = i2.target || i2.srcElement, o2 = Ki.heatmap.getTargetElement(a2, e2);
        o2 ? t2.start(i2, o2, o2.tagName.toLowerCase()) : _(a2) && a2.tagName.toLowerCase() === "div" && r(Ki.para.heatmap) && Ki.para.heatmap.get_vtrack_config && Ua.events.length > 0 && Ua.isTargetEle(a2) && t2.start(i2, a2, a2.tagName.toLowerCase(), { $lib_method: "vtrack" });
      })));
    } }, Fa = { autoTrackIsUsed: false, isReady: function(t2) {
      return e(t2) ? void t2() : void Ki.log("error: isReady callback must be function");
    }, getUtm: function() {
      return ya.campaignParams();
    }, getStayTime: function() {
      return (new Date() - Ki._t) / 1e3;
    }, setProfileLocal: function(e2) {
      if (!zi.isSupport())
        return Ki.setProfile(e2), false;
      if (!r(e2) || oe(e2))
        return false;
      var t2 = Ia.readObjectVal("sensorsdata_2015_jssdk_profile"), n2 = false;
      if (r(t2) && !oe(t2)) {
        for (var i2 in e2)
          !(i2 in t2 && t2[i2] !== e2[i2]) && i2 in t2 || (t2[i2] = e2[i2], n2 = true);
        n2 && (Ia.saveObjectVal("sensorsdata_2015_jssdk_profile", t2), Ki.setProfile(e2));
      } else
        Ia.saveObjectVal("sensorsdata_2015_jssdk_profile", e2), Ki.setProfile(e2);
    }, setInitReferrer: function() {
      var e2 = De();
      Ki.setOnceProfile({ _init_referrer: e2, _init_referrer_host: ya.pageProp.referrer_host });
    }, setSessionReferrer: function() {
      var e2 = De();
      Ia.setSessionPropsOnce({ _session_referrer: e2, _session_referrer_host: ya.pageProp.referrer_host });
    }, setDefaultAttr: function() {
      ya.register({ _current_url: location.href, _referrer: De(), _referring_host: ya.pageProp.referrer_host });
    }, trackHeatMap: function(e2, t2, r2) {
      if (typeof e2 == "object" && e2.tagName && _(e2.parentNode)) {
        var n2 = e2.tagName.toLowerCase(), i2 = e2.parentNode.tagName.toLowerCase(), a2 = Ki.para.heatmap && Ki.para.heatmap.track_attr ? Ki.para.heatmap.track_attr : ["data-sensors-click"];
        n2 === "button" || n2 === "a" || i2 === "a" || i2 === "button" || n2 === "input" || n2 === "textarea" || Y(e2, a2) || Va.start(null, e2, n2, t2, r2);
      }
    }, trackAllHeatMap: function(e2, t2, r2) {
      if (typeof e2 == "object" && e2.tagName) {
        var n2 = e2.tagName.toLowerCase();
        Va.start(null, e2, n2, t2, r2);
      }
    }, autoTrackSinglePage: function(e2, t2) {
      function n2(e3, t3) {
        Ki.track("$pageview", P({ $referrer: i2, $url: Z(), $url_path: G(), $title: document.title }, e3, mt()), t3), i2 = Z();
      }
      var i2;
      i2 = this.autoTrackIsUsed ? ya.pageProp.url : ya.pageProp.referrer, e2 = r(e2) ? e2 : {};
      var a2 = !e2.not_set_profile;
      e2.not_set_profile && delete e2.not_set_profile, n2(e2, t2), this.autoTrackSinglePage = n2, vt(Ki.setOnceProfile, false, a2);
    }, autoTrackWithoutProfile: function(e2, t2) {
      e2 = r(e2) ? e2 : {}, this.autoTrack(P(e2, { not_set_profile: true }), t2);
    }, autoTrack: function(e2, t2) {
      e2 = r(e2) ? e2 : {};
      var n2 = mt(), i2 = !e2.not_set_profile;
      e2.not_set_profile && delete e2.not_set_profile;
      var a2 = location.href;
      Ki.para.is_single_page && w(function() {
        var r2 = De(a2, true);
        Ki.track("$pageview", P({ $referrer: r2, $url: Z(), $url_path: G(), $title: document.title }, n2, e2), t2), a2 = Z();
      }), Ki.track("$pageview", P({ $referrer: De(null, true), $url: Z(), $url_path: G(), $title: document.title }, n2, e2), t2), vt(Ki.setOnceProfile, true, i2), this.autoTrackIsUsed = true;
    }, getAnonymousID: function() {
      return oe(Ia._state) ? "SDK is not initialized." : Ia._state._first_id || Ia._state.first_id || Ia._state._distinct_id || Ia._state.distinct_id;
    }, setPlugin: function(t2) {
      return !!r(t2) && void k(t2, function(t3, n2) {
        e(t3) && (r(window.SensorsDataWebJSSDKPlugin) && window.SensorsDataWebJSSDKPlugin[n2] ? t3(window.SensorsDataWebJSSDKPlugin[n2]) : r(Ki.modules) && Ki.modules[n2] ? t3(window.SensorsDataWebJSSDKPlugin[n2]) : Ne(n2 + "is not found,please check sensorsdata documents."));
      });
    }, useModulePlugin: function() {
      Ki.use.apply(Ki, arguments);
    }, useAppPlugin: function() {
      this.setPlugin.apply(this, arguments);
    } }, za = new l(), Wa = new l(), Xa = {};
    Xa.spa = za, Xa.sdk = Wa, Xa.initSystemEvent = function() {
      yt(function(e2) {
        za.emit("switch", e2);
      });
    }, Xa.EVENT_LIST = { spaSwitch: ["spa", "switch"], sdkBeforeInit: ["sdk", "beforeInit"], sdkInitPara: ["sdk", "initPara"], sdkAfterInitPara: ["sdk", "afterInitPara"], sdkInitAPI: ["sdk", "initAPI"], sdkAfterInitAPI: ["sdk", "afterInitAPI"], sdkAfterInit: ["sdk", "afterInit"], sdkReady: ["sdk", "ready"] };
    var Za = { state: 0, historyState: [], stateType: { 1: "1-init\u672A\u5F00\u59CB", 2: "2-init\u5F00\u59CB", 3: "3-store\u5B8C\u6210" }, getState: function() {
      return this.historyState.join("\n");
    }, setState: function(e2) {
      String(e2) in this.stateType && (this.state = e2), this.historyState.push(this.stateType[e2]);
    } }, Ga = 1, Qa = { __proto__: null, setInitVar: Pt, initPara: Ct, quick: Ot, use: Nt, track: jt, bind: Tt, unbind: It, trackLink: $t, trackLinks: At, setItem: Dt, deleteItem: xt, setProfile: Et, setOnceProfile: Lt, appendProfile: Ut, incrementProfile: Rt, deleteProfile: Ht, unsetProfile: Bt, identify: Jt, trackSignup: qt, registerPage: Kt, clearAllRegister: Vt, clearPageRegister: Ft, register: zt, registerOnce: Wt, registerSession: Xt, registerSessionOnce: Zt, login: Gt, loginWithKey: Qt, logout: Yt, getPresetProperties: er, readyState: Za, debug: va, on: bt, log: Oe };
    Fi.setup(Oe);
    var Ya = P({}, sa, ja), eo = { bridge_info: { touch_app_bridge: false, verify_success: false, platform: "", support_two_way_call: false }, is_verify_success: false, initPara: function() {
      var e2 = { is_send: Ki.para.use_app_track_is_send !== false && Ki.para.use_app_track !== "only", white_list: [], is_mui: Ki.para.use_app_track === "mui" };
      typeof Ki.para.app_js_bridge == "object" ? Ki.para.app_js_bridge = P({}, e2, Ki.para.app_js_bridge) : Ki.para.use_app_track !== true && Ki.para.app_js_bridge !== true && Ki.para.use_app_track !== "only" && Ki.para.use_app_track !== "mui" || (Ki.para.app_js_bridge = P({}, e2)), Ki.para.app_js_bridge.is_send === false && Ne("\u8BBE\u7F6E\u4E86 is_send:false,\u5982\u679C\u6253\u901A\u5931\u8D25\uFF0C\u6570\u636E\u5C06\u88AB\u4E22\u5F03!");
    }, app_js_bridge_v1: function() {
      function e2(e3) {
        n2 = e3, ue(n2) && (n2 = JSON.parse(n2)), i2 && (i2(n2), i2 = null, n2 = null);
      }
      function t2() {
        typeof window.SensorsData_APP_JS_Bridge == "object" && window.SensorsData_APP_JS_Bridge.sensorsdata_call_app && (n2 = window.SensorsData_APP_JS_Bridge.sensorsdata_call_app(), ue(n2) && (n2 = JSON.parse(n2)));
      }
      function r2() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
          var e3 = document.createElement("iframe");
          e3.setAttribute("src", "sensorsanalytics://getAppInfo"), document.documentElement.appendChild(e3), e3.parentNode.removeChild(e3), e3 = null;
        }
      }
      var n2 = null, i2 = null;
      window.sensorsdata_app_js_bridge_call_js = function(t3) {
        e2(t3);
      }, Ki.getAppStatus = function(e3) {
        return r2(), t2(), e3 ? void (n2 === null ? i2 = e3 : (e3(n2), n2 = null)) : n2;
      };
    }, hasVisualModeBridge: function() {
      var e2 = window.SensorsData_App_Visual_Bridge, t2 = "sensorsdata_visualized_mode";
      return r(e2) && e2[t2] && (e2[t2] === true || e2[t2]());
    }, validateAppUrl: ir };
    rr.prototype.call = function(e2, t2) {
      var r2 = this, i2 = new Date().getTime().toString(16) + String(n()).replace(".", "").slice(1, 8);
      this.resultCbs[i2] = r2.resultCbs[i2] || { result: null, callbacks: [] }, this.timeoutCbs[i2] = r2.timeoutCbs[i2] || { isTimeout: false, callbacks: [] }, e2 = e2.data ? e2 : { data: e2 }, e2.data.message_id = i2;
      var a2 = P({ callType: this.type }, e2);
      return t2 && (this.timerId = setTimeout(function() {
        r2.timeoutCbs[i2].isTimeout = true;
        for (var e3 in r2.timeoutCbs[i2].callbacks)
          r2.timeoutCbs[i2].callbacks[e3].call(null), r2.timeoutCbs[i2].callbacks.splice(e3, 1);
      }, t2)), nr(a2), { onResult: function(e3) {
        return r2.resultCbs[i2].result ? (e3(r2.resultCbs[i2].result), this) : (!r2.timeoutCbs[i2].isTimeout && r2.resultCbs[i2].callbacks.push(e3), this);
      }, onTimeout: function(e3) {
        return r2.timeoutCbs[i2].isTimeout ? (e3(), this) : (!r2.resultCbs[i2].result && r2.timeoutCbs[i2].callbacks.push(e3), this);
      } };
    }, rr.prototype.onAppNotify = function(e2) {
      this.appCallJsCallback = e2;
    }, rr.prototype.notifyApp = function(e2, t2) {
      var r2 = P({ callType: this.type }, e2);
      return t2 && (r2.message_id = t2), nr(r2);
    }, ar.prototype = { "double": function() {
    }, getAppData: function() {
    }, hasAppBridge: function() {
      return Ki.bridge.bridge_info.support_two_way_call;
    }, init: function() {
    }, jsCallApp: function() {
    }, requestToApp: function(t2) {
      this.bridge.call(t2, t2.timeout.time).onResult(function(r2) {
        e(t2.callback) && t2.callback(r2);
      }).onTimeout(function() {
        e(t2.timeout.callback) && t2.timeout.callback();
      });
    } };
    var to = { isSeachHasKeyword: function() {
      return F(location.href, "sa-request-id") !== "" && (typeof sessionStorage.getItem("sensors-visual-mode") == "string" && sessionStorage.removeItem("sensors-visual-mode"), true);
    }, hasKeywordHandle: function() {
      var e2 = location.href, t2 = F(e2, "sa-request-id") || null, r2 = F(e2, "sa-request-type") || null, n2 = F(e2, "sa-request-url") || null;
      if (Va.setNotice(n2), na.isSupport())
        if (n2 !== null && sessionStorage.setItem("sensors_heatmap_url", n2), sessionStorage.setItem("sensors_heatmap_id", t2), r2 !== null)
          r2 === "1" || r2 === "2" || r2 === "3" ? sessionStorage.setItem("sensors_heatmap_type", r2) : r2 = null;
        else {
          var i2 = sessionStorage.getItem("sensors_heatmap_type");
          r2 = i2 !== null ? i2 : null;
        }
      this.isReady(t2, r2);
    }, isReady: function(e2, t2, r2) {
      Ki.para.heatmap_url ? _e({ success: function() {
        setTimeout(function() {
          typeof sa_jssdk_heatmap_render != "undefined" && (sa_jssdk_heatmap_render(Ki, e2, t2, r2), typeof console == "object" && typeof console.log == "function" && (Ki.heatmap_version && Ki.heatmap_version === Ki.lib_version || Ne("heatmap.js\u4E0Esensorsdata.js\u7248\u672C\u53F7\u4E0D\u4E00\u81F4\uFF0C\u53EF\u80FD\u5B58\u5728\u98CE\u9669!")));
        }, 0);
      }, error: function() {
      }, type: "js", url: Ki.para.heatmap_url }) : je("\u6CA1\u6709\u6307\u5B9Aheatmap_url\u7684\u8DEF\u5F84");
    }, isStorageHasKeyword: function() {
      return na.isSupport() && typeof sessionStorage.getItem("sensors_heatmap_id") == "string";
    }, storageHasKeywordHandle: function() {
      Va.setNotice(), to.isReady(sessionStorage.getItem("sensors_heatmap_id"), sessionStorage.getItem("sensors_heatmap_type"), location.href);
    }, isWindowNameHasKeyword: function() {
      try {
        var e2 = JSON.parse(window.name), t2 = p(e2["sa-request-page-url"]) ? u(e2["sa-request-page-url"]) : null;
        return e2["sa-request-id"] && p(e2["sa-request-id"]) && t2 === location.href;
      } catch (r2) {
        return false;
      }
    }, windowNameHasKeywordHandle: function() {
      function e2(e3) {
        var r3 = t2[e3];
        return p(r3) ? u(r3) : null;
      }
      var t2 = JSON.parse(window.name), r2 = e2("sa-request-id"), n2 = e2("sa-request-type"), i2 = e2("sa-request-url");
      Va.setNotice(i2), na.isSupport() && (i2 !== null && sessionStorage.setItem("sensors_heatmap_url", i2), sessionStorage.setItem("sensors_heatmap_id", r2), n2 !== null ? n2 === "1" || n2 === "2" || n2 === "3" ? sessionStorage.setItem("sensors_heatmap_type", n2) : n2 = null : n2 = sessionStorage.getItem("sensors_heatmap_type") !== null ? sessionStorage.getItem("sensors_heatmap_type") : null), to.isReady(r2, n2);
    } }, ro = { isStorageHasKeyword: function() {
      return na.isSupport() && typeof sessionStorage.getItem("sensors-visual-mode") == "string";
    }, isSearchHasKeyword: function() {
      return (sr("sa-visual-mode") === true || sr("sa-visual-mode") === "true") && (typeof sessionStorage.getItem("sensors_heatmap_id") == "string" && sessionStorage.removeItem("sensors_heatmap_id"), true);
    }, loadVtrack: function() {
      _e({ success: function() {
      }, error: function() {
      }, type: "js", url: Ki.para.vtrack_url ? Ki.para.vtrack_url : gt() + "//static.sensorsdata.cn/sdk/" + Ki.lib_version + "/vtrack.min.js" });
    }, messageListener: function(e2) {
      function t2(e3) {
        return se(e3) ? he(e3) : (je("\u53EF\u89C6\u5316\u6A21\u5F0F\u68C0\u6D4B URL \u5931\u8D25"), false);
      }
      if (!e2 || !e2.data || e2.data.source !== "sa-fe")
        return false;
      if (e2.data.type === "v-track-mode") {
        if (e2.data.data && e2.data.data.isVtrack)
          if (na.isSupport() && sessionStorage.setItem("sensors-visual-mode", "true"), e2.data.data.userURL && location.href.match(/sa-visual-mode=true/)) {
            var r2 = t2(e2.data.data.userURL);
            r2 && (window.location.href = r2);
          } else
            ro.loadVtrack();
        window.removeEventListener("message", ro.messageListener, false);
      }
    }, removeMessageHandle: function() {
      window.removeEventListener && window.removeEventListener("message", ro.messageListener, false);
    }, verifyVtrackMode: function() {
      window.addEventListener && window.addEventListener("message", ro.messageListener, false), ro.postMessage();
    }, postMessage: function() {
      try {
        window.parent && window.parent.postMessage && window.parent.postMessage({ source: "sa-web-sdk", type: "v-is-vtrack", data: { sdkversion: fa } }, "*");
      } catch (e2) {
        je("\u6D4F\u89C8\u5668\u7248\u672C\u8FC7\u4F4E\uFF0C\u4E0D\u652F\u6301 postMessage API");
      }
    }, notifyUser: function() {
      var e2 = function(t2) {
        return !(!t2 || !t2.data || t2.data.source !== "sa-fe") && void (t2.data.type === "v-track-mode" && (t2.data.data && t2.data.data.isVtrack && alert("\u5F53\u524D\u7248\u672C\u4E0D\u652F\u6301\uFF0C\u8BF7\u5347\u7EA7\u90E8\u7F72\u795E\u7B56\u6570\u636E\u6CBB\u7406"), window.removeEventListener("message", e2, false)));
      };
      window.addEventListener && window.addEventListener("message", e2, false), ro.postMessage();
    } }, no = ["setItem", "deleteItem", "getAppStatus", "track", "quick", "register", "registerPage", "registerOnce", "trackSignup", "setProfile", "setOnceProfile", "appendProfile", "incrementProfile", "deleteProfile", "unsetProfile", "identify", "login", "logout", "trackLink", "clearAllRegister", "clearPageRegister", "bind", "unbind", "loginWithKey"], io = { track: function(e2, t2, r2) {
    }, quick: function(e2, t2, r2, n2) {
    }, register: function(e2) {
    }, registerPage: function(e2) {
    }, registerOnce: function(e2) {
    }, clearAllRegister: function(e2) {
    }, trackSignup: function(e2, t2, r2, n2) {
    }, setProfile: function(e2, t2) {
    }, setOnceProfile: function(e2, t2) {
    }, appendProfile: function(e2, t2) {
    }, incrementProfile: function(e2, t2) {
    }, deleteProfile: function(e2) {
    }, unsetProfile: function(e2, t2) {
    }, identify: function(e2, t2) {
    }, login: function(e2, t2) {
    }, logout: function(e2) {
    }, trackLink: function(e2, t2, r2) {
    }, deleteItem: function(e2, t2) {
    }, setItem: function(e2, t2, r2) {
    }, getAppStatus: function(e2) {
    }, clearPageRegister: function(e2) {
    } };
    mr.prototype.process = function(e2, t2) {
      if (!(e2 && e2 in this.processDef))
        return void je("process [" + e2 + "] is not supported");
      var r2 = this.registeredInterceptors[e2];
      if (r2 && v(r2) && r2.length > 0)
        for (var n2 = { current: 0, total: r2.length }, i2 = new hr(t2, n2, Ki), a2 = 0; a2 < r2.length; a2++)
          try {
            if (n2.current = a2 + 1, t2 = r2[a2].call(null, t2, i2) || t2, i2.cancellationToken.getCanceled())
              break;
            if (i2.cancellationToken.getStopped())
              return;
          } catch (o2) {
            je("interceptor error:" + o2);
          }
      return this.processDef[e2] && this.processDef[e2] in this.processDef && (t2 = this.process(this.processDef[e2], t2)), t2;
    }, mr.prototype.registerStageImplementation = function(t2) {
      t2 && t2.init && e(t2.init) && (t2.init(this), t2.interceptor && this.registerInterceptor(t2.interceptor));
    }, mr.prototype.registerInterceptor = function(t2) {
      if (t2)
        for (var n2 in t2) {
          var i2 = t2[n2];
          if (i2 && r(i2) && e(i2.entry)) {
            ce(i2.priority) || (i2.priority = Number.MAX_VALUE), this.registeredInterceptors[n2] || (this.registeredInterceptors[n2] = []);
            var a2 = this.registeredInterceptors[n2];
            i2.entry.priority = i2.priority, a2.push(i2.entry), a2.sort(function(e2, t3) {
              return e2.priority - t3.priority;
            });
          }
        }
    };
    var ao = { basicProps: "extendProps", extendProps: "formatData", formatData: "finalAdjustData", finalAdjustData: null }, oo = new mr(ao), so = { send: null }, lo = new mr(so), uo = { getUtmData: null, callSchema: null }, co = new mr(uo), po = { webClickEvent: null, webStayEvent: null }, fo = new mr(po), go2 = { buildDataStage: function(e2) {
      e2 && oo.registerInterceptor(e2);
    }, businessStage: function(e2) {
      e2 && co.registerInterceptor(e2);
    }, sendDataStage: function(e2) {
      e2 && lo.registerInterceptor(e2);
    }, viewStage: function(e2) {
      e2 && fo.registerInterceptor(e2);
    } }, _o = { stage: null, init: function(e2) {
      this.stage = e2;
    } }, ho = { stage: null, init: function(e2) {
      this.stage = e2;
    }, interceptor: { send: { entry: function(e2) {
      return e2;
    } } } }, mo = {};
    mo.buildData = function(e2) {
      return pt(e2);
    }, mo.sendData = function(e2, t2) {
      var r2 = qe(e2.properties), n2 = { server_url: Ki.para.server_url, data: e2, config: r2 || {}, callback: t2 };
      wr(n2), Ki.log(e2);
    }, mo.encodeTrackData = function(e2) {
      return Qe(e2);
    }, mo.getUtmData = function() {
      return br();
    };
    var vo = { webClickEvent: { entry: function(e2, t2) {
      var r2 = t2.sensors;
      e2.tagName === "a" && r2.para.heatmap && r2.para.heatmap.isTrackLink === true ? r2.trackLink({ event: e2.event, target: e2.target }, "$WebClick", e2.props) : r2.track("$WebClick", e2.props, e2.callback);
    } }, webStayEvent: { entry: function(e2, t2) {
      var r2 = t2.sensors;
      r2.track("$WebStay", e2);
    } } }, yo = window.sensors_data_pre_config, bo = !!Ya.isObject(yo) && yo.is_compliance_enabled;
    Ki.init = function(e2) {
      return Xa.sdk.emit("beforeInit"), !(Ki.readyState && Ki.readyState.state && Ki.readyState.state >= 2) && (bo && (Pr(true), gr()), Xa.initSystemEvent(), Ki.setInitVar(), Ki.readyState.setState(2), Ki.initPara(e2), Xa.sdk.emit("initPara"), Xa.sdk.emit("afterInitPara"), Xa.sdk.emit("initAPI"), Xa.sdk.emit("afterInitAPI"), Ki.detectMode(), tr(), Xa.sdk.emit("afterInit"), void Xa.sdk.emit("ready"));
    }, bo ? Pr(false) : (Pr(true), gr());
    var wo, So, ko, Po, Co, Oo, No, jo, To, Io, $o, Ao, Do, xo, Eo, Lo, Uo, Ro, Ho = "1.25.4", Bo = { init: function(e2) {
      var t2 = e2._.isString, r2 = e2._.rot13defs, n2 = e2._.dfmapping, i2 = "data:enc;", a2 = "dfm-enc-";
      e2.ee.sdk.on("afterInitPara", function() {
        e2.kit.userEncrypt = function(e3) {
          return a2 + n2(e3);
        }, e2.kit.userDecrypt = function(e3) {
          return e3.indexOf(i2) === 0 ? (e3 = e3.substring(i2.length), e3 = r2(e3)) : e3.indexOf(a2) === 0 && (e3 = e3.substring(a2.length), e3 = n2(e3)), e3;
        }, e2.kit.userDecryptIfNeeded = function(r3) {
          return !t2(r3) || r3.indexOf(i2) !== 0 && r3.indexOf(a2) !== 0 || (r3 = e2.kit.userDecrypt(r3)), r3;
        };
      });
    }, plugin_name: "UserEncryptDefault" }, Jo = Nr(Bo), Mo = "1.25.4", qo = { sd: null, init: function(e2) {
      if (this.sd)
        return false;
      if (this.sd = e2, !this.sd || !this.sd._)
        return false;
      var t2 = this.sd._.cookie.get("sensors_amp_id"), r2 = this.sd.store._state.distinct_id;
      if (t2 && t2.length > 0) {
        var n2 = t2.slice(0, 4) === "amp-";
        if (t2 !== r2) {
          if (!n2)
            return false;
          this.sd.store._state.first_id ? (this.sd.identify(t2, true), this.sd.saEvent.send({ original_id: t2, distinct_id: r2, type: "track_signup", event: "$SignUp", properties: {} }, null), this.setAmpId(r2)) : this.sd.identify(t2, true);
        }
      } else
        this.setAmpId(r2);
      this.addListener();
    }, addListener: function() {
      var e2 = this;
      this.sd.events.on("changeDistinctId", function(t2) {
        e2.setAmpId(t2);
      }), this.sd.events.isReady();
    }, setAmpId: function(e2) {
      this.sd._.cookie.set("sensors_amp_id", e2);
    } }, Ko = Ir(qo, "Amp", "sdkReady"), Vo = window.SensorsData_App_Visual_Bridge, Fo = Vo && Vo.sensorsdata_visualized_mode, zo = Vo && Vo.sensorsdata_visualized_alert_info, Wo = Vo && Vo.sensorsdata_hover_web_nodes, Xo = { isVerify: function() {
      return Fo && (Fo === true || Fo.call(Vo));
    }, commands: { app_alert: $r, visualized_track: Ar, page_info: Ar, sensorsdata_get_app_visual_config: Dr } }, Zo = "1.25.4", Go = { init: function(e2) {
      Po = e2, Co = Po && Po._, Oo = Po && Po.log || console && console.log || function() {
      }, Ur();
    }, handleCommand: Hr }, Qo = Lr(Go, "AndroidBridge", "sdkAfterInitPara"), Yo = window.SensorsData_App_Visual_Bridge, es = Yo && Yo.sensorsdata_visualized_mode, ts = Yo && Yo.sensorsdata_visualized_alert_info, rs = Yo && Yo.sensorsdata_hover_web_nodes, ns = { isVerify: function() {
      return es && (es === true || es.call(Yo));
    }, commands: { app_alert: Br, visualized_track: Jr, page_info: Jr, sensorsdata_get_app_visual_config: Mr } }, is = "1.25.4", as = { init: function(e2) {
      $o = e2, Ao = $o && $o._, Do = $o && $o.log || console && console.log || function() {
      }, Fr();
    }, handleCommand: Wr }, os = Vr(as, "AndroidObsoleteBridge", "sdkAfterInitPara"), ss = "1.25.4", ls = { event_list: [], latest_event_initial_time: null, max_save_time: 2592e6, init: function(e2, t2) {
      function r2() {
        return xo = Eo._, Lo = Eo.store, !!xo.localStorage.isSupport() && (Eo.para.max_string_length = 1024, n2.eventList.init(), n2.addLatestChannelUrl(), void n2.addIsChannelCallbackEvent());
      }
      if (Eo || !e2)
        return false;
      t2 = t2 || {}, Uo = t2.cookie_name || "sensorsdata2015jssdkchannel", Eo = e2;
      var n2 = this;
      r2();
    }, addIsChannelCallbackEvent: function() {
      Eo.registerPage({ $is_channel_callback_event: function(e2) {
        if (xo.isObject(e2) && e2.event && e2.event !== "$WebClick" && e2.event !== "$pageview" && e2.event !== "$WebStay" && e2.event !== "$SignUp")
          return !ls.eventList.hasEvent(e2.event) && (ls.eventList.add(e2.event), true);
      } });
    }, addLatestChannelUrl: function() {
      var e2 = this.getUrlDomain(), t2 = this.cookie.getChannel();
      if (e2 === "url\u89E3\u6790\u5931\u8D25")
        this.registerAndSave({ _sa_channel_landing_url: "", _sa_channel_landing_url_error: "url\u7684domain\u89E3\u6790\u5931\u8D25" });
      else if (xo.isReferralTraffic(document.referrer)) {
        var r2 = xo.getQueryParam(location.href, "sat_cf");
        xo.isString(r2) && r2.length > 0 ? (this.registerAndSave({ _sa_channel_landing_url: location.href }), ls.channelLinkHandler()) : this.registerAndSave({ _sa_channel_landing_url: "" });
      } else
        t2 ? Eo.registerPage(t2) : Eo.registerPage({ _sa_channel_landing_url: "", _sa_channel_landing_url_error: "\u53D6\u503C\u5F02\u5E38" });
    }, registerAndSave: function(e2) {
      Eo.registerPage(e2), this.cookie.saveChannel(e2);
    }, cookie: { getChannel: function() {
      var e2 = Eo.kit.userDecryptIfNeeded(xo.cookie.get(Uo));
      return e2 = xo.safeJSONParse(e2), !(!xo.isObject(e2) || !e2.prop) && e2.prop;
    }, saveChannel: function(e2) {
      var t2 = { prop: e2 }, r2 = JSON.stringify(t2);
      Eo.para.encrypt_cookie && (r2 = Eo.kit.userEncrypt(r2)), xo.cookie.set(Uo, r2);
    } }, channelLinkHandler: function() {
      this.eventList.reset(), Eo.track("$ChannelLinkReaching");
    }, getUrlDomain: function() {
      var e2 = xo.info.pageProp.url_domain;
      return e2 === "" && (e2 = "url\u89E3\u6790\u5931\u8D25"), e2;
    }, eventList: { init: function() {
      var e2 = this.get(), t2 = new Date().getTime();
      if (e2 && xo.isNumber(e2.latest_event_initial_time) && xo.isArray(e2.eventList)) {
        var r2 = t2 - e2.latest_event_initial_time;
        r2 > 0 && r2 < ls.max_save_time ? (ls.event_list = e2.eventList, ls.latest_event_initial_time = e2.latest_event_initial_time) : this.reset();
      } else
        this.reset();
    }, get: function() {
      var e2 = {};
      try {
        e2 = Lo.readObjectVal("sawebjssdkchannel");
      } catch (t2) {
        Eo.log(t2);
      }
      return e2;
    }, add: function(e2) {
      ls.event_list.push(e2), this.save();
    }, save: function() {
      var e2 = { latest_event_initial_time: ls.latest_event_initial_time, eventList: ls.event_list };
      Lo.saveObjectVal("sawebjssdkchannel", e2);
    }, reset: function() {
      ls.event_list = [], ls.latest_event_initial_time = new Date().getTime(), this.save();
    }, hasEvent: function(e2) {
      var t2 = false;
      return xo.each(ls.event_list, function(r2) {
        r2 === e2 && (t2 = true);
      }), t2;
    } } }, us = Gr(ls, "SensorsChannel", "sdkAfterInitAPI"), cs = "1.25.4", ps = (/micromessenger\/([\d.]+)/i.test(navigator.userAgent || ""), function() {
      var e2 = {};
      return typeof document.hidden != "undefined" ? (e2.hidden = "hidden", e2.visibilityChange = "visibilitychange") : typeof document.msHidden != "undefined" ? (e2.hidden = "msHidden", e2.visibilityChange = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (e2.hidden = "webkitHidden", e2.visibilityChange = "webkitvisibilitychange"), e2;
    });
    Ro = ps().hidden;
    var ds, fs, gs, _s, hs, ms, vs, ys, bs = { android: /Android/i, iOS: /iPhone|iPad|iPod/i }, ws = function() {
      for (var e2 in bs)
        if (navigator.userAgent.match(bs[e2]))
          return e2;
      return "";
    }, Ss = ws(), ks = function() {
      return bs.hasOwnProperty(Ss);
    }, Ps = function(e2) {
      return e2 != null && Object.prototype.toString.call(e2) == "[object Object]";
    }, Cs = function(e2) {
      var t2 = /\/sd\/(\w+)\/(\w+)$/;
      return e2.match(t2);
    }, Os = function(e2) {
      var t2 = e2._.URL(e2.para.server_url);
      return { origin: t2.origin, project: t2.searchParams.get("project") || "default" };
    }, Ns = function(e2, t2, r2) {
      e2.log("\u5C1D\u8BD5\u5524\u8D77 android app");
      var n2 = t2;
      e2.log("\u5524\u8D77APP\u7684\u5730\u5740\uFF1A" + n2), window.location = n2, e2.timer = setTimeout(function() {
        var t3 = tn();
        return e2.log("hide:" + Ro + ":" + document[Ro]), t3 ? (e2.log("The page is hidden, stop navigating to download page"), false) : (e2.log("App\u53EF\u80FD\u672A\u5B89\u88C5\uFF0C\u8DF3\u8F6C\u5230\u4E0B\u8F7D\u5730\u5740"), void (window.location = r2));
      }, e2.timeout);
    }, js = function(e2, t2, r2) {
      e2.log("\u5C1D\u8BD5\u5524\u8D77 iOS app:" + t2), window.location.href = t2, e2.timer = setTimeout(function() {
        var t3 = tn();
        return t3 ? (e2.log("The page is hidden, stop navigating to download page"), false) : (e2.log("App\u53EF\u80FD\u672A\u5B89\u88C5\uFF0C\u8DF3\u8F6C\u5230\u4E0B\u8F7D\u5730\u5740"), void (window.location.href = r2));
      }, e2.timeout), e2.log("new timer:" + e2.timer);
    }, Ts = { key: null, timer: null, sd: null, data: null, timeout: 2500, apiURL: "{origin}/sdk/deeplink/param?key={key}&system_type=JS&project={project}", init: function(e2) {
      if (this.sd)
        return this.log("deeplink\u5DF2\u7ECF\u521D\u59CB\u5316"), false;
      if (this.sd = e2, this.log("deeplink init called"), this.sd === null)
        return this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165"), false;
      var t2 = {};
      if (arguments.length > 0 && (arguments.length === 1 && Ps(arguments[0]) ? t2 = arguments[0] : arguments.length >= 2 && Ps(arguments[1]) && (t2 = arguments[1])), !ks())
        return this.log("\u4E0D\u652F\u6301\u5F53\u524D\u7CFB\u7EDF\uFF0C\u76EE\u524D\u53EA\u652F\u6301Android\u548CiOS"), false;
      if (Ps(t2) && this.sd._.isNumber(t2.timeout) && t2.timeout >= 2500 && (this.timeout = t2.timeout), !this.sd.para.server_url)
        return this.log("\u795E\u7B56JS SDK\u914D\u7F6E\u9879server_url\u672A\u6B63\u786E\u914D\u7F6E"), false;
      var r2 = Os(this.sd);
      this.apiURL = this.apiURL.replace("{origin}", r2.origin).replace("{project}", r2.project);
      var n2 = this.sd._.getQueryParam(window.location.href, "deeplink");
      if (!n2)
        return this.log("\u5F53\u524D\u9875\u9762\u7F3A\u5C11deeplink\u53C2\u6570"), false;
      n2 = window.decodeURIComponent(n2);
      var i2 = Cs(n2);
      return i2 ? (this.key = i2[2], this.apiURL = this.apiURL.replace("{key}", window.encodeURIComponent(i2[2])), this.sd._.ajax({ url: this.apiURL, type: "GET", cors: true, credentials: false, success: function(e3) {
        return e3.errorMsg ? (Ts.log("API\u62A5\u9519\uFF1A" + e3.errorMsg), false) : (Ts.data = e3, Ts.log("API\u67E5\u8BE2\u6210\u529F\uFF0C\u6570\u636E\uFF1A" + JSON.stringify(e3, null, "  ")), void (this.data.app_key && (this.data.android_info && this.data.android_info.url_schemes && (this.data.android_info.url_schemes += "://sensorsdata/sd/" + this.data.app_key + "/" + this.key), this.data.ios_info && this.data.ios_info.url_schemes && (this.data.ios_info.url_schemes += "://sensorsdata/sd/" + this.data.app_key + "/" + this.key))));
      }.bind(this), error: function() {
        Ts.log("API\u67E5\u8BE2\u51FA\u9519");
      } }), void this.addListeners()) : (this.log("\u5F53\u524D\u9875\u9762\u7684deeplink\u53C2\u6570\u65E0\u6548"), false);
    }, openDeepLink: function() {
      if (this.log("openDeeplink()"), !this.data)
        return this.log("\u6CA1\u6709Deep link\u6570\u636E!"), false;
      if (Ss === "iOS") {
        this.log("\u5F53\u524D\u7CFB\u7EDF\u662FiOS");
        var e2 = this.sd && this.sd._ && this.sd._.getIOSVersion() >= 9 && this.data.ios_info.ios_wake_url ? this.data.ios_info.ios_wake_url : this.data.ios_info.url_schemes;
        this.log("\u5524\u8D77APP\u7684\u5730\u5740\uFF1A" + e2), js(this, e2, this.data.ios_info.download_url);
      } else
        this.log("\u5F53\u524D\u7CFB\u7EDF\u662F android"), Ns(this, this.data.android_info.url_schemes, this.data.android_info.download_url);
    }, log: function(e2) {
      this.sd && this.sd.log(e2);
    }, addListeners: function() {
      var e2 = ps().visibilityChange;
      e2 && document.addEventListener(e2, function() {
        clearTimeout(this.timer), this.log("visibilitychange, clear timeout:" + this.timer);
      }.bind(this), false), window.addEventListener("pagehide", function() {
        this.log("page hide, clear timeout:" + this.timer), clearTimeout(this.timer);
      }.bind(this), false);
    } }, Is = en(Ts, "Deeplink", "sdkReady"), $s = "1.25.4", As = { init: function(e2) {
      gs = e2, _s = gs && gs._, hs = gs && gs.log || console && console.log || function() {
      }, on2();
    }, handleCommand: ln }, Ds = an(As, "IOSBridge", "sdkAfterInitPara"), xs = "1.25.4", Es = { init: function(e2) {
      ms = e2, vs = ms && ms._, ys = ms && ms.log || console && console.log || function() {
      }, dn();
    } }, Ls = pn(Es, "IOSObsoleteBridge", "sdkAfterInitPara"), Us = "1.25.4", Rs = 5e3, Hs = 432e3;
    yn.prototype.init = function(e2, t2) {
      if (e2) {
        if (this.sd = e2, this._ = this.sd._, t2) {
          this.option = t2;
          var r2 = t2.heartbeat_interval_time;
          r2 && (this._.isNumber(r2) || this._.isNumber(1 * r2)) && 1 * r2 > 0 && (this.heartbeat_interval_time = 1e3 * r2);
          var n2 = t2.max_duration;
          n2 && (this._.isNumber(n2) || this._.isNumber(1 * n2)) && 1 * n2 > 0 && (this.max_duration = n2);
        }
        this.page_id = Number(String(this._.getRandom()).slice(2, 5) + String(this._.getRandom()).slice(2, 4) + String(new Date().getTime()).slice(-4)), this.addEventListener(), document.hidden === true ? this.page_show_status = false : this.addHeartBeatInterval(), this.log("PageLeave\u521D\u59CB\u5316\u5B8C\u6BD5");
      } else
        this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, yn.prototype.log = function(e2) {
      this.sd && this.sd.log(e2);
    }, yn.prototype.refreshPageEndTimer = function() {
      var e2 = this;
      this.timer && (clearTimeout(this.timer), this.timer = null), this.timer = setTimeout(function() {
        e2.page_hidden_status = false;
      }, Rs);
    }, yn.prototype.hiddenStatusHandler = function() {
      clearTimeout(this.timer), this.timer = null, this.page_hidden_status = false;
    }, yn.prototype.pageStartHandler = function() {
      this.start_time = +new Date(), !document.hidden == true ? this.page_show_status = true : this.page_show_status = false, this.url = location.href, this.title = document.title;
    }, yn.prototype.pageEndHandler = function() {
      if (this.page_hidden_status !== true) {
        var e2 = this.getPageLeaveProperties();
        this.page_show_status === false && delete e2.event_duration, this.page_show_status = false, this.page_hidden_status = true, this.isCollectUrl(this.url) && this.sd.track("$WebPageLeave", e2), this.refreshPageEndTimer(), this.delHeartBeatData();
      }
    }, yn.prototype.addEventListener = function() {
      this.addPageStartListener(), this.addPageSwitchListener(), this.addSinglePageListener(), this.addPageEndListener();
    }, yn.prototype.addPageStartListener = function() {
      var e2 = this;
      "onpageshow" in window && this._.addEvent(window, "pageshow", function() {
        e2.pageStartHandler(), e2.hiddenStatusHandler();
      });
    }, yn.prototype.isCollectUrl = function(e2) {
      return typeof this.option.isCollectUrl != "function" || (typeof e2 != "string" || e2 === "" || this.option.isCollectUrl(e2));
    }, yn.prototype.addSinglePageListener = function() {
      var e2 = this;
      this.sd.ee && this.sd.ee.spa.prepend("switch", function(t2) {
        t2 !== location.href && (e2.url = t2, e2.pageEndHandler(), e2.stopHeartBeatInterval(), e2.current_page_url = e2.url, e2.pageStartHandler(), e2.hiddenStatusHandler(), e2.addHeartBeatInterval());
      });
    }, yn.prototype.addPageEndListener = function() {
      var e2 = this;
      this._.each(["pagehide", "beforeunload", "unload"], function(t2) {
        "on" + t2 in window && e2._.addEvent(window, t2, function() {
          e2.pageEndHandler(), e2.stopHeartBeatInterval();
        });
      });
    }, yn.prototype.addPageSwitchListener = function() {
      var e2 = this;
      this._.listenPageState({ visible: function() {
        e2.pageStartHandler(), e2.hiddenStatusHandler(), e2.addHeartBeatInterval();
      }, hidden: function() {
        e2.url = location.href, e2.title = document.title, e2.pageEndHandler(), e2.stopHeartBeatInterval();
      } });
    }, yn.prototype.addHeartBeatInterval = function() {
      this._.localStorage.isSupport() && this.startHeartBeatInterval();
    }, yn.prototype.startHeartBeatInterval = function() {
      var e2 = this;
      this.heartbeat_interval_timer && this.stopHeartBeatInterval();
      var t2 = true;
      this.isCollectUrl(this.url) || (t2 = false), this.heartbeat_interval_timer = setInterval(function() {
        t2 && e2.saveHeartBeatData();
      }, this.heartbeat_interval_time), t2 && this.saveHeartBeatData("is_first_heartbeat"), this.reissueHeartBeatData();
    }, yn.prototype.stopHeartBeatInterval = function() {
      clearInterval(this.heartbeat_interval_timer), this.heartbeat_interval_timer = null;
    }, yn.prototype.saveHeartBeatData = function(e2) {
      var t2 = this.getPageLeaveProperties(), r2 = new Date();
      t2.$time = r2, e2 === "is_first_heartbeat" && (t2.event_duration = 3.14);
      var n2 = this.sd.kit.buildData({ type: "track", event: "$WebPageLeave", properties: t2 });
      try {
        this.sd.bridge.bridge_info.verify_success === "success" && (n2.properties.$time = 1 * r2);
      } catch (i2) {
        this.log(i2.message);
      }
      n2.heartbeat_interval_time = this.heartbeat_interval_time, this.sd.store.saveObjectVal(this.storage_name + "-" + this.page_id, n2);
    }, yn.prototype.delHeartBeatData = function(e2) {
      this._.localStorage.isSupport() && this._.localStorage.remove(e2 || this.storage_name + "-" + this.page_id);
    }, yn.prototype.reissueHeartBeatData = function() {
      for (var e2 = window.localStorage.length, t2 = e2 - 1; t2 >= 0; t2--) {
        var r2 = window.localStorage.key(t2);
        if (r2 && r2 !== this.storage_name + "-" + this.page_id && r2.indexOf(this.storage_name + "-") === 0) {
          var n2 = this.sd.store.readObjectVal(r2);
          this._.isObject(n2) && 1 * new Date() - n2.time > n2.heartbeat_interval_time + 5e3 && (delete n2.heartbeat_interval_time, this.sd.kit.sendData(n2), this.delHeartBeatData(r2));
        }
      }
    }, yn.prototype.getPageLeaveProperties = function() {
      var e2 = (+new Date() - this.start_time) / 1e3;
      (isNaN(e2) || e2 < 0 || e2 > this.max_duration) && (e2 = 0), e2 = Number(e2.toFixed(3));
      var t2 = this._.getReferrer(this.current_page_url), r2 = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body && document.body.scrollTop || 0;
      r2 = Math.round(r2) || 0;
      var n2 = { $title: this.title, $url: this._.getURL(this.url), $url_path: this._.getURLPath(this._.URL(this.url).pathname), $referrer_host: t2 ? this._.getHostname(t2) : "", $referrer: t2, $viewport_position: r2 };
      return e2 !== 0 && (n2.event_duration = e2), n2 = this._.extend(n2, this.option.custom_props);
    };
    var Bs = new yn(), Js = vn(Bs, "PageLeave", "sdkReady"), Ms = "1.25.4", qs = false, Ks = { init: function(e2, t2) {
      function r2(t3, r3) {
        if (t3.getEntries && typeof t3.getEntries == "function") {
          for (var n3 = t3.getEntries(), i3 = null, a3 = 0; a3 < n3.length; a3++)
            "transferSize" in n3[a3] && (i3 += n3[a3].transferSize);
          e2._.isNumber(i3) && i3 >= 0 && i3 < 10737418240 && (r3.$page_resource_size = Number((i3 / 1024).toFixed(3)));
        }
      }
      function n2(t3) {
        var r3 = 0;
        if (t3.timing) {
          var n3 = t3.timing;
          n3.fetchStart !== 0 && e2._.isNumber(n3.fetchStart) && n3.domContentLoadedEventEnd !== 0 && e2._.isNumber(n3.domContentLoadedEventEnd) ? r3 = n3.domContentLoadedEventEnd - n3.fetchStart : e2.log("performance \u6570\u636E\u83B7\u53D6\u5F02\u5E38");
        }
        return r3;
      }
      function i2(t3) {
        var r3 = 0;
        if (e2._.isFunction(t3.getEntriesByType)) {
          var n3 = t3.getEntriesByType("navigation") || [{}];
          r3 = (n3[0] || {}).domContentLoadedEventEnd || 0;
        }
        return r3;
      }
      function a2() {
        var o2 = 0, s2 = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance, l2 = { $url: e2._.getURL(), $title: document.title, $url_path: e2._.getURLPath(), $referrer: e2._.getReferrer(null, true) };
        if (s2 ? (o2 = i2(s2) || n2(s2), r2(s2, l2)) : e2.log("\u6D4F\u89C8\u5668\u672A\u652F\u6301 performance API."), o2 > 0) {
          var u2 = e2._.isObject(t2) && t2.max_duration || 1800;
          o2 = Number((o2 / 1e3).toFixed(3)), (!e2._.isNumber(u2) || u2 <= 0 || o2 <= u2) && (l2.event_duration = o2);
        }
        qs || (e2.track("$WebPageLoad", l2), qs = true), window.removeEventListener ? window.removeEventListener("load", a2) : window.detachEvent && window.detachEvent("onload", a2);
      }
      document.readyState == "complete" ? a2() : window.addEventListener ? window.addEventListener("load", a2) : window.attachEvent && window.attachEvent("onload", a2);
    } }, Vs = Sn(Ks, "PageLoad", "sdkReady");
    Pn.prototype.init = function(e2) {
      if (e2) {
        this.sd = e2, this._ = e2._, this.log = e2.log;
        var t2 = this;
        e2.registerInterceptor("buildDataStage", { extendProps: { priority: 0, entry: function(e3) {
          return kn(e3, t2);
        } } });
      } else
        this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, Pn.prototype.register = function(e2) {
      return this.sd ? void (this._.isObject(e2) && this._.isArray(e2.events) && e2.events.length > 0 && this._.isObject(e2.properties) && !this._.isEmptyObject(e2.properties) ? this.customRegister.push(e2) : this.log("RegisterProperties: register \u53C2\u6570\u9519\u8BEF")) : void this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, Pn.prototype.hookRegister = function(e2) {
      return this.sd ? void (this._.isFunction(e2) ? this.customRegister.push(e2) : this.log("RegisterProperties: hookRegister \u53C2\u6570\u9519\u8BEF")) : void this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    };
    var Fs = "1.25.4";
    Pn.prototype.plugin_name = "RegisterProperties";
    var zs, Ws, Xs = new Pn(), Zs = Nn(Xs), Gs = "1.25.4", Qs = window.console && window.console.log || function() {
    }, Ys = { init: function(e2) {
      return zs = e2, Qs = zs && zs.log || Qs, e2 && e2.kit && e2.kit.buildData ? (Ws = zs.kit.buildData, zs.kit.buildData = $n, void Qs("RegisterPropertyPageHeight \u63D2\u4EF6\u521D\u59CB\u5316\u5B8C\u6210")) : void Qs("RegisterPropertyPageHeight \u63D2\u4EF6\u521D\u59CB\u5316\u5931\u8D25,\u5F53\u524D\u4E3Bsdk\u4E0D\u652F\u6301 RegisterPropertyPageHeight \u63D2\u4EF6\uFF0C\u8BF7\u5347\u7EA7\u4E3Bsdk");
    } }, el = In(Ys, "RegisterPropertyPageHeight", "sdkReady"), tl = "1.25.4", rl = {};
    rl.getPart = function(e2) {
      var t2 = false, r2 = this.option.length;
      if (r2) {
        for (var n2 = 0; n2 < r2; n2++)
          if (e2.indexOf(this.option[n2].part_url) > -1)
            return true;
      }
      return t2;
    }, rl.getPartHash = function(e2) {
      var t2 = this.option.length, r2 = false;
      if (t2) {
        for (var n2 = 0; n2 < t2; n2++)
          if (e2.indexOf(this.option[n2].part_url) > -1)
            return this.option[n2].after_hash;
      }
      return !!r2;
    }, rl.getCurrenId = function() {
      var e2 = this.store.getDistinctId() || "", t2 = this.store.getFirstId() || "";
      this._.urlSafeBase64 && this._.urlSafeBase64.encode ? e2 = e2 ? this._.urlSafeBase64.trim(this._.urlSafeBase64.encode(this._.base64Encode(e2))) : "" : this._.rot13obfs && (e2 = e2 ? this._.rot13obfs(e2) : "");
      var r2 = t2 ? "f" + e2 : "d" + e2;
      return encodeURIComponent(r2);
    }, rl.rewriteUrl = function(e2, t2) {
      var r2 = this, n2 = /([^?#]+)(\?[^#]*)?(#.*)?/, i2 = n2.exec(e2), a2 = "";
      if (i2) {
        var o2, s2 = i2[1] || "", l2 = i2[2] || "", u2 = i2[3] || "", c2 = "_sasdk=" + this.getCurrenId(), p2 = function(e3) {
          var t3 = e3.split("&"), n3 = [];
          return r2._.each(t3, function(e4) {
            e4.indexOf("_sasdk=") > -1 ? n3.push(c2) : n3.push(e4);
          }), n3.join("&");
        };
        if (this.getPartHash(e2)) {
          o2 = u2.indexOf("_sasdk");
          var d2 = u2.indexOf("?");
          a2 = d2 > -1 ? o2 > -1 ? s2 + l2 + "#" + u2.substring(1, o2) + p2(u2.substring(o2, u2.length)) : s2 + l2 + u2 + "&" + c2 : s2 + l2 + "#" + u2.substring(1) + "?" + c2;
        } else {
          o2 = l2.indexOf("_sasdk");
          var f2 = /^\?(\w)+/.test(l2);
          a2 = f2 ? o2 > -1 ? s2 + "?" + p2(l2.substring(1)) + u2 : s2 + l2 + "&" + c2 + u2 : s2 + "?" + c2 + u2;
        }
        return t2 && (t2.href = a2), a2;
      }
    }, rl.getUrlId = function() {
      var e2 = location.href.match(/_sasdk=([aufd][^\?\#\&\=]+)/);
      if (this._.isArray(e2) && e2[1]) {
        var t2 = decodeURIComponent(e2[1]);
        return !t2 || t2.substring(0, 1) !== "f" && t2.substring(0, 1) !== "d" || (this._.urlSafeBase64 && this._.urlSafeBase64.isUrlSafeBase64 && this._.urlSafeBase64.isUrlSafeBase64(t2) ? t2 = t2.substring(0, 1) + this._.base64Decode(this._.urlSafeBase64.decode(t2.substring(1))) : this._.rot13defs && (t2 = t2.substring(0, 1) + this._.rot13defs(t2.substring(1)))), t2;
      }
      return "";
    }, rl.setRefferId = function(e2) {
      var t2 = this.store.getDistinctId(), r2 = this.getUrlId();
      if (r2 && r2 !== "") {
        var n2 = r2.substring(0, 1) === "a" || r2.substring(0, 1) === "d";
        r2 = r2.substring(1), r2 !== t2 && (n2 ? (this.sd.identify(r2, true), this.store.getFirstId() && this.sd.saEvent.send({ original_id: r2, distinct_id: t2, type: "track_signup", event: "$SignUp", properties: {} }, null)) : this.store.getFirstId() && !e2.re_login || this.sd.login(r2));
      }
    }, rl.addListen = function() {
      var e2 = this, t2 = function(t3) {
        var r2, n2, i2 = t3.target, a2 = i2.tagName.toLowerCase(), o2 = i2.parentNode;
        if (a2 === "a" && i2.href || o2 && o2.tagName && o2.tagName.toLowerCase() === "a" && o2.href) {
          a2 === "a" && i2.href ? (r2 = i2.href, n2 = i2) : (r2 = o2.href, n2 = o2);
          var s2 = e2._.URL(r2), l2 = s2.protocol;
          l2 !== "http:" && l2 !== "https:" || e2.getPart(r2) && e2.rewriteUrl(r2, n2);
        }
      };
      e2._.addEvent(document, "mousedown", t2), window.PointerEvent && "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints >= 0 && e2._.addEvent(document, "pointerdown", t2);
    }, rl.init = function(e2, t2) {
      function r2(t3) {
        for (var r3 = t3.length, n2 = [], i2 = 0; i2 < r3; i2++)
          /[A-Za-z0-9]+\./.test(t3[i2].part_url) && Object.prototype.toString.call(t3[i2].after_hash) == "[object Boolean]" ? n2.push(t3[i2]) : e2.log("linker \u914D\u7F6E\u7684\u7B2C " + (i2 + 1) + " \u9879\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u68C0\u67E5\u53C2\u6570\u683C\u5F0F\uFF01");
        return n2;
      }
      return this.sd = e2, this._ = e2._, this.store = e2.store, this.para = e2.para, this._.isObject(t2) && this._.isArray(t2.linker) && t2.linker.length > 0 ? (this.setRefferId(t2), this.addListen(), this.option = t2.linker, void (this.option = r2(this.option))) : void e2.log("\u8BF7\u914D\u7F6E\u6253\u901A\u57DF\u540D\u53C2\u6570\uFF01");
    };
    var nl, il, al, ol, sl, ll, ul, cl, pl, dl, fl, gl, _l, hl = xn(rl, "SiteLinker", "sdkReady"), ml = "utm_source utm_medium utm_campaign utm_content utm_term", vl = "1.25.4", yl = { init: function(e2) {
      function t2() {
        var e3 = ml.split(" "), t3 = "", r2 = {};
        return nl._.isArray(nl.para.source_channel) && nl.para.source_channel.length > 0 && (e3 = e3.concat(nl.para.source_channel), e3 = nl._.unique(e3)), nl._.each(e3, function(e4) {
          t3 = nl._.getQueryParam(location.href, e4), t3.length && (r2[e4] = t3);
        }), r2;
      }
      e2 && !nl && (nl = e2, nl.registerInterceptor("businessStage", { getUtmData: { priority: 0, entry: function() {
        return t2();
      } } }));
    } }, bl = Un(yl, "Utm", "sdkAfterInitPara"), wl = "1.25.4", Sl = false, kl = null, Pl = { init: function(e2) {
      kl = e2, kl.disableSDK = Jn, kl.enableSDK = Mn, kl.getDisabled = qn;
    } }, Cl = Bn(Pl, "DisableSDK", "sdkInitAPI"), Ol = "1.25.4", Nl = { plugin_name: "DebugSender", init: function(e2) {
      il = e2, al = il._, Zn();
    } }, jl = Fn(Nl), Tl = "1.25.4", Il = { plugin_name: "JsappSender", init: function(e2) {
      ol = e2, sl = ol._, ti();
    } }, $l = Yn(Il), Al = "1.25.4", Dl = null, xl = { plugin_name: "BatchSender", init: function(e2) {
      ll = e2, ul = ll._, li();
    } }, El = ai(xl), Ll = "1.25.4", Ul = { plugin_name: "BeaconSender", init: function(e2) {
      cl = e2, pl = cl._, _i();
    } }, Rl = pi(Ul), Hl = "1.25.4", Bl = { plugin_name: "AjaxSender", init: function(e2) {
      dl = e2, fl = dl._, Si();
    } }, Jl = vi(Bl), Ml = "1.25.4", ql = { plugin_name: "ImageSender", init: function(e2) {
      gl = e2, _l = gl._, Ii();
    } }, Kl = Ci(ql), Vl = null, Fl = null, zl = [], Wl = { init: function(e2) {
      e2 && (Vl = e2, Fl = Vl._, Vl.logger && Vl.logger.appendWriter(xi), Vl.on && Vl.on("sdkAfterInitPara", function() {
        for (var e3 = 0; e3 < zl.length; e3++)
          Ei(zl[e3]);
        zl = null;
      }), Vl.on && Vl.on("sdkInitAPI", function() {
        Vl.enableLocalLog = Ji, Vl.disableLocalLog = Mi;
      }));
    } }, Xl = Di(Wl, "ConsoleLogger"), Zl = "sensorsdata_jssdk_debug";
    Ki.modules = Ki.modules || {};
    for (var Gl = [Xl, Ko, Qo, os, us, Is, Ds, Ls, Js, Vs, Zs, el, hl, bl, Cl, jl, $l, El, Rl, Jl, Kl], Ql = [Xl, Jo, bl, Cl, $l, jl, Qo, Ds, os, Ls, El, Rl, Jl, Kl], Yl = 0; Yl < Gl.length; Yl++) {
      var eu = Gl[Yl];
      Ki._.isString(eu.plugin_name) ? Ki.modules[eu.plugin_name] = eu : Ki._.isArray(eu.plugin_name) && Ki._.each(eu.plugin_name, function(e2) {
        Ki.modules[e2] = eu;
      });
    }
    for (Yl = 0; Yl < Ql.length; Yl++)
      Ki.use(Ql[Yl]);
    var tu = Ki;
    try {
      typeof window.sensorsDataAnalytic201505 == "string" ? (Ki.para = window[sensorsDataAnalytic201505].para, Ki._q = window[sensorsDataAnalytic201505]._q, window[sensorsDataAnalytic201505] = Ki, window.sensorsDataAnalytic201505 = Ki, Ki.init()) : typeof window.sensorsDataAnalytic201505 == "undefined" ? window.sensorsDataAnalytic201505 = Ki : tu = window.sensorsDataAnalytic201505;
    } catch (ru) {
      je(ru);
    }
    var nu = tu;
    return nu;
  });
})(sensorsdata);
var sensors$1 = sensorsdata.exports;
var uaParser = { exports: {} };
(function(module, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "0.7.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend2 = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i in regexes2) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes2[i]);
        } else {
          mergedRegexes[i] = regexes2[i];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    }, has = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version2) {
      return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    }, trim2 = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua2, arrays) {
      var i = 0, j, k, p, q, matches, match;
      while (i < arrays.length && !matches) {
        var regex = arrays[i], props2 = arrays[i + 1];
        j = k = 0;
        while (j < regex.length && !matches) {
          if (!regex[j]) {
            break;
          }
          matches = regex[j++].exec(ua2);
          if (!!matches) {
            for (p = 0; p < props2.length; p++) {
              match = matches[++k];
              q = props2[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                  } else {
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                }
              } else {
                this[q] = match ? match : undefined$1;
              }
            }
          }
        }
        i += 2;
      }
    }, strMapper = function(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has(map[i][j], str)) {
              return i === UNKNOWN ? undefined$1 : i;
            }
          }
        } else if (has(map[i], str)) {
          return i === UNKNOWN ? undefined$1 : i;
        }
      }
      return str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /opios[\/ ]+([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          /(heytap|ovi)browser\/([\d\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [VERSION2, [NAME, "UC" + BROWSER]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          /\bqbcore\/([\w\.]+).+microm/i
        ],
        [VERSION2, [NAME, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [VERSION2, [NAME, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION2],
        [
          /\bfocus\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "MIUI " + BROWSER]],
        [
          /fxios\/([-\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
        ],
        [[NAME, "360 " + BROWSER]],
        [
          /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 " + BROWSER], VERSION2],
        [
          /(comodo_dragon)\/([\w\.]+)/i
        ],
        [[NAME, /_/g, " "], VERSION2],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          /(lbbrowser)/i,
          /\[(linkedin)app\]/i
        ],
        [NAME],
        [
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [[NAME, FACEBOOK], VERSION2],
        [
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [VERSION2, [NAME, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
        ],
        [VERSION2, [NAME, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [VERSION2, [NAME, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [[NAME, CHROME + " WebView"], VERSION2],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [VERSION2, [NAME, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        ],
        [VERSION2, [NAME, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        ],
        [VERSION2, NAME],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [NAME, [VERSION2, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [[NAME, "Netscape"], VERSION2],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [VERSION2, [NAME, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /(links) \(([\w\.]+)/i,
          /panasonic;(viera)/i
        ],
        [NAME, VERSION2],
        [
          /(cobalt)\/([\w\.]+)/i
        ],
        [NAME, [VERSION2, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
        ],
        [[ARCHITECTURE, lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          /windows (ce|mobile); ppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        ],
        [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
        [
          /(sun4\w)[;\)]/i
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /(macintosh);/i
        ],
        [MODEL, [VENDOR, APPLE]],
        [
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
        [
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          /\b(poco[\w ]+)(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
        [
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
        [
          /(pixel c)\b/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          /(playbook);[-\w\),; ]+(rim)/i
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          /(nexus 9)/i
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          /(hp) ([\w ]+\w)/i,
          /(asus)-?(\w+)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w]+)/i,
          /(jolla)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kobo)\s(ereader|touch)/i,
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /(shield[\w ]+) b/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          /smart-tv.+(samsung)/i
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w)( bui|\))/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
        [
          /(bravia[\w ]+)( bui|\))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
        [
          /(mitv-\w{5}) bui/i
        ],
        [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
        [
          /Hbbtv.*(technisat) (.*);/i
        ],
        [VENDOR, MODEL, [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
        ],
        [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[TYPE, SMARTTV]],
        [
          /(ouya)/i,
          /(nintendo) ([wids3utch]+)/i
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield) bui/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation [345portablevi]+)/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          /((pebble))app/i
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /(quest( 2| pro)?)/i
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /(aeobc)\b/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        ],
        [[TYPE, MOBILE]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, EDGE + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          /\b(libweb)/i
        ],
        [NAME, VERSION2],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [VERSION2, NAME]
      ],
      os: [
        [
          /microsoft (windows) (vista|xp)/i
        ],
        [NAME, VERSION2],
        [
          /(windows) nt 6\.2; (arm)/i,
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [NAME, [VERSION2, strMapper, windowsVersionMap]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[NAME, "Windows"], [VERSION2, strMapper, windowsVersionMap]],
        [
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /ios;fbsv\/([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION2, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [[NAME, MAC_OS], [VERSION2, /_/g, "."]],
        [
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        ],
        [VERSION2, NAME],
        [
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          /\((series40);/i
        ],
        [NAME, VERSION2],
        [
          /\(bb(10);/i
        ],
        [VERSION2, [NAME, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        ],
        [VERSION2, [NAME, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
        ],
        [VERSION2, [NAME, "watchOS"]],
        [
          /crkey\/([\d\.]+)/i
        ],
        [VERSION2, [NAME, CHROME + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
        ],
        [[NAME, CHROMIUM_OS], VERSION2],
        [
          /panasonic;(viera)/i,
          /(netrange)mmh/i,
          /(nettv)\/(\d+\.[\w\.]+)/i,
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux) ?([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [NAME, VERSION2],
        [
          /(sunos) ?([\w\.\d]*)/i
        ],
        [[NAME, "Solaris"], VERSION2],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [NAME, VERSION2]
      ]
    };
    var UAParser2 = function(ua2, extensions) {
      if (typeof ua2 === OBJ_TYPE) {
        extensions = ua2;
        ua2 = undefined$1;
      }
      if (!(this instanceof UAParser2)) {
        return new UAParser2(ua2, extensions).getResult();
      }
      var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1;
      var _ua = ua2 || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION2] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION2]);
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = "Brave";
        }
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION2] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION2] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua3) {
        _ua = typeof ua3 === STR_TYPE && ua3.length > UA_MAX_LENGTH ? trim2(ua3, UA_MAX_LENGTH) : ua3;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser2.VERSION = LIBVERSION;
    UAParser2.BROWSER = enumerize([NAME, VERSION2, MAJOR]);
    UAParser2.CPU = enumerize([ARCHITECTURE]);
    UAParser2.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser2.ENGINE = UAParser2.OS = enumerize([NAME, VERSION2]);
    {
      if (module.exports) {
        exports = module.exports = UAParser2;
      }
      exports.UAParser = UAParser2;
    }
    var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser2();
      $.ua = parser.getResult();
      $.ua.get = function() {
        return parser.getUA();
      };
      $.ua.set = function(ua2) {
        parser.setUA(ua2);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var UAParser = uaParser.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
}
class Tools {
  static getUuid() {
    const timeStamp = new Date().getTime();
    return `${"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    })}-${timeStamp}`;
  }
  static isOnlyObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
  }
}
/*! js-cookie v3.0.1 | MIT */
function assign$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source2 = arguments[i];
    for (var key in source2) {
      target[key] = source2[key];
    }
  }
  return target;
}
var defaultConverter$1 = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init$1(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign$1({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get2(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set,
    get: get2,
    remove: function(key, attributes) {
      set(key, "", assign$1({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init$1(this.converter, assign$1({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init$1(assign$1({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
var api$1 = init$1(defaultConverter$1, { path: "/" });
function getLocalClientId() {
  let id = api$1.get("_MG_C_CID");
  if (!id) {
    id = Date.parse(new Date() + "") + "-" + Math.floor(Math.random() * 1e8);
    api$1.set("_MG_C_CID", id);
  }
  return id;
}
function getGpuInfo() {
  var _a2, _b;
  const canvas = document.createElement("canvas");
  let context;
  let webglInfo = "unknow";
  let gpuVendor = "unknow";
  let gpuApi = "unknow";
  let webglVersion = "experimental";
  try {
    context = canvas.getContext("webgl2");
    if (context) {
      webglVersion = "webgl2";
    }
  } catch (l) {
  }
  if (!context) {
    try {
      context = canvas.getContext("webgl");
      if (context) {
        webglVersion = "webgl";
      }
    } catch (l) {
    }
  }
  if (context) {
    const debugInfo = context === null || context === void 0 ? void 0 : context.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
      webglInfo = context.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL).toLowerCase();
      gpuVendor = ((_a2 = /\bamd\b|\bati\b|\bnvidia\b|\bintel\b/.exec(webglInfo)) === null || _a2 === void 0 ? void 0 : _a2[0]) || "unknow";
      if (gpuVendor === "ati")
        gpuVendor = "amd";
      gpuApi = ((_b = /direct3d9|direct3d11|opengl/.exec(webglInfo)) === null || _b === void 0 ? void 0 : _b[0]) || "unknow";
    }
  }
  return {
    gpuVendor,
    gpuApi,
    webglVersion,
    webglInfo
  };
}
const ua = new UAParser().getResult();
let infoHost;
function hostInfo() {
  var _a2;
  if (infoHost)
    return infoHost;
  infoHost = Object.assign(Object.assign({}, ua), { clientId: getLocalClientId(), gpu: getGpuInfo(), memory: (_a2 = navigator.deviceMemory) !== null && _a2 !== void 0 ? _a2 : "unknow" });
  return infoHost;
}
var version = "3.3.2";
function wait(durationMs, resolveWith) {
  return new Promise(function(resolve) {
    return setTimeout(resolve, durationMs, resolveWith);
  });
}
function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
  if (deadlineTimeout === void 0) {
    deadlineTimeout = Infinity;
  }
  var requestIdleCallback2 = window.requestIdleCallback;
  if (requestIdleCallback2) {
    return new Promise(function(resolve) {
      return requestIdleCallback2.call(window, function() {
        return resolve();
      }, { timeout: deadlineTimeout });
    });
  } else {
    return wait(Math.min(fallbackTimeout, deadlineTimeout));
  }
}
function isPromise(value) {
  return value && typeof value.then === "function";
}
function awaitIfAsync(action, callback) {
  try {
    var returnedValue = action();
    if (isPromise(returnedValue)) {
      returnedValue.then(function(result) {
        return callback(true, result);
      }, function(error) {
        return callback(false, error);
      });
    } else {
      callback(true, returnedValue);
    }
  } catch (error) {
    callback(false, error);
  }
}
function forEachWithBreaks(items, callback, loopReleaseInterval) {
  if (loopReleaseInterval === void 0) {
    loopReleaseInterval = 16;
  }
  return __awaiter(this, void 0, void 0, function() {
    var lastLoopReleaseTime, i, now;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          lastLoopReleaseTime = Date.now();
          i = 0;
          _a2.label = 1;
        case 1:
          if (!(i < items.length))
            return [3, 4];
          callback(items[i], i);
          now = Date.now();
          if (!(now >= lastLoopReleaseTime + loopReleaseInterval))
            return [3, 3];
          lastLoopReleaseTime = now;
          return [4, wait(0)];
        case 2:
          _a2.sent();
          _a2.label = 3;
        case 3:
          ++i;
          return [3, 1];
        case 4:
          return [2];
      }
    });
  });
}
function x64Add(m2, n) {
  m2 = [m2[0] >>> 16, m2[0] & 65535, m2[1] >>> 16, m2[1] & 65535];
  n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
  var o2 = [0, 0, 0, 0];
  o2[3] += m2[3] + n[3];
  o2[2] += o2[3] >>> 16;
  o2[3] &= 65535;
  o2[2] += m2[2] + n[2];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[1] += m2[1] + n[1];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[0] += m2[0] + n[0];
  o2[0] &= 65535;
  return [o2[0] << 16 | o2[1], o2[2] << 16 | o2[3]];
}
function x64Multiply(m2, n) {
  m2 = [m2[0] >>> 16, m2[0] & 65535, m2[1] >>> 16, m2[1] & 65535];
  n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
  var o2 = [0, 0, 0, 0];
  o2[3] += m2[3] * n[3];
  o2[2] += o2[3] >>> 16;
  o2[3] &= 65535;
  o2[2] += m2[2] * n[3];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[2] += m2[3] * n[2];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[1] += m2[1] * n[3];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[1] += m2[2] * n[2];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[1] += m2[3] * n[1];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[0] += m2[0] * n[3] + m2[1] * n[2] + m2[2] * n[1] + m2[3] * n[0];
  o2[0] &= 65535;
  return [o2[0] << 16 | o2[1], o2[2] << 16 | o2[3]];
}
function x64Rotl(m2, n) {
  n %= 64;
  if (n === 32) {
    return [m2[1], m2[0]];
  } else if (n < 32) {
    return [m2[0] << n | m2[1] >>> 32 - n, m2[1] << n | m2[0] >>> 32 - n];
  } else {
    n -= 32;
    return [m2[1] << n | m2[0] >>> 32 - n, m2[0] << n | m2[1] >>> 32 - n];
  }
}
function x64LeftShift(m2, n) {
  n %= 64;
  if (n === 0) {
    return m2;
  } else if (n < 32) {
    return [m2[0] << n | m2[1] >>> 32 - n, m2[1] << n];
  } else {
    return [m2[1] << n - 32, 0];
  }
}
function x64Xor(m2, n) {
  return [m2[0] ^ n[0], m2[1] ^ n[1]];
}
function x64Fmix(h) {
  h = x64Xor(h, [0, h[0] >>> 1]);
  h = x64Multiply(h, [4283543511, 3981806797]);
  h = x64Xor(h, [0, h[0] >>> 1]);
  h = x64Multiply(h, [3301882366, 444984403]);
  h = x64Xor(h, [0, h[0] >>> 1]);
  return h;
}
function x64hash128(key, seed) {
  key = key || "";
  seed = seed || 0;
  var remainder = key.length % 16;
  var bytes = key.length - remainder;
  var h1 = [0, seed];
  var h2 = [0, seed];
  var k1 = [0, 0];
  var k2 = [0, 0];
  var c1 = [2277735313, 289559509];
  var c2 = [1291169091, 658871167];
  var i;
  for (i = 0; i < bytes; i = i + 16) {
    k1 = [
      key.charCodeAt(i + 4) & 255 | (key.charCodeAt(i + 5) & 255) << 8 | (key.charCodeAt(i + 6) & 255) << 16 | (key.charCodeAt(i + 7) & 255) << 24,
      key.charCodeAt(i) & 255 | (key.charCodeAt(i + 1) & 255) << 8 | (key.charCodeAt(i + 2) & 255) << 16 | (key.charCodeAt(i + 3) & 255) << 24
    ];
    k2 = [
      key.charCodeAt(i + 12) & 255 | (key.charCodeAt(i + 13) & 255) << 8 | (key.charCodeAt(i + 14) & 255) << 16 | (key.charCodeAt(i + 15) & 255) << 24,
      key.charCodeAt(i + 8) & 255 | (key.charCodeAt(i + 9) & 255) << 8 | (key.charCodeAt(i + 10) & 255) << 16 | (key.charCodeAt(i + 11) & 255) << 24
    ];
    k1 = x64Multiply(k1, c1);
    k1 = x64Rotl(k1, 31);
    k1 = x64Multiply(k1, c2);
    h1 = x64Xor(h1, k1);
    h1 = x64Rotl(h1, 27);
    h1 = x64Add(h1, h2);
    h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 1390208809]);
    k2 = x64Multiply(k2, c2);
    k2 = x64Rotl(k2, 33);
    k2 = x64Multiply(k2, c1);
    h2 = x64Xor(h2, k2);
    h2 = x64Rotl(h2, 31);
    h2 = x64Add(h2, h1);
    h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 944331445]);
  }
  k1 = [0, 0];
  k2 = [0, 0];
  switch (remainder) {
    case 15:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
    case 14:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
    case 13:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
    case 12:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
    case 11:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
    case 10:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
    case 9:
      k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
      k2 = x64Multiply(k2, c2);
      k2 = x64Rotl(k2, 33);
      k2 = x64Multiply(k2, c1);
      h2 = x64Xor(h2, k2);
    case 8:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
    case 7:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
    case 6:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
    case 5:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
    case 4:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
    case 3:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
    case 2:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
    case 1:
      k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
      k1 = x64Multiply(k1, c1);
      k1 = x64Rotl(k1, 31);
      k1 = x64Multiply(k1, c2);
      h1 = x64Xor(h1, k1);
  }
  h1 = x64Xor(h1, [0, key.length]);
  h2 = x64Xor(h2, [0, key.length]);
  h1 = x64Add(h1, h2);
  h2 = x64Add(h2, h1);
  h1 = x64Fmix(h1);
  h2 = x64Fmix(h2);
  h1 = x64Add(h1, h2);
  h2 = x64Add(h2, h1);
  return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
}
function errorToObject(error) {
  var _a2;
  return __assign({ name: error.name, message: error.message, stack: (_a2 = error.stack) === null || _a2 === void 0 ? void 0 : _a2.split("\n") }, error);
}
function includes(haystack, needle) {
  for (var i = 0, l = haystack.length; i < l; ++i) {
    if (haystack[i] === needle) {
      return true;
    }
  }
  return false;
}
function excludes(haystack, needle) {
  return !includes(haystack, needle);
}
function toInt(value) {
  return parseInt(value);
}
function toFloat(value) {
  return parseFloat(value);
}
function replaceNaN(value, replacement) {
  return typeof value === "number" && isNaN(value) ? replacement : value;
}
function countTruthy(values) {
  return values.reduce(function(sum, value) {
    return sum + (value ? 1 : 0);
  }, 0);
}
function round(value, base) {
  if (base === void 0) {
    base = 1;
  }
  if (Math.abs(base) >= 1) {
    return Math.round(value / base) * base;
  } else {
    var counterBase = 1 / base;
    return Math.round(value * counterBase) / counterBase;
  }
}
function parseSimpleCssSelector(selector) {
  var _a2, _b;
  var errorMessage = "Unexpected syntax '" + selector + "'";
  var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
  var tag = tagMatch[1] || void 0;
  var attributes = {};
  var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
  var addAttribute = function(name2, value) {
    attributes[name2] = attributes[name2] || [];
    attributes[name2].push(value);
  };
  for (; ; ) {
    var match = partsRegex.exec(tagMatch[2]);
    if (!match) {
      break;
    }
    var part = match[0];
    switch (part[0]) {
      case ".":
        addAttribute("class", part.slice(1));
        break;
      case "#":
        addAttribute("id", part.slice(1));
        break;
      case "[": {
        var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
        if (attributeMatch) {
          addAttribute(attributeMatch[1], (_b = (_a2 = attributeMatch[4]) !== null && _a2 !== void 0 ? _a2 : attributeMatch[5]) !== null && _b !== void 0 ? _b : "");
        } else {
          throw new Error(errorMessage);
        }
        break;
      }
      default:
        throw new Error(errorMessage);
    }
  }
  return [tag, attributes];
}
function ensureErrorWithMessage(error) {
  return error && typeof error === "object" && "message" in error ? error : { message: error };
}
function loadSource(source2, sourceOptions) {
  var isFinalResultLoaded = function(loadResult) {
    return typeof loadResult !== "function";
  };
  var sourceLoadPromise = new Promise(function(resolveLoad) {
    var loadStartTime = Date.now();
    awaitIfAsync(source2.bind(null, sourceOptions), function() {
      var loadArgs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        loadArgs[_i] = arguments[_i];
      }
      var loadDuration = Date.now() - loadStartTime;
      if (!loadArgs[0]) {
        return resolveLoad(function() {
          return { error: ensureErrorWithMessage(loadArgs[1]), duration: loadDuration };
        });
      }
      var loadResult = loadArgs[1];
      if (isFinalResultLoaded(loadResult)) {
        return resolveLoad(function() {
          return { value: loadResult, duration: loadDuration };
        });
      }
      resolveLoad(function() {
        return new Promise(function(resolveGet) {
          var getStartTime = Date.now();
          awaitIfAsync(loadResult, function() {
            var getArgs = [];
            for (var _i2 = 0; _i2 < arguments.length; _i2++) {
              getArgs[_i2] = arguments[_i2];
            }
            var duration = loadDuration + Date.now() - getStartTime;
            if (!getArgs[0]) {
              return resolveGet({ error: ensureErrorWithMessage(getArgs[1]), duration });
            }
            resolveGet({ value: getArgs[1], duration });
          });
        });
      });
    });
  });
  return function getComponent() {
    return sourceLoadPromise.then(function(finalizeSource) {
      return finalizeSource();
    });
  };
}
function loadSources(sources2, sourceOptions, excludeSources) {
  var includedSources = Object.keys(sources2).filter(function(sourceKey) {
    return excludes(excludeSources, sourceKey);
  });
  var sourceGetters = Array(includedSources.length);
  forEachWithBreaks(includedSources, function(sourceKey, index2) {
    sourceGetters[index2] = loadSource(sources2[sourceKey], sourceOptions);
  });
  return function getComponents() {
    return __awaiter(this, void 0, void 0, function() {
      var components, _i, includedSources_1, sourceKey, componentPromises, _loop_1, state_1;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            components = {};
            for (_i = 0, includedSources_1 = includedSources; _i < includedSources_1.length; _i++) {
              sourceKey = includedSources_1[_i];
              components[sourceKey] = void 0;
            }
            componentPromises = Array(includedSources.length);
            _loop_1 = function() {
              var hasAllComponentPromises;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    hasAllComponentPromises = true;
                    return [4, forEachWithBreaks(includedSources, function(sourceKey2, index2) {
                      if (!componentPromises[index2]) {
                        if (sourceGetters[index2]) {
                          componentPromises[index2] = sourceGetters[index2]().then(function(component) {
                            return components[sourceKey2] = component;
                          });
                        } else {
                          hasAllComponentPromises = false;
                        }
                      }
                    })];
                  case 1:
                    _a3.sent();
                    if (hasAllComponentPromises) {
                      return [2, "break"];
                    }
                    return [4, wait(1)];
                  case 2:
                    _a3.sent();
                    return [2];
                }
              });
            };
            _a2.label = 1;
          case 1:
            return [5, _loop_1()];
          case 2:
            state_1 = _a2.sent();
            if (state_1 === "break")
              return [3, 4];
            _a2.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [4, Promise.all(componentPromises)];
          case 5:
            _a2.sent();
            return [2, components];
        }
      });
    });
  };
}
function isTrident() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "MSCSSMatrix" in w,
    "msSetImmediate" in w,
    "msIndexedDB" in w,
    "msMaxTouchPoints" in n,
    "msPointerEnabled" in n
  ]) >= 4;
}
function isEdgeHTML() {
  var w = window;
  var n = navigator;
  return countTruthy(["msWriteProfilerMark" in w, "MSStream" in w, "msLaunchUri" in n, "msSaveBlob" in n]) >= 3 && !isTrident();
}
function isChromium() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "webkitPersistentStorage" in n,
    "webkitTemporaryStorage" in n,
    n.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in w,
    "BatteryManager" in w,
    "webkitMediaStream" in w,
    "webkitSpeechGrammar" in w
  ]) >= 5;
}
function isWebKit() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "ApplePayError" in w,
    "CSSPrimitiveValue" in w,
    "Counter" in w,
    n.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in n,
    "WebKitMediaKeys" in w
  ]) >= 4;
}
function isDesktopSafari() {
  var w = window;
  return countTruthy([
    "safari" in w,
    !("DeviceMotionEvent" in w),
    !("ongestureend" in w),
    !("standalone" in navigator)
  ]) >= 3;
}
function isGecko() {
  var _a2, _b;
  var w = window;
  return countTruthy([
    "buildID" in navigator,
    "MozAppearance" in ((_b = (_a2 = document.documentElement) === null || _a2 === void 0 ? void 0 : _a2.style) !== null && _b !== void 0 ? _b : {}),
    "onmozfullscreenchange" in w,
    "mozInnerScreenX" in w,
    "CSSMozDocumentRule" in w,
    "CanvasCaptureMediaStream" in w
  ]) >= 4;
}
function isChromium86OrNewer() {
  var w = window;
  return countTruthy([
    !("MediaSettingsRange" in w),
    "RTCEncodedAudioFrame" in w,
    "" + w.Intl === "[object Intl]",
    "" + w.Reflect === "[object Reflect]"
  ]) >= 3;
}
function isWebKit606OrNewer() {
  var w = window;
  return countTruthy([
    "DOMRectList" in w,
    "RTCPeerConnectionIceEvent" in w,
    "SVGGeometryElement" in w,
    "ontransitioncancel" in w
  ]) >= 3;
}
function isIPad() {
  if (navigator.platform === "iPad") {
    return true;
  }
  var s = screen;
  var screenRatio = s.width / s.height;
  return countTruthy([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    screenRatio > 0.65 && screenRatio < 1.53
  ]) >= 2;
}
function getFullscreenElement() {
  var d = document;
  return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function exitFullscreen() {
  var d = document;
  return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
function isAndroid() {
  var isItChromium = isChromium();
  var isItGecko = isGecko();
  if (!isItChromium && !isItGecko) {
    return false;
  }
  var w = window;
  return countTruthy([
    "onorientationchange" in w,
    "orientation" in w,
    isItChromium && !("SharedWorker" in w),
    isItGecko && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function getAudioFingerprint() {
  var w = window;
  var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
  if (!AudioContext) {
    return -2;
  }
  if (doesCurrentBrowserSuspendAudioContext()) {
    return -1;
  }
  var hashFromIndex = 4500;
  var hashToIndex = 5e3;
  var context = new AudioContext(1, hashToIndex, 44100);
  var oscillator = context.createOscillator();
  oscillator.type = "triangle";
  oscillator.frequency.value = 1e4;
  var compressor = context.createDynamicsCompressor();
  compressor.threshold.value = -50;
  compressor.knee.value = 40;
  compressor.ratio.value = 12;
  compressor.attack.value = 0;
  compressor.release.value = 0.25;
  oscillator.connect(compressor);
  compressor.connect(context.destination);
  oscillator.start(0);
  var _a2 = startRenderingAudio(context), renderPromise = _a2[0], finishRendering = _a2[1];
  var fingerprintPromise = renderPromise.then(function(buffer) {
    return getHash(buffer.getChannelData(0).subarray(hashFromIndex));
  }, function(error) {
    if (error.name === "timeout" || error.name === "suspended") {
      return -3;
    }
    throw error;
  });
  fingerprintPromise.catch(function() {
    return void 0;
  });
  return function() {
    finishRendering();
    return fingerprintPromise;
  };
}
function doesCurrentBrowserSuspendAudioContext() {
  return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
}
function startRenderingAudio(context) {
  var renderTryMaxCount = 3;
  var renderRetryDelay = 500;
  var runningMaxAwaitTime = 500;
  var runningSufficientTime = 5e3;
  var finalize = function() {
    return void 0;
  };
  var resultPromise = new Promise(function(resolve, reject) {
    var isFinalized = false;
    var renderTryCount = 0;
    var startedRunningAt = 0;
    context.oncomplete = function(event) {
      return resolve(event.renderedBuffer);
    };
    var startRunningTimeout = function() {
      setTimeout(function() {
        return reject(makeInnerError("timeout"));
      }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
    };
    var tryRender = function() {
      try {
        context.startRendering();
        switch (context.state) {
          case "running":
            startedRunningAt = Date.now();
            if (isFinalized) {
              startRunningTimeout();
            }
            break;
          case "suspended":
            if (!document.hidden) {
              renderTryCount++;
            }
            if (isFinalized && renderTryCount >= renderTryMaxCount) {
              reject(makeInnerError("suspended"));
            } else {
              setTimeout(tryRender, renderRetryDelay);
            }
            break;
        }
      } catch (error) {
        reject(error);
      }
    };
    tryRender();
    finalize = function() {
      if (!isFinalized) {
        isFinalized = true;
        if (startedRunningAt > 0) {
          startRunningTimeout();
        }
      }
    };
  });
  return [resultPromise, finalize];
}
function getHash(signal) {
  var hash = 0;
  for (var i = 0; i < signal.length; ++i) {
    hash += Math.abs(signal[i]);
  }
  return hash;
}
function makeInnerError(name2) {
  var error = new Error(name2);
  error.name = name2;
  return error;
}
function withIframe(action, initialHtml, domPollInterval) {
  var _a2, _b, _c;
  if (domPollInterval === void 0) {
    domPollInterval = 50;
  }
  return __awaiter(this, void 0, void 0, function() {
    var d, iframe;
    return __generator(this, function(_d) {
      switch (_d.label) {
        case 0:
          d = document;
          _d.label = 1;
        case 1:
          if (!!d.body)
            return [3, 3];
          return [4, wait(domPollInterval)];
        case 2:
          _d.sent();
          return [3, 1];
        case 3:
          iframe = d.createElement("iframe");
          _d.label = 4;
        case 4:
          _d.trys.push([4, , 10, 11]);
          return [4, new Promise(function(_resolve, _reject) {
            var isComplete = false;
            var resolve = function() {
              isComplete = true;
              _resolve();
            };
            var reject = function(error) {
              isComplete = true;
              _reject(error);
            };
            iframe.onload = resolve;
            iframe.onerror = reject;
            var style = iframe.style;
            style.setProperty("display", "block", "important");
            style.position = "absolute";
            style.top = "0";
            style.left = "0";
            style.visibility = "hidden";
            if (initialHtml && "srcdoc" in iframe) {
              iframe.srcdoc = initialHtml;
            } else {
              iframe.src = "about:blank";
            }
            d.body.appendChild(iframe);
            var checkReadyState = function() {
              var _a3, _b2;
              if (isComplete) {
                return;
              }
              if (((_b2 = (_a3 = iframe.contentWindow) === null || _a3 === void 0 ? void 0 : _a3.document) === null || _b2 === void 0 ? void 0 : _b2.readyState) === "complete") {
                resolve();
              } else {
                setTimeout(checkReadyState, 10);
              }
            };
            checkReadyState();
          })];
        case 5:
          _d.sent();
          _d.label = 6;
        case 6:
          if (!!((_b = (_a2 = iframe.contentWindow) === null || _a2 === void 0 ? void 0 : _a2.document) === null || _b === void 0 ? void 0 : _b.body))
            return [3, 8];
          return [4, wait(domPollInterval)];
        case 7:
          _d.sent();
          return [3, 6];
        case 8:
          return [4, action(iframe, iframe.contentWindow)];
        case 9:
          return [2, _d.sent()];
        case 10:
          (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
          return [7];
        case 11:
          return [2];
      }
    });
  });
}
function selectorToElement(selector) {
  var _a2 = parseSimpleCssSelector(selector), tag = _a2[0], attributes = _a2[1];
  var element = document.createElement(tag !== null && tag !== void 0 ? tag : "div");
  for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
    var name_1 = _b[_i];
    element.setAttribute(name_1, attributes[name_1].join(" "));
  }
  return element;
}
var testString = "mmMwWLliI0O&1";
var textSize = "48px";
var baseFonts = ["monospace", "sans-serif", "serif"];
var fontList = [
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function getFonts() {
  return withIframe(function(_, _a2) {
    var document2 = _a2.document;
    var holder = document2.body;
    holder.style.fontSize = textSize;
    var spansContainer = document2.createElement("div");
    var defaultWidth = {};
    var defaultHeight = {};
    var createSpan = function(fontFamily) {
      var span = document2.createElement("span");
      var style = span.style;
      style.position = "absolute";
      style.top = "0";
      style.left = "0";
      style.fontFamily = fontFamily;
      span.textContent = testString;
      spansContainer.appendChild(span);
      return span;
    };
    var createSpanWithFonts = function(fontToDetect, baseFont) {
      return createSpan("'" + fontToDetect + "'," + baseFont);
    };
    var initializeBaseFontsSpans = function() {
      return baseFonts.map(createSpan);
    };
    var initializeFontsSpans = function() {
      var spans = {};
      var _loop_1 = function(font2) {
        spans[font2] = baseFonts.map(function(baseFont) {
          return createSpanWithFonts(font2, baseFont);
        });
      };
      for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
        var font = fontList_1[_i];
        _loop_1(font);
      }
      return spans;
    };
    var isFontAvailable = function(fontSpans) {
      return baseFonts.some(function(baseFont, baseFontIndex) {
        return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] || fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
      });
    };
    var baseFontsSpans = initializeBaseFontsSpans();
    var fontsSpans = initializeFontsSpans();
    holder.appendChild(spansContainer);
    for (var index2 = 0; index2 < baseFonts.length; index2++) {
      defaultWidth[baseFonts[index2]] = baseFontsSpans[index2].offsetWidth;
      defaultHeight[baseFonts[index2]] = baseFontsSpans[index2].offsetHeight;
    }
    return fontList.filter(function(font) {
      return isFontAvailable(fontsSpans[font]);
    });
  });
}
function getPlugins() {
  var rawPlugins = navigator.plugins;
  if (!rawPlugins) {
    return void 0;
  }
  var plugins = [];
  for (var i = 0; i < rawPlugins.length; ++i) {
    var plugin = rawPlugins[i];
    if (!plugin) {
      continue;
    }
    var mimeTypes = [];
    for (var j = 0; j < plugin.length; ++j) {
      var mimeType = plugin[j];
      mimeTypes.push({
        type: mimeType.type,
        suffixes: mimeType.suffixes
      });
    }
    plugins.push({
      name: plugin.name,
      description: plugin.description,
      mimeTypes
    });
  }
  return plugins;
}
function getCanvasFingerprint() {
  var _a2 = makeCanvasContext(), canvas = _a2[0], context = _a2[1];
  if (!isSupported(canvas, context)) {
    return { winding: false, geometry: "", text: "" };
  }
  return {
    winding: doesSupportWinding(context),
    geometry: makeGeometryImage(canvas, context),
    text: makeTextImage(canvas, context)
  };
}
function makeCanvasContext() {
  var canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  return [canvas, canvas.getContext("2d")];
}
function isSupported(canvas, context) {
  return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
  context.rect(0, 0, 10, 10);
  context.rect(2, 2, 6, 6);
  return !context.isPointInPath(5, 5, "evenodd");
}
function makeTextImage(canvas, context) {
  canvas.width = 240;
  canvas.height = 60;
  context.textBaseline = "alphabetic";
  context.fillStyle = "#f60";
  context.fillRect(100, 1, 62, 20);
  context.fillStyle = "#069";
  context.font = '11pt "Times New Roman"';
  var printedText = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835);
  context.fillText(printedText, 2, 15);
  context.fillStyle = "rgba(102, 204, 0, 0.2)";
  context.font = "18pt Arial";
  context.fillText(printedText, 4, 45);
  return save(canvas);
}
function makeGeometryImage(canvas, context) {
  canvas.width = 122;
  canvas.height = 110;
  context.globalCompositeOperation = "multiply";
  for (var _i = 0, _a2 = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; _i < _a2.length; _i++) {
    var _b = _a2[_i], color = _b[0], x = _b[1], y = _b[2];
    context.fillStyle = color;
    context.beginPath();
    context.arc(x, y, 40, 0, Math.PI * 2, true);
    context.closePath();
    context.fill();
  }
  context.fillStyle = "#f9c";
  context.arc(60, 60, 60, 0, Math.PI * 2, true);
  context.arc(60, 60, 20, 0, Math.PI * 2, true);
  context.fill("evenodd");
  return save(canvas);
}
function save(canvas) {
  return canvas.toDataURL();
}
function getTouchSupport() {
  var n = navigator;
  var maxTouchPoints = 0;
  var touchEvent;
  if (n.maxTouchPoints !== void 0) {
    maxTouchPoints = toInt(n.maxTouchPoints);
  } else if (n.msMaxTouchPoints !== void 0) {
    maxTouchPoints = n.msMaxTouchPoints;
  }
  try {
    document.createEvent("TouchEvent");
    touchEvent = true;
  } catch (_a2) {
    touchEvent = false;
  }
  var touchStart = "ontouchstart" in window;
  return {
    maxTouchPoints,
    touchEvent,
    touchStart
  };
}
function getOsCpu() {
  return navigator.oscpu;
}
function getLanguages() {
  var n = navigator;
  var result = [];
  var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
  if (language !== void 0) {
    result.push([language]);
  }
  if (Array.isArray(n.languages)) {
    if (!(isChromium() && isChromium86OrNewer())) {
      result.push(n.languages);
    }
  } else if (typeof n.languages === "string") {
    var languages = n.languages;
    if (languages) {
      result.push(languages.split(","));
    }
  }
  return result;
}
function getColorDepth() {
  return window.screen.colorDepth;
}
function getDeviceMemory() {
  return replaceNaN(toFloat(navigator.deviceMemory), void 0);
}
function getScreenResolution() {
  var s = screen;
  var parseDimension = function(value) {
    return replaceNaN(toInt(value), null);
  };
  var dimensions = [parseDimension(s.width), parseDimension(s.height)];
  dimensions.sort().reverse();
  return dimensions;
}
var screenFrameCheckInterval = 2500;
var roundingPrecision = 10;
var screenFrameBackup;
var screenFrameSizeTimeoutId;
function watchScreenFrame() {
  if (screenFrameSizeTimeoutId !== void 0) {
    return;
  }
  var checkScreenFrame = function() {
    var frameSize = getCurrentScreenFrame();
    if (isFrameSizeNull(frameSize)) {
      screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
    } else {
      screenFrameBackup = frameSize;
      screenFrameSizeTimeoutId = void 0;
    }
  };
  checkScreenFrame();
}
function getScreenFrame() {
  var _this = this;
  watchScreenFrame();
  return function() {
    return __awaiter(_this, void 0, void 0, function() {
      var frameSize;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            frameSize = getCurrentScreenFrame();
            if (!isFrameSizeNull(frameSize))
              return [3, 2];
            if (screenFrameBackup) {
              return [2, __spreadArrays(screenFrameBackup)];
            }
            if (!getFullscreenElement())
              return [3, 2];
            return [4, exitFullscreen()];
          case 1:
            _a2.sent();
            frameSize = getCurrentScreenFrame();
            _a2.label = 2;
          case 2:
            if (!isFrameSizeNull(frameSize)) {
              screenFrameBackup = frameSize;
            }
            return [2, frameSize];
        }
      });
    });
  };
}
function getRoundedScreenFrame() {
  var _this = this;
  var screenFrameGetter = getScreenFrame();
  return function() {
    return __awaiter(_this, void 0, void 0, function() {
      var frameSize, processSize;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, screenFrameGetter()];
          case 1:
            frameSize = _a2.sent();
            processSize = function(sideSize) {
              return sideSize === null ? null : round(sideSize, roundingPrecision);
            };
            return [2, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
        }
      });
    });
  };
}
function getCurrentScreenFrame() {
  var s = screen;
  return [
    replaceNaN(toFloat(s.availTop), null),
    replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
    replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
    replaceNaN(toFloat(s.availLeft), null)
  ];
}
function isFrameSizeNull(frameSize) {
  for (var i = 0; i < 4; ++i) {
    if (frameSize[i]) {
      return false;
    }
  }
  return true;
}
function getHardwareConcurrency() {
  return replaceNaN(toInt(navigator.hardwareConcurrency), void 0);
}
function getTimezone() {
  var _a2;
  var DateTimeFormat = (_a2 = window.Intl) === null || _a2 === void 0 ? void 0 : _a2.DateTimeFormat;
  if (DateTimeFormat) {
    var timezone = new DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) {
      return timezone;
    }
  }
  var offset = -getTimezoneOffset();
  return "UTC" + (offset >= 0 ? "+" : "") + Math.abs(offset);
}
function getTimezoneOffset() {
  var currentYear = new Date().getFullYear();
  return Math.max(toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}
function getSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (error) {
    return true;
  }
}
function getLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e) {
    return true;
  }
}
function getIndexedDB() {
  if (isTrident() || isEdgeHTML()) {
    return void 0;
  }
  try {
    return !!window.indexedDB;
  } catch (e) {
    return true;
  }
}
function getOpenDatabase() {
  return !!window.openDatabase;
}
function getCpuClass() {
  return navigator.cpuClass;
}
function getPlatform() {
  var platform2 = navigator.platform;
  if (platform2 === "MacIntel") {
    if (isWebKit() && !isDesktopSafari()) {
      return isIPad() ? "iPad" : "iPhone";
    }
  }
  return platform2;
}
function getVendor() {
  return navigator.vendor || "";
}
function getVendorFlavors() {
  var flavors = [];
  for (var _i = 0, _a2 = [
    "chrome",
    "safari",
    "__crWeb",
    "__gCrWeb",
    "yandex",
    "__yb",
    "__ybro",
    "__firefox__",
    "__edgeTrackingPreventionStatistics",
    "webkit",
    "oprt",
    "samsungAr",
    "ucweb",
    "UCShellJava",
    "puffinDevice"
  ]; _i < _a2.length; _i++) {
    var key = _a2[_i];
    var value = window[key];
    if (value && typeof value === "object") {
      flavors.push(key);
    }
  }
  return flavors.sort();
}
function areCookiesEnabled() {
  var d = document;
  try {
    d.cookie = "cookietest=1; SameSite=Strict;";
    var result = d.cookie.indexOf("cookietest=") !== -1;
    d.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT";
    return result;
  } catch (e) {
    return false;
  }
}
var filters = {
  abpIndo: [
    "#Iklan-Melayang",
    "#Kolom-Iklan-728",
    "#SidebarIklan-wrapper",
    'a[title="7naga poker" i]',
    '[title="ALIENBOLA" i]'
  ],
  abpvn: [
    "#quangcaomb",
    ".iosAdsiosAds-layout",
    ".quangcao",
    '[href^="https://r88.vn/"]',
    '[href^="https://zbet.vn/"]'
  ],
  adBlockFinland: [
    ".mainostila",
    ".sponsorit",
    ".ylamainos",
    'a[href*="/clickthrgh.asp?"]',
    'a[href^="https://app.readpeak.com/ads"]'
  ],
  adBlockPersian: [
    "#navbar_notice_50",
    'a[href^="http://g1.v.fwmrm.net/ad/"]',
    ".kadr",
    'TABLE[width="140px"]',
    "#divAgahi"
  ],
  adBlockWarningRemoval: ["#adblock-honeypot", ".adblocker-root", ".wp_adblock_detect"],
  adGuardAnnoyances: ['amp-embed[type="zen"]', ".hs-sosyal", "#cookieconsentdiv", 'div[class^="app_gdpr"]', ".as-oil"],
  adGuardBase: ["#ad-after", "#ad-p3", ".BetterJsPopOverlay", "#ad_300X250", "#bannerfloat22"],
  adGuardChinese: [
    '#piao_div_0[style*="width:140px;"]',
    'a[href*=".ttz5.cn"]',
    'a[href*=".yabovip2027.com/"]',
    ".tm3all2h4b",
    ".cc5278_banner_ad"
  ],
  adGuardFrench: [
    ".zonepub",
    '[class*="_adLeaderboard"]',
    '[id^="block-xiti_oas-"]',
    'a[href^="http://ptapjmp.com/"]',
    'a[href^="https://go.alvexo.com/"]'
  ],
  adGuardGerman: [
    ".banneritemwerbung_head_1",
    ".boxstartwerbung",
    ".werbung3",
    'a[href^="http://www.eis.de/index.phtml?refid="]',
    'a[href^="https://www.tipico.com/?affiliateId="]'
  ],
  adGuardJapanese: [
    "#kauli_yad_1",
    "#ad-giftext",
    "#adsSPRBlock",
    'a[href^="http://ad2.trafficgate.net/"]',
    'a[href^="http://www.rssad.jp/"]'
  ],
  adGuardMobile: ["amp-auto-ads", "#mgid_iframe", ".amp_ad", 'amp-embed[type="24smi"]', "#mgid_iframe1"],
  adGuardRussian: [
    'a[href^="https://ya-distrib.ru/r/"]',
    'a[href^="https://ad.letmeads.com/"]',
    ".reclama",
    'div[id^="smi2adblock"]',
    'div[id^="AdFox_banner_"]'
  ],
  adGuardSocial: [
    'a[href^="//www.stumbleupon.com/submit?url="]',
    'a[href^="//telegram.me/share/url?"]',
    ".etsy-tweet",
    "#inlineShare",
    ".popup-social"
  ],
  adGuardSpanishPortuguese: [
    "#barraPublicidade",
    "#Publicidade",
    "#publiEspecial",
    "#queTooltip",
    '[href^="http://ads.glispa.com/"]'
  ],
  adGuardTrackingProtection: [
    'amp-embed[type="taboola"]',
    "#qoo-counter",
    'a[href^="http://click.hotlog.ru/"]',
    'a[href^="http://hitcounter.ru/top/stat.php"]',
    'a[href^="http://top.mail.ru/jump"]'
  ],
  adGuardTurkish: [
    "#backkapat",
    "#reklami",
    'a[href^="http://adserv.ontek.com.tr/"]',
    'a[href^="http://izlenzi.com/campaign/"]',
    'a[href^="http://www.installads.net/"]'
  ],
  bulgarian: ["td#freenet_table_ads", "#adbody", "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
  easyList: ["#AD_banner_bottom", "#Ads_google_02", "#N-ad-article-rightRail-1", "#ad-fullbanner2", "#ad-zone-2"],
  easyListChina: [
    'a[href*=".wensixuetang.com/"]',
    'A[href*="/hth107.com/"]',
    '.appguide-wrap[onclick*="bcebos.com"]',
    ".frontpageAdvM",
    "#taotaole"
  ],
  easyListCookie: ["#adtoniq-msg-bar", "#CoockiesPage", "#CookieModal_cookiemodal", "#DO_CC_PANEL", "#ShowCookie"],
  easyListCzechSlovak: ["#onlajny-stickers", "#reklamni-box", ".reklama-megaboard", ".sklik", '[id^="sklikReklama"]'],
  easyListDutch: [
    "#advertentie",
    "#vipAdmarktBannerBlock",
    ".adstekst",
    'a[href^="https://xltube.nl/click/"]',
    "#semilo-lrectangle"
  ],
  easyListGermany: [
    'a[href^="http://www.hw-area.com/?dp="]',
    'a[href^="https://ads.sunmaker.com/tracking.php?"]',
    ".werbung-skyscraper2",
    ".bannergroup_werbung",
    ".ads_rechts"
  ],
  easyListItaly: [
    ".box_adv_annunci",
    ".sb-box-pubbliredazionale",
    'a[href^="http://affiliazioniads.snai.it/"]',
    'a[href^="https://adserver.html.it/"]',
    'a[href^="https://affiliazioniads.snai.it/"]'
  ],
  easyListLithuania: [
    ".reklamos_tarpas",
    ".reklamos_nuorodos",
    'img[alt="Reklaminis skydelis"]',
    'img[alt="Dedikuoti.lt serveriai"]',
    'img[alt="Hostingas Serveriai.lt"]'
  ],
  estonian: ['A[href*="http://pay4results24.eu"]'],
  fanboyAnnoyances: [
    "#feedback-tab",
    "#taboola-below-article",
    ".feedburnerFeedBlock",
    ".widget-feedburner-counter",
    '[title="Subscribe to our blog"]'
  ],
  fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
  fanboyEnhancedTrackers: [
    ".open.pushModal",
    "#issuem-leaky-paywall-articles-zero-remaining-nag",
    "#sovrn_container",
    'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
    ".BlockNag__Card"
  ],
  fanboySocial: [
    ".td-tags-and-social-wrapper-box",
    ".twitterContainer",
    ".youtube-social",
    'a[title^="Like us on Facebook"]',
    'img[alt^="Share on Digg"]'
  ],
  frellwitSwedish: [
    'a[href*="casinopro.se"][target="_blank"]',
    'a[href*="doktor-se.onelink.me"]',
    "article.category-samarbete",
    "div.holidAds",
    "ul.adsmodern"
  ],
  greekAdBlock: [
    'A[href*="adman.otenet.gr/click?"]',
    'A[href*="http://axiabanners.exodus.gr/"]',
    'A[href*="http://interactive.forthnet.gr/click?"]',
    "DIV.agores300",
    "TABLE.advright"
  ],
  hungarian: [
    'A[href*="ad.eval.hu"]',
    'A[href*="ad.netmedia.hu"]',
    'A[href*="daserver.ultraweb.hu"]',
    "#cemp_doboz",
    ".optimonk-iframe-container"
  ],
  iDontCareAboutCookies: [
    '.alert-info[data-block-track*="CookieNotice"]',
    ".ModuleTemplateCookieIndicator",
    ".o--cookies--container",
    ".cookie-msg-info-container",
    "#cookies-policy-sticky"
  ],
  icelandicAbp: ['A[href^="/framework/resources/forms/ads.aspx"]'],
  latvian: [
    'a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
    'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]'
  ],
  listKr: [
    'a[href*="//kingtoon.slnk.kr"]',
    'a[href*="//playdsb.com/kr"]',
    "div.logly-lift-adz",
    'div[data-widget_id="ml6EJ074"]',
    "ins.daum_ddn_area"
  ],
  listeAr: [
    ".geminiLB1Ad",
    ".right-and-left-sponsers",
    'a[href*=".aflam.info"]',
    'a[href*="booraq.org"]',
    'a[href*="dubizzle.com/ar/?utm_source="]'
  ],
  listeFr: [
    'a[href^="http://promo.vador.com/"]',
    "#adcontainer_recherche",
    'a[href*="weborama.fr/fcgi-bin/"]',
    ".site-pub-interstitiel",
    'div[id^="crt-"][data-criteo-id]'
  ],
  officialPolish: [
    "#ceneo-placeholder-ceneo-12",
    '[href^="https://aff.sendhub.pl/"]',
    'a[href^="http://advmanager.techfun.pl/redirect/"]',
    'a[href^="http://www.trizer.pl/?utm_source"]',
    "div#skapiec_ad"
  ],
  ro: [
    'a[href^="//afftrk.altex.ro/Counter/Click"]',
    'a[href^="/magazin/"]',
    'a[href^="https://blackfridaysales.ro/trk/shop/"]',
    'a[href^="https://event.2performant.com/events/click"]',
    'a[href^="https://l.profitshare.ro/"]'
  ],
  ruAd: [
    'a[href*="//febrare.ru/"]',
    'a[href*="//utimg.ru/"]',
    'a[href*="://chikidiki.ru"]',
    "#pgeldiz",
    ".yandex-rtb-block"
  ],
  thaiAds: ["a[href*=macau-uta-popup]", "#ads-google-middle_rectangle-group", ".ads300s", ".bumq", ".img-kosana"],
  webAnnoyancesUltralist: [
    "#mod-social-share-2",
    "#social-tools",
    ".ctpl-fullbanner",
    ".zergnet-recommend",
    ".yt.btn-link.btn-md.btn"
  ]
};
function getDomBlockers(_a2) {
  var debug2 = (_a2 === void 0 ? {} : _a2).debug;
  return __awaiter(this, void 0, void 0, function() {
    var filterNames, allSelectors, blockedSelectors, activeBlockers;
    var _b;
    return __generator(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (!isApplicable()) {
            return [2, void 0];
          }
          filterNames = Object.keys(filters);
          allSelectors = (_b = []).concat.apply(_b, filterNames.map(function(filterName) {
            return filters[filterName];
          }));
          return [4, getBlockedSelectors(allSelectors)];
        case 1:
          blockedSelectors = _c.sent();
          if (debug2) {
            printDebug(blockedSelectors);
          }
          activeBlockers = filterNames.filter(function(filterName) {
            var selectors = filters[filterName];
            var blockedCount = countTruthy(selectors.map(function(selector) {
              return blockedSelectors[selector];
            }));
            return blockedCount > selectors.length * 0.6;
          });
          activeBlockers.sort();
          return [2, activeBlockers];
      }
    });
  });
}
function isApplicable() {
  return isWebKit() || isAndroid();
}
function getBlockedSelectors(selectors) {
  var _a2;
  return __awaiter(this, void 0, void 0, function() {
    var d, root, elements, blockedSelectors, i, element, holder, i;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          d = document;
          root = d.createElement("div");
          elements = new Array(selectors.length);
          blockedSelectors = {};
          forceShow(root);
          for (i = 0; i < selectors.length; ++i) {
            element = selectorToElement(selectors[i]);
            holder = d.createElement("div");
            forceShow(holder);
            holder.appendChild(element);
            root.appendChild(holder);
            elements[i] = element;
          }
          _b.label = 1;
        case 1:
          if (!!d.body)
            return [3, 3];
          return [4, wait(50)];
        case 2:
          _b.sent();
          return [3, 1];
        case 3:
          d.body.appendChild(root);
          try {
            for (i = 0; i < selectors.length; ++i) {
              if (!elements[i].offsetParent) {
                blockedSelectors[selectors[i]] = true;
              }
            }
          } finally {
            (_a2 = root.parentNode) === null || _a2 === void 0 ? void 0 : _a2.removeChild(root);
          }
          return [2, blockedSelectors];
      }
    });
  });
}
function forceShow(element) {
  element.style.setProperty("display", "block", "important");
}
function printDebug(blockedSelectors) {
  var message = "DOM blockers debug:\n```";
  for (var _i = 0, _a2 = Object.keys(filters); _i < _a2.length; _i++) {
    var filterName = _a2[_i];
    message += "\n" + filterName + ":";
    for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
      var selector = _c[_b];
      message += "\n  " + selector + " " + (blockedSelectors[selector] ? "\u{1F6AB}" : "\u27A1\uFE0F");
    }
  }
  console.log(message + "\n```");
}
function getColorGamut() {
  for (var _i = 0, _a2 = ["rec2020", "p3", "srgb"]; _i < _a2.length; _i++) {
    var gamut = _a2[_i];
    if (matchMedia("(color-gamut: " + gamut + ")").matches) {
      return gamut;
    }
  }
  return void 0;
}
function areColorsInverted() {
  if (doesMatch("inverted")) {
    return true;
  }
  if (doesMatch("none")) {
    return false;
  }
  return void 0;
}
function doesMatch(value) {
  return matchMedia("(inverted-colors: " + value + ")").matches;
}
function areColorsForced() {
  if (doesMatch$1("active")) {
    return true;
  }
  if (doesMatch$1("none")) {
    return false;
  }
  return void 0;
}
function doesMatch$1(value) {
  return matchMedia("(forced-colors: " + value + ")").matches;
}
var maxValueToCheck = 100;
function getMonochromeDepth() {
  if (!matchMedia("(min-monochrome: 0)").matches) {
    return void 0;
  }
  for (var i = 0; i <= maxValueToCheck; ++i) {
    if (matchMedia("(max-monochrome: " + i + ")").matches) {
      return i;
    }
  }
  throw new Error("Too high value");
}
function getContrastPreference() {
  if (doesMatch$2("no-preference")) {
    return 0;
  }
  if (doesMatch$2("high") || doesMatch$2("more")) {
    return 1;
  }
  if (doesMatch$2("low") || doesMatch$2("less")) {
    return -1;
  }
  if (doesMatch$2("forced")) {
    return 10;
  }
  return void 0;
}
function doesMatch$2(value) {
  return matchMedia("(prefers-contrast: " + value + ")").matches;
}
function isMotionReduced() {
  if (doesMatch$3("reduce")) {
    return true;
  }
  if (doesMatch$3("no-preference")) {
    return false;
  }
  return void 0;
}
function doesMatch$3(value) {
  return matchMedia("(prefers-reduced-motion: " + value + ")").matches;
}
function isHDR() {
  if (doesMatch$4("high")) {
    return true;
  }
  if (doesMatch$4("standard")) {
    return false;
  }
  return void 0;
}
function doesMatch$4(value) {
  return matchMedia("(dynamic-range: " + value + ")").matches;
}
var M = Math;
var fallbackFn = function() {
  return 0;
};
function getMathFingerprint() {
  var acos = M.acos || fallbackFn;
  var acosh = M.acosh || fallbackFn;
  var asin = M.asin || fallbackFn;
  var asinh = M.asinh || fallbackFn;
  var atanh = M.atanh || fallbackFn;
  var atan = M.atan || fallbackFn;
  var sin = M.sin || fallbackFn;
  var sinh = M.sinh || fallbackFn;
  var cos = M.cos || fallbackFn;
  var cosh = M.cosh || fallbackFn;
  var tan = M.tan || fallbackFn;
  var tanh = M.tanh || fallbackFn;
  var exp = M.exp || fallbackFn;
  var expm1 = M.expm1 || fallbackFn;
  var log1p = M.log1p || fallbackFn;
  var powPI = function(value) {
    return M.pow(M.PI, value);
  };
  var acoshPf = function(value) {
    return M.log(value + M.sqrt(value * value - 1));
  };
  var asinhPf = function(value) {
    return M.log(value + M.sqrt(value * value + 1));
  };
  var atanhPf = function(value) {
    return M.log((1 + value) / (1 - value)) / 2;
  };
  var sinhPf = function(value) {
    return M.exp(value) - 1 / M.exp(value) / 2;
  };
  var coshPf = function(value) {
    return (M.exp(value) + 1 / M.exp(value)) / 2;
  };
  var expm1Pf = function(value) {
    return M.exp(value) - 1;
  };
  var tanhPf = function(value) {
    return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1);
  };
  var log1pPf = function(value) {
    return M.log(1 + value);
  };
  return {
    acos: acos(0.12312423423423424),
    acosh: acosh(1e308),
    acoshPf: acoshPf(1e154),
    asin: asin(0.12312423423423424),
    asinh: asinh(1),
    asinhPf: asinhPf(1),
    atanh: atanh(0.5),
    atanhPf: atanhPf(0.5),
    atan: atan(0.5),
    sin: sin(-1e300),
    sinh: sinh(1),
    sinhPf: sinhPf(1),
    cos: cos(10.000000000123),
    cosh: cosh(1),
    coshPf: coshPf(1),
    tan: tan(-1e300),
    tanh: tanh(1),
    tanhPf: tanhPf(1),
    exp: exp(1),
    expm1: expm1(1),
    expm1Pf: expm1Pf(1),
    log1p: log1p(10),
    log1pPf: log1pPf(10),
    powPI: powPI(-100)
  };
}
var defaultText = "mmMwWLliI0fiflO&1";
var presets = {
  default: [],
  apple: [{ font: "-apple-system-body" }],
  serif: [{ fontFamily: "serif" }],
  sans: [{ fontFamily: "sans-serif" }],
  mono: [{ fontFamily: "monospace" }],
  min: [{ fontSize: "1px" }],
  system: [{ fontFamily: "system-ui" }]
};
function getFontPreferences() {
  return withNaturalFonts(function(document2, container) {
    var elements = {};
    var sizes = {};
    for (var _i = 0, _a2 = Object.keys(presets); _i < _a2.length; _i++) {
      var key = _a2[_i];
      var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
      var element = document2.createElement("span");
      element.textContent = text;
      element.style.whiteSpace = "nowrap";
      for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
        var name_1 = _f[_e];
        var value = style[name_1];
        if (value !== void 0) {
          element.style[name_1] = value;
        }
      }
      elements[key] = element;
      container.appendChild(document2.createElement("br"));
      container.appendChild(element);
    }
    for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
      var key = _h[_g];
      sizes[key] = elements[key].getBoundingClientRect().width;
    }
    return sizes;
  });
}
function withNaturalFonts(action, containerWidthPx) {
  if (containerWidthPx === void 0) {
    containerWidthPx = 4e3;
  }
  return withIframe(function(_, iframeWindow) {
    var iframeDocument = iframeWindow.document;
    var iframeBody = iframeDocument.body;
    var bodyStyle = iframeBody.style;
    bodyStyle.width = containerWidthPx + "px";
    bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = "none";
    if (isChromium()) {
      iframeBody.style.zoom = "" + 1 / iframeWindow.devicePixelRatio;
    } else if (isWebKit()) {
      iframeBody.style.zoom = "reset";
    }
    var linesOfText = iframeDocument.createElement("div");
    linesOfText.textContent = __spreadArrays(Array(containerWidthPx / 20 << 0)).map(function() {
      return "word";
    }).join(" ");
    iframeBody.appendChild(linesOfText);
    return action(iframeDocument, iframeBody);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
var sources = {
  fonts: getFonts,
  domBlockers: getDomBlockers,
  fontPreferences: getFontPreferences,
  audio: getAudioFingerprint,
  screenFrame: getRoundedScreenFrame,
  osCpu: getOsCpu,
  languages: getLanguages,
  colorDepth: getColorDepth,
  deviceMemory: getDeviceMemory,
  screenResolution: getScreenResolution,
  hardwareConcurrency: getHardwareConcurrency,
  timezone: getTimezone,
  sessionStorage: getSessionStorage,
  localStorage: getLocalStorage,
  indexedDB: getIndexedDB,
  openDatabase: getOpenDatabase,
  cpuClass: getCpuClass,
  platform: getPlatform,
  plugins: getPlugins,
  canvas: getCanvasFingerprint,
  touchSupport: getTouchSupport,
  vendor: getVendor,
  vendorFlavors: getVendorFlavors,
  cookiesEnabled: areCookiesEnabled,
  colorGamut: getColorGamut,
  invertedColors: areColorsInverted,
  forcedColors: areColorsForced,
  monochrome: getMonochromeDepth,
  contrast: getContrastPreference,
  reducedMotion: isMotionReduced,
  hdr: isHDR,
  math: getMathFingerprint
};
function loadBuiltinSources(options) {
  return loadSources(sources, options, []);
}
var commentTemplate = "$ if upgrade to Pro: https://fpjs.dev/pro";
function getConfidence(components) {
  var openConfidenceScore = getOpenConfidenceScore(components);
  var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
  return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "" + proConfidenceScore) };
}
function getOpenConfidenceScore(components) {
  if (isAndroid()) {
    return 0.4;
  }
  if (isWebKit()) {
    return isDesktopSafari() ? 0.5 : 0.3;
  }
  var platform2 = components.platform.value || "";
  if (/^Win/.test(platform2)) {
    return 0.6;
  }
  if (/^Mac/.test(platform2)) {
    return 0.5;
  }
  return 0.7;
}
function deriveProConfidenceScore(openConfidenceScore) {
  return round(0.99 + 0.01 * openConfidenceScore, 1e-4);
}
function componentsToCanonicalString(components) {
  var result = "";
  for (var _i = 0, _a2 = Object.keys(components).sort(); _i < _a2.length; _i++) {
    var componentKey = _a2[_i];
    var component = components[componentKey];
    var value = component.error ? "error" : JSON.stringify(component.value);
    result += (result ? "|" : "") + componentKey.replace(/([:|\\])/g, "\\$1") + ":" + value;
  }
  return result;
}
function componentsToDebugString(components) {
  return JSON.stringify(components, function(_key, value) {
    if (value instanceof Error) {
      return errorToObject(value);
    }
    return value;
  }, 2);
}
function hashComponents(components) {
  return x64hash128(componentsToCanonicalString(components));
}
function makeLazyGetResult(components) {
  var visitorIdCache;
  var confidence = getConfidence(components);
  return {
    get visitorId() {
      if (visitorIdCache === void 0) {
        visitorIdCache = hashComponents(this.components);
      }
      return visitorIdCache;
    },
    set visitorId(visitorId) {
      visitorIdCache = visitorId;
    },
    confidence,
    components,
    version
  };
}
function prepareForSources(delayFallback) {
  if (delayFallback === void 0) {
    delayFallback = 50;
  }
  return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
function makeAgent(getComponents, debug2) {
  var creationTime = Date.now();
  return {
    get: function(options) {
      return __awaiter(this, void 0, void 0, function() {
        var startTime, components, result;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              startTime = Date.now();
              return [4, getComponents()];
            case 1:
              components = _a2.sent();
              result = makeLazyGetResult(components);
              if (debug2 || (options === null || options === void 0 ? void 0 : options.debug)) {
                console.log("Copy the text below to get the debug data:\n\n```\nversion: " + result.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (startTime - creationTime) + "\nvisitorId: " + result.visitorId + "\ncomponents: " + componentsToDebugString(components) + "\n```");
              }
              return [2, result];
          }
        });
      });
    }
  };
}
function monitor() {
  if (window.__fpjs_d_m || Math.random() >= 0.01) {
    return;
  }
  try {
    var request3 = new XMLHttpRequest();
    request3.open("get", "https://openfpcdn.io/fingerprintjs/v" + version + "/npm-monitoring", true);
    request3.send();
  } catch (error) {
    console.error(error);
  }
}
function load(_a2) {
  var _b = _a2 === void 0 ? {} : _a2, delayFallback = _b.delayFallback, debug2 = _b.debug, _c = _b.monitoring, monitoring = _c === void 0 ? true : _c;
  return __awaiter(this, void 0, void 0, function() {
    var getComponents;
    return __generator(this, function(_d) {
      switch (_d.label) {
        case 0:
          if (monitoring) {
            monitor();
          }
          return [4, prepareForSources(delayFallback)];
        case 1:
          _d.sent();
          getComponents = loadBuiltinSources({ debug: debug2 });
          return [2, makeAgent(getComponents, debug2)];
      }
    });
  });
}
const fpPromise = load();
let cacheHash = "";
function getDeviceUUID() {
  if (cacheHash)
    return Promise.resolve(cacheHash);
  return new Promise((resolve) => {
    const task2 = () => {
      fpPromise.then((fp) => fp.get()).then((result) => {
        cacheHash = result.visitorId;
        resolve(cacheHash);
      });
    };
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(task2);
    } else {
      setTimeout(task2, 600);
    }
  });
}
function debounce(handle, time) {
  let starTime = new Date().getTime();
  let timeOut;
  return function dd2(...arg) {
    let nowTime = new Date().getTime();
    if (nowTime - starTime < time) {
      clearTimeout(timeOut);
    }
    starTime = nowTime;
    return new Promise((resolve) => {
      timeOut = setTimeout(() => {
        resolve(handle.call(this, ...arg));
      }, time);
    });
  };
}
function throttle(handle, time) {
  let starTime = performance.now();
  let first = true;
  let dd2 = debounce(handle, time);
  return function tt(...arg) {
    let nowTime = performance.now();
    if (nowTime - starTime >= time || first) {
      handle.call(this, ...arg);
      starTime = nowTime;
      first = false;
    } else {
      dd2.call(this, ...arg);
    }
  };
}
function on(eventName, cb, target, options) {
  if (!target.addEventListener) {
    console.warn("addEventListener is not exist");
    return () => null;
  }
  target.addEventListener(eventName, cb, options);
  return () => {
    target.removeEventListener(eventName, cb);
  };
}
function wrapEvent(e, doc) {
  doc = doc || document;
  const value = Object.assign(Object.assign({}, e), { timestamp: performance.now(), clienttime: Date.now(), isVisible: doc.visibilityState !== "hidden" });
  return value;
}
function getDayTimestamp(timestamp) {
  return new Date(new Date(timestamp).setHours(0, 0, 0, 0)).getTime();
}
var ObserverName;
(function(ObserverName2) {
  ObserverName2["mouseObserver"] = "mouseObserver";
  ObserverName2["scrollObserver"] = "scrollObserver";
  ObserverName2["keyboardObserver"] = "keyboardObserver";
  ObserverName2["pageChangeObserver"] = "pageChangeObserver";
})(ObserverName || (ObserverName = {}));
var EventType;
(function(EventType2) {
  EventType2[EventType2["interaction"] = 1] = "interaction";
  EventType2[EventType2["pageChange"] = 2] = "pageChange";
  EventType2[EventType2["statistic"] = 3] = "statistic";
})(EventType || (EventType = {}));
var InteractionType;
(function(InteractionType2) {
  InteractionType2[InteractionType2["mousemove"] = 0] = "mousemove";
  InteractionType2[InteractionType2["mouseup"] = 1] = "mouseup";
  InteractionType2[InteractionType2["mousedown"] = 2] = "mousedown";
  InteractionType2[InteractionType2["click"] = 3] = "click";
  InteractionType2[InteractionType2["contextmenu"] = 4] = "contextmenu";
  InteractionType2[InteractionType2["touchmove"] = 5] = "touchmove";
  InteractionType2[InteractionType2["touchstart"] = 6] = "touchstart";
  InteractionType2[InteractionType2["touchend"] = 7] = "touchend";
  InteractionType2[InteractionType2["drag"] = 8] = "drag";
  InteractionType2[InteractionType2["scroll"] = 9] = "scroll";
  InteractionType2[InteractionType2["keydown"] = 10] = "keydown";
  InteractionType2[InteractionType2["keyup"] = 11] = "keyup";
  InteractionType2[InteractionType2["custom"] = 12] = "custom";
})(InteractionType || (InteractionType = {}));
var StatisticEventType;
(function(StatisticEventType2) {
  StatisticEventType2[StatisticEventType2["activeDurationStart"] = 0] = "activeDurationStart";
  StatisticEventType2[StatisticEventType2["activeDuration"] = 1] = "activeDuration";
})(StatisticEventType || (StatisticEventType = {}));
var MouseInteractions;
(function(MouseInteractions2) {
  MouseInteractions2["mouseup"] = "mouseup";
  MouseInteractions2["mousedown"] = "mousedown";
  MouseInteractions2["click"] = "click";
  MouseInteractions2["contextmenu"] = "contextmenu";
  MouseInteractions2["touchstart"] = "touchstart";
  MouseInteractions2["touchend"] = "touchend";
})(MouseInteractions || (MouseInteractions = {}));
class MouseObserver {
  constructor(cb, { localWindow, doc }, options) {
    this.mouseInteractionObserver(cb, { localWindow, doc }, options === null || options === void 0 ? void 0 : options.disabledMap);
    this.mousemoveObserver(cb, { localWindow, doc }, options === null || options === void 0 ? void 0 : options.callbackThreshold);
  }
  static getEvent(mouseEventInfo) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({}, mouseEventInfo)
    });
  }
  clear() {
    if (this.removeMoveObserver) {
      this.removeMoveObserver();
      this.removeMoveObserver = null;
    }
    if (this.removeInteractionObserver) {
      this.removeInteractionObserver();
      this.removeInteractionObserver = null;
    }
  }
  mouseInteractionObserver(cb, { doc }, disableMap) {
    const handlers = [];
    const getHandler = (eventKey) => {
      return (event) => {
        const eventData = event instanceof TouchEvent ? event.changedTouches[0] : event;
        if (!eventData) {
          return;
        }
        const { clientX, clientY } = eventData;
        const interactionEventData = MouseObserver.getEvent({
          tag: InteractionType[eventKey],
          x: clientX,
          y: clientY
        });
        cb(interactionEventData);
      };
    };
    Object.values(MouseInteractions).filter((key) => !disableMap || !disableMap[key]).forEach((eventName) => {
      const handler = getHandler(eventName);
      handlers.push(on(eventName, handler, doc));
    });
    this.removeInteractionObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  mousemoveObserver(cb, { doc }, callbackThreshold) {
    callbackThreshold = callbackThreshold || 300;
    const updatePosition = throttle((event) => {
      const isTouch = isTouchEvent(event);
      const { clientX, clientY } = isTouch ? event.changedTouches[0] : event;
      const actionType = event instanceof MouseEvent ? InteractionType.mousemove : isTouch ? InteractionType.touchmove : InteractionType.drag;
      const eventData = MouseObserver.getEvent({
        tag: actionType,
        x: clientX,
        y: clientY
      });
      cb(eventData);
    }, callbackThreshold);
    const handlers = [
      on("mousemove", updatePosition, doc),
      on("touchmove", updatePosition, doc),
      on("drag", updatePosition, doc)
    ];
    this.removeMoveObserver = () => {
      handlers.forEach((h) => h());
    };
  }
}
MouseObserver.recordName = ObserverName.mouseObserver;
function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
class ScrollObserver {
  constructor(cb, { localWindow, doc }) {
    const updatePosition = throttle((evt) => {
      if (!evt.target)
        return;
      const scrollEl = evt.target === doc ? doc.scrollingElement || doc.documentElement : evt.target;
      const eventData = ScrollObserver.getEvent({
        x: scrollEl.scrollLeft,
        y: scrollEl.scrollTop
      });
      cb(eventData);
    }, 100);
    this.removeObserver = on("scroll", updatePosition, localWindow, true);
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(scrollInfo) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({ tag: InteractionType.scroll }, scrollInfo)
    });
  }
}
ScrollObserver.recordName = ObserverName.scrollObserver;
var KeyboardEventType;
(function(KeyboardEventType2) {
  KeyboardEventType2["keyup"] = "keyup";
  KeyboardEventType2["keydown"] = "keydown";
})(KeyboardEventType || (KeyboardEventType = {}));
class KeyboardObserver {
  constructor(cb, { localWindow }) {
    const getKeyboardInfoCb = (eventName) => {
      return (event) => {
        const eventData = KeyboardObserver.getEvent({
          tag: InteractionType[eventName],
          key: event.key
        });
        cb(eventData);
      };
    };
    const handlers = [
      on("keyup", getKeyboardInfoCb(KeyboardEventType.keyup), localWindow, true),
      on("keydown", getKeyboardInfoCb(KeyboardEventType.keydown), localWindow, true)
    ];
    this.removeObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(info2) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({}, info2)
    });
  }
}
KeyboardObserver.recordName = ObserverName.keyboardObserver;
let groupId = 1;
class ObserverGroup {
  constructor({ doc = document, localWindow = window }, observeOptions) {
    this.emitEventNums = 0;
    this.id = 0;
    this.observerList = [];
    this.id = groupId;
    const observerCreaters = [MouseObserver, ScrollObserver, KeyboardObserver];
    observerCreaters.forEach((creater) => {
      const createrName = creater.recordName;
      observeOptions ? observeOptions[createrName] : null;
      this.addObserver(creater, { doc, localWindow });
    });
  }
  get observerId() {
    return this.id;
  }
  addObserver(observer, envInfo, options) {
    const cb = (event) => {
      this.emit(event);
    };
    this.observerList.push(new observer(cb, envInfo, options));
  }
  clear() {
    this.observerList.forEach((observer) => {
      observer.clear();
    });
    this.observerList = [];
  }
  on(callback) {
    if (typeof callback === "function") {
      this.listenerCallback = callback;
    } else {
      console.error(new Error("callback need a function"));
    }
  }
  emit(event) {
    this.emitEventNums++;
    if (this.listenerCallback)
      this.listenerCallback(event);
  }
  removeCb() {
    this.listenerCallback = null;
  }
}
class ObserverGroupMap {
  constructor() {
    this.emitEventNums = 0;
    this.groupMap = /* @__PURE__ */ new Map();
    this.listenerCallback = null;
  }
  decorateObserverEmit(observers) {
    const that = this;
    observers.emit = function(...arg) {
      this.emitEventNums++;
      if (typeof that.listenerCallback === "function") {
        that.listenerCallback(...arg);
      }
      ObserverGroup.prototype.emit.apply(this, arg);
    };
  }
  on(cb) {
    this.listenerCallback = cb;
  }
  create({ doc, localWindow }, observeOptions) {
    const newGroups = new ObserverGroup({ doc, localWindow }, observeOptions);
    const id = newGroups.observerId;
    this.groupMap.set(id, newGroups);
    this.decorateObserverEmit(newGroups);
    return newGroups;
  }
  set(id, observers) {
    this.groupMap.set(id, observers);
    if (observers.emit === ObserverGroup.prototype.emit)
      return;
    this.decorateObserverEmit(observers);
  }
  delete(id) {
    const observers = this.groupMap.get(id);
    if (observers === null || observers === void 0 ? void 0 : observers.clear) {
      observers === null || observers === void 0 ? void 0 : observers.clear();
    }
    this.groupMap.delete(id);
  }
  clear() {
    this.groupMap.forEach((observers) => {
      observers === null || observers === void 0 ? void 0 : observers.clear();
    });
    this.emitEventNums = 0;
    this.groupMap = /* @__PURE__ */ new Map();
  }
}
const globalObserversMap = new ObserverGroupMap();
var PageChangeType;
(function(PageChangeType2) {
  PageChangeType2["hashchange"] = "hashchange";
  PageChangeType2["pushState"] = "pushState";
  PageChangeType2["replaceState"] = "replaceState";
  PageChangeType2["popstate"] = "popstate";
})(PageChangeType || (PageChangeType = {}));
var UrlChangeType;
(function(UrlChangeType2) {
  UrlChangeType2[UrlChangeType2["no"] = 0] = "no";
  UrlChangeType2[UrlChangeType2["path"] = 1] = "path";
  UrlChangeType2[UrlChangeType2["hash"] = 2] = "hash";
  UrlChangeType2[UrlChangeType2["hashPath"] = 3] = "hashPath";
  UrlChangeType2[UrlChangeType2["hashQuery"] = 4] = "hashQuery";
  UrlChangeType2[UrlChangeType2["query"] = 5] = "query";
  UrlChangeType2[UrlChangeType2["error"] = 6] = "error";
})(UrlChangeType || (UrlChangeType = {}));
function getUrlChangeType(routeChangeEvent) {
  const { url: currentUrl, preUrl } = routeChangeEvent.data;
  const defaultUrl = window.location.origin;
  try {
    const currentUrlData = new URL(currentUrl || defaultUrl);
    const preUrlData = new URL(preUrl || defaultUrl);
    if (currentUrlData.pathname !== preUrlData.pathname)
      return UrlChangeType.path;
    if (currentUrlData.hash !== preUrlData.hash) {
      const isHashMode = /^#\//.test(currentUrlData.hash);
      if (!isHashMode)
        return UrlChangeType.hash;
      return compareHashMode(currentUrlData.hash, preUrlData.hash);
    }
    if (currentUrlData.search !== preUrlData.search)
      return UrlChangeType.query;
  } catch (e) {
    return UrlChangeType.error;
  }
  return UrlChangeType.no;
}
class RouteObserver {
  constructor(cb, { localWindow }) {
    this.pageIndex = 1;
    this.preUrl = "";
    this.preUrl = localWindow.location.href;
    wrapHistoryMethod(PageChangeType.pushState, localWindow);
    wrapHistoryMethod(PageChangeType.replaceState, localWindow);
    const getPageInfoCb = (eventName) => {
      return () => {
        const eventData = RouteObserver.getEvent({
          type: PageChangeType[eventName],
          url: localWindow.location.href,
          preUrl: this.preUrl,
          index: this.pageIndex
        });
        this.preUrl = localWindow.location.href;
        this.pageIndex++;
        cb(eventData);
      };
    };
    const handlers = [
      on("hashchange", getPageInfoCb(PageChangeType.hashchange), localWindow),
      on("pushState", getPageInfoCb(PageChangeType.pushState), localWindow),
      on("replaceState", getPageInfoCb(PageChangeType.replaceState), localWindow),
      on("popstate", getPageInfoCb(PageChangeType.popstate), localWindow)
    ];
    this.removeObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(info2) {
    return wrapEvent({
      type: EventType.pageChange,
      data: Object.assign({}, info2)
    });
  }
}
RouteObserver.recordName = ObserverName.pageChangeObserver;
function wrapHistoryMethod(methodName, localWindow) {
  if (!localWindow.__mastergo_origin_change) {
    localWindow.__mastergo_origin_change = {};
  }
  if (localWindow.__mastergo_origin_change[methodName])
    return;
  const oringinMethod = localWindow === null || localWindow === void 0 ? void 0 : localWindow.history[methodName];
  localWindow.history[methodName] = function mastergoPushState(...arg) {
    const res = oringinMethod.apply(this, arg);
    const e = new Event(methodName);
    localWindow.dispatchEvent(e);
    return res;
  };
  localWindow.__mastergo_origin_change[methodName] = true;
}
function compareHashMode(currentHash, preHash) {
  const defaultPreStr = window.location.origin;
  try {
    currentHash = currentHash.replace(/^#/, "");
    preHash = preHash.replace(/^#/, "");
    const currentHashData = new URL(defaultPreStr + currentHash);
    const preHashData = new URL(defaultPreStr + preHash);
    if (currentHashData.pathname !== preHashData.pathname)
      return UrlChangeType.hashPath;
    if (currentHashData.search !== preHashData.search)
      return UrlChangeType.hashQuery;
  } catch (e) {
    return UrlChangeType.error;
  }
  return UrlChangeType.error;
}
const DEFAULT_ACTIVE_TIME_THRESHOLD = 3 * 60 * 1e3;
var ActiveStartType;
(function(ActiveStartType2) {
  ActiveStartType2[ActiveStartType2["default"] = 0] = "default";
  ActiveStartType2[ActiveStartType2["overDay"] = 1] = "overDay";
})(ActiveStartType || (ActiveStartType = {}));
var ActiveEndType;
(function(ActiveEndType2) {
  ActiveEndType2[ActiveEndType2["overTime"] = 0] = "overTime";
  ActiveEndType2[ActiveEndType2["overDay"] = 1] = "overDay";
  ActiveEndType2[ActiveEndType2["pageChange"] = 2] = "pageChange";
  ActiveEndType2[ActiveEndType2["pageClose"] = 3] = "pageClose";
})(ActiveEndType || (ActiveEndType = {}));
class ActiveStatistic {
  constructor(options) {
    this.recordIndex = 0;
    this.currentActiveTimes = null;
    this.activeTimeThreshold = DEFAULT_ACTIVE_TIME_THRESHOLD;
    const { threshold, callback } = options || {};
    this.activeTimeThreshold = threshold || DEFAULT_ACTIVE_TIME_THRESHOLD;
    if (callback) {
      this.on(callback);
    }
    window.addEventListener("beforeunload", () => {
      this.creatActiveDurationEvent(ActiveEndType.pageClose);
    });
  }
  on(cb) {
    if (typeof cb === "function") {
      this.callback = cb;
    }
  }
  tracking(event) {
    const isActive = this.isActiveEvent(event);
    const isPageEvent = this.isPageChange(event);
    if (!isActive && !isPageEvent)
      return;
    const eventBirthTime = event.timestamp;
    if (!this.currentActiveTimes && isActive) {
      this.creatActiveStartEvent(eventBirthTime, eventBirthTime, ActiveStartType.default);
      return;
    }
    if (!this.currentActiveTimes)
      return;
    const isOverKeepTimeThreshold = this.isOverTimeThreshold(eventBirthTime);
    if (isOverKeepTimeThreshold) {
      this.finishWithOverTime(eventBirthTime);
      return;
    }
    if (isPageEvent) {
      this.finishWithPageChange(eventBirthTime);
      return;
    }
    this.setEndTime(eventBirthTime);
  }
  clearRecord() {
    const hasRecord = this.currentActiveTimes;
    this.currentActiveTimes = null;
    return hasRecord;
  }
  createActiveItem(startTime, endTime, startIndex) {
    this.recordIndex++;
    return {
      index: this.recordIndex,
      startIndex: startIndex || this.recordIndex,
      startTime,
      endTime,
      pageUrl: window.location.href
    };
  }
  creatActiveStartEvent(startTime, endTime, startType) {
    this.currentActiveTimes = this.createActiveItem(startTime, endTime);
    const startEvent = {
      type: EventType.statistic,
      data: {
        tag: StatisticEventType.activeDurationStart,
        info: Object.assign({}, this.currentActiveTimes),
        startType
      },
      timestamp: this.currentActiveTimes.startTime
    };
    this.pipe(startEvent);
  }
  creatActiveDurationEvent(endType) {
    if (!this.currentActiveTimes)
      return;
    const { startTime, endTime, startIndex } = this.currentActiveTimes;
    let durationPords = [Object.assign({}, this.currentActiveTimes)];
    if (this.isOverDay()) {
      const dayTimestamp = getDayTimestamp(endTime);
      const secendActiveTimes = this.createActiveItem(dayTimestamp, endTime, startIndex);
      this.currentActiveTimes.endTime = dayTimestamp;
      durationPords = [Object.assign({}, this.currentActiveTimes), secendActiveTimes];
    }
    durationPords.forEach((info2) => {
      const endEvent = {
        type: EventType.statistic,
        data: {
          tag: StatisticEventType.activeDuration,
          info: info2,
          endType
        },
        timestamp: info2.endTime
      };
      this.pipe(endEvent);
    });
    this.currentActiveTimes = null;
  }
  pipe(data2) {
    if (this.callback) {
      this.callback(data2);
    }
    return data2;
  }
  isPageChange(event) {
    if (event.type !== EventType.pageChange)
      return false;
    const routeChangeType = getUrlChangeType(event);
    return routeChangeType === UrlChangeType.path || routeChangeType === UrlChangeType.hashPath;
  }
  isActiveEvent(event) {
    return event.type === EventType.interaction && event.isVisible;
  }
  isOverDay() {
    const { startTime, endTime } = this.currentActiveTimes;
    return new Date(startTime).getDate() !== new Date(endTime).getDate();
  }
  isOverTimeThreshold(keepTime) {
    const lastTime = this.currentActiveTimes.endTime;
    return keepTime - lastTime > this.activeTimeThreshold;
  }
  setEndTime(timestamp) {
    if (!this.currentActiveTimes)
      return;
    const { startTime, endTime } = this.currentActiveTimes;
    if (timestamp < startTime || timestamp < endTime)
      return;
    this.currentActiveTimes.endTime = timestamp;
  }
  finishWithOverTime(endTime) {
    this.creatActiveDurationEvent(ActiveEndType.overTime);
    this.creatActiveStartEvent(endTime, endTime, ActiveStartType.default);
  }
  finishWithPageChange(endTime) {
    if (!this.currentActiveTimes)
      return;
    this.currentActiveTimes.endTime = endTime;
    this.creatActiveDurationEvent(ActiveEndType.pageChange);
  }
}
const fetchOrigin = window.fetch.fetchOrigin || window.fetch;
var FetchMethod;
(function(FetchMethod2) {
  FetchMethod2["post"] = "POST";
  FetchMethod2["get"] = "GET";
  FetchMethod2["put"] = "PUT";
  FetchMethod2["del"] = "DELETE";
})(FetchMethod || (FetchMethod = {}));
const DEFAULT_TIMEOUT = 60 * 1e3;
const DEFAULT_FETCH_MODE = "cors";
const DEFAULT_FETCH_METHOD = FetchMethod.get;
const DEFAULT_HEADERS = {
  "Content-Type": "application/json"
};
function fetchRequest(url, options) {
  if (!url) {
    return Promise.resolve(null);
  }
  const reqUrl = new URL(url, location.origin);
  options = options || {};
  const timeout = options.timeout || DEFAULT_TIMEOUT;
  const setQuerys = options.query || {};
  Object.keys(setQuerys).forEach((key) => {
    reqUrl.searchParams.set(key, setQuerys[key]);
  });
  let bodyString = "";
  try {
    bodyString = JSON.stringify(options.body || null);
  } catch (err) {
    return Promise.resolve(null);
  }
  const method = options.method || DEFAULT_FETCH_METHOD;
  bodyString = method === "GET" ? void 0 : bodyString;
  return new Promise((rs) => {
    const reqTimeOut = setTimeout(() => {
      console.error("fetch is timeout:", reqUrl.href);
      rs(null);
    }, timeout);
    fetchOrigin(reqUrl.href, {
      mode: (options === null || options === void 0 ? void 0 : options.mode) || DEFAULT_FETCH_MODE,
      headers: Object.assign(Object.assign({}, DEFAULT_HEADERS), options === null || options === void 0 ? void 0 : options.headers),
      body: bodyString,
      method
    }).then((response) => {
      clearTimeout(reqTimeOut);
      if (response.status !== 200)
        return Promise.reject("Fetch Error:" + response.status);
      rs(response.json());
    }).catch((err) => {
      console.error(err);
      clearTimeout(reqTimeOut);
      rs(null);
    });
  });
}
function fetchGet(url, params, options) {
  options = options || {};
  options.method = FetchMethod.get;
  options.query = params;
  return fetchRequest(url, options);
}
const GET_SERVER_TIME = "/et/t";
const TRY_INTEVALS = [0, 2 * 1e3, 10 * 1e3, 30 * 1e3, 60 * 1e3, 10 * 60 * 1e3, 30 * 60 * 1e3];
const OPERATOR = 0.5;
const MAX_DEVIATION = 10 * 1e3;
function fetchCurrentServerTime() {
  const t1 = performance.now();
  return fetchGet(GET_SERVER_TIME, {}, { timeout: MAX_DEVIATION * 2 }).then((res) => {
    if (!res || res.code !== "ok")
      return null;
    const t2 = res.data.time;
    const t3 = performance.now();
    const reqTime = t3 - t1;
    const span = Math.round(reqTime * OPERATOR);
    if (span > MAX_DEVIATION)
      return null;
    return { currentServerTime: t2 + span, pageNowTime: t3 };
  });
}
function timerFetch(time) {
  if (!time)
    return fetchCurrentServerTime();
  return new Promise((resolve) => {
    setTimeout(() => {
      fetchCurrentServerTime().then((res) => {
        resolve(res);
      });
    }, time);
  });
}
function getServerTime$1() {
  return __awaiter(this, void 0, void 0, function* () {
    let l = TRY_INTEVALS.length;
    for (let i = 0; i < l; i++) {
      const res = yield timerFetch(TRY_INTEVALS[i]);
      if (res)
        return res;
    }
    return { currentServerTime: new Date().getTime(), pageNowTime: performance.now() };
  });
}
const ALLOWED_DEVIATION_THRESHOLD = 10 * 1e3;
class TimeSynchronizationManager {
  constructor() {
    this._startServerTime = 0;
    this._startBrowerTime = 0;
    this._sleepTime = 0;
    this._BrowerChangeTime = 0;
    this._loading = this.init().then(() => {
      this._loading = false;
      return true;
    });
  }
  get ready() {
    return this._loading;
  }
  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const { currentServerTime, pageNowTime } = yield getServerTime$1();
      this._startServerTime = currentServerTime - pageNowTime;
      this._startBrowerTime = new Date().getTime() - performance.now();
    });
  }
  getSleepTime(currentServerTime, pageNowTime) {
    return currentServerTime - pageNowTime - this._startServerTime;
  }
  getBrowerTimeDeviation() {
    const nowPerformanceTime = performance.now();
    const nowTime = new Date().getTime();
    return nowTime - nowPerformanceTime - this._startBrowerTime - this._BrowerChangeTime - this._sleepTime;
  }
  checkTimeValid() {
    const timeTeviation = this.getBrowerTimeDeviation();
    return timeTeviation < ALLOWED_DEVIATION_THRESHOLD;
  }
  timeSynchronization() {
    return __awaiter(this, void 0, void 0, function* () {
      const { currentServerTime, pageNowTime } = yield getServerTime$1();
      const newSleepTime = this.getSleepTime(currentServerTime, pageNowTime);
      const sleepTimeDeviation = newSleepTime - this._sleepTime;
      const hasSleep = sleepTimeDeviation > ALLOWED_DEVIATION_THRESHOLD;
      if (hasSleep) {
        this._sleepTime = newSleepTime;
      }
      const changeTimeTeviation = this.getBrowerTimeDeviation();
      if (changeTimeTeviation > ALLOWED_DEVIATION_THRESHOLD) {
        this._BrowerChangeTime += changeTimeTeviation;
      }
      this._loading = false;
      return hasSleep;
    });
  }
  loadingServeTime() {
    const notNeedFix = this.checkTimeValid();
    if (notNeedFix)
      return false;
    if (this._loading)
      return this._loading;
    this._loading = this.timeSynchronization();
    return this._loading;
  }
  getServerTime(performanceTime) {
    performanceTime = performanceTime === void 0 ? performance.now() : performanceTime;
    const serverTimestamp = performanceTime + this._sleepTime + this._startServerTime;
    return Math.ceil(serverTimestamp);
  }
  get startServerTime() {
    return this._startServerTime;
  }
  get sleepTimePerformaceNow() {
    return performance.now() + this._sleepTime;
  }
  get sleepTime() {
    return this._sleepTime;
  }
}
const timeSynchronizationGlobal = new TimeSynchronizationManager();
const getServerTime = timeSynchronizationGlobal.getServerTime.bind(timeSynchronizationGlobal);
const DEFAULT_LIMIT = 1e5;
class AddTimeManager {
  constructor(queueLimit, cb) {
    this.castId = -1;
    this.id = 0;
    this.timeWaitQueue = /* @__PURE__ */ new Map();
    this.isClearing = false;
    this.max = DEFAULT_LIMIT;
    this.max = queueLimit || DEFAULT_LIMIT;
    if (cb) {
      this.callback = cb;
    }
  }
  get queueLength() {
    return this.id - this.castId - 1;
  }
  on(cb) {
    this.callback = cb;
  }
  add(dataHandle) {
    if (typeof dataHandle !== "function") {
      console.error("time add need function");
      return;
    }
    if (this.max < this.queueLength) {
      this.overLimit();
      return;
    }
    this.timeWaitQueue.set(this.id, dataHandle);
    this.id++;
    this.clearQueue();
  }
  clearQueue() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isClearing)
        return;
      this.isClearing = true;
      const dateIsLoading = timeSynchronizationGlobal.loadingServeTime();
      if (dateIsLoading) {
        yield dateIsLoading;
      }
      while (this.queueLength) {
        this.castWait();
      }
      this.isClearing = false;
    });
  }
  castWait() {
    this.castId++;
    const dataHandle = this.timeWaitQueue.get(this.castId);
    if (typeof dataHandle === "function") {
      const data2 = dataHandle(getServerTime);
      this.pipe(data2);
    }
    this.timeWaitQueue.delete(this.castId);
  }
  pipe(data2) {
    if (typeof this.callback === "function") {
      this.callback(data2);
    }
    return data2;
  }
  overLimit() {
    return;
  }
}
class InteractionRecord {
  constructor() {
    this.addTime = new AddTimeManager();
    this.activeTimeCreater = new ActiveStatistic();
    this.isObserving = false;
  }
  actionEventHandle(event) {
    this.addTime.add((getServerTime2) => {
      event.timestamp = getServerTime2(event.timestamp);
      return event;
    });
  }
  start() {
    if (this.isObserving) {
      console.warn("record has start observer, retry after stoped");
      return;
    }
    this.addTime.on((event) => {
      this.activeTimeCreater.tracking(event);
      if (this.actionEventCallback) {
        this.actionEventCallback(event);
      }
    });
    this.activeTimeCreater.on((activeTimeRecord) => {
      if (this.statisticEventCallback) {
        this.statisticEventCallback(activeTimeRecord);
      }
    });
    const mainEnv = { doc: document, localWindow: window };
    globalObserversMap.on(this.actionEventHandle.bind(this));
    const mainObserverGroup = globalObserversMap.create(mainEnv);
    mainObserverGroup.addObserver(RouteObserver, mainEnv);
    this.isObserving = true;
  }
  stop() {
    globalObserversMap.clear();
    this.isObserving = false;
  }
  onAction(cb) {
    if (typeof cb === "function") {
      this.actionEventCallback = cb;
    }
  }
  onStatistic(cb) {
    if (typeof cb === "function") {
      this.statisticEventCallback = cb;
    }
  }
}
const globalInteractionRecord = new InteractionRecord();
class SensorsSdk {
  constructor(options) {
    this.url = "";
    this.trackSinglePage = true;
    this.showLog = false;
    this.clickMap = "not_collect";
    this.scrollNOticeMap = "not_collect";
    this.sessionTime = 0;
    this.deviceHash = "";
    this.hasStartRecord = false;
    if (!options) {
      return;
    }
    this.url = options.url || "";
    this.trackSinglePage = options.trackSinglePage;
    this.showLog = options.showLog;
    this.clickMap = options.clickMap;
    this.scrollNOticeMap = options.scrollNOticeMap;
    this.init();
  }
  init() {
    sensors$1.init({
      server_url: this.url,
      is_track_single_page: this.trackSinglePage,
      use_client_time: true,
      send_type: "beacon",
      show_log: this.showLog
    });
    this.setDeviceId();
    this.initPublic();
  }
  startActiveObsever(options) {
    const { statistic, action } = options || {};
    if (this.hasStartRecord)
      return globalInteractionRecord;
    globalInteractionRecord.start();
    this.hasStartRecord = true;
    if (action) {
      globalInteractionRecord.onAction(action);
    }
    if (statistic) {
      globalInteractionRecord.onStatistic(statistic);
    }
    return globalInteractionRecord;
  }
  initPublic() {
    const info2 = hostInfo();
    this.setPublic({
      session_id: Tools.getUuid(),
      data_source: "frontend",
      operation_sysatem: info2.os.name,
      os_version: info2.os.version,
      browser: info2.browser.name
    });
  }
  setDeviceId() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deviceHash) {
        return this.deviceHash;
      }
      const deviceId = yield getDeviceUUID();
      this.deviceHash = deviceId;
      api$1.set("_mg_cd_uid", deviceId);
      this.setPublic({
        device_hash: deviceId
      });
      return this.deviceHash;
    });
  }
  getDeviceId() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deviceHash) {
        return this.deviceHash;
      }
      return yield this.setDeviceId();
    });
  }
  setPublic(obj) {
    if (!Tools.isOnlyObject(obj)) {
      console.error("setPublic arguments must be objects");
      return;
    }
    sensors$1.registerPage(obj);
  }
  setProfile(obj) {
    if (!Tools.isOnlyObject(obj)) {
      console.error("setProfile arguments must be objects");
      return;
    }
    sensors$1.setProfile(obj);
  }
  quick() {
    sensors$1.quick("isReady", () => {
      sensors$1.getPresetProperties();
    });
  }
  track(eventName, obj) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!eventName) {
        console.error("eventName cannot be empty");
        return;
      }
      yield this.setDeviceId();
      const time = Date.now();
      if (time - this.sessionTime > 1e3 * 60 * 30) {
        this.setPublic({
          session_id: Tools.getUuid()
        });
        this.sessionTime = time;
      }
      sensors$1.track(eventName, obj);
    });
  }
}
const sensorConfig = {
  url: `${window.location.origin}/et/event/sa`,
  showLog: false
};
if (window.location.search.includes("showlog=true")) {
  sensorConfig.showLog = true;
}
if (window.location.hash.includes("showlog=true")) {
  sensorConfig.showLog = true;
}
if (window.location.search.includes("showlog=false")) {
  sensorConfig.showLog = false;
}
const sensorsInner = new SensorsSdk(sensorConfig);
const sensors = sensorsInner;
const sendLog = (actionType = "", actionDetail = "") => {
  if (!actionType)
    return;
  sensors.track("ocpc", {
    action_type: actionType,
    action_detail: actionDetail
  });
};
const store = new Dexie$1("login_plugin_store");
store.version(1).stores({
  drainageData: "id,data"
});
store.open();
async function setStore(name2, data2) {
  const table = store[name2];
  if (!table)
    return;
  await table.put(data2);
}
async function getStore(name2, key) {
  const table = store[name2];
  if (!table)
    return;
  return await table.get(key);
}
async function deleteStore(name2, id) {
  const table = store[name2];
  if (!table)
    return;
  await table.delete(id);
}
async function setDrainageData(value) {
  sendLog("save_start", value);
  await setStore("drainageData", { id: 1, data: value });
  sendLog("save_success", value);
}
async function getDrainageData() {
  const res = await getStore("drainageData", 1);
  const value = res ? res.data : "";
  sendLog("get", value);
  return value;
}
async function removeDrainageData() {
  await deleteStore("drainageData", 1);
  sendLog("remove");
}
function filterUTM() {
  const utm = getUrlData([...UTM_TERM]);
  if (Object.keys(utm).length) {
    setSessionStorageItem(SESSION_KEYS.UTM_ITEM, JSON.stringify(utm));
  }
}
function filterPromote() {
  const key = Object.keys(PROMOTE).find((item) => getUrlValue(item));
  if (!key)
    return;
  const promote = {
    detail: {
      logidUrl: document.location.href
    },
    advType: PROMOTE[key]
  };
  setDrainageData(JSON.stringify(promote));
}
function filterGenSign() {
  const genSignKey = "gen_sign";
  const genSign = getUrlValue(genSignKey);
  if (genSign) {
    setSessionStorageItem(SESSION_KEYS.GEN_SIGN, genSign);
    deleteUrlQuery(genSignKey);
  }
}
function filterWechatCode() {
  const weChatCodeKey = "code";
  const weChatCode = !isWeiXinFastPage() && getUrlValue(weChatCodeKey);
  if (weChatCode) {
    setSessionStorageItem(SESSION_KEYS.WECHAT_CODE, weChatCode);
    deleteUrlQuery(weChatCodeKey);
  }
}
function filterDingDingCode() {
  const dingDingCodeKey = "authCode";
  const dingDingCode = getUrlValue(dingDingCodeKey);
  if (dingDingCode) {
    setSessionStorageItem(SESSION_KEYS.DING_DING_OAUTH_CODE, dingDingCode);
    deleteUrlQuery(dingDingCodeKey);
  }
}
function filterDingJumpCode() {
  const dingAuthCodeKey = "dingAuthCode";
  const dingAuthCode = getUrlValue(dingAuthCodeKey);
  if (dingAuthCode) {
    setSessionStorageItem(SESSION_KEYS.DING_JUMP_AUTH_CODE, dingAuthCode);
    deleteUrlQuery(dingAuthCodeKey);
  }
}
function setInviteToken() {
  const source2 = getUrlValue("source");
  const fileId = getPathId("file");
  const inviteMemberId = getPathId("invite-member");
  const documentInvite = getUrlValue("inviteDocumentId");
  const inviteBatchId = getUrlValue("inviteBatchId");
  const teamInvite = getUrlValue("inviteTeamId");
  const tokenList = [];
  if (teamInvite) {
    tokenList[0] = 1;
    tokenList[1] = teamInvite;
  } else if (documentInvite) {
    tokenList[0] = 1;
    tokenList[1] = documentInvite;
  } else if (inviteMemberId) {
    tokenList[0] = 2;
    tokenList[1] = inviteMemberId;
  } else if (source2 && fileId) {
    tokenList[0] = 3;
    tokenList[1] = fileId;
  }
  if (inviteBatchId) {
    tokenList[0] = 4;
    tokenList[2] = inviteBatchId;
  }
  if (tokenList.length) {
    setSessionStorageItem(SESSION_KEYS.INVITE_TOKEN, tokenList.join("_"));
  }
}
function filterSubToken() {
  const subToken = getUrlValue("subToken");
  if (subToken) {
    setSessionStorageItem(SESSION_KEYS.SUB_TOKEN, subToken);
  }
}
function filterSamlCode() {
  const key = "errcode";
  const code = getUrlValue(key);
  if (code) {
    setSessionStorageItem(SESSION_KEYS.SAML_CODE, code);
    deleteUrlQuery(key);
  }
}
function filterPrivateCode() {
  const key = "private_code";
  const code = getUrlValue(key);
  if (code) {
    setSessionStorageItem(SESSION_KEYS.PRIVATE_CODE, code);
    deleteUrlQuery(key);
  }
}
function setLoginData() {
  filterDingJumpCode();
  filterUTM();
  filterPromote();
  filterGenSign();
  filterWechatCode();
  filterDingDingCode();
  setInviteToken();
  filterSubToken();
  filterSamlCode();
  filterPrivateCode();
}
var axios$2 = { exports: {} };
var bind$4 = function bind(fn, thisArg) {
  return function wrap2() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$3 = bind$4;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$3(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$e = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$d = utils$e;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config, code, request3, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request3;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request3, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request3, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name2, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$a.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$a.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$a.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$9 = utils$e;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$9.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request3 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request3.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request3.timeout = config.timeout;
    function onloadend() {
      if (!request3) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders2(request3.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
      var response = {
        data: responseData,
        status: request3.status,
        statusText: request3.statusText,
        headers: responseHeaders,
        config,
        request: request3
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request3 = null;
    }
    if ("onloadend" in request3) {
      request3.onloadend = onloadend;
    } else {
      request3.onreadystatechange = function handleLoad() {
        if (!request3 || request3.readyState !== 4) {
          return;
        }
        if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request3.onabort = function handleAbort() {
      if (!request3) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request3));
      request3 = null;
    };
    request3.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request3));
      request3 = null;
    };
    request3.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional2 = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request3));
      request3 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request3) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request3.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config.withCredentials)) {
      request3.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request3.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request3.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request3.upload) {
      request3.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request3) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request3.abort();
        request3 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request3.send(requestData);
  });
};
var utils$6 = utils$e;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional2 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError2(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status2) {
    return status2 >= 200 && status2 < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$e;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$5.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$e;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$4.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$e;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.25.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type2, i) {
  validators$1[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i < 1 ? "n " : " ") + type2;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys2 = Object.keys(options);
  var i = keys2.length;
  while (i-- > 0) {
    var opt = keys2[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional2 = config.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l = token._listeners.length;
    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap2(arr) {
    return callback.apply(null, arr);
  };
};
var utils$1 = utils$e;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$e;
var bind$2 = bind$4;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create2(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const request2 = axios.create({
  baseURL: "/",
  timeout: 3e4,
  headers: {
    "Cache-Control": "no-store, no-cache"
  }
});
request2.interceptors.request.use((config) => {
  if (!config.headers)
    return;
  let experiment = "";
  try {
    experiment = JSON.stringify(parseExperiment(experimentClient));
  } catch (e) {
  }
  config.headers["x-mg-experiment"] = experiment;
  return config;
}, (error) => Promise.reject(error));
request2.interceptors.response.use((res) => {
  if (res.data.code === "OK") {
    return res.data;
  }
  return Promise.reject(res);
}, (err) => {
  if (err.response) {
    if (err.response.status === 403 && err.response.data.code === "OrganizationForbidden") {
      const url = "https://mastergo.com/404";
      window.location.href = url;
    }
  }
  return Promise.reject(err);
});
const createRequest = (data2) => {
  return new Promise((resolve, reject) => {
    request2(data2).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
};
function wechatLogin(data2) {
  return createRequest({
    url: "/api/v1/signin/wechat",
    method: "POST",
    data: data2
  });
}
function sendMessageCode(data2) {
  return createRequest({
    url: "/api/v1/message/code",
    method: "POST",
    data: data2
  });
}
function signinByPassword(data2) {
  return createRequest({
    url: "/api/v1/signup",
    method: "POST",
    data: data2
  });
}
function phoneAndEmailSignup(data2) {
  return createRequest({
    url: "/api/v1/signup/code",
    method: "POST",
    data: __spreadValues({}, data2)
  });
}
function signupByPassword(data2) {
  return createRequest({
    url: "/api/v1/signin",
    method: "POST",
    data: data2
  });
}
function getSigninCaptcha(params) {
  return createRequest({
    url: "/api/v1/signin/captcha",
    method: "GET",
    params
  });
}
function initpassword(data2) {
  return createRequest({
    url: "/api/v1/users/initpassword",
    method: "PUT",
    data: data2
  });
}
function getWeChatQrCode() {
  return createRequest({
    url: "/api/v1/signin/wechatqrcode",
    method: "GET"
  });
}
function getWeChatSubState(token) {
  return createRequest({
    url: "/api/v1/wechat/substate",
    method: "GET",
    params: {
      token
    }
  });
}
function lanHuLogin(data2) {
  return createRequest({
    url: "/api/v1/signin/lanhu",
    method: "POST",
    data: data2
  });
}
function getUserInfo() {
  return createRequest({
    url: "/api/v1/user",
    method: "get"
  });
}
function logOut(data2 = {}) {
  return createRequest({
    url: "/api/v1/signout",
    method: "POST",
    data: data2
  });
}
function getLocalPhoneToken() {
  return createRequest({
    url: "/api/v1/h5verify/token",
    method: "GET"
  });
}
function verifyLocalPhoneToken(data2 = {}) {
  return createRequest({
    url: "/api/v1/h5verify/signup",
    method: "POST",
    data: data2
  });
}
function verifyDingDingToken(data2 = {}) {
  return createRequest({
    url: "/api/v1/signin/dingtalk",
    method: "POST",
    data: data2
  });
}
function getDingAuthCode() {
  return createRequest({
    url: "/api/v1/jump-code",
    method: "get"
  });
}
function getLoginProtocol(params) {
  return createRequest({
    url: "/api/v1/sso",
    method: "get",
    params
  });
}
function verifySaml(params) {
  return createRequest({
    url: "/api/v1/saml/getloginreq",
    method: "get",
    withCredentials: true,
    params
  });
}
function verifyOauth(params) {
  return createRequest({
    url: "/api/v1/oauth/getloginreq",
    method: "get",
    withCredentials: true,
    params
  });
}
function getLoginType() {
  return createRequest({
    url: "/api/v1/login_method",
    method: "GET"
  });
}
function priLoginByCode(data2) {
  return createRequest({
    url: `/api/v1/code_login`,
    method: "POST",
    data: data2
  });
}
function canRegister() {
  return createRequest({
    url: "/org/api/pub/settings",
    method: "GET"
  });
}
const sendFormData = (params) => {
  let detail = null;
  if (params && params.advType === 3) {
    params.advType = 0;
    detail = params.detail;
  }
  return (user) => {
    if (!detail || !user || !user.data || !user.data.isReg)
      return;
    const { logidUrl } = detail;
    if (!logidUrl)
      return;
    const res = logidUrl.match(/cb=([^\&]+)/);
    if (!res && res[1])
      return;
    let url = window.decodeURIComponent(res[1]);
    const vs = {
      __EVENTTYPE__: "api_submit",
      __TIMESTAMP__: Math.floor(Date.now() / 1e3)
    };
    Object.keys(vs).forEach((key) => {
      if (url.indexOf(key) === -1) {
        url += `&${key}=${vs[key]}`;
      } else {
        url = url.replace(key, vs[key]);
      }
    });
    const image = new Image();
    image.src = url;
  };
};
const getFormData = async () => {
  let promote = {};
  let utm = {};
  let extendTrackInfo = {};
  let naturalGrowth = true;
  try {
    const utmItem = getSessionStorageItem(SESSION_KEYS.UTM_ITEM);
    if (utmItem) {
      utm = JSON.parse(utmItem);
      naturalGrowth = false;
    }
    const mgPromote = await getDrainageData();
    if (mgPromote) {
      promote = JSON.parse(mgPromote);
    }
    const extendTrackStr = getSessionStorageItem(SESSION_KEYS.EXTEND_TRACK);
    if (extendTrackStr) {
      extendTrackInfo = JSON.parse(extendTrackStr);
    }
  } catch (e) {
  }
  const yToken = getSessionStorageItem(SESSION_KEYS.Y_TOKEN);
  const invToken = getSessionStorageItem(SESSION_KEYS.INVITE_TOKEN);
  const subToken = getSessionStorageItem(SESSION_KEYS.SUB_TOKEN);
  const randomNum = getUrlValue(SESSION_KEYS.RANDOM_NUM, getSessionStorageItem("appAuth") || "");
  const app = isMirror() ? "mirror_app" : randomNum ? "masterdesktop" : "masterweb";
  return __spreadProps(__spreadValues(__spreadValues(__spreadValues({
    action_position: getActionPosition(window.location.href)
  }, promote), utm), extendTrackInfo), {
    yToken,
    naturalGrowth,
    invToken,
    subToken,
    randomNum,
    app
  });
};
const getPhoneNumberServer = function() {
  let phoneNumberServer = null;
  return () => {
    if (phoneNumberServer)
      return phoneNumberServer;
    if (isInIframe())
      throw Error("phoneNumberServer used in iframe");
    const { PhoneNumberServer } = require("aliyun_numberauthsdk_web");
    phoneNumberServer = new PhoneNumberServer();
    return phoneNumberServer;
  };
}();
function checkAuthAvailable(data2) {
  const phoneNumberServer = getPhoneNumberServer();
  return new Promise((success, error) => phoneNumberServer.checkAuthAvailable(__spreadProps(__spreadValues({}, data2), { success, error })));
}
function getVerifyToken() {
  const phoneNumberServer = getPhoneNumberServer();
  return new Promise((success, error) => phoneNumberServer.getVerifyToken({ success, error }));
}
var SensorsType = /* @__PURE__ */ ((SensorsType2) => {
  SensorsType2["CLICK_LOGIN_BTN"] = "click_login_btn";
  SensorsType2["LOGIN_POPOUT_LOAD"] = "login_popout_load";
  SensorsType2["EVENT_CLICK"] = "event_click";
  SensorsType2["USER_LOGIN"] = "user_login";
  SensorsType2["SHOW_LOGIN"] = "show_login";
  SensorsType2["WECHAT_QR_LOAD"] = "wechat_qr_load";
  SensorsType2["SEND_CODE"] = "send_code";
  return SensorsType2;
})(SensorsType || {});
var union = { exports: {} };
var ddSdk = {};
var env$1 = {};
var sdk = {};
var sdkLib = {};
(function(exports) {
  function isFunction2(o2) {
    return typeof o2 == "function";
  }
  function compareVersion(o2, e) {
    function r(o3) {
      return parseInt(o3, 10) || 0;
    }
    for (var n = o2.split(".").map(r), t = e.split(".").map(r), E = 0; E < n.length; E++) {
      if (t[E] === void 0)
        return false;
      if (n[E] < t[E])
        return false;
      if (n[E] > t[E])
        return true;
    }
    return true;
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.LogLevel = exports.APP_TYPE = exports.ENV_ENUM_SUB = exports.ENV_ENUM = exports.ERROR_CODE = exports.compareVersion = exports.isFunction = void 0, exports.isFunction = isFunction2, exports.compareVersion = compareVersion;
  !function(o2) {
    o2.cancel = "-1", o2.not_exist = "1", o2.no_permission = "7", o2.jsapi_internal_error = "22";
  }(exports.ERROR_CODE || (exports.ERROR_CODE = {}));
  !function(o2) {
    o2.pc = "pc", o2.android = "android", o2.ios = "ios", o2.notInDingTalk = "notInDingTalk";
  }(exports.ENV_ENUM || (exports.ENV_ENUM = {}));
  !function(o2) {
    o2.mac = "mac", o2.win = "win", o2.noSub = "noSub";
  }(exports.ENV_ENUM_SUB || (exports.ENV_ENUM_SUB = {}));
  !function(o2) {
    o2.WEB = "WEB", o2.MINI_APP = "MINI_APP", o2.WEEX = "WEEX", o2.WEBVIEW_IN_MINIAPP = "WEBVIEW_IN_MINIAPP", o2.WEEX_WIDGET = "WEEX_WIDGET";
  }(exports.APP_TYPE || (exports.APP_TYPE = {}));
  !function(o2) {
    o2[o2.INFO = 1] = "INFO", o2[o2.WARNING = 2] = "WARNING", o2[o2.ERROR = 3] = "ERROR";
  }(exports.LogLevel || (exports.LogLevel = {}));
})(sdkLib);
(function(exports) {
  function getTargetApiConfigVS(e, o2) {
    var i = e && e.vs;
    return typeof i == "object" && (i = i[o2.platformSub]), i;
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.Sdk = exports.LogLevel = exports.APP_TYPE = exports.isFunction = exports.compareVersion = exports.ENV_ENUM_SUB = exports.ENV_ENUM = void 0;
  var sdkLib_1 = sdkLib;
  Object.defineProperty(exports, "APP_TYPE", { enumerable: true, get: function() {
    return sdkLib_1.APP_TYPE;
  } }), Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function() {
    return sdkLib_1.LogLevel;
  } }), Object.defineProperty(exports, "isFunction", { enumerable: true, get: function() {
    return sdkLib_1.isFunction;
  } }), Object.defineProperty(exports, "compareVersion", { enumerable: true, get: function() {
    return sdkLib_1.compareVersion;
  } }), Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return sdkLib_1.ENV_ENUM;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return sdkLib_1.ENV_ENUM_SUB;
  } });
  var Sdk = function() {
    function e(e2, o2) {
      var i = this;
      this.configJsApiList = [], this.hadConfig = false, this.p = {}, this.config$ = new Promise(function(e3, o3) {
        i.p.reject = o3, i.p.resolve = e3;
      }), this.logQueue = [], this.devConfig = { debug: false }, this.platformConfigMap = {}, this.invokeAPIConfigMapByMethod = {}, this.isBridgeDrity = true, this.getExportSdk = function() {
        return i.exportSdk;
      }, this.setAPI = function(e3, o3) {
        i.invokeAPIConfigMapByMethod[e3] = o3;
      }, this.setPlatform = function(e3) {
        i.isBridgeDrity = true, i.platformConfigMap[e3.platform] = e3, e3.platform === i.env.platform && e3.bridgeInit().catch(function(e4) {
          i.customLog(sdkLib_1.LogLevel.WARNING, ["auto bridgeInit error", e4 || ""]);
        });
      }, this.getPlatformConfigMap = function() {
        return i.platformConfigMap;
      }, this.deleteApiConfig = function(e3, o3) {
        var t2 = i.invokeAPIConfigMapByMethod[e3];
        t2 && delete t2[o3];
      }, this.invokeAPI = function(e3, o3, t2) {
        o3 === void 0 && (o3 = {}), t2 === void 0 && (t2 = true), i.customLog(sdkLib_1.LogLevel.INFO, ['==> "' + e3 + '" params: ', o3]);
        var n = +new Date(), r = n + "_" + Math.floor(1e3 * Math.random());
        if (i.devConfig.onBeforeInvokeAPI)
          try {
            i.devConfig.onBeforeInvokeAPI({ invokeId: r, method: e3, params: o3, startTime: n });
          } catch (e4) {
            i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onBeforeInvokeAPI failed, reason:", e4]);
          }
        return i.devConfig.isAuthApi === false && (t2 = false), i.bridgeInitFn().then(function(s) {
          var a = i.invokeAPIConfigMapByMethod[e3], f = i.devConfig.forceEnableDealApiFnMap && i.devConfig.forceEnableDealApiFnMap[e3] && i.devConfig.forceEnableDealApiFnMap[e3](o3) === true, u = !f && (i.devConfig.isDisableDeal === true || i.devConfig.disbaleDealApiWhiteList && i.devConfig.disbaleDealApiWhiteList.indexOf(e3) !== -1);
          if (a || !t2) {
            var d;
            if (a && (d = a[i.env.platform]), d || !t2) {
              var c = {};
              c = !u && d && d.paramsDeal && sdkLib_1.isFunction(d.paramsDeal) ? d.paramsDeal(o3) : Object.assign({}, o3);
              var g = function(e4) {
                return !u && d && d.resultDeal && sdkLib_1.isFunction(d.resultDeal) ? d.resultDeal(e4) : e4;
              };
              if (sdkLib_1.isFunction(c.onSuccess)) {
                var l = c.onSuccess;
                c.onSuccess = function(e4) {
                  l(g(e4));
                };
              }
              return s(e3, c).then(g, function(o4) {
                var n2 = i.hadConfig && i.isReady === void 0 && i.configJsApiList.indexOf(e3) !== -1, r2 = typeof o4 == "object" && typeof o4.errorCode == "string" && o4.errorCode === sdkLib_1.ERROR_CODE.no_permission, a2 = typeof o4 == "object" && typeof o4.errorCode == "string" && o4.errorCode === sdkLib_1.ERROR_CODE.cancel, f2 = getTargetApiConfigVS(d, i.env), u2 = f2 && i.env.version && sdkLib_1.compareVersion(i.env.version, f2), l2 = (i.env.platform === sdkLib_1.ENV_ENUM.ios || i.env.platform === sdkLib_1.ENV_ENUM.android) && n2 && r2, p2 = i.env.platform === sdkLib_1.ENV_ENUM.pc && n2 && (u2 && !a2 && t2 || r2);
                return l2 || p2 ? i.config$.then(function() {
                  return s(e3, c).then(g);
                }) : Promise.reject(o4);
              }).then(function(t3) {
                if (i.devConfig.onAfterInvokeAPI)
                  try {
                    i.devConfig.onAfterInvokeAPI({ invokeId: r, method: e3, params: o3, payload: t3, isSuccess: true, startTime: n, duration: +new Date() - n });
                  } catch (e4) {
                    i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onAfterInvokeAPI failed, reason:", e4]);
                  }
                return i.customLog(sdkLib_1.LogLevel.INFO, ['<== "' + e3 + '" success result: ', t3]), t3;
              }, function(t3) {
                if (i.devConfig.onAfterInvokeAPI)
                  try {
                    i.devConfig.onAfterInvokeAPI({ invokeId: r, method: e3, params: o3, payload: t3, startTime: n, duration: +new Date() - n, isSuccess: false });
                  } catch (t4) {
                    i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onAfterInvokeAPI failed, reason:", t4]);
                  }
                return i.customLog(sdkLib_1.LogLevel.WARNING, ['<== "' + e3 + '" fail result: ', t3]), Promise.reject(t3);
              });
            }
            var p = '"' + e3 + '" do not support the current platform (' + i.env.platform + ")";
            return i.customLog(sdkLib_1.LogLevel.ERROR, [p]), Promise.reject({ errorCode: sdkLib_1.ERROR_CODE.jsapi_internal_error, errorMessage: p });
          }
          var p = "This API method is not configured for the platform (" + i.env.platform + ")";
          return i.customLog(sdkLib_1.LogLevel.ERROR, [p]), Promise.reject({ errorCode: sdkLib_1.ERROR_CODE.jsapi_internal_error, errorMessage: p });
        });
      }, this.isLogQueueTimeout = false, this.customLog = function(e3, o3) {
        var t2 = { level: e3, text: o3, time: new Date() };
        if (i.devConfig.debug === true)
          i.customLogInstance(t2);
        else if (!i.isLogQueueTimeout) {
          i.logQueueTimer || (i.logQueueTimer = setTimeout(function() {
            i.isLogQueueTimeout = true, i.logQueue = [];
          }, 1e4)), i.logQueue.push(t2);
          i.logQueue.length > 10 && (i.logQueue = i.logQueue.slice(i.logQueue.length - 10));
        }
      }, this.clearLogQueue = function() {
        i.logQueue.forEach(function(e3) {
          i.customLogInstance(e3);
        }), i.logQueue = [];
      }, this.customLogInstance = o2, this.env = e2, this.bridgeInitFn = function() {
        if (i.bridgeInitFnPromise && !i.isBridgeDrity)
          return i.bridgeInitFnPromise;
        i.isBridgeDrity = false;
        var o3 = i.platformConfigMap[e2.platform];
        if (o3)
          i.bridgeInitFnPromise = o3.bridgeInit().catch(function(e3) {
            return i.customLog(sdkLib_1.LogLevel.ERROR, ["\b\b\b\b\bJsBridge initialization fails, jsapi will not work"]), Promise.reject(e3);
          });
        else {
          var t2 = "Do not support the current environment\uFF1A" + e2.platform;
          i.customLog(sdkLib_1.LogLevel.WARNING, [t2]), i.bridgeInitFnPromise = Promise.reject(new Error(t2));
        }
        return i.bridgeInitFnPromise;
      };
      var t = function(e3) {
        e3 === void 0 && (e3 = {}), i.devConfig = Object.assign(i.devConfig, e3), e3.debug === true && i.clearLogQueue(), e3.extraPlatform && i.setPlatform(e3.extraPlatform);
      };
      this.exportSdk = { config: function(o3) {
        o3 === void 0 && (o3 = {});
        var n = true;
        Object.keys(o3).forEach(function(e3) {
          ["debug", "usePromise"].indexOf(e3) === -1 && (n = false);
        }), n ? (i.customLog(sdkLib_1.LogLevel.WARNING, ["This is a deprecated feature, recommend use dd.devConfig"]), t(o3)) : i.hadConfig ? i.customLog(sdkLib_1.LogLevel.WARNING, ["Config has been executed"]) : (o3.jsApiList && (i.configJsApiList = o3.jsApiList), i.hadConfig = true, i.bridgeInitFn().then(function(t2) {
          var n2 = i.platformConfigMap[e2.platform], r = o3;
          n2.authParamsDeal && (r = n2.authParamsDeal(r)), t2(n2.authMethod, r).then(function(e3) {
            i.isReady = true, i.p.resolve(e3);
          }).catch(function(e3) {
            i.isReady = false, i.p.reject(e3);
          });
        }, function(e3) {
          i.customLog(sdkLib_1.LogLevel.ERROR, ['\b\b\b\b\bJsBridge initialization failed and "dd.config" failed to call']), i.p.reject(e3);
        }));
      }, devConfig: t, ready: function(e3) {
        i.hadConfig === false ? (i.customLog(sdkLib_1.LogLevel.WARNING, ["You don 't use a dd.config, so you don't need to wrap dd.ready, recommend remove dd.ready"]), i.bridgeInitFn().then(function() {
          e3();
        })) : i.config$.then(function(o3) {
          e3();
        });
      }, error: function(e3) {
        i.config$.catch(function(o3) {
          e3(o3);
        });
      }, on: function(o3, t2) {
        i.bridgeInitFn().then(function() {
          i.platformConfigMap[e2.platform].event.on(o3, t2);
        });
      }, off: function(o3, t2) {
        i.bridgeInitFn().then(function() {
          i.platformConfigMap[e2.platform].event.off(o3, t2);
        });
      }, env: e2, checkJsApi: function(o3) {
        o3 === void 0 && (o3 = {});
        var t2 = {};
        return o3.jsApiList && o3.jsApiList.forEach(function(o4) {
          var n = i.invokeAPIConfigMapByMethod[o4];
          if (n) {
            var r = n[e2.platform], s = getTargetApiConfigVS(r, e2);
            s && e2.version && sdkLib_1.compareVersion(e2.version, s) && (t2[o4] = true);
          }
          t2[o4] || (t2[o4] = false);
        }), Promise.resolve(t2);
      }, _invoke: function(e3, o3) {
        return o3 === void 0 && (o3 = {}), i.invokeAPI(e3, o3, false);
      } };
    }
    return e;
  }();
  exports.Sdk = Sdk;
})(sdk);
var dingtalkJavascriptEnv = {};
var whichOneRuntime$1 = {};
function snifferMachine(e, n) {
  for (var i = e.length, a = 0, f = true; a < i; a++)
    try {
      if (!(e[a] in n)) {
        f = false;
        break;
      }
    } catch (e2) {
      f = false;
      break;
    }
  return f;
}
function whichOneRuntime() {
  return maybeInWebView && maybeInWeexVueEnv ? snifferMachine(snifferWeexVueMap, weex) ? "Web.Vue" : "Web.Unknown" : !maybeInWebView && maybeInWeexVueEnv ? snifferMachine(snifferWeexVueMap, weex) ? "Weex.Vue" : "Weex.Unknown" : maybeInWebView && maybeInNative && !maybeInWeexVueEnv ? snifferMachine(snifferWeexRaxMap, window) ? "Weex.Rax" : "Weex.Unknown" : maybeInWebView && snifferMachine(snifferWebViewMap, window) ? "Web.Unknown" : "Unknown.Unknown";
}
Object.defineProperty(whichOneRuntime$1, "__esModule", { value: true });
var maybeInWebView = typeof window != "undefined", maybeInWeexVueEnv = typeof weex != "undefined", maybeInNative = typeof callNative != "undefined", snifferWeexRaxMap = ["__weex_config__", "__weex_options__", "__weex_require__"], snifferWebViewMap = ["localStorage", "location", "navigator", "XMLHttpRequest"], snifferWeexVueMap = ["config", "requireModule", "document"];
whichOneRuntime$1.default = whichOneRuntime;
var environment$1 = {};
var constants = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.FRAMEWORK = exports.PLATFORM = exports.RUNTIME = void 0, exports.RUNTIME = { WEB: "Web", WEEX: "Weex", UNKNOWN: "Unknown" }, exports.PLATFORM = { MAC: "Mac", WINDOWS: "Windows", IOS: "iOS", ANDROID: "Android", IPAD: "iPad", BROWSER: "Browser", UNKNOWN: "Unknown" }, exports.FRAMEWORK = { VUE: "Vue", RAX: "Rax", UNKNOWN: "Unknown" };
})(constants);
function environment(n, i, a) {
  var t = a.platform === "Web", e = a.platform === "iOS", r = a.platform === "android", o2 = r || e, s = function() {
    return t ? window.navigator.userAgent.toLowerCase() : "";
  }(), c = function() {
    var n2 = {};
    if (t) {
      var i2 = window.name;
      try {
        var a2 = JSON.parse(i2);
        n2.containerId = a2.containerId, n2.version = a2.hostVersion, n2.language = a2.language || "*";
      } catch (n3) {
      }
    }
    return n2;
  }(), d = function() {
    return o2 ? a.appName === "DingTalk" || a.appName === "com.alibaba.android.rimet" : s.indexOf("dingtalk") > -1 || !!c.containerId;
  }(), O = function() {
    if (t) {
      if (c.version)
        return c.version;
      var n2 = s.match(/aliapp\(\w+\/([a-zA-Z0-9.-]+)\)/);
      n2 === null && (n2 = s.match(/dingtalk\/([a-zA-Z0-9.-]+)/));
      return n2 && n2[1] || "Unknown";
    }
    return a.appVersion;
  }(), u = !!c.containerId, l = /iphone|ipod|ios/.test(s), f = /ipad/.test(s), p = s.indexOf("android") > -1, m2 = s.indexOf("mac") > -1 && u, A = s.indexOf("win") > -1 && u, g = !m2 && !A && u, v = u, P = "";
  return P = d ? l || e ? constants_1$1.PLATFORM.IOS : p || r ? constants_1$1.PLATFORM.ANDROID : f ? constants_1$1.PLATFORM.IPAD : m2 ? constants_1$1.PLATFORM.MAC : A ? constants_1$1.PLATFORM.WINDOWS : g ? constants_1$1.PLATFORM.BROWSER : constants_1$1.PLATFORM.UNKNOWN : constants_1$1.PLATFORM.UNKNOWN, { isDingTalk: d, isWebiOS: l, isWebAndroid: p, isWeexiOS: e, isWeexAndroid: r, isDingTalkPCMac: m2, isDingTalkPCWeb: g, isDingTalkPCWindows: A, isDingTalkPC: v, runtime: n, framework: i, platform: P, version: O, isWeex: o2 };
}
Object.defineProperty(environment$1, "__esModule", { value: true });
var constants_1$1 = constants;
environment$1.default = environment;
function getVirtualEnv() {
  var n = {};
  switch (framework) {
    case constants_1.FRAMEWORK.VUE:
      var t = weex.config, e = t.env;
      n.platform = e.platform, constants_1.RUNTIME.WEEX === runtime && (n.appVersion = e.appVersion, n.appName = e.appName);
      break;
    case constants_1.FRAMEWORK.RAX:
      constants_1.RUNTIME.WEEX === runtime && (n.platform = navigator.platform, n.appName = navigator.appName, n.appVersion = navigator.appVersion);
      break;
    case constants_1.FRAMEWORK.UNKNOWN:
      constants_1.RUNTIME.WEB === runtime && (n.platform = constants_1.RUNTIME.WEB), constants_1.RUNTIME.UNKNOWN === runtime && (n.platform = constants_1.RUNTIME.UNKNOWN);
  }
  return n;
}
Object.defineProperty(dingtalkJavascriptEnv, "__esModule", { value: true });
var whichOneRuntime_1 = whichOneRuntime$1, environment_1 = environment$1, constants_1 = constants, _a = whichOneRuntime_1.default().split("."), runtime = _a[0], framework = _a[1], virtualEnv = getVirtualEnv(), env = environment_1.default(runtime, framework, virtualEnv);
dingtalkJavascriptEnv.default = env;
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getENV = exports.getUA = void 0;
  var sdk_12 = sdk, sdk_2 = sdk;
  Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return sdk_2.ENV_ENUM;
  } }), Object.defineProperty(exports, "APP_TYPE", { enumerable: true, get: function() {
    return sdk_2.APP_TYPE;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return sdk_2.ENV_ENUM_SUB;
  } });
  var dingtalk_javascript_env_1 = dingtalkJavascriptEnv, getTopBridge = function() {
    try {
      if (typeof window != "undefined" && window.top !== void 0) {
        return window.top.__dingtalk_jsapi_top_platfrom_config__;
      }
    } catch (e) {
      return;
    }
  }, EDdWeexEnv;
  !function(e) {
    e.singlePage = "singlePage", e.miniApp = "miniApp", e.miniWidget = "miniWidget";
  }(EDdWeexEnv || (EDdWeexEnv = {})), exports.getUA = function() {
    var e = "";
    try {
      typeof navigator != "undefined" && (e = navigator && (navigator.userAgent || navigator.swuserAgent) || "");
    } catch (t) {
      e = "";
    }
    return e;
  }, exports.getENV = function() {
    var e = exports.getUA(), t = /iPhone|iPad|iPod|iOS/i.test(e), i = /Android/i.test(e), n = (/Nebula/i.test(e), /DingTalk/i.test(e)), a = /dd-web/i.test(e), r = typeof nuva == "object", d = typeof dd == "object" && typeof dd.dtBridge == "function", o2 = d && t || r && t, _ = n || dingtalk_javascript_env_1.default.isDingTalk, s = t && _ || dingtalk_javascript_env_1.default.isWeexiOS || o2, p = i && _ || dingtalk_javascript_env_1.default.isWeexAndroid, E = d, g = a, c = sdk_12.APP_TYPE.WEB;
    if (g)
      c = sdk_12.APP_TYPE.WEBVIEW_IN_MINIAPP;
    else if (E)
      c = sdk_12.APP_TYPE.MINI_APP;
    else if (dingtalk_javascript_env_1.default.isWeexiOS || dingtalk_javascript_env_1.default.isWeexAndroid)
      try {
        var u = weex.config.ddWeexEnv;
        c = u === EDdWeexEnv.miniWidget ? sdk_12.APP_TYPE.WEEX_WIDGET : sdk_12.APP_TYPE.WEEX;
      } catch (e2) {
        c = sdk_12.APP_TYPE.WEEX;
      }
    var f, v = "*", l = e.match(/AliApp\(\w+\/([a-zA-Z0-9.-]+)\)/);
    l === null && (l = e.match(/DingTalk\/([a-zA-Z0-9.-]+)/));
    var P;
    l && l[1] && (P = l[1]);
    var k = "";
    typeof name != "undefined" && (k = name);
    var N = getTopBridge();
    try {
      N && typeof window != "undefined" && window.top !== void 0 && window.top !== window && (k = top.name);
    } catch (e2) {
    }
    if (k)
      try {
        var A = JSON.parse(k);
        A.hostVersion && (P = A.hostVersion), v = A.language || navigator.language || "*", f = A.containerId;
      } catch (e2) {
      }
    var m2 = !!f;
    m2 && !P && (l = e.match(/DingTalk\(([a-zA-Z0-9\.-]+)\)/)) && l[1] && (P = l[1]);
    var x, U = sdk_12.ENV_ENUM_SUB.noSub;
    if ((x = s ? sdk_12.ENV_ENUM.ios : p ? sdk_12.ENV_ENUM.android : m2 ? sdk_12.ENV_ENUM.pc : N && N.platform ? N.platform : sdk_12.ENV_ENUM.notInDingTalk) === sdk_12.ENV_ENUM.pc) {
      U = e.indexOf("Macintosh; Intel Mac OS") > -1 ? sdk_12.ENV_ENUM_SUB.mac : sdk_12.ENV_ENUM_SUB.win;
    }
    return { platform: x, platformSub: U, version: P, appType: c, language: v };
  };
})(env$1);
var log = {};
(function(exports) {
  function padNumber(e) {
    return e = "00" + e, e.substring(e.length - 2, e.length);
  }
  var __spreadArrays2 = commonjsGlobal && commonjsGlobal.__spreadArrays || function() {
    for (var e = 0, r = 0, t = arguments.length; r < t; r++)
      e += arguments[r].length;
    for (var o2 = Array(e), s = 0, r = 0; r < t; r++)
      for (var n = arguments[r], a = 0, u = n.length; a < u; a++, s++)
        o2[s] = n[a];
    return o2;
  };
  Object.defineProperty(exports, "__esModule", { value: true }), exports.log = void 0, exports.log = function(e) {
    console.log.apply(console, __spreadArrays2([padNumber(e.time.getHours()) + ":" + padNumber(e.time.getMinutes()) + ":" + padNumber(e.time.getSeconds())], e.text));
  };
})(log);
var polyfills = {};
(function(module, exports) {
  (function(global2, factory) {
    factory();
  })(commonjsGlobal, function() {
    var setTimeoutFunc = setTimeout;
    function noop2() {
    }
    function bind3(fn, thisArg) {
      return function() {
        fn.apply(thisArg, arguments);
      };
    }
    function Promise2(fn) {
      if (!(this instanceof Promise2))
        throw new TypeError("Promises must be constructed via new");
      if (typeof fn !== "function")
        throw new TypeError("not a function");
      this._state = 0;
      this._handled = false;
      this._value = void 0;
      this._deferreds = [];
      doResolve(fn, this);
    }
    function handle(self2, deferred) {
      while (self2._state === 3) {
        self2 = self2._value;
      }
      if (self2._state === 0) {
        self2._deferreds.push(deferred);
        return;
      }
      self2._handled = true;
      Promise2._immediateFn(function() {
        var cb = self2._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
          (self2._state === 1 ? resolve : reject)(deferred.promise, self2._value);
          return;
        }
        var ret;
        try {
          ret = cb(self2._value);
        } catch (e) {
          reject(deferred.promise, e);
          return;
        }
        resolve(deferred.promise, ret);
      });
    }
    function resolve(self2, newValue) {
      try {
        if (newValue === self2)
          throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
          var then = newValue.then;
          if (newValue instanceof Promise2) {
            self2._state = 3;
            self2._value = newValue;
            finale(self2);
            return;
          } else if (typeof then === "function") {
            doResolve(bind3(then, newValue), self2);
            return;
          }
        }
        self2._state = 1;
        self2._value = newValue;
        finale(self2);
      } catch (e) {
        reject(self2, e);
      }
    }
    function reject(self2, newValue) {
      self2._state = 2;
      self2._value = newValue;
      finale(self2);
    }
    function finale(self2) {
      if (self2._state === 2 && self2._deferreds.length === 0) {
        Promise2._immediateFn(function() {
          if (!self2._handled) {
            Promise2._unhandledRejectionFn(self2._value);
          }
        });
      }
      for (var i = 0, len = self2._deferreds.length; i < len; i++) {
        handle(self2, self2._deferreds[i]);
      }
      self2._deferreds = null;
    }
    function Handler(onFulfilled, onRejected, promise) {
      this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
      this.onRejected = typeof onRejected === "function" ? onRejected : null;
      this.promise = promise;
    }
    function doResolve(fn, self2) {
      var done = false;
      try {
        fn(function(value) {
          if (done)
            return;
          done = true;
          resolve(self2, value);
        }, function(reason) {
          if (done)
            return;
          done = true;
          reject(self2, reason);
        });
      } catch (ex) {
        if (done)
          return;
        done = true;
        reject(self2, ex);
      }
    }
    Promise2.prototype["catch"] = function(onRejected) {
      return this.then(null, onRejected);
    };
    Promise2.prototype.then = function(onFulfilled, onRejected) {
      var prom = new this.constructor(noop2);
      handle(this, new Handler(onFulfilled, onRejected, prom));
      return prom;
    };
    Promise2.prototype["finally"] = function(callback) {
      var constructor = this.constructor;
      return this.then(function(value) {
        return constructor.resolve(callback()).then(function() {
          return value;
        });
      }, function(reason) {
        return constructor.resolve(callback()).then(function() {
          return constructor.reject(reason);
        });
      });
    };
    Promise2.all = function(arr) {
      return new Promise2(function(resolve2, reject2) {
        if (!arr || typeof arr.length === "undefined")
          throw new TypeError("Promise.all accepts an array");
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0)
          return resolve2([]);
        var remaining = args.length;
        function res(i2, val) {
          try {
            if (val && (typeof val === "object" || typeof val === "function")) {
              var then = val.then;
              if (typeof then === "function") {
                then.call(val, function(val2) {
                  res(i2, val2);
                }, reject2);
                return;
              }
            }
            args[i2] = val;
            if (--remaining === 0) {
              resolve2(args);
            }
          } catch (ex) {
            reject2(ex);
          }
        }
        for (var i = 0; i < args.length; i++) {
          res(i, args[i]);
        }
      });
    };
    Promise2.resolve = function(value) {
      if (value && typeof value === "object" && value.constructor === Promise2) {
        return value;
      }
      return new Promise2(function(resolve2) {
        resolve2(value);
      });
    };
    Promise2.reject = function(value) {
      return new Promise2(function(resolve2, reject2) {
        reject2(value);
      });
    };
    Promise2.race = function(values) {
      return new Promise2(function(resolve2, reject2) {
        for (var i = 0, len = values.length; i < len; i++) {
          values[i].then(resolve2, reject2);
        }
      });
    };
    Promise2._immediateFn = typeof setImmediate === "function" && function(fn) {
      setImmediate(fn);
    } || function(fn) {
      setTimeoutFunc(fn, 0);
    };
    Promise2._unhandledRejectionFn = function _unhandledRejectionFn(err) {
      if (typeof console !== "undefined" && console) {
        console.warn("Possible Unhandled Promise Rejection:", err);
      }
    };
    var globalNS = function() {
      if (typeof self !== "undefined") {
        return self;
      }
      if (typeof window !== "undefined") {
        return window;
      }
      if (typeof commonjsGlobal !== "undefined") {
        return commonjsGlobal;
      }
      throw new Error("unable to locate global object");
    }();
    if (!globalNS.Promise) {
      globalNS.Promise = Promise2;
    }
  });
})();
typeof Object.assign != "function" && Object.defineProperty(Object, "assign", { value: function(e, t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var n = Object(e), r = 1; r < arguments.length; r++) {
    var o2 = arguments[r];
    if (o2 != null)
      for (var c in o2)
        Object.prototype.hasOwnProperty.call(o2, c) && (n[c] = o2[c]);
  }
  return n;
}, writable: true, configurable: true });
Object.keys || (Object.keys = function(e) {
  if (e !== Object(e))
    throw new TypeError("Object.keys called on a non-object");
  var t, r = [];
  for (t in e)
    Object.prototype.hasOwnProperty.call(e, t) && r.push(t);
  return r;
});
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
})(polyfills);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.ddSdk = void 0;
  var env_12 = env$1, log_1 = log, env_2 = env$1;
  Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return env_2.ENV_ENUM;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return env_2.ENV_ENUM_SUB;
  } });
  var sdk_12 = sdk;
  exports.ddSdk = new sdk_12.Sdk(env_12.getENV(), log_1.log);
})(ddSdk);
var otherApi$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.version = exports.language = exports.compareVersion = exports.other = exports.pc = exports.android = exports.ios = void 0;
  var env_12 = env$1, ENV = env_12.getENV();
  exports.ios = ENV.platform === env_12.ENV_ENUM.ios, exports.android = ENV.platform === env_12.ENV_ENUM.android, exports.pc = ENV.platform === env_12.ENV_ENUM.pc, exports.other = ENV.platform === env_12.ENV_ENUM.notInDingTalk, exports.compareVersion = function(e, r, t) {
    function o2(e2) {
      return parseInt(e2, 10) || 0;
    }
    if (typeof e != "string" || typeof r != "string")
      return false;
    for (var s, p, n = e.split("-")[0].split(".").map(o2), i = r.split("-")[0].split(".").map(o2); s === p && i.length > 0; )
      s = n.shift(), p = i.shift();
    return t ? (p || 0) >= (s || 0) : (p || 0) > (s || 0);
  }, exports.language = ENV.language, exports.version = ENV.version;
})(otherApi$1);
var ddSdk_1$3 = ddSdk, otherApi = otherApi$1, core = Object.assign({}, otherApi, ddSdk_1$3.ddSdk.getExportSdk());
var core_1 = core;
var platform = {};
var pc = {};
var h5Pc = {};
var frameTalkClientPc = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    return function(t) {
      function e(r) {
        if (n[r])
          return n[r].exports;
        var o2 = n[r] = { i: r, l: false, exports: {} };
        return t[r].call(o2.exports, o2, o2.exports, e), o2.l = true, o2.exports;
      }
      var n = {};
      return e.m = t, e.c = n, e.i = function(t2) {
        return t2;
      }, e.d = function(t2, n2, r) {
        e.o(t2, n2) || Object.defineProperty(t2, n2, { configurable: false, enumerable: true, get: r });
      }, e.n = function(t2) {
        var n2 = t2 && t2.__esModule ? function() {
          return t2.default;
        } : function() {
          return t2;
        };
        return e.d(n2, "a", n2), n2;
      }, e.o = function(t2, e2) {
        return Object.prototype.hasOwnProperty.call(t2, e2);
      }, e.p = "", e(e.s = 721);
    }({ 199: function(t, e, n) {
      var r = n(201);
      t.exports = r;
    }, 201: function(t, e, n) {
      var r = n(203), o2 = n(204), i = n(202), u = n(205), c = new i(), a = false, s = "", f = null, l = {}, p = /{.*}/;
      try {
        var h = window.name.match(p);
        if (h && h[0])
          var l = JSON.parse(h[0]);
      } catch (t2) {
        l = {};
      }
      l.hostOrigin && l.hostOrigin.split(":")[1].slice(0 - ".dingtalk.com".length) === ".dingtalk.com" && l.containerId && (a = true, s = l.hostOrigin, f = l.containerId);
      var d = {}, v = new Promise(function(t2, e2) {
        d._resolve = t2, d._reject = e2;
      }), y = {}, _ = null;
      window.top !== window ? (_ = window.top, d._resolve()) : typeof dingtalk == "object" && typeof dingtalk.platform == "object" && typeof dingtalk.platform.invokeAPI == "function" && (_ = window, d._resolve()), y[u.SYS_INIT] = function(t2) {
        _ = t2.frameWindow, d._resolve(), t2.respond({});
      }, window.addEventListener("message", function(t2) {
        var e2 = t2.data, n2 = t2.origin;
        if (n2 === s) {
          if (e2.type === "response" && e2.msgId) {
            var r2 = e2.msgId, i2 = c.getMsyById(r2);
            i2 && i2.methodName !== u.SYS_EVENT && i2.receiveResponse(e2.body, !e2.success);
          } else if (e2.type === "event" && e2.msgId) {
            var r2 = e2.msgId, i2 = c.getMsyById(r2);
            i2 && i2.receiveEvent(e2.eventName, e2.body);
          } else if (e2.type === "request" && e2.msgId) {
            var i2 = new o2(t2.source, n2, e2);
            y[i2.methodName] && y[i2.methodName](i2);
          }
        }
      }), e.invokeAPI = function(t2, e2) {
        var n2 = new r(f, t2, e2);
        return a && v.then(function() {
          _ && _.postMessage(n2.getPayload(), s), c.addPending(n2);
        }), n2;
      };
      var b = null;
      e.addEventListener = function(t2, n2) {
        b || (b = e.invokeAPI(u.SYS_EVENT, {})), b.addEventListener(t2, n2);
      }, e.removeEventListener = function(t2, e2) {
        b && b.removeEventListener(t2, e2);
      };
    }, 202: function(t, e, n) {
      var r = function() {
        this.pendingMsgs = {};
      };
      r.prototype.addPending = function(t2) {
        this.pendingMsgs[t2.id] = t2;
        var e2 = function() {
          delete this.pendingMsgs[t2.id], t2.removeEventListener("_finish", e2);
        }.bind(this);
        t2.addEventListener("_finish", e2);
      }, r.prototype.getMsyById = function(t2) {
        return this.pendingMsgs[t2];
      }, t.exports = r;
    }, 203: function(t, e, n) {
      var r = n(716), o2 = n(715), i = 0, u = Math.floor(1e3 * Math.random()), c = function() {
        return 1e3 * (1e3 * u + Math.floor(1e3 * Math.random())) + ++i % 1e3;
      }, a = { code: 408, reason: "timeout" }, s = { TIMEOUT: "_timeout", FINISH: "_finish" }, f = { timeout: -1 }, l = function(t2, e2, n2, r2) {
        this.id = c(), this.methodName = e2, this.containerId = t2, this.option = o2({}, f, r2);
        var n2 = n2 || {};
        this._p = {}, this.result = new Promise(function(t3, e3) {
          this._p._resolve = t3, this._p._reject = e3;
        }.bind(this)), this.callbacks = {}, this.plainMsg = this._handleMsg(n2), this._eventsHandle = {}, this._timeoutTimer = null, this._initTimeout(), this.isFinish = false;
      };
      l.prototype._initTimeout = function() {
        this._clearTimeout(), this.option.timeout > 0 && (this._timeoutTimer = setTimeout(function() {
          this.receiveEvent(s.TIMEOUT), this.receiveResponse(a, true);
        }.bind(this), this.option.timeout));
      }, l.prototype._clearTimeout = function() {
        clearTimeout(this._timeoutTimer);
      }, l.prototype._handleMsg = function(t2) {
        var e2 = {};
        return Object.keys(t2).forEach(function(n2) {
          var o3 = t2[n2];
          typeof o3 == "function" && n2.slice(0, 2) === "on" ? this.callbacks[n2] = o3 : e2[n2] = r(o3);
        }.bind(this)), e2;
      }, l.prototype.getPayload = function() {
        return { msgId: this.id, containerId: this.containerId, methodName: this.methodName, body: this.plainMsg, type: "request" };
      }, l.prototype.receiveEvent = function(t2, e2) {
        if (this.isFinish && t2 !== s.FINISH)
          return false;
        t2 !== s.FINISH && t2 !== s.TIMEOUT && this._initTimeout(), Array.isArray(this._eventsHandle[t2]) && this._eventsHandle[t2].forEach(function(t3) {
          try {
            t3(e2);
          } catch (t4) {
            console.error(e2);
          }
        });
        var n2 = "on" + t2.charAt(0).toUpperCase() + t2.slice(1);
        return this.callbacks[n2] && this.callbacks[n2](e2), true;
      }, l.prototype.addEventListener = function(t2, e2) {
        if (!t2 || typeof e2 != "function")
          throw "eventName is null or handle is not a function, addEventListener fail";
        Array.isArray(this._eventsHandle[t2]) || (this._eventsHandle[t2] = []), this._eventsHandle[t2].push(e2);
      }, l.prototype.removeEventListener = function(t2, e2) {
        if (!t2 || !e2)
          throw "eventName is null or handle is null, invoke removeEventListener fail";
        if (Array.isArray(this._eventsHandle[t2])) {
          var n2 = this._eventsHandle[t2].indexOf(e2);
          n2 !== -1 && this._eventsHandle[t2].splice(n2, 1);
        }
      }, l.prototype.receiveResponse = function(t2, e2) {
        if (this.isFinish === true)
          return false;
        this._clearTimeout();
        var e2 = !!e2;
        return e2 ? this._p._reject(t2) : this._p._resolve(t2), setTimeout(function() {
          this.receiveEvent(s.FINISH);
        }.bind(this), 0), this.isFinish = true, true;
      }, t.exports = l;
    }, 204: function(t, e, n) {
      var r = function(t2, e2, n2) {
        if (this._msgId = n2.msgId, this.frameWindow = t2, this.methodName = n2.methodName, this.clientOrigin = e2, this.containerId = n2.containerId, this.params = n2.body, !this._msgId)
          throw "msgId not exist";
        if (!this.frameWindow)
          throw "frameWindow not exist";
        if (!this.methodName)
          throw "methodName not exits";
        if (!this.clientOrigin)
          throw "clientOrigin not exist";
        this.hasResponded = false;
      };
      r.prototype.respond = function(t2, e2) {
        var e2 = !!e2;
        if (this.hasResponded !== true) {
          var n2 = { type: "response", success: !e2, body: t2, msgId: this._msgId };
          this.frameWindow.postMessage(n2, this.clientOrigin), this.hasResponded = true;
        }
      }, r.prototype.emit = function(t2, e2) {
        var n2 = { type: "event", eventName: t2, body: e2, msgId: this._msgId };
        this.frameWindow.postMessage(n2, this.clientOrigin);
      }, t.exports = r;
    }, 205: function(t, e, n) {
      t.exports = { SYS_EVENT: "SYS_openAPIContainerInitEvent", SYS_INIT: "SYS_openAPIContainerInit" };
    }, 4: function(t, e) {
      var n;
      n = function() {
        return this;
      }();
      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (t2) {
        typeof window == "object" && (n = window);
      }
      t.exports = n;
    }, 714: function(t, e, n) {
      (function(t2, n2) {
        function r(t3, e2) {
          return t3.set(e2[0], e2[1]), t3;
        }
        function o2(t3, e2) {
          return t3.add(e2), t3;
        }
        function i(t3, e2) {
          for (var n3 = -1, r2 = t3.length; ++n3 < r2 && e2(t3[n3], n3, t3) !== false; )
            ;
          return t3;
        }
        function u(t3, e2) {
          for (var n3 = -1, r2 = e2.length, o3 = t3.length; ++n3 < r2; )
            t3[o3 + n3] = e2[n3];
          return t3;
        }
        function c(t3, e2, n3, r2) {
          var o3 = -1, i2 = t3.length;
          for (r2 && i2 && (n3 = t3[++o3]); ++o3 < i2; )
            n3 = e2(n3, t3[o3], o3, t3);
          return n3;
        }
        function a(t3, e2) {
          for (var n3 = -1, r2 = Array(t3); ++n3 < t3; )
            r2[n3] = e2(n3);
          return r2;
        }
        function s(t3) {
          return t3 && t3.Object === Object ? t3 : null;
        }
        function f(t3) {
          var e2 = false;
          if (t3 != null && typeof t3.toString != "function")
            try {
              e2 = !!(t3 + "");
            } catch (t4) {
            }
          return e2;
        }
        function l(t3) {
          var e2 = -1, n3 = Array(t3.size);
          return t3.forEach(function(t4, r2) {
            n3[++e2] = [r2, t4];
          }), n3;
        }
        function p(t3) {
          var e2 = -1, n3 = Array(t3.size);
          return t3.forEach(function(t4) {
            n3[++e2] = t4;
          }), n3;
        }
        function h(t3) {
          var e2 = -1, n3 = t3 ? t3.length : 0;
          for (this.clear(); ++e2 < n3; ) {
            var r2 = t3[e2];
            this.set(r2[0], r2[1]);
          }
        }
        function d() {
          this.__data__ = ke ? ke(null) : {};
        }
        function v(t3) {
          return this.has(t3) && delete this.__data__[t3];
        }
        function y(t3) {
          var e2 = this.__data__;
          if (ke) {
            var n3 = e2[t3];
            return n3 === St ? void 0 : n3;
          }
          return ye.call(e2, t3) ? e2[t3] : void 0;
        }
        function _(t3) {
          var e2 = this.__data__;
          return ke ? e2[t3] !== void 0 : ye.call(e2, t3);
        }
        function b(t3, e2) {
          return this.__data__[t3] = ke && e2 === void 0 ? St : e2, this;
        }
        function g(t3) {
          var e2 = -1, n3 = t3 ? t3.length : 0;
          for (this.clear(); ++e2 < n3; ) {
            var r2 = t3[e2];
            this.set(r2[0], r2[1]);
          }
        }
        function m2() {
          this.__data__ = [];
        }
        function j(t3) {
          var e2 = this.__data__, n3 = W(e2, t3);
          return !(n3 < 0 || (n3 == e2.length - 1 ? e2.pop() : xe.call(e2, n3, 1), 0));
        }
        function w(t3) {
          var e2 = this.__data__, n3 = W(e2, t3);
          return n3 < 0 ? void 0 : e2[n3][1];
        }
        function I(t3) {
          return W(this.__data__, t3) > -1;
        }
        function O(t3, e2) {
          var n3 = this.__data__, r2 = W(n3, t3);
          return r2 < 0 ? n3.push([t3, e2]) : n3[r2][1] = e2, this;
        }
        function x(t3) {
          var e2 = -1, n3 = t3 ? t3.length : 0;
          for (this.clear(); ++e2 < n3; ) {
            var r2 = t3[e2];
            this.set(r2[0], r2[1]);
          }
        }
        function A() {
          this.__data__ = { hash: new h(), map: new (Me || g)(), string: new h() };
        }
        function E(t3) {
          return rt(this, t3).delete(t3);
        }
        function S(t3) {
          return rt(this, t3).get(t3);
        }
        function M2(t3) {
          return rt(this, t3).has(t3);
        }
        function N(t3, e2) {
          return rt(this, t3).set(t3, e2), this;
        }
        function P(t3) {
          this.__data__ = new g(t3);
        }
        function T() {
          this.__data__ = new g();
        }
        function k(t3) {
          return this.__data__.delete(t3);
        }
        function F(t3) {
          return this.__data__.get(t3);
        }
        function H(t3) {
          return this.__data__.has(t3);
        }
        function L(t3, e2) {
          var n3 = this.__data__;
          return n3 instanceof g && n3.__data__.length == Et && (n3 = this.__data__ = new x(n3.__data__)), n3.set(t3, e2), this;
        }
        function $(t3, e2, n3) {
          var r2 = t3[e2];
          ye.call(t3, e2) && yt(r2, n3) && (n3 !== void 0 || e2 in t3) || (t3[e2] = n3);
        }
        function W(t3, e2) {
          for (var n3 = t3.length; n3--; )
            if (yt(t3[n3][0], e2))
              return n3;
          return -1;
        }
        function U(t3, e2) {
          return t3 && tt(e2, At(e2), t3);
        }
        function R(t3, e2, n3, r2, o3, u2, c2) {
          var a2;
          if (r2 && (a2 = u2 ? r2(t3, o3, u2, c2) : r2(t3)), a2 !== void 0)
            return a2;
          if (!wt(t3))
            return t3;
          var s2 = Ye(t3);
          if (s2) {
            if (a2 = at(t3), !e2)
              return Z(t3, a2);
          } else {
            var l2 = ct(t3), p2 = l2 == kt || l2 == Ft;
            if (Ce(t3))
              return D(t3, e2);
            if (l2 == $t || l2 == Nt || p2 && !u2) {
              if (f(t3))
                return u2 ? t3 : {};
              if (a2 = st(p2 ? {} : t3), !e2)
                return et(t3, U(a2, t3));
            } else {
              if (!re[l2])
                return u2 ? t3 : {};
              a2 = ft(t3, l2, R, e2);
            }
          }
          c2 || (c2 = new P());
          var h2 = c2.get(t3);
          if (h2)
            return h2;
          if (c2.set(t3, a2), !s2)
            var d2 = n3 ? nt(t3) : At(t3);
          return i(d2 || t3, function(o4, i2) {
            d2 && (i2 = o4, o4 = t3[i2]), $(a2, i2, R(o4, e2, n3, r2, i2, t3, c2));
          }), a2;
        }
        function B(t3) {
          return wt(t3) ? Ie(t3) : {};
        }
        function Y(t3, e2, n3) {
          var r2 = e2(t3);
          return Ye(t3) ? r2 : u(r2, n3(t3));
        }
        function C(t3, e2) {
          return ye.call(t3, e2) || typeof t3 == "object" && e2 in t3 && it(t3) === null;
        }
        function V(t3) {
          return Ee(Object(t3));
        }
        function D(t3, e2) {
          if (e2)
            return t3.slice();
          var n3 = new t3.constructor(t3.length);
          return t3.copy(n3), n3;
        }
        function G(t3) {
          var e2 = new t3.constructor(t3.byteLength);
          return new je(e2).set(new je(t3)), e2;
        }
        function q(t3, e2) {
          var n3 = e2 ? G(t3.buffer) : t3.buffer;
          return new t3.constructor(n3, t3.byteOffset, t3.byteLength);
        }
        function z(t3, e2, n3) {
          return c(e2 ? n3(l(t3), true) : l(t3), r, new t3.constructor());
        }
        function J(t3) {
          var e2 = new t3.constructor(t3.source, te.exec(t3));
          return e2.lastIndex = t3.lastIndex, e2;
        }
        function K(t3, e2, n3) {
          return c(e2 ? n3(p(t3), true) : p(t3), o2, new t3.constructor());
        }
        function Q(t3) {
          return Re ? Object(Re.call(t3)) : {};
        }
        function X(t3, e2) {
          var n3 = e2 ? G(t3.buffer) : t3.buffer;
          return new t3.constructor(n3, t3.byteOffset, t3.length);
        }
        function Z(t3, e2) {
          var n3 = -1, r2 = t3.length;
          for (e2 || (e2 = Array(r2)); ++n3 < r2; )
            e2[n3] = t3[n3];
          return e2;
        }
        function tt(t3, e2, n3, r2) {
          n3 || (n3 = {});
          for (var o3 = -1, i2 = e2.length; ++o3 < i2; ) {
            var u2 = e2[o3];
            $(n3, u2, r2 ? r2(n3[u2], t3[u2], u2, n3, t3) : t3[u2]);
          }
          return n3;
        }
        function et(t3, e2) {
          return tt(t3, ut2(t3), e2);
        }
        function nt(t3) {
          return Y(t3, At, ut2);
        }
        function rt(t3, e2) {
          var n3 = t3.__data__;
          return ht(e2) ? n3[typeof e2 == "string" ? "string" : "hash"] : n3.map;
        }
        function ot(t3, e2) {
          var n3 = t3[e2];
          return Ot(n3) ? n3 : void 0;
        }
        function it(t3) {
          return Ae(Object(t3));
        }
        function ut2(t3) {
          return we(Object(t3));
        }
        function ct(t3) {
          return _e.call(t3);
        }
        function at(t3) {
          var e2 = t3.length, n3 = t3.constructor(e2);
          return e2 && typeof t3[0] == "string" && ye.call(t3, "index") && (n3.index = t3.index, n3.input = t3.input), n3;
        }
        function st(t3) {
          return typeof t3.constructor != "function" || dt(t3) ? {} : B(it(t3));
        }
        function ft(t3, e2, n3, r2) {
          var o3 = t3.constructor;
          switch (e2) {
            case Yt:
              return G(t3);
            case Pt:
            case Tt:
              return new o3(+t3);
            case Ct:
              return q(t3, r2);
            case Vt:
            case Dt:
            case Gt:
            case qt:
            case zt:
            case Jt:
            case Kt:
            case Qt:
            case Xt:
              return X(t3, r2);
            case Ht:
              return z(t3, r2, n3);
            case Lt:
            case Rt:
              return new o3(t3);
            case Wt:
              return J(t3);
            case Ut:
              return K(t3, r2, n3);
            case Bt:
              return Q(t3);
          }
        }
        function lt(t3) {
          var e2 = t3 ? t3.length : void 0;
          return jt(e2) && (Ye(t3) || xt(t3) || _t(t3)) ? a(e2, String) : null;
        }
        function pt(t3, e2) {
          return !!(e2 = e2 == null ? Mt : e2) && (typeof t3 == "number" || ne.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e2;
        }
        function ht(t3) {
          var e2 = typeof t3;
          return e2 == "string" || e2 == "number" || e2 == "symbol" || e2 == "boolean" ? t3 !== "__proto__" : t3 === null;
        }
        function dt(t3) {
          var e2 = t3 && t3.constructor;
          return t3 === (typeof e2 == "function" && e2.prototype || de);
        }
        function vt(t3) {
          if (t3 != null) {
            try {
              return ve.call(t3);
            } catch (t4) {
            }
            try {
              return t3 + "";
            } catch (t4) {
            }
          }
          return "";
        }
        function yt(t3, e2) {
          return t3 === e2 || t3 !== t3 && e2 !== e2;
        }
        function _t(t3) {
          return gt(t3) && ye.call(t3, "callee") && (!Oe.call(t3, "callee") || _e.call(t3) == Nt);
        }
        function bt(t3) {
          return t3 != null && jt(Be(t3)) && !mt(t3);
        }
        function gt(t3) {
          return It(t3) && bt(t3);
        }
        function mt(t3) {
          var e2 = wt(t3) ? _e.call(t3) : "";
          return e2 == kt || e2 == Ft;
        }
        function jt(t3) {
          return typeof t3 == "number" && t3 > -1 && t3 % 1 == 0 && t3 <= Mt;
        }
        function wt(t3) {
          var e2 = typeof t3;
          return !!t3 && (e2 == "object" || e2 == "function");
        }
        function It(t3) {
          return !!t3 && typeof t3 == "object";
        }
        function Ot(t3) {
          return !!wt(t3) && (mt(t3) || f(t3) ? be : ee).test(vt(t3));
        }
        function xt(t3) {
          return typeof t3 == "string" || !Ye(t3) && It(t3) && _e.call(t3) == Rt;
        }
        function At(t3) {
          var e2 = dt(t3);
          if (!e2 && !bt(t3))
            return V(t3);
          var n3 = lt(t3), r2 = !!n3, o3 = n3 || [], i2 = o3.length;
          for (var u2 in t3)
            !C(t3, u2) || r2 && (u2 == "length" || pt(u2, i2)) || e2 && u2 == "constructor" || o3.push(u2);
          return o3;
        }
        var Et = 200, St = "__lodash_hash_undefined__", Mt = 9007199254740991, Nt = "[object Arguments]", Pt = "[object Boolean]", Tt = "[object Date]", kt = "[object Function]", Ft = "[object GeneratorFunction]", Ht = "[object Map]", Lt = "[object Number]", $t = "[object Object]", Wt = "[object RegExp]", Ut = "[object Set]", Rt = "[object String]", Bt = "[object Symbol]", Yt = "[object ArrayBuffer]", Ct = "[object DataView]", Vt = "[object Float32Array]", Dt = "[object Float64Array]", Gt = "[object Int8Array]", qt = "[object Int16Array]", zt = "[object Int32Array]", Jt = "[object Uint8Array]", Kt = "[object Uint8ClampedArray]", Qt = "[object Uint16Array]", Xt = "[object Uint32Array]", Zt = /[\\^$.*+?()[\]{}|]/g, te = /\w*$/, ee = /^\[object .+?Constructor\]$/, ne = /^(?:0|[1-9]\d*)$/, re = {};
        re[Nt] = re["[object Array]"] = re[Yt] = re[Ct] = re[Pt] = re[Tt] = re[Vt] = re[Dt] = re[Gt] = re[qt] = re[zt] = re[Ht] = re[Lt] = re[$t] = re[Wt] = re[Ut] = re[Rt] = re[Bt] = re[Jt] = re[Kt] = re[Qt] = re[Xt] = true, re["[object Error]"] = re[kt] = re["[object WeakMap]"] = false;
        var oe = { function: true, object: true }, ie = oe[typeof e] && e && !e.nodeType ? e : void 0, ue = oe[typeof t2] && t2 && !t2.nodeType ? t2 : void 0, ce = ue && ue.exports === ie ? ie : void 0, ae = s(ie && ue && typeof n2 == "object" && n2), se = s(oe[typeof self] && self), fe = s(oe[typeof window] && window), le = s(oe[typeof this] && this), pe = ae || fe !== (le && le.window) && fe || se || le || Function("return this")(), he = Array.prototype, de = Object.prototype, ve = Function.prototype.toString, ye = de.hasOwnProperty, _e = de.toString, be = RegExp("^" + ve.call(ye).replace(Zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ge = ce ? pe.Buffer : void 0, me = pe.Symbol, je = pe.Uint8Array, we = Object.getOwnPropertySymbols, Ie = Object.create, Oe = de.propertyIsEnumerable, xe = he.splice, Ae = Object.getPrototypeOf, Ee = Object.keys, Se = ot(pe, "DataView"), Me = ot(pe, "Map"), Ne = ot(pe, "Promise"), Pe = ot(pe, "Set"), Te = ot(pe, "WeakMap"), ke = ot(Object, "create"), Fe = vt(Se), He = vt(Me), Le = vt(Ne), $e = vt(Pe), We = vt(Te), Ue = me ? me.prototype : void 0, Re = Ue ? Ue.valueOf : void 0;
        h.prototype.clear = d, h.prototype.delete = v, h.prototype.get = y, h.prototype.has = _, h.prototype.set = b, g.prototype.clear = m2, g.prototype.delete = j, g.prototype.get = w, g.prototype.has = I, g.prototype.set = O, x.prototype.clear = A, x.prototype.delete = E, x.prototype.get = S, x.prototype.has = M2, x.prototype.set = N, P.prototype.clear = T, P.prototype.delete = k, P.prototype.get = F, P.prototype.has = H, P.prototype.set = L;
        var Be = function(t3) {
          return function(t4) {
            return t4 == null ? void 0 : t4.length;
          };
        }();
        we || (ut2 = function() {
          return [];
        }), (Se && ct(new Se(new ArrayBuffer(1))) != Ct || Me && ct(new Me()) != Ht || Ne && ct(Ne.resolve()) != "[object Promise]" || Pe && ct(new Pe()) != Ut || Te && ct(new Te()) != "[object WeakMap]") && (ct = function(t3) {
          var e2 = _e.call(t3), n3 = e2 == $t ? t3.constructor : void 0, r2 = n3 ? vt(n3) : void 0;
          if (r2)
            switch (r2) {
              case Fe:
                return Ct;
              case He:
                return Ht;
              case Le:
                return "[object Promise]";
              case $e:
                return Ut;
              case We:
                return "[object WeakMap]";
            }
          return e2;
        });
        var Ye = Array.isArray, Ce = ge ? function(t3) {
          return t3 instanceof ge;
        } : function(t3) {
          return function() {
            return false;
          };
        }();
        t2.exports = R;
      }).call(e, n(719)(t), n(4));
    }, 715: function(t, e, n) {
      function r(t2, e2, n2) {
        var r2 = t2[e2];
        m2.call(t2, e2) && a(r2, n2) && (n2 !== void 0 || e2 in t2) || (t2[e2] = n2);
      }
      function o2(t2, e2, n2, o3) {
        n2 || (n2 = {});
        for (var i2 = -1, u2 = e2.length; ++i2 < u2; ) {
          var c2 = e2[i2];
          r(n2, c2, o3 ? o3(n2[c2], t2[c2], c2, n2, t2) : t2[c2]);
        }
        return n2;
      }
      function i(t2, e2) {
        return !!(e2 = e2 == null ? v : e2) && (typeof t2 == "number" || b.test(t2)) && t2 > -1 && t2 % 1 == 0 && t2 < e2;
      }
      function u(t2, e2, n2) {
        if (!p(n2))
          return false;
        var r2 = typeof e2;
        return !!(r2 == "number" ? s(n2) && i(e2, n2.length) : r2 == "string" && e2 in n2) && a(n2[e2], t2);
      }
      function c(t2) {
        var e2 = t2 && t2.constructor;
        return t2 === (typeof e2 == "function" && e2.prototype || g);
      }
      function a(t2, e2) {
        return t2 === e2 || t2 !== t2 && e2 !== e2;
      }
      function s(t2) {
        return t2 != null && l(O(t2)) && !f(t2);
      }
      function f(t2) {
        var e2 = p(t2) ? j.call(t2) : "";
        return e2 == y || e2 == _;
      }
      function l(t2) {
        return typeof t2 == "number" && t2 > -1 && t2 % 1 == 0 && t2 <= v;
      }
      function p(t2) {
        var e2 = typeof t2;
        return !!t2 && (e2 == "object" || e2 == "function");
      }
      var h = n(717), d = n(718), v = 9007199254740991, y = "[object Function]", _ = "[object GeneratorFunction]", b = /^(?:0|[1-9]\d*)$/, g = Object.prototype, m2 = g.hasOwnProperty, j = g.toString, w = g.propertyIsEnumerable, I = !w.call({ valueOf: 1 }, "valueOf"), O = function(t2) {
        return function(t3) {
          return t3 == null ? void 0 : t3.length;
        };
      }(), x = function(t2) {
        return d(function(e2, n2) {
          var r2 = -1, o3 = n2.length, i2 = o3 > 1 ? n2[o3 - 1] : void 0, c2 = o3 > 2 ? n2[2] : void 0;
          for (i2 = t2.length > 3 && typeof i2 == "function" ? (o3--, i2) : void 0, c2 && u(n2[0], n2[1], c2) && (i2 = o3 < 3 ? void 0 : i2, o3 = 1), e2 = Object(e2); ++r2 < o3; ) {
            var a2 = n2[r2];
            a2 && t2(e2, a2);
          }
          return e2;
        });
      }(function(t2, e2) {
        if (I || c(e2) || s(e2))
          return void o2(e2, h(e2), t2);
        for (var n2 in e2)
          m2.call(e2, n2) && r(t2, n2, e2[n2]);
      });
      t.exports = x;
    }, 716: function(t, e, n) {
      function r(t2) {
        return o2(t2, true, true);
      }
      var o2 = n(714);
      t.exports = r;
    }, 717: function(t, e) {
      function n(t2, e2) {
        for (var n2 = -1, r2 = Array(t2); ++n2 < t2; )
          r2[n2] = e2(n2);
        return r2;
      }
      function r(t2, e2) {
        var r2 = x(t2) || c(t2) ? n(t2.length, String) : [], o3 = r2.length, u2 = !!o3;
        for (var a2 in t2)
          !e2 && !j.call(t2, a2) || u2 && (a2 == "length" || i(a2, o3)) || r2.push(a2);
        return r2;
      }
      function o2(t2) {
        if (!u(t2))
          return O(t2);
        var e2 = [];
        for (var n2 in Object(t2))
          j.call(t2, n2) && n2 != "constructor" && e2.push(n2);
        return e2;
      }
      function i(t2, e2) {
        return !!(e2 = e2 == null ? v : e2) && (typeof t2 == "number" || g.test(t2)) && t2 > -1 && t2 % 1 == 0 && t2 < e2;
      }
      function u(t2) {
        var e2 = t2 && t2.constructor;
        return t2 === (typeof e2 == "function" && e2.prototype || m2);
      }
      function c(t2) {
        return s(t2) && j.call(t2, "callee") && (!I.call(t2, "callee") || w.call(t2) == y);
      }
      function a(t2) {
        return t2 != null && l(t2.length) && !f(t2);
      }
      function s(t2) {
        return h(t2) && a(t2);
      }
      function f(t2) {
        var e2 = p(t2) ? w.call(t2) : "";
        return e2 == _ || e2 == b;
      }
      function l(t2) {
        return typeof t2 == "number" && t2 > -1 && t2 % 1 == 0 && t2 <= v;
      }
      function p(t2) {
        var e2 = typeof t2;
        return !!t2 && (e2 == "object" || e2 == "function");
      }
      function h(t2) {
        return !!t2 && typeof t2 == "object";
      }
      function d(t2) {
        return a(t2) ? r(t2) : o2(t2);
      }
      var v = 9007199254740991, y = "[object Arguments]", _ = "[object Function]", b = "[object GeneratorFunction]", g = /^(?:0|[1-9]\d*)$/, m2 = Object.prototype, j = m2.hasOwnProperty, w = m2.toString, I = m2.propertyIsEnumerable, O = function(t2, e2) {
        return function(n2) {
          return t2(e2(n2));
        };
      }(Object.keys, Object), x = Array.isArray;
      t.exports = d;
    }, 718: function(t, e) {
      function n(t2, e2, n2) {
        switch (n2.length) {
          case 0:
            return t2.call(e2);
          case 1:
            return t2.call(e2, n2[0]);
          case 2:
            return t2.call(e2, n2[0], n2[1]);
          case 3:
            return t2.call(e2, n2[0], n2[1], n2[2]);
        }
        return t2.apply(e2, n2);
      }
      function r(t2, e2) {
        return e2 = I(e2 === void 0 ? t2.length - 1 : e2, 0), function() {
          for (var r2 = arguments, o3 = -1, i2 = I(r2.length - e2, 0), u2 = Array(i2); ++o3 < i2; )
            u2[o3] = r2[e2 + o3];
          o3 = -1;
          for (var c2 = Array(e2 + 1); ++o3 < e2; )
            c2[o3] = r2[o3];
          return c2[e2] = u2, n(t2, this, c2);
        };
      }
      function o2(t2, e2) {
        if (typeof t2 != "function")
          throw new TypeError(l);
        return e2 = e2 === void 0 ? e2 : s(e2), r(t2, e2);
      }
      function i(t2) {
        var e2 = typeof t2;
        return !!t2 && (e2 == "object" || e2 == "function");
      }
      function u(t2) {
        return !!t2 && typeof t2 == "object";
      }
      function c(t2) {
        return typeof t2 == "symbol" || u(t2) && w.call(t2) == v;
      }
      function a(t2) {
        return t2 ? (t2 = f(t2)) === p || t2 === -p ? (t2 < 0 ? -1 : 1) * h : t2 === t2 ? t2 : 0 : t2 === 0 ? t2 : 0;
      }
      function s(t2) {
        var e2 = a(t2), n2 = e2 % 1;
        return e2 === e2 ? n2 ? e2 - n2 : e2 : 0;
      }
      function f(t2) {
        if (typeof t2 == "number")
          return t2;
        if (c(t2))
          return d;
        if (i(t2)) {
          var e2 = typeof t2.valueOf == "function" ? t2.valueOf() : t2;
          t2 = i(e2) ? e2 + "" : e2;
        }
        if (typeof t2 != "string")
          return t2 === 0 ? t2 : +t2;
        t2 = t2.replace(y, "");
        var n2 = b.test(t2);
        return n2 || g.test(t2) ? m2(t2.slice(2), n2 ? 2 : 8) : _.test(t2) ? d : +t2;
      }
      var l = "Expected a function", p = 1 / 0, h = 17976931348623157e292, d = NaN, v = "[object Symbol]", y = /^\s+|\s+$/g, _ = /^[-+]0x[0-9a-f]+$/i, b = /^0b[01]+$/i, g = /^0o[0-7]+$/i, m2 = parseInt, j = Object.prototype, w = j.toString, I = Math.max;
      t.exports = o2;
    }, 719: function(t, e) {
      t.exports = function(t2) {
        return t2.webpackPolyfill || (t2.deprecate = function() {
        }, t2.paths = [], t2.children || (t2.children = []), Object.defineProperty(t2, "loaded", { enumerable: true, get: function() {
          return t2.l;
        } }), Object.defineProperty(t2, "id", { enumerable: true, get: function() {
          return t2.i;
        } }), t2.webpackPolyfill = 1), t2;
      };
    }, 721: function(t, e, n) {
      t.exports = n(199);
    } });
  });
})(frameTalkClientPc);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5PcBridgeInit = void 0, exports.h5PcBridgeInit = function() {
    return Promise.resolve(frameTalkClientPc.exports);
  };
  var h5PcBridge = function(e, n) {
    return new Promise(function(r, t) {
      return frameTalkClientPc.exports.invokeAPI(e, n).result.then(function(e2) {
        return typeof n.onSuccess == "function" && n.onSuccess.call(null, e2), r(e2);
      }, function(e2) {
        return typeof n.onFail == "function" && n.onFail.call(null, e2), t(e2);
      });
    });
  };
  exports.default = h5PcBridge;
})(h5Pc);
var eapp = {};
Object.defineProperty(eapp, "__esModule", { value: true });
var eappBridge = function(e, n) {
  return new Promise(function(o2, t) {
    dd.dtBridge({ m: e, args: n, onSuccess: function(e2) {
      typeof n.onSuccess == "function" && n.onSuccess(e2), o2(e2);
    }, onFail: function(e2) {
      typeof n.onFail == "function" && n.onFail(e2), t(e2);
    } });
  });
};
eapp.default = eappBridge;
var h5PcEvent = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0, exports.on = function(e, t) {
    frameTalkClientPc.exports.addEventListener(e, t);
  }, exports.off = function(e, t) {
    frameTalkClientPc.exports.removeEventListener(e, t);
  };
})(h5PcEvent);
Object.defineProperty(pc, "__esModule", { value: true });
var ddSdk_1$2 = ddSdk, env_1$2 = env$1, h5Pc_1 = h5Pc, eapp_1$2 = eapp, sdk_1$2 = sdk, h5PcEvent_1 = h5PcEvent;
ddSdk_1$2.ddSdk.setPlatform({ platform: env_1$2.ENV_ENUM.pc, bridgeInit: function() {
  switch (env_1$2.getENV().appType) {
    case sdk_1$2.APP_TYPE.MINI_APP:
      return Promise.resolve(eapp_1$2.default);
    default:
      return h5Pc_1.h5PcBridgeInit().then(function() {
        return h5Pc_1.default;
      });
  }
}, authMethod: "config", authParamsDeal: function(e) {
  var r = Object.assign({}, e);
  return r.url = window.location.href.split("#")[0], r;
}, event: { on: function(e, r) {
  if (env_1$2.getENV().appType === sdk_1$2.APP_TYPE.WEB)
    return h5PcEvent_1.on(e, r);
}, off: function(e, r) {
  if (env_1$2.getENV().appType === sdk_1$2.APP_TYPE.WEB)
    return h5PcEvent_1.off(e, r);
} } });
var android = {};
var webviewInMiniApp = {};
Object.defineProperty(webviewInMiniApp, "__esModule", { value: true });
var noop = function() {
}, webviewInMiniappBridge = function(e, n) {
  return new Promise(function(r, i) {
    var o2 = n.onSuccess || noop, a = n.onFail || noop;
    if (delete n.onSuccess, delete n.onFail, AlipayJSBridge) {
      var p = e.split("."), l = p.pop() || "", t = p.join(".");
      AlipayJSBridge.call.apply(null, ["webDdExec", { serviceName: t, actionName: l, args: n }, function(e2) {
        var n2 = {}, p2 = e2.content;
        if (p2)
          try {
            n2 = JSON.parse(p2);
          } catch (e3) {
            console.error("parse dt api result error", p2, e3);
          }
        e2.success ? (o2.apply(null, [n2]), r(n2)) : (a.apply(null, [n2]), i(n2));
      }]);
    } else {
      var c = new Error("Fatal error, cannot find bridge ,current env is WebView in MiniApp");
      a(c), i(c);
    }
  });
};
webviewInMiniApp.default = webviewInMiniappBridge;
var h5Android = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5AndroidbridgeInit = void 0;
  var h5BridgeReadyPromise;
  exports.h5AndroidbridgeInit = function() {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = new Promise(function(e, i) {
      var n = function() {
        try {
          window.WebViewJavascriptBridgeAndroid = window.nuva && window.nuva.require(), e({});
        } catch (e2) {
          i(e2);
        }
      };
      window.nuva && (window.nuva.isReady === void 0 || window.nuva.isReady) ? n() : (document.addEventListener("runtimeready", function() {
        n();
      }, false), document.addEventListener("runtimefailed", function(e2) {
        var n2 = e2 && e2.detail || { errorCode: "2", errorMessage: "unknown nuvajs bootstrap error" };
        i(n2);
      }, false));
    })), h5BridgeReadyPromise;
  };
  var h5AndroidBridge = function(e, i) {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = exports.h5AndroidbridgeInit()), h5BridgeReadyPromise.then(function() {
      return new Promise(function(n, r) {
        var o2 = e.split("."), d = o2.pop() || "", t = o2.join("."), a = function(e2) {
          typeof i.onSuccess == "function" && i.onSuccess(e2), n(e2);
        }, u = function(e2) {
          typeof i.onFail == "function" && i.onFail(e2), r(e2);
        };
        typeof window.WebViewJavascriptBridgeAndroid == "function" && window.WebViewJavascriptBridgeAndroid(a, u, t, d, i);
      });
    });
  };
  exports.default = h5AndroidBridge;
})(h5Android);
var weex$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.androidWeexBridge = exports.iosWeexBridge = exports.requireModule = void 0;
  var STATUS_OK = 1, WEEX_IOS_BIZ_SUCCESS_CODE = "0";
  exports.requireModule = function(e) {
    return typeof __weex_require__ != "undefined" ? __weex_require__("@weex-module/" + e) : typeof weex != "undefined" ? weex.requireModule(e) : void 0;
  }, exports.iosWeexBridge = function() {
    return Promise.resolve(function(e, o2) {
      return new Promise(function(r, n) {
        var s = exports.requireModule("nuvajs-exec"), t = e.split("."), i = t.pop(), _ = t.join(".");
        s.exec({ plugin: _, action: i, args: o2 }, function(e2) {
          e2 && e2.errorCode === WEEX_IOS_BIZ_SUCCESS_CODE ? (typeof o2.onSuccess == "function" && o2.onSuccess(e2.result), r(e2.result)) : (typeof o2.onFail == "function" && o2.onFail(e2.result), n(e2.result));
        });
      });
    });
  }, exports.androidWeexBridge = function() {
    return Promise.resolve(function(e, o2) {
      return new Promise(function(r, n) {
        var s = exports.requireModule("nuvajs-exec"), t = e.split("."), i = t.pop(), _ = t.join(".");
        s.exec({ plugin: _, action: i, args: o2 }, function(e2) {
          var s2 = {};
          try {
            if (e2 && e2.__message__)
              if (typeof e2.__message__ == "object")
                s2 = e2.__message__;
              else
                try {
                  s2 = JSON.parse(e2.__message__);
                } catch (o3) {
                  typeof e2.__message__ == "string" && (s2 = e2.__message__);
                }
          } catch (e3) {
          }
          e2 && parseInt(e2.__status__ + "", 10) === STATUS_OK ? (typeof o2.onSuccess == "function" && o2.onSuccess(s2), r(s2)) : (typeof o2.onFail == "function" && o2.onFail(s2), n(s2));
        });
      });
    });
  };
})(weex$1);
var h5Event = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0;
  var NON_BRIDGE_EVENTS = ["resume", "pause", "online", "offline", "backbutton", "goBack", "pullToRefresh", "message", "recycle", "restore", "drawer", "tab", "navHelpIcon", "navRightButton", "navMenu", "navTitle", "appLinkResponse", "internalPageLinkResponse", "networkEvent", "hostTaskEvent", "deviceOrientationChanged", "autoCheckIn", "deviceFound", "hostCheckIn", "screenshot", "becomeActive", "keepAlive", "navTitleClick", "sharePage", "wxNotify", "editNoteCommand", "updateStyle", "qrscanCommonNotify", "__message__", "dtChannelEvent", "livePlayerEventPlay", "livePlayerEventPause", "livePlayerEventEnded", "livePlayerEventError", "navActions", "attendEvents"], BizEventBridgeType = "dtBizBridgeEvent", EventTypeListKey = "__eventTypeList__", handlerProxyMap = function() {
    return typeof WeakMap == "undefined" ? void 0 : /* @__PURE__ */ new WeakMap();
  }(), getOnHandlerProxy = function(e, n) {
    if (handlerProxyMap) {
      var t = handlerProxyMap.get(n);
      return t === void 0 ? (t = function(e2) {
        var r = e2.detail;
        if (r.namespace && r.eventName) {
          var a = r.namespace + "." + r.eventName;
          t && t[EventTypeListKey].indexOf(a) !== -1 && n(r.data);
        }
      }, t[EventTypeListKey] = [e], handlerProxyMap.set(n, t)) : t[EventTypeListKey].indexOf(e) === -1 && t[EventTypeListKey].push(e), t;
    }
  }, getOffHandlerProxy = function(e, n) {
    if (handlerProxyMap) {
      var t = handlerProxyMap.get(n);
      return t && t[EventTypeListKey].indexOf(e) !== -1 && t[EventTypeListKey].splice(t[EventTypeListKey].indexOf(e), 1), t && t[EventTypeListKey].length <= 1 ? t : void 0;
    }
  };
  exports.on = function(e, n) {
    if (NON_BRIDGE_EVENTS.indexOf(e) !== -1)
      document.addEventListener(e, n);
    else {
      var t = getOnHandlerProxy(e, n);
      t ? document.addEventListener(BizEventBridgeType, t) : console.log("bind event : " + e + " need WeakMap support , current environment doesnot");
    }
  }, exports.off = function(e, n) {
    if (NON_BRIDGE_EVENTS.indexOf(e) !== -1)
      document.removeEventListener(e, n);
    else {
      var t = getOffHandlerProxy(e, n);
      t && document.removeEventListener(BizEventBridgeType, t);
    }
  };
})(h5Event);
var weexEvent = {};
(function(exports) {
  var _this = commonjsGlobal;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0;
  var weex_12 = weex$1;
  exports.on = function(e, t) {
    weex_12.requireModule("globalEvent").addEventListener(e, function(e2) {
      var r = { preventDefault: function() {
        throw new Error("does not support preventDefault");
      }, detail: e2 };
      t.call(_this, r);
    });
  }, exports.off = function(e, t) {
    weex_12.requireModule("globalEvent").removeEventListener(e, t);
  };
})(weexEvent);
Object.defineProperty(android, "__esModule", { value: true });
var ddSdk_1$1 = ddSdk, env_1$1 = env$1, sdk_1$1 = sdk, eapp_1$1 = eapp, webviewInMiniApp_1$1 = webviewInMiniApp, h5Android_1 = h5Android, weex_1$1 = weex$1, h5Event_1$1 = h5Event, weexEvent_1$1 = weexEvent;
ddSdk_1$1.ddSdk.setPlatform({ platform: env_1$1.ENV_ENUM.android, bridgeInit: function() {
  var e = env_1$1.getENV();
  return e.appType === sdk_1$1.APP_TYPE.MINI_APP ? Promise.resolve(eapp_1$1.default) : e.appType === sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP ? Promise.resolve(webviewInMiniApp_1$1.default) : e.appType === sdk_1$1.APP_TYPE.WEEX ? weex_1$1.androidWeexBridge() : h5Android_1.h5AndroidbridgeInit().then(function() {
    return h5Android_1.default;
  });
}, authMethod: "runtime.permission.requestJsApis", event: { on: function(e, r) {
  var i = env_1$1.getENV();
  switch (i.appType) {
    case sdk_1$1.APP_TYPE.WEB:
    case sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      h5Event_1$1.on(e, r);
      break;
    case sdk_1$1.APP_TYPE.WEEX:
      weexEvent_1$1.on(e, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: " + i.appType);
  }
}, off: function(e, r) {
  var i = env_1$1.getENV();
  switch (i.appType) {
    case sdk_1$1.APP_TYPE.WEB:
    case sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      h5Event_1$1.off(e, r);
      break;
    case sdk_1$1.APP_TYPE.WEEX:
      weexEvent_1$1.off(e, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: " + i.appType);
  }
} } });
var ios = {};
var h5Ios = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5IosBridgeInit = void 0;
  var h5BridgeReadyPromise;
  exports.h5IosBridgeInit = function() {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = new Promise(function(e, r) {
      if (typeof WebViewJavascriptBridge != "undefined") {
        try {
          WebViewJavascriptBridge.init(function(e2, r2) {
          });
        } catch (e2) {
          return r();
        }
        return e({});
      }
      document.addEventListener("WebViewJavascriptBridgeReady", function() {
        if (typeof WebViewJavascriptBridge == "undefined")
          return r();
        try {
          WebViewJavascriptBridge.init(function(e2, r2) {
          });
        } catch (e2) {
          return r();
        }
        return e({});
      }, false);
    })), h5BridgeReadyPromise;
  };
  var h5IosBridge = function(e, r) {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = exports.h5IosBridgeInit()), h5BridgeReadyPromise.then(function() {
      var i = Object.assign({}, r);
      return new Promise(function(r2, n) {
        if (i.watch === true) {
          var t = i.onSuccess;
          delete i.onSuccess, typeof WebViewJavascriptBridge != "undefined" && WebViewJavascriptBridge.registerHandler(e, function(e2, r3) {
            typeof t == "function" && t.call(null, e2), r3 && r3({ errorCode: "0", errorMessage: "success" });
          });
        }
        window.WebViewJavascriptBridge !== void 0 && window.WebViewJavascriptBridge.callHandler(e, Object.assign({}, i), function(e2) {
          var t2 = e2 || {};
          t2.errorCode === "0" ? (typeof i.onSuccess == "function" && i.onSuccess.call(null, t2.result), r2(t2.result)) : (t2.errorCode === "-1" && typeof i.onCancel == "function" ? i.onCancel.call(null, t2.result, t2.errorCode) : typeof i.onFail == "function" && i.onFail.call(null, t2.result, t2.errorCode), n(t2.result));
        });
      });
    });
  };
  exports.default = h5IosBridge;
})(h5Ios);
Object.defineProperty(ios, "__esModule", { value: true });
var ddSdk_1 = ddSdk, env_1 = env$1, sdk_1 = sdk, eapp_1 = eapp, webviewInMiniApp_1 = webviewInMiniApp, h5Ios_1 = h5Ios, weex_1 = weex$1, h5Event_1 = h5Event, weexEvent_1 = weexEvent;
ddSdk_1.ddSdk.setPlatform({ platform: env_1.ENV_ENUM.ios, bridgeInit: function() {
  var e = env_1.getENV();
  return e.appType === sdk_1.APP_TYPE.MINI_APP ? Promise.resolve(eapp_1.default) : e.appType === sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP ? Promise.resolve(webviewInMiniApp_1.default) : e.appType === sdk_1.APP_TYPE.WEEX ? weex_1.iosWeexBridge() : h5Ios_1.h5IosBridgeInit().then(function() {
    return h5Ios_1.default;
  });
}, authMethod: "runtime.permission.requestJsApis", event: { on: function(e, r) {
  var i = env_1.getENV();
  switch (i.appType) {
    case sdk_1.APP_TYPE.WEB:
    case sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      h5Event_1.on(e, r);
      break;
    case sdk_1.APP_TYPE.WEEX:
      weexEvent_1.on(e, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: " + i.appType);
  }
}, off: function(e, r) {
  var i = env_1.getENV();
  switch (i.appType) {
    case sdk_1.APP_TYPE.WEB:
    case sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      h5Event_1.off(e, r);
      break;
    case sdk_1.APP_TYPE.WEEX:
      weexEvent_1.off(e, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: " + i.appType);
  }
} } });
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
})(platform);
var dd$2 = core_1;
union.exports = dd$2;
var apiObj = {};
var beaconPicker = {};
(function(exports) {
  function beaconPicker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.beaconPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.beaconPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.beaconPicker$ = beaconPicker$, exports.default = beaconPicker$;
})(beaconPicker);
var detectFace = {};
(function(exports) {
  function detectFace$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.detectFace$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.detectFace";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.18" }, _a2)), exports.detectFace$ = detectFace$, exports.default = detectFace$;
})(detectFace);
var detectFaceFullScreen = {};
(function(exports) {
  function detectFaceFullScreen$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.detectFaceFullScreen$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.detectFaceFullScreen";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.18" }, _a2)), exports.detectFaceFullScreen$ = detectFaceFullScreen$, exports.default = detectFaceFullScreen$;
})(detectFaceFullScreen);
var faceManager = {};
(function(exports) {
  function faceManager$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.faceManager$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.faceManager";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.faceManager$ = faceManager$, exports.default = faceManager$;
})(faceManager);
var punchModePicker = {};
(function(exports) {
  function punchModePicker$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.punchModePicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.punchModePicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.punchModePicker$ = punchModePicker$, exports.default = punchModePicker$;
})(punchModePicker);
var bindAlipay = {};
(function(exports) {
  function bindAlipay$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bindAlipay$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.bindAlipay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.15" }, _a2)), exports.bindAlipay$ = bindAlipay$, exports.default = bindAlipay$;
})(bindAlipay);
var openAuth = {};
(function(exports) {
  function openAuth$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.openAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.8" }, _a2)), exports.openAuth$ = openAuth$, exports.default = openAuth$;
})(openAuth);
var pay = {};
(function(exports) {
  function pay$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pay$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.pay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.pay$ = pay$, exports.default = pay$;
})(pay);
var openAccountPwdLoginPage = {};
(function(exports) {
  function openAccountPwdLoginPage$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openAccountPwdLoginPage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.auth.openAccountPwdLoginPage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.0" }, _a2)), exports.openAccountPwdLoginPage$ = openAccountPwdLoginPage$, exports.default = openAccountPwdLoginPage$;
})(openAccountPwdLoginPage);
var requestAuthInfo = {};
(function(exports) {
  function requestAuthInfo$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.auth.requestAuthInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.19" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.19" }, _a2)), exports.requestAuthInfo$ = requestAuthInfo$, exports.default = requestAuthInfo$;
})(requestAuthInfo);
var chooseDateTime = {};
var apiHelper = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.genBizStoreParamsDealFn = exports.genBoolResultDealFn = exports.forceChangeParamsDealFn = exports.genDefaultParamsDealFn = exports.addDefaultCorpIdParamsDeal = exports.addWatchParamsDeal = void 0, exports.addWatchParamsDeal = function(e) {
    var a = Object.assign({}, e);
    return a.watch = true, a;
  }, exports.addDefaultCorpIdParamsDeal = function(e) {
    var a = Object.assign({}, e);
    return a.corpId = "corpId", a;
  }, exports.genDefaultParamsDealFn = function(e) {
    var a = Object.assign({}, e);
    return function(e2) {
      return Object.assign({}, a, e2);
    };
  }, exports.forceChangeParamsDealFn = function(e) {
    var a = Object.assign({}, e);
    return function(e2) {
      return Object.assign(e2, a);
    };
  }, exports.genBoolResultDealFn = function(e) {
    return function(a) {
      var r = Object.assign({}, a);
      return e.forEach(function(e2) {
        r[e2] !== void 0 && (r[e2] = !!r[e2]);
      }), r;
    };
  }, exports.genBizStoreParamsDealFn = function(e) {
    var a = Object.assign({}, e);
    return typeof a.params != "string" ? (a.params = JSON.stringify(a), a) : a;
  };
})(apiHelper);
(function(exports) {
  function chooseDateTime$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseDateTime$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseDateTime";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseDateTime$ = chooseDateTime$, exports.default = chooseDateTime$;
})(chooseDateTime);
var chooseHalfDay = {};
(function(exports) {
  function chooseHalfDay$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseHalfDay$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseHalfDay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseHalfDay$ = chooseHalfDay$, exports.default = chooseHalfDay$;
})(chooseHalfDay);
var chooseInterval = {};
(function(exports) {
  function chooseInterval$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseInterval$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseInterval";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseInterval$ = chooseInterval$, exports.default = chooseInterval$;
})(chooseInterval);
var chooseOneDay = {};
(function(exports) {
  function chooseOneDay$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseOneDay$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseOneDay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseOneDay$ = chooseOneDay$, exports.default = chooseOneDay$;
})(chooseOneDay);
var chooseConversationByCorpId = {};
(function(exports) {
  function chooseConversationByCorpId$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseConversationByCorpId$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.chat.chooseConversationByCorpId", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.11", paramsDeal }, _a2)), exports.chooseConversationByCorpId$ = chooseConversationByCorpId$, exports.default = chooseConversationByCorpId$;
})(chooseConversationByCorpId);
var collectSticker = {};
(function(exports) {
  function collectSticker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.collectSticker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.collectSticker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.25" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.25" }, _a2)), exports.collectSticker$ = collectSticker$, exports.default = collectSticker$;
})(collectSticker);
var createSceneGroup = {};
(function(exports) {
  function createSceneGroup$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createSceneGroup$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.createSceneGroup";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.17" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.17" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.17" }, _a2)), exports.createSceneGroup$ = createSceneGroup$, exports.default = createSceneGroup$;
})(createSceneGroup);
var getRealmCid = {};
(function(exports) {
  function getRealmCid$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getRealmCid$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.getRealmCid";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.12" }, _a2)), exports.getRealmCid$ = getRealmCid$, exports.default = getRealmCid$;
})(getRealmCid);
var locationChatMessage = {};
(function(exports) {
  function locationChatMessage$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.locationChatMessage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.locationChatMessage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.locationChatMessage$ = locationChatMessage$, exports.default = locationChatMessage$;
})(locationChatMessage);
var openSingleChat = {};
(function(exports) {
  function openSingleChat$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSingleChat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.openSingleChat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.10" }, _a2)), exports.openSingleChat$ = openSingleChat$, exports.default = openSingleChat$;
})(openSingleChat);
var pickConversation = {};
(function(exports) {
  function pickConversation$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pickConversation$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.pickConversation";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.2" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.2" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.9" }, _a2)), exports.pickConversation$ = pickConversation$, exports.default = pickConversation$;
})(pickConversation);
var sendEmotion = {};
(function(exports) {
  function sendEmotion$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.sendEmotion$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.sendEmotion";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.12" }, _a2)), exports.sendEmotion$ = sendEmotion$, exports.default = sendEmotion$;
})(sendEmotion);
var toConversation = {};
(function(exports) {
  function toConversation$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toConversation$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.toConversation";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.toConversation$ = toConversation$, exports.default = toConversation$;
})(toConversation);
var toConversationByOpenConversationId = {};
(function(exports) {
  function toConversationByOpenConversationId$(o2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, o2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toConversationByOpenConversationId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.toConversationByOpenConversationId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.30" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.30" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.33" }, _a2)), exports.toConversationByOpenConversationId$ = toConversationByOpenConversationId$, exports.default = toConversationByOpenConversationId$;
})(toConversationByOpenConversationId);
var setData = {};
(function(exports) {
  function setData$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.clipboardData.setData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.1" }, _a2)), exports.setData$ = setData$, exports.default = setData$;
})(setData);
var createCloudCall = {};
(function(exports) {
  function createCloudCall$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createCloudCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.createCloudCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.createCloudCall$ = createCloudCall$, exports.default = createCloudCall$;
})(createCloudCall);
var getCloudCallInfo = {};
(function(exports) {
  function getCloudCallInfo$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCloudCallInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.getCloudCallInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.getCloudCallInfo$ = getCloudCallInfo$, exports.default = getCloudCallInfo$;
})(getCloudCallInfo);
var getCloudCallList = {};
(function(exports) {
  function getCloudCallList$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCloudCallList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.getCloudCallList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.getCloudCallList$ = getCloudCallList$, exports.default = getCloudCallList$;
})(getCloudCallList);
var videoConfCall = {};
(function(exports) {
  function videoConfCall$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.videoConfCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.videoConfCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.8" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.28" }, _a2)), exports.videoConfCall$ = videoConfCall$, exports.default = videoConfCall$;
})(videoConfCall);
var choose$1 = {};
(function(exports) {
  function choose$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.choose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.contact.choose", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ multiple: true, startWithDepartmentId: 0, users: [] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.choose$ = choose$, exports.default = choose$;
})(choose$1);
var chooseMobileContacts = {};
(function(exports) {
  function chooseMobileContacts$(o2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, o2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseMobileContacts$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.chooseMobileContacts";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.1" }, _a2)), exports.chooseMobileContacts$ = chooseMobileContacts$, exports.default = chooseMobileContacts$;
})(chooseMobileContacts);
var complexPicker = {};
(function(exports) {
  function complexPicker$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.complexPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.complexPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.3.5" }, _a2)), exports.complexPicker$ = complexPicker$, exports.default = complexPicker$;
})(complexPicker);
var createGroup = {};
(function(exports) {
  function createGroup$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createGroup$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.createGroup";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.1" }, _a2)), exports.createGroup$ = createGroup$, exports.default = createGroup$;
})(createGroup);
var departmentsPicker = {};
(function(exports) {
  function departmentsPicker$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.departmentsPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.departmentsPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.2.5" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.departmentsPicker$ = departmentsPicker$, exports.default = departmentsPicker$;
})(departmentsPicker);
var externalComplexPicker = {};
(function(exports) {
  function externalComplexPicker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.externalComplexPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.externalComplexPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.externalComplexPicker$ = externalComplexPicker$, exports.default = externalComplexPicker$;
})(externalComplexPicker);
var externalEditForm = {};
(function(exports) {
  function externalEditForm$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.externalEditForm$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.externalEditForm";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.externalEditForm$ = externalEditForm$, exports.default = externalEditForm$;
})(externalEditForm);
var rolesPicker = {};
(function(exports) {
  function rolesPicker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.rolesPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.rolesPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.16" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.16" }, _a2)), exports.rolesPicker$ = rolesPicker$, exports.default = rolesPicker$;
})(rolesPicker);
var setRule = {};
(function(exports) {
  function setRule$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setRule$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.setRule";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.15" }, _a2)), exports.setRule$ = setRule$, exports.default = setRule$;
})(setRule);
var chooseSpaceDir = {};
(function(exports) {
  function chooseSpaceDir$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseSpaceDir$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.chooseSpaceDir";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.27" }, _a2)), exports.chooseSpaceDir$ = chooseSpaceDir$, exports.default = chooseSpaceDir$;
})(chooseSpaceDir);
var _delete = {};
(function(exports) {
  function delete$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.delete$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.delete";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.21" }, _a2)), exports.delete$ = delete$, exports.default = delete$;
})(_delete);
var preview = {};
(function(exports) {
  function preview$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.preview$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.preview";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2)), exports.preview$ = preview$, exports.default = preview$;
})(preview);
var saveFile = {};
(function(exports) {
  function saveFile$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.saveFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.saveFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.saveFile$ = saveFile$, exports.default = saveFile$;
})(saveFile);
var choose = {};
(function(exports) {
  function choose$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.choose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.customContact.choose", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ isShowCompanyName: false, max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.5.2", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.5.2", paramsDeal }, _a2)), exports.choose$ = choose$, exports.default = choose$;
})(choose);
var multipleChoose = {};
(function(exports) {
  function multipleChoose$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.multipleChoose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.customContact.multipleChoose", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ isShowCompanyName: false, max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.multipleChoose$ = multipleChoose$, exports.default = multipleChoose$;
})(multipleChoose);
var create = {};
(function(exports) {
  function create$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.create$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ding.create";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.1", resultDeal: function(e) {
    return e === "" ? e = { dingCreateResult: false } : typeof e == "object" && (e.dingCreateResult = !!e.dingCreateResult), e;
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.1" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.9" }, _a2)), exports.create$ = create$, exports.default = create$;
})(create);
var post$1 = {};
(function(exports) {
  function post$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.post$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ding.post";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.post$ = post$, exports.default = post$;
})(post$1);
var finishMiniCourseByRecordId = {};
(function(exports) {
  function finishMiniCourseByRecordId$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.finishMiniCourseByRecordId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.finishMiniCourseByRecordId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.finishMiniCourseByRecordId$ = finishMiniCourseByRecordId$, exports.default = finishMiniCourseByRecordId$;
})(finishMiniCourseByRecordId);
var getMiniCourseDraftList = {};
(function(exports) {
  function getMiniCourseDraftList$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getMiniCourseDraftList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.getMiniCourseDraftList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.getMiniCourseDraftList$ = getMiniCourseDraftList$, exports.default = getMiniCourseDraftList$;
})(getMiniCourseDraftList);
var joinClassroom = {};
(function(exports) {
  function joinClassroom$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.joinClassroom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.joinClassroom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.15" }, _a2)), exports.joinClassroom$ = joinClassroom$, exports.default = joinClassroom$;
})(joinClassroom);
var makeMiniCourse = {};
(function(exports) {
  function makeMiniCourse$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.makeMiniCourse$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.makeMiniCourse";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.makeMiniCourse$ = makeMiniCourse$, exports.default = makeMiniCourse$;
})(makeMiniCourse);
var newMsgNotificationStatus = {};
(function(exports) {
  function newMsgNotificationStatus$(t) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, t);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.newMsgNotificationStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.newMsgNotificationStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.newMsgNotificationStatus$ = newMsgNotificationStatus$, exports.default = newMsgNotificationStatus$;
})(newMsgNotificationStatus);
var startAuth$1 = {};
(function(exports) {
  function startAuth$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.startAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.startAuth$ = startAuth$, exports.default = startAuth$;
})(startAuth$1);
var tokenFaceImg = {};
(function(exports) {
  function tokenFaceImg$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.tokenFaceImg$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.tokenFaceImg";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.tokenFaceImg$ = tokenFaceImg$, exports.default = tokenFaceImg$;
})(tokenFaceImg);
var notifyWeex = {};
(function(exports) {
  function notifyWeex$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.notifyWeex$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.event.notifyWeex";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.0" }, _a2)), exports.notifyWeex$ = notifyWeex$, exports.default = notifyWeex$;
})(notifyWeex);
var fetchData = {};
(function(exports) {
  function fetchData$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.fetchData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.intent.fetchData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.fetchData$ = fetchData$, exports.default = fetchData$;
})(fetchData);
var bind$1 = {};
(function(exports) {
  function bind$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bind$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.bind";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.bind$ = bind$, exports.default = bind$;
})(bind$1);
var bindMeetingRoom = {};
(function(exports) {
  function bindMeetingRoom$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bindMeetingRoom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.bindMeetingRoom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.bindMeetingRoom$ = bindMeetingRoom$, exports.default = bindMeetingRoom$;
})(bindMeetingRoom);
var getDeviceProperties = {};
(function(exports) {
  function getDeviceProperties$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getDeviceProperties$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.getDeviceProperties";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.getDeviceProperties$ = getDeviceProperties$, exports.default = getDeviceProperties$;
})(getDeviceProperties);
var invokeThingService = {};
(function(exports) {
  function invokeThingService$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.invokeThingService$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.invokeThingService";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.invokeThingService$ = invokeThingService$, exports.default = invokeThingService$;
})(invokeThingService);
var queryMeetingRoomList = {};
(function(exports) {
  function queryMeetingRoomList$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.queryMeetingRoomList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.queryMeetingRoomList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.queryMeetingRoomList$ = queryMeetingRoomList$, exports.default = queryMeetingRoomList$;
})(queryMeetingRoomList);
var setDeviceProperties = {};
(function(exports) {
  function setDeviceProperties$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setDeviceProperties$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.setDeviceProperties";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.setDeviceProperties$ = setDeviceProperties$, exports.default = setDeviceProperties$;
})(setDeviceProperties);
var unbind$1 = {};
(function(exports) {
  function unbind$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.unbind$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.unbind";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.unbind$ = unbind$, exports.default = unbind$;
})(unbind$1);
var startClassRoom = {};
(function(exports) {
  function startClassRoom$(s) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, s);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startClassRoom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.live.startClassRoom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.19" }, _a2)), exports.startClassRoom$ = startClassRoom$, exports.default = startClassRoom$;
})(startClassRoom);
var startUnifiedLive = {};
(function(exports) {
  function startUnifiedLive$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startUnifiedLive$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.live.startUnifiedLive";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.18" }, _a2)), exports.startUnifiedLive$ = startUnifiedLive$, exports.default = startUnifiedLive$;
})(startUnifiedLive);
var locate = {};
(function(exports) {
  function locate$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.locate$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.map.locate";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.locate$ = locate$, exports.default = locate$;
})(locate);
var search = {};
(function(exports) {
  function search$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.search$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.map.search", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ scope: 500 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.search$ = search$, exports.default = search$;
})(search);
var view = {};
(function(exports) {
  function view$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.view$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.map.view";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.view$ = view$, exports.default = view$;
})(view);
var compressVideo = {};
(function(exports) {
  function compressVideo$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.compressVideo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.media.compressVideo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.37" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.37" }, _a2)), exports.compressVideo$ = compressVideo$, exports.default = compressVideo$;
})(compressVideo);
var openApp = {};
(function(exports) {
  function openApp$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openApp$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.microApp.openApp";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.6" }, _a2)), exports.openApp$ = openApp$, exports.default = openApp$;
})(openApp);
var close$1 = {};
(function(exports) {
  function close$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.close$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.close";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.3.5" }, _a2)), exports.close$ = close$, exports.default = close$;
})(close$1);
var goBack = {};
(function(exports) {
  function goBack$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.goBack$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.goBack";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.goBack$ = goBack$, exports.default = goBack$;
})(goBack);
var hideBar = {};
(function(exports) {
  function hideBar$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.hideBar$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.hideBar";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.hideBar$ = hideBar$, exports.default = hideBar$;
})(hideBar);
var navigateToMiniProgram = {};
(function(exports) {
  function navigateToMiniProgram$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.navigateToMiniProgram$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.navigateToMiniProgram";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.31" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.31" }, _a2)), exports.navigateToMiniProgram$ = navigateToMiniProgram$, exports.default = navigateToMiniProgram$;
})(navigateToMiniProgram);
var quit = {};
(function(exports) {
  function quit$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.quit$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.quit";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.quit$ = quit$, exports.default = quit$;
})(quit);
var replace = {};
(function(exports) {
  function replace$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.replace$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.replace";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.6" }, _a2)), exports.replace$ = replace$, exports.default = replace$;
})(replace);
var setIcon = {};
(function(exports) {
  function setIcon$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setIcon$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setIcon", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ watch: true, showIcon: true, iconIndex: 1 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setIcon$ = setIcon$, exports.default = setIcon$;
})(setIcon);
var setLeft = {};
(function(exports) {
  function setLeft$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setLeft$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setLeft", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ watch: true, show: true, control: false, showIcon: true, text: "" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setLeft$ = setLeft$, exports.default = setLeft$;
})(setLeft);
var setMenu = {};
(function(exports) {
  function setMenu$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setMenu$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setMenu";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.setMenu$ = setMenu$, exports.default = setMenu$;
})(setMenu);
var setRight = {};
(function(exports) {
  function setRight$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setRight$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setRight", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ watch: true, show: true, control: false, showIcon: true, text: "" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setRight$ = setRight$, exports.default = setRight$;
})(setRight);
var setTitle = {};
(function(exports) {
  function setTitle$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setTitle$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.setTitle";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.setTitle$ = setTitle$, exports.default = setTitle$;
})(setTitle);
var componentPunchFromPartner = {};
(function(exports) {
  function componentPunchFromPartner$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.componentPunchFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.componentPunchFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.componentPunchFromPartner$ = componentPunchFromPartner$, exports.default = componentPunchFromPartner$;
})(componentPunchFromPartner);
var startMatchRuleFromPartner = {};
(function(exports) {
  function startMatchRuleFromPartner$(r) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, r);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startMatchRuleFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.startMatchRuleFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.startMatchRuleFromPartner$ = startMatchRuleFromPartner$, exports.default = startMatchRuleFromPartner$;
})(startMatchRuleFromPartner);
var stopMatchRuleFromPartner = {};
(function(exports) {
  function stopMatchRuleFromPartner$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopMatchRuleFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.stopMatchRuleFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.stopMatchRuleFromPartner$ = stopMatchRuleFromPartner$, exports.default = stopMatchRuleFromPartner$;
})(stopMatchRuleFromPartner);
var getRealtimeTracingStatus = {};
(function(exports) {
  function getRealtimeTracingStatus$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getRealtimeTracingStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.getRealtimeTracingStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.getRealtimeTracingStatus$ = getRealtimeTracingStatus$, exports.default = getRealtimeTracingStatus$;
})(getRealtimeTracingStatus);
var getUserExclusiveInfo = {};
(function(exports) {
  function getUserExclusiveInfo$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getUserExclusiveInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.getUserExclusiveInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.14" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.14" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.17" }, _a2)), exports.getUserExclusiveInfo$ = getUserExclusiveInfo$, exports.default = getUserExclusiveInfo$;
})(getUserExclusiveInfo);
var startRealtimeTracing = {};
(function(exports) {
  function startRealtimeTracing$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startRealtimeTracing$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.startRealtimeTracing";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.startRealtimeTracing$ = startRealtimeTracing$, exports.default = startRealtimeTracing$;
})(startRealtimeTracing);
var stopRealtimeTracing = {};
(function(exports) {
  function stopRealtimeTracing$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopRealtimeTracing$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.stopRealtimeTracing";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.stopRealtimeTracing$ = stopRealtimeTracing$, exports.default = stopRealtimeTracing$;
})(stopRealtimeTracing);
var subscribe2 = {};
(function(exports) {
  function subscribe$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.subscribe$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.subscribe";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.18" }, _a2)), exports.subscribe$ = subscribe$, exports.default = subscribe$;
})(subscribe2);
var unsubscribe2 = {};
(function(exports) {
  function unsubscribe$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.unsubscribe$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.unsubscribe";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.18" }, _a2)), exports.unsubscribe$ = unsubscribe$, exports.default = unsubscribe$;
})(unsubscribe2);
var addShortCut = {};
(function(exports) {
  function addShortCut$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.addShortCut$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.shortCut.addShortCut";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.32" }, _a2)), exports.addShortCut$ = addShortCut$, exports.default = addShortCut$;
})(addShortCut);
var closeUnpayOrder = {};
(function(exports) {
  function closeUnpayOrder$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.closeUnpayOrder$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.closeUnpayOrder";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.closeUnpayOrder$ = closeUnpayOrder$, exports.default = closeUnpayOrder$;
})(closeUnpayOrder);
var createOrder = {};
(function(exports) {
  function createOrder$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createOrder$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.createOrder";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.createOrder$ = createOrder$, exports.default = createOrder$;
})(createOrder);
var getPayUrl = {};
(function(exports) {
  function getPayUrl$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPayUrl$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.getPayUrl";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.getPayUrl$ = getPayUrl$, exports.default = getPayUrl$;
})(getPayUrl);
var inquiry = {};
(function(exports) {
  function inquiry$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.inquiry$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.inquiry";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.inquiry$ = inquiry$, exports.default = inquiry$;
})(inquiry);
var call = {};
(function(exports) {
  function call$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.call$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.call";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.call$ = call$, exports.default = call$;
})(call);
var checkBizCall = {};
(function(exports) {
  function checkBizCall$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkBizCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.checkBizCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.checkBizCall$ = checkBizCall$, exports.default = checkBizCall$;
})(checkBizCall);
var quickCallList = {};
(function(exports) {
  function quickCallList$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.quickCallList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.quickCallList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.quickCallList$ = quickCallList$, exports.default = quickCallList$;
})(quickCallList);
var showCallMenu = {};
(function(exports) {
  function showCallMenu$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.showCallMenu$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.showCallMenu";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.showCallMenu$ = showCallMenu$, exports.default = showCallMenu$;
})(showCallMenu);
var checkPassword = {};
(function(exports) {
  function checkPassword$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkPassword$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.user.checkPassword";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.8" }, _a2)), exports.checkPassword$ = checkPassword$, exports.default = checkPassword$;
})(checkPassword);
var get$1 = {};
(function(exports) {
  function get$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.get$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.user.get";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.get$ = get$, exports.default = get$;
})(get$1);
var callComponent = {};
(function(exports) {
  function callComponent$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.callComponent$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.callComponent";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.35" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.35" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.3.35" }, _a2)), exports.callComponent$ = callComponent$, exports.default = callComponent$;
})(callComponent);
var chooseImage = {};
(function(exports) {
  function chooseImage$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.chooseImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.1" }, _a2)), exports.chooseImage$ = chooseImage$, exports.default = chooseImage$;
})(chooseImage);
var chosen = {};
(function(exports) {
  function chosen$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chosen$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.chosen";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.chosen$ = chosen$, exports.default = chosen$;
})(chosen);
var clearWebStoreCache = {};
(function(exports) {
  function clearWebStoreCache$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.clearWebStoreCache$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.clearWebStoreCache";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.clearWebStoreCache$ = clearWebStoreCache$, exports.default = clearWebStoreCache$;
})(clearWebStoreCache);
var closePreviewImage = {};
(function(exports) {
  function closePreviewImage$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.closePreviewImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.closePreviewImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.19" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.17" }, _a2)), exports.closePreviewImage$ = closePreviewImage$, exports.default = closePreviewImage$;
})(closePreviewImage);
var datepicker = {};
(function(exports) {
  function datepicker$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.datepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.datepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.datepicker$ = datepicker$, exports.default = datepicker$;
})(datepicker);
var datetimepicker = {};
(function(exports) {
  function datetimepicker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.datetimepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.datetimepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.datetimepicker$ = datetimepicker$, exports.default = datetimepicker$;
})(datetimepicker);
var decrypt = {};
(function(exports) {
  function decrypt$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.decrypt$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.decrypt";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.1" }, _a2)), exports.decrypt$ = decrypt$, exports.default = decrypt$;
})(decrypt);
var downloadFile = {};
(function(exports) {
  function downloadFile$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.downloadFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.downloadFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.downloadFile$ = downloadFile$, exports.default = downloadFile$;
})(downloadFile);
var encrypt = {};
(function(exports) {
  function encrypt$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.encrypt$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.encrypt";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.1" }, _a2)), exports.encrypt$ = encrypt$, exports.default = encrypt$;
})(encrypt);
var getPerfInfo = {};
(function(exports) {
  function getPerfInfo$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPerfInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.getPerfInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.14" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.14" }, _a2)), exports.getPerfInfo$ = getPerfInfo$, exports.default = getPerfInfo$;
})(getPerfInfo);
var invokeWorkbench = {};
(function(exports) {
  function invokeWorkbench$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.invokeWorkbench$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.invokeWorkbench";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.8" }, _a2)), exports.invokeWorkbench$ = invokeWorkbench$, exports.default = invokeWorkbench$;
})(invokeWorkbench);
var isEnableGPUAcceleration = {};
(function(exports) {
  function isEnableGPUAcceleration$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isEnableGPUAcceleration$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.isEnableGPUAcceleration";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.isEnableGPUAcceleration$ = isEnableGPUAcceleration$, exports.default = isEnableGPUAcceleration$;
})(isEnableGPUAcceleration);
var isLocalFileExist = {};
(function(exports) {
  function isLocalFileExist$(i) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, i);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isLocalFileExist$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.isLocalFileExist";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.isLocalFileExist$ = isLocalFileExist$, exports.default = isLocalFileExist$;
})(isLocalFileExist);
var multiSelect = {};
(function(exports) {
  function multiSelect$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.multiSelect$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.multiSelect";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0.0" }, _a2)), exports.multiSelect$ = multiSelect$, exports.default = multiSelect$;
})(multiSelect);
var open = {};
(function(exports) {
  function open$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.open$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.open";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.open$ = open$, exports.default = open$;
})(open);
var openLink = {};
(function(exports) {
  function openLink$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openLink$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.openLink", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ credible: true, showMenuBar: true });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.openLink$ = openLink$, exports.default = openLink$;
})(openLink);
var openLocalFile = {};
(function(exports) {
  function openLocalFile$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openLocalFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openLocalFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openLocalFile$ = openLocalFile$, exports.default = openLocalFile$;
})(openLocalFile);
var openModal = {};
(function(exports) {
  function openModal$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openModal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openModal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openModal$ = openModal$, exports.default = openModal$;
})(openModal);
var openSlidePanel = {};
(function(exports) {
  function openSlidePanel$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSlidePanel$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openSlidePanel";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openSlidePanel$ = openSlidePanel$, exports.default = openSlidePanel$;
})(openSlidePanel);
var presentWindow = {};
(function(exports) {
  function presentWindow$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.presentWindow$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.presentWindow";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.presentWindow$ = presentWindow$, exports.default = presentWindow$;
})(presentWindow);
var previewImage = {};
(function(exports) {
  function previewImage$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.previewImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.previewImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.previewImage$ = previewImage$, exports.default = previewImage$;
})(previewImage);
var previewVideo = {};
(function(exports) {
  function previewVideo$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.previewVideo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.previewVideo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.33" }, _a2)), exports.previewVideo$ = previewVideo$, exports.default = previewVideo$;
})(previewVideo);
var saveImage = {};
(function(exports) {
  function saveImage$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.saveImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.saveImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.1" }, _a2)), exports.saveImage$ = saveImage$, exports.default = saveImage$;
})(saveImage);
var scan = {};
(function(exports) {
  function scan$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.scan$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.scan", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ type: "qrCode" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.scan$ = scan$, exports.default = scan$;
})(scan);
var scanCard = {};
(function(exports) {
  function scanCard$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.scanCard$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.scanCard";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.scanCard$ = scanCard$, exports.default = scanCard$;
})(scanCard);
var setGPUAcceleration = {};
(function(exports) {
  function setGPUAcceleration$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setGPUAcceleration$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setGPUAcceleration";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.setGPUAcceleration$ = setGPUAcceleration$, exports.default = setGPUAcceleration$;
})(setGPUAcceleration);
var setScreenBrightnessAndKeepOn = {};
(function(exports) {
  function setScreenBrightnessAndKeepOn$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setScreenBrightnessAndKeepOn$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setScreenBrightnessAndKeepOn";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.37" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.3" }, _a2)), exports.setScreenBrightnessAndKeepOn$ = setScreenBrightnessAndKeepOn$, exports.default = setScreenBrightnessAndKeepOn$;
})(setScreenBrightnessAndKeepOn);
var setScreenKeepOn = {};
(function(exports) {
  function setScreenKeepOn$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setScreenKeepOn$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setScreenKeepOn";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.26" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.26" }, _a2)), exports.setScreenKeepOn$ = setScreenKeepOn$, exports.default = setScreenKeepOn$;
})(setScreenKeepOn);
var share = {};
(function(exports) {
  function share$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.share$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.share", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ title: "", buttonName: "\u786E\u5B9A" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.37", paramsDeal }, _a2)), exports.share$ = share$, exports.default = share$;
})(share);
var shareImage = {};
(function(exports) {
  function shareImage$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.shareImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.shareImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.1" }, _a2)), exports.shareImage$ = shareImage$, exports.default = shareImage$;
})(shareImage);
var startDocSign = {};
(function(exports) {
  function startDocSign$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startDocSign$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.startDocSign";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.33" }, _a2)), exports.startDocSign$ = startDocSign$, exports.default = startDocSign$;
})(startDocSign);
var systemShare = {};
(function(exports) {
  function systemShare$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.systemShare$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.systemShare";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.11" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.11" }, _a2)), exports.systemShare$ = systemShare$, exports.default = systemShare$;
})(systemShare);
var timepicker = {};
(function(exports) {
  function timepicker$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.timepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.timepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.timepicker$ = timepicker$, exports.default = timepicker$;
})(timepicker);
var uploadAttachment = {};
(function(exports) {
  function uploadAttachment$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadAttachment$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.uploadAttachment";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2)), exports.uploadAttachment$ = uploadAttachment$, exports.default = uploadAttachment$;
})(uploadAttachment);
var uploadImage = {};
(function(exports) {
  function uploadImage$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadImage$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.uploadImage", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ multiple: false });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.uploadImage$ = uploadImage$, exports.default = uploadImage$;
})(uploadImage);
var uploadImageFromCamera = {};
(function(exports) {
  function uploadImageFromCamera$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadImageFromCamera$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.uploadImageFromCamera";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.uploadImageFromCamera$ = uploadImageFromCamera$, exports.default = uploadImageFromCamera$;
})(uploadImageFromCamera);
var ut = {};
(function(exports) {
  function ut$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.ut$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.ut", utParamsObj2Str = function(a) {
    var e = Object.assign({}, a), t = e.value, d = [];
    if (t && typeof t == "object") {
      for (var r in t)
        t[r] !== void 0 && d.push(r + "=" + t[r]);
      t = d.join(",");
    }
    return e.value = t || "", e;
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.5.0", paramsDeal: utParamsObj2Str }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: function(a) {
    var e = Object.assign({}, a), t = e.value;
    return t && typeof t == "object" && (t = JSON.stringify(t)), e.value = t, e;
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: utParamsObj2Str }, _a2)), exports.ut$ = ut$, exports.default = ut$;
})(ut);
var openBindIDCard = {};
(function(exports) {
  function openBindIDCard$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openBindIDCard$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.verify.openBindIDCard";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2)), exports.openBindIDCard$ = openBindIDCard$, exports.default = openBindIDCard$;
})(openBindIDCard);
var startAuth = {};
(function(exports) {
  function startAuth$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.verify.startAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2)), exports.startAuth$ = startAuth$, exports.default = startAuth$;
})(startAuth);
var requestAuthCode$1 = {};
(function(exports) {
  function requestAuthCode$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "channel.permission.requestAuthCode";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0.0" }, _a2)), exports.requestAuthCode$ = requestAuthCode$, exports.default = requestAuthCode$;
})(requestAuthCode$1);
var clearShake = {};
(function(exports) {
  function clearShake$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.clearShake$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.accelerometer.clearShake";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.clearShake$ = clearShake$, exports.default = clearShake$;
})(clearShake);
var watchShake = {};
(function(exports) {
  function watchShake$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.watchShake$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.accelerometer.watchShake";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: function(a) {
    return apiHelper_1.forceChangeParamsDealFn({ sensitivity: 3.2 })(apiHelper_1.addWatchParamsDeal(a));
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.watchShake$ = watchShake$, exports.default = watchShake$;
})(watchShake);
var download = {};
(function(exports) {
  function download$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.download$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.download";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.download$ = download$, exports.default = download$;
})(download);
var onPlayEnd = {};
(function(exports) {
  function onPlayEnd$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.onPlayEnd$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.onPlayEnd";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.onPlayEnd$ = onPlayEnd$, exports.default = onPlayEnd$;
})(onPlayEnd);
var onRecordEnd = {};
(function(exports) {
  function onRecordEnd$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.onRecordEnd$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.onRecordEnd";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.onRecordEnd$ = onRecordEnd$, exports.default = onRecordEnd$;
})(onRecordEnd);
var pause$1 = {};
(function(exports) {
  function pause$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pause$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.pause";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.pause$ = pause$, exports.default = pause$;
})(pause$1);
var play = {};
(function(exports) {
  function play$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.play$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.play";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.play$ = play$, exports.default = play$;
})(play);
var resume$1 = {};
(function(exports) {
  function resume$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resume$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.resume";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.resume$ = resume$, exports.default = resume$;
})(resume$1);
var startRecord = {};
(function(exports) {
  function startRecord$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startRecord$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.startRecord";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.startRecord$ = startRecord$, exports.default = startRecord$;
})(startRecord);
var stop$3 = {};
(function(exports) {
  function stop$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$3);
var stopRecord = {};
(function(exports) {
  function stopRecord$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopRecord$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.stopRecord";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.stopRecord$ = stopRecord$, exports.default = stopRecord$;
})(stopRecord);
var translateVoice = {};
(function(exports) {
  function translateVoice$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.translateVoice$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.translateVoice";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.translateVoice$ = translateVoice$, exports.default = translateVoice$;
})(translateVoice);
var getInterface = {};
(function(exports) {
  function getInterface$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getInterface$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getInterface";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.getInterface$ = getInterface$, exports.default = getInterface$;
})(getInterface);
var getPhoneInfo = {};
(function(exports) {
  function getPhoneInfo$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPhoneInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getPhoneInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0" }, _a2)), exports.getPhoneInfo$ = getPhoneInfo$, exports.default = getPhoneInfo$;
})(getPhoneInfo);
var getUUID = {};
(function(exports) {
  function getUUID$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getUUID$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getUUID";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.6" }, _a2)), exports.getUUID$ = getUUID$, exports.default = getUUID$;
})(getUUID);
var getWifiStatus = {};
(function(exports) {
  function getWifiStatus$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getWifiStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getWifiStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.getWifiStatus$ = getWifiStatus$, exports.default = getWifiStatus$;
})(getWifiStatus);
var openSystemSetting = {};
(function(exports) {
  function openSystemSetting$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSystemSetting$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.openSystemSetting";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.27" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2)), exports.openSystemSetting$ = openSystemSetting$, exports.default = openSystemSetting$;
})(openSystemSetting);
var getNetworkType = {};
(function(exports) {
  function getNetworkType$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getNetworkType$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.connection.getNetworkType";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.getNetworkType$ = getNetworkType$, exports.default = getNetworkType$;
})(getNetworkType);
var checkPermission = {};
(function(exports) {
  function checkPermission$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkPermission$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.checkPermission";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.0" }, _a2)), exports.checkPermission$ = checkPermission$, exports.default = checkPermission$;
})(checkPermission);
var get = {};
(function(exports) {
  function get$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.get$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.get";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.get$ = get$, exports.default = get$;
})(get);
var start$1 = {};
(function(exports) {
  function start$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.start$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.start";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.7" }, _a2)), exports.start$ = start$, exports.default = start$;
})(start$1);
var status = {};
(function(exports) {
  function status$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.status$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.status";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.8" }, _a2)), exports.status$ = status$, exports.default = status$;
})(status);
var stop$2 = {};
(function(exports) {
  function stop$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.7" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$2);
var checkInstalledApps = {};
(function(exports) {
  function checkInstalledApps$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkInstalledApps$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.launcher.checkInstalledApps";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.checkInstalledApps$ = checkInstalledApps$, exports.default = checkInstalledApps$;
})(checkInstalledApps);
var launchApp = {};
(function(exports) {
  function launchApp$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.launchApp$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.launcher.launchApp";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.launchApp$ = launchApp$, exports.default = launchApp$;
})(launchApp);
var nfcRead = {};
(function(exports) {
  function nfcRead$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcRead$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcRead";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.nfcRead$ = nfcRead$, exports.default = nfcRead$;
})(nfcRead);
var nfcStop = {};
(function(exports) {
  function nfcStop$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcStop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcStop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.9" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.9" }, _a2)), exports.nfcStop$ = nfcStop$, exports.default = nfcStop$;
})(nfcStop);
var nfcWrite = {};
(function(exports) {
  function nfcWrite$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcWrite$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcWrite";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.nfcWrite$ = nfcWrite$, exports.default = nfcWrite$;
})(nfcWrite);
var actionSheet = {};
(function(exports) {
  function actionSheet$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.actionSheet$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.actionSheet";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.actionSheet$ = actionSheet$, exports.default = actionSheet$;
})(actionSheet);
var alert$1 = {};
(function(exports) {
  function alert$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.alert$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.alert", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ title: "", buttonName: "\u786E\u5B9A" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.alert$ = alert$, exports.default = alert$;
})(alert$1);
var confirm = {};
(function(exports) {
  function confirm$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.confirm$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.confirm", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ title: "", buttonLabels: ["\u786E\u5B9A", "\u53D6\u6D88"] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.confirm$ = confirm$, exports.default = confirm$;
})(confirm);
var extendModal = {};
(function(exports) {
  function extendModal$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.extendModal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.extendModal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.5.0" }, _a2)), exports.extendModal$ = extendModal$, exports.default = extendModal$;
})(extendModal);
var hidePreloader = {};
(function(exports) {
  function hidePreloader$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.hidePreloader$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.hidePreloader";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.hidePreloader$ = hidePreloader$, exports.default = hidePreloader$;
})(hidePreloader);
var modal = {};
(function(exports) {
  function modal$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.modal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.modal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.2.5" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.modal$ = modal$, exports.default = modal$;
})(modal);
var prompt = {};
(function(exports) {
  function prompt$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.prompt$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.prompt", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ title: "", buttonLabels: ["\u786E\u5B9A", "\u53D6\u6D88"] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.prompt$ = prompt$, exports.default = prompt$;
})(prompt);
var showPreloader = {};
(function(exports) {
  function showPreloader$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.showPreloader$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.showPreloader", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ text: "\u52A0\u8F7D\u4E2D...", showIcon: true });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.showPreloader$ = showPreloader$, exports.default = showPreloader$;
})(showPreloader);
var toast = {};
(function(exports) {
  function toast$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toast$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.toast", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ text: "toast", duration: 3, delay: 0 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0", paramsDeal: function(a) {
    return a.icon && !a.type && (a.icon === "success" ? a.type = "success" : a.icon === "error" && (a.type = "error")), a;
  } }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.toast$ = toast$, exports.default = toast$;
})(toast);
var vibrate = {};
(function(exports) {
  function vibrate$(a) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.vibrate$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.vibrate", paramsDeal = apiHelper_1.genDefaultParamsDealFn({ duration: 300 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.vibrate$ = vibrate$, exports.default = vibrate$;
})(vibrate);
var insetAdjust = {};
(function(exports) {
  function insetAdjust$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.insetAdjust$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.insetAdjust";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.18" }, _a2)), exports.insetAdjust$ = insetAdjust$, exports.default = insetAdjust$;
})(insetAdjust);
var resetView = {};
(function(exports) {
  function resetView$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resetView$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.resetView";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.0.0" }, _a2)), exports.resetView$ = resetView$, exports.default = resetView$;
})(resetView);
var rotateView = {};
(function(exports) {
  function rotateView$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.rotateView$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.rotateView";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.0.0" }, _a2)), exports.rotateView$ = rotateView$, exports.default = rotateView$;
})(rotateView);
var keepAlive = {};
(function(exports) {
  function keepAlive$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.keepAlive$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.keepAlive";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.keepAlive$ = keepAlive$, exports.default = keepAlive$;
})(keepAlive);
var pause = {};
(function(exports) {
  function pause$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pause$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.pause";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.pause$ = pause$, exports.default = pause$;
})(pause);
var resume = {};
(function(exports) {
  function resume$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resume$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.resume";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.resume$ = resume$, exports.default = resume$;
})(resume);
var start = {};
(function(exports) {
  function start$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.start$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.start";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.start$ = start$, exports.default = start$;
})(start);
var stop$1 = {};
(function(exports) {
  function stop$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$1);
var loginGovNet = {};
(function(exports) {
  function loginGovNet$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.loginGovNet$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "net.bjGovApn.loginGovNet";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.16" }, _a2)), exports.loginGovNet$ = loginGovNet$, exports.default = loginGovNet$;
})(loginGovNet);
var fetch = {};
(function(exports) {
  function fetch$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.fetch$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.message.fetch";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.fetch$ = fetch$, exports.default = fetch$;
})(fetch);
var post = {};
(function(exports) {
  function post$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.post$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.message.post";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.post$ = post$, exports.default = post$;
})(post);
var getLoadTime = {};
(function(exports) {
  function getLoadTime$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getLoadTime$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.monitor.getLoadTime";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.10" }, _a2)), exports.getLoadTime$ = getLoadTime$, exports.default = getLoadTime$;
})(getLoadTime);
var requestAuthCode = {};
(function(exports) {
  function requestAuthCode$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.permission.requestAuthCode", paramsDeal = function(e) {
    return Object.assign(e, { url: location.href.split("#")[0] });
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.requestAuthCode$ = requestAuthCode$, exports.default = requestAuthCode$;
})(requestAuthCode);
var requestOperateAuthCode = {};
(function(exports) {
  function requestOperateAuthCode$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestOperateAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.permission.requestOperateAuthCode", paramsDeal = function(e) {
    return Object.assign(e, { url: location.href.split("#")[0] });
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.3.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.3.0" }, _a2)), exports.requestOperateAuthCode$ = requestOperateAuthCode$, exports.default = requestOperateAuthCode$;
})(requestOperateAuthCode);
var plain = {};
(function(exports) {
  function plain$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.plain$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.input.plain";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.plain$ = plain$, exports.default = plain$;
})(plain);
var addToFloat = {};
(function(exports) {
  function addToFloat$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.addToFloat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.multitask.addToFloat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.0" }, _a2)), exports.addToFloat$ = addToFloat$, exports.default = addToFloat$;
})(addToFloat);
var removeFromFloat = {};
(function(exports) {
  function removeFromFloat$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.removeFromFloat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.multitask.removeFromFloat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.0" }, _a2)), exports.removeFromFloat$ = removeFromFloat$, exports.default = removeFromFloat$;
})(removeFromFloat);
var close = {};
(function(exports) {
  function close$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.close$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.close";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.close$ = close$, exports.default = close$;
})(close);
var getCurrentId = {};
(function(exports) {
  function getCurrentId$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCurrentId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.getCurrentId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.getCurrentId$ = getCurrentId$, exports.default = getCurrentId$;
})(getCurrentId);
var go = {};
(function(exports) {
  function go$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.go$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.go";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.go$ = go$, exports.default = go$;
})(go);
var preload = {};
(function(exports) {
  function preload$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.preload$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.preload";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.preload$ = preload$, exports.default = preload$;
})(preload);
var recycle = {};
(function(exports) {
  function recycle$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.recycle$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.recycle";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.recycle$ = recycle$, exports.default = recycle$;
})(recycle);
var setColors = {};
(function(exports) {
  function setColors$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setColors$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.progressBar.setColors";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.setColors$ = setColors$, exports.default = setColors$;
})(setColors);
var disable$1 = {};
(function(exports) {
  function disable$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.disable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.pullToRefresh.disable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.disable$ = disable$, exports.default = disable$;
})(disable$1);
var enable$1 = {};
(function(exports) {
  function enable$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.enable$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "ui.pullToRefresh.enable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.enable$ = enable$, exports.default = enable$;
})(enable$1);
var stop = {};
(function(exports) {
  function stop$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.pullToRefresh.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop);
var disable = {};
(function(exports) {
  function disable$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.disable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.webViewBounce.disable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.disable$ = disable$, exports.default = disable$;
})(disable);
var enable = {};
(function(exports) {
  function enable$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.enable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.webViewBounce.enable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.enable$ = enable$, exports.default = enable$;
})(enable);
var getItem = {};
(function(exports) {
  function getItem$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.getItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.29" }, _a2)), exports.getItem$ = getItem$, exports.default = getItem$;
})(getItem);
var removeItem = {};
(function(exports) {
  function removeItem$(e) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.removeItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.removeItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.29" }, _a2)), exports.removeItem$ = removeItem$, exports.default = removeItem$;
})(removeItem);
var setItem = {};
(function(exports) {
  function setItem$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.setItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.9" }, _a2)), exports.setItem$ = setItem$, exports.default = setItem$;
})(setItem);
var getData = {};
(function(exports) {
  function getData$(d) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.openTemporary.getData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.15" }, _a2)), exports.getData$ = getData$, exports.default = getData$;
})(getData);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.apiObj = void 0;
  var beaconPicker_1 = beaconPicker, detectFace_1 = detectFace, detectFaceFullScreen_1 = detectFaceFullScreen, faceManager_1 = faceManager, punchModePicker_1 = punchModePicker, bindAlipay_1 = bindAlipay, openAuth_1 = openAuth, pay_1 = pay, openAccountPwdLoginPage_1 = openAccountPwdLoginPage, requestAuthInfo_1 = requestAuthInfo, chooseDateTime_1 = chooseDateTime, chooseHalfDay_1 = chooseHalfDay, chooseInterval_1 = chooseInterval, chooseOneDay_1 = chooseOneDay, chooseConversationByCorpId_1 = chooseConversationByCorpId, collectSticker_1 = collectSticker, createSceneGroup_1 = createSceneGroup, getRealmCid_1 = getRealmCid, locationChatMessage_1 = locationChatMessage, openSingleChat_1 = openSingleChat, pickConversation_1 = pickConversation, sendEmotion_1 = sendEmotion, toConversation_1 = toConversation, toConversationByOpenConversationId_1 = toConversationByOpenConversationId, setData_1 = setData, createCloudCall_1 = createCloudCall, getCloudCallInfo_1 = getCloudCallInfo, getCloudCallList_1 = getCloudCallList, videoConfCall_1 = videoConfCall, choose_1 = choose$1, chooseMobileContacts_1 = chooseMobileContacts, complexPicker_1 = complexPicker, createGroup_1 = createGroup, departmentsPicker_1 = departmentsPicker, externalComplexPicker_1 = externalComplexPicker, externalEditForm_1 = externalEditForm, rolesPicker_1 = rolesPicker, setRule_1 = setRule, chooseSpaceDir_1 = chooseSpaceDir, delete_1 = _delete, preview_1 = preview, saveFile_1 = saveFile, choose_2 = choose, multipleChoose_1 = multipleChoose, create_1 = create, post_1 = post$1, finishMiniCourseByRecordId_1 = finishMiniCourseByRecordId, getMiniCourseDraftList_1 = getMiniCourseDraftList, joinClassroom_1 = joinClassroom, makeMiniCourse_1 = makeMiniCourse, newMsgNotificationStatus_1 = newMsgNotificationStatus, startAuth_1 = startAuth$1, tokenFaceImg_1 = tokenFaceImg, notifyWeex_1 = notifyWeex, fetchData_1 = fetchData, bind_1 = bind$1, bindMeetingRoom_1 = bindMeetingRoom, getDeviceProperties_1 = getDeviceProperties, invokeThingService_1 = invokeThingService, queryMeetingRoomList_1 = queryMeetingRoomList, setDeviceProperties_1 = setDeviceProperties, unbind_1 = unbind$1, startClassRoom_1 = startClassRoom, startUnifiedLive_1 = startUnifiedLive, locate_1 = locate, search_1 = search, view_1 = view, compressVideo_1 = compressVideo, openApp_1 = openApp, close_1 = close$1, goBack_1 = goBack, hideBar_1 = hideBar, navigateToMiniProgram_1 = navigateToMiniProgram, quit_1 = quit, replace_1 = replace, setIcon_1 = setIcon, setLeft_1 = setLeft, setMenu_1 = setMenu, setRight_1 = setRight, setTitle_1 = setTitle, componentPunchFromPartner_1 = componentPunchFromPartner, startMatchRuleFromPartner_1 = startMatchRuleFromPartner, stopMatchRuleFromPartner_1 = stopMatchRuleFromPartner, getRealtimeTracingStatus_1 = getRealtimeTracingStatus, getUserExclusiveInfo_1 = getUserExclusiveInfo, startRealtimeTracing_1 = startRealtimeTracing, stopRealtimeTracing_1 = stopRealtimeTracing, subscribe_1 = subscribe2, unsubscribe_1 = unsubscribe2, addShortCut_1 = addShortCut, closeUnpayOrder_1 = closeUnpayOrder, createOrder_1 = createOrder, getPayUrl_1 = getPayUrl, inquiry_1 = inquiry, call_1 = call, checkBizCall_1 = checkBizCall, quickCallList_1 = quickCallList, showCallMenu_1 = showCallMenu, checkPassword_1 = checkPassword, get_1 = get$1, callComponent_1 = callComponent, chooseImage_1 = chooseImage, chosen_1 = chosen, clearWebStoreCache_1 = clearWebStoreCache, closePreviewImage_1 = closePreviewImage, datepicker_1 = datepicker, datetimepicker_1 = datetimepicker, decrypt_1 = decrypt, downloadFile_1 = downloadFile, encrypt_1 = encrypt, getPerfInfo_1 = getPerfInfo, invokeWorkbench_1 = invokeWorkbench, isEnableGPUAcceleration_1 = isEnableGPUAcceleration, isLocalFileExist_1 = isLocalFileExist, multiSelect_1 = multiSelect, open_1 = open, openLink_1 = openLink, openLocalFile_1 = openLocalFile, openModal_1 = openModal, openSlidePanel_1 = openSlidePanel, presentWindow_1 = presentWindow, previewImage_1 = previewImage, previewVideo_1 = previewVideo, saveImage_1 = saveImage, scan_1 = scan, scanCard_1 = scanCard, setGPUAcceleration_1 = setGPUAcceleration, setScreenBrightnessAndKeepOn_1 = setScreenBrightnessAndKeepOn, setScreenKeepOn_1 = setScreenKeepOn, share_1 = share, shareImage_1 = shareImage, startDocSign_1 = startDocSign, systemShare_1 = systemShare, timepicker_1 = timepicker, uploadAttachment_1 = uploadAttachment, uploadImage_1 = uploadImage, uploadImageFromCamera_1 = uploadImageFromCamera, ut_1 = ut, openBindIDCard_1 = openBindIDCard, startAuth_2 = startAuth, requestAuthCode_1 = requestAuthCode$1, clearShake_1 = clearShake, watchShake_1 = watchShake, download_1 = download, onPlayEnd_1 = onPlayEnd, onRecordEnd_1 = onRecordEnd, pause_1 = pause$1, play_1 = play, resume_1 = resume$1, startRecord_1 = startRecord, stop_1 = stop$3, stopRecord_1 = stopRecord, translateVoice_1 = translateVoice, getInterface_1 = getInterface, getPhoneInfo_1 = getPhoneInfo, getUUID_1 = getUUID, getWifiStatus_1 = getWifiStatus, openSystemSetting_1 = openSystemSetting, getNetworkType_1 = getNetworkType, checkPermission_1 = checkPermission, get_2 = get, start_1 = start$1, status_1 = status, stop_2 = stop$2, checkInstalledApps_1 = checkInstalledApps, launchApp_1 = launchApp, nfcRead_1 = nfcRead, nfcStop_1 = nfcStop, nfcWrite_1 = nfcWrite, actionSheet_1 = actionSheet, alert_1 = alert$1, confirm_1 = confirm, extendModal_1 = extendModal, hidePreloader_1 = hidePreloader, modal_1 = modal, prompt_1 = prompt, showPreloader_1 = showPreloader, toast_1 = toast, vibrate_1 = vibrate, insetAdjust_1 = insetAdjust, resetView_1 = resetView, rotateView_1 = rotateView, keepAlive_1 = keepAlive, pause_2 = pause, resume_2 = resume, start_2 = start, stop_3 = stop$1, loginGovNet_1 = loginGovNet, fetch_1 = fetch, post_2 = post, getLoadTime_1 = getLoadTime, requestAuthCode_2 = requestAuthCode, requestOperateAuthCode_1 = requestOperateAuthCode, plain_1 = plain, addToFloat_1 = addToFloat, removeFromFloat_1 = removeFromFloat, close_2 = close, getCurrentId_1 = getCurrentId, go_1 = go, preload_1 = preload, recycle_1 = recycle, setColors_1 = setColors, disable_1 = disable$1, enable_1 = enable$1, stop_4 = stop, disable_2 = disable, enable_2 = enable, getItem_1 = getItem, removeItem_1 = removeItem, setItem_1 = setItem, getData_1 = getData;
  exports.apiObj = { biz: { ATMBle: { beaconPicker: beaconPicker_1.beaconPicker$, detectFace: detectFace_1.detectFace$, detectFaceFullScreen: detectFaceFullScreen_1.detectFaceFullScreen$, faceManager: faceManager_1.faceManager$, punchModePicker: punchModePicker_1.punchModePicker$ }, alipay: { bindAlipay: bindAlipay_1.bindAlipay$, openAuth: openAuth_1.openAuth$, pay: pay_1.pay$ }, auth: { openAccountPwdLoginPage: openAccountPwdLoginPage_1.openAccountPwdLoginPage$, requestAuthInfo: requestAuthInfo_1.requestAuthInfo$ }, calendar: { chooseDateTime: chooseDateTime_1.chooseDateTime$, chooseHalfDay: chooseHalfDay_1.chooseHalfDay$, chooseInterval: chooseInterval_1.chooseInterval$, chooseOneDay: chooseOneDay_1.chooseOneDay$ }, chat: { chooseConversationByCorpId: chooseConversationByCorpId_1.chooseConversationByCorpId$, collectSticker: collectSticker_1.collectSticker$, createSceneGroup: createSceneGroup_1.createSceneGroup$, getRealmCid: getRealmCid_1.getRealmCid$, locationChatMessage: locationChatMessage_1.locationChatMessage$, openSingleChat: openSingleChat_1.openSingleChat$, pickConversation: pickConversation_1.pickConversation$, sendEmotion: sendEmotion_1.sendEmotion$, toConversation: toConversation_1.toConversation$, toConversationByOpenConversationId: toConversationByOpenConversationId_1.toConversationByOpenConversationId$ }, clipboardData: { setData: setData_1.setData$ }, conference: { createCloudCall: createCloudCall_1.createCloudCall$, getCloudCallInfo: getCloudCallInfo_1.getCloudCallInfo$, getCloudCallList: getCloudCallList_1.getCloudCallList$, videoConfCall: videoConfCall_1.videoConfCall$ }, contact: { choose: choose_1.choose$, chooseMobileContacts: chooseMobileContacts_1.chooseMobileContacts$, complexPicker: complexPicker_1.complexPicker$, createGroup: createGroup_1.createGroup$, departmentsPicker: departmentsPicker_1.departmentsPicker$, externalComplexPicker: externalComplexPicker_1.externalComplexPicker$, externalEditForm: externalEditForm_1.externalEditForm$, rolesPicker: rolesPicker_1.rolesPicker$, setRule: setRule_1.setRule$ }, cspace: { chooseSpaceDir: chooseSpaceDir_1.chooseSpaceDir$, delete: delete_1.delete$, preview: preview_1.preview$, saveFile: saveFile_1.saveFile$ }, customContact: { choose: choose_2.choose$, multipleChoose: multipleChoose_1.multipleChoose$ }, ding: { create: create_1.create$, post: post_1.post$ }, edu: { finishMiniCourseByRecordId: finishMiniCourseByRecordId_1.finishMiniCourseByRecordId$, getMiniCourseDraftList: getMiniCourseDraftList_1.getMiniCourseDraftList$, joinClassroom: joinClassroom_1.joinClassroom$, makeMiniCourse: makeMiniCourse_1.makeMiniCourse$, newMsgNotificationStatus: newMsgNotificationStatus_1.newMsgNotificationStatus$, startAuth: startAuth_1.startAuth$, tokenFaceImg: tokenFaceImg_1.tokenFaceImg$ }, event: { notifyWeex: notifyWeex_1.notifyWeex$ }, intent: { fetchData: fetchData_1.fetchData$ }, iot: { bind: bind_1.bind$, bindMeetingRoom: bindMeetingRoom_1.bindMeetingRoom$, getDeviceProperties: getDeviceProperties_1.getDeviceProperties$, invokeThingService: invokeThingService_1.invokeThingService$, queryMeetingRoomList: queryMeetingRoomList_1.queryMeetingRoomList$, setDeviceProperties: setDeviceProperties_1.setDeviceProperties$, unbind: unbind_1.unbind$ }, live: { startClassRoom: startClassRoom_1.startClassRoom$, startUnifiedLive: startUnifiedLive_1.startUnifiedLive$ }, map: { locate: locate_1.locate$, search: search_1.search$, view: view_1.view$ }, media: { compressVideo: compressVideo_1.compressVideo$ }, microApp: { openApp: openApp_1.openApp$ }, navigation: { close: close_1.close$, goBack: goBack_1.goBack$, hideBar: hideBar_1.hideBar$, navigateToMiniProgram: navigateToMiniProgram_1.navigateToMiniProgram$, quit: quit_1.quit$, replace: replace_1.replace$, setIcon: setIcon_1.setIcon$, setLeft: setLeft_1.setLeft$, setMenu: setMenu_1.setMenu$, setRight: setRight_1.setRight$, setTitle: setTitle_1.setTitle$ }, pbp: { componentPunchFromPartner: componentPunchFromPartner_1.componentPunchFromPartner$, startMatchRuleFromPartner: startMatchRuleFromPartner_1.startMatchRuleFromPartner$, stopMatchRuleFromPartner: stopMatchRuleFromPartner_1.stopMatchRuleFromPartner$ }, realm: { getRealtimeTracingStatus: getRealtimeTracingStatus_1.getRealtimeTracingStatus$, getUserExclusiveInfo: getUserExclusiveInfo_1.getUserExclusiveInfo$, startRealtimeTracing: startRealtimeTracing_1.startRealtimeTracing$, stopRealtimeTracing: stopRealtimeTracing_1.stopRealtimeTracing$, subscribe: subscribe_1.subscribe$, unsubscribe: unsubscribe_1.unsubscribe$ }, shortCut: { addShortCut: addShortCut_1.addShortCut$ }, store: { closeUnpayOrder: closeUnpayOrder_1.closeUnpayOrder$, createOrder: createOrder_1.createOrder$, getPayUrl: getPayUrl_1.getPayUrl$, inquiry: inquiry_1.inquiry$ }, telephone: { call: call_1.call$, checkBizCall: checkBizCall_1.checkBizCall$, quickCallList: quickCallList_1.quickCallList$, showCallMenu: showCallMenu_1.showCallMenu$ }, user: { checkPassword: checkPassword_1.checkPassword$, get: get_1.get$ }, util: { callComponent: callComponent_1.callComponent$, chooseImage: chooseImage_1.chooseImage$, chosen: chosen_1.chosen$, clearWebStoreCache: clearWebStoreCache_1.clearWebStoreCache$, closePreviewImage: closePreviewImage_1.closePreviewImage$, datepicker: datepicker_1.datepicker$, datetimepicker: datetimepicker_1.datetimepicker$, decrypt: decrypt_1.decrypt$, downloadFile: downloadFile_1.downloadFile$, encrypt: encrypt_1.encrypt$, getPerfInfo: getPerfInfo_1.getPerfInfo$, invokeWorkbench: invokeWorkbench_1.invokeWorkbench$, isEnableGPUAcceleration: isEnableGPUAcceleration_1.isEnableGPUAcceleration$, isLocalFileExist: isLocalFileExist_1.isLocalFileExist$, multiSelect: multiSelect_1.multiSelect$, open: open_1.open$, openLink: openLink_1.openLink$, openLocalFile: openLocalFile_1.openLocalFile$, openModal: openModal_1.openModal$, openSlidePanel: openSlidePanel_1.openSlidePanel$, presentWindow: presentWindow_1.presentWindow$, previewImage: previewImage_1.previewImage$, previewVideo: previewVideo_1.previewVideo$, saveImage: saveImage_1.saveImage$, scan: scan_1.scan$, scanCard: scanCard_1.scanCard$, setGPUAcceleration: setGPUAcceleration_1.setGPUAcceleration$, setScreenBrightnessAndKeepOn: setScreenBrightnessAndKeepOn_1.setScreenBrightnessAndKeepOn$, setScreenKeepOn: setScreenKeepOn_1.setScreenKeepOn$, share: share_1.share$, shareImage: shareImage_1.shareImage$, startDocSign: startDocSign_1.startDocSign$, systemShare: systemShare_1.systemShare$, timepicker: timepicker_1.timepicker$, uploadAttachment: uploadAttachment_1.uploadAttachment$, uploadImage: uploadImage_1.uploadImage$, uploadImageFromCamera: uploadImageFromCamera_1.uploadImageFromCamera$, ut: ut_1.ut$ }, verify: { openBindIDCard: openBindIDCard_1.openBindIDCard$, startAuth: startAuth_2.startAuth$ } }, channel: { permission: { requestAuthCode: requestAuthCode_1.requestAuthCode$ } }, device: { accelerometer: { clearShake: clearShake_1.clearShake$, watchShake: watchShake_1.watchShake$ }, audio: { download: download_1.download$, onPlayEnd: onPlayEnd_1.onPlayEnd$, onRecordEnd: onRecordEnd_1.onRecordEnd$, pause: pause_1.pause$, play: play_1.play$, resume: resume_1.resume$, startRecord: startRecord_1.startRecord$, stop: stop_1.stop$, stopRecord: stopRecord_1.stopRecord$, translateVoice: translateVoice_1.translateVoice$ }, base: { getInterface: getInterface_1.getInterface$, getPhoneInfo: getPhoneInfo_1.getPhoneInfo$, getUUID: getUUID_1.getUUID$, getWifiStatus: getWifiStatus_1.getWifiStatus$, openSystemSetting: openSystemSetting_1.openSystemSetting$ }, connection: { getNetworkType: getNetworkType_1.getNetworkType$ }, geolocation: { checkPermission: checkPermission_1.checkPermission$, get: get_2.get$, start: start_1.start$, status: status_1.status$, stop: stop_2.stop$ }, launcher: { checkInstalledApps: checkInstalledApps_1.checkInstalledApps$, launchApp: launchApp_1.launchApp$ }, nfc: { nfcRead: nfcRead_1.nfcRead$, nfcStop: nfcStop_1.nfcStop$, nfcWrite: nfcWrite_1.nfcWrite$ }, notification: { actionSheet: actionSheet_1.actionSheet$, alert: alert_1.alert$, confirm: confirm_1.confirm$, extendModal: extendModal_1.extendModal$, hidePreloader: hidePreloader_1.hidePreloader$, modal: modal_1.modal$, prompt: prompt_1.prompt$, showPreloader: showPreloader_1.showPreloader$, toast: toast_1.toast$, vibrate: vibrate_1.vibrate$ }, screen: { insetAdjust: insetAdjust_1.insetAdjust$, resetView: resetView_1.resetView$, rotateView: rotateView_1.rotateView$ } }, media: { voiceRecorder: { keepAlive: keepAlive_1.keepAlive$, pause: pause_2.pause$, resume: resume_2.resume$, start: start_2.start$, stop: stop_3.stop$ } }, net: { bjGovApn: { loginGovNet: loginGovNet_1.loginGovNet$ } }, runtime: { message: { fetch: fetch_1.fetch$, post: post_2.post$ }, monitor: { getLoadTime: getLoadTime_1.getLoadTime$ }, permission: { requestAuthCode: requestAuthCode_2.requestAuthCode$, requestOperateAuthCode: requestOperateAuthCode_1.requestOperateAuthCode$ } }, ui: { input: { plain: plain_1.plain$ }, multitask: { addToFloat: addToFloat_1.addToFloat$, removeFromFloat: removeFromFloat_1.removeFromFloat$ }, nav: { close: close_2.close$, getCurrentId: getCurrentId_1.getCurrentId$, go: go_1.go$, preload: preload_1.preload$, recycle: recycle_1.recycle$ }, progressBar: { setColors: setColors_1.setColors$ }, pullToRefresh: { disable: disable_1.disable$, enable: enable_1.enable$, stop: stop_4.stop$ }, webViewBounce: { disable: disable_2.disable$, enable: enable_2.enable$ } }, util: { domainStorage: { getItem: getItem_1.getItem$, removeItem: removeItem_1.removeItem$, setItem: setItem_1.setItem$ }, openTemporary: { getData: getData_1.getData$ } } };
})(apiObj);
var ddWithoutApi = union.exports, apiObj_1 = apiObj, dd$1 = Object.assign(ddWithoutApi, apiObj_1.apiObj);
var dingtalkJsapi = dd$1;
const envs = [
  {
    env: 0,
    LAN_HU_HOST: "https://lanhuapp.com",
    MAIN_ORIGIN: "https://mastergo.com",
    LYH_ORIGIN: "https://lyh.mastergo.com",
    DING_CLIENT_ID: "suitesghrhw6xhswidjzx"
  },
  {
    env: 1,
    LAN_HU_HOST: "https://pre.lanhuapp.com",
    MAIN_ORIGIN: "https://pre.mastergo.com",
    LYH_ORIGIN: "https://lyh-pre.mastergo.com",
    DING_CLIENT_ID: "suitekdyyuv5inpc47llz"
  },
  {
    env: 2,
    LAN_HU_HOST: "https://www-cicd-test.develop.lanhuapp.com",
    MAIN_ORIGIN: "https://dev.mastergo.com",
    LYH_ORIGIN: "https://tongbin.mastergo.com",
    DING_CLIENT_ID: "suitedle9yfyuww1wrffa"
  },
  {
    env: 3,
    LAN_HU_HOST: "https://lanhuapp.com",
    MAIN_ORIGIN: "https://mastergo.com",
    LYH_ORIGIN: "https://tongbin.mastergo.com",
    DING_CLIENT_ID: "suitepck5onjucarcxowr"
  }
];
var configs = envs.find((item) => [item.MAIN_ORIGIN, item.LYH_ORIGIN].includes(window.location.origin)) || envs[0];
function getDingDingToken() {
  if (!platformInfo().isDingDing)
    return;
  const corpId = getUrlValue("corpId");
  if (!corpId)
    return;
  return new Promise((rs, re) => {
    dingtalkJsapi.ready(() => {
      dingtalkJsapi.runtime.permission.requestAuthCode({
        corpId,
        onSuccess(info2) {
          const code = info2.code;
          rs({
            code,
            corpId
          });
        }
      });
      dingtalkJsapi.error(() => {
        re();
      });
    });
  });
}
const dingQuery = {
  response_type: "code",
  scope: "openid",
  state: "DingDingOAuth",
  prompt: "consent",
  client_id: configs.DING_CLIENT_ID
};
function jumpDingOAuth(url) {
  const query = __spreadProps(__spreadValues({}, dingQuery), {
    redirect_uri: window.encodeURIComponent(url)
  });
  const href = "https://login.dingtalk.com/oauth2/auth?" + Object.keys(query).map((key) => `${key}=${query[key]}`).join("&");
  window.location.href = href;
}
function dingOpenWindowWithOAuth() {
  if (!platformInfo().isDingDing)
    return;
  return (url) => new Promise(async (rs, re) => {
    const res = await getDingAuthCode();
    if (!res || !res.data)
      return re();
    const dingAuthCode = res.data.jumpCode;
    if (url.indexOf("?") === -1) {
      url += `?dingAuthCode=${dingAuthCode}`;
    } else {
      url += `&dingAuthCode=${dingAuthCode}`;
    }
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = window.location.origin + url;
    }
    dingtalkJsapi.biz.util.openLink({
      url,
      onSuccess(data2) {
        rs(data2);
      },
      onFail(err) {
        re(err);
      }
    });
  });
}
const getActionPosition = (url) => {
  if (!url)
    return 0;
  if (/mastergo\.com\/community\/plugin/.test(url)) {
    return 5;
  } else if (/mastergo\.com\/community/.test(url)) {
    return 3;
  } else if (/mastergo\.com\/file/.test(url)) {
    return 1;
  } else if (/mastergo\.com/.test(url)) {
    return 2;
  } else if (/lyh(\-\w+)\.mastergo\.com\/tvc/.test(url)) {
    return 20220511;
  } else if (/lyh(\-\w+)\.mastergo\.com/.test(url)) {
    return 20220510;
  }
  return 0;
};
const lanhu = async (genSign = "") => {
  var _a2, _b;
  const formData = await getFormData();
  const fn = sendFormData(formData);
  const data2 = __spreadProps(__spreadValues({
    token: genSign
  }, formData), {
    action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.SOURCE_URL) || "")
  });
  try {
    const res = await lanHuLogin(data2);
    fn(res);
    sensors.track(SensorsType.USER_LOGIN, {
      action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.SOURCE_URL) || ""),
      action_detail: "lanhu"
    });
    return res;
  } catch (err) {
    sensors.track(SensorsType.USER_LOGIN, {
      action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.SOURCE_URL) || ""),
      action_detail: "lanhu",
      action_successed: false,
      action_error: ((_b = (_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code) || "js_err"
    });
    return {};
  }
};
function isValidHttpProtocal(url) {
  const lowerCase = url.toLowerCase();
  return lowerCase.startsWith("http://") || lowerCase.startsWith("https://");
}
function backToFile() {
  const url = getSessionStorageItem(SESSION_KEYS.FILE_URL);
  if (url && isValidHttpProtocal(url)) {
    window.location.href = url;
  }
}
const wechat = async (code = "") => {
  const formData = await getFormData();
  const fn = sendFormData(formData);
  const res = await wechatLogin(__spreadProps(__spreadValues({
    code
  }, formData), {
    action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.FILE_URL) || "")
  }));
  setLocalStorageItem(SESSION_KEYS.WE_CHAT_LOGIN_DONE, "1");
  fn(res);
  return res;
};
const dingDing = async (code) => {
  const data2 = {
    action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.FILE_URL) || "")
  };
  if (code) {
    Object.assign(data2, {
      code,
      oauthType: "web"
    });
  } else {
    const rs = await getDingDingToken();
    if (!rs)
      return;
    Object.assign(data2, rs, {
      oauthType: "app"
    });
  }
  const formData = await getFormData();
  const fn = sendFormData(formData);
  Object.assign(data2, formData);
  const res = await verifyDingDingToken(data2);
  fn && fn(res);
  return res;
};
const normal = () => {
  if (isInIframe())
    return Promise.resolve({});
  return getUserInfo();
};
const loginFirst = async () => {
  var _a2, _b;
  const genSign = getSessionStorageItem(SESSION_KEYS.GEN_SIGN);
  const code = getSessionStorageItem(SESSION_KEYS.WECHAT_CODE);
  const subToken = getSessionStorageItem(SESSION_KEYS.SUB_TOKEN);
  const dingDingOAuthCode = getSessionStorageItem(SESSION_KEYS.DING_DING_OAUTH_CODE);
  const dingAuthCode = getSessionStorageItem(SESSION_KEYS.DING_JUMP_AUTH_CODE);
  let res = {};
  if (dingAuthCode) {
    try {
      res = await verifyDingDingToken({
        code: dingAuthCode,
        oauthType: "jump"
      });
      if (res) {
        startRemoveSession();
        return res;
      }
    } catch {
    }
  }
  res = await dingDing();
  if (res)
    return res;
  if (canUseThiryLogin()) {
    if (genSign) {
      res = await lanhu(genSign);
    } else if (subToken) {
      res = await wechat();
    } else if (dingDingOAuthCode) {
      try {
        res = await dingDing(dingDingOAuthCode);
        sensors.track(SensorsType.USER_LOGIN, {
          action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.SOURCE_URL) || ""),
          action_detail: "dingtalk",
          action_successed: true
        });
      } catch (err) {
        sensors.track(SensorsType.USER_LOGIN, {
          action_position: getActionPosition(getSessionStorageItem(SESSION_KEYS.SOURCE_URL) || ""),
          action_detail: "dingtalk",
          action_successed: false,
          action_error: ((_b = (_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code) || "js_err"
        });
      }
    } else if (code) {
      res = await wechat(code);
    }
    if (res) {
      backToFile();
      removeDrainageData();
      startRemoveSession();
      return res;
    }
  }
  return res;
};
const login = async (isPri = false) => {
  let res = null;
  try {
    if (!isPri) {
      res = await loginFirst();
    }
    if (!res) {
      res = await normal();
    }
  } catch {
  }
  return res;
};
const initWeiXin = () => {
  const headEl = document.querySelector("head");
  const weixin = document.createElement("script");
  weixin.type = "text/javascript";
  weixin.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
  if (headEl) {
    headEl.append(weixin);
  }
};
/*! js-cookie v3.0.1 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source2 = arguments[i];
    for (var key in source2) {
      target[key] = source2[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get2(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set,
    get: get2,
    remove: function(key, attributes) {
      set(key, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
var api = init(defaultConverter, { path: "/" });
const logout = async () => {
  const deviceID = api.get("_mg_cd_uid");
  if (deviceID) {
    await logOut({ deviceID });
  }
};
function addExperimentData(data2) {
  if (typeof data2 === "object") {
    Object.assign(experimentClient, data2);
  }
}
function setExtendTrack(key, value) {
  const extendTrack = getExtendTrackJson();
  extendTrack[key] = value;
  const newExtendInfo = JSON.stringify(extendTrack);
  setSessionStorageItem(SESSION_KEYS.EXTEND_TRACK, newExtendInfo);
}
function getExtendTrack(key) {
  return getExtendTrackJson()[key];
}
function clearExtendTrack() {
  removeSessionStorageItem(SESSION_KEYS.EXTEND_TRACK);
}
function deleteExtendTrack(key) {
  const extendTrack = getExtendTrackJson();
  try {
    delete extendTrack[key];
    setSessionStorageItem(SESSION_KEYS.EXTEND_TRACK, JSON.stringify(extendTrack));
  } catch (e) {
  }
}
function getExtendTrackJson() {
  const extendTrackStr = getSessionStorageItem(SESSION_KEYS.EXTEND_TRACK);
  try {
    return JSON.parse(extendTrackStr || "");
  } catch (e) {
    return {};
  }
}
var index$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setLoginData,
  login,
  initWeiXin,
  logout,
  addExperimentData,
  jumpDingOAuth,
  dingOpenWindowWithOAuth,
  getExtendTrack,
  setExtendTrack,
  clearExtendTrack,
  deleteExtendTrack
}, Symbol.toStringTag, { value: "Module" }));
var index$1 = "";
var index = "";
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "16", "height": "16", "viewBox": "0 0 16 16" } }, [_c("clipPath", { attrs: { "id": "master_svg0_517_0937/517_0500" } }, [_c("rect", { attrs: { "x": "3.2001953125", "y": "0.533447265625", "width": "9.504701614379883", "height": "14.933334350585938", "rx": "0" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { attrs: { "clip-path": "url(#master_svg0_517_0937/517_0500)" } }, [_c("g", [_c("path", { attrs: { "d": "M12.2070653125,7.526027265625C9.8282153125,5.689417265625,7.1460653125,3.256957265625,4.2050453125,0.648331265625C3.9737443125,0.443072165625,3.7684863125,0.524256575625,3.6643253125,0.796913265625C3.0025953125,2.547737265625,3.6444113125,4.100967265625,4.6829553125,4.997057265625C5.724565312499999,5.896217265625,7.2747353125,6.724907265625,8.2229053125,7.164527265625C8.259665312500001,7.181377265625,8.2275053125,7.236517265625,8.1907353125,7.219677265625C6.4475753125,6.452247265625,5.2344053125,5.897747265625,3.5907993125,4.629427265625C3.4131133125,4.4931072656249995,3.2338947125,4.545187265625,3.2124497125,4.813247265625C3.0776533125,6.482887265625,4.1468353125,7.797157265625,5.3416253125,8.241367265625C6.0814753125,8.515557265624999,6.8902553125,8.668737265625,7.6392953125,8.759117265625C7.6775953125,8.763707265625,7.6699353125,8.821917265625,7.6301053125,8.821917265625C6.6635553125,8.824977265625,5.4948053125000005,8.593677265625,4.4853553125,8.204607265625C4.2724453125,8.121887265625,4.1989163125,8.291917265624999,4.2326153125,8.426717265625001C4.4057053125,9.132867265625,5.2788253125,10.214307265625,6.6712153125,10.441007265625C6.9316153125,10.483897265625,7.2088653125,10.488497265625,7.4554853125,10.482367265625C7.5136853125,10.480837265625,7.5290053125,10.512997265625,7.5090953125,10.558947265625Q6.5639853125,12.178047265625,6.522625312500001,12.246947265625C6.4904553125,12.300547265625,6.5103753125,12.343447265625,6.5777753125,12.343447265625C6.6451753125,12.343447265625,7.7679653125,12.343447265625,7.8246453125,12.343447265625C7.8828453125,12.343447265625,7.9180853125,12.380247265625,7.8889753125,12.429247265625C7.8598753125,12.478247265625,6.2239353125,15.191047265625,6.1458053125,15.321247265625C6.0784153125,15.433047265625,6.1580653125,15.520347265625,6.2852053125000005,15.426947265625C6.4123353125,15.333547265625,11.6403053125,11.507147265625,11.7888953125,11.396847265625C11.8578253125,11.346247265625,11.8409753125,11.278847265625,11.7444653125,11.278847265625C11.6479653125,11.278847265625,10.6982653125,11.278847265625,10.6262653125,11.278847265625C10.5527453125,11.278847265625,10.5374253125,11.229847265625,10.5864453125,11.180847265625C10.6369953125,11.131847265625,11.8562853125,9.915607265625,12.2882553125,9.460667265625C12.7401253125,8.985817265625,12.9698953125,8.115767265625,12.2070653125,7.526027265625Z", "fill": "currentColor", "fill-opacity": "1" } })])])])])]);
};
var staticRenderFns$z = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$z = defineComponent({
  name: "DingDingLogoIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    }
  }
});
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(__vue2_script$z, render$z, staticRenderFns$z, false, __vue2_injectStyles$z, null, null, null);
function __vue2_injectStyles$z(context) {
  for (let o2 in __cssModules$z) {
    this[o2] = __cssModules$z[o2];
  }
}
var DingDingLogoIcon = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "20", "height": "20", "viewBox": "0 0 20 20" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_2856_3065" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "20", "height": "20", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_2856_3065/202_353" } }, [_c("rect", { attrs: { "x": "2.142578125", "y": "1.4287109375", "width": "15.584417343139648", "height": "17.142858505249023", "rx": "0" } })])]), _c("g", { attrs: { "clip-path": "url(#master_svg0_2856_3065)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_2856_3065/202_353)" } }, [_c("g", [_c("path", { attrs: { "d": "M17.4295078125,15.71138125C16.5219078125,14.69878125,15.7221078125,13.52848125,15.7199078125,9.23132125C15.7244078125,9.13304125,15.7244078125,9.12847125,15.7244078125,9.02789125C15.7244078125,7.27247125,15.0919078125,5.68389125,14.0675078125,4.52275125C14.1454078125,4.42447125,14.2233078125,4.30561125,14.3035078125,4.17304125C14.3127078125,4.15704125,14.3218078125,4.14104125,14.3310078125,4.12275125C14.4227078125,3.96504125,14.5144078125,3.79132125,14.6014078125,3.60618125C14.6862078125,3.42332125,14.7619078125,3.23361125,14.8260078125,3.0438912499999997C14.8329078125,3.0210412499999997,14.8421078125,2.9958912499999997,14.8490078125,2.97304125C14.8879078125,2.8496112499999997,14.9223078125,2.72847125,14.9498078125,2.60961125C15.0804078125,2.05190025,15.0552078125,1.57647125,14.7321078125,1.44161385C14.5487078125,1.36389955,14.3287078125,1.58104225,14.0720078125,1.90104225C14.0629078125,1.91247125,14.0537078125,1.92390025,14.0422078125,1.93532825C14.0308078125,1.94904225,14.0193078125,1.9627572500000001,14.0079078125,1.9787572500000001C13.8406078125,2.19361425,13.6549078125,2.44504125,13.4532078125,2.67590125C13.4372078125,2.6941812499999997,13.4234078125,2.7101812499999998,13.4074078125,2.72847125C13.3982078125,2.73761125,13.3891078125,2.7490412500000003,13.3799078125,2.75818125C13.1599078125,3.00504125,12.9192078125,3.22218125,12.6603078125,3.3501812500000003C11.8535478125,2.8724712500000003,10.9322378125,2.60276125,9.9536378125,2.60276125C8.9498078125,2.60276125,8.007867812499999,2.8884712500000003,7.1851078125,3.38904125C6.8940378125,3.2701812500000003,6.6258978125,3.03247125,6.3829678125,2.76047125C6.3737978125,2.75133125,6.3646378125,2.73990125,6.3554678125,2.73076125C6.3394178125,2.71247125,6.3256678125,2.69647125,6.3096178125,2.6781812499999997C6.1079478125,2.44504125,5.9223078125,2.19361425,5.755007812500001,1.98104225C5.7435478125,1.96504225,5.7320978125,1.95132825,5.7206178125000005,1.93761425C5.7114678125000005,1.92390025,5.7000078125,1.91475725,5.6908378125,1.90332825C5.4341478125,1.58332825,5.2118378125,1.36618525,5.0307978124999995,1.44389955C4.7076378125,1.57875725,4.684717812500001,2.05647125,4.8130678125,2.61190125C4.8405678125,2.72847125,4.8749478125,2.85190125,4.9139078125,2.97532125C4.9207778125,2.99818125,4.9299478125,3.02332125,4.9368178125,3.04618125C5.0009978125,3.23589125,5.0789178125,3.42561125,5.1614178125,3.60847125C5.246217812499999,3.79361125,5.3378978125,3.96732125,5.4318478125,4.125041250000001C5.4410178125,4.14104125,5.4501978125,4.15704125,5.4593678125,4.17532125C5.5624978125,4.3467512500000005,5.6656178125,4.49532125,5.7641778125,4.60961125C4.7832678125,5.76161125,4.1805178125,7.31589125,4.1805178125,9.02789125C4.1805178125,9.16504125,4.1736378125,9.21305125,4.1805178125,9.34791125C4.1621778124999995,13.55588125,3.3142078125000003,14.70558125,2.4158118125,15.71138125C1.7695168125,16.43138125,2.3195568125,17.94448125,3.6671478125,17.27018125C6.3829678125,15.91018125,7.0155078125,18.43588125,9.9215478125,18.35138125C12.8276078125,18.26678125,13.3822078125,15.91018125,16.182807812500002,17.27018125C17.5326078125,17.92848125,18.0735078125,16.43138125,17.4295078125,15.71138125C17.4295078125,15.71138125,17.4295078125,15.71138125,17.4295078125,15.71138125ZM9.9215478125,12.03588125C8.9200178125,12.03588125,8.0193278125,11.60388125,7.3936678125,10.91818125C6.8436178125,10.31248125,6.5067178125,9.50789125,6.5067178125,8.62561125C6.5067178125,6.74218125,8.0353778125,5.21761125,9.9215478125,5.21761125C11.1545478125,5.21761125,12.2340078125,5.86904125,12.8322078125,6.84504125C12.8344078125,6.84732125,12.8344078125,6.84732125,12.8344078125,6.84961125C13.1530078125,7.36847125,13.3364078125,7.97647125,13.3364078125,8.627891250000001C13.3341078125,10.50904125,11.8077278125,12.03588125,9.9215478125,12.03588125C9.9215478125,12.03588125,9.9215478125,12.03588125,9.9215478125,12.03588125Z", "fill": "#FFFFFF", "fill-opacity": "0.8500000238418579" } })]), _c("g", [_c("path", { attrs: { "d": "M13.065445,8.1329365625C13.065445,9.0860865625,12.290805,9.8586565625,11.337415,9.8586565625C10.384012,9.8586565625,9.609375,9.0860865625,9.609375,8.1329365625C9.609375,7.1797975625,10.384012,6.4072265625,11.337415,6.4072265625C12.293105,6.4072265625,13.065445,7.1797975625,13.065445,8.1329365625C13.065445,8.1329365625,13.065445,8.1329365625,13.065445,8.1329365625Z", "fill": "#FFFFFF", "fill-opacity": "0.8500000238418579" } })])])])]);
};
var staticRenderFns$y = [];
const __vue2_script$y = defineComponent({
  name: "LogoLanhuIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(__vue2_script$y, render$y, staticRenderFns$y, false, __vue2_injectStyles$y, null, null, null);
function __vue2_injectStyles$y(context) {
  for (let o2 in __cssModules$y) {
    this[o2] = __cssModules$y[o2];
  }
}
var LogoLanhuIcon = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "20", "height": "20", "viewBox": "0 0 20 20" } }, [_c("clipPath", { attrs: { "id": "master_svg0_298_0507" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "20", "height": "20", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_298_0507/20_089" } }, [_c("rect", { attrs: { "x": "2.14306640625", "y": "1.428466796875", "width": "15.584417343139648", "height": "17.142858505249023", "rx": "0" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_298_0507)" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg1_298_0507/20_089)" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M17.42999609375,15.71138125C16.52239609375,14.69878125,15.72259609375,13.52848125,15.72039609375,9.23132125C15.72489609375,9.13304125,15.72489609375,9.12847125,15.72489609375,9.02789125C15.72489609375,7.27247125,15.09239609375,5.68389125,14.06799609375,4.52275125C14.14589609375,4.42447125,14.22379609375,4.30561125,14.30399609375,4.17304125C14.31319609375,4.15704125,14.32229609375,4.14104125,14.33149609375,4.12275125C14.42319609375,3.96504125,14.51489609375,3.79132125,14.60189609375,3.60618125C14.68669609375,3.42332125,14.76239609375,3.23361125,14.82649609375,3.0438912499999997C14.83339609375,3.0210412499999997,14.84259609375,2.9958912499999997,14.84949609375,2.97304125C14.88839609375,2.8496112499999997,14.92279609375,2.72847125,14.95029609375,2.60961125C15.08089609375,2.05190025,15.05569609375,1.57647125,14.73259609375,1.44161385C14.54919609375,1.36389955,14.32919609375,1.58104225,14.07249609375,1.90104225C14.06339609375,1.91247125,14.05419609375,1.92390025,14.04269609375,1.93532825C14.03129609375,1.94904225,14.01979609375,1.9627572500000001,14.00839609375,1.9787572500000001C13.84109609375,2.19361425,13.65539609375,2.44504125,13.45369609375,2.67590125C13.43769609375,2.6941812499999997,13.42389609375,2.7101812499999998,13.40789609375,2.72847125C13.39869609375,2.73761125,13.38959609375,2.7490412500000003,13.38039609375,2.75818125C13.16039609375,3.00504125,12.91969609375,3.22218125,12.66079609375,3.3501812500000003C11.85403609375,2.8724712500000003,10.93272609375,2.60276125,9.95412609375,2.60276125C8.95029609375,2.60276125,8.008356093749999,2.8884712500000003,7.18559609375,3.38904125C6.89452609375,3.2701812500000003,6.62638609375,3.03247125,6.38345609375,2.76047125C6.37428609375,2.75133125,6.36512609375,2.73990125,6.35595609375,2.73076125C6.33990609375,2.71247125,6.32615609375,2.69647125,6.31010609375,2.6781812499999997C6.10843609375,2.44504125,5.92279609375,2.19361425,5.755496093750001,1.98104225C5.74403609375,1.96504225,5.73258609375,1.95132825,5.7211060937500005,1.93761425C5.7119560937500005,1.92390025,5.70049609375,1.91475725,5.69132609375,1.90332825C5.43463609375,1.58332825,5.21232609375,1.36618525,5.0312860937499995,1.44389955C4.70812609375,1.57875725,4.685206093750001,2.05647125,4.81355609375,2.61190125C4.84105609375,2.72847125,4.87543609375,2.85190125,4.91439609375,2.97532125C4.92126609375,2.99818125,4.93043609375,3.02332125,4.93730609375,3.04618125C5.00148609375,3.23589125,5.07940609375,3.42561125,5.16190609375,3.60847125C5.246706093749999,3.79361125,5.33838609375,3.96732125,5.43233609375,4.125041250000001C5.44150609375,4.14104125,5.45068609375,4.15704125,5.45985609375,4.17532125C5.56298609375,4.3467512500000005,5.66610609375,4.49532125,5.76466609375,4.60961125C4.78375609375,5.76161125,4.18100609375,7.31589125,4.18100609375,9.02789125C4.18100609375,9.16504125,4.17412609375,9.21305125,4.18100609375,9.34791125C4.1626660937499995,13.55588125,3.3146960937500003,14.70558125,2.41630009375,15.71138125C1.77000509375,16.43138125,2.32004509375,17.94448125,3.66763609375,17.27018125C6.38345609375,15.91018125,7.01599609375,18.43588125,9.92203609375,18.35138125C12.82809609375,18.26678125,13.38269609375,15.91018125,16.183296093750002,17.27018125C17.53309609375,17.92848125,18.07399609375,16.43138125,17.42999609375,15.71138125C17.42999609375,15.71138125,17.42999609375,15.71138125,17.42999609375,15.71138125ZM9.92203609375,12.03588125C8.92050609375,12.03588125,8.019806093749999,11.60388125,7.39415609375,10.91818125C6.84410609375,10.31248125,6.50720609375,9.50789125,6.50720609375,8.62561125C6.50720609375,6.74218125,8.03586609375,5.21761125,9.92203609375,5.21761125C11.15503609375,5.21761125,12.23449609375,5.86904125,12.83269609375,6.84504125C12.83489609375,6.84732125,12.83489609375,6.84732125,12.83489609375,6.84961125C13.15349609375,7.36847125,13.33689609375,7.97647125,13.33689609375,8.627891250000001C13.33459609375,10.50904125,11.80820609375,12.03588125,9.92203609375,12.03588125C9.92203609375,12.03588125,9.92203609375,12.03588125,9.92203609375,12.03588125Z", "fill": "#2D78EE", "fill-opacity": "1" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M13.065445,8.13244828125C13.065445,9.08559828125,12.290805,9.85816828125,11.337415,9.85816828125C10.384012,9.85816828125,9.609375,9.08559828125,9.609375,8.13244828125C9.609375,7.17930928125,10.384012,6.40673828125,11.337415,6.40673828125C12.293105,6.40673828125,13.065445,7.17930928125,13.065445,8.13244828125C13.065445,8.13244828125,13.065445,8.13244828125,13.065445,8.13244828125Z", "fill": "#2D3C4D", "fill-opacity": "1" } })])])])])])]);
};
var staticRenderFns$x = [];
const __vue2_script$x = defineComponent({
  name: "LogoLanhuIconLight",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(__vue2_script$x, render$x, staticRenderFns$x, false, __vue2_injectStyles$x, null, null, null);
function __vue2_injectStyles$x(context) {
  for (let o2 in __cssModules$x) {
    this[o2] = __cssModules$x[o2];
  }
}
var LogoLanhuIconLight = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var wechatIcon = "data:image/png;base64,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";
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("div", { staticClass: "login-register-other" }, [!_vm.disableOptions.wechat ? _c("div", { staticClass: "login-register-wechat" }, [_c("button", { staticClass: "normal-btn", on: { "click": _vm.onThirdPartLoginBtnClick } }, [_c("img", { attrs: { "src": wechatIcon, "alt": "" } }), _vm._v(" \u5FAE\u4FE1\u767B\u5F55 ")])]) : _vm._e(), !_vm.disableOptions.dingding ? _c("div", { staticClass: "login-register-ding-ding" }, [_c("button", { staticClass: "normal-btn", on: { "click": _vm.toDingDing } }, [_c("DingDingLogoIcon")], 1)]) : _vm._e(), !_vm.disableOptions.lanhu ? _c("div", { staticClass: "login-register-lanhu" }, [_c("button", { staticClass: "normal-btn", on: { "click": _vm.toLanhu } }, [_vm.themeColor === "dark" ? _c("LogoLanhuIcon") : _c("LogoLanhuIconLight", { attrs: { "size": "18" } })], 1)]) : _vm._e()]), _vm._m(0)]);
};
var staticRenderFns$w = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "or-online" }, [_c("span", [_vm._v("\u6216")])]);
}];
var index_vue_vue_type_style_index_0_scoped_true_lang$3 = "";
const __vue2_script$w = defineComponent({
  name: "ThirdParty",
  components: {
    DingDingLogoIcon,
    LogoLanhuIcon,
    LogoLanhuIconLight
  },
  props: {
    redirectUri: {
      type: String,
      default: ""
    },
    disableOptions: {
      type: Object,
      default: () => ({
        thirdPartLogin: false,
        lanhu: false,
        wechat: false,
        dingding: false
      })
    }
  },
  emits: ["log", "onThirdPartBtnClick"],
  setup(props2, { emit }) {
    const themeColor = ref(getThemeColor());
    const onThirdPartLoginBtnClick = () => {
      emit("onThirdPartBtnClick", ThirdPartType.WEIXIN);
    };
    const toDingDing = () => {
      setSessionStorageItem(SESSION_KEYS.SOURCE_URL, window.location.href);
      emit("log", SensorsType.CLICK_LOGIN_BTN, {
        action_type: "dingding"
      });
      let redirectUri = props2.redirectUri;
      if (["https://", "http://"].every((url) => !redirectUri.startsWith(url))) {
        redirectUri = window.location.origin + "/" + redirectUri;
      }
      jumpDingOAuth(redirectUri);
    };
    const toLanhu = () => {
      setSessionStorageItem(SESSION_KEYS.SOURCE_URL, window.location.href);
      emit("log", SensorsType.CLICK_LOGIN_BTN, {
        action_type: "lanhu"
      });
      window.location.href = configs.LAN_HU_HOST + "/web/#/user/login?uselocal=true&platformName=mastergo";
    };
    return {
      themeColor,
      onThirdPartLoginBtnClick,
      toDingDing,
      toLanhu
    };
  }
});
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(__vue2_script$w, render$w, staticRenderFns$w, false, __vue2_injectStyles$w, "44d4872c", null, null);
function __vue2_injectStyles$w(context) {
  for (let o2 in __cssModules$w) {
    this[o2] = __cssModules$w[o2];
  }
}
var ThirdPartLogin = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { attrs: { "id": "wxLoginCodeContainer" } });
};
var staticRenderFns$v = [];
var authQrCode_vue_vue_type_style_index_0_lang = "";
const __vue2_script$v = defineComponent({
  components: {},
  props: [
    "redirectUri"
  ],
  emits: ["changeState"],
  setup(props2, { emit }) {
    const timer = ref(null);
    onBeforeUnmount(() => {
      clearTimeout(timer.value);
    });
    onMounted(() => {
      timer.value = setTimeout(() => {
        emit("changeState", "retry");
        timer.value = null;
      }, 10 * 60 * 1e3);
      nextTick(() => {
        if (!window.WxLogin) {
          return;
        }
        let state = props2.redirectUri;
        if (["https://", "http://"].every((url) => !state.startsWith(url))) {
          state = window.location.origin + "/" + state;
        }
        const href = getThemeColor() === "dark" ? "https://static.mastergo.com/master-login/1.2.30/wechatIframeDark.css" : "https://static.mastergo.com/master-login/1.2.30/wechatIframeLight.css";
        new window.WxLogin({
          id: "wxLoginCodeContainer",
          appid: "wx030af9b07a55fbde",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("https://mastergo.com/api/v1/wechat/proxy"),
          state: encodeURIComponent(state),
          style: "black",
          href
        });
      });
    });
  }
});
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(__vue2_script$v, render$v, staticRenderFns$v, false, __vue2_injectStyles$v, null, null, null);
function __vue2_injectStyles$v(context) {
  for (let o2 in __cssModules$v) {
    this[o2] = __cssModules$v[o2];
  }
}
var AuthQrCode = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "qrcode-img" }, [_vm.qrCodeUrl ? _c("img", { staticClass: "img", attrs: { "src": _vm.qrCodeUrl, "alt": "" } }) : _vm._e()]);
};
var staticRenderFns$u = [];
var FollowQrCode_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$u = defineComponent({
  components: {},
  props: {
    state: {
      type: String,
      require: true
    }
  },
  emits: ["wechat", "changeState"],
  setup(props2, { emit }) {
    const interval = ref(null);
    const expireQrCodeInt = ref(null);
    const wechatToken = ref("");
    const wechatExpiresIn = ref(0);
    ref("");
    const qrCodeUrl = ref("");
    const init2 = () => {
      initData();
      cleanInterval();
      getTokenAndQrCode();
    };
    const initData = () => {
      wechatToken.value = "";
      emit("changeState", "");
      wechatExpiresIn.value = 0;
    };
    const getTokenAndQrCode = async () => {
      try {
        const res = await getWeChatQrCode();
        const { qrcode: qrcode2, token, expiresIn } = res.data;
        wechatToken.value = token;
        wechatExpiresIn.value = Date.now() + expiresIn * 1e3;
        qrCodeUrl.value = qrcode2;
        interval.value = setInterval(getSubstate, 1e3);
        expireQrCodeInt.value = setInterval(expireQrCode, 1e3);
      } catch {
      }
    };
    const getSubstate = async () => {
      if (!wechatToken.value)
        return;
      try {
        const res = await getWeChatSubState(wechatToken.value);
        const { state: code, token } = res.data;
        if (code === 2 && !props2.state) {
          emit("changeState", "success");
          setSessionStorageItem(SESSION_KEYS.SUB_TOKEN, token);
          cleanInterval();
          emit("wechat");
        }
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data.code === "InvalidWeChatToken") {
          qrCodeExpire();
        }
      }
    };
    const qrCodeExpire = () => {
      emit("changeState", "retry");
      cleanInterval();
    };
    const expireQrCode = () => {
      if (!wechatExpiresIn.value || wechatExpiresIn.value > Date.now())
        return;
      qrCodeExpire();
    };
    const cleanInterval = () => {
      clearInterval(interval.value);
      clearInterval(expireQrCodeInt.value);
    };
    onMounted(() => {
      nextTick(() => {
        init2();
      });
    });
    onBeforeUnmount(() => {
      cleanInterval();
    });
    return {
      qrCodeUrl
    };
  }
});
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(__vue2_script$u, render$u, staticRenderFns$u, false, __vue2_injectStyles$u, "440bf633", null, null);
function __vue2_injectStyles$u(context) {
  for (let o2 in __cssModules$u) {
    this[o2] = __cssModules$u[o2];
  }
}
var FollowQrCode = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var stateSuccessIcon = "data:image/png;base64,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";
var stateRetryIcon = "data:image/png;base64,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";
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "34", "height": "34", "viewBox": "0 0 34 34" } }, [_c("clipPath", { attrs: { "id": "master_svg0_449_1154" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "34", "height": "34", "rx": "0" } })]), _c("g", { attrs: { "clip-path": "url(#master_svg0_449_1154)" } }, [_c("g", [_c("path", { attrs: { "d": "M17.0011541015625,32.78575546875Q17.3886541015625,32.78575546875,17.7757541015625,32.76675546875Q18.1627541015625,32.74775546875,18.5484541015625,32.709755468750004Q18.9340541015625,32.67175546875,19.3174541015625,32.61495546875Q19.7007541015625,32.55805546875,20.0808541015625,32.482455468750004Q20.4608541015625,32.406855468749995,20.8367541015625,32.312655468749995Q21.2126541015625,32.21855546875,21.5835541015625,32.10605546875Q21.9543541015625,31.99355546875,22.3192541015625,31.86305546875Q22.6840541015625,31.73245546875,23.0420541015625,31.58415546875Q23.4001541015625,31.43585546875,23.7504541015625,31.27015546875Q24.1007541015625,31.10445546875,24.4424541015625,30.92185546875Q24.7842541015625,30.73915546875,25.1166541015625,30.53995546875Q25.4490541015625,30.34065546875,25.7712541015625,30.12545546875Q26.0934541015625,29.91015546875,26.4046541015625,29.67925546875Q26.7159541015625,29.44845546875,27.0155541015625,29.20255546875Q27.3150541015625,28.95675546875,27.6022541015625,28.69655546875Q27.8893541015625,28.43625546875,28.1633541015625,28.16225546875Q28.4373541015625,27.88825546875,28.6976541015625,27.60105546875Q28.9578541015625,27.31395546875,29.2036541015625,27.01445546875Q29.4495541015625,26.71485546875,29.6803541015625,26.40355546875Q29.9112541015625,26.09235546875,30.1265541015625,25.77015546875Q30.3417541015625,25.44795546875,30.5410541015625,25.11555546875Q30.7402541015625,24.78315546875,30.9229541015625,24.44135546875Q31.1055541015625,24.09965546875,31.2712541015625,23.74935546875Q31.4369541015625,23.39905546875,31.5852541015625,23.04095546875Q31.7335541015625,22.68295546875,31.8641541015625,22.31815546875Q31.9946541015625,21.95325546875,32.1071541015625,21.58245546875Q32.2196541015625,21.21155546875,32.313754101562495,20.83565546875Q32.407954101562495,20.45975546875,32.483554101562504,20.07975546875Q32.5591541015625,19.69965546875,32.6160541015625,19.31635546875Q32.6728541015625,18.93295546875,32.710854101562504,18.54735546875Q32.7488541015625,18.16165546875,32.7678541015625,17.77465546875Q32.7868541015625,17.38755546875,32.7868541015625,17.00005546875Q32.7868541015625,16.61255546875,32.7678541015625,16.22545546875Q32.7488541015625,15.83845546875,32.710854101562504,15.45275546875Q32.6728541015625,15.06715546875,32.6160541015625,14.68385546875Q32.5591541015625,14.30045546875,32.483554101562504,13.92045546875Q32.407954101562495,13.54035546875,32.313754101562495,13.16445546875Q32.2196541015625,12.78855546875,32.1071541015625,12.41775546875Q31.9946541015625,12.04685546875,31.8641541015625,11.68205546875Q31.7335541015625,11.31715546875,31.5852541015625,10.95913546875Q31.4369541015625,10.60111546875,31.2712541015625,10.25080546875Q31.1055541015625,9.90049546875,30.9229541015625,9.55873546875Q30.7402541015625,9.21697546875,30.5410541015625,8.88458546875Q30.3417541015625,8.55220546875,30.1265541015625,8.229995468750001Q29.9112541015625,7.90778546875,29.6803541015625,7.59652546875Q29.4495541015625,7.28527546875,29.2036541015625,6.98571546875Q28.9578541015625,6.68616546875,28.6976541015625,6.39903546875Q28.4373541015625,6.11189546875,28.1633541015625,5.83788546875Q27.8893541015625,5.56386546875,27.6021541015625,5.30362546875Q27.3150541015625,5.0433854687499995,27.0155541015625,4.79754546875Q26.7159541015625,4.55170546875,26.4046541015625,4.32086546875Q26.0934541015625,4.0900254687499995,25.7712541015625,3.87472546875Q25.4490541015625,3.65943546875,25.1166541015625,3.46021546875Q24.7842541015625,3.26098546875,24.4424541015625,3.07831546875Q24.1007541015625,2.89563546875,23.7504541015625,2.72995546875Q23.4001541015625,2.56426546875,23.0420541015625,2.41597546875Q22.6840541015625,2.2676754687500003,22.3192541015625,2.1371244687499997Q21.9543541015625,2.00657346875,21.5835541015625,1.89408246875Q21.2126541015625,1.78159246875,20.8367541015625,1.68743346875Q20.4608541015625,1.59327446875,20.0808541015625,1.51767346875Q19.7007541015625,1.44207246875,19.3174541015625,1.3852114687500001Q18.9340541015625,1.32835146875,18.5484541015625,1.29036796875Q18.1627541015625,1.25238466875,17.7757541015625,1.23337006875Q17.3886541015625,1.21435546875,17.0011541015625,1.21435546875Q16.6136541015625,1.21435546875,16.2265541015625,1.23337006875Q15.8395541015625,1.25238466875,15.4538541015625,1.29036796875Q15.0682541015625,1.32835146875,14.6849541015625,1.3852114687500001Q14.3015541015625,1.44207246875,13.9215541015625,1.51767346875Q13.5414541015625,1.59327446875,13.1655541015625,1.68743346875Q12.7896541015625,1.78159246875,12.4188541015625,1.89408246875Q12.0479541015625,2.00657346875,11.6831541015625,2.1371244687499997Q11.3182541015625,2.2676754687500003,10.9602341015625,2.41597546875Q10.6022141015625,2.56426546875,10.2519041015625,2.72995546875Q9.9015941015625,2.89563546875,9.5598341015625,3.07831546875Q9.2180741015625,3.26098546875,8.8856841015625,3.46021546875Q8.5533041015625,3.65943546875,8.231094101562501,3.87472546875Q7.9088841015625,4.0900254687499995,7.5976241015625,4.32086546875Q7.2863741015625,4.55170546875,6.9868141015625,4.79754546875Q6.6872641015625,5.0433854687499995,6.4001341015625,5.30362546875Q6.1129941015625,5.56386546875,5.8389841015625,5.83788546875Q5.5649641015625,6.11189546875,5.3047241015625,6.39903546875Q5.0444841015624995,6.68616546875,4.7986441015625,6.98571546875Q4.5528041015625,7.28527546875,4.3219641015625,7.59652546875Q4.0911241015624995,7.90778546875,3.8758241015625,8.229995468750001Q3.6605341015625,8.55220546875,3.4613141015625,8.88458546875Q3.2620841015625,9.21697546875,3.0794141015625,9.55873546875Q2.8967341015625,9.90049546875,2.7310541015625,10.25080546875Q2.5653641015625,10.60111546875,2.4170741015625,10.95913546875Q2.2687741015625003,11.31715546875,2.1382231015624997,11.68205546875Q2.0076721015625,12.04685546875,1.8951811015625,12.41775546875Q1.7826911015625,12.78855546875,1.6885321015625,13.16445546875Q1.5943731015625,13.54035546875,1.5187721015625,13.92045546875Q1.4431711015625,14.30045546875,1.3863101015625001,14.68385546875Q1.3294501015625,15.06715546875,1.2914666015625,15.45275546875Q1.2534833015625,15.83845546875,1.2344687015625,16.22545546875Q1.2154541015625,16.61255546875,1.2154541015625,17.00005546875Q1.2154541015625,17.38755546875,1.2344687015625,17.77465546875Q1.2534833015625,18.16165546875,1.2914666015625,18.54735546875Q1.3294501015625,18.93295546875,1.3863101015625001,19.31635546875Q1.4431711015625,19.69965546875,1.5187721015625,20.07975546875Q1.5943731015625,20.45975546875,1.6885321015625,20.83565546875Q1.7826911015625,21.21155546875,1.8951811015625,21.58245546875Q2.0076721015625,21.95325546875,2.1382231015624997,22.31815546875Q2.2687741015625003,22.68295546875,2.4170741015625,23.04095546875Q2.5653641015625,23.39905546875,2.7310541015625,23.74935546875Q2.8967341015625,24.09965546875,3.0794141015625,24.44135546875Q3.2620841015625,24.78315546875,3.4613141015625,25.11555546875Q3.6605341015625,25.44795546875,3.8758241015625,25.77015546875Q4.0911241015624995,26.09235546875,4.3219641015625,26.40355546875Q4.5528041015625,26.71485546875,4.7986441015625,27.01445546875Q5.0444841015624995,27.31395546875,5.3047241015625,27.60115546875Q5.5649641015625,27.88825546875,5.8389841015625,28.16225546875Q6.1129941015625,28.43625546875,6.4001341015625,28.69655546875Q6.6872641015625,28.95675546875,6.9868141015625,29.20255546875Q7.2863741015625,29.44845546875,7.5976241015625,29.67925546875Q7.9088841015625,29.91015546875,8.231094101562501,30.12545546875Q8.5533041015625,30.34065546875,8.8856841015625,30.53995546875Q9.2180741015625,30.73915546875,9.5598341015625,30.92185546875Q9.9015941015625,31.10445546875,10.2519041015625,31.27015546875Q10.6022141015625,31.43585546875,10.9602341015625,31.58415546875Q11.3182541015625,31.73245546875,11.6831541015625,31.86305546875Q12.0479541015625,31.99355546875,12.4188541015625,32.10605546875Q12.7896541015625,32.21855546875,13.1655541015625,32.312655468749995Q13.5414541015625,32.406855468749995,13.9215541015625,32.482455468750004Q14.3015541015625,32.55805546875,14.6849541015625,32.61495546875Q15.0682541015625,32.67175546875,15.4538541015625,32.709755468750004Q15.8395541015625,32.74775546875,16.2265541015625,32.76675546875Q16.6136541015625,32.78575546875,17.0011541015625,32.78575546875ZM26.9478541015625,13.05375546875C27.2323541015625,12.76915546875,27.2323541015625,12.30785546875,26.9478541015625,12.02335546875L25.4023541015625,10.47782546875C25.1177541015625,10.19330546875,24.6564541015625,10.19329546875,24.3719541015625,10.47782546875L15.6252541015625,19.22445546875L11.5107541015625,15.08495546875C11.2271541015625,14.79955546875,10.7658141015625,14.79815546875,10.4804241015625,15.08175546875L8.930194101562499,16.62255546875C8.6448041015625,16.90625546875,8.6434041015625,17.36755546875,8.9270541015625,17.65295546875L15.1021541015625,23.86575546875C15.3864541015625,24.15175546875,15.8489541015625,24.15245546875,16.134054101562498,23.86735546875L26.9478541015625,13.05375546875Z", "fill-rule": "evenodd", "fill": "#0AC700", "fill-opacity": "1" } })])])]);
};
var staticRenderFns$t = [];
const __vue2_script$t = defineComponent({
  name: "CheckedGreen",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(__vue2_script$t, render$t, staticRenderFns$t, false, __vue2_injectStyles$t, null, null, null);
function __vue2_injectStyles$t(context) {
  for (let o2 in __cssModules$t) {
    this[o2] = __cssModules$t[o2];
  }
}
var CheckedGreen = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "34", "height": "34", "viewBox": "0 0 34 34" } }, [_c("clipPath", { attrs: { "id": "master_svg0_472_1500" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "34", "height": "34", "rx": "0" } })]), _c("g", { attrs: { "clip-path": "url(#master_svg0_472_1500)" } }, [_c("g", [_c("path", { attrs: { "d": "M17.5,34.5Q17.9173,34.5,18.3342,34.4795Q18.751,34.459,19.1663,34.4181Q19.5816,34.3772,19.9944,34.316Q20.4072,34.2548,20.8165,34.1733Q21.2258,34.0919,21.6307,33.9905Q22.0355,33.8891,22.4348,33.768Q22.8342,33.6468,23.2271,33.5062Q23.6201,33.3657,24.0056,33.2059Q24.3912,33.0462,24.7684,32.8678Q25.1457,32.6894,25.5137,32.4927Q25.8818,32.2959,26.2397,32.0814Q26.5977,31.8668,26.9447,31.635Q27.2917,31.4031,27.6269,31.1545Q27.9621,30.9059,28.2847,30.6412Q28.6073,30.3764,28.9165,30.0962Q29.2257,29.8159,29.5208,29.5208Q29.8159,29.2257,30.0962,28.9165Q30.3764,28.6073,30.6412,28.2847Q30.9059,27.9621,31.1545,27.6269Q31.4031,27.2917,31.635,26.9447Q31.8668,26.5977,32.0814,26.2397Q32.2959,25.8818,32.4927,25.5137Q32.6894,25.1457,32.8678,24.7684Q33.0462,24.3912,33.2059,24.0056Q33.3657,23.6201,33.5062,23.2271Q33.6468,22.8342,33.768,22.4348Q33.8891,22.0355,33.9905,21.6307Q34.0919,21.2258,34.1733,20.8165Q34.2548,20.4072,34.316,19.9944Q34.3772,19.5816,34.4181,19.1663Q34.459,18.751,34.4795,18.3342Q34.5,17.9173,34.5,17.5Q34.5,17.0827,34.4795,16.6658Q34.459,16.249000000000002,34.4181,15.8337Q34.3772,15.4184,34.316,15.0056Q34.2548,14.5928,34.1733,14.1835Q34.0919,13.7742,33.9905,13.3693Q33.8891,12.9645,33.768,12.5652Q33.6468,12.1658,33.5062,11.7729Q33.3657,11.3799,33.2059,10.9944Q33.0462,10.6088,32.8678,10.23156Q32.6894,9.8543,32.4927,9.48625Q32.2959,9.11821,32.0814,8.76025Q31.8668,8.4023,31.635,8.05531Q31.4031,7.70831,31.1545,7.37311Q30.9059,7.03791,30.6412,6.71531Q30.3764,6.39272,30.0962,6.0835Q29.8159,5.77428,29.5208,5.47918Q29.2257,5.18409,28.9165,4.90383Q28.6073,4.62357,28.2847,4.35882Q27.9621,4.09407,27.6269,3.84547Q27.2917,3.59687,26.9447,3.36502Q26.5977,3.13316,26.2397,2.91861Q25.8818,2.70406,25.5137,2.50734Q25.1457,2.31061,24.7684,2.13218Q24.3912,1.95375,24.0056,1.79405Q23.6201,1.63434,23.2271,1.493751Q22.8342,1.353158,22.4348,1.232014Q22.0355,1.110871,21.6307,1.009469Q21.2258,0.908067,20.8165,0.82665Q20.4072,0.745234,19.9944,0.683999Q19.5816,0.622765,19.1663,0.5818596Q18.751,0.5409545,18.3342,0.5204772Q17.9173,0.5,17.5,0.5Q17.0827,0.5,16.6658,0.5204772Q16.249000000000002,0.5409545,15.8337,0.5818596Q15.4184,0.622765,15.0056,0.683999Q14.5928,0.745234,14.1835,0.82665Q13.7742,0.908067,13.3693,1.009469Q12.9645,1.110871,12.5652,1.232014Q12.1658,1.353158,11.7729,1.493751Q11.3799,1.63434,10.9944,1.79405Q10.6088,1.95375,10.23156,2.13218Q9.8543,2.31061,9.48625,2.50734Q9.11821,2.70406,8.76025,2.91861Q8.4023,3.13316,8.05531,3.36502Q7.70831,3.59687,7.37311,3.84547Q7.03791,4.09407,6.71531,4.35882Q6.39272,4.62357,6.0835,4.90383Q5.77428,5.18409,5.47918,5.47918Q5.18409,5.77428,4.90383,6.0835Q4.62357,6.39272,4.35882,6.71531Q4.09407,7.03791,3.84547,7.37311Q3.59687,7.70831,3.36502,8.05531Q3.13316,8.4023,2.91861,8.76025Q2.70406,9.11821,2.50734,9.48625Q2.31061,9.8543,2.13218,10.23156Q1.95375,10.6088,1.79405,10.9944Q1.63434,11.3799,1.493751,11.7729Q1.353158,12.1658,1.232014,12.5652Q1.110871,12.9645,1.009469,13.3693Q0.908067,13.7742,0.82665,14.1835Q0.745234,14.5928,0.683999,15.0056Q0.622765,15.4184,0.5818596,15.8337Q0.5409545,16.249000000000002,0.5204772,16.6658Q0.5,17.0827,0.5,17.5Q0.5,17.9173,0.5204772,18.3342Q0.5409545,18.751,0.5818596,19.1663Q0.622765,19.5816,0.683999,19.9944Q0.745234,20.4072,0.82665,20.8165Q0.908067,21.2258,1.009469,21.6307Q1.110871,22.0355,1.232014,22.4348Q1.353158,22.8342,1.493751,23.2271Q1.63434,23.6201,1.79405,24.0056Q1.95375,24.3912,2.13218,24.7684Q2.31061,25.1457,2.50734,25.5137Q2.70406,25.8818,2.91861,26.2397Q3.13316,26.5977,3.36502,26.9447Q3.59687,27.2917,3.84547,27.6269Q4.09407,27.9621,4.35882,28.2847Q4.62357,28.6073,4.90383,28.9165Q5.18409,29.2257,5.47918,29.5208Q5.77428,29.8159,6.0835,30.0962Q6.39272,30.3764,6.71531,30.6412Q7.03791,30.9059,7.37311,31.1545Q7.70831,31.4031,8.05531,31.635Q8.4023,31.8668,8.76025,32.0814Q9.11821,32.2959,9.48625,32.4927Q9.8543,32.6894,10.23156,32.8678Q10.6088,33.0462,10.9944,33.2059Q11.3799,33.3657,11.7729,33.5062Q12.1658,33.6468,12.5652,33.768Q12.9645,33.8891,13.3693,33.9905Q13.7742,34.0919,14.1835,34.1733Q14.5928,34.2548,15.0056,34.316Q15.4184,34.3772,15.8337,34.4181Q16.249000000000002,34.459,16.6658,34.4795Q17.0827,34.5,17.5,34.5ZM17.8329,7.03845C14.7277,7.03845,12.2105,9.80707,12.2105,11.9832L12.2105,12.7428L14.925,12.7428C15.1901,12.7428,15.4133,12.5445,15.4444,12.2813L15.4797,11.9832C15.5548,11.1119,16.5333,10.25532,17.8329,10.25532C19.1325,10.25532,20.186,11.292,20.186,12.5708L20.186,12.7428L23.4552,12.7428L23.4552,12.5708C23.4552,9.51536,20.938,7.03845,17.8329,7.03845ZM20.1864,12.7428C20.1864,13.5061,19.8056,13.8492,18.5502,14.8937C17.3773,15.8695,15.7556,17.309,15.7556,20.1154L19.0248,20.1154C19.0248,18.8259,19.6185,18.2175,20.661,17.3502C20.7319,17.2912,20.8076,17.2294,20.887,17.1647C21.882,16.3535,23.4556,15.0705,23.4556,12.7428L20.1864,12.7428ZM20.1154,25.3461Q20.1154,25.4746,20.1028,25.6025Q20.0902,25.7303,20.0652,25.8563Q20.0401,25.9824,20.0028,26.1053Q19.9655,26.2283,19.9163,26.347Q19.8672,26.4657,19.8066,26.579Q19.746,26.6923,19.6746,26.7991Q19.6033,26.906,19.5217,27.0053Q19.4402,27.1046,19.3494,27.1955Q19.2585,27.2863,19.1592,27.3678Q19.0599,27.4493,18.9531,27.5207Q18.8462,27.5921,18.7329,27.6527Q18.6196,27.7132,18.5009,27.7624Q18.3822,27.8116,18.2592,27.8489Q18.1363,27.8862,18.0103,27.9112Q17.8842,27.9363,17.7564,27.9489Q17.6285,27.9615,17.5,27.9615Q17.3715,27.9615,17.2437,27.9489Q17.1158,27.9363,16.9898,27.9112Q16.8638,27.8862,16.7408,27.8489Q16.6179,27.8116,16.499200000000002,27.7624Q16.380499999999998,27.7132,16.2671,27.6527Q16.1538,27.5921,16.047,27.5207Q15.9402,27.4493,15.8408,27.3678Q15.7415,27.2863,15.6507,27.1955Q15.5598,27.1046,15.4783,27.0053Q15.3968,26.906,15.3254,26.7991Q15.254,26.6923,15.1935,26.579Q15.1329,26.4657,15.0837,26.347Q15.0346,26.2283,14.9973,26.1053Q14.96,25.9824,14.9349,25.8563Q14.9098,25.7303,14.8972,25.6025Q14.8846,25.4746,14.8846,25.3461Q14.8846,25.2176,14.8972,25.0897Q14.9098,24.9619,14.9349,24.8359Q14.96,24.7098,14.9973,24.5869Q15.0346,24.4639,15.0837,24.3452Q15.1329,24.2265,15.1935,24.1132Q15.254,23.9999,15.3254,23.8931Q15.3968,23.7862,15.4783,23.6869Q15.5598,23.5876,15.6507,23.4967Q15.7415,23.4059,15.8408,23.3244Q15.9402,23.2429,16.047,23.1715Q16.1538,23.1001,16.2671,23.0395Q16.380499999999998,22.979,16.499200000000002,22.9298Q16.6179,22.8806,16.7408,22.8433Q16.8638,22.806,16.9898,22.781Q17.1158,22.7559,17.2437,22.7433Q17.3715,22.7307,17.5,22.7307Q17.6285,22.7307,17.7564,22.7433Q17.8842,22.7559,18.0103,22.781Q18.1363,22.806,18.2592,22.8433Q18.3822,22.8806,18.5009,22.9298Q18.6196,22.979,18.7329,23.0395Q18.8462,23.1001,18.9531,23.1715Q19.0599,23.2429,19.1592,23.3244Q19.2585,23.4059,19.3494,23.4967Q19.4402,23.5876,19.5217,23.6869Q19.6033,23.7862,19.6746,23.8931Q19.746,23.9999,19.8066,24.1132Q19.8672,24.2265,19.9163,24.3452Q19.9655,24.4639,20.0028,24.5869Q20.0401,24.7098,20.0652,24.8359Q20.0902,24.9619,20.1028,25.0897Q20.1154,25.2176,20.1154,25.3461Z", "fill-rule": "evenodd", "fill": "#0256FF", "fill-opacity": "1" } })])])]);
};
var staticRenderFns$s = [];
const __vue2_script$s = defineComponent({
  name: "QuestionIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(__vue2_script$s, render$s, staticRenderFns$s, false, __vue2_injectStyles$s, null, null, null);
function __vue2_injectStyles$s(context) {
  for (let o2 in __cssModules$s) {
    this[o2] = __cssModules$s[o2];
  }
}
var QuestionIcon = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, marginTop: "2px", transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "34", "height": "34", "viewBox": "0 0 34 34" } }, [_c("g", [_c("g"), _c("path", { attrs: { "d": "M32.78569443359375,16.9999333984375C32.78569443359375,25.7182333984375,25.71829443359375,32.7856333984375,16.99999443359375,32.7856333984375C8.28180443359375,32.7856333984375,1.21429443359375,25.7182333984375,1.21429443359375,16.9999333984375C1.21429443359375,8.2817433984375,8.28180443359375,1.2142333984375,16.99999443359375,1.2142333984375C25.71829443359375,1.2142333984375,32.78569443359375,8.2817433984375,32.78569443359375,16.9999333984375ZM14.81309443359375,9.7022833984375C14.68369443359375,8.408463398437501,15.69969443359375,7.2857633984375,16.99999443359375,7.2857633984375C18.30029443359375,7.2857633984375,19.31629443359375,8.4084533984375,19.18689443359375,9.7022833984375L18.33509443359375,18.2203333984375C18.26649443359375,18.9063333984375,17.68929443359375,19.4286333984375,16.99999443359375,19.4286333984375C16.31069443359375,19.4286333984375,15.73349443359375,18.9063333984375,15.66489443359375,18.2203333984375L14.81309443359375,9.7022833984375ZM16.99999443359375,26.7107333984375C15.65719443359375,26.7107333984375,14.57139443359375,25.6345333984375,14.57139443359375,24.2822333984375C14.57139443359375,22.9575333984375,15.65719443359375,21.8536333984375,16.99999443359375,21.8536333984375C18.34289443359375,21.8536333984375,19.42859443359375,22.9299333984375,19.42859443359375,24.2822333984375C19.42859443359375,25.6345333984375,18.34289443359375,26.7107333984375,16.99999443359375,26.7107333984375Z", "fill-rule": "evenodd", "fill": "#F4B60C", "fill-opacity": "1" } })])]);
};
var staticRenderFns$r = [];
const __vue2_script$r = defineComponent({
  name: "WarningTipsIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(__vue2_script$r, render$r, staticRenderFns$r, false, __vue2_injectStyles$r, null, null, null);
function __vue2_injectStyles$r(context) {
  for (let o2 in __cssModules$r) {
    this[o2] = __cssModules$r[o2];
  }
}
var WarningTipsIcon = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.loaded ? _c("div", { staticClass: "qrcode", class: !_vm.useFollowCode && "qrcode__no-bottom", style: { width: _vm.width } }, [_c("div", { staticClass: "qrcode-act" }, [_vm.showCode ? _c(_vm.useFollowCode ? "FollowQrCode" : "AuthQrCode", { tag: "component", staticClass: "img", class: "m-img__" + _vm.state, attrs: { "state": _vm.state, "redirectUri": _vm.redirectUri }, on: { "changeState": _vm.changeState, "wechat": _vm.weChat } }) : _vm._e(), !!_vm.state && _vm.useOldTip ? _c("div", { staticClass: "qrcode-display", on: { "click": function($event) {
    $event.stopPropagation();
    return _vm.reloadCode.apply(null, arguments);
  } } }, [_c("img", { staticClass: "img", attrs: { "src": _vm.stateInfo[_vm.state].img, "alt": "" } }), _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.stateInfo[_vm.state].title))]), _c("div", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.stateInfo[_vm.state].desc))])]) : !_vm.useOldTip && _vm.state === "retry" ? _c("div", { staticClass: "qrcode-cover", on: { "click": function($event) {
    $event.stopPropagation();
    return _vm.reloadCode.apply(null, arguments);
  } } }, [_c("img", { staticClass: "img", attrs: { "src": _vm.stateInfo[_vm.state].img, "alt": "" } })]) : _vm._e()], 1), _vm.useOldTip ? _c("div", { staticClass: "qrcode-text" }, [_vm._v(' \u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 "MasterGo \u4EA7\u54C1\u8BBE\u8BA1\u5DE5\u5177" \u5FEB\u901F' + _vm._s(_vm.isLogin ? "\u767B\u5F55" : "\u6CE8\u518C") + " ")]) : _vm.state === "success" ? [_c("div", { staticClass: "qrcode-tip-wrap" }, [_c("div", { staticClass: "qrcode-tip-text" }, [_c("div", { staticClass: "qrcode-tip-icon" }, [_c("CheckedGreen")], 1), _c("span", { staticClass: "qrcode-tip-text-title" }, [_vm._v("\u626B\u7801\u6210\u529F")])])]), _c("div", { staticClass: "qrcode-tip-text-context" }, [_vm._v("\u5FAE\u4FE1\u4E2D\u70B9\u51FB\u5173\u6CE8\u5373\u53EF\u6CE8\u518C\u6210\u529F")])] : _vm.state === "retry" ? [_c("div", { staticClass: "qrcode-tip-wrap" }, [_c("div", { staticClass: "qrcode-tip-text" }, [_c("div", { staticClass: "qrcode-tip-icon" }, [_c("WarningTipsIcon")], 1), _c("span", { staticClass: "qrcode-tip-text-title" }, [_vm._v("\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548")])])]), _c("div", { staticClass: "qrcode-tip-text-context" }, [_vm._v("\u8BF7"), _c("button", { staticClass: "refresh-btn", on: { "click": _vm.reloadCode } }, [_vm._v("\u5237\u65B0")]), _vm._v("\u540E\u518D\u6B21\u5C1D\u8BD5\u6216\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F")])] : _vm.tipUserLogin && _vm.useFollowCode ? [_c("div", { staticClass: "qrcode-tip-wrap" }, [_c("div", { staticClass: "qrcode-tip-text" }, [_c("div", { staticClass: "qrcode-tip-icon" }, [_c("QuestionIcon")], 1), _c("span", { staticClass: "qrcode-tip-text-title" }, [_vm._v("\u626B\u7801\u9047\u5230\u95EE\u9898?")])])]), _c("div", { staticClass: "qrcode-tip-text-context" }, [_vm._v("\u53EF"), _c("button", { staticClass: "refresh-btn", on: { "click": _vm.reloadCode } }, [_vm._v("\u5237\u65B0\u4E8C\u7EF4\u7801")]), _vm._v("\u540E\u518D\u6B21\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8")])] : _vm.useFollowCode ? _c("div", { staticClass: "qrcode-default-text" }, [_vm._v(" " + _vm._s(_vm.useFollowCode ? "\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 MasterGo \u516C\u4F17\u53F7 \u5373\u53EF\u5FEB\u901F" + (_vm.isLogin ? "\u767B\u5F55" : "\u6CE8\u518C") : "") + " ")]) : _vm._e()], 2) : _vm._e();
};
var staticRenderFns$q = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$2 = "";
const __vue2_script$q = defineComponent({
  name: "WeChatQrCode",
  components: {
    AuthQrCode,
    FollowQrCode,
    CheckedGreen,
    QuestionIcon,
    WarningTipsIcon
  },
  props: {
    isLogin: {
      type: Boolean,
      require: true
    },
    width: {
      type: String,
      default: "312px"
    },
    redirectUri: {
      type: String,
      default: ""
    }
  },
  emits: ["log", "wechat"],
  setup(props2, { emit }) {
    ref(null);
    ref(null);
    const state = ref("");
    ref("");
    ref(0);
    ref("");
    const stateInfo = reactive({
      success: {
        title: "\u626B\u7801\u6210\u529F",
        img: stateSuccessIcon,
        desc: "\u8BF7\u5728\u624B\u673A\u4E0A\u64CD\u4F5C"
      },
      retry: {
        title: "\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548",
        img: stateRetryIcon,
        desc: "\u70B9\u51FB\u5237\u65B0"
      }
    });
    const loaded = ref(true);
    const useFollowCode = ref(true);
    const showCode = ref(true);
    const useOldTip = ref(true);
    const tipUserLogin = ref(false);
    const timer = ref(null);
    watch(showCode, (flag) => {
      state.value = "";
      if (useOldTip.value)
        return;
      if (!useFollowCode.value)
        return;
      if (flag) {
        timer.value = setTimeout(() => {
          tipUserLogin.value = true;
          timer.value = null;
        }, 60 * 1e3);
      } else {
        if (timer.value) {
          clearTimeout(timer.value);
          timer.value = null;
        }
      }
    });
    const reloadCode = () => {
      console.log("reload");
      if (state.value === "retry") {
        showCode.value = false;
        nextTick(() => {
          showCode.value = true;
        });
      }
    };
    const changeState = (s) => {
      state.value = s;
    };
    const weChat = (code) => {
      emit("wechat", code);
    };
    onMounted(async () => {
      initWeiXin();
      loaded.value = true;
      nextTick(() => {
        emit("log", SensorsType.CLICK_LOGIN_BTN, {
          action_type: "wechat"
        });
        emit("log", SensorsType.WECHAT_QR_LOAD, {
          action_type: props2.isLogin ? "login" : "register"
        });
      });
    });
    return {
      stateInfo,
      state,
      reloadCode,
      loaded,
      changeState,
      weChat,
      showCode,
      useFollowCode,
      tipUserLogin,
      useOldTip
    };
  }
});
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(__vue2_script$q, render$q, staticRenderFns$q, false, __vue2_injectStyles$q, "21040746", null, null);
function __vue2_injectStyles$q(context) {
  for (let o2 in __cssModules$q) {
    this[o2] = __cssModules$q[o2];
  }
}
var WeChatQrCode = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "width": "1em", "height": "1em", "viewBox": "0 0 14 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M3.18711 6.58315L8.94645 1.19991C9.0654 1.08872 9.25133 1.09272 9.3654 1.20892L9.78465 1.63604C9.90272 1.75633 9.89855 1.95026 9.77541 2.06536L4.48531 7.01L9.7741 11.9334C9.89747 12.0483 9.90204 12.2422 9.78421 12.3627L9.36586 12.7907C9.25203 12.9071 9.06611 12.9115 8.94693 12.8005L3.18799 7.43941C3.06809 7.32779 3.00017 7.17318 3 7.01147C2.99983 6.84975 3.06743 6.69501 3.18711 6.58315Z", "fill": "currentcolor" } })]);
};
var staticRenderFns$p = [];
const __vue2_script$p = defineComponent({
  name: "ChevronLeftIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(__vue2_script$p, render$p, staticRenderFns$p, false, __vue2_injectStyles$p, null, null, null);
function __vue2_injectStyles$p(context) {
  for (let o2 in __cssModules$p) {
    this[o2] = __cssModules$p[o2];
  }
}
var ChevronLeftIcon = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "width": "1em", "height": "1em", "viewBox": "0 0 14 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M12 7C12 7.09687 11.9457 7.33736 11.7023 7.69448C11.47 8.03513 11.1123 8.41103 10.6435 8.76185C9.70317 9.46551 8.40887 10 7 10C5.59113 10 4.29683 9.46551 3.35649 8.76185C2.88767 8.41103 2.53 8.03513 2.29774 7.69448C2.05425 7.33736 2 7.09687 2 7C2 6.90313 2.05425 6.66264 2.29774 6.30552C2.53 5.96487 2.88767 5.58897 3.35649 5.23815C4.29683 4.53449 5.59113 4 7 4C8.40887 4 9.70317 4.53449 10.6435 5.23815C11.1123 5.58897 11.47 5.96487 11.7023 6.30552C11.9457 6.66264 12 6.90313 12 7ZM13 7C13 8.5 10.3137 11 7 11C3.68629 11 1 8.5 1 7C1 5.5 3.68629 3 7 3C10.3137 3 13 5.5 13 7ZM5 7C5 8.10891 5.89109 9 7 9C8.10891 9 9 8.10891 9 7C9 5.89109 8.10891 5 7 5C5.89109 5 5 5.89109 5 7Z", "fill": "currentcolor" } })]);
};
var staticRenderFns$o = [];
const __vue2_script$o = defineComponent({
  name: "EyeIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(__vue2_script$o, render$o, staticRenderFns$o, false, __vue2_injectStyles$o, null, null, null);
function __vue2_injectStyles$o(context) {
  for (let o2 in __cssModules$o) {
    this[o2] = __cssModules$o[o2];
  }
}
var EyeIcon = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "width": "1em", "height": "1em", "viewBox": "0 0 14 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M6.99594 7.63334C9.20735 7.63334 11.1002 6.33666 11.9012 5.14847C11.9938 5.01109 12.1753 4.9575 12.3206 5.03717L12.6713 5.22952C12.8166 5.30919 12.8706 5.49174 12.7807 5.6309C12.496 6.07159 12.0995 6.51496 11.615 6.92067L12.8027 8.23973C12.9135 8.36286 12.9036 8.55255 12.7805 8.66341L12.4832 8.93107C12.3601 9.04193 12.1704 9.03199 12.0595 8.90886L10.801 7.51108C10.2768 7.83936 9.68826 8.11805 9.05372 8.3156L9.54834 10.1616C9.59123 10.3216 9.49625 10.4861 9.33621 10.529L8.94984 10.6325C8.7898 10.6754 8.6253 10.5804 8.58242 10.4204L8.08004 8.54546C7.7278 8.60256 7.36556 8.63334 6.99594 8.63334C6.62145 8.63334 6.25455 8.60174 5.89795 8.5432L5.39497 10.4204C5.35208 10.5804 5.18758 10.6754 5.02754 10.6325L4.64117 10.529C4.48113 10.4861 4.38616 10.3216 4.42904 10.1616L4.92478 8.31143C4.2974 8.11478 3.71517 7.83886 3.19601 7.51427L1.94032 8.90886C1.82946 9.03199 1.63977 9.04193 1.51664 8.93107L1.21938 8.66341C1.09625 8.55255 1.08631 8.36286 1.19718 8.23973L2.38144 6.92447C1.89483 6.51774 1.49678 6.07297 1.21115 5.6309C1.12123 5.49174 1.17531 5.30919 1.32058 5.22952L1.67129 5.03717C1.81657 4.9575 1.99808 5.01109 2.0907 5.14847C2.89169 6.33666 4.78452 7.63334 6.99594 7.63334Z", "fill": "currentcolor" } })]);
};
var staticRenderFns$n = [];
const __vue2_script$n = defineComponent({
  name: "EyeSlashIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(__vue2_script$n, render$n, staticRenderFns$n, false, __vue2_injectStyles$n, null, null, null);
function __vue2_injectStyles$n(context) {
  for (let o2 in __cssModules$n) {
    this[o2] = __cssModules$n[o2];
  }
}
var EyeSlashIcon = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "width": "1em", "height": "1em", "viewBox": "0 0 14 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7ZM13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7ZM6.0995 3.99504C6.04623 3.46229 6.46459 3 7 3C7.53541 3 7.95377 3.46229 7.9005 3.99504L7.54975 7.50248C7.52151 7.78492 7.28384 8 7 8C6.71616 8 6.47849 7.78492 6.45025 7.50249L6.0995 3.99504ZM7 10.9985C6.44706 10.9985 6 10.5554 6 9.99854C6 9.45308 6.44706 8.99854 7 8.99854C7.55294 8.99854 8 9.44172 8 9.99854C8 10.5554 7.55294 10.9985 7 10.9985Z", "fill": "currentcolor" } })]);
};
var staticRenderFns$m = [];
const __vue2_script$m = defineComponent({
  name: "WarningIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(__vue2_script$m, render$m, staticRenderFns$m, false, __vue2_injectStyles$m, null, null, null);
function __vue2_injectStyles$m(context) {
  for (let o2 in __cssModules$m) {
    this[o2] = __cssModules$m[o2];
  }
}
var WarningIcon = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "height": "17.59999999999991", "version": "1.1", "width": "17.59999999999991", "viewBox": "0 0 17.59999999999991 17.59999999999991", "fill": "none" } }, [_c("defs"), _c("g", [_c("path", { staticStyle: { "fill-opacity": "1" }, attrs: { "d": "M13.446444375000182,3.4464466154999545L8.800004375000182,8.092894374999954L4.153553375000182,3.4464466154999545L3.446446615500182,4.153553374999954L8.092894375000181,8.800004374999954L3.4464462280001817,13.446444374999954L4.153553375000182,14.153584374999955L8.800004375000182,9.507104374999955L13.446444375000182,14.153584374999955L14.153584375000182,13.446444374999954L9.507104375000182,8.800004374999954L14.153584375000182,4.153553374999954L13.446444375000182,3.4464466154999545Z", "fill": "currentcolor" } })])]);
};
var staticRenderFns$l = [];
const __vue2_script$l = defineComponent({
  name: "WindowsCloseIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(__vue2_script$l, render$l, staticRenderFns$l, false, __vue2_injectStyles$l, null, null, null);
function __vue2_injectStyles$l(context) {
  for (let o2 in __cssModules$l) {
    this[o2] = __cssModules$l[o2];
  }
}
var WindowsCloseIcon = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "64", "height": "64", "viewBox": "0 0 64 64" } }, [_c("clipPath", { attrs: { "id": "master_svg_0" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "64", "height": "64", "rx": "0" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg_0)" } }, [_c("g", [_c("path", { attrs: { "d": "M73.5914255859375,54.7954984375C73.5914255859375,55.2727984375,73.4048255859375,55.7307984375,73.0728255859375,56.0682984375C72.7407255859375,56.4057984375,72.2900255859375,56.5954984375,71.8204255859375,56.5954984375L57.6522455859375,56.5954984375C57.1826155859375,56.5954984375,56.7319445859375,56.4057984375,56.3998825859375,56.0682984375C56.0678205859375,55.7307984375,55.8812255859375,55.2727984375,55.8812255859375,54.7954984375L55.8812255859375,40.3955984375C55.8812255859375,39.7523984375,56.2188235859375,39.1580984375,56.7667375859375,38.836698437500004C57.3146555859375,38.5152984375,57.9898555859375,38.5152984375,58.5377655859375,38.836698437500004C59.0856655859375,39.1580984375,59.4232755859375,39.7523984375,59.4232755859375,40.3955984375L59.4232755859375,52.9954984375L71.8204255859375,52.9954984375C72.2900255859375,52.9954984375,72.7407255859375,53.1850984375,73.0728255859375,53.5225984375C73.4048255859375,53.8600984375,73.5914255859375,54.3181984375,73.5914255859375,54.7954984375ZM57.6522455859375,27.7956984375C58.1218855859375,27.7956984375,58.5725555859375,27.6060984375,58.9046155859375,27.2685984375C59.2366755859375,26.9310984375,59.4232755859375,26.4730984375,59.4232755859375,25.9956984375L59.4232755859375,13.395868437499999L71.8204255859375,13.395868437499999C72.4533255859375,13.395868437499999,73.0380255859375,13.0527484375,73.3542255859375,12.4958684375C73.6705255859375,11.9389984375,73.6705255859375,11.2527484375,73.3542255859375,10.6958904375C73.0380255859375,10.1390264375,72.4533255859375,9.7958984375,71.8204255859375,9.7958984375L57.6522455859375,9.7958984375C57.1826155859375,9.7958984375,56.7319445859375,9.9855444375,56.3998825859375,10.3230364375C56.0678205859375,10.6605284375,55.8812255859375,11.1185684375,55.8812255859375,11.5958784375L55.8812255859375,25.9956984375C55.8812255859375,26.4730984375,56.0678205859375,26.9310984375,56.3998825859375,27.2685984375C56.7319445859375,27.6060984375,57.1826155859375,27.7956984375,57.6522455859375,27.7956984375ZM96.6148255859375,9.7958984375L82.4466255859375,9.7958984375C81.8137255859375,9.7958984375,81.2290255859375,10.1390164375,80.9128255859375,10.6958904375C80.5965255859375,11.2527684375,80.5965255859375,11.9390084375,80.9128255859375,12.4958684375C81.2290255859375,13.0527384375,81.8137255859375,13.395868437499999,82.4466255859375,13.395868437499999L94.8437255859375,13.395868437499999L94.8437255859375,25.9956984375C94.8437255859375,26.6389984375,95.1813255859375,27.2331984375,95.7292255859375,27.5545984375C96.2772255859375,27.8760984375,96.9524255859375,27.8760984375,97.5003255859375,27.5545984375C98.0482255859375,27.2331984375,98.38582558593751,26.6389984375,98.38582558593751,25.9956984375L98.38582558593751,11.5958784375C98.38582558593751,11.1185684375,98.1992255859375,10.6605284375,97.8671255859375,10.3230364375C97.5351255859375,9.9855444375,97.08442558593751,9.7958984375,96.6148255859375,9.7958984375ZM96.6148255859375,38.5955984375C96.1451255859375,38.5955984375,95.6944255859375,38.7852984375,95.3624255859375,39.122798437499995C95.0303255859375,39.4602984375,94.8437255859375,39.9182984375,94.8437255859375,40.3955984375L94.8437255859375,52.9954984375L82.4466255859375,52.9954984375C81.8137255859375,52.9954984375,81.2290255859375,53.3385984375,80.9128255859375,53.8954984375C80.5965255859375,54.4523984375,80.5965255859375,55.1385984375,80.9128255859375,55.6954984375C81.2290255859375,56.2522984375,81.8137255859375,56.5954984375,82.4466255859375,56.5954984375L96.6148255859375,56.5954984375C97.08442558593751,56.5954984375,97.5351255859375,56.4057984375,97.8671255859375,56.0682984375C98.1992255859375,55.7307984375,98.38582558593751,55.2727984375,98.38582558593751,54.7954984375L98.38582558593751,40.3955984375C98.38582558593751,39.9182984375,98.1992255859375,39.4602984375,97.8671255859375,39.122798437499995C97.5351255859375,38.7852984375,97.08442558593751,38.5955984375,96.6148255859375,38.5955984375ZM80.67552558593749,25.9956984375L80.67552558593749,18.7958184375C80.67552558593749,18.3184984375,80.86212558593749,17.8604584375,81.1942255859375,17.5229684375C81.5263255859375,17.1854784375,81.9769255859375,16.995828437500002,82.4466255859375,16.995828437500002L89.5306255859375,16.995828437500002C90.0003255859375,16.995828437500002,90.4510255859375,17.1854784375,90.78302558593751,17.5229684375C91.1151255859375,17.8604584375,91.3017255859375,18.3184984375,91.3017255859375,18.7958184375L91.3017255859375,25.9956984375C91.3017255859375,26.4730984375,91.1151255859375,26.9310984375,90.78302558593751,27.2685984375C90.4510255859375,27.6060984375,90.0003255859375,27.7956984375,89.5306255859375,27.7956984375L82.4466255859375,27.7956984375C81.9769255859375,27.7956984375,81.5263255859375,27.6060984375,81.1942255859375,27.2685984375C80.86212558593749,26.9310984375,80.67552558593749,26.4730984375,80.67552558593749,25.9956984375ZM84.2176255859375,24.195798437500002L87.7596255859375,24.195798437500002L87.7596255859375,20.5957984375L84.2176255859375,20.5957984375L84.2176255859375,24.195798437500002ZM71.8204255859375,27.7956984375L64.7363455859375,27.7956984375C64.2667155859375,27.7956984375,63.8160355859375,27.6060984375,63.4839755859375,27.2685984375C63.1519155859375,26.9310984375,62.9653255859375,26.4730984375,62.9653255859375,25.9956984375L62.9653255859375,18.7958184375C62.9653255859375,18.3184984375,63.1519155859375,17.8604584375,63.4839755859375,17.5229684375C63.8160355859375,17.1854784375,64.2667155859375,16.995828437500002,64.7363455859375,16.995828437500002L71.8204255859375,16.995828437500002C72.2900255859375,16.995828437500002,72.7407255859375,17.1854784375,73.0728255859375,17.5229684375C73.4048255859375,17.8604584375,73.5914255859375,18.3184984375,73.5914255859375,18.7958184375L73.5914255859375,25.9956984375C73.5914255859375,26.4730984375,73.4048255859375,26.9310984375,73.0728255859375,27.2685984375C72.7407255859375,27.6060984375,72.2900255859375,27.7956984375,71.8204255859375,27.7956984375ZM70.0494255859375,20.5957984375L66.5073255859375,20.5957984375L66.5073255859375,24.195798437500002L70.0494255859375,24.195798437500002L70.0494255859375,20.5957984375ZM73.5914255859375,40.3955984375L73.5914255859375,47.5954984375C73.5914255859375,48.0728984375,73.4048255859375,48.5308984375,73.0728255859375,48.8683984375C72.7407255859375,49.2058984375,72.2900255859375,49.3954984375,71.8204255859375,49.3954984375L64.7363455859375,49.3954984375C64.2667155859375,49.3954984375,63.8160355859375,49.2058984375,63.4839755859375,48.8683984375C63.1519155859375,48.5308984375,62.9653255859375,48.0728984375,62.9653255859375,47.5954984375L62.9653255859375,40.3955984375C62.9653255859375,39.9182984375,63.1519155859375,39.4602984375,63.4839755859375,39.122798437499995C63.8160355859375,38.7852984375,64.2667155859375,38.5955984375,64.7363455859375,38.5955984375L71.8204255859375,38.5955984375C72.2900255859375,38.5955984375,72.7407255859375,38.7852984375,73.0728255859375,39.122798437499995C73.4048255859375,39.4602984375,73.5914255859375,39.9182984375,73.5914255859375,40.3955984375ZM70.0494255859375,42.1955984375L66.5073255859375,42.1955984375L66.5073255859375,45.7955984375L70.0494255859375,45.7955984375L70.0494255859375,42.1955984375ZM84.2176255859375,42.1955984375L84.2176255859375,40.3955984375L85.9886255859375,40.3955984375C86.6215255859375,40.3955984375,87.2062255859375,40.0524984375,87.5224255859375,39.4955984375C87.8387255859375,38.9386984375,87.8387255859375,38.2524984375,87.5224255859375,37.695598437499996C87.2062255859375,37.1387984375,86.6215255859375,36.795598437500004,85.9886255859375,36.795598437500004L82.4466255859375,36.795598437500004C81.9769255859375,36.795598437500004,81.5263255859375,36.9852984375,81.1942255859375,37.3227984375C80.86212558593749,37.6602984375,80.67552558593749,38.1182984375,80.67552558593749,38.5955984375L80.67552558593749,42.1955984375C80.67552558593749,42.8387984375,81.0131255859375,43.4330984375,81.5610255859375,43.7544984375C82.1090255859375,44.0758984375,82.78422558593749,44.0758984375,83.3321255859375,43.7544984375C83.8800255859375,43.4330984375,84.2176255859375,42.8387984375,84.2176255859375,42.1955984375ZM64.7363455859375,31.3956984375C64.1034455859375,31.3956984375,63.5187955859375,31.7387984375,63.2025355859375,32.2956984375C62.8862855859375,32.8525984375,62.8862855859375,33.5387984375,63.2025355859375,34.095698437500005C63.5187955859375,34.6524984375,64.1034655859375,34.995698437499996,64.7363455859375,34.995698437499996L68.2784255859375,34.995698437499996C68.9113255859375,34.995698437499996,69.4959255859375,34.6524984375,69.8122255859375,34.095698437500005C70.12842558593749,33.5387984375,70.12842558593749,32.8525984375,69.8122255859375,32.2956984375C69.4959255859375,31.7387984375,68.9113255859375,31.3956984375,68.2784255859375,31.3956984375L64.7363455859375,31.3956984375ZM80.67552558593749,34.995698437499996C81.3084255859375,34.995698437499996,81.8931255859375,34.6524984375,82.2093255859375,34.095698437500005C82.5256255859375,33.5387984375,82.5256255859375,32.8525984375,82.2093255859375,32.2956984375C81.8931255859375,31.7387984375,81.3084255859375,31.3956984375,80.67552558593749,31.3956984375L78.9045255859375,31.3956984375L78.9045255859375,25.9956984375C78.9045255859375,25.3524984375,78.5669255859375,24.758298437500002,78.0190255859375,24.4368984375C77.4711255859375,24.115398437499998,76.7959255859375,24.115398437499998,76.2480255859375,24.4368984375C75.7001255859375,24.758298437500002,75.3625255859375,25.3524984375,75.3625255859375,25.9956984375L75.3625255859375,31.3956984375L73.5914255859375,31.3956984375C72.95852558593751,31.3956984375,72.3739255859375,31.7387984375,72.0576255859375,32.2956984375C71.7414255859375,32.8525984375,71.7414255859375,33.5387984375,72.0576255859375,34.095698437500005C72.3739255859375,34.6524984375,72.9586255859375,34.995698437499996,73.5914255859375,34.995698437499996L80.67552558593749,34.995698437499996ZM89.5306255859375,31.3956984375L87.7596255859375,31.3956984375C87.12672558593749,31.3956984375,86.5421255859375,31.7387984375,86.2258255859375,32.2956984375C85.9096255859375,32.8525984375,85.9096255859375,33.5387984375,86.2258255859375,34.095698437500005C86.5421255859375,34.6524984375,87.12672558593749,34.995698437499996,87.7596255859375,34.995698437499996L89.5306255859375,34.995698437499996C90.1636255859375,34.995698437499996,90.74822558593749,34.6524984375,91.0645255859375,34.095698437500005C91.3807255859375,33.5387984375,91.3807255859375,32.8525984375,91.0645255859375,32.2956984375C90.74822558593749,31.7387984375,90.16352558593749,31.3956984375,89.5306255859375,31.3956984375ZM77.1335255859375,22.395798437499998C77.6031255859375,22.395798437499998,78.0538255859375,22.2060984375,78.3859255859375,21.868598437499998C78.71792558593751,21.531198437500002,78.9045255859375,21.0730984375,78.9045255859375,20.5957984375L78.9045255859375,18.7958184375C78.9045255859375,18.152558437499998,78.5669255859375,17.5583484375,78.0190255859375,17.236928437499998C77.4711255859375,16.9154984375,76.7959255859375,16.9154984375,76.2480255859375,17.236928437499998C75.7001255859375,17.5583484375,75.3625255859375,18.1525784375,75.3625255859375,18.7958184375L75.3625255859375,20.5957984375C75.3625255859375,21.0730984375,75.5491255859375,21.531198437500002,75.8811255859375,21.868598437499998C76.2132255859375,22.2060984375,76.6639255859375,22.395798437499998,77.1335255859375,22.395798437499998ZM77.1335255859375,36.795598437500004C76.6639255859375,36.795598437500004,76.2132255859375,36.9852984375,75.8811255859375,37.3227984375C75.5491255859375,37.6602984375,75.3625255859375,38.1182984375,75.3625255859375,38.5955984375L75.3625255859375,47.5954984375C75.3625255859375,48.2387984375,75.7001255859375,48.8329984375,76.2480255859375,49.1543984375C76.7959255859375,49.4758984375,77.4711255859375,49.4758984375,78.0190255859375,49.1543984375C78.5669255859375,48.8329984375,78.9045255859375,48.2387984375,78.9045255859375,47.5954984375L78.9045255859375,38.5955984375C78.9045255859375,38.1182984375,78.71792558593751,37.6602984375,78.3859255859375,37.3227984375C78.0538255859375,36.9852984375,77.6031255859375,36.795598437500004,77.1335255859375,36.795598437500004ZM84.2176255859375,49.3954984375L89.5306255859375,49.3954984375C90.0003255859375,49.3954984375,90.4510255859375,49.2058984375,90.78302558593751,48.8683984375C91.1151255859375,48.5308984375,91.3017255859375,48.0728984375,91.3017255859375,47.5954984375L91.3017255859375,42.1955984375C91.3017255859375,41.5522984375,90.9641255859375,40.9580984375,90.4162255859375,40.6366984375C89.8683255859375,40.315298437500005,89.1930255859375,40.315298437500005,88.6451255859375,40.6366984375C88.09722558593751,40.9580984375,87.7596255859375,41.5523984375,87.7596255859375,42.1955984375L87.7596255859375,45.7955984375L84.2176255859375,45.7955984375C83.58472558593749,45.7955984375,83.0000255859375,46.1386984375,82.6838255859375,46.6955984375C82.3675255859375,47.2523984375,82.3675255859375,47.9386984375,82.6838255859375,48.4954984375C83.0000255859375,49.0523984375,83.58472558593749,49.3954984375,84.2176255859375,49.3954984375Z", "transform": "matrix(0,1,-1,0,65.6771240234375,-46.0853271484375)", "fill": "#FFFFFF", "fill-opacity": "1" } })])])]);
};
var staticRenderFns$k = [];
const __vue2_script$k = defineComponent({
  name: "QrCodeIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(__vue2_script$k, render$k, staticRenderFns$k, false, __vue2_injectStyles$k, null, null, null);
function __vue2_injectStyles$k(context) {
  for (let o2 in __cssModules$k) {
    this[o2] = __cssModules$k[o2];
  }
}
var QrCodeIcon = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "64", "height": "64", "viewBox": "0 0 64 64" } }, [_c("clipPath", { attrs: { "id": "master_svg_0" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "64", "height": "64", "rx": "0" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg_0)" } }, [_c("g", [_c("g", [_c("path", { attrs: { "d": "M57.965313671875,15.919676562500001L35.018813671875,15.919676562500001C35.730913671875,10.2787765625,40.576713671875,5.8978765625000005,46.442113671875,5.8978765625000005C51.207413671875,5.8978765625000005,55.084513671875,2.0441265625,55.084513671875,-2.6923334375000003C55.084513671875,-3.4832784375,54.439913671875,-4.1240234375,53.644113671875,-4.1240234375C52.848413671875,-4.1240234375,52.203713671875,-3.4832784375,52.203713671875,-2.6923334375000003C52.203713671875,0.46547656250000014,49.619113671875,3.0344465625000003,46.442113671875,3.0344465625000003C38.986113671875,3.0344465625000003,32.835613671874995,8.6949765625,32.110213671875,15.919676562500001L8.991903671875,15.919676562500001C8.196151671875,15.919676562500001,7.551513671875,16.5604765625,7.551513671875,17.3513765625L7.551513671875,45.9852765625C7.551513671875,46.7762765625,8.196151671875,47.4169765625,8.991903671875,47.4169765625L57.965313671875,47.4169765625C58.761013671875,47.4169765625,59.405713671875,46.7762765625,59.405713671875,45.9852765625L59.405713671875,17.3513765625C59.405713671875,16.5604765625,58.761013671875,15.919676562500001,57.965313671875,15.919676562500001ZM56.524913671875,44.5535765625L10.432303671875001,44.5535765625L10.432303671875001,18.7830765625L56.524913671875,18.7830765625L56.524913671875,44.5535765625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M16.193878893890382,23.078174375C16.193878893890382,23.868734375,15.54883889389038,24.509874375,14.753478893890382,24.509874375C13.95812889389038,24.509874375,13.31308889389038,23.868734375,13.31308889389038,23.078174375C13.31308889389038,22.287628375,13.95812889389038,21.646484375,14.753478893890382,21.646484375C15.54883889389038,21.646484375,16.193878893890382,22.287628375,16.193878893890382,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M24.836243872680665,28.8057134375C24.836243872680665,29.5962734375,24.191203872680664,30.2374134375,23.395843872680665,30.2374134375C22.600493872680666,30.2374134375,21.955453872680664,29.5962734375,21.955453872680664,28.8057134375C21.955453872680664,28.0151674375,22.600493872680666,27.3740234375,23.395843872680665,27.3740234375C24.191203872680664,27.3740234375,24.836243872680665,28.0151674375,24.836243872680665,28.8057134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M21.955456023254396,34.5322759375C21.955456023254396,35.3228359375,21.310416023254394,35.9639759375,20.515056023254395,35.9639759375C19.719706023254396,35.9639759375,19.074666023254395,35.3228359375,19.074666023254395,34.5322759375C19.074666023254395,33.7417299375,19.719706023254396,33.1005859375,20.515056023254395,33.1005859375C21.310416023254394,33.1005859375,21.955456023254396,33.7417299375,21.955456023254396,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M16.193878893890382,34.5322759375C16.193878893890382,35.3228359375,15.54883889389038,35.9639759375,14.753478893890382,35.9639759375C13.95812889389038,35.9639759375,13.31308889389038,35.3228359375,13.31308889389038,34.5322759375C13.31308889389038,33.7417299375,13.95812889389038,33.1005859375,14.753478893890382,33.1005859375C15.54883889389038,33.1005859375,16.193878893890382,33.7417299375,16.193878893890382,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M27.71703267578125,34.5322759375C27.71703267578125,35.3228359375,27.07199267578125,35.9639759375,26.27663267578125,35.9639759375C25.48128267578125,35.9639759375,24.83624267578125,35.3228359375,24.83624267578125,34.5322759375C24.83624267578125,33.7417299375,25.48128267578125,33.1005859375,26.27663267578125,33.1005859375C27.07199267578125,33.1005859375,27.71703267578125,33.7417299375,27.71703267578125,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M33.47861028198242,34.5322759375C33.47861028198242,35.3228359375,32.833570281982425,35.9639759375,32.03821028198242,35.9639759375C31.242860281982423,35.9639759375,30.597820281982422,35.3228359375,30.597820281982422,34.5322759375C30.597820281982422,33.7417299375,31.242860281982423,33.1005859375,32.03821028198242,33.1005859375C32.833570281982425,33.1005859375,33.47861028198242,33.7417299375,33.47861028198242,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M39.24018788818359,34.5322759375C39.24018788818359,35.3228359375,38.5951478881836,35.9639759375,37.799787888183594,35.9639759375C37.004437888183595,35.9639759375,36.359397888183594,35.3228359375,36.359397888183594,34.5322759375C36.359397888183594,33.7417299375,37.004437888183595,33.1005859375,37.799787888183594,33.1005859375C38.5951478881836,33.1005859375,39.24018788818359,33.7417299375,39.24018788818359,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M45.00176930908203,34.5322759375C45.00176930908203,35.3228359375,44.356729309082034,35.9639759375,43.56136930908203,35.9639759375C42.76601930908203,35.9639759375,42.12097930908203,35.3228359375,42.12097930908203,34.5322759375C42.12097930908203,33.7417299375,42.76601930908203,33.1005859375,43.56136930908203,33.1005859375C44.356729309082034,33.1005859375,45.00176930908203,33.7417299375,45.00176930908203,34.5322759375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M30.597821478881837,28.8057134375C30.597821478881837,29.5962734375,29.952781478881835,30.2374134375,29.157421478881837,30.2374134375C28.362071478881838,30.2374134375,27.717031478881836,29.5962734375,27.717031478881836,28.8057134375C27.717031478881836,28.0151674375,28.362071478881838,27.3740234375,29.157421478881837,27.3740234375C29.952781478881835,27.3740234375,30.597821478881837,28.0151674375,30.597821478881837,28.8057134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M36.35939717773437,28.8057134375C36.35939717773437,29.5962734375,35.71435717773438,30.2374134375,34.918997177734376,30.2374134375C34.12364717773438,30.2374134375,33.478607177734375,29.5962734375,33.478607177734375,28.8057134375C33.478607177734375,28.0151674375,34.12364717773438,27.3740234375,34.918997177734376,27.3740234375C35.71435717773438,27.3740234375,36.35939717773437,28.0151674375,36.35939717773437,28.8057134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M42.120974783935544,28.8057134375C42.120974783935544,29.5962734375,41.47593478393555,30.2374134375,40.68057478393555,30.2374134375C39.88522478393555,30.2374134375,39.24018478393555,29.5962734375,39.24018478393555,28.8057134375C39.24018478393555,28.0151674375,39.88522478393555,27.3740234375,40.68057478393555,27.3740234375C41.47593478393555,27.3740234375,42.120974783935544,28.0151674375,42.120974783935544,28.8057134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M47.882552390136716,28.8057134375C47.882552390136716,29.5962734375,47.23751239013672,30.2374134375,46.44215239013672,30.2374134375C45.64680239013672,30.2374134375,45.00176239013672,29.5962734375,45.00176239013672,28.8057134375C45.00176239013672,28.0151674375,45.64680239013672,27.3740234375,46.44215239013672,27.3740234375C47.23751239013672,27.3740234375,47.882552390136716,28.0151674375,47.882552390136716,28.8057134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M24.836243872680665,23.078174375C24.836243872680665,23.868734375,24.191203872680664,24.509874375,23.395843872680665,24.509874375C22.600493872680666,24.509874375,21.955453872680664,23.868734375,21.955453872680664,23.078174375C21.955453872680664,22.287628375,22.600493872680666,21.646484375,23.395843872680665,21.646484375C24.191203872680664,21.646484375,24.836243872680665,22.287628375,24.836243872680665,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M30.597821478881837,23.078174375C30.597821478881837,23.868734375,29.952781478881835,24.509874375,29.157421478881837,24.509874375C28.362071478881838,24.509874375,27.717031478881836,23.868734375,27.717031478881836,23.078174375C27.717031478881836,22.287628375,28.362071478881838,21.646484375,29.157421478881837,21.646484375C29.952781478881835,21.646484375,30.597821478881837,22.287628375,30.597821478881837,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M36.35939717773437,23.078174375C36.35939717773437,23.868734375,35.71435717773438,24.509874375,34.918997177734376,24.509874375C34.12364717773438,24.509874375,33.478607177734375,23.868734375,33.478607177734375,23.078174375C33.478607177734375,22.287628375,34.12364717773438,21.646484375,34.918997177734376,21.646484375C35.71435717773438,21.646484375,36.35939717773437,22.287628375,36.35939717773437,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M42.120974783935544,23.078174375C42.120974783935544,23.868734375,41.47593478393555,24.509874375,40.68057478393555,24.509874375C39.88522478393555,24.509874375,39.24018478393555,23.868734375,39.24018478393555,23.078174375C39.24018478393555,22.287628375,39.88522478393555,21.646484375,40.68057478393555,21.646484375C41.47593478393555,21.646484375,42.120974783935544,22.287628375,42.120974783935544,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M47.882552390136716,23.078174375C47.882552390136716,23.868734375,47.23751239013672,24.509874375,46.44215239013672,24.509874375C45.64680239013672,24.509874375,45.00176239013672,23.868734375,45.00176239013672,23.078174375C45.00176239013672,22.287628375,45.64680239013672,21.646484375,46.44215239013672,21.646484375C47.23751239013672,21.646484375,47.882552390136716,22.287628375,47.882552390136716,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M53.644133811035154,23.078174375C53.644133811035154,23.868734375,52.99909381103516,24.509874375,52.20373381103516,24.509874375C51.408379811035154,24.509874375,50.763343811035156,23.868734375,50.763343811035156,23.078174375C50.763343811035156,22.287628375,51.408379811035154,21.646484375,52.20373381103516,21.646484375C52.99909381103516,21.646484375,53.644133811035154,22.287628375,53.644133811035154,23.078174375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M53.644133811035154,40.25835015625C53.644133811035154,41.04891015625,52.99909381103516,41.69005015625,52.20373381103516,41.69005015625C51.408379811035154,41.69005015625,50.763343811035156,41.04891015625,50.763343811035156,40.25835015625C50.763343811035156,39.46780415625,51.408379811035154,38.82666015625,52.20373381103516,38.82666015625C52.99909381103516,38.82666015625,53.644133811035154,39.46780415625,53.644133811035154,40.25835015625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M47.882552390136716,40.25835015625C47.882552390136716,41.04891015625,47.23751239013672,41.69005015625,46.44215239013672,41.69005015625C45.64680239013672,41.69005015625,45.00176239013672,41.04891015625,45.00176239013672,40.25835015625C45.00176239013672,39.46780415625,45.64680239013672,38.82666015625,46.44215239013672,38.82666015625C47.23751239013672,38.82666015625,47.882552390136716,39.46780415625,47.882552390136716,40.25835015625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M21.955456023254396,40.25835015625C21.955456023254396,41.04891015625,21.310416023254394,41.69005015625,20.515056023254395,41.69005015625C19.719706023254396,41.69005015625,19.074666023254395,41.04891015625,19.074666023254395,40.25835015625C19.074666023254395,39.46780415625,19.719706023254396,38.82666015625,20.515056023254395,38.82666015625C21.310416023254394,38.82666015625,21.955456023254396,39.46780415625,21.955456023254396,40.25835015625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M16.193878893890382,40.25835015625C16.193878893890382,41.04891015625,15.54883889389038,41.69005015625,14.753478893890382,41.69005015625C13.95812889389038,41.69005015625,13.31308889389038,41.04891015625,13.31308889389038,40.25835015625C13.31308889389038,39.46780415625,13.95812889389038,38.82666015625,14.753478893890382,38.82666015625C15.54883889389038,38.82666015625,16.193878893890382,39.46780415625,16.193878893890382,40.25835015625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M40.680542675781254,38.82666015625L26.27663267578125,38.82666015625C25.48088067578125,38.82666015625,24.83624267578125,39.46740415625,24.83624267578125,40.25835015625C24.83624267578125,41.04930015625,25.48088067578125,41.69005015625,26.27663267578125,41.69005015625L40.680542675781254,41.69005015625C41.476342675781254,41.69005015625,42.12094267578125,41.04930015625,42.12094267578125,40.25835015625C42.12094267578125,39.46740415625,41.476342675781254,38.82666015625,40.680542675781254,38.82666015625Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M14.753478893890382,30.2374134375L17.63426889389038,30.2374134375C18.43002889389038,30.2374134375,19.074668893890383,29.5966634375,19.074668893890383,28.8057134375C19.074668893890383,28.0147674375,18.43002889389038,27.3740234375,17.63426889389038,27.3740234375L14.753478893890382,27.3740234375C13.957726893890381,27.3740234375,13.31308889389038,28.0147674375,13.31308889389038,28.8057134375C13.31308889389038,29.5966634375,13.957726893890381,30.2374134375,14.753478893890382,30.2374134375Z", "fill": "#FFFFFF", "fill-opacity": "1" } }), _c("path", { attrs: { "d": "M49.32294310058594,35.9641934375L52.203733100585936,35.9641934375C52.99949310058594,35.9641934375,53.64413310058594,35.3234434375,53.64413310058594,34.5324934375L53.64413310058594,28.8057134375C53.64413310058594,28.0147674375,52.99949310058594,27.3740234375,52.203733100585936,27.3740234375C51.40798310058594,27.3740234375,50.763343100585935,28.0147674375,50.763343100585935,28.8057134375L50.763343100585935,33.1008034375L49.32294310058594,33.1008034375C48.52719110058594,33.1008034375,47.88255310058594,33.7415434375,47.88255310058594,34.5324934375C47.88255310058594,35.3234434375,48.52719110058594,35.9641934375,49.32294310058594,35.9641934375Z", "fill": "#FFFFFF", "fill-opacity": "1" } })])])])]);
};
var staticRenderFns$j = [];
const __vue2_script$j = defineComponent({
  name: "KeyBoardIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(__vue2_script$j, render$j, staticRenderFns$j, false, __vue2_injectStyles$j, null, null, null);
function __vue2_injectStyles$j(context) {
  for (let o2 in __cssModules$j) {
    this[o2] = __cssModules$j[o2];
  }
}
var KeyBoardIcon = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { style: { fontSize: _vm.size, color: _vm.fill, transform: "rotate(" + _vm.rotate + "deg)" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "16", "height": "16", "viewBox": "0 0 16 16" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g")]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M8.000103203125,15.4283890625C12.102833203125,15.4283890625,15.428633203125,12.1025890625,15.428633203125,7.9998590625C15.428633203125,3.8971690625,12.102833203125,0.5712890625,8.000103203125,0.5712890625C3.897413203125,0.5712890625,0.571533203125,3.8971690625,0.571533203125,7.9998590625C0.571533203125,12.1025890625,3.897413203125,15.4283890625,8.000103203125,15.4283890625C8.000103203125,15.4283890625,8.000103203125,15.4283890625,8.000103203125,15.4283890625Z", "fill-rule": "evenodd", "fill": "#E05F42", "fill-opacity": "1" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M8.000002925262452,3.428572177886963C7.388101925262451,3.428572177886963,6.909975325262451,3.956896177886963,6.970861925262451,4.565762177886963L7.371711925262451,8.574262177886963C7.403990925262451,8.897052177886962,7.675605925262452,9.142852177886962,8.000002925262452,9.142852177886962C8.324392925262451,9.142852177886962,8.596012925262452,8.897052177886962,8.62828292526245,8.574262177886963L9.029142925262452,4.565752177886963C9.090022925262451,3.956896177886963,8.61189292526245,3.428572177886963,8.000002925262452,3.428572177886963ZM6.857142925262451,11.426902177886962C6.857142925262451,12.063262177886964,7.368066925262451,12.569762177886963,8.000002925262452,12.569762177886963C8.63193292526245,12.569762177886963,9.142852925262451,12.063262177886964,9.142852925262451,11.426902177886962C9.142852925262451,10.790532177886963,8.63193292526245,10.284042177886963,8.000002925262452,10.284042177886963C7.368066925262451,10.284042177886963,6.857142925262451,10.803522177886963,6.857142925262451,11.426902177886962Z", "fill-rule": "evenodd", "fill": "#FFFFFF", "fill-opacity": "1" } })])])])]);
};
var staticRenderFns$i = [];
const __vue2_script$i = defineComponent({
  name: "ErrorRedBorder",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(__vue2_script$i, render$i, staticRenderFns$i, false, __vue2_injectStyles$i, null, null, null);
function __vue2_injectStyles$i(context) {
  for (let o2 in __cssModules$i) {
    this[o2] = __cssModules$i[o2];
  }
}
var ErrorRedBorderIcon = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.featureLoading, expression: "!featureLoading" }], staticClass: "login-register__wrap" }, [_c("div", { class: _vm.isDialog ? "login-register-container-dialog" : "login-register-container", on: { "mousedown": _vm.closeForModal } }, [_c("div", { class: {
    "login-register-wrap": !_vm.isDialog,
    "login-register-wrap-dialog": _vm.isDialog
  } }, [_c("div", { class: { "login-register-wrap-dialog__border": _vm.isDialog } }, [_c("div", { staticClass: "login-types-wrap" }, [_c("div", { staticClass: "email-phone-wrap" }, [_c("div", { staticClass: "input-wrap" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.title || _vm.dialogTitle, expression: "pageInit.title || dialogTitle" }], staticClass: "login-register-title" }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showBack, expression: "pageInit.showBack" }], staticClass: "login-register-back", on: { "click": function($event) {
    return _vm.turnDialogType(_vm.originLoginType);
  } } }, [_c("ChevronLeftIcon", { attrs: { "size": "20" } })], 1), _vm.pageInit.dialogTitle ? _c("p", [_vm._v(_vm._s(_vm.dialogTitle))]) : _c("p", [_vm._v(_vm._s(_vm.pageInit.title))]), _vm.allowCloseDialog && _vm.targetLoginType !== "setPassword" ? _c("span", { staticClass: "login-register-close", on: { "click": function($event) {
    return _vm.closeDialog($event);
  } } }, [_c("WindowsCloseIcon", { attrs: { "size": "20px" } })], 1) : _vm._e()]), _vm.pageInit.hasAccount && _vm.openUserRegister && _vm.smtpConfigured ? _c("div", { staticClass: "login-register-tab" }, [_c("div", { class: { "active": _vm.registerType === "code" }, on: { "click": function($event) {
    return _vm.changeRegisterType("code");
  } } }, [_vm._v("\u9A8C\u8BC1\u7801\u6CE8\u518C")]), _c("div", { class: { "active": _vm.registerType === "password" }, on: { "click": function($event) {
    return _vm.changeRegisterType("password");
  } } }, [_vm._v("\u5BC6\u7801\u6CE8\u518C ")])]) : _vm._e(), !_vm.IS_PRI && _vm.targetLoginType !== "sso" ? _c("ThirdPartLogin", { attrs: { "redirectUri": _vm.redirectUri, "disableOptions": _vm.disableOptions }, on: { "log": _vm.sendLog, "onThirdPartBtnClick": _vm.onThirdPartLoginBtnClick } }) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.firstLogin, expression: "pageInit.firstLogin" }], staticClass: "text-btn-wrap align-left" }, [_vm._v(" \u6CE8\u518C\u540E\u9996\u6B21\u767B\u5F55\uFF0C\u8BF7\u4E3A " + _vm._s(_vm.account) + " \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801 ")]), _c("input", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.inputPlaceholder, expression: "pageInit.inputPlaceholder" }, { name: "model", rawName: "v-model", value: _vm.account, expression: "account" }], staticClass: "text-input phone-mail", class: { "error-border": _vm.accountError || _vm.accountErrorBorder }, attrs: { "type": "text", "placeholder": _vm.pageInit.inputPlaceholder }, domProps: { "value": _vm.account }, on: { "keyup": _vm.onAccountChange, "change": _vm.checkAccount, "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.account = $event.target.value;
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isOneBtnLogin && _vm.accountError, expression: "!isOneBtnLogin && accountError" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.accountError))])], 1), _c("input", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showLocalPhone, expression: "pageInit.showLocalPhone" }, { name: "model", rawName: "v-model", value: _vm.localPhone, expression: "localPhone" }], staticClass: "text-input one-btn", class: { "error-border": _vm.oneBtnPhoneError, "no-text-input": !_vm.localPhone }, attrs: { "type": "number", "placeholder": "\u8BF7\u8F93\u5165\u672C\u673A\u53F7\u7801" }, domProps: { "value": _vm.localPhone }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.localPhone = $event.target.value;
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isOneBtnLogin && _vm.oneBtnPhoneError, expression: "isOneBtnLogin && oneBtnPhoneError" }], staticClass: "error local-phone-error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.oneBtnPhoneError))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showPassword, expression: "pageInit.showPassword" }], staticClass: "login-password" }, [(_vm.eyeStatus ? "password" : "text") === "checkbox" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password, expression: "password" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": _vm.pageInit.firstLogin ? "\u5BC6\u78018\u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57" : "\u5BC6\u7801", "type": "checkbox" }, domProps: { "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : _vm.password }, on: { "change": [function($event) {
    var $$a = _vm.password, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.password = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.password = $$c;
    }
  }, _vm.passwordChange] } }) : (_vm.eyeStatus ? "password" : "text") === "radio" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password, expression: "password" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": _vm.pageInit.firstLogin ? "\u5BC6\u78018\u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57" : "\u5BC6\u7801", "type": "radio" }, domProps: { "checked": _vm._q(_vm.password, null) }, on: { "change": [function($event) {
    _vm.password = null;
  }, _vm.passwordChange] } }) : _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password, expression: "password" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": _vm.pageInit.firstLogin ? "\u5BC6\u78018\u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57" : "\u5BC6\u7801", "type": _vm.eyeStatus ? "password" : "text" }, domProps: { "value": _vm.password }, on: { "change": _vm.passwordChange, "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.password = $event.target.value;
  } } }), _c("span", { staticClass: "login-eye-icon", on: { "click": function($event) {
    _vm.eyeStatus = !_vm.eyeStatus;
  } } }, [_vm.eyeStatus ? _c("EyeSlashIcon") : _c("EyeIcon")], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.passwordError, expression: "passwordError" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", { staticClass: "password-error__text" }, [_vm._v(_vm._s(_vm.passwordError))])], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.IS_PRI && _vm.needCaptchaCode && _vm.targetLoginType === "login", expression: "IS_PRI && needCaptchaCode && targetLoginType === 'login'" }], staticClass: "captcha-wrap" }, [_c("div", { staticClass: "captcha-code" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.captchaCode, expression: "captchaCode" }], staticClass: "text-input verification-code", class: { "error-border": _vm.captchaCodeError }, attrs: { "type": "text", "placeholder": "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801", "maxlength": "6" }, domProps: { "value": _vm.captchaCode }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.captchaCode = $event.target.value;
  } } })]), _c("div", { staticClass: "captcha-code-btn", on: { "click": _vm.handleGetSigninCaptcha } }, [_c("img", { attrs: { "src": _vm.captchaCodeUrl, "alt": "\u56FE\u5F62\u9A8C\u8BC1\u7801" } })])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.IS_PRI && _vm.needCaptchaCode && _vm.targetLoginType === "login" && _vm.captchaCodeError, expression: "IS_PRI && needCaptchaCode && targetLoginType === 'login' && captchaCodeError" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.captchaCodeError))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showCode, expression: "pageInit.showCode" }], staticClass: "register-container" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.targetLoginType === "code" || _vm.targetLoginType === "register" && _vm.registerType !== "password", expression: "targetLoginType === 'code' || (targetLoginType === 'register' && registerType !== 'password')" }], staticClass: "register-wrap" }, [_c("div", { staticClass: "register-code" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.verificationCode, expression: "verificationCode" }], staticClass: "text-input verification-code", class: { "error-border": _vm.codeError }, attrs: { "type": "text", "placeholder": "\u9A8C\u8BC1\u7801", "maxlength": "6" }, domProps: { "value": _vm.verificationCode }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.verificationCode = $event.target.value;
  } } })]), _c("div", { staticClass: "register-code-btn" }, [_c("button", { staticClass: "normal-btn", attrs: { "disabled": !!_vm.process }, on: { "click": _vm.sendVerificationCode } }, [_vm._v(_vm._s(_vm.process ? _vm.process + " \u79D2" : "\u83B7\u53D6\u9A8C\u8BC1\u7801"))])])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.IS_PRI && _vm.pageInit.hasAccount && _vm.registerType === "password", expression: "IS_PRI && pageInit.hasAccount && registerType === 'password'" }], staticClass: "login-password" }, [(_vm.eyeStatus ? "password" : "text") === "checkbox" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password1, expression: "password1" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": "\u5BC6\u7801 8 \u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57", "type": "checkbox" }, domProps: { "checked": Array.isArray(_vm.password1) ? _vm._i(_vm.password1, null) > -1 : _vm.password1 }, on: { "change": [function($event) {
    var $$a = _vm.password1, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.password1 = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.password1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.password1 = $$c;
    }
  }, _vm.passwordChange] } }) : (_vm.eyeStatus ? "password" : "text") === "radio" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password1, expression: "password1" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": "\u5BC6\u7801 8 \u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57", "type": "radio" }, domProps: { "checked": _vm._q(_vm.password1, null) }, on: { "change": [function($event) {
    _vm.password1 = null;
  }, _vm.passwordChange] } }) : _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password1, expression: "password1" }], staticClass: "text-input password_input", class: { "error-border": _vm.passwordError }, attrs: { "placeholder": "\u5BC6\u7801 8 \u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57", "type": _vm.eyeStatus ? "password" : "text" }, domProps: { "value": _vm.password1 }, on: { "change": _vm.passwordChange, "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.password1 = $event.target.value;
  } } }), _c("span", { staticClass: "login-eye-icon", on: { "click": function($event) {
    _vm.eyeStatus = !_vm.eyeStatus;
  } } }, [_vm.eyeStatus ? _c("EyeSlashIcon") : _c("EyeIcon")], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.passwordError, expression: "passwordError" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.passwordError))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.IS_PRI && _vm.registerType === "password" && _vm.pageInit.hasAccount, expression: "IS_PRI && registerType === 'password' && pageInit.hasAccount" }], staticClass: "login-password" }, [(_vm.eyeStatus2 ? "password" : "text") === "checkbox" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password2, expression: "password2" }], staticClass: "text-input password_input", class: { "error-border": _vm.password2Error }, attrs: { "placeholder": "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801", "type": "checkbox" }, domProps: { "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : _vm.password2 }, on: { "change": [function($event) {
    var $$a = _vm.password2, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.password2 = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.password2 = $$c;
    }
  }, _vm.password2Change] } }) : (_vm.eyeStatus2 ? "password" : "text") === "radio" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password2, expression: "password2" }], staticClass: "text-input password_input", class: { "error-border": _vm.password2Error }, attrs: { "placeholder": "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801", "type": "radio" }, domProps: { "checked": _vm._q(_vm.password2, null) }, on: { "change": [function($event) {
    _vm.password2 = null;
  }, _vm.password2Change] } }) : _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.password2, expression: "password2" }], staticClass: "text-input password_input", class: { "error-border": _vm.password2Error }, attrs: { "placeholder": "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801", "type": _vm.eyeStatus2 ? "password" : "text" }, domProps: { "value": _vm.password2 }, on: { "change": _vm.password2Change, "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.password2 = $event.target.value;
  } } }), _c("span", { staticClass: "login-eye-icon", on: { "click": function($event) {
    _vm.eyeStatus2 = !_vm.eyeStatus2;
  } } }, [_vm.eyeStatus2 ? _c("EyeSlashIcon") : _c("EyeIcon")], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.password2Error, expression: "password2Error" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.password2Error))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.codeError, expression: "codeError" }], staticClass: "error" }, [_c("WarningIcon", { attrs: { "size": "12" } }), _c("span", [_vm._v(_vm._s(_vm.codeError))])], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.needPolicy, expression: "needPolicy" }], staticClass: "text-btn-wrap policy-container", class: {
    "local-policy": _vm.isOneBtnLogin,
    "hide-policy": _vm.isOneBtnLogin && (_vm.localPhone.length !== 11 || _vm.oneBtnPhoneError),
    "register-no-policy-label": _vm.registerNoPolicy
  }, on: { "animationend": _vm.registerNoPolicyEnd } }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.policy, expression: "policy" }, { name: "show", rawName: "v-show", value: _vm.policy, expression: "policy" }], attrs: { "type": "checkbox", "id": "policy" }, domProps: { "checked": Array.isArray(_vm.policy) ? _vm._i(_vm.policy, null) > -1 : _vm.policy }, on: { "change": function($event) {
    var $$a = _vm.policy, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.policy = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.policy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.policy = $$c;
    }
  } } }), _c("label", { attrs: { "for": "policy" } }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: !_vm.policy, expression: "!policy" }], staticClass: "label-check" }), _c("span", [_vm._v("\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F")])]), _c("a", { staticClass: "text-btn", attrs: { "rel": "noopener noreferrer", "target": _vm.isMirror ? "_self" : "_blank", "href": _vm.envOrigin + "/serviceAgreement" } }, [_vm._v(" \u670D\u52A1\u534F\u8BAE ")]), _vm._v(" \u548C "), _c("a", { staticClass: "text-btn", attrs: { "rel": "noopener noreferrer", "target": _vm.isMirror ? "_self" : "_blank", "href": _vm.envOrigin + "/privacyPolicy" } }, [_vm._v(" \u9690\u79C1\u534F\u8BAE ")])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.buttonText, expression: "pageInit.buttonText" }], staticClass: "login-btn", class: { "local-phone-btn": _vm.targetLoginType === "oneBtn", withoutPolicy: _vm.IS_PRI }, on: { "click": _vm.buttonClick } }, [_c("button", { ref: _vm.loginBtn, staticClass: "light-btn", class: _vm.isOneBtnLogin && _vm.oneLoginBtnStatus === 2 && "light-btn-pressing" }, [_vm._v(_vm._s(_vm.pageInit.buttonText))])]), _vm.isOneBtnLogin && _vm.oneLoginBtnStatus === 3 ? _c("div", { staticClass: "one-btn-login-success" }, [_c("CheckedBlueIcon", { staticClass: "success-icon" })], 1) : _vm._e(), _vm.pageInit.showFollowWeChat ? _c("WeChatQrCode", { staticClass: "column-code", attrs: { "isLogin": _vm.isLogin, "experimentInfo": true, "text": _vm.pageInit.text, "redirectUri": _vm.redirectUri }, on: { "wechat": _vm.wechatLoginMethod, "log": _vm.sendLog } }) : _vm._e()], 1), _c("div", { staticClass: "operations-wrap" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.forgetPassword, expression: "pageInit.forgetPassword" }], staticClass: "text-btn-wrap" }, [_c("span", { staticClass: "text-btn", on: { "click": _vm.forgetPassword } }, [_vm._v(" \u5FD8\u8BB0\u5BC6\u7801 ")])]), _c("div", { staticClass: "text-btn-wrap" }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showOneBtnLogin, expression: "pageInit.showOneBtnLogin" }], staticClass: "text-btn", on: { "click": function($event) {
    return _vm.turnDialogType("oneBtn");
  } } }, [_vm._v(" \u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55 ")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showOneBtnLogin, expression: "pageInit.showOneBtnLogin" }] }, [_vm._v("|")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showPasswordLoginBtn, expression: "pageInit.showPasswordLoginBtn" }], staticClass: "text-btn", on: { "click": function($event) {
    return _vm.turnDialogType("login");
  } } }, [_vm._v("\u5BC6\u7801\u767B\u5F55")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showPasswordLoginBtn, expression: "pageInit.showPasswordLoginBtn" }] }, [_vm._v("|")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showCodeLoginBtn, expression: "pageInit.showCodeLoginBtn" }], staticClass: "text-btn", on: { "click": function($event) {
    return _vm.turnDialogType("code");
  } } }, [_vm._v("\u9A8C\u8BC1\u7801\u767B\u5F55")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showCodeLoginBtn && _vm.pageInit.showSSOBtn, expression: "pageInit.showCodeLoginBtn && pageInit.showSSOBtn" }] }, [_vm._v("|")]), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showSSOBtn, expression: "pageInit.showSSOBtn" }], staticClass: "text-btn", on: { "click": function($event) {
    return _vm.turnDialogType("sso");
  } } }, [_vm._v("SSO\u767B\u5F55")])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.showNotOneBtnLogin, expression: "pageInit.showNotOneBtnLogin" }], staticClass: "text-btn-wrap" }, [_c("span", { staticClass: "text-btn", on: { "click": _vm.turnOriginLogin } }, [_vm._v(" \u5176\u4ED6\u767B\u5F55\u65B9\u5F0F ")])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.noRegister && _vm.openUserRegister, expression: "pageInit.noRegister && openUserRegister" }], staticClass: "text-btn-wrap" }, [_c("span", { staticClass: "text-btn-label" }, [_vm._v("\u8FD8\u6CA1\u6709\u8D26\u53F7?")]), _c("span", { staticClass: "text-btn", on: { "click": function($event) {
    return _vm.turnDialogType("register");
  } } }, [_vm._v("\u524D\u5F80\u6CE8\u518C")])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.pageInit.hasAccount, expression: "pageInit.hasAccount" }], staticClass: "text-btn-wrap" }, [_vm._v(" \u5DF2\u6709\u8D26\u53F7? "), _c("span", { staticClass: "text-btn", on: { "click": _vm.turnOriginLogin } }, [_vm._v("\u7ACB\u5373\u767B\u5F55")])])])])]), _vm.showReloadConfirm ? _c("div", { staticClass: "reload-confirm" }, [_c("div", { staticClass: "reload-confirm_content", style: { marginTop: _vm.dialogContentTop + "px" } }, [_c("div", { staticClass: "reload-confirm_content-title" }, [_c("ErrorRedBorderIcon", { staticClass: "reload-confirm_error-icon" }), _c("span", { staticClass: "reload-confirm_error-text" }, [_vm._v("\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002")])], 1), _c("div", { staticClass: "login-btn reload-confirm_btn", on: { "click": _vm.reloadPage } }, [_c("button", { staticClass: "light-btn" }, [_vm._v(" \u5237\u65B0 ")])])])]) : _vm._e()])])])]);
};
var staticRenderFns$h = [];
var index_vue_vue_type_style_index_0_lang = "";
var index_vue_vue_type_style_index_1_scoped_true_lang = "";
const __vue2_script$h = {
  name: "MLogin",
  components: {
    ThirdPartLogin,
    WeChatQrCode,
    ChevronLeftIcon,
    EyeIcon,
    EyeSlashIcon,
    WarningIcon,
    WindowsCloseIcon,
    QrCodeIcon,
    KeyBoardIcon,
    ErrorRedBorderIcon
  },
  props: {
    allowCloseDialog: {
      type: Boolean,
      default: false
    },
    redirectUri: {
      type: String,
      default: "files/home?lastPath=login&connect_redirect=1"
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ""
    },
    targetType: {
      type: String,
      default: "login"
    },
    actionData: {
      type: Object,
      default: () => ({
        actionDetail: null,
        actionPosition: "masterWeb",
        actionType: "",
        appVersion: ""
      })
    },
    disableOptions: {
      type: Object,
      default: () => ({
        thirdPartLogin: false,
        lanhu: false,
        wechat: false,
        dingding: false
      })
    },
    configs: {
      type: Object,
      default: () => ({
        isRequiredLoginMethod: false
      })
    }
  },
  emits: ["turnPage", "turnType", "setUserInfo", "refreshPassword", "close", "toast", "onThirdPartBtnClick"],
  setup(props2, { emit }) {
    const defaultLogin = isMobile() ? "code" : "login";
    const account = ref("");
    const localPhone = ref("");
    const password = ref("");
    const password1 = ref("");
    const password2 = ref("");
    const verificationCode = ref("");
    const needCaptchaCode = ref(false);
    const captchaCode = ref("");
    const captchaCodeId = ref("");
    const captchaCodeUrl = ref("");
    const policy = ref(false);
    const registerNoPolicy = ref(false);
    const process2 = ref(0);
    const originLoginType = ref(defaultLogin);
    const targetLoginType = ref(defaultLogin);
    const eyeStatus = ref(true);
    const eyeStatus2 = ref(true);
    const accountError = ref("");
    const accountErrorBorder = ref(false);
    const passwordError = ref("");
    const password2Error = ref("");
    const captchaCodeError = ref("");
    const codeError = ref("");
    const featureLoading = ref(true);
    const oneBtnPhoneError = ref("");
    const oneLoginBtnStatus = ref(oneBtnStatus.ON_INPUT);
    const showReloadConfirm = ref(false);
    const hasOneBtnLogin = ref(false);
    const dialogContentTop = ref(226);
    const loginBtn = ref(null);
    const userInfo = ref(null);
    const isMobile2 = ref(isMobile());
    const roleReg = {
      phone: /^1[3456789]\d{9}$/,
      email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      verificationCode: /^.{6}$/
    };
    const listener = ref(null);
    const formData = reactive({});
    const titleMap = {
      register: "\u6CE8\u518C\u65B0\u8D26\u53F7",
      login: "\u6B22\u8FCE\u56DE\u6765",
      code: "\u6B22\u8FCE\u56DE\u6765",
      oneBtn: "\u4E00\u952E\u767B\u5F55",
      sso: "SSO\u767B\u5F55",
      followWeChat: "\u5FAE\u4FE1\u767B\u5F55",
      wechat: "\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C",
      setPassword: "\u8BBE\u7F6E\u5BC6\u7801"
    };
    const title = computed(() => titleMap[targetLoginType.value]);
    const randomNum = getUrlValue(SESSION_KEYS.RANDOM_NUM, getSessionStorageItem("appAuth") || "");
    const basePointForBackend = {
      app_version: props2.actionData.appVersion,
      app: isMirror() ? "mirror_app" : randomNum ? "masterdesktop" : "masterweb",
      position: `${props2.actionData.actionPosition || ""}+${window.location.pathname}`
    };
    const openUserRegister = ref(!props2.configs.isRequiredLoginMethod);
    const smtpConfigured = ref(false);
    const registerType = ref("");
    const IS_PRI = ref(props2.configs.isRequiredLoginMethod);
    onMounted(async () => {
      if (props2.configs.isRequiredLoginMethod) {
        await getLoginStatus();
      }
      const code = getSessionStorageItem(SESSION_KEYS.SAML_CODE);
      if (code) {
        removeSessionStorageItem(SESSION_KEYS.SAML_CODE);
        if (samlErrCode[code]) {
          emit("toast", {
            content: samlErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else {
          emit("toast", {
            content: accountErrorCode.saml,
            timeout: 3e3,
            position: "top"
          });
        }
      }
      sendLog2(SensorsType.SHOW_LOGIN, {
        action_parameter9: randomNum
      });
      if (isMobile2.value && !platformInfo().isWeiXin) {
        const meta = window.document.createElement("meta");
        meta.setAttribute("name", "referrer");
        meta.setAttribute("content", "origin");
        window.document.head.appendChild(meta);
      }
      if (props2.targetType && !IS_PRI.value) {
        turnDialogType(props2.targetType);
      }
      nextTick(() => {
        listener.value = (ev) => {
          if (ev.keyCode === 13) {
            buttonClick();
          }
        };
        window.addEventListener("keyup", listener.value);
      });
      if (props2.isDialog) {
        sendLog2(SensorsType.LOGIN_POPOUT_LOAD, {
          url_name: window.location.pathname
        });
      }
      await getPageInitData();
    });
    const changeRegisterType = (type2) => {
      initErrors();
      registerType.value = type2;
    };
    const getLoginStatus = async () => {
      var _a2, _b;
      if (isMirror() && !window.mirrorVersion) {
        window.alert("\u5DF2\u5347\u7EA7\u66F4\u5B89\u5168\u7684\u767B\u5F55\u8BBF\u95EE\uFF0C\u5F53\u524D\u7248\u672C\u53EF\u80FD\u51FA\u73B0\u767B\u5F55\u5F02\u5E38\u3002\u8BF7\u5C3D\u5FEB\u5347\u7EA7\u81F3\u6700\u65B0\u7248\u624B\u673A\u5BA2\u6237\u7AEF\u4F7F\u7528\u3002");
      }
      const res = await canRegister();
      openUserRegister.value = !!res.data.openUserRegister;
      smtpConfigured.value = res.data.smtpConfigured;
      if (smtpConfigured.value) {
        turnDialogType("code");
      }
      const code = getSessionStorageItem(SESSION_KEYS.PRIVATE_CODE);
      if (code) {
        startRemoveSession();
        try {
          const data2 = await priLoginByCode({ private_code: code, platformName: "mastergo" });
          if (data2.code === "OK") {
            location.href = location.origin;
          }
        } catch (e) {
          const code2 = (_b = (_a2 = e == null ? void 0 : e.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
          if (code2 && samlEmailErrCode[code2]) {
            emit("toast", {
              content: samlEmailErrCode[code2],
              timeout: 3e3,
              position: "top"
            });
          }
        }
      } else {
        const res2 = await getLoginType();
        if (res2.data.login_type === "sso" && res2.data.login_methods[0].redirect_url) {
          location.href = res2.data.login_methods[0].redirect_url;
        }
      }
    };
    watch(account, (val, oldVal) => {
      if (val !== oldVal) {
        accountError.value = "";
        accountErrorBorder.value = false;
      }
    });
    watch(localPhone, (val, oldVal) => {
      if (/\D/.test(val) || val.length > 11) {
        localPhone.value = oldVal;
        return;
      }
      if (val !== oldVal) {
        oneBtnPhoneError.value = "";
      }
    });
    watch(password, (val, oldVal) => {
      if (val !== oldVal) {
        codeError.value = "";
      }
      passwordError.value = "";
    });
    watch(password1, (val, oldVal) => {
      passwordError.value = "";
    });
    watch(password2, (val, oldVal) => {
      password2Error.value = "";
    });
    watch(verificationCode, (val, oldVal) => {
      if (val !== oldVal) {
        codeError.value = "";
      }
    });
    watch(() => props2.targetType, (val) => {
      turnDialogType(val);
    });
    const passwordChange = () => {
      const priFlag = IS_PRI.value && targetLoginType.value === "register" && registerType.value === "password";
      const flag = targetLoginType.value === "setPassword";
      if (priFlag || flag) {
        let passVal = password1.value;
        if (targetLoginType.value === "setPassword") {
          passVal = password.value;
        }
        const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/g;
        if (passVal.length <= 8 || !reg.test(passVal)) {
          passwordError.value = "\u786E\u4FDD\u5BC6\u7801 8 \u4F4D\u4EE5\u4E0A\uFF0C\u5305\u542B\u5927\u5199\u3001\u5C0F\u5199\u548C\u6570\u5B57";
          return false;
        } else {
          passwordError.value = "";
          return true;
        }
      } else {
        return true;
      }
    };
    const password2Change = () => {
      if (password1.value !== password2.value) {
        password2Error.value = "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165";
        return false;
      } else {
        password2Error.value = "";
        return true;
      }
    };
    const isLogin = computed(() => {
      return ["code", "login"].includes(props2.targetType);
    });
    const closeDialog = () => {
      emit("close");
    };
    const closeForModal = (ev) => {
      if (`${ev.target.className}`.indexOf("login-register-container") === -1) {
        return;
      }
      if (!props2.isDialog || !props2.allowCloseDialog) {
        return;
      }
      closeDialog();
    };
    const wechatLoginMethod = async (code = "") => {
      const data2 = await getFormData();
      const fn = sendFormData(data2);
      try {
        const wxRes = await wechatLogin(__spreadValues(__spreadValues({
          code
        }, data2), basePointForBackend));
        removeSessionStorageItem(SESSION_KEYS.SUB_TOKEN);
        emit("setUserInfo", wxRes.data);
        removeDrainageData();
        fn(wxRes);
      } catch {
      }
    };
    const initPassword = async () => {
      try {
        await initpassword({
          password: password.value
        });
      } catch {
      }
      emit("refreshPassword", {
        userState: 1
      });
      emit("setUserInfo", __spreadProps(__spreadValues({}, userInfo.value), { userState: 1 }));
    };
    const initErrors = () => {
      passwordError.value = "";
      password2Error.value = "";
      codeError.value = "";
      accountError.value = "";
      captchaCodeError.value = "";
      accountErrorBorder.value = false;
      oneBtnPhoneError.value = "";
    };
    const setTitle2 = (title2 = "") => {
      if (!props2.isDialog) {
        document.title = title2;
      }
    };
    const onThirdPartLoginBtnClick = (thirdPartType) => {
      sendLog2(SensorsType.CLICK_LOGIN_BTN, {
        action_type: "wechat"
      });
      if (!!(window == null ? void 0 : window.flutter_inappwebview)) {
        emit("onThirdPartBtnClick", { thirdPartType });
      } else {
        turnDialogType("followWeChat");
      }
    };
    const turnDialogType = (type2) => {
      initErrors();
      if (!titleMap[type2])
        return;
      verificationCode.value = "";
      originLoginType.value = targetLoginType.value;
      targetLoginType.value = type2;
      const pageTitle = type2 === "register" ? "\u6CE8\u518C" : "\u767B\u5F55";
      setTitle2(document.title.replace(/.*/, pageTitle));
      if (type2 === "register" && IS_PRI.value) {
        registerType.value = smtpConfigured.value ? "code" : "password";
      }
      emit("turnType", type2);
    };
    const turnOriginLogin = () => {
      turnDialogType(defaultLogin);
      registerType.value = "";
    };
    const forgetPassword = () => {
      if (window.mirrorVersion) {
        location.href = `${window.location.origin}/login/forget-password`;
      } else {
        window.open(`${window.location.origin}/login/forget-password`);
      }
    };
    const isEmail = () => {
      return account.value.indexOf("@") !== -1;
    };
    const onAccountChange = () => {
      if (!IS_PRI.value)
        return;
      needCaptchaCode.value = false;
      captchaCodeError.value = "";
    };
    const checkAccount = () => {
      const regName = isEmail() ? "email" : "phone";
      const status2 = roleReg[regName].test(account.value);
      if (IS_PRI.value && (!status2 || regName === "phone")) {
        accountError.value = accountErrorCode.emailError;
        return false;
      }
      if (!status2) {
        accountError.value = accountErrorCode.default;
        return false;
      }
      if (IS_PRI && needCaptchaCode.value && !captchaCode.value) {
        captchaCodeError.value = accountErrorCode.noCaptcha;
        return false;
      }
      accountError.value = "";
      return true;
    };
    const checkCode = () => {
      const status2 = roleReg.verificationCode.test(verificationCode.value);
      if (!status2) {
        codeError.value = "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165";
        return false;
      }
      codeError.value = "";
      return checkPolicy();
    };
    const checkLocalPhone = () => {
      const status2 = roleReg.phone.test(localPhone.value);
      if (!status2) {
        oneBtnPhoneError.value = "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7";
        return false;
      }
      oneBtnPhoneError.value = "";
      return checkPolicy();
    };
    const checkPolicy = () => {
      if (needPolicy.value && !policy.value) {
        registerNoPolicy.value = true;
        return false;
      }
      return true;
    };
    const registerNoPolicyEnd = () => {
      registerNoPolicy.value = false;
    };
    const cutTime = () => {
      const timer = setTimeout(() => {
        if (process2.value > 0) {
          process2.value--;
          cutTime();
        }
        clearTimeout(timer);
      }, 1e3);
    };
    const sendCode = () => {
      sendLog2(SensorsType.SEND_CODE, __spreadProps(__spreadValues({}, basePointForBackend), {
        action_type: ["code", "login"].includes(targetLoginType.value) ? "login" : "register"
      }));
      return sendMessageCode({
        identity: account.value
      }).then(() => {
        process2.value = 60;
        cutTime();
      }).catch((e) => {
        var _a2, _b;
        const err = (_a2 = e == null ? void 0 : e.response) == null ? void 0 : _a2.data;
        if (err.code) {
          accountError.value = accountErrorCode[err.code];
        }
        process2.value = (err == null ? void 0 : err.meta) ? (_b = err == null ? void 0 : err.meta) == null ? void 0 : _b.sec : process2.value;
        cutTime();
      });
    };
    const handleGetSigninCaptcha = async () => {
      try {
        const { data: { id, image } } = await getSigninCaptcha({ identity: account.value });
        captchaCodeId.value = id;
        captchaCodeUrl.value = `data:image/png;base64,${image}`;
      } catch (e) {
        console.error("\u9A8C\u8BC1\u7801\u83B7\u53D6\u5931\u8D25\uFF1A", JSON.stringify(e));
      }
    };
    const sendVerificationCode = () => {
      if (process2.value) {
        return;
      }
      if (!checkAccount()) {
        return;
      }
      sendCode();
    };
    const buttonClick = async () => {
      initErrors();
      if (targetLoginType.value === "setPassword") {
        passwordChange() && initPassword();
      } else if (["code", "register"].includes(targetLoginType.value)) {
        if (registerType.value === "password" && IS_PRI.value) {
          checkAccount() && passwordChange() && password2Change() && passwordSignin();
        } else {
          checkAccount() && checkCode() && signUpByCode();
        }
      } else if (["login"].includes(targetLoginType.value)) {
        if (checkAccount() && checkPolicy()) {
          signUpByPassword();
        }
      } else if (["oneBtn"].includes(targetLoginType.value)) {
        if (checkLocalPhone()) {
          verifyLocalPhone();
        }
        sendLog2(SensorsType.CLICK_LOGIN_BTN, {
          action_type: "one_click_login"
        });
      } else if (["sso"].includes(targetLoginType.value)) {
        signUpBySSO();
        sendLog2(SensorsType.CLICK_LOGIN_BTN, {
          action_type: "sso_saml"
        });
      }
    };
    const checkOneBtnLogin = async () => {
      const { data: { JwtToken, AccessToken } } = await getLocalPhoneToken();
      await checkAuthAvailable({ jwtToken: JwtToken, accessToken: AccessToken, phoneNumber: localPhone.value });
      const { spToken } = await getVerifyToken();
      return spToken;
    };
    const verifyLocalPhone = async () => {
      if (oneLoginBtnStatus.value !== oneBtnStatus.ON_INPUT)
        return;
      try {
        oneLoginBtnStatus.value = oneBtnStatus.IN_REVIEW;
        const spToken = await checkOneBtnLogin();
        const data2 = await getFromData();
        const fn = sendFormData(data2);
        const res = await verifyLocalPhoneToken(__spreadValues(__spreadValues({
          identity: "" + localPhone.value,
          code: spToken
        }, data2), basePointForBackend));
        oneLoginBtnStatus.value = oneBtnStatus.CHECK_SUCCESS;
        removeDrainageData();
        fn(res);
        setTimeout(() => showSetPassDialog(res.data), 500);
      } catch (e) {
        oneLoginBtnStatus.value = oneBtnStatus.ON_INPUT;
        const code = e && e.code;
        switch (code) {
          case 600008: {
            showReloadConfirm.value = true;
            if (loginBtn.value) {
              dialogContentTop.value = +loginBtn.value.offsetTop - 12;
            }
            break;
          }
          case 600025: {
            oneBtnPhoneError.value = "\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801";
            break;
          }
          default: {
            emit("toast", {
              content: "\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
              timeout: 3e3,
              position: "top"
            });
            break;
          }
        }
      }
    };
    const signUpByCode = async () => {
      var _a2, _b;
      try {
        const data2 = await getFromData();
        const fn = sendFormData(data2);
        const res = await phoneAndEmailSignup(__spreadValues(__spreadValues({
          identity: account.value,
          code: verificationCode.value
        }, data2), basePointForBackend));
        removeDrainageData();
        showSetPassDialog(res.data);
        startRemoveSession();
        fn(res);
      } catch (e) {
        const code = (_b = (_a2 = e == null ? void 0 : e.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
        if (code && samlEmailErrCode[code]) {
          emit("toast", {
            content: samlEmailErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else {
          accountErrorBorder.value = true;
          codeError.value = "\u7528\u6237\u540D\u6216\u9A8C\u8BC1\u7801\u9519\u8BEF";
        }
      }
    };
    const passwordSignin = async () => {
      try {
        const data2 = await getFromData();
        const fn = sendFormData(data2);
        const res = await signinByPassword(__spreadValues(__spreadValues({
          email: account.value,
          password: password1.value
        }, data2), basePointForBackend)).catch((e) => {
          var _a2;
          const err = (_a2 = e == null ? void 0 : e.response) == null ? void 0 : _a2.data;
          if (err.code) {
            accountError.value = accountErrorCode[err.code];
          }
        });
        removeDrainageData();
        showSetPassDialog(res.data);
        startRemoveSession();
        fn(res);
      } catch (error) {
      }
    };
    const signUpByPassword = async () => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
      try {
        const yToken = getSessionStorageItem("yToken");
        const params = __spreadValues({
          identity: account.value,
          password: password.value,
          yToken
        }, basePointForBackend);
        if (needCaptchaCode.value) {
          params.captchaId = captchaCodeId.value;
          params.captchaValue = captchaCode.value;
        }
        const res = await signupByPassword(params);
        showSetPassDialog(res.data);
      } catch (e) {
        const code = (_b = (_a2 = e == null ? void 0 : e.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
        if (code && samlEmailErrCode[code]) {
          emit("toast", {
            content: samlEmailErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else if (IS_PRI.value && (code === "NeedCaptcha" || code === "InvalidCaptcha")) {
          captchaCodeError.value = accountErrorCode[code];
          needCaptchaCode.value = true;
          captchaCodeId.value = (_e = (_d = (_c = e == null ? void 0 : e.response) == null ? void 0 : _c.data) == null ? void 0 : _d.data) == null ? void 0 : _e.captchaId;
          captchaCodeUrl.value = `data:image/png;base64,${(_h = (_g = (_f = e == null ? void 0 : e.response) == null ? void 0 : _f.data) == null ? void 0 : _g.data) == null ? void 0 : _h.captchaValue}`;
        } else if (code === "LoginTooManyTimes") {
          accountErrorBorder.value = true;
          passwordError.value = "\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5";
        } else {
          accountErrorBorder.value = true;
          passwordError.value = "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF";
          if ((_k = (_j = (_i = e == null ? void 0 : e.response) == null ? void 0 : _i.data) == null ? void 0 : _j.data) == null ? void 0 : _k.captchaId) {
            captchaCodeId.value = (_n = (_m = (_l = e == null ? void 0 : e.response) == null ? void 0 : _l.data) == null ? void 0 : _m.data) == null ? void 0 : _n.captchaId;
            captchaCodeUrl.value = `data:image/png;base64,${(_q = (_p = (_o = e == null ? void 0 : e.response) == null ? void 0 : _o.data) == null ? void 0 : _p.data) == null ? void 0 : _q.captchaValue}`;
          } else {
            needCaptchaCode.value = false;
          }
        }
      }
    };
    const getSSOverifyMethod = (type2) => {
      switch (type2) {
        case "saml":
          return verifySaml;
        case "oauth":
          return verifyOauth;
        default:
          return verifySaml;
      }
    };
    const signUpBySSO = async () => {
      var _a2, _b, _c;
      if (!roleReg.email.test(account.value)) {
        accountError.value = accountErrorCode.orgEmailErr;
        return;
      }
      try {
        const sourceUrl = getSessionStorageItem(SESSION_KEYS.SOURCE_URL);
        const redirect = sourceUrl ? sourceUrl : window.location.origin + "/files/home";
        console.log("redirect url is:", redirect);
        const loginProtocol = await getLoginProtocol({ email: account.value });
        const verifyMethod = getSSOverifyMethod((_a2 = loginProtocol == null ? void 0 : loginProtocol.data) == null ? void 0 : _a2.loginType);
        const params = {
          email: account.value,
          redirect_url: redirect
        };
        const res = await verifyMethod(params);
        window.open(res.data.auth_req_url, "_self");
      } catch (e) {
        console.log("Failed: ", e);
        const code = (_c = (_b = e == null ? void 0 : e.response) == null ? void 0 : _b.data) == null ? void 0 : _c.code;
        if (samlEmailErrCode[code]) {
          accountError.value = samlEmailErrCode[code];
        } else {
          accountError.value = accountErrorCode.saml;
        }
      }
    };
    const showSetPassDialog = async (res = {}) => {
      emit("setUserInfo", res, !res.userState);
      if (!res.userState) {
        turnDialogType("setPassword");
        userInfo.value = res;
      }
    };
    const getFromData = async () => {
      const source2 = getSessionStorageItem("setRegistrationCode");
      formData.value = await getFormData();
      const naturalGrowth = formData.value.naturalGrowth;
      return __spreadProps(__spreadValues({}, formData.value), {
        source: source2,
        naturalGrowth
      });
    };
    const reloadWithReason = () => {
      window.location.reload();
    };
    const sendLog2 = (type2, data2) => {
      if (!data2)
        data2 = {};
      const actionDetail = props2.actionData.actionDetail;
      if (actionDetail && actionDetail[type2]) {
        data2.action_detail = actionDetail;
      }
      if (type2 === "click_login_btn") {
        data2.app = isMirror() ? "mirror_app" : "masterweb";
      }
      data2.action_position = `${props2.actionData.actionPosition || ""}+${window.location.pathname}`;
      if (props2.actionData.actionType) {
        data2.action_type = props2.actionData.actionType;
      }
      sensors.track(type2, data2);
    };
    const reloadPage = () => {
      showReloadConfirm.value = false;
      reloadWithReason();
    };
    const getOneBtnUse = async () => {
      try {
        if (isMobile2.value && !platformInfo().isWeiXin) {
          await checkOneBtnLogin();
          await turnDialogType("oneBtn");
          hasOneBtnLogin.value = true;
          return;
        }
        return null;
      } catch {
        return null;
      }
    };
    const getPageInitData = async () => {
      await getOneBtnUse();
      featureLoading.value = false;
    };
    const isOneBtnLogin = computed(() => targetLoginType.value === "oneBtn");
    const pageInit = computed(() => {
      let data2 = {};
      if (props2.targetType === "wechat") {
        Object.assign(data2, {
          showFollowWeChat: true
        });
      } else {
        switch (targetLoginType.value) {
          case "code": {
            data2 = {
              inputPlaceholder: props2.configs.isRequiredLoginMethod ? "\u90AE\u7BB1" : "\u624B\u673A\u53F7/\u90AE\u7BB1",
              policy: true,
              buttonText: "\u5F00\u59CB\u4F7F\u7528",
              showPasswordLoginBtn: true,
              noRegister: true,
              showCode: true,
              showOneBtnLogin: hasOneBtnLogin.value,
              showSSOBtn: true
            };
            break;
          }
          case "login": {
            data2 = {
              showBack: false,
              inputPlaceholder: props2.configs.isRequiredLoginMethod ? "\u90AE\u7BB1" : "\u624B\u673A\u53F7/\u90AE\u7BB1",
              showPassword: true,
              policy: true,
              buttonText: "\u5F00\u59CB\u4F7F\u7528",
              forgetPassword: true,
              showCodeLoginBtn: true,
              showSSOBtn: true,
              noRegister: true
            };
            break;
          }
          case "register": {
            data2 = {
              inputPlaceholder: props2.configs.isRequiredLoginMethod ? "\u90AE\u7BB1" : "\u624B\u673A\u53F7/\u90AE\u7BB1",
              showCode: true,
              hasAccount: true,
              policy: true,
              buttonText: "\u6CE8\u518C"
            };
            break;
          }
          case "followWeChat": {
            data2 = {
              title: `\u5FAE\u4FE1${isLogin.value ? "\u5B89\u5168\u767B\u5F55" : "\u626B\u7801\u6CE8\u518C"}`,
              showBack: true,
              showFollowWeChat: true
            };
            break;
          }
          case "setPassword": {
            data2 = {
              firstLogin: true,
              showPassword: true,
              buttonText: "\u5F00\u59CB\u4F7F\u7528"
            };
            break;
          }
          case "oneBtn": {
            let buttonText;
            switch (oneLoginBtnStatus.value) {
              case oneBtnStatus.ON_INPUT: {
                buttonText = "\u9A8C\u8BC1\u53F7\u7801";
                break;
              }
              case oneBtnStatus.IN_REVIEW: {
                buttonText = "\u9A8C\u8BC1\u4E2D...";
                break;
              }
              case oneBtnStatus.CHECK_SUCCESS: {
                buttonText = "";
                break;
              }
              default: {
                buttonText = "\u9A8C\u8BC1\u53F7\u7801";
              }
            }
            data2 = {
              showLocalPhone: true,
              showNotOneBtnLogin: true,
              policy: true,
              buttonText
            };
            break;
          }
          case "sso": {
            data2 = {
              buttonText: "\u4E0B\u4E00\u6B65",
              showCodeLoginBtn: true,
              showPasswordLoginBtn: true,
              noRegister: true,
              inputPlaceholder: "\u4F01\u4E1A\u90AE\u7BB1"
            };
          }
        }
      }
      return __spreadValues({
        title: title.value,
        dialogTitle: props2.dialogTitle,
        showBack: false,
        firstLogin: false,
        showPassword: false,
        showCode: false,
        policy: false,
        buttonText: "",
        showPasswordLoginBtn: false,
        forgetPassword: false,
        noRegister: false,
        hasAccount: false,
        showFollowWeChat: false,
        showLocalPhone: false,
        showOneBtnLogin: false,
        showNotOneBtnLogin: false,
        showCodeLoginBtn: false,
        showSSOBtn: false,
        inputPlaceholder: ""
      }, data2);
    });
    const needPolicy = computed(() => pageInit.value.policy && !IS_PRI.value);
    onBeforeUnmount(() => {
      window.removeEventListener("keyup", listener.value);
      removeSessionStorageItem(SESSION_KEYS.RANDOM_NUM);
    });
    return {
      isLogin,
      pageInit,
      needPolicy,
      wechatIcon,
      closeForModal,
      closeDialog,
      onThirdPartLoginBtnClick,
      turnDialogType,
      account,
      accountError,
      accountErrorBorder,
      eyeStatus,
      eyeStatus2,
      passwordError,
      password,
      needCaptchaCode,
      captchaCode,
      captchaCodeUrl,
      verificationCode,
      handleGetSigninCaptcha,
      sendVerificationCode,
      process: process2,
      captchaCodeError,
      codeError,
      policy,
      registerNoPolicy,
      registerNoPolicyEnd,
      buttonClick,
      wechatLoginMethod,
      forgetPassword,
      turnOriginLogin,
      originLoginType,
      targetLoginType,
      featureLoading,
      sendLog: sendLog2,
      localPhone,
      oneBtnPhoneError,
      oneLoginBtnStatus,
      showReloadConfirm,
      reloadPage,
      hasOneBtnLogin,
      dialogContentTop,
      isOneBtnLogin,
      loginBtn,
      envOrigin: configs.MAIN_ORIGIN,
      isMobile2,
      ThirdPartType,
      openUserRegister,
      smtpConfigured,
      registerType,
      password1,
      password2,
      password2Error,
      passwordChange,
      password2Change,
      checkAccount,
      onAccountChange,
      changeRegisterType,
      IS_PRI,
      isMirror
    };
  }
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(__vue2_script$h, render$h, staticRenderFns$h, false, __vue2_injectStyles$h, "08e4ffae", null, null);
function __vue2_injectStyles$h(context) {
  for (let o2 in __cssModules$h) {
    this[o2] = __cssModules$h[o2];
  }
}
var MLogin = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var defaultIcon = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAHgAeAMBEQACEQEDEQH/xABUAAEBAAAAAAAAAAAAAAAAAAAACBABAQADAAAAAAAAAAAAAAAAAAERUZEBAQEBAAAAAAAAAAAAAAAAAAAJChEBAAMAAAAAAAAAAAAAAAAAAAERUf/aAAwDAQACEQMRAD8AiRpjT1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMXV4XGhi6vC40MXV4XGhi6vC40MXV4XGhi6vC40MXV4XGj//Z";
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "avatar", class: _vm.size ? "avatar_" + _vm.size : "" }, [_vm.info.avatar ? _c("img", { attrs: { "src": _vm.img || _vm.info.avatar }, on: { "error": _vm.onerror } }) : _c("div", { staticClass: "name-container bg-g-blue text-white", class: _vm.info.type ? "type-" + _vm.info.type : "" }, [_vm._v(" " + _vm._s(_vm.name) + " ")])]);
};
var staticRenderFns$g = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const __vue2_script$g = defineComponent({
  name: "MAvatar",
  props: {
    size: {
      type: String,
      default: "middle"
    },
    info: {
      type: Object,
      default: () => ({
        name: "",
        avatar: ""
      })
    },
    showBorder: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const img = ref("");
    const name2 = ref("");
    watch(() => props2.info, (val) => {
      img.value = transUrl(props2.info.avatar || "");
      if (!val.avatar) {
        if (val.name) {
          name2.value = val.name.trim() || "";
        }
        const len = name2.value.length;
        if (!isChinese(name2.value)) {
          if (name2.value[0] !== "+") {
            const firstChar = Array.from(name2.value)[0];
            if (containEmoji(firstChar)) {
              name2.value = firstChar;
            } else {
              name2.value = firstChar.toUpperCase();
            }
          }
        } else if (len <= 2) {
          name2.value = name2.value.substring(len - 1);
        } else {
          name2.value = props2.size === "small" ? name2.value.substring(len - 1) : name2.value.substring(len - 2);
        }
      }
    }, { immediate: true, deep: true });
    const onerror = () => {
      img.value = defaultIcon;
    };
    return {
      img,
      name: name2,
      onerror
    };
  }
});
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(__vue2_script$g, render$g, staticRenderFns$g, false, __vue2_injectStyles$g, "83d284fa", null, null);
function __vue2_injectStyles$g(context) {
  for (let o2 in __cssModules$g) {
    this[o2] = __cssModules$g[o2];
  }
}
var MAvatar = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var qrcode$1 = { exports: {} };
(function(module, exports) {
  var QRCode2;
  (function(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    function QR8bitByte(data2) {
      this.mode = QRMode.MODE_8BIT_BYTE;
      this.data = data2;
      this.parsedData = [];
      for (var i2 = 0, l = this.data.length; i2 < l; i2++) {
        var byteArray = [];
        var code = this.data.charCodeAt(i2);
        if (code > 65536) {
          byteArray[0] = 240 | (code & 1835008) >>> 18;
          byteArray[1] = 128 | (code & 258048) >>> 12;
          byteArray[2] = 128 | (code & 4032) >>> 6;
          byteArray[3] = 128 | code & 63;
        } else if (code > 2048) {
          byteArray[0] = 224 | (code & 61440) >>> 12;
          byteArray[1] = 128 | (code & 4032) >>> 6;
          byteArray[2] = 128 | code & 63;
        } else if (code > 128) {
          byteArray[0] = 192 | (code & 1984) >>> 6;
          byteArray[1] = 128 | code & 63;
        } else {
          byteArray[0] = code;
        }
        this.parsedData.push(byteArray);
      }
      this.parsedData = Array.prototype.concat.apply([], this.parsedData);
      if (this.parsedData.length != this.data.length) {
        this.parsedData.unshift(191);
        this.parsedData.unshift(187);
        this.parsedData.unshift(239);
      }
    }
    QR8bitByte.prototype = {
      getLength: function(buffer) {
        return this.parsedData.length;
      },
      write: function(buffer) {
        for (var i2 = 0, l = this.parsedData.length; i2 < l; i2++) {
          buffer.put(this.parsedData[i2], 8);
        }
      }
    };
    function QRCodeModel(typeNumber, errorCorrectLevel) {
      this.typeNumber = typeNumber;
      this.errorCorrectLevel = errorCorrectLevel;
      this.modules = null;
      this.moduleCount = 0;
      this.dataCache = null;
      this.dataList = [];
    }
    QRCodeModel.prototype = { addData: function(data2) {
      var newData = new QR8bitByte(data2);
      this.dataList.push(newData);
      this.dataCache = null;
    }, isDark: function(row, col) {
      if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
        throw new Error(row + "," + col);
      }
      return this.modules[row][col];
    }, getModuleCount: function() {
      return this.moduleCount;
    }, make: function() {
      this.makeImpl(false, this.getBestMaskPattern());
    }, makeImpl: function(test, maskPattern) {
      this.moduleCount = this.typeNumber * 4 + 17;
      this.modules = new Array(this.moduleCount);
      for (var row = 0; row < this.moduleCount; row++) {
        this.modules[row] = new Array(this.moduleCount);
        for (var col = 0; col < this.moduleCount; col++) {
          this.modules[row][col] = null;
        }
      }
      this.setupPositionProbePattern(0, 0);
      this.setupPositionProbePattern(this.moduleCount - 7, 0);
      this.setupPositionProbePattern(0, this.moduleCount - 7);
      this.setupPositionAdjustPattern();
      this.setupTimingPattern();
      this.setupTypeInfo(test, maskPattern);
      if (this.typeNumber >= 7) {
        this.setupTypeNumber(test);
      }
      if (this.dataCache == null) {
        this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
      }
      this.mapData(this.dataCache, maskPattern);
    }, setupPositionProbePattern: function(row, col) {
      for (var r = -1; r <= 7; r++) {
        if (row + r <= -1 || this.moduleCount <= row + r)
          continue;
        for (var c = -1; c <= 7; c++) {
          if (col + c <= -1 || this.moduleCount <= col + c)
            continue;
          if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
            this.modules[row + r][col + c] = true;
          } else {
            this.modules[row + r][col + c] = false;
          }
        }
      }
    }, getBestMaskPattern: function() {
      var minLostPoint = 0;
      var pattern = 0;
      for (var i2 = 0; i2 < 8; i2++) {
        this.makeImpl(true, i2);
        var lostPoint = QRUtil.getLostPoint(this);
        if (i2 == 0 || minLostPoint > lostPoint) {
          minLostPoint = lostPoint;
          pattern = i2;
        }
      }
      return pattern;
    }, createMovieClip: function(target_mc, instance_name, depth) {
      var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
      var cs = 1;
      this.make();
      for (var row = 0; row < this.modules.length; row++) {
        var y = row * cs;
        for (var col = 0; col < this.modules[row].length; col++) {
          var x = col * cs;
          var dark = this.modules[row][col];
          if (dark) {
            qr_mc.beginFill(0, 100);
            qr_mc.moveTo(x, y);
            qr_mc.lineTo(x + cs, y);
            qr_mc.lineTo(x + cs, y + cs);
            qr_mc.lineTo(x, y + cs);
            qr_mc.endFill();
          }
        }
      }
      return qr_mc;
    }, setupTimingPattern: function() {
      for (var r = 8; r < this.moduleCount - 8; r++) {
        if (this.modules[r][6] != null) {
          continue;
        }
        this.modules[r][6] = r % 2 == 0;
      }
      for (var c = 8; c < this.moduleCount - 8; c++) {
        if (this.modules[6][c] != null) {
          continue;
        }
        this.modules[6][c] = c % 2 == 0;
      }
    }, setupPositionAdjustPattern: function() {
      var pos = QRUtil.getPatternPosition(this.typeNumber);
      for (var i2 = 0; i2 < pos.length; i2++) {
        for (var j = 0; j < pos.length; j++) {
          var row = pos[i2];
          var col = pos[j];
          if (this.modules[row][col] != null) {
            continue;
          }
          for (var r = -2; r <= 2; r++) {
            for (var c = -2; c <= 2; c++) {
              if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
                this.modules[row + r][col + c] = true;
              } else {
                this.modules[row + r][col + c] = false;
              }
            }
          }
        }
      }
    }, setupTypeNumber: function(test) {
      var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
      for (var i2 = 0; i2 < 18; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        this.modules[Math.floor(i2 / 3)][i2 % 3 + this.moduleCount - 8 - 3] = mod;
      }
      for (var i2 = 0; i2 < 18; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        this.modules[i2 % 3 + this.moduleCount - 8 - 3][Math.floor(i2 / 3)] = mod;
      }
    }, setupTypeInfo: function(test, maskPattern) {
      var data2 = this.errorCorrectLevel << 3 | maskPattern;
      var bits = QRUtil.getBCHTypeInfo(data2);
      for (var i2 = 0; i2 < 15; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        if (i2 < 6) {
          this.modules[i2][8] = mod;
        } else if (i2 < 8) {
          this.modules[i2 + 1][8] = mod;
        } else {
          this.modules[this.moduleCount - 15 + i2][8] = mod;
        }
      }
      for (var i2 = 0; i2 < 15; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        if (i2 < 8) {
          this.modules[8][this.moduleCount - i2 - 1] = mod;
        } else if (i2 < 9) {
          this.modules[8][15 - i2 - 1 + 1] = mod;
        } else {
          this.modules[8][15 - i2 - 1] = mod;
        }
      }
      this.modules[this.moduleCount - 8][8] = !test;
    }, mapData: function(data2, maskPattern) {
      var inc = -1;
      var row = this.moduleCount - 1;
      var bitIndex = 7;
      var byteIndex = 0;
      for (var col = this.moduleCount - 1; col > 0; col -= 2) {
        if (col == 6)
          col--;
        while (true) {
          for (var c = 0; c < 2; c++) {
            if (this.modules[row][col - c] == null) {
              var dark = false;
              if (byteIndex < data2.length) {
                dark = (data2[byteIndex] >>> bitIndex & 1) == 1;
              }
              var mask = QRUtil.getMask(maskPattern, row, col - c);
              if (mask) {
                dark = !dark;
              }
              this.modules[row][col - c] = dark;
              bitIndex--;
              if (bitIndex == -1) {
                byteIndex++;
                bitIndex = 7;
              }
            }
          }
          row += inc;
          if (row < 0 || this.moduleCount <= row) {
            row -= inc;
            inc = -inc;
            break;
          }
        }
      }
    } };
    QRCodeModel.PAD0 = 236;
    QRCodeModel.PAD1 = 17;
    QRCodeModel.createData = function(typeNumber, errorCorrectLevel, dataList) {
      var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
      var buffer = new QRBitBuffer();
      for (var i2 = 0; i2 < dataList.length; i2++) {
        var data2 = dataList[i2];
        buffer.put(data2.mode, 4);
        buffer.put(data2.getLength(), QRUtil.getLengthInBits(data2.mode, typeNumber));
        data2.write(buffer);
      }
      var totalDataCount = 0;
      for (var i2 = 0; i2 < rsBlocks.length; i2++) {
        totalDataCount += rsBlocks[i2].dataCount;
      }
      if (buffer.getLengthInBits() > totalDataCount * 8) {
        throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
      }
      if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
        buffer.put(0, 4);
      }
      while (buffer.getLengthInBits() % 8 != 0) {
        buffer.putBit(false);
      }
      while (true) {
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(QRCodeModel.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(QRCodeModel.PAD1, 8);
      }
      return QRCodeModel.createBytes(buffer, rsBlocks);
    };
    QRCodeModel.createBytes = function(buffer, rsBlocks) {
      var offset = 0;
      var maxDcCount = 0;
      var maxEcCount = 0;
      var dcdata = new Array(rsBlocks.length);
      var ecdata = new Array(rsBlocks.length);
      for (var r = 0; r < rsBlocks.length; r++) {
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for (var i2 = 0; i2 < dcdata[r].length; i2++) {
          dcdata[r][i2] = 255 & buffer.buffer[i2 + offset];
        }
        offset += dcCount;
        var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for (var i2 = 0; i2 < ecdata[r].length; i2++) {
          var modIndex = i2 + modPoly.getLength() - ecdata[r].length;
          ecdata[r][i2] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
      }
      var totalCodeCount = 0;
      for (var i2 = 0; i2 < rsBlocks.length; i2++) {
        totalCodeCount += rsBlocks[i2].totalCount;
      }
      var data2 = new Array(totalCodeCount);
      var index2 = 0;
      for (var i2 = 0; i2 < maxDcCount; i2++) {
        for (var r = 0; r < rsBlocks.length; r++) {
          if (i2 < dcdata[r].length) {
            data2[index2++] = dcdata[r][i2];
          }
        }
      }
      for (var i2 = 0; i2 < maxEcCount; i2++) {
        for (var r = 0; r < rsBlocks.length; r++) {
          if (i2 < ecdata[r].length) {
            data2[index2++] = ecdata[r][i2];
          }
        }
      }
      return data2;
    };
    var QRMode = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 };
    var QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 };
    var QRMaskPattern = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 };
    var QRUtil = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0, G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0, G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1, getBCHTypeInfo: function(data2) {
      var d = data2 << 10;
      while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
        d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
      }
      return (data2 << 10 | d) ^ QRUtil.G15_MASK;
    }, getBCHTypeNumber: function(data2) {
      var d = data2 << 12;
      while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
        d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
      }
      return data2 << 12 | d;
    }, getBCHDigit: function(data2) {
      var digit = 0;
      while (data2 != 0) {
        digit++;
        data2 >>>= 1;
      }
      return digit;
    }, getPatternPosition: function(typeNumber) {
      return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    }, getMask: function(maskPattern, i2, j) {
      switch (maskPattern) {
        case QRMaskPattern.PATTERN000:
          return (i2 + j) % 2 == 0;
        case QRMaskPattern.PATTERN001:
          return i2 % 2 == 0;
        case QRMaskPattern.PATTERN010:
          return j % 3 == 0;
        case QRMaskPattern.PATTERN011:
          return (i2 + j) % 3 == 0;
        case QRMaskPattern.PATTERN100:
          return (Math.floor(i2 / 2) + Math.floor(j / 3)) % 2 == 0;
        case QRMaskPattern.PATTERN101:
          return i2 * j % 2 + i2 * j % 3 == 0;
        case QRMaskPattern.PATTERN110:
          return (i2 * j % 2 + i2 * j % 3) % 2 == 0;
        case QRMaskPattern.PATTERN111:
          return (i2 * j % 3 + (i2 + j) % 2) % 2 == 0;
        default:
          throw new Error("bad maskPattern:" + maskPattern);
      }
    }, getErrorCorrectPolynomial: function(errorCorrectLength) {
      var a = new QRPolynomial([1], 0);
      for (var i2 = 0; i2 < errorCorrectLength; i2++) {
        a = a.multiply(new QRPolynomial([1, QRMath.gexp(i2)], 0));
      }
      return a;
    }, getLengthInBits: function(mode, type2) {
      if (1 <= type2 && type2 < 10) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 10;
          case QRMode.MODE_ALPHA_NUM:
            return 9;
          case QRMode.MODE_8BIT_BYTE:
            return 8;
          case QRMode.MODE_KANJI:
            return 8;
          default:
            throw new Error("mode:" + mode);
        }
      } else if (type2 < 27) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 12;
          case QRMode.MODE_ALPHA_NUM:
            return 11;
          case QRMode.MODE_8BIT_BYTE:
            return 16;
          case QRMode.MODE_KANJI:
            return 10;
          default:
            throw new Error("mode:" + mode);
        }
      } else if (type2 < 41) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 14;
          case QRMode.MODE_ALPHA_NUM:
            return 13;
          case QRMode.MODE_8BIT_BYTE:
            return 16;
          case QRMode.MODE_KANJI:
            return 12;
          default:
            throw new Error("mode:" + mode);
        }
      } else {
        throw new Error("type:" + type2);
      }
    }, getLostPoint: function(qrCode) {
      var moduleCount = qrCode.getModuleCount();
      var lostPoint = 0;
      for (var row = 0; row < moduleCount; row++) {
        for (var col = 0; col < moduleCount; col++) {
          var sameCount = 0;
          var dark = qrCode.isDark(row, col);
          for (var r = -1; r <= 1; r++) {
            if (row + r < 0 || moduleCount <= row + r) {
              continue;
            }
            for (var c = -1; c <= 1; c++) {
              if (col + c < 0 || moduleCount <= col + c) {
                continue;
              }
              if (r == 0 && c == 0) {
                continue;
              }
              if (dark == qrCode.isDark(row + r, col + c)) {
                sameCount++;
              }
            }
          }
          if (sameCount > 5) {
            lostPoint += 3 + sameCount - 5;
          }
        }
      }
      for (var row = 0; row < moduleCount - 1; row++) {
        for (var col = 0; col < moduleCount - 1; col++) {
          var count = 0;
          if (qrCode.isDark(row, col))
            count++;
          if (qrCode.isDark(row + 1, col))
            count++;
          if (qrCode.isDark(row, col + 1))
            count++;
          if (qrCode.isDark(row + 1, col + 1))
            count++;
          if (count == 0 || count == 4) {
            lostPoint += 3;
          }
        }
      }
      for (var row = 0; row < moduleCount; row++) {
        for (var col = 0; col < moduleCount - 6; col++) {
          if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
            lostPoint += 40;
          }
        }
      }
      for (var col = 0; col < moduleCount; col++) {
        for (var row = 0; row < moduleCount - 6; row++) {
          if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
            lostPoint += 40;
          }
        }
      }
      var darkCount = 0;
      for (var col = 0; col < moduleCount; col++) {
        for (var row = 0; row < moduleCount; row++) {
          if (qrCode.isDark(row, col)) {
            darkCount++;
          }
        }
      }
      var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
      lostPoint += ratio * 10;
      return lostPoint;
    } };
    var QRMath = { glog: function(n) {
      if (n < 1) {
        throw new Error("glog(" + n + ")");
      }
      return QRMath.LOG_TABLE[n];
    }, gexp: function(n) {
      while (n < 0) {
        n += 255;
      }
      while (n >= 256) {
        n -= 255;
      }
      return QRMath.EXP_TABLE[n];
    }, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) };
    for (var i = 0; i < 8; i++) {
      QRMath.EXP_TABLE[i] = 1 << i;
    }
    for (var i = 8; i < 256; i++) {
      QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
    }
    for (var i = 0; i < 255; i++) {
      QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
    }
    function QRPolynomial(num, shift) {
      if (num.length == void 0) {
        throw new Error(num.length + "/" + shift);
      }
      var offset = 0;
      while (offset < num.length && num[offset] == 0) {
        offset++;
      }
      this.num = new Array(num.length - offset + shift);
      for (var i2 = 0; i2 < num.length - offset; i2++) {
        this.num[i2] = num[i2 + offset];
      }
    }
    QRPolynomial.prototype = { get: function(index2) {
      return this.num[index2];
    }, getLength: function() {
      return this.num.length;
    }, multiply: function(e) {
      var num = new Array(this.getLength() + e.getLength() - 1);
      for (var i2 = 0; i2 < this.getLength(); i2++) {
        for (var j = 0; j < e.getLength(); j++) {
          num[i2 + j] ^= QRMath.gexp(QRMath.glog(this.get(i2)) + QRMath.glog(e.get(j)));
        }
      }
      return new QRPolynomial(num, 0);
    }, mod: function(e) {
      if (this.getLength() - e.getLength() < 0) {
        return this;
      }
      var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e.get(0));
      var num = new Array(this.getLength());
      for (var i2 = 0; i2 < this.getLength(); i2++) {
        num[i2] = this.get(i2);
      }
      for (var i2 = 0; i2 < e.getLength(); i2++) {
        num[i2] ^= QRMath.gexp(QRMath.glog(e.get(i2)) + ratio);
      }
      return new QRPolynomial(num, 0).mod(e);
    } };
    function QRRSBlock(totalCount, dataCount) {
      this.totalCount = totalCount;
      this.dataCount = dataCount;
    }
    QRRSBlock.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
    QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
      var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
      if (rsBlock == void 0) {
        throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
      }
      var length = rsBlock.length / 3;
      var list = [];
      for (var i2 = 0; i2 < length; i2++) {
        var count = rsBlock[i2 * 3 + 0];
        var totalCount = rsBlock[i2 * 3 + 1];
        var dataCount = rsBlock[i2 * 3 + 2];
        for (var j = 0; j < count; j++) {
          list.push(new QRRSBlock(totalCount, dataCount));
        }
      }
      return list;
    };
    QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
      switch (errorCorrectLevel) {
        case QRErrorCorrectLevel.L:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case QRErrorCorrectLevel.M:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case QRErrorCorrectLevel.Q:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case QRErrorCorrectLevel.H:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
          return void 0;
      }
    };
    function QRBitBuffer() {
      this.buffer = [];
      this.length = 0;
    }
    QRBitBuffer.prototype = { get: function(index2) {
      var bufIndex = Math.floor(index2 / 8);
      return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) == 1;
    }, put: function(num, length) {
      for (var i2 = 0; i2 < length; i2++) {
        this.putBit((num >>> length - i2 - 1 & 1) == 1);
      }
    }, getLengthInBits: function() {
      return this.length;
    }, putBit: function(bit) {
      var bufIndex = Math.floor(this.length / 8);
      if (this.buffer.length <= bufIndex) {
        this.buffer.push(0);
      }
      if (bit) {
        this.buffer[bufIndex] |= 128 >>> this.length % 8;
      }
      this.length++;
    } };
    var QRCodeLimitLength = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];
    function _isSupportCanvas() {
      return typeof CanvasRenderingContext2D != "undefined";
    }
    function _getAndroid() {
      var android2 = false;
      var sAgent = navigator.userAgent;
      if (/android/i.test(sAgent)) {
        android2 = true;
        var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
        if (aMat && aMat[1]) {
          android2 = parseFloat(aMat[1]);
        }
      }
      return android2;
    }
    var svgDrawer = function() {
      var Drawing2 = function(el, htOption) {
        this._el = el;
        this._htOption = htOption;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _htOption = this._htOption;
        var _el = this._el;
        var nCount = oQRCode.getModuleCount();
        Math.floor(_htOption.width / nCount);
        Math.floor(_htOption.height / nCount);
        this.clear();
        function makeSVG(tag, attrs) {
          var el = document.createElementNS("http://www.w3.org/2000/svg", tag);
          for (var k in attrs)
            if (attrs.hasOwnProperty(k))
              el.setAttribute(k, attrs[k]);
          return el;
        }
        var svg = makeSVG("svg", { "viewBox": "0 0 " + String(nCount) + " " + String(nCount), "width": "100%", "height": "100%", "fill": _htOption.colorLight });
        svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        _el.appendChild(svg);
        svg.appendChild(makeSVG("rect", { "fill": _htOption.colorLight, "width": "100%", "height": "100%" }));
        svg.appendChild(makeSVG("rect", { "fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template" }));
        for (var row = 0; row < nCount; row++) {
          for (var col = 0; col < nCount; col++) {
            if (oQRCode.isDark(row, col)) {
              var child = makeSVG("use", { "x": String(col), "y": String(row) });
              child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template");
              svg.appendChild(child);
            }
          }
        }
      };
      Drawing2.prototype.clear = function() {
        while (this._el.hasChildNodes())
          this._el.removeChild(this._el.lastChild);
      };
      return Drawing2;
    }();
    var useSVG = document.documentElement.tagName.toLowerCase() === "svg";
    var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? function() {
      var Drawing2 = function(el, htOption) {
        this._el = el;
        this._htOption = htOption;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _htOption = this._htOption;
        var _el = this._el;
        var nCount = oQRCode.getModuleCount();
        var nWidth = Math.floor(_htOption.width / nCount);
        var nHeight = Math.floor(_htOption.height / nCount);
        var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
        for (var row = 0; row < nCount; row++) {
          aHTML.push("<tr>");
          for (var col = 0; col < nCount; col++) {
            aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + "px;height:" + nHeight + "px;background-color:" + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
          }
          aHTML.push("</tr>");
        }
        aHTML.push("</table>");
        _el.innerHTML = aHTML.join("");
        var elTable = _el.childNodes[0];
        var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
        var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
        if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
          elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
        }
      };
      Drawing2.prototype.clear = function() {
        this._el.innerHTML = "";
      };
      return Drawing2;
    }() : function() {
      function _onMakeImage() {
        this._elImage.src = this._elCanvas.toDataURL("image/png");
        this._elImage.style.display = "block";
        this._elCanvas.style.display = "none";
      }
      if (this && this._android && this._android <= 2.1) {
        var factor = 1 / window.devicePixelRatio;
        var drawImage = CanvasRenderingContext2D.prototype.drawImage;
        CanvasRenderingContext2D.prototype.drawImage = function(image, sx, sy, sw, sh, dx, dy, dw, dh) {
          if ("nodeName" in image && /img/i.test(image.nodeName)) {
            for (var i2 = arguments.length - 1; i2 >= 1; i2--) {
              arguments[i2] = arguments[i2] * factor;
            }
          } else if (typeof dw == "undefined") {
            arguments[1] *= factor;
            arguments[2] *= factor;
            arguments[3] *= factor;
            arguments[4] *= factor;
          }
          drawImage.apply(this, arguments);
        };
      }
      function _safeSetDataURI(fSuccess, fFail) {
        var self2 = this;
        self2._fFail = fFail;
        self2._fSuccess = fSuccess;
        if (self2._bSupportDataURI === null) {
          var el = document.createElement("img");
          var fOnError = function() {
            self2._bSupportDataURI = false;
            if (self2._fFail) {
              self2._fFail.call(self2);
            }
          };
          var fOnSuccess = function() {
            self2._bSupportDataURI = true;
            if (self2._fSuccess) {
              self2._fSuccess.call(self2);
            }
          };
          el.onabort = fOnError;
          el.onerror = fOnError;
          el.onload = fOnSuccess;
          el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==";
          return;
        } else if (self2._bSupportDataURI === true && self2._fSuccess) {
          self2._fSuccess.call(self2);
        } else if (self2._bSupportDataURI === false && self2._fFail) {
          self2._fFail.call(self2);
        }
      }
      var Drawing2 = function(el, htOption) {
        this._bIsPainted = false;
        this._android = _getAndroid();
        this._htOption = htOption;
        this._elCanvas = document.createElement("canvas");
        this._elCanvas.width = htOption.width;
        this._elCanvas.height = htOption.height;
        el.appendChild(this._elCanvas);
        this._el = el;
        this._oContext = this._elCanvas.getContext("2d");
        this._bIsPainted = false;
        this._elImage = document.createElement("img");
        this._elImage.alt = "Scan me!";
        this._elImage.style.display = "none";
        this._el.appendChild(this._elImage);
        this._bSupportDataURI = null;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _elImage = this._elImage;
        var _oContext = this._oContext;
        var _htOption = this._htOption;
        var nCount = oQRCode.getModuleCount();
        var nWidth = _htOption.width / nCount;
        var nHeight = _htOption.height / nCount;
        var nRoundedWidth = Math.round(nWidth);
        var nRoundedHeight = Math.round(nHeight);
        _elImage.style.display = "none";
        this.clear();
        for (var row = 0; row < nCount; row++) {
          for (var col = 0; col < nCount; col++) {
            var bIsDark = oQRCode.isDark(row, col);
            var nLeft = col * nWidth;
            var nTop = row * nHeight;
            _oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
            _oContext.lineWidth = 1;
            _oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
            _oContext.fillRect(nLeft, nTop, nWidth, nHeight);
            _oContext.strokeRect(Math.floor(nLeft) + 0.5, Math.floor(nTop) + 0.5, nRoundedWidth, nRoundedHeight);
            _oContext.strokeRect(Math.ceil(nLeft) - 0.5, Math.ceil(nTop) - 0.5, nRoundedWidth, nRoundedHeight);
          }
        }
        this._bIsPainted = true;
      };
      Drawing2.prototype.makeImage = function() {
        if (this._bIsPainted) {
          _safeSetDataURI.call(this, _onMakeImage);
        }
      };
      Drawing2.prototype.isPainted = function() {
        return this._bIsPainted;
      };
      Drawing2.prototype.clear = function() {
        this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
        this._bIsPainted = false;
      };
      Drawing2.prototype.round = function(nNumber) {
        if (!nNumber) {
          return nNumber;
        }
        return Math.floor(nNumber * 1e3) / 1e3;
      };
      return Drawing2;
    }();
    function _getTypeNumber(sText, nCorrectLevel) {
      var nType = 1;
      var length = _getUTF8Length(sText);
      for (var i2 = 0, len = QRCodeLimitLength.length; i2 <= len; i2++) {
        var nLimit = 0;
        switch (nCorrectLevel) {
          case QRErrorCorrectLevel.L:
            nLimit = QRCodeLimitLength[i2][0];
            break;
          case QRErrorCorrectLevel.M:
            nLimit = QRCodeLimitLength[i2][1];
            break;
          case QRErrorCorrectLevel.Q:
            nLimit = QRCodeLimitLength[i2][2];
            break;
          case QRErrorCorrectLevel.H:
            nLimit = QRCodeLimitLength[i2][3];
            break;
        }
        if (length <= nLimit) {
          break;
        } else {
          nType++;
        }
      }
      if (nType > QRCodeLimitLength.length) {
        throw new Error("Too long data");
      }
      return nType;
    }
    function _getUTF8Length(sText) {
      var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
      return replacedText.length + (replacedText.length != sText ? 3 : 0);
    }
    QRCode2 = function(el, vOption) {
      this._htOption = {
        width: 256,
        height: 256,
        typeNumber: 4,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRErrorCorrectLevel.H
      };
      if (typeof vOption === "string") {
        vOption = {
          text: vOption
        };
      }
      if (vOption) {
        for (var i2 in vOption) {
          this._htOption[i2] = vOption[i2];
        }
      }
      if (typeof el == "string") {
        el = document.getElementById(el);
      }
      if (this._htOption.useSVG) {
        Drawing = svgDrawer;
      }
      this._android = _getAndroid();
      this._el = el;
      this._oQRCode = null;
      this._oDrawing = new Drawing(this._el, this._htOption);
      if (this._htOption.text) {
        this.makeCode(this._htOption.text);
      }
    };
    QRCode2.prototype.makeCode = function(sText) {
      this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
      this._oQRCode.addData(sText);
      this._oQRCode.make();
      this._el.title = sText;
      this._oDrawing.draw(this._oQRCode);
      this.makeImage();
    };
    QRCode2.prototype.makeImage = function() {
      if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
        this._oDrawing.makeImage();
      }
    };
    QRCode2.prototype.clear = function() {
      this._oDrawing.clear();
    };
    QRCode2.CorrectLevel = QRErrorCorrectLevel;
    return QRCode2;
  });
})(qrcode$1);
var QRCode = qrcode$1.exports;
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("div", { staticClass: "code_wrapper" }, [_c("div", { ref: "omni-qrcode", attrs: { "id": "omni-qrcode" } })]), _c("p", { staticClass: "qrcode_tip" }, [_vm._v("\u8BF7\u626B\u7801\u4E0B\u8F7D")])]);
};
var staticRenderFns$f = [];
var qrcode_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$f = defineComponent({
  name: "selectMenu",
  props: {
    text: {
      type: String,
      require: true
    },
    size: {
      type: Number,
      require: false
    }
  },
  data() {
    return {
      theme: "light",
      qrcode: null
    };
  },
  computed: {
    isThemeLight() {
      return this.theme === "light";
    }
  },
  mounted() {
    this.initTheme();
    this.initQrCode();
  },
  methods: {
    initTheme() {
      this.theme = getThemeColor();
    },
    initQrCode() {
      this.qrcode = new QRCode(this.$refs["omni-qrcode"], {
        text: this.text,
        width: this.size,
        height: this.size,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  }
});
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(__vue2_script$f, render$f, staticRenderFns$f, false, __vue2_injectStyles$f, "450ef698", null, null);
function __vue2_injectStyles$f(context) {
  for (let o2 in __cssModules$f) {
    this[o2] = __cssModules$f[o2];
  }
}
var qrcode = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_10675_19132" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_10675_19132)" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M7.75736,7.75736Q6,9.51472,6,12Q6,14.48528,7.75736,16.2426Q9.51472,18,12,18Q14.48528,18,16.2426,16.2426Q18,14.48528,18,12Q18,9.51472,16.2426,7.75736Q14.48528,6,12,6Q9.51472,6,7.75736,7.75736ZM8.46447,15.53553Q7,14.07107,7,12Q7,9.92893,8.46447,8.46447Q9.92893,7,12,7Q14.07107,7,15.53553,8.46447Q17,9.92893,17,12Q17,14.07107,15.53553,15.53553Q14.07107,17,12,17Q9.92893,17,8.46447,15.53553ZM13.53073,15.69552Q12.79565,16,12,16L12,8Q12.79565,8,13.53073,8.30448C14.02079,8.50747,14.45335,8.7965,14.82843,9.17157Q15.39104,9.73418,15.69552,10.46927Q16,11.20435,16,12Q16,12.79565,15.69552,13.53073C15.49253,14.02079,15.2035,14.45335,14.82843,14.82843Q14.26582,15.39104,13.53073,15.69552Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])]);
};
var staticRenderFns$e = [];
const __vue2_script$e = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(__vue2_script$e, render$e, staticRenderFns$e, false, __vue2_injectStyles$e, null, null, null);
function __vue2_injectStyles$e(context) {
  for (let o2 in __cssModules$e) {
    this[o2] = __cssModules$e[o2];
  }
}
var colormodeIcon = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_10464_08031" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_10483_08692" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_10464_08031)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_10483_08692)" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M15,7.5L16.5,7.5Q17.1212,7.49999114871,17.560499999999998,7.939331Q18,8.378679,18,9L18,15Q17.9998,15.8284,17.414099999999998,16.41418Q16.828400000000002,17,16,17L8,17Q7.1717200000000005,16.999969999999998,6.585938,16.41418Q6,15.82843,6,15L6,9Q6.000113279,8.378671,6.439453,7.939331Q6.87868,7.5,7.5,7.5L9,7.5L9,8.5L7.5,8.5Q7.29293,8.499977,7.14648,8.646419999999999Q7,8.79289,7,9L7,15Q7.0000800000000005,15.414200000000001,7.29297,15.70709Q7.58579,16,8,16L16,16Q16.414099999999998,15.99998,16.707,15.70709Q17,15.41421,17,15L17,9Q17,8.79287,16.8535,8.646419999999999Q16.7071,8.5,16.5,8.5L15,8.5L15,7.5ZM12.5,7.5L12.5,12.53693L13.76822,11.26788L14.47556,11.97476L12.00207,14.449860000000001L9.52708,11.97487L10.23419,11.26777L11.5,12.53358L11.5,7.5L12.5,7.5Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])])])])]);
};
var staticRenderFns$d = [];
const __vue2_script$d = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(__vue2_script$d, render$d, staticRenderFns$d, false, __vue2_injectStyles$d, null, null, null);
function __vue2_injectStyles$d(context) {
  for (let o2 in __cssModules$d) {
    this[o2] = __cssModules$d[o2];
  }
}
var downloadIcon = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_10675_05875" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_10675_05881" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_10675_05875)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_10675_05881)" } }, [_c("g", [_c("path", { attrs: { "d": "M13.5,15.5L15.5,15.5Q15.91421,15.5,16.20711,15.20711Q16.5,14.91421,16.5,14.5L16.5,8.5Q16.5,8.08579,16.20711,7.792893Q15.91421,7.5,15.5,7.5L8.5,7.5Q8.08579,7.5,7.792893,7.792893Q7.5,8.08579,7.5,8.5L7.5,14.5Q7.5,14.91421,7.792893,15.20711Q8.08579,15.5,8.5,15.5L10.5,15.5Q10.65139,15.5,10.77735,15.58397L12.27735,16.58397L12,17L11.72265,16.58397L13.22265,15.58397Q13.34861,15.5,13.5,15.5ZM13.5,16.5L13.5,16L13.77735,16.41603L12.27735,17.416Q12.21575,17.4571,12.14489,17.4785Q12.07403,17.5,12,17.5Q11.92597,17.5,11.85511,17.4785Q11.78425,17.4571,11.72265,17.416L10.22265,16.41603L10.5,16L10.5,16.5L8.5,16.5Q7.671572,16.5,7.0857865,15.91421Q6.5,15.32843,6.5,14.5L6.5,8.5Q6.5,7.671573,7.0857865,7.0857865Q7.671573,6.5,8.5,6.5L15.5,6.5Q16.32843,6.5,16.91421,7.0857865Q17.5,7.671572,17.5,8.5L17.5,14.5Q17.5,15.32843,16.91421,15.91421Q16.32843,16.5,15.5,16.5L13.5,16.5Z", "fill": "currentColor", "fill-opacity": "1" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M11.5,13.25L11.5,9.75L12.5,9.75L12.5,13.25L11.5,13.25ZM12.5,13.25Q12.5,13.29925,12.490393,13.34754Q12.480785000000001,13.39584,12.46194,13.44134Q12.443094,13.48684,12.415735,13.52778Q12.388375,13.56873,12.353553,13.60355Q12.318731,13.63838,12.277785,13.66573Q12.236839,13.69309,12.191342,13.71194Q12.145845,13.73078,12.0975451,13.74039Q12.0492457,13.75,12,13.75Q11.9507543,13.75,11.9024549,13.74039Q11.854155,13.73078,11.808658,13.71194Q11.763161,13.69309,11.722215,13.66573Q11.681269,13.63838,11.646447,13.60355Q11.611625,13.56873,11.584265,13.52778Q11.556906,13.48684,11.53806,13.44134Q11.519214999999999,13.39584,11.509607,13.34754Q11.5,13.29925,11.5,13.25Q11.5,13.20075,11.509607,13.15245Q11.519214999999999,13.10415,11.53806,13.05866Q11.556906,13.01316,11.584265,12.97221Q11.611625,12.93127,11.646447,12.89645Q11.681269,12.86162,11.722215,12.83426Q11.763161,12.80691,11.808658,12.78806Q11.854155,12.769210000000001,11.9024549,12.75961Q11.9507543,12.75,12,12.75Q12.0492457,12.75,12.0975451,12.75961Q12.145845,12.769210000000001,12.191342,12.78806Q12.236839,12.80691,12.277785,12.83426Q12.318731,12.86162,12.353553,12.89645Q12.388375,12.93127,12.415735,12.97221Q12.443094,13.01316,12.46194,13.05866Q12.480785000000001,13.10415,12.490393,13.15245Q12.5,13.20075,12.5,13.25ZM12.5,9.75Q12.5,9.7992457,12.490393,9.8475451Q12.480785000000001,9.895845,12.46194,9.941342Q12.443094,9.986839,12.415735,10.027785Q12.388375,10.068731,12.353553,10.103553Q12.318731,10.138375,12.277785,10.165735Q12.236839,10.193094,12.191342,10.21194Q12.145845,10.230785000000001,12.0975451,10.240393Q12.0492457,10.25,12,10.25Q11.9507543,10.25,11.9024549,10.240393Q11.854155,10.230785000000001,11.808658,10.21194Q11.763161,10.193094,11.722215,10.165735Q11.681269,10.138375,11.646447,10.103553Q11.611625,10.068731,11.584265,10.027785Q11.556906,9.986839,11.53806,9.941342Q11.519214999999999,9.895845,11.509607,9.8475451Q11.5,9.7992457,11.5,9.75Q11.5,9.7007543,11.509607,9.6524549Q11.519214999999999,9.604155,11.53806,9.558658Q11.556906,9.513161,11.584265,9.472215Q11.611625,9.431269,11.646447,9.396447Q11.681269,9.361625,11.722215,9.334265Q11.763161,9.306906,11.808658,9.28806Q11.854155,9.269214999999999,11.9024549,9.259607Q11.9507543,9.25,12,9.25Q12.0492457,9.25,12.0975451,9.259607Q12.145845,9.269214999999999,12.191342,9.28806Q12.236839,9.306906,12.277785,9.334265Q12.318731,9.361625,12.353553,9.396447Q12.388375,9.431269,12.415735,9.472215Q12.443094,9.513161,12.46194,9.558658Q12.480785000000001,9.604155,12.490393,9.6524549Q12.5,9.7007543,12.5,9.75Z", "fill": "currentColor", "fill-opacity": "1" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "transform": "matrix(0,1,-1,0,23.25,-3.75)" } }, [_c("path", { attrs: { "d": "M13,12.75L13,9.75L14,9.75L14,12.75L13,12.75ZM14,12.75Q14,12.79925,13.990393,12.84754Q13.980785000000001,12.89584,13.96194,12.94134Q13.943094,12.98684,13.915735,13.02778Q13.888375,13.06873,13.853553,13.10355Q13.818731,13.13837,13.777785,13.16573Q13.736839,13.19309,13.691342,13.21194Q13.645845,13.23078,13.5975451,13.24039Q13.5492457,13.25,13.5,13.25Q13.4507543,13.25,13.4024549,13.24039Q13.354155,13.23078,13.308658,13.21194Q13.263161,13.19309,13.222215,13.16573Q13.181269,13.13837,13.146447,13.10355Q13.111625,13.06873,13.084265,13.02778Q13.056906,12.98684,13.03806,12.94134Q13.019214999999999,12.89584,13.009607,12.84754Q13,12.79925,13,12.75Q13,12.70075,13.009607,12.65245Q13.019214999999999,12.60415,13.03806,12.55866Q13.056906,12.51316,13.084265,12.47221Q13.111625,12.43127,13.146447,12.39645Q13.181269,12.36162,13.222215,12.33426Q13.263161,12.30691,13.308658,12.28806Q13.354155,12.269210000000001,13.4024549,12.25961Q13.4507543,12.25,13.5,12.25Q13.5492457,12.25,13.5975451,12.25961Q13.645845,12.269210000000001,13.691342,12.28806Q13.736839,12.30691,13.777785,12.33426Q13.818731,12.36162,13.853553,12.39645Q13.888375,12.43127,13.915735,12.47221Q13.943094,12.51316,13.96194,12.55866Q13.980785000000001,12.60415,13.990393,12.65245Q14,12.70075,14,12.75ZM14,9.75Q14,9.7992457,13.990393,9.8475451Q13.980785000000001,9.895845,13.96194,9.941342Q13.943094,9.986839,13.915735,10.027785Q13.888375,10.068731,13.853553,10.103553Q13.818731,10.138375,13.777785,10.165735Q13.736839,10.193094,13.691342,10.21194Q13.645845,10.230785000000001,13.5975451,10.240393Q13.5492457,10.25,13.5,10.25Q13.4507543,10.25,13.4024549,10.240393Q13.354155,10.230785000000001,13.308658,10.21194Q13.263161,10.193094,13.222215,10.165735Q13.181269,10.138375,13.146447,10.103553Q13.111625,10.068731,13.084265,10.027785Q13.056906,9.986839,13.03806,9.941342Q13.019214999999999,9.895845,13.009607,9.8475451Q13,9.7992457,13,9.75Q13,9.7007543,13.009607,9.6524549Q13.019214999999999,9.604155,13.03806,9.558658Q13.056906,9.513161,13.084265,9.472215Q13.111625,9.431269,13.146447,9.396447Q13.181269,9.361625,13.222215,9.334265Q13.263161,9.306906,13.308658,9.28806Q13.354155,9.269214999999999,13.4024549,9.259607Q13.4507543,9.25,13.5,9.25Q13.5492457,9.25,13.5975451,9.259607Q13.645845,9.269214999999999,13.691342,9.28806Q13.736839,9.306906,13.777785,9.334265Q13.818731,9.361625,13.853553,9.396447Q13.888375,9.431269,13.915735,9.472215Q13.943094,9.513161,13.96194,9.558658Q13.980785000000001,9.604155,13.990393,9.6524549Q14,9.7007543,14,9.75Z", "fill": "currentColor", "fill-opacity": "1" } })])])])])])]);
};
var staticRenderFns$c = [];
const __vue2_script$c = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(__vue2_script$c, render$c, staticRenderFns$c, false, __vue2_injectStyles$c, null, null, null);
function __vue2_injectStyles$c(context) {
  for (let o2 in __cssModules$c) {
    this[o2] = __cssModules$c[o2];
  }
}
var fontIcon = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_14563_05605/10675_05855" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_14563_05605/10675_05861" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_14563_05605/10675_05855)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_14563_05605/10675_05861)" } }, [_c("g", [_c("g", [_c("g", [_c("rect", { attrs: { "x": "8.00048828125", "y": "7", "width": "8", "height": "10", "rx": "1.5", "fill-opacity": "0", "stroke-opacity": "0.8500000238418579", "stroke": "currentColor", "fill": "none", "stroke-width": "1" } })])])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M10 7.5C10 7.5 10 7.5 10 7.5L14 7.5C14 7.5 14 7.5 14 7.5L14 7.875C14 8.082106781186548 13.832106781186548 8.25 13.625 8.25L10.375 8.25C10.167893218813452 8.25 10 8.082106781186548 10 7.875Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("ellipse", { attrs: { "cx": "12", "cy": "15", "rx": "0.5", "ry": "0.5", "fill": "currentColor", "fill-opacity": "1" } })])])])])])]);
};
var staticRenderFns$b = [];
const __vue2_script$b = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(__vue2_script$b, render$b, staticRenderFns$b, false, __vue2_injectStyles$b, null, null, null);
function __vue2_injectStyles$b(context) {
  for (let o2 in __cssModules$b) {
    this[o2] = __cssModules$b[o2];
  }
}
var mobileIcon = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_76_66" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "24", "height": "24", "rx": "0" } })])]), _c("g", { attrs: { "clip-path": "url(#master_svg0_76_66)" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("path", { attrs: { "d": "M14.5,15L14.5,16Q14.5,16.621299999999998,14.06066,17.0607Q13.62132,17.5,13,17.5L8.5,17.5Q7.878679,17.5,7.43934,17.0607Q7,16.621299999999998,7,16L7,8Q7,7.37868,7.43934,6.93934Q7.87868,6.5,8.5,6.5L13,6.5Q13.62132,6.5,14.06066,6.93934Q14.5,7.37868,14.5,8L14.5,9L13.5,9L13.5,8Q13.5,7.79289,13.35355,7.64645Q13.20711,7.5,13,7.5L8.5,7.5Q8.29289,7.5,8.14645,7.64645Q8,7.79289,8,8L8,16Q8,16.20711,8.14645,16.35355Q8.29289,16.5,8.5,16.5L13,16.5Q13.20711,16.5,13.35355,16.35355Q13.5,16.20711,13.5,16L13.5,15L14.5,15ZM15.14645,14.14645L17.6464,11.64645L18,12L17.6464,12.35355L15.14645,9.85355L15.85355,9.14645L18.7071,12L15.85355,14.85355L15.14645,14.14645ZM18,12.5L11,12.5L11,11.5L18,11.5L18,12.5Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])])])]);
};
var staticRenderFns$a = [];
const __vue2_script$a = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(__vue2_script$a, render$a, staticRenderFns$a, false, __vue2_injectStyles$a, null, null, null);
function __vue2_injectStyles$a(context) {
  for (let o2 in __cssModules$a) {
    this[o2] = __cssModules$a[o2];
  }
}
var logoutIcon = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "4", "height": "6", "viewBox": "0 0 4 6" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M0,5C0,5.41202,0.470382,5.64721,0.8,5.4L3.46667,3.4C3.73333,3.2,3.73333,2.8,3.46667,2.6L0.8,0.6C0.470382,0.352786,0,0.587977,0,1L0,5Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])]);
};
var staticRenderFns$9 = [];
const __vue2_script$9 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(__vue2_script$9, render$9, staticRenderFns$9, false, __vue2_injectStyles$9, null, null, null);
function __vue2_injectStyles$9(context) {
  for (let o2 in __cssModules$9) {
    this[o2] = __cssModules$9[o2];
  }
}
var moreIcon = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("ellipse", { attrs: { "cx": "12", "cy": "9.5", "rx": "2.5", "ry": "2.5", "fill-opacity": "0", "stroke-opacity": "1", "stroke": "currentColor", "fill": "none", "stroke-width": "1" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M6,17.5Q6,16.05025,7.025126,15.025126Q8.05025,14,9.5,14L14.5,14Q15.94975,14,16.974899999999998,15.025126Q18,16.05025,18,17.5L17,17.5Q17,16.46447,16.26777,15.73223Q15.53553,15,14.5,15L9.5,15Q8.46447,15,7.7322299999999995,15.73223Q7,16.46447,7,17.5L6,17.5Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])]);
};
var staticRenderFns$8 = [];
const __vue2_script$8 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(__vue2_script$8, render$8, staticRenderFns$8, false, __vue2_injectStyles$8, null, null, null);
function __vue2_injectStyles$8(context) {
  for (let o2 in __cssModules$8) {
    this[o2] = __cssModules$8[o2];
  }
}
var settingIcon = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_76_215" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_76_215)" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M7.75736,7.75736Q6,9.51472,6,12Q6,14.48528,7.75736,16.2426Q9.51472,18,12,18Q14.48528,18,16.2426,16.2426Q18,14.48528,18,12Q18,9.51472,16.2426,7.75736Q14.48528,6,12,6Q9.51472,6,7.75736,7.75736ZM10.82727,7.1282700000000006Q9.49553,7.43341,8.46447,8.46447Q7.18002,9.74891,7.02213,11.5L9.019,11.5Q9.18634,9.30005,10.82727,7.1282700000000006ZM7.02213,12.5Q7.18002,14.25109,8.46447,15.53553Q9.49553,16.5666,10.82727,16.8717Q9.18634,14.69995,9.019,12.5L7.02213,12.5ZM13.17273,16.8717Q14.50447,16.5666,15.53553,15.53553Q16.82,14.25109,16.977899999999998,12.5L14.981,12.5Q14.81366,14.69995,13.17273,16.8717ZM16.977899999999998,11.5L14.981,11.5Q14.81366,9.30005,13.17273,7.1282700000000006Q14.50447,7.43341,15.53553,8.46447Q16.82,9.74891,16.977899999999998,11.5ZM10.02262,11.5Q10.212679999999999,9.39706,12,7.26023Q13.787320000000001,9.39706,13.97738,11.5L10.02262,11.5ZM12,16.739800000000002Q10.212679999999999,14.60294,10.02262,12.5L13.97738,12.5Q13.787320000000001,14.60294,12,16.739800000000002Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])])]);
};
var staticRenderFns$7 = [];
const __vue2_script$7 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(__vue2_script$7, render$7, staticRenderFns$7, false, __vue2_injectStyles$7, null, null, null);
function __vue2_injectStyles$7(context) {
  for (let o2 in __cssModules$7) {
    this[o2] = __cssModules$7[o2];
  }
}
var websiteIcon = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_14563_05598/10675_05846" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_14563_05598/10675_05848" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_14563_05598/10675_05846)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_14563_05598/10675_05848)" } }, [_c("g", [_c("g", [_c("g", [_c("rect", { attrs: { "x": "7.00048828125", "y": "7", "width": "10", "height": "7.5", "rx": "1.5", "fill-opacity": "0", "stroke-opacity": "0.8500000238418579", "stroke": "currentColor", "fill": "none", "stroke-width": "1" } })]), _c("g", [_c("rect", { attrs: { "x": "8.00048828125", "y": "16", "width": "8", "height": "1", "rx": "0.30000001192092896", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M10 7.5C10 7.5 10 7.5 10 7.5L14 7.5C14 7.5 14 7.5 14 7.5L14 7.75C14 7.888071187457698 13.8880711874577 8 13.75 8L10.25 8C10.1119288125423 8 10 7.888071187457698 10 7.75Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])])])]);
};
var staticRenderFns$6 = [];
const __vue2_script$6 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(__vue2_script$6, render$6, staticRenderFns$6, false, __vue2_injectStyles$6, null, null, null);
function __vue2_injectStyles$6(context) {
  for (let o2 in __cssModules$6) {
    this[o2] = __cssModules$6[o2];
  }
}
var pcIcon = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_14563_05521" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "24", "height": "24", "rx": "0" } })]), _c("clipPath", { attrs: { "id": "master_svg1_14563_05523" } }, [_c("rect", { attrs: { "x": "0", "y": "0", "width": "24", "height": "24", "rx": "0" } })])]), _c("g", { attrs: { "clip-path": "url(#master_svg0_14563_05521)" } }, [_c("g", { attrs: { "clip-path": "url(#master_svg1_14563_05523)" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M17.99976356496811,12.00028818359375L14.999723564968109,6.80413818359375L8.999723564968109,6.80413818359375L5.9997269509681095,12.00028818359375L8.999723564968109,17.19643818359375L14.999723564968109,17.19643818359375L17.99976356496811,12.00028818359375ZM16.845063564968108,12.00028818359375L14.42237356496811,7.80413818359375L9.57707356496811,7.80413818359375L7.154423564968109,12.00028818359375L9.57707356496811,16.196448183593752L14.42237356496811,16.196448183593752L16.845063564968108,12.00028818359375Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M11.5,14.5L11.5,12L12.5,12L12.5,14.5L11.5,14.5Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M9.757248,10.071254L12.257249999999999,11.57125L11.742750000000001,12.42875L9.242752,10.928746L9.757248,10.071254Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M11.742752,11.57125L14.242750000000001,10.071254L14.757249999999999,10.928746L12.257248,12.42875L11.742752,11.57125Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])])]);
};
var staticRenderFns$5 = [];
const __vue2_script$5 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(__vue2_script$5, render$5, staticRenderFns$5, false, __vue2_injectStyles$5, null, null, null);
function __vue2_injectStyles$5(context) {
  for (let o2 in __cssModules$5) {
    this[o2] = __cssModules$5[o2];
  }
}
var workspaceIcon = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M14,13.7L14,16.4Q14,16,13.6,16L16.9,16Q16.5,16,16.5,16.4L16.5,10.05662Q16.5,10.283100000000001,16.694200000000002,10.39962L11.7942,7.4596160000000005Q12,7.583095,12.2058,7.4596160000000005L7.305798,10.39962Q7.5,10.28309,7.5,10.05662L7.5,16.4Q7.5,16,7.1,16L10.4,16Q10.23431,16,10.11716,16.11716Q10,16.23432,10,16.4L10,13.7Q10,13.41005,10.20503,13.205020000000001Q10.41005,13,10.7,13L13.3,13Q13.58995,13,13.79497,13.20503Q14,13.41005,14,13.7ZM13,13.7Q13,14,13.3,14L10.7,14Q11,14,11,13.7L11,16.4Q11,16.64853,10.82427,16.824260000000002Q10.648530000000001,17,10.4,17L7.1,17Q6.851471,17,6.6757349999999995,16.824260000000002Q6.5,16.64853,6.5,16.4L6.5,10.05662Q6.5,9.71691,6.791302,9.54212L11.6913,6.602123Q12,6.416904,12.3087,6.602123L17.2087,9.54212Q17.5,9.716899999999999,17.5,10.05662L17.5,16.4Q17.5,16.64853,17.3243,16.824260000000002Q17.1485,17,16.9,17L13.6,17Q13.351469999999999,17,13.17573,16.824260000000002Q13,16.64853,13,16.4L13,13.7Z", "fill-rule": "evenodd", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])]);
};
var staticRenderFns$4 = [];
const __vue2_script$4 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(__vue2_script$4, render$4, staticRenderFns$4, false, __vue2_injectStyles$4, null, null, null);
function __vue2_injectStyles$4(context) {
  for (let o2 in __cssModules$4) {
    this[o2] = __cssModules$4[o2];
  }
}
var profileIcon = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "fill": "none", "version": "1.1", "width": "24", "height": "24", "viewBox": "0 0 24 24" } }, [_c("defs", [_c("clipPath", { attrs: { "id": "master_svg0_76_226" } }, [_c("rect", { attrs: { "x": "6", "y": "6", "width": "12", "height": "12", "rx": "0" } })])]), _c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" }, attrs: { "clip-path": "url(#master_svg0_76_226)" } }, [_c("g", { staticStyle: { "mix-blend-mode": "passthrough" } }, [_c("path", { attrs: { "d": "M9.48071,9.626999999999999L11.500779999999999,6.597418Q11.67892,6.330252,12.000029999999999,6.330278Q12.32114,6.330303,12.49924,6.597497L14.51861,9.62707L14.10256,9.90439L14.22279,9.41906L17.465899999999998,10.22243Q17.787599999999998,10.30212,17.8914,10.61685Q17.9953,10.93159,17.784100000000002,11.187059999999999L15.53943,13.903030000000001L15.15403,13.5845L15.65289,13.55079L15.88682,17.0118Q15.90972,17.3505,15.63112,17.544600000000003Q15.35252,17.7387,15.04272,17.599800000000002L11.795079999999999,16.14367L11.99964,15.68743L12.204229999999999,16.14365L8.94633,17.6047Q8.6486,17.7382,8.3747,17.5608Q8.10081,17.383499999999998,8.10082,17.0572L8.10087,13.5845L8.60087,13.5845L8.19897,13.88196L6.187291,11.16394Q5.9963180000000005,10.90591,6.104998,10.603860000000001Q6.213678,10.30181,6.5252674,10.2246L9.77647,9.41906L9.89672,9.90439L9.48071,9.626999999999999ZM10.20516,10.34308L6.765765,11.19525Q6.973491,11.14379,7.045945,10.94242Q7.118398,10.74105,6.991083,10.56903L9.10087,13.419599999999999L9.10082,17.0572Q9.10082,16.8397,8.91822,16.721420000000002Q8.73563,16.603189999999998,8.53714,16.6922L11.99962,15.13946L15.45183,16.687269999999998Q15.24529,16.59467,15.05957,16.724040000000002Q14.87383,16.8534,14.8891,17.0792L14.64173,13.4195L17.0133,10.55Q16.8726,10.72031,16.9418,10.93014Q17.011,11.13996,17.2255,11.19309L13.79409,10.34308L11.66715,7.152131Q11.785879999999999,7.330261,11.99995,7.330278Q12.214030000000001,7.330294,12.33279,7.152184L10.31272,10.18177L10.20516,10.34308Z", "fill": "currentColor", "fill-opacity": "0.8500000238418579" } })])])])]);
};
var staticRenderFns$3 = [];
const __vue2_script$3 = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(__vue2_script$3, render$3, staticRenderFns$3, false, __vue2_injectStyles$3, null, null, null);
function __vue2_injectStyles$3(context) {
  for (let o2 in __cssModules$3) {
    this[o2] = __cssModules$3[o2];
  }
}
var starIcon = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: [!!_vm.level && "select bg-gray-600 radius-m submenu", { "no-info-select": !_vm.showInfo }], style: !_vm.level && { width: _vm.width, right: _vm.right + "px", top: _vm.top + "px" } }, [_c("ul", { staticClass: "select_ul" }, _vm._l(_vm.list, function(value, key) {
    return _c("li", { key, staticClass: "transition h5 hover--text-tran-85", class: { "has-border": value.divid, "qr-code-wrapper": value.qrCodeUrl }, attrs: { "data-tours-name": value.toursName }, on: { "click": function($event) {
      $event.stopPropagation();
      return _vm.clickHandler(value);
    }, "mouseenter": function($event) {
      return _vm.hoverHandler(value);
    } } }, [value.qrCodeUrl ? _c("qrcode", { attrs: { "text": value.qrCodeUrl, "size": 124 } }) : [_c("span", { staticClass: "icon" }, [_c(value.icon, { tag: "component" })], 1), _c("span", [_vm._v(_vm._s(value.title))]), value.child ? _c("span", { staticClass: "more" }, [_c("moreIcon", { tag: "component" })], 1) : _vm._e()], value.child && _vm.checked === value.title ? _c("select-menu", { attrs: { "list": value.child, "level": _vm.level + 1 }, on: { "clickItem": function(value2) {
      return _vm.$emit("clickItem", value2);
    } } }) : _vm._e()], 2);
  }), 0)]);
};
var staticRenderFns$2 = [];
var selectMenu_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$2 = defineComponent({
  name: "selectMenu",
  props: {
    list: {
      type: Array,
      require: true
    },
    level: {
      type: Number,
      require: false
    },
    top: {
      type: Number,
      require: true,
      default: 0
    },
    right: {
      type: Number,
      require: false,
      default: 0
    },
    triangleLeft: {
      type: Number,
      require: true
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "240px"
    }
  },
  emits: ["clickItem"],
  components: { qrcode, colormodeIcon, downloadIcon, fontIcon, mobileIcon, logoutIcon, moreIcon, settingIcon, websiteIcon, pcIcon, workspaceIcon, profileIcon, starIcon },
  data() {
    return {
      checked: ""
    };
  },
  methods: {
    hoverHandler(value) {
      this.checked = value.title;
    },
    clickHandler(value) {
      this.$emit("clickItem", value);
    }
  }
});
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(__vue2_script$2, render$2, staticRenderFns$2, false, __vue2_injectStyles$2, "a825604c", null, null);
function __vue2_injectStyles$2(context) {
  for (let o2 in __cssModules$2) {
    this[o2] = __cssModules$2[o2];
  }
}
var selectMenu = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "select bg-gray-600 radius-m", class: { "no-info-select": !_vm.showInfo }, style: { width: _vm.width, right: _vm.right + "px", top: _vm.top + "px" } }, [_vm.showArrow ? _c("div", { staticClass: "select_triangle", style: { left: _vm.triangleLeft + "px" } }) : _vm._e(), _vm.showInfo ? _c("div", { staticClass: "header transition h5" }, [_vm._t("front")], 2) : _vm._e(), _c("select-menu", { directives: [{ name: "show", rawName: "v-show", value: _vm.list, expression: "list" }], attrs: { "list": _vm.list, "top": _vm.top, "right": _vm.right, "level": 0 }, on: { "clickItem": function(value) {
    return _vm.$emit("clickItem", value);
  } } })], 1);
};
var staticRenderFns$1 = [];
var selectPortrait_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1 = defineComponent({
  props: {
    list: {
      type: Array,
      require: true
    },
    top: {
      type: Number,
      require: true
    },
    right: {
      type: Number,
      require: true
    },
    triangleLeft: {
      type: Number,
      require: true
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "240px"
    }
  },
  emits: ["clickItem"],
  components: { selectMenu }
});
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, render$1, staticRenderFns$1, false, __vue2_injectStyles$1, "23581f6c", null, null);
function __vue2_injectStyles$1(context) {
  for (let o2 in __cssModules$1) {
    this[o2] = __cssModules$1[o2];
  }
}
var selectPortrait = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "m-head-container", class: { "m-head-pointer": _vm.usePointer, "working-space": _vm.headType === "withButton" }, attrs: { "data-tours-name": "avatar" }, on: { "click": function($event) {
    return _vm.sendLog({ action_detail: "image" });
  } } }, [_c("MAvatar", { attrs: { "info": _vm.userInfo, "size": _vm.avatarSize } }), _vm.headType === "withButton" ? _c("span", { staticClass: "working-space-text", on: { "click": _vm.jumpHome } }, [_vm._v("\u524D\u5F80\u5DE5\u4F5C\u53F0")]) : _vm._e(), _c("transition", { attrs: { "name": "fade-out" } }, [_vm.selectChoose ? _c("selectPortrait", { directives: [{ name: "clickoutside", rawName: "v-clickoutside", value: _vm.closePortrait, expression: "closePortrait" }], attrs: { "top": _vm.config.top, "right": _vm.config.right, "triangleLeft": _vm.config.triangleLeft, "list": _vm.list, "showInfo": _vm.headType === "OnlyAvatar" }, on: { "clickItem": _vm.emitEvent }, scopedSlots: _vm._u([_vm.headType === "OnlyAvatar" ? { key: "front", fn: function() {
    return [_c("div", { staticClass: "menu-info" }, [_c("div", { staticStyle: { "margin-right": "15px" } }, [_c("MAvatar", { attrs: { "info": _vm.userInfo, "size": "middle" } })], 1), _c("div", { staticStyle: { "flex": "1", "overflow": "hidden" } }, [_c("div", { staticClass: "menu-info-name truncate h4" }, [_vm._v(" " + _vm._s(_vm.userInfo.name) + " ")]), _c("div", { staticClass: "menu-info-mail truncate p6" }, [_vm._v(" " + _vm._s(_vm.userInfo.email) + " ")])])])];
  }, proxy: true } : null], null, true) }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
var index_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script = defineComponent({
  name: "MHead",
  components: {
    MAvatar,
    selectPortrait
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        name: "",
        avatar: "",
        email: ""
      })
    },
    isPri: {
      type: Boolean,
      default: false
    },
    isResourceSquare: {
      type: Boolean,
      default: false
    },
    expandList: {
      type: Array,
      default: () => []
    },
    listMode: {
      type: Object,
      default: () => ({})
    },
    avatarSize: {
      type: String,
      default: "middle"
    },
    theme: {
      type: String,
      default: "light"
    },
    usePointer: {
      type: Boolean,
      default: false
    },
    headType: {
      type: String,
      default: "OnlyAvatar"
    },
    actionPosition: {
      type: String,
      default: "workplace"
    }
  },
  setup(props2, { emit }) {
    const selectChoose = ref(false);
    const config = computed(() => props2.type === "withButton" ? {
      right: 0,
      triangleLeft: 0
    } : {
      top: 50,
      right: 0,
      triangleLeft: 189
    });
    const list = computed(() => {
      const {
        home = true,
        theme = true,
        community = true,
        personal = false,
        website = true,
        download: download2 = false,
        setting = true,
        logout: logout2 = true
      } = props2.listMode;
      const origin = [
        {
          title: "\u5DE5\u4F5C\u53F0",
          enabled: home,
          type: "router",
          path: ROUTER_PATH.FILES_HOME,
          toursName: "home",
          icon: "workspaceIcon"
        },
        {
          title: props2.isResourceSquare ? "\u56DE\u5230\u4E3B\u9875" : "\u8D44\u6E90\u793E\u533A",
          enabled: isMobile() && community,
          type: "router",
          path: props2.isResourceSquare ? ROUTER_PATH.FILES_HOME : ROUTER_PATH.COMMUNITY,
          toursName: "community",
          icon: "websiteIcon"
        },
        {
          title: "\u793E\u533A\u4E2A\u4EBA\u4E3B\u9875",
          enabled: personal,
          type: "router",
          path: ROUTER_PATH.COMMUNITY_PROFILE,
          toursName: "personal",
          icon: "profileIcon"
        },
        {
          title: "\u524D\u5F80\u5B98\u7F51",
          enabled: !props2.isPri && website,
          type: "router",
          path: ROUTER_PATH.OFFICIAL_WEBSITE,
          toursName: "website",
          icon: "websiteIcon"
        },
        {
          title: props2.theme === "dark" ? "\u5207\u6362\u81F3\u6D45\u8272\u6A21\u5F0F" : "\u5207\u6362\u81F3\u6DF1\u8272\u6A21\u5F0F",
          enabled: theme,
          type: "theme",
          value: props2.theme === "dark" ? "light" : "dark",
          toursName: "theme",
          icon: "colormodeIcon",
          divid: true
        },
        {
          title: "\u4E2A\u4EBA\u8BBE\u7F6E",
          enabled: setting,
          type: "router",
          path: ROUTER_PATH.SETTING,
          toursName: "setting",
          icon: "settingIcon"
        },
        {
          title: "\u9000\u51FA\u767B\u5F55",
          enabled: logout2 && !platformInfo().isDingDing,
          type: "logout",
          toursName: "logout",
          icon: "logoutIcon"
        }
      ];
      let downloadList = [{
        title: "\u672C\u5730\u5B57\u4F53\u63D2\u4EF6",
        enabled: download2,
        type: "download",
        path: "",
        toursName: "font-extension",
        icon: "fontIcon"
      }];
      if (!props2.isPri) {
        downloadList = downloadList.concat([
          {
            title: "\u7535\u8111\u5BA2\u6237\u7AEF",
            enabled: download2,
            type: "download",
            path: "",
            toursName: "pc-app",
            icon: "pcIcon"
          },
          {
            title: "\u624B\u673A\u5BA2\u6237\u7AEF",
            enabled: download2,
            type: "download",
            path: "",
            toursName: "mobile-app",
            icon: "mobileIcon"
          }
        ]);
      }
      origin.splice(5, 0, {
        title: "\u4E0B\u8F7D\u5E94\u7528\u7A0B\u5E8F",
        enabled: download2,
        type: "download",
        path: "",
        toursName: "download",
        icon: "downloadIcon",
        child: downloadList
      });
      props2.expandList.forEach((item) => {
        if (item.appendIndex !== void 0) {
          if (typeof item.appendIndex === "function") {
            let index2 = origin.findIndex((child) => item.appendIndex(child));
            if (item.position === "next") {
              index2 += 1;
            }
            origin.splice(index2, 0, item);
          } else {
            origin.splice(item.appendIndex, 0, item);
          }
          return;
        }
        origin.push(item);
      });
      return origin.filter((item) => item.enabled);
    });
    const closePortrait = () => {
      selectChoose.value = false;
    };
    const changeVisible = () => {
      selectChoose.value = !selectChoose.value;
    };
    const currentTheme = ref("");
    watch(() => props2.theme, (val) => {
      currentTheme.value = val;
    }, { immediate: true });
    const jumpHome = (path) => {
      emitEvent({
        type: "router",
        path: "/files/home"
      }, 1);
    };
    const emitEvent = async (value, level = 2) => {
      let data2 = {};
      if (value.type === "theme") {
        data2.action_detail = "mode";
        currentTheme.value = currentTheme.value === "dark" ? "light" : "dark";
      } else if (value.type === "logout") {
        data2.action_detail = "logout";
      } else {
        switch (value.path) {
          case ROUTER_PATH.FILES_HOME: {
            data2.action_detail = "workplace" + level;
            break;
          }
          case ROUTER_PATH.SETTING: {
            data2.action_detail = "setting";
            break;
          }
          case ROUTER_PATH.OFFICIAL_WEBSITE: {
            data2.action_detail = "officialwebsite";
            const fn = dingOpenWindowWithOAuth();
            if (fn) {
              sendLog2(data2);
              await fn(ROUTER_PATH.OFFICIAL_WEBSITE + "?stop_leave=1");
              return;
            }
            break;
          }
          case ROUTER_PATH.COMMUNITY_PROFILE: {
            const fn = dingOpenWindowWithOAuth();
            if (fn) {
              sendLog2(data2);
              await fn(ROUTER_PATH.COMMUNITY_PROFILE);
              return;
            }
            break;
          }
          case ROUTER_PATH.COMMUNITY: {
            const fn = dingOpenWindowWithOAuth();
            if (fn) {
              sendLog2(data2);
              await fn(ROUTER_PATH.COMMUNITY);
              return;
            }
          }
        }
      }
      sendLog2(data2);
      emit(value.type, value);
      changeVisible();
    };
    const sendLog2 = (data2) => {
      if (!data2)
        data2 = {};
      data2.action_position = props2.actionPosition;
      data2.action_parameter1 = props2.headType === "withButton" ? "backworkplace" : "image";
      sensors.track(SensorsType.EVENT_CLICK, data2);
      changeVisible();
    };
    return {
      jumpHome,
      emitEvent,
      currentTheme,
      sendLog: sendLog2,
      list,
      closePortrait,
      selectChoose,
      config
    };
  }
});
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, "02aeea95", null, null);
function __vue2_injectStyles(context) {
  for (let o2 in __cssModules) {
    this[o2] = __cssModules[o2];
  }
}
var MHead = /* @__PURE__ */ function() {
  return __component__.exports;
}();
function onEvent(el, event, value) {
  const path = event.path || event.composedPath && event.composedPath();
  const isClickOutside = path ? path.indexOf(el) < 0 : !el.contains(event.target);
  if (!isClickOutside) {
    return;
  }
  event.stopPropagation();
  value();
}
function bind2(el, binding) {
  const eventHandler = (ev) => {
    onEvent(el, ev, binding.value);
  };
  el.clickoutsideHandler = eventHandler;
  setTimeout(() => {
    document.addEventListener("click", eventHandler, { capture: true });
  }, 0);
}
function unbind(el) {
  const eventHandler = el.clickoutsideHandler;
  if (eventHandler && typeof eventHandler === "function") {
    document.removeEventListener("click", eventHandler, { capture: true });
  }
  el.clickoutsideHandler = void 0;
}
const clickoutside = {
  mounted: bind2,
  beforeUnmount: unbind,
  bind: bind2,
  unbind
};
const initDirectives = (Vue) => {
  Vue.directive("clickoutside", clickoutside);
};
function installLogin(Vue) {
  Vue.mixin({
    mounted() {
      initDirectives(Vue);
    }
  });
  Vue.component("MLogin", MLogin);
  Vue.component("MHead", MHead);
}
export { MHead, MLogin, installLogin as default, index$2 as plugin };
